/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 116);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(130);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeDuplicates", function() { return removeDuplicates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupByCategory", function() { return groupByCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAccordion", function() { return toggleAccordion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrlParams", function() { return getUrlParams; });
/* harmony export (immutable) */ __webpack_exports__["detectCardBrand"] = detectCardBrand;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateCreditCard", function() { return validateCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskCashTransferAgency", function() { return maskCashTransferAgency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskCashTransferAccount", function() { return maskCashTransferAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePurchaseSummaryData", function() { return updatePurchaseSummaryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePurchase", function() { return validatePurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePurchaseMobile", function() { return validatePurchaseMobile; });
/* harmony export (immutable) */ __webpack_exports__["isValidName"] = isValidName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePurchaseOnBlur", function() { return validatePurchaseOnBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductDiscount", function() { return getProductDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDaysDiff", function() { return getDaysDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeTitle", function() { return changeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isB2b", function() { return isB2b; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanDate", function() { return cleanDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanSlugDestination", function() { return cleanSlugDestination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateFormat", function() { return getDateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidDate", function() { return isValidDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAgeStatus", function() { return getAgeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidCPF", function() { return isValidCPF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidEmail", function() { return isValidEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidPhone", function() { return isValidPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCookie", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCookie", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkCookie", function() { return checkCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCookie", function() { return removeCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeOperatorCookies", function() { return removeOperatorCookies; });
/* harmony export (immutable) */ __webpack_exports__["getAllCookies"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["getPartnersCookie"] = getPartnersCookie;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperatorsCookie", function() { return getOperatorsCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthCookie", function() { return getAuthCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatPrice", function() { return formatPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDate", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatURL", function() { return formatURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPage", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSameDaySearch", function() { return isSameDaySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanStateErrors", function() { return cleanStateErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertDate", function() { return convertDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quotationDateYear", function() { return quotationDateYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showDateVerbose", function() { return showDateVerbose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderAndFooterPayment", function() { return HeaderAndFooterPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxValueParcel", function() { return maxValueParcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaxParcel", function() { return getMaxParcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateFormatGMT", function() { return dateFormatGMT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHoursDateGMT", function() { return getHoursDateGMT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPurchasePending", function() { return getPurchasePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSelected", function() { return isSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateTrackerModalOnBlur", function() { return validateTrackerModalOnBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateTrackerModal", function() { return validateTrackerModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redirectToTracker", function() { return redirectToTracker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verifyOriginSearchUrl", function() { return verifyOriginSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCupomInUrl", function() { return getCupomInUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilterSearchUrl", function() { return getFilterSearchUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatCategoryName", function() { return FormatCategoryName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDestinationSlugByName", function() { return getDestinationSlugByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDestinationBySlug", function() { return getDestinationBySlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildSearchWithDestinationCategories", function() { return buildSearchWithDestinationCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDateFromConvert", function() { return formatDateFromConvert; });
/* harmony export (immutable) */ __webpack_exports__["deadlineForText"] = deadlineForText;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizePaymentMethodsName", function() { return normalizePaymentMethodsName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cleanProviderName", function() { return cleanProviderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fmtQueryParams", function() { return fmtQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trackMatomoEvent", function() { return trackMatomoEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveFilterToSession", function() { return saveFilterToSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFiltersFromSession", function() { return getFiltersFromSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFiltersFromSession", function() { return clearFiltersFromSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDateToMonthYear", function() { return formatDateToMonthYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDaysInAdvance", function() { return getDaysInAdvance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(195);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var removeDuplicates = function removeDuplicates(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) {
      uniqueArray.push(arr[i]);
    }
  }
  return uniqueArray;
};
var groupByCategory = function groupByCategory(benefits) {
  var groupedObj = [];
  benefits.forEach(function (benefit) {
    if (groupedObj[benefit.category_name] === undefined) groupedObj[benefit.category_name] = [];
    groupedObj[benefit.category_name].push(_objectSpread(_objectSpread({}, benefit), {}, {
      opened: false
    }));
  });
  return groupedObj;
};
var toggleAccordion = function toggleAccordion(accordionList, code) {
  var newAccordionList = {};
  Object.keys(accordionList).forEach(function (key) {
    newAccordionList[key] = accordionList[key].map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        opened: item.code === code ? !item.opened : false
      });
    });
  });
  return newAccordionList;
};
var getUrlParams = function getUrlParams(url) {
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  if (!queryString) return {};
  var obj = {};
  var _queryString$split = queryString.split('#');
  var _queryString$split2 = _slicedToArray(_queryString$split, 1);
  queryString = _queryString$split2[0];
  var param = queryString.split('&');
  for (var i = 0; i < param.length; i += 1) {
    var paramName = param[i].substr(0, param[i].indexOf('=')).toLowerCase();
    var paramValue = param[i].substr(param[i].indexOf('=') + 1);
    obj[paramName] = paramValue;
  }
  return obj;
};
function detectCardBrand(number) {
  var num = number.replace(/\D/g, '');
  if (/^4/.test(num)) return 'visa';
  if (/^5[1-5]/.test(num) || /^2(2[2-9]|[3-6]|7[01]|720)/.test(num)) return 'mastercard';
  if (/^3[47]/.test(num)) return 'amex';
  if (/^3(0[0-5]|[68])/.test(num)) return 'diners';
  if (/^(606282|3841)/.test(num)) return 'hiper';
  if (/^(4011|4312|4389|4514|4573|4576|5041|5066|5067|509|6277|6362|6363|650|6516|6550)/.test(num)) return 'elo';
  return '';
}
var validateCreditCard = function validateCreditCard(brand, number, field) {
  var valid = true;
  var num = number.replace(/\s/g, '').toString();
  var regexBrands = {
    amex: {
      number: [/^(34|37)\d+$/, /^3[47][0-9]{13}$/gm],
      cvv: /^\d{4}$/
    },
    visa: {
      number: [/^4\d{12}(\d{3})?$/gm, /^(((40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/g],
      cvv: /^\d{3}$/
    },
    mastercard: {
      number: /^(?:5[1-5]\d{2}|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)\d{12}$/gm,
      cvv: /^\d{3}$/
    },
    elo: {
      number: [/^4\d{12}(\d{3})?$/gm, /^(((40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/g],
      cvv: /^\d{3}$/
    },
    diners: {
      number: [/^(?:5[1-5])\d{14}$/gm, /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/gm],
      cvv: /^\d{3}$/
    },
    hiper: {
      number: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/gm,
      cvv: /^\d{3}$/
    }
  };
  if (regexBrands[brand][field].length > 1) {
    if (!regexBrands[brand][field][0].test(num) && !regexBrands[brand][field][1].test(num)) valid = false;
  } else {
    if (!regexBrands[brand][field].test(num)) valid = false;
  }
  return valid;
};
var maskCashTransferAgency = function maskCashTransferAgency(bank) {
  switch (bank.slug) {
    case 'banco-do-brasil':
      return [/\d/, /\d/, /\d/, /\d/, '-', /\d/];
    default:
      return [/\d/, /\d/, /\d/, /\d/];
  }
};
var maskCashTransferAccount = function maskCashTransferAccount(bank) {
  switch (bank.slug) {
    case 'santander':
      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
    case 'inter':
      return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
    default:
      return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];
  }
};
var updatePurchaseSummaryData = function updatePurchaseSummaryData(state) {
  var checkAvailablePaymentMethods = function checkAvailablePaymentMethods(oldState) {
    var paymentMethods = _toConsumableArray(oldState.paymentMethods);
    var safetypayMethod = paymentMethods.find(function (element) {
      return element.slug === 'safetypay';
    });
    var boletoMethod = paymentMethods.find(function (element) {
      return element.slug === 'boleto';
    });
    if (safetypayMethod) {
      if (parseFloat(oldState.purchaseSummary.total) < parseFloat(oldState.safetypay.min_value)) {
        paymentMethods.find(function (element) {
          return element.slug === 'safetypay';
        }).available = false;
      } else {
        paymentMethods.find(function (element) {
          return element.slug === 'safetypay';
        }).available = oldState.safetypay.available;
      }
    }
    if (boletoMethod) {
      if (parseFloat(oldState.purchaseSummary.total) < parseFloat(oldState.boleto.min_value)) {
        paymentMethods.find(function (element) {
          return element.slug === 'boleto';
        }).available = false;
      } else {
        paymentMethods.find(function (element) {
          return element.slug === 'boleto';
        }).available = oldState.boleto.available;
      }
    }
    return _objectSpread(_objectSpread({}, oldState), {}, {
      paymentMethods: paymentMethods
    });
  };
  var selectedPaymentMethod = function selectedPaymentMethod(paymentMethods) {
    for (var pm in paymentMethods) {
      if (paymentMethods[pm].selected) {
        return paymentMethods[pm].id;
      }
    }
  };
  if (!state.plans || state.plans.length === 0) return _objectSpread({}, state);
  var paymentMethods = state.paymentMethods,
    alert = state.alert;
  var purchaseSummary = _objectSpread(_objectSpread({}, state.purchaseSummary), {}, {
    child: {
      qte: 0,
      price: 0
    },
    adult: {
      qte: 0,
      price: 0
    },
    elder: {
      qte: 0,
      price: 0
    },
    invalid: {
      qte: 0,
      price: 0
    }
  });
  state.insuredForms.forEach(function (insured) {
    if (insured.birth_date.match(/[0-3]\d\/[0-1]\d\/[1-2]\d\d\d/)) {
      var splDate = insured.birth_date.split('/');
      var fmtBirth = "".concat(splDate[2], "-").concat(splDate[1], "-").concat(splDate[0]);
      var birthDate = new Date(fmtBirth);
      var ref = new Date(state.quotationParams.departure_date);
      var age = 0;
      if (birthDate.getUTCDate() <= ref.getUTCDate() && birthDate.getUTCMonth() === ref.getUTCMonth() || birthDate.getUTCMonth() < ref.getUTCMonth()) {
        age = ref.getUTCFullYear() - birthDate.getUTCFullYear();
      } else {
        age = ref.getUTCFullYear() - birthDate.getUTCFullYear() - 1;
      }

      // invalid
      if (age < state.plans[0].child.min_age || age > state.plans[0].elder.max_age) purchaseSummary.invalid.qte += 1;
      // child
      else if (age >= state.plans[0].child.min_age && age <= state.plans[0].child.max_age) {
        purchaseSummary.child.qte += 1;
        purchaseSummary.child.price = purchaseSummary.child.qte * state.plans[0].child.price;
      }
      // elder
      else if (state.plans[0].elder.max_age <= state.plans[0].elder.min_age && age > state.plans[0].elder.max_age) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      } else if (state.plans[0].elder.max_age - state.plans[0].elder.min_age <= 1 && age > state.plans[0].elder.max_age) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      } else if (age >= state.plans[0].elder.min_age && age <= state.plans[0].elder.max_age) {
        purchaseSummary.elder.qte += 1;
        purchaseSummary.elder.price = purchaseSummary.elder.qte * state.plans[0].elder.price;
        insured.elder = true;
      }
      // adult
      else if (age >= state.plans[0].adult.min_age && age <= state.plans[0].adult.max_age) {
        purchaseSummary.adult.qte += 1;
        purchaseSummary.adult.price = purchaseSummary.adult.qte * state.plans[0].adult.price;
      }
    } else {
      purchaseSummary.adult.qte += 1;
      purchaseSummary.adult.price = purchaseSummary.adult.qte * state.plans[0].adult.price;
    }
  });
  if (state.insuredForms.length > 1) state.isInsuredFormDeletable = true;
  purchaseSummary.subtotal = purchaseSummary.child.price + purchaseSummary.adult.price + purchaseSummary.elder.price;
  purchaseSummary.paymentMethodDiscountValue = 0.0;
  if (state.paymentMethods.filter(function (method) {
    return method.selected;
  }).length > 0) {
    purchaseSummary.paymentMethodDiscountValue = state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0] && state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0].discount > 0 ? (state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0].discount / 100 * purchaseSummary.subtotal).toFixed(2) : 0;
    purchaseSummary.paymentMethodSelected = state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0] ? state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0].name : 0;
    purchaseSummary.paymentMethodDiscountPercent = state.paymentMethods.filter(function (method) {
      return method.selected;
    })[0].discount;
  }
  purchaseSummary.total = (purchaseSummary.subtotal - purchaseSummary.paymentMethodDiscountValue).toFixed(2);
  purchaseSummary.coupon_discount = 0;
  if (state.coupon.payment_method === null || selectedPaymentMethod(paymentMethods) === state.coupon.payment_method) {
    if (state.coupon.discount_type === 0) purchaseSummary.coupon_discount = parseFloat(state.coupon.discount);else if (state.coupon.discount_type === 1) purchaseSummary.coupon_discount = state.coupon.discount / 100 * purchaseSummary.total;
  }
  purchaseSummary.creditCouponCreditAmount = 0.0;
  if (state.creditCoupon && state.creditCoupon.creditAmount > 0 && state.creditCoupon.applied) {
    purchaseSummary.creditCouponCreditAmount = state.creditCoupon.creditAmount;
  }
  purchaseSummary.creditCouponAmountUsed = purchaseSummary.creditCouponCreditAmount;
  purchaseSummary.total -= purchaseSummary.coupon_discount;
  if (purchaseSummary.total < 0) {
    purchaseSummary.total = 0.0;
    purchaseSummary.creditCouponAmountUsed = 0;
  }
  if (purchaseSummary.total > 0) {
    purchaseSummary.total -= purchaseSummary.creditCouponCreditAmount;
  }
  if (purchaseSummary.total < 0) {
    purchaseSummary.creditCouponRemainingBalance = Math.abs(purchaseSummary.total);
    purchaseSummary.creditCouponAmountUsed = purchaseSummary.creditCouponCreditAmount - purchaseSummary.creditCouponRemainingBalance;
    purchaseSummary.total = 0.0;
  }
  if (purchaseSummary.total === 0) {
    paymentMethods.forEach(function (paymentMethod) {
      paymentMethod.selected = false;
      if (paymentMethod.slug === 'pix') {
        paymentMethod.selected = true;
      }
    });
  }
  purchaseSummary.coupon_discount = purchaseSummary.coupon_discount.toFixed(2);

  // Investimento por dia
  var begin = new Date(state.quotationParams.departure_date);
  var end = new Date(state.quotationParams.return_date);
  var diffDays = getDaysDiff(begin, end);
  purchaseSummary.investmentPerDay = purchaseSummary.total / diffDays;
  return checkAvailablePaymentMethods(_objectSpread(_objectSpread({}, state), {}, {
    purchaseSummary: purchaseSummary,
    paymentMethods: paymentMethods,
    alert: alert
  }));
};
var validatePurchase = function validatePurchase(state) {
  var EMPTY_FIELD = 'Este campo é obrigatório';
  var INVALID_VALUE = 'Preencha o campo corretamente';
  var destination = state.quotationParams.destination;
  var errors = {
    insuredForms: state.insuredForms.map(function () {
      return [{
        cpf: false,
        rg: false,
        name: false,
        birth_date: false,
        incoming: false
      }];
    }),
    paymentMethods: false,
    creditCard: {
      cvv: false,
      cpf: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      expiry_month: false
    },
    boleto: {
      cpf: false,
      name: false
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false
    },
    cash: {
      holderName: false,
      holderCpf: false
    },
    pix: {
      name: false,
      cpf: false
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false,
      cep: false,
      city: false,
      state: false,
      number: false,
      address: false,
      district: false,
      complement: false
    },
    purchase_is_valid: false,
    errorsModalFranchise: false
  };
  var plans = state.plans,
    insuredForms = state.insuredForms,
    quotationParams = state.quotationParams;
  var validDuplicateCPF = function validDuplicateCPF(birth_date) {
    var birthDate = new Date(birth_date.split('/').reverse().join('/'));
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    if (age <= 5) return false;
    return true;
  };

  // Validar Formulários de Segurados
  insuredForms.forEach(function (insured, i) {
    var rg = insured.rg,
      cpf = insured.cpf,
      passport = insured.passport,
      name = insured.name,
      birth_date = insured.birth_date,
      document_type = insured.document_type,
      incoming = insured.incoming;
    // valida nome
    if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
    if (name.match(/^\s/)) {
      errors.insuredForms[i].name = 'Este campo não pode começar com espaço';
    }
    if (name.split(' ').length < 2) errors.insuredForms[i].name = 'Digite o nome Completo';
    if (!isValidName(name)) {
      errors.insuredForms[i].name = 'O nome não pode conter caracteres especiais.';
    }
    if (document_type === 'cpf') {
      // valida cpf
      if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
      if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
      for (var j = 0; j < insuredForms.length; j++) {
        if (j !== i && insuredForms[j].cpf === cpf && validDuplicateCPF(insuredForms[j].birth_date) && validDuplicateCPF(insuredForms[i].birth_date)) {
          errors.insuredForms[i].cpf = 'Esse CPF já está em uso.';
        }
      }
    } else if (document_type === 'rg') {
      // valida rg
      if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
    } else if (document_type === 'passport') {
      // valida rg
      if (passport.replace(/_/g, '').length < 6 || passport.replace(/_/g, '').length > 20) errors.insuredForms[i].passport = 'Passaporte inválido';
      if (passport === '') errors.insuredForms[i].passport = EMPTY_FIELD;
    }
    if (destination === 'receptivo') {
      if (incoming === '') errors.insuredForms[i].incoming = EMPTY_FIELD;
    }
    var minAge = plans[0].child.min_age;
    var maxAge = plans[0].elder.max_age;

    // valida data_nascimento
    if (!birth_date === '') errors.insuredForms[i].birth_date = EMPTY_FIELD;else if (isValidDate(birth_date, quotationParams.departure_date)) {
      var ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);
      if (ageStatus.aboveMaxAge) errors.insuredForms[i].birth_date = "O plano possui faixa et\xE1ria limite de at\xE9 ".concat(maxAge, " anos. Escolha um novo seguro.");else if (ageStatus.belowMinAge) errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
    } else {
      errors.insuredForms[i].birth_date = INVALID_VALUE;
    }
  });
  // Validar Método de Pagamento
  var selectedPM = state.paymentMethods.filter(function (method) {
    return method.selected;
  });
  selectedPM = selectedPM.length ? selectedPM[0] : null;
  var selectCard = state.creditCard.brands.filter(function (brand) {
    return brand.selected;
  });
  selectCard = selectCard.length ? selectCard[0] : null;
  if (selectedPM) {
    if (!selectedPM.available) {
      if (selectedPM.slug === 'boleto') errors.paymentMethods = 'O Boleto não está disponível para a data selecionada';
      if (selectedPM.slug === 'safetypay') errors.paymentMethods = 'A transferência bancária não está disponível para a data selecionada';
    }
    if (selectedPM.slug === 'credit-card') {
      // Validar Cartão de Crédito
      // number
      if (selectCard) {
        if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number')) errors.creditCard.number = INVALID_VALUE;
      }
      // holder_name
      if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;
      if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;
      if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;
      if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;
      if (state.creditCard.parcels.filter(function (p) {
        return p.selected;
      }).length <= 0) errors.creditCard.parcels = 'Por favor, selecione a forma de parcelamento';

      // cvv
      if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv')) errors.creditCard.cvv = INVALID_VALUE;
    }
    if (selectedPM.slug === 'boleto') {
      // Validar Boleto
      // nome
      if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
      // cpf
      if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;
    }
    if (selectedPM.slug === 'safetypay') {
      // Validar Transferência
      var selectedBank = state.safetypay.banks.filter(function (bank) {
        return bank.selected;
      })[0];
      if (!selectedBank) errors.safetypay.banks = 'Selecione um banco';

      // nome
      if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
      // cpf
      if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
    }
    if (selectedPM.slug === 'cash') {
      // Validar Dinheiro
      // responsável pelo pagamento
      if (state.cash.holderName === '') errors.cash.holderName = EMPTY_FIELD;
      // cpf do responsável
      if (!isValidCPF(state.cash.holderCpf)) errors.cash.holderCpf = INVALID_VALUE;
    }
    if (selectedPM.slug === 'pix') {
      if (state.pix.name === '') errors.pix.name = EMPTY_FIELD;
      if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;
    }
  } else errors.paymentMethods = 'Selecione um método de pagamento';

  // contato
  // nome
  if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
  // email
  else if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
  if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
  // telefone
  if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;

  // endereço
  if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
  if (state.contact.city === '') errors.contact.city = EMPTY_FIELD;else if (state.contact.city.length < 3) errors.contact.city = EMPTY_FIELD;else if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
  if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;
  if (state.contact.number === '') {
    if (!state.contact.complement || state.contact.complement.trim() === '') {
      errors.contact.number = EMPTY_FIELD;
    }
  } else {
    if (/[^0-9]/.test(state.contact.number)) {
      errors.contact.number = 'Digite apenas números';
    }
    if (state.contact.number.length > 10) {
      errors.contact.number = 'O número deve ter no máximo 10 caracteres';
    }
    if (state.contact.number === '0') {
      errors.contact.number = 'O número não pode ser 0';
    }
  }
  if (state.contact.address.length < 3) errors.contact.address = EMPTY_FIELD;
  if (state.contact.district === '') errors.contact.district = EMPTY_FIELD;
  if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;
  if (state.contact.district.length > 50) errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';
  errors.errorsModalFranchise = true;
  var isOk = true;
  var anchor = '';

  // Vereifica se há error após a validação para que o formulário seja enviado
  for (var field1 in errors) {
    if (errors[field1] && typeof errors[field1] !== 'string') {
      for (var field2 in errors[field1]) {
        if (errors[field1][field2] && typeof errors[field1][field2] !== 'string') {
          for (var field3 in errors[field1][field2]) {
            if (errors[field1][field2][field3] && typeof errors[field1][field2][field3] !== 'string') {
              for (var field4 in errors[field1][field2][field3]) {
                if (typeof errors[field1][field2][field3][field4] === 'string') {
                  anchor = "".concat(field1, "_").concat(field2, "_").concat(field3, "_").concat(field4);
                  isOk = false;
                  return _objectSpread(_objectSpread({}, state), {}, {
                    anchor: anchor,
                    errors: errors,
                    purchase_is_valid: isOk
                  });
                }
              }
            } else if (typeof errors[field1][field2][field3] === 'string') {
              anchor = "".concat(field1, "_").concat(field2, "_").concat(field3);
              isOk = false;
              return _objectSpread(_objectSpread({}, state), {}, {
                anchor: anchor,
                errors: errors,
                purchase_is_valid: isOk
              });
            }
          }
        } else if (typeof errors[field1][field2] === 'string') {
          anchor = "".concat(field1, "_").concat(field2);
          isOk = false;
          return _objectSpread(_objectSpread({}, state), {}, {
            anchor: anchor,
            errors: errors,
            purchase_is_valid: isOk
          });
        }
      }
    } else if (typeof errors[field1] === 'string') {
      anchor = "".concat(field1);
      isOk = false;
      return _objectSpread(_objectSpread({}, state), {}, {
        anchor: anchor,
        errors: errors,
        purchase_is_valid: isOk
      });
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    anchor: anchor,
    errors: errors,
    purchase_is_valid: true
  });
};
var validatePurchaseMobile = function validatePurchaseMobile(state, stage) {
  var EMPTY_FIELD = 'Este campo é obrigatório';
  var INVALID_VALUE = 'Preencha o campo corretamente';
  var errors = {
    insuredForms: state.insuredForms.map(function () {
      return [{
        cpf: false,
        rg: false,
        name: false,
        birth_date: false
      }];
    }),
    paymentMethods: false,
    creditCard: {
      cvv: false,
      cpf: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      expiry_month: false
    },
    boleto: {
      cpf: false,
      name: false
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false
    },
    cash: {
      username: false,
      password: false
    },
    pix: {
      name: false,
      cpf: false
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false,
      cep: false,
      city: false,
      state: false,
      number: false,
      address: false,
      district: false,
      complement: false
    },
    purchase_is_valid: false,
    errorsModalFranchise: false
  };
  var plans = state.plans,
    insuredForms = state.insuredForms,
    quotationParams = state.quotationParams;
  var validDuplicateCPF = function validDuplicateCPF(birth_date) {
    var birthDate = new Date(birth_date.split('/').reverse().join('/'));
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    if (age <= 5) return false;
    return true;
  };

  // Validar Formulários de Segurados
  switch (stage) {
    case 'INSURED_CONTACT':
      insuredForms.forEach(function (insured, i) {
        var rg = insured.rg,
          cpf = insured.cpf,
          name = insured.name,
          birth_date = insured.birth_date,
          document_type = insured.document_type;

        // valida nome
        if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
        if (name.split(' ').length < 2) {
          errors.insuredForms[i].name = 'Digite o nome Completo';
        }
        if (document_type === 'cpf') {
          // valida cpf
          if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
          if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
          for (var j = 0; j < insuredForms.length; j++) {
            if (i !== j && insuredForms[j].cpf === cpf && validDuplicateCPF(insuredForms[j].birth_date) && validDuplicateCPF(insuredForms[i].birth_date)) {
              errors.insuredForms[i].cpf = 'Esse CPF já está em uso. Crianças de 0 a 5 anos solicitamos que seja preenchido com o CPF do titular.';
            }
          }
        } else if (document_type === 'rg') {
          // valida rg
          if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
        }
        var minAge = plans[0].child.min_age;
        var maxAge = plans[0].elder.max_age;

        // valida data_nascimento
        if (birth_date === '') {
          errors.insuredForms[i].birth_date = EMPTY_FIELD;
        } else if (isValidDate(birth_date, quotationParams.departure_date)) {
          var ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);
          if (ageStatus.aboveMaxAge) errors.insuredForms[i].birth_date = "O plano possui faixa et\xE1ria limite de at\xE9 ".concat(maxAge, " anos. Escolha um novo seguro.");else if (ageStatus.belowMinAge) errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
        } else errors.insuredForms[i].birth_date = INVALID_VALUE;
      });
      break;
    case 'INSURED_PAYMENT_PURCHASE':
      insuredForms.forEach(function (insured, i) {
        var rg = insured.rg,
          cpf = insured.cpf,
          name = insured.name,
          birth_date = insured.birth_date,
          document_type = insured.document_type;

        // valida nome
        if (name === '') errors.insuredForms[i].name = 'Este campo é obrigatório';
        if (name.split(' ').length < 2) errors.insuredForms[i].name = 'Digite o nome Completo';
        if (document_type === 'cpf') {
          // valida cpf
          if (!isValidCPF(cpf)) errors.insuredForms[i].cpf = INVALID_VALUE;
          if (cpf === '') errors.insuredForms[i].cpf = EMPTY_FIELD;
        } else if (document_type === 'rg') {
          // valida rg
          if (rg === '') errors.insuredForms[i].rg = EMPTY_FIELD;
        }
        var minAge = plans[0].child.min_age;
        var maxAge = plans[0].elder.max_age;

        // valida data_nascimento
        if (!birth_date === '') errors.insuredForms[i].birth_date = EMPTY_FIELD;else if (isValidDate(birth_date, quotationParams.departure_date)) {
          var ageStatus = getAgeStatus(birth_date, quotationParams.departure_date, minAge, maxAge);
          if (ageStatus.aboveMaxAge) errors.insuredForms[i].birth_date = "O plano possui faixa et\xE1ria limite de at\xE9 ".concat(maxAge, " anos. Escolha um novo seguro.");else if (ageStatus.belowMinAge) errors.insuredForms[i].birth_date = 'Verifique idade mínima do plano escolhido.';
        } else errors.insuredForms[i].birth_date = INVALID_VALUE;
      });
      // Validar Método de Pagamento
      var selectedPM = state.paymentMethods.filter(function (method) {
        return method.selected;
      });
      selectedPM = selectedPM.length ? selectedPM[0] : null;
      var selectCard = state.creditCard.brands.filter(function (brand) {
        return brand.selected;
      });
      selectCard = selectCard.length ? selectCard[0] : null;
      if (selectedPM) {
        if (!selectedPM.available) {
          if (selectedPM.slug === 'boleto') errors.paymentMethods = 'O Boleto não está disponível para a data selecionada';
          if (selectedPM.slug === 'safetypay') errors.paymentMethods = 'A transferência bancária não está disponível para a data selecionada';
        }
        if (selectedPM.slug === 'credit-card') {
          // Validar Cartão de Crédito
          // number
          if (selectCard) {
            // validação de número de digitos por bandeira
            if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number')) errors.creditCard.number = INVALID_VALUE;
          }
          // holder_name
          if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;
          if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;
          if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;
          if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;
          if (state.creditCard.parcels.filter(function (p) {
            return p.selected;
          }).length <= 0) errors.creditCard.parcels = 'Por favor, selecione a forma de parcelamento';

          // cvv
          if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv')) errors.creditCard.cvv = INVALID_VALUE;
        }
        if (selectedPM.slug === 'pix') {
          if (state.pix.cpf === '') errors.pix.cpf = EMPTY_FIELD;else if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;
        }
        if (selectedPM.slug === 'boleto') {
          // Validar Boleto
          // nome
          if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
          // cpf
          if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;
        }
        if (selectedPM.slug === 'safetypay') {
          // Validar Transferência
          var selectedBank = state.safetypay.banks.filter(function (bank) {
            return bank.selected;
          })[0];
          if (!selectedBank) errors.safetypay.banks = 'Selecione um banco';

          // nome
          if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
          // cpf
          if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
        }
        if (selectedPM.slug === 'cash') {
          // Validar Dinheiro
          // Responsável pelo pagamento
          if (state.cash.holderName === '') errors.cash.holderName = EMPTY_FIELD;
          // Cpf do responsável pelo pagamento
          if (state.cash.holderCpf === '') errors.cash.holderCpf = EMPTY_FIELD;
        }
      } else errors.paymentMethods = 'Selecione um método de pagamento';
      break;
    case 'INSURED_RESP_CONTACT':
      // contato
      // nome
      if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
      // email
      else if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
      if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
      // telefone
      if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;

      // endereço
      if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
      if (state.contact.city === '') errors.contact.city = EMPTY_FIELD;else if (state.contact.city === ' ') errors.contact.city = EMPTY_FIELD;else if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
      if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;
      if (state.contact.number === '') {
        if (!state.contact.complement || state.contact.complement.trim() === '') {
          errors.contact.number = EMPTY_FIELD;
        }
      } else {
        if (/[^0-9]/.test(state.contact.number)) {
          errors.contact.number = 'Digite apenas números';
        }
        if (state.contact.number.length > 10) {
          errors.contact.number = 'O número deve ter no máximo 10 caracteres';
        }
        if (state.contact.number === '0') {
          errors.contact.number = 'O número não pode ser 0';
        }
      }
      if (state.contact.address === '') errors.contact.address = EMPTY_FIELD;else if (state.contact.address === ' ') errors.contact.address = EMPTY_FIELD;
      if (state.contact.district === '') errors.contact.district = EMPTY_FIELD;else if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;else if (state.contact.district.length > 50) errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';
      break;
    default:
      break;
  }
  errors.errorsModalFranchise = true;
  var isOk = true;
  var anchor = '';

  // Vereifica se há error após a validação para que o formulário seja enviado
  for (var field1 in errors) {
    if (errors[field1] && typeof errors[field1] !== 'string') {
      for (var field2 in errors[field1]) {
        if (errors[field1][field2] && typeof errors[field1][field2] !== 'string') {
          for (var field3 in errors[field1][field2]) {
            if (errors[field1][field2][field3] && typeof errors[field1][field2][field3] !== 'string') {
              for (var field4 in errors[field1][field2][field3]) {
                if (typeof errors[field1][field2][field3][field4] === 'string') {
                  anchor = "".concat(field1, "_").concat(field2, "_").concat(field3, "_").concat(field4);
                  isOk = false;
                  return _objectSpread(_objectSpread({}, state), {}, {
                    anchor: anchor,
                    errors: errors,
                    purchase_is_valid: isOk
                  });
                }
              }
            } else if (typeof errors[field1][field2][field3] === 'string') {
              anchor = "".concat(field1, "_").concat(field2, "_").concat(field3);
              isOk = false;
              return _objectSpread(_objectSpread({}, state), {}, {
                anchor: anchor,
                errors: errors,
                purchase_is_valid: isOk
              });
            }
          }
        } else if (typeof errors[field1][field2] === 'string') {
          anchor = "".concat(field1, "_").concat(field2);
          isOk = false;
          return _objectSpread(_objectSpread({}, state), {}, {
            anchor: anchor,
            errors: errors,
            purchase_is_valid: isOk
          });
        }
      }
    } else if (typeof errors[field1] === 'string') {
      anchor = "".concat(field1);
      isOk = false;
      return _objectSpread(_objectSpread({}, state), {}, {
        anchor: anchor,
        errors: errors,
        purchase_is_valid: isOk
      });
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    anchor: anchor,
    errors: errors,
    purchase_is_valid: true
  });
};
function isValidName(name) {
  return /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/.test(name.trim());
}
var validatePurchaseOnBlur = function validatePurchaseOnBlur(value, name, index, state) {
  var errors = {
    insuredForms: [],
    paymentMethods: false,
    creditCard: {},
    boleto: {},
    safetypay: {},
    cash: {
      username: false,
      password: false
    },
    pix: {},
    coupon: false,
    contact: {},
    purchase_is_valid: false,
    errorsModalFranchise: false,
    just_loaded: true
  };
  var EMPTY_FIELD = 'Este campo é obrigatório';
  var INVALID_VALUE = 'Preencha o campo corretamente';
  var plans = state.plans;
  var selectCard = state.creditCard.brands.filter(function (brand) {
    return brand.selected;
  });
  selectCard = selectCard.length ? selectCard[0] : null;
  errors.insuredForms = state.errors.insuredForms;
  errors.boleto = state.errors.boleto;
  errors.safetypay = state.errors.safetypay;
  errors.creditCard = state.errors.creditCard;
  errors.pix = state.errors.pix;
  errors.contact = state.errors.contact;

  // VALIDAÇÃO SEGURADOS
  if (name === 'name') {
    if (errors.insuredForms[index]) {
      errors.insuredForms[index].name = false;
      if (value === '') {
        errors.insuredForms[index].name = 'Este campo é obrigatório';
      }
      if (value.match(/^\s/)) {
        errors.insuredForms[index].name = 'Este campo não pode começar com espaço';
      }
      if (value.split(' ').length < 2) {
        errors.insuredForms[index].name = 'Digite o nome Completo';
      }
      if (!isValidName(value)) {
        errors.insuredForms[index].name = 'O nome não pode conter caracteres especiais.';
      }
    }
  }
  if (name === 'cpf') {
    if (index <= errors.insuredForms.length - 1) {
      errors.insuredForms[index].cpf = false;
      if (!isValidCPF(value) && errors.insuredForms[index].cpf) errors.insuredForms[index].cpf = INVALID_VALUE;
      if (value === '') errors.insuredForms[index].cpf = EMPTY_FIELD;
    }
    if (errors.insuredForms[index]) {
      errors.insuredForms[index].just_loaded = false;
    }
  }
  if (name === 'passport') {
    if (index <= errors.insuredForms.length - 1) {
      errors.insuredForms[index].passport = false;
      if (value.replace(/_/g, '').length < 6) {
        errors.insuredForms[index].passport = INVALID_VALUE;
      }
      if (value === '') errors.insuredForms[index].passport = EMPTY_FIELD;
    }
    errors.insuredForms[index].just_loaded = false;
  }

  // optional incoming
  if (name === 'incoming') {
    errors.insuredForms[index].incoming = false;
    if (value === '') errors.insuredForms[index].incoming = EMPTY_FIELD;else {
      errors.just_loaded = false;
    }
  }
  var minAge = plans[0].child.min_age;
  var maxAge = plans[0].elder.max_age;
  if (name === 'birth_date') {
    if (value === '') {
      errors.insuredForms[index].birth_date = EMPTY_FIELD;
    } else if (isValidDate(value, state.quotationParams.departure_date)) {
      var ageStatus = getAgeStatus(value, state.quotationParams.departure_date, minAge, maxAge);
      if (ageStatus.aboveMaxAge) {
        errors.insuredForms[index].birth_date = "O plano possui faixa et\xE1ria limite de at\xE9 ".concat(maxAge, " anos. Escolha um novo seguro.");
      } else if (ageStatus.belowMinAge) {
        errors.insuredForms[index].birth_date = 'Verifique idade mínima do plano escolhido.';
      } else {
        if (errors.insuredForms && errors.insuredForms[index]) {
          errors.insuredForms[index].birth_date = false;
        }
      }
    } else {
      errors.insuredForms[index].birth_date = INVALID_VALUE;
    }
  }

  // datalayer when all 3 inputs are correct
  if (name === 'name' || name === 'birth_data' || name === 'cpf') {
    if (errors.insuredForms && errors.insuredForms[index] && errors.insuredForms[index].birth_date === false && errors.insuredForms[index].cpf === false && errors.insuredForms[index].name === false && errors.insuredForms[index].just_loaded === false) {
      __WEBPACK_IMPORTED_MODULE_0__utils_dataLayer__["a" /* default */].raw({
        event: 'inclusao_dados_identificacao'
      });
    }
  }

  // VALIDAÇÃO BOLETO
  if (name === 'boleto_name') {
    errors.boleto.name = false;
    if (state.boleto.name === '') errors.boleto.name = EMPTY_FIELD;else if (state.boleto.name.split(' ').length < 2) errors.boleto.name = 'Digite o nome completo';
  }
  if (name === 'boleto_cpf') {
    errors.boleto.cpf = false;
    if (state.boleto.cpf === '') errors.boleto.cpf = EMPTY_FIELD;else if (!isValidCPF(state.boleto.cpf)) errors.boleto.cpf = INVALID_VALUE;else {
      errors.just_loaded = false;
    }
  }
  if (errors.boleto.cpf === false && errors.boleto.name === false && errors.just_loaded === false) {
    __WEBPACK_IMPORTED_MODULE_0__utils_dataLayer__["a" /* default */].raw({
      event: 'inclusao_dados_pagamento'
    });
  }

  // VALIDAÇÃO PIX
  if (name === 'pix_name') {
    errors.pix.name = false;
    if (state.pix.name === '') errors.pix.name = EMPTY_FIELD;else if (state.pix.name.split(' ').length < 2) errors.pix.name = 'Digite o nome completo';
  }
  if (name === 'pix_cpf') {
    errors.pix.cpf = false;
    if (state.pix.cpf === '') errors.pix.cpf = EMPTY_FIELD;else if (!isValidCPF(state.pix.cpf)) errors.pix.cpf = INVALID_VALUE;else {
      errors.just_loaded = false;
    }
  }
  if (errors.pix.cpf === false && errors.pix.name === false && errors.just_loaded === false) {
    __WEBPACK_IMPORTED_MODULE_0__utils_dataLayer__["a" /* default */].raw({
      event: 'inclusao_dados_pagamento'
    });
  }

  // VALIDAÇÃO TRANSFERENCIA
  if (name === 'transf_name') {
    errors.safetypay.name = false;
    if (state.safetypay.name === '') errors.safetypay.name = EMPTY_FIELD;else if (state.safetypay.name.split(' ').length < 2) errors.safetypay.name = 'Digite o nome completo';
  }
  if (name === 'transf_cpf') {
    errors.safetypay.cpf = false;
    if (state.safetypay.cpf === '') errors.safetypay.cpf = EMPTY_FIELD;else if (!isValidCPF(state.safetypay.cpf)) errors.safetypay.cpf = INVALID_VALUE;
  }
  if (name === 'transf_agency') {
    if (typeof errors.safetypay.agency === 'string') {
      errors.safetypay.agency = false;
      if (state.safetypay.agency === '') errors.safetypay.agency = EMPTY_FIELD;else if (!state.safetypay.agency.match(/\d{4}-?\d?/)) errors.safetypay.agency = INVALID_VALUE;
    }
  }
  if (name === 'transf_account') {
    errors.safetypay.account = false;
    if (state.safetypay.account === '') errors.safetypay.account = EMPTY_FIELD;else if (!state.safetypay.account.match(/\d{4}-?\d?/)) errors.safetypay.account = INVALID_VALUE;
  }

  // VALIDAÇÃO CARTÃO DE CRÉDITO
  if (name === 'creditcard_number') {
    errors.creditCard.number = false;
    if (!validateCreditCard(selectCard.brand_name, state.creditCard.number, 'number')) errors.creditCard.number = INVALID_VALUE;
  }
  if (name === 'creditcard_month') {
    errors.creditCard.expiry_month = false;
    if (state.creditCard.expiry_month === '') errors.creditCard.expiry_month = EMPTY_FIELD;else if (state.creditCard.expiry_month.length !== 2) errors.creditCard.expiry_month = INVALID_VALUE;
  }
  if (name === 'creditcard_year') {
    errors.creditCard.expiry_year = false;
    if (state.creditCard.expiry_year === '') errors.creditCard.expiry_year = EMPTY_FIELD;else if (state.creditCard.expiry_year.length !== 4) errors.creditCard.expiry_year = INVALID_VALUE;
  }
  if (name === 'creditcard_cvv') {
    errors.creditCard.cvv = false;
    if (!validateCreditCard(selectCard.brand_name, state.creditCard.cvv, 'cvv')) errors.creditCard.cvv = INVALID_VALUE;
  }
  if (name === 'creditcard_holdername') {
    errors.creditCard.holder_name = false;
    if (state.creditCard.holder_name === '') errors.creditCard.holder_name = EMPTY_FIELD;else if (state.creditCard.holder_name.split(' ').length < 2) errors.creditCard.holder_name = INVALID_VALUE;
  }
  if (name === 'creditcard_holdercpf') {
    errors.creditCard.holder_cpf = false;
    if (state.creditCard.holder_cpf === '') errors.creditCard.holder_cpf = EMPTY_FIELD;else if (!isValidCPF(state.creditCard.holder_cpf)) errors.creditCard.holder_cpf = INVALID_VALUE;
  }

  // DADOS DO CONTATO
  if (name === 'contact_name') {
    errors.contact.contact_name = false;
    if (state.contact.contact_name === '') errors.contact.contact_name = EMPTY_FIELD;
  }
  if (name === 'contact_email') {
    errors.contact.email = false;
    if (state.contact.email === '') errors.contact.email = EMPTY_FIELD;
    if (!isValidEmail(state.contact.email)) errors.contact.email = INVALID_VALUE;
  }
  if (name === 'contact_phone') {
    errors.contact.phone_number = false;
    if (state.contact.phone_number === '') errors.contact.phone_number = EMPTY_FIELD;else if (!isValidPhone(state.contact.phone_number)) errors.contact.phone_number = INVALID_VALUE;
  }
  if (name === 'contact_cep') {
    errors.contact.cep = false;
    if (state.contact.cep === '') errors.contact.cep = EMPTY_FIELD;else if (!state.contact.cep.match(/^\d\d\.?\d\d\d-?\d\d\d$/)) errors.contact.cep = INVALID_VALUE;
  }
  if (name === 'contact_address') {
    errors.contact.address = false;
    if (state.contact.address === '') if (state.contact.address.length < 3) errors.contact.address = EMPTY_FIELD;
  }
  if (name === 'contact_number') {
    errors.contact.number = false;
    var numberVal = state.contact.number;
    var complementVal = state.contact.complement;
    if (numberVal === '') {
      if (!complementVal || complementVal.trim() === '') {
        errors.contact.number = EMPTY_FIELD;
      }
    } else {
      if (/[^0-9]/.test(numberVal)) {
        errors.contact.number = 'Digite apenas números';
      }
      if (numberVal.length > 10) {
        errors.contact.number = 'O número deve ter no máximo 10 caracteres';
      }
      if (numberVal === '0') {
        errors.contact.number = 'O número não pode ser 0';
      }
    }
  }
  if (name === 'contact_district') {
    errors.contact.district = false;
    if (state.contact.district === '') {
      errors.contact.district = EMPTY_FIELD;
    } else {
      if (state.contact.district.length < 3) errors.contact.district = EMPTY_FIELD;
      if (state.contact.district.length > 50) errors.contact.district = 'O bairro deve ter no máximo 50 caracteres';
    }
  }
  if (name === 'contact_city') {
    errors.contact.city = false;
    if (state.contact.city === '') {
      errors.contact.city = EMPTY_FIELD;
    } else {
      if (state.contact.city.length < 3) errors.contact.city = EMPTY_FIELD;
      if (state.contact.city.length > 100) errors.contact.city = 'A cidade deve ter no máximo 100 caracteres';
    }
  }
  if (name === 'contact_state') {
    errors.contact.state = false;
    if (state.contact.state === '') errors.contact.state = EMPTY_FIELD;else {
      errors.just_loaded = false;
    }
  }
  var _errors$contact = errors.contact,
    address = _errors$contact.address,
    cep = _errors$contact.cep,
    city = _errors$contact.city,
    contact_name = _errors$contact.contact_name,
    email = _errors$contact.email,
    number = _errors$contact.number,
    phone_number = _errors$contact.phone_number;
  if (address === false && cep === false && city === false && contact_name === false && email === false && number === false && phone_number === false && errors.contact.state === false && errors.just_loaded === false) {
    __WEBPACK_IMPORTED_MODULE_0__utils_dataLayer__["a" /* default */].raw({
      event: 'inclusao_dados_contato'
    });
  }
  errors.errorsModalFranchise = true;
  return errors;
};
var getProductDiscount = function getProductDiscount(price, productId, coupon) {
  if (!coupon) return 0;
  if (!coupon.products) return 0;
  if (!coupon.products.includes(productId.toString())) return 0;
  var newPrice = price;
  if (coupon.discount_type === 1) newPrice *= 1 - coupon.discount / 100;else if (coupon.discount_type === 0) newPrice -= coupon.discount;
  return newPrice;
};
var getDaysDiff = function getDaysDiff(begin, end) {
  return Math.ceil(Math.abs(end.getTime() - begin.getTime()) / (1000 * 3600 * 24)) + 1;
};
var changeTitle = function changeTitle(page) {
  var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var title = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* HOME_PAGE_TITLE */];
  switch (page) {
    case 'search':
      title = "".concat(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SEARCH_PAGE_TITLE */], " ").concat(getDestinationBySlug(custom));
      break;
    case 'comparison':
      title = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* COMPARISON_PAGE_TITLE */];
      break;
    case 'detail':
      title = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DETAIL_PAGE_TITLE */];
      break;
    case 'purchase':
      title = __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* PURCHASE_PAGE_TITLE */];
      break;
    default:
      title = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* HOME_PAGE_TITLE */];
  }
  document.title = title;
};

// #region Checks
var isB2b = function isB2b() {
  return window.location.pathname.includes('/b2b/');
};
var cleanDate = function cleanDate(date) {
  return date.match(/(\d{4}-\d{2}-\d{2})/)[1];
};
var cleanSlugDestination = function cleanSlugDestination(slug) {
  switch (slug) {
    case 'brasil':
      return 'Brasil';
    case 'america-do-sul':
      return 'América do Sul';
    case 'europa':
      return 'Europa';
    case 'america-do-norte':
      return 'América do Norte';
    case 'america-central':
      return 'América Central';
    case 'oceania':
      return 'Oceania';
    case 'oriente-medio':
      return 'Oriente Médio';
    case 'asia':
      return 'Ásia';
    case 'africa':
      return 'África';
    case 'maritimo':
      return 'Marítimo';
    case 'internacional':
      return 'Internacional';
    case 'receptivo':
      return 'Receptivo';
    default:
      return '';
  }
};
var isMobile = function isMobile() {
  return window.innerWidth < 768;
};
var getDateFormat = function getDateFormat(dateString) {
  if (typeof dateString !== 'string') return '';
  var brFormatRegex = new RegExp('(' + '(((^[0-2][0-9]|3[0-1])/(0[13578]|10|12))|' +
  // dia/mes
  '((^[0-2][0-9]|30)/(0[469]|11))|' +
  // dia/mes
  '(^[0-2][0-9]/02))' +
  // dia/mes
  '/((18|19|20)[0-9]{2})$' +
  // ano
  ')', 'i');
  var utcFormatRegex = new RegExp('(' + '(^(18|19|20)[0-9]{2})-' +
  // ano
  '(((0[13578]|10|12)-([0-2][0-9]|3[0-1]))|' +
  // dia-mes
  '((0[469]|11)-([0-2][0-9]|30))|' +
  // dia-mes
  '(02-[0-2][0-9]))' +
  // dia-mes
  ')', 'i');
  if (dateString.match(brFormatRegex)) return 'br';
  if (dateString.match(utcFormatRegex)) return 'utc';
  return '';
};
var isValidDate = function isValidDate(dateString, refDate) {
  var dateFormat = getDateFormat(dateString);
  if (dateFormat === '') return;
  var fmtDate = dateString;
  var splDateString = dateString.split('/');
  if (dateFormat === 'br') {
    fmtDate = "".concat(splDateString[2], "-").concat(splDateString[1], "-").concat(splDateString[0]);
  }
  var date = new Date(fmtDate);
  var ref = new Date(refDate);
  if (date.getUTCFullYear() > ref.getFullYear()) return false;
  if (date.getUTCFullYear() === ref.getUTCFullYear()) {
    if (date.getUTCMonth() > ref.getUTCMonth()) return false;
    if (date.getUTCMonth() === ref.getUTCMonth()) if (date.getUTCDate() > ref.getUTCDate()) return false;
  }
  return true;
};
var getAgeStatus = function getAgeStatus(birthDateString, refDateString, minAge, maxAge) {
  var formattedBirthDateString = birthDateString.split('/');
  formattedBirthDateString = "".concat(formattedBirthDateString[2], "-").concat(formattedBirthDateString[1], "-").concat(formattedBirthDateString[0]);
  var time = new Date();
  var birthDate = new Date(formattedBirthDateString);
  var refDate = new Date(refDateString);
  refDate.setDate(time.getDate() + 1);
  var aboveMaxAge = false;
  var belowMinAge = false;
  var age = 0;
  if (birthDate.getUTCDate() < refDate.getUTCDate() && birthDate.getUTCMonth() === refDate.getUTCMonth() || birthDate.getUTCMonth() < refDate.getUTCMonth()) {
    // Has already had a birthday
    age = refDate.getUTCFullYear() - birthDate.getUTCFullYear();
  } else {
    // Hasn't had a birthday yet
    age = refDate.getUTCFullYear() - birthDate.getUTCFullYear() - 1;
  }
  if (age > maxAge) {
    aboveMaxAge = true;
  }
  if (age < minAge) {
    belowMinAge = true;
  }
  return {
    aboveMaxAge: aboveMaxAge,
    belowMinAge: belowMinAge
  };
};
var isValidCPF = function isValidCPF(cpf) {
  var allEqual = function allEqual(input) {
    return input.split('').every(function (_char) {
      return _char === input[0];
    });
  };
  var cpfString = cpf.replace(/\./g, '').replace(/-/g, '');
  var Soma;
  var Resto;
  Soma = 0;
  if (allEqual(cpfString)) return false;
  if (cpfString === '01234567890') return false;
  for (var i = 1; i <= 9; i += 1) Soma += parseInt(cpfString.substring(i - 1, i), 10) * (11 - i);
  Resto = Soma * 10 % 11;
  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpfString.substring(9, 10), 10)) return false;
  Soma = 0;
  for (var _i = 1; _i <= 10; _i += 1) Soma += parseInt(cpfString.substring(_i - 1, _i), 10) * (12 - _i);
  Resto = Soma * 10 % 11;
  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpfString.substring(10, 11), 10)) return false;
  return true;
};
var isValidEmail = function isValidEmail(emailString) {
  var regex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var match = emailString.match(regex);
  if (match) return true;
  return false;
};
var isValidPhone = function isValidPhone(phone) {
  var regex = new RegExp(/^\(?[0-9]{2}\)? ?[0-9]{5} ?-?[0-9]{4}$/);
  var match = phone.replace('_', '').match(regex);
  if (match) return true;
  return false;
};
// #endregion

// #region CookieUtilities
var setCookie = function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=".concat(d.toUTCString());
  document.cookie = "".concat(cname, "=").concat(cvalue, ";").concat(expires, ";path=/");
};
var getCookie = function getCookie(name) {
  var cookie = document.cookie.split('; ').find(function (row) {
    return row.startsWith("".concat(name, "="));
  });
  if (!cookie) {
    return '';
  }
  var value = cookie.substring(name.length + 1);
  if (value.startsWith('"') && value.endsWith('"')) {
    value = value.slice(1, -1);
  }
  return value;
};
var checkCookie = function checkCookie(cookieName) {
  if (getCookie(cookieName) !== '' && getCookie(cookieName) != null) return true;
  return false;
};
var removeCookie = function removeCookie(cookieName) {
  if (cookieName.indexOf('pcrid') === -1 || cookieName.indexOf('pcrslug') === -1) document.cookie = "".concat(cookieName, "=;path=/;domain=.segurospromo.com.br");
};
var removeOperatorCookies = function removeOperatorCookies() {
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookies = decodedCookie.split('; ');
  cookies.forEach(function (cookie) {
    if (cookie.includes('operator_')) {
      var operator = cookie.trim().split('=')[0];
      document.cookie = "".concat(operator, "=; path=/; Max-Age=-1");
    }
  });
};
function getAllCookies() {
  var bareCookies = document.cookie.split(';');
  var dictCookies = {};
  var _iterator = _createForOfIteratorHelper(bareCookies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      var _cookie$split = cookie.split('='),
        _cookie$split2 = _slicedToArray(_cookie$split, 2),
        key = _cookie$split2[0],
        value = _cookie$split2[1];
      dictCookies[key] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return dictCookies;
}
function getPartnersCookie() {
  var partnersList = [];
  var cookies = getAllCookies();
  for (var _i2 = 0, _Object$entries = Object.entries(cookies); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (key.includes('pcrid_')) {
      var _value$split = value.split('|'),
        _value$split2 = _slicedToArray(_value$split, 3),
        last_access = _value$split2[0],
        expiration = _value$split2[1],
        pcrtt = _value$split2[2];
      var partnerData = {
        pcrid: key.split('_')[1],
        last_access: last_access,
        expiration: expiration,
        tags: pcrtt
      };
      partnersList.push(partnerData);
    }
    if (key.includes('pcrslug_')) {
      var _value$split3 = value.split('|'),
        _value$split4 = _slicedToArray(_value$split3, 3),
        _last_access = _value$split4[0],
        _expiration = _value$split4[1],
        _pcrtt = _value$split4[2];
      var _partnerData = {
        pcrslug: key.split('_')[1],
        last_access: _last_access,
        expiration: _expiration,
        tags: _pcrtt
      };
      partnersList.push(_partnerData);
    }
  }
  return partnersList;
}
var getOperatorsCookie = function getOperatorsCookie() {
  var operators = [];
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookies = decodedCookie.split('; ');
  cookies.forEach(function (cookie) {
    if (cookie.includes('operator_')) {
      var _cookie$trim$split = cookie.trim().split('='),
        _cookie$trim$split2 = _slicedToArray(_cookie$trim$split, 2),
        operator = _cookie$trim$split2[0],
        accessDate = _cookie$trim$split2[1];
      var _operator$split = operator.split('_'),
        _operator$split2 = _slicedToArray(_operator$split, 2),
        operatorId = _operator$split2[1];
      operators.push({
        operator_id: "SV-".concat(operatorId),
        access_date: accessDate ? parseInt(accessDate, 10) : 0
      });
    }
  });
  return operators;
};
var getAuthCookie = function getAuthCookie() {
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookies = decodedCookie.split('; ');
  var validCookie = null;
  cookies.forEach(function (cookie) {
    if (cookie.startsWith('a_u=')) {
      var value = cookie.trim().split('=')[1] || '';
      if (value && value.trim() !== '') {
        validCookie = value;
      }
    }
  });
  return validCookie;
};

// #endregion

// #region Formatters
var formatPrice = function formatPrice(price) {
  if (!price) return null;
  return parseFloat(price).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    currency: 'BRL'
  });
};
var formatDate = function formatDate(date, format) {
  if (typeof date !== 'string') return date;
  var splitDate = date.split('-');
  var fmtDate = "".concat(splitDate[0], "/").concat(splitDate[1], "/").concat(splitDate[2]);
  if (format === 'pt-br') {
    return "".concat(splitDate[2], "/").concat(splitDate[1], "/").concat(splitDate[0]);
  }
  return fmtDate;
};
var formatURL = function formatURL(params, url, search, ignoreSearch) {
  var fmtReq = function fmtReq(oldUrl) {
    var fmtUrl = '';
    var isFirst = true;
    oldUrl.split('').forEach(function (character) {
      if (character === '?' && isFirst) {
        isFirst = false;
        fmtUrl += character;
      } else if (character === '?') fmtUrl += '&';else fmtUrl += character;
    });
    return fmtUrl;
  };
  var basePath = '',
    fmtUrl = '',
    getParams = window.location.search;
  if (params.partner) {
    basePath = "/p/".concat(params.partner);
  } else if (params.user) {
    basePath = "/b2b/belvitur/".concat(params.user);
  } else {
    basePath = '/site';
  }
  if (!url.includes('comparacao')) getParams = getParams.replace(/products_ids=[0-9,+]+&?/, '');
  if (ignoreSearch) fmtUrl = basePath + url;else if (search) fmtUrl = basePath + url + search;else fmtUrl = basePath + url + getParams;
  return fmtReq(fmtUrl);
};
// #endregion

var getPage = function getPage() {
  if (window.location.pathname.includes('pedido/')) return 'pagamento';
  if (window.location.pathname.includes('pedido-finalizado/')) return 'pos-compra';
  if (window.location.pathname.includes('cobertura/')) return 'cobertura';
  if (window.location.pathname.includes('comparacao/')) return 'comparacao';
  return 'pesquisa';
};
var isSameDaySearch = function isSameDaySearch(departureDate) {
  var fmtDepartureDate = new Date(departureDate.substr(0, 4), parseInt(departureDate.substr(5, 2), 0) - 1, departureDate.substr(8, 2), 0, 0, 0, 0);
  if (new Date().toLocaleDateString() === fmtDepartureDate.toLocaleDateString()) return true;
  return false;
};
var cleanStateErrors = function cleanStateErrors() {
  var errorsDefault = {
    insuredForms: [{
      cpf: false,
      name: false,
      birth_date: false
    }],
    paymentMethods: false,
    creditCard: {
      cvv: false,
      number: false,
      parcels: false,
      card_brand: false,
      expiry_year: false,
      holder_name: false,
      holder_cpf: false,
      expiry_month: false
    },
    boleto: {
      name: false,
      cpf: false
    },
    safetypay: {
      cpf: false,
      name: false,
      banks: false,
      agency: false,
      account: false
    },
    cash: {
      username: false,
      password: false
    },
    pix: {
      name: false,
      cpf: false
    },
    coupon: false,
    contact: {
      contact_name: false,
      email: false,
      phone_number: false
    },
    purchase_is_valid: false,
    errorsModalFranchise: false
  };
  return errorsDefault;
};
var convertDate = function convertDate(date) {
  var parts = date.split('-');
  var mydate = new Date(parts[0], parts[1] - 1, parts[2]);
  var options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  mydate = mydate.toLocaleDateString('pt-BR', options).split('de ');
  return mydate;
};
var quotationDateYear = function quotationDateYear(beginDate, returnDate) {
  var begin = new Date(beginDate);
  var dReturn = new Date(returnDate);
  var diff = Math.abs(begin.getTime() - dReturn.getTime());
  var days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  if (days >= 365) {
    return true;
  }
  return false;
};
var showDateVerbose = function showDateVerbose(date) {
  var parts = '';
  var mydate = '';
  if (date.indexOf('/') > 0) {
    parts = date.split('/');
    mydate = new Date(parts[2], parts[1] - 1, parts[0]);
  } else {
    parts = date.split('-');
    mydate = new Date(parts[0], parts[1] - 1, parts[2]);
  }
  var options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  mydate = mydate.toLocaleDateString('pt-BR', options).split('.').join('');
  if (mydate === 'Invalid Date') return '';
  return mydate.split('de ').join('');
};
var HeaderAndFooterPayment = function HeaderAndFooterPayment(location) {
  var compHeader = document.getElementsByClassName('comp_header clearfixs');
  var compFooter = document.getElementsByClassName('comp_footer');
  if (compHeader.length > 0 && compFooter.length > 0) {
    if (location.indexOf('/pedido/') !== -1) {
      compHeader[0].classList.add('payment');
      compFooter[0].classList.add('payment');
    } else {
      compHeader[0].classList.remove('payment');
      compFooter[0].classList.remove('payment');
    }
  }
};
var maxValueParcel = function maxValueParcel(plans) {
  // 30.000 é o valor mínimo de cada parcela
  // 12 é a quantidade máxima de parcelas
  var new_plans_with_parcels = plans.map(function (plan, index) {
    for (var i = 1; i <= 12; i += 1) {
      var parcelPrice = plan.adult.price / i;
      if (parcelPrice >= 30.0) plan.parcels = i;
    }
    return plan;
  });
  return new_plans_with_parcels;
};
var getMaxParcel = function getMaxParcel(price) {
  var minimalParcel = 30.0;
  if (price < minimalParcel * 2) {
    return 1;
  }
  var maxParcel = Math.floor(price / minimalParcel);
  if (maxParcel > 12) {
    maxParcel = 12;
  }
  return maxParcel;
};
var dateFormatGMT = function dateFormatGMT(date) {
  var dateNew = new Date(date);
  return "".concat(dateNew.getDate(), "/").concat(dateNew.getMonth() + 1, "/").concat(dateNew.getFullYear());
};
var getHoursDateGMT = function getHoursDateGMT(date) {
  var dateNew = new Date(date);
  return "".concat(dateNew.getHours(), ":").concat(dateNew.getMinutes() < 10 ? '0' + dateNew.getMinutes() : dateNew.getMinutes());
};
var getPurchasePending = function getPurchasePending(status) {
  return status.indexOf('Pendente') !== -1;
};
var isSelected = function isSelected(config) {
  var currentValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!!currentValue) return true;
  var screenSizeValid = window.innerWidth <= 768 ? false : true;
  return Boolean(screenSizeValid && config.selected);
};
var validateTrackerModalOnBlur = function validateTrackerModalOnBlur(prospect, key) {
  if (prospect[key] === '') {
    return [key], 'Campo obrigatório';
  } else if (key === 'phone' && !isValidPhone(prospect[key])) {
    return [key], 'Campo incorreto';
  } else if (key === 'email' && !isValidEmail(prospect[key])) {
    return [key], 'Campo incorreto';
  } else if (key === 'name' && prospect[key].split(' ').length < 2) {
    return [key], 'Digite o nome Completo';
  } else {
    return [key], '';
  }
};
var validateTrackerModal = function validateTrackerModal(prospect) {
  var errorName = validateTrackerModalOnBlur(prospect, 'name');
  var errorPhone = validateTrackerModalOnBlur(prospect, 'phone');
  var errorEmail = validateTrackerModalOnBlur(prospect, 'email');
  var valid = errorName === '' && errorPhone === '' && errorEmail === '';
  return {
    name: errorName,
    phone: errorPhone,
    email: errorEmail,
    isValid: valid
  };
};
var redirectToTracker = function redirectToTracker(destination, begin_date, end_date, prospect, coupon) {
  setCookie('cupom', coupon, 1);
  var url = "/emitir-seguros/r/search?destination=".concat(destination) + "&coverageBegin=".concat(begin_date) + "&coverageEnd=".concat(end_date) + "&name=".concat(prospect.name) + "&email=".concat(prospect.email) + "&phone=".concat(prospect.phone);
  console.log('Redirect to', url);
  window.location.href = url;
};
var verifyOriginSearchUrl = function verifyOriginSearchUrl(httpParams) {
  httpParams = httpParams.replace('?', '').split('&');
  var filterParams = httpParams.filter(function (httpParam) {
    var params = httpParam.split('=');
    if (params[0] === 'origin') {
      return params[1] === 'pp';
    }
  });
  return filterParams.length > 0;
};
var getCupomInUrl = function getCupomInUrl(httpParams) {
  httpParams = httpParams.replace('?', '').split('&');
  var cupom = '';
  httpParams.filter(function (httpParams) {
    var params = httpParams.split('=');
    if (params[0] === 'cupom') {
      return cupom = params[1];
    } else {
      cupom = 'PROMO15';
    }
  });
  return cupom;
};
var getFilterSearchUrl = function getFilterSearchUrl(httpParams) {
  var categoryUrl = [];
  var providerUrl = [];
  httpParams = httpParams.replace('?', '').split('&');
  httpParams.map(function (param) {
    if (param.search('category=') === 0) {
      categoryUrl.push.apply(categoryUrl, _toConsumableArray(param.replace('category=', '').split(',')));
    }
    if (param.search('provider=') === 0) {
      providerUrl.push.apply(providerUrl, _toConsumableArray(param.replace('provider=', '').split(',')));
    }
  });
  return {
    categoryUrl: categoryUrl,
    providerUrl: providerUrl
  };
};
var FormatCategoryName = function FormatCategoryName(name) {
  var newName = name.split(' ').join('-');
  return newName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};
var destinations = [{
  value: '1',
  name: 'Brasil',
  slug: 'brasil'
}, {
  value: '2',
  name: 'América do Sul',
  slug: 'america-do-sul'
}, {
  value: '3',
  name: 'Europa',
  slug: 'europa'
}, {
  value: '4',
  name: 'América do Norte',
  slug: 'america-do-norte'
}, {
  value: '5',
  name: 'América Central',
  slug: 'america-central'
}, {
  value: '6',
  name: 'Oceania',
  slug: 'oceania'
}, {
  value: '7',
  name: 'Oriente Médio',
  slug: 'oriente-medio'
}, {
  value: '8',
  name: 'Ásia',
  slug: 'asia'
}, {
  value: '9',
  name: 'África',
  slug: 'africa'
}, {
  value: '10',
  name: 'Marítimo',
  slug: 'maritimo'
}, {
  value: '11',
  name: 'Internacional',
  slug: 'internacional'
}, {
  value: '12',
  name: 'Brasil Receptivo',
  slug: 'brasil-receptivo'
}, {
  value: '13',
  name: 'Receptivo',
  slug: 'receptivo'
}, {
  value: '16',
  name: 'Argentina',
  slug: 'argentina'
}];
var getDestinationSlugByName = function getDestinationSlugByName(name) {
  var destination = destinations.find(function (dest) {
    return dest.name === name;
  });
  return destination ? destination.slug : null;
};
var getDestinationBySlug = function getDestinationBySlug(slugValue) {
  var destination = destinations.find(function (dest) {
    return dest.slug === slugValue;
  });
  return destination ? destination.name : null;
};
var buildSearchWithDestinationCategories = function buildSearchWithDestinationCategories(destinationsList, destinationSlug) {
  var search = window.location.search ? "?".concat(window.location.search.replace('?', '').split('&').filter(function (param) {
    return param && !param.startsWith('category=');
  }).join('&')) : '';
  if (search === '?') search = '';
  var selectedDestination = (destinationsList || []).find(function (d) {
    return d.slug === destinationSlug;
  });
  if (selectedDestination && selectedDestination.benefit_category_ids && selectedDestination.benefit_category_ids.length > 0) {
    var categoryParams = selectedDestination.benefit_category_ids.map(function (id) {
      return "category=".concat(id);
    }).join('&');
    search = search ? "".concat(search, "&").concat(categoryParams) : "?".concat(categoryParams);
  }
  return search;
};
var formatDateFromConvert = function formatDateFromConvert(date) {
  var deadline_convert = date.split(/[-:]/);
  var deadline = "".concat(deadline_convert[2], "-").concat(deadline_convert[1], "-").concat(deadline_convert[0], " ").concat(deadline_convert[3], ":").concat(deadline_convert[4], ":").concat(deadline_convert[5]);
  return deadline;
};
function deadlineForText(valor) {
  var hours = Math.floor(valor / 60); // Divide o valor total de minutos por 60 para obter as horas
  var minutes = valor % 60; // Usa o operador de módulo para obter os minutos restantes após a divisão por 60

  var text = '';
  if (hours > 0) {
    text += hours === 1 ? hours + ' hora' : hours + ' horas';
  }
  if (minutes > 0) {
    if (text.length > 0) {
      text += ' e ';
    }
    text += minutes === 1 ? minutes + ' minuto' : minutes + ' minutos';
  }
  if (text.length === 0) {
    text = '0 minutos';
  }
  return text;
}
var normalizePaymentMethodsName = function normalizePaymentMethodsName(name) {
  switch (name) {
    case 'creditcard':
      return 'credit-card';
    case 'boleto':
      return 'boleto';
    case 'transfer':
      return 'safetypay';
    case 'cash':
      return 'cash';
    case 'pix':
      return 'pix';
    default:
      return '';
  }
};
var cleanProviderName = function cleanProviderName(name) {
  return name.split(' ').join('-').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};
var fmtQueryParams = function fmtQueryParams(queryParams) {
  var params = new URLSearchParams(queryParams);
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(params.entries()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        key = _step2$value[0],
        value = _step2$value[1];
      result[key] = value;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
};
var trackMatomoEvent = function trackMatomoEvent(category, action, name, value) {
  if (window._paq) {
    var params = ['trackEvent', category, action, name];
    if (typeof value !== 'undefined' && value !== null && value !== '') {
      params.push(value);
    }
    window._paq.push(params);
  }
};
var saveFilterToSession = function saveFilterToSession(filterData) {
  var existingFilters = getFiltersFromSession();
  var updatedFilters = [].concat(_toConsumableArray(existingFilters), [filterData]);
  sessionStorage.setItem('selectedFilters', JSON.stringify(updatedFilters));
};
var getFiltersFromSession = function getFiltersFromSession() {
  var filters = sessionStorage.getItem('selectedFilters');
  return filters ? JSON.parse(filters) : [];
};
var clearFiltersFromSession = function clearFiltersFromSession() {
  sessionStorage.removeItem('selectedFilters');
};
var formatDateToMonthYear = function formatDateToMonthYear(dateString) {
  var monthNames = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
  var dateObj = new Date(dateString);
  var month = monthNames[dateObj.getMonth()];
  var year = dateObj.getFullYear();
  return "".concat(month, "-").concat(year);
};
var getDaysInAdvance = function getDaysInAdvance(dateString) {
  var today = new Date();
  var targetDate = new Date(dateString);
  return Math.floor((targetDate - today) / (1000 * 60 * 60 * 24));
};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(170);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(171);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(173);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(175);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(40);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(179);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(183);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(184);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getPaymentMethodsAvaliable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return fetchDiscountCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return clearCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return fetchFirstActiveCreditCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyCreditCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return removeAppliedCreditCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return setCreditCouponCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addInsuredForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return removeInsuredForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return changeInsuredFormAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fetchPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return selectPaymentMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeCreditCardAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return selectCreditCardParcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return selectCreditCardBrand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeBoletoAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return selectBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return changeCashTransferAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeCashAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return changePixAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeContactAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchBenefitsList; });
/* unused harmony export fetchPaymentInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return fetchPlansPurchase; });
/* unused harmony export updatePurchaseSummary */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return finishPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return setPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return setCouponText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return setQuotationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return setPurchaseUuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return validatePurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return fetchAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return clearAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return sendingPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return finishedPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return openModalDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return closeModalDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return openModalPurchaseError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return openModalCouponError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return openModalPurchaseDateError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return openModalGenericError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return openModalPlanRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return openModalFailPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return closeModalPlanRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return closeModalFailPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return showInvalidCreditCardError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return hideInvalidCreditCardError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return closeModalPurchaseError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return closeModalCouponError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return closeModalPurchaseDateError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return closeModalGenericError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return openModalFranchise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return closeModalFranchise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return openModalOperatorConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return closeModalOperatorConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return openModalNotCovidCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return closeModalNotCovidCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return openModalStudent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return closeModalStudent; });
/* unused harmony export openModalTermsOfUse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return closeModalTermsOfUse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return openModalSafetypay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return closeModalSafetypay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return openModalTravelRenewal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return closeModalTravelRenewal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return openModalRenewalFranchise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return closeModalRenewalFranchise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return openModalReceptiveProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return closeModalReceptiveProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return fetchPurchaseData; });
/* unused harmony export setUserDetails */
/* unused harmony export changeConfirmTerms */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return cleanErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return nextStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return selectPaymentCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return selectBankCashTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return editPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return selectPaymentMethodAlterStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backStagePaymentMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return backStagePurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return cleanStatesPurchaseMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return validatorHandlerBlur; });
/* unused harmony export setInfosProspect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return setInfosProspectInPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return clearInfosProspect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getInfosInsureds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return fetchUserDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getInfosProspect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getBenefits; });
/* unused harmony export setBenefitsDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return setOperatorConfirmationClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return setUpsellPurchase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_matomo__ = __webpack_require__(10);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-unused-expressions */





// #setting payment methods
var getPaymentMethodsAvaliable = function getPaymentMethodsAvaliable(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_45" /* PURCHASE_GET_PAYMENT_METHODS */],
    data: data
  };
};
// #region Coupon
var fetchDiscountCoupon = function fetchDiscountCoupon(coupon) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_1" /* FETCH_DISCOUNT_COUPON */],
    coupon: coupon
  };
};
var clearCoupon = function clearCoupon() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["w" /* CLEAR_COUPON */]
  };
};
// #endregion

var fetchFirstActiveCreditCoupon = function fetchFirstActiveCreditCoupon() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var url, response, responseBody, payload, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            url = "".concat("https://dev.segurospromo.com.br", "/safearea/api/v1/credit-coupons/active/first/");
            _context.n = 1;
            return fetch(url, {
              credentials: 'include'
            });
          case 1:
            response = _context.v;
            _context.n = 2;
            return response.json();
          case 2:
            responseBody = _context.v;
            if (response.ok) {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_3" /* FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS */],
                payload: responseBody
              });
            } else {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_2" /* FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR */],
                payload: responseBody
              });
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            payload = {
              msg: 'Ocorreu um erro ao buscar o cupom de crédito. Por favor, tente novamente mais tarde.'
            };
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_2" /* FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR */],
              payload: payload
            });
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var applyCreditCoupon = function applyCreditCoupon(code) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var url, response, responseBody, payload, _payload, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            url = "".concat("https://dev.segurospromo.com.br", "/safearea/api/v1/credit-coupons/").concat(code, "/");
            _context2.n = 1;
            return fetch(url, {
              credentials: 'include'
            });
          case 1:
            response = _context2.v;
            _context2.n = 2;
            return response.json();
          case 2:
            responseBody = _context2.v;
            if (response.ok) {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["e" /* APPLY_CREDIT_COUPON_SUCCESS */],
                payload: responseBody
              });
            } else {
              payload = {
                msg: responseBody.message
              };
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* APPLY_CREDIT_COUPON_ERROR */],
                payload: payload
              });
            }
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _payload = {
              msg: 'Ocorreu um erro ao buscar o cupom de crédito. Por favor, tente novamente mais tarde.'
            };
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* APPLY_CREDIT_COUPON_ERROR */],
              payload: _payload
            });
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 3]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var removeAppliedCreditCoupon = function removeAppliedCreditCoupon() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_46" /* REMOVE_APPLIED_CREDIT_COUPON */]
  };
};
var setCreditCouponCode = function setCreditCouponCode(code) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_61" /* SET_CREDIT_COUPON_CODE_TEXT */],
    value: code
  };
};

// #region InsuredRegister
var addInsuredForm = function addInsuredForm(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* ADD_INSURED_FORM */],
    form: {
      rg: '',
      cpf: '',
      name: '',
      birth_date: '',
      document_type: 'cpf',
      incoming: ''
    }
  };
};
var removeInsuredForm = function removeInsuredForm(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_48" /* REMOVE_INSURED_FORM */],
    formIndex: id
  };
};
var changeInsuredFormAttr = function changeInsuredFormAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["p" /* CHANGE_INSURED_FORM_ATTR */],
    field: field.name,
    value: field.value,
    formIndex: field.formId
  };
};
// #endregion

// #region PaymentMethods
var fetchPaymentMethods = function fetchPaymentMethods(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_5" /* FETCH_PAYMENT_METHODS */],
    paymentMethods: data.payment_methods,
    extra: data.extra
  };
};
var selectPaymentMethod = function selectPaymentMethod(methodIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_55" /* SELECT_PAYMENT_METHOD */],
    methodIndex: methodIndex
  };
};
// #endregion

// #region CreditCard
var changeCreditCardAttr = function changeCreditCardAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["m" /* CHANGE_CREDITCARD_ATTR */],
    field: field.name,
    value: field.value
  };
};
var selectCreditCardParcel = function selectCreditCardParcel(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_53" /* SELECT_CREDITCARD_PARCEL */],
    parcel_index: index
  };
};
var selectCreditCardBrand = function selectCreditCardBrand(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_52" /* SELECT_CREDITCARD_BRAND */],
    brand_index: index
  };
};
// #endregion

// #region Boleto
var changeBoletoAttr = function changeBoletoAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["i" /* CHANGE_BOLETO_ATTR */],
    field: field.name,
    value: field.value
  };
};
// #endregion

// #region CashTransfer
var selectBank = function selectBank(bankIndex) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_51" /* SELECT_BANK */],
    bankIndex: bankIndex
  };
};
var changeCashTransferAttr = function changeCashTransferAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["r" /* CHANGE_SAFETYPAY_ATTR */],
    field: field.name,
    value: field.value
  };
};
// #endregion

// #region Cash
var changeCashAttr = function changeCashAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["j" /* CHANGE_CASH_ATTR */],
    field: field.name,
    value: field.value
  };
};
// #endregion

// #region pix
var changePixAttr = function changePixAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["q" /* CHANGE_PIX_ATTR */],
    field: field.name,
    value: field.value
  };
};

// #region Contact
var changeContactAttr = function changeContactAttr(field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["l" /* CHANGE_CONTACT_ATTR */],
    field: field.name,
    value: field.value
  };
};
var fetchBenefitsList = function fetchBenefitsList(benefits) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Y" /* FETCH_BENEFITS_METHODS */],
    benefits: benefits
  };
};
// #endregion

// #region
var fetchPaymentInfo = function fetchPaymentInfo(paymentInfo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_4" /* FETCH_PAYMENT_INFO */],
    paymentInfo: paymentInfo
  };
};
// #endregion

var fetchPlansPurchase = function fetchPlansPurchase(plan, context) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_7" /* FETCH_PLANS_PURCHASE */],
    context: context,
    plan: plan
  };
};
var updatePurchaseSummary = function updatePurchaseSummary(purchaseSummary) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_83" /* UPDATE_PURCHASE_SUMMARY */],
    purchaseSummary: purchaseSummary
  };
};
var finishPurchase = function finishPurchase() {
  return function (dispatch) {
    return new Promise(function (resolve) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_13" /* FINISH_PURCHASE */]
      });
      resolve();
    });
  };
};
var setPartner = function setPartner(partner) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_64" /* SET_PARTNER */],
    partner: partner
  };
};
var setCouponText = function setCouponText(value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_60" /* SET_COUPON_TEXT */],
    value: value
  };
};
var setQuotationParams = function setQuotationParams(_ref3) {
  var begin_date = _ref3.begin_date,
    end_date = _ref3.end_date,
    destination = _ref3.destination,
    product_code = _ref3.product_code,
    context = _ref3.context,
    queryParams = _ref3.queryParams;
  Object(__WEBPACK_IMPORTED_MODULE_1__apiCalls__["getProductQuotation"])({
    begin_date: begin_date,
    end_date: end_date,
    destination: destination,
    product_code: product_code,
    context: context
  });
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_67" /* SET_QUOTATION_PARAMS */],
    departure_date: begin_date,
    return_date: end_date,
    destination: destination,
    product_code: product_code,
    queryParams: queryParams
  };
};
var setPurchaseUuid = function setPurchaseUuid(uuid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_66" /* SET_PURCHASE_UUID */],
    uuid: uuid
  };
};
var validatePurchase = function validatePurchase(isValid, status, message) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_84" /* VALIDATE_PURCHASE */],
    purchaseIsValid: isValid,
    status: status,
    message: message
  };
};
var fetchAddress = function fetchAddress(_ref4) {
  var tipo_logradouro = _ref4.tipo_logradouro,
    bairro = _ref4.bairro,
    cidade = _ref4.cidade,
    uf = _ref4.uf,
    logradouro = _ref4.logradouro;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["X" /* FETCH_ADDRESS */],
    address: "".concat(tipo_logradouro, " ").concat(logradouro),
    district: bairro,
    city: cidade,
    state: uf.toUpperCase()
  };
};
var clearAlerts = function clearAlerts() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["v" /* CLEAR_ALERTS */]
  };
};
var sendingPurchase = function sendingPurchase() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_78" /* START_PURCHASE_LOADING */]
  };
};
var finishedPurchase = function finishedPurchase() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["W" /* END_PURCHASE_LOADING */]
  };
};
var openModalDetail = function openModalDetail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_23" /* OPEN_DETAIL_MODAL */]
  };
};
var closeModalDetail = function closeModalDetail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["z" /* CLOSE_DETAIL_MODAL */]
  };
};
var openModalPurchaseError = function openModalPurchaseError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_34" /* OPEN_MODAL_PURCHASE_ERROR */]
  };
};
var openModalCouponError = function openModalCouponError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_24" /* OPEN_MODAL_COUPON_ERROR */]
  };
};
var openModalPurchaseDateError = function openModalPurchaseDateError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_33" /* OPEN_MODAL_PURCHASE_DATE_ERROR */]
  };
};
var openModalGenericError = function openModalGenericError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_29" /* OPEN_MODAL_GENERIC_ERROR */]
  };
};
var openModalPlanRules = function openModalPlanRules() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_32" /* OPEN_MODAL_PLAN_RULES */]
  };
};
var openModalFailPayment = function openModalFailPayment() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_26" /* OPEN_MODAL_FAIL_PAYMENT */]
  };
};
var closeModalPlanRules = function closeModalPlanRules() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["I" /* CLOSE_MODAL_PLAN_RULES */]
  };
};
var closeModalFailPayment = function closeModalFailPayment() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["C" /* CLOSE_MODAL_FAIL_PAYMENT */]
  };
};
var showInvalidCreditCardError = function showInvalidCreditCardError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_75" /* SHOW_INVALID_CREDIT_CARD_ERROR */]
  };
};
var hideInvalidCreditCardError = function hideInvalidCreditCardError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_19" /* HIDE_INVALID_CREDIT_CARD_ERROR */]
  };
};
var closeModalPurchaseError = function closeModalPurchaseError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["K" /* CLOSE_MODAL_PURCHASE_ERROR */]
  };
};
var closeModalCouponError = function closeModalCouponError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["A" /* CLOSE_MODAL_COUPON_ERROR */]
  };
};
var closeModalPurchaseDateError = function closeModalPurchaseDateError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["J" /* CLOSE_MODAL_PURCHASE_DATE_ERROR */]
  };
};
var closeModalGenericError = function closeModalGenericError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["F" /* CLOSE_MODAL_GENERIC_ERROR */]
  };
};
var openModalFranchise = function openModalFranchise() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_28" /* OPEN_MODAL_FRANCHISE */]
  };
};
var closeModalFranchise = function closeModalFranchise() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["E" /* CLOSE_MODAL_FRANCHISE */]
  };
};
var openModalOperatorConfirmation = function openModalOperatorConfirmation() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_31" /* OPEN_MODAL_OPERATOR_CONFIRMATION */]
  };
};
var closeModalOperatorConfirmation = function closeModalOperatorConfirmation() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["H" /* CLOSE_MODAL_OPERATOR_CONFIRMATION */]
  };
};
var openModalNotCovidCoverage = function openModalNotCovidCoverage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_30" /* OPEN_MODAL_NOT_COVID_COVERAGE */]
  };
};
var closeModalNotCovidCoverage = function closeModalNotCovidCoverage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["G" /* CLOSE_MODAL_NOT_COVID_COVERAGE */]
  };
};
var openModalStudent = function openModalStudent() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_40" /* OPEN_MODAL_STUDENT */]
  };
};
var closeModalStudent = function closeModalStudent() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Q" /* CLOSE_MODAL_STUDENT */]
  };
};
var openModalTermsOfUse = function openModalTermsOfUse() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_41" /* OPEN_MODAL_TERMS_OF_USE */]
  };
};
var closeModalTermsOfUse = function closeModalTermsOfUse() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["R" /* CLOSE_MODAL_TERMS_OF_USE */]
  };
};
var openModalSafetypay = function openModalSafetypay() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_39" /* OPEN_MODAL_SAFETYPAY */]
  };
};
var closeModalSafetypay = function closeModalSafetypay() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["P" /* CLOSE_MODAL_SAFETYPAY */]
  };
};
var openModalTravelRenewal = function openModalTravelRenewal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_42" /* OPEN_MODAL_TRAVEL_RENEWAL */]
  };
};
var closeModalTravelRenewal = function closeModalTravelRenewal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["S" /* CLOSE_MODAL_TRAVEL_RENEWAL */]
  };
};
var openModalRenewalFranchise = function openModalRenewalFranchise() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_38" /* OPEN_MODAL_RENEWAL_FRANCHISE */]
  };
};
var closeModalRenewalFranchise = function closeModalRenewalFranchise() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["O" /* CLOSE_MODAL_RENEWAL_FRANCHISE */]
  };
};
var openModalReceptiveProduct = function openModalReceptiveProduct() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_37" /* OPEN_MODAL_RECEPTIVE_PRODUCT */]
  };
};
var closeModalReceptiveProduct = function closeModalReceptiveProduct() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["N" /* CLOSE_MODAL_RECEPTIVE_PRODUCT */]
  };
};
var fetchPurchaseData = function fetchPurchaseData(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_9" /* FETCH_PURCHASE_DATA */],
    data: data
  };
};
var setUserDetails = function setUserDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* SET_USER_DETAILS */],
    userDetails: data
  };
};
var changeConfirmTerms = function changeConfirmTerms(dateTime) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["k" /* CHANGE_CONFIRM_TERMS */],
    dateTimeAccept: dateTime.data
  };
};
var cleanErrors = function cleanErrors() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["t" /* CLEAN_ERRORS */]
  };
};
var nextStage = function nextStage(index, stageValidator) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_20" /* NEXT_STAGE_PURCHASE_MOBILE */],
    index: index,
    stageValidator: stageValidator
  };
};
var selectPaymentCreditCard = function selectPaymentCreditCard(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_77" /* STAGE_PAYMENT_CREDIT_CARD */],
    stepDisplayCreditCard: index
  };
};
var selectBankCashTransfer = function selectBankCashTransfer(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_76" /* STAGE_PAYMENT_CASH_TRANSFER */],
    stepDisplayCashTransfer: index
  };
};
var editPurchase = function editPurchase(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["V" /* EDIT_PURCHASE */],
    stagePurchase: index
  };
};
var selectPaymentMethodAlterStage = function selectPaymentMethodAlterStage(index, name) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_54" /* SELECT_PAYMENT_ALTER_STATE */],
    index: value !== null ? value : index,
    name: name
  };
};
var backStagePaymentMethod = function backStagePaymentMethod(index, name, condition) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["g" /* BACK_STAGE_PAYMENT_METHOD */],
    index: index,
    name: name,
    condition: condition
  };
};
var backStagePurchase = function backStagePurchase(index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["h" /* BACK_STAGE_PURCHASE */],
    stagePurchase: index
  };
};
var cleanStatesPurchaseMobile = function cleanStatesPurchaseMobile() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["u" /* CLEAN_STATES_PURCHASE_MOBILE */]
  };
};
var validatorHandlerBlur = function validatorHandlerBlur(value, name) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return function (dispatch, getState) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_86" /* VALIDATOR_HANDLER_BLUR */],
      value: value,
      name: name,
      index: index
    });
  };
};
var setInfosProspect = function setInfosProspect(infos) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_15" /* GET_INFOS_PROSPECT */],
    infos: infos
  };
};
var setInfosProspectInPurchase = function setInfosProspectInPurchase() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_62" /* SET_INFOS_PROSPECT_IN_PURCHASE */]
  };
};
var clearInfosProspect = function clearInfosProspect() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["y" /* CLEAR_INFOS_PROSPECT */]
  };
};
var getInfosInsureds = function getInfosInsureds(payment) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_14" /* GET_INFOS_INSUREDS */],
    payment: payment
  };
};
var fetchUserDetails = function fetchUserDetails() {
  return function (dispatch) {
    var url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/pedido/api/user-detail/");
    var fetchOptions = {
      headers: {
        Authorization: "Basic c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
      }
    };
    return fetch(url, fetchOptions).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(setUserDetails(json));
    });
  };
};
var getInfosProspect = function getInfosProspect() {
  return function (dispatch) {
    var infos = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["getCookie"])('infosprospect');
    var url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/pedido/api/purchase-data/").concat(infos, "/");
    if (infos) {
      fetch(url, {
        method: 'GET'
      }).then(function (response) {
        if (response.status !== 200) return null;
        response.json().then(function (json) {
          var setProspect = {
            exist: true,
            name: json.name,
            email: json.email,
            phone: json.phone
          };
          return dispatch(setInfosProspect(setProspect));
        });
      });
    }
  };
};
var getBenefits = function getBenefits() {
  return function (dispatch) {
    var url = "https://dev.segurospromo.com.br/services/ecommerce" + '/benefits';
    var fetchOptions = {
      headers: {
        method: "GET",
        Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
      }
    };
    fetch(url, fetchOptions).then(function (response) {
      response.json().then(function (json) {
        return dispatch(setBenefitsDescription(json));
      });
    });
  };
};
var setBenefitsDescription = function setBenefitsDescription(benefits) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_59" /* SET_BENEFITS */],
    benefits: benefits
  };
};
var setOperatorConfirmationClicked = function setOperatorConfirmationClicked() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_63" /* SET_OPERATOR_CONFIRMATION_CLICKED */]
  };
};
var setUpsellPurchase = function setUpsellPurchase(upsellProduct) {
  return function (dispatch) {
    sessionStorage.setItem('upsellUpgrade', upsellProduct);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_72" /* SET_UPSELL_PURCHASE */],
      upsellProduct: upsellProduct
    });
  };
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return searchEcommerceSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return searchProviderSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addComparisonPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return removeComparisonPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cleanComparisonPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return filterPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return unselectFilterCategoryOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyFilterCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearFilterCategories; });
/* unused harmony export setSortOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return setSortOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setProviderFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return filterPlansMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openModalQuotationDateWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return closeModalQuotationDateWarning; });
/* unused harmony export setInfosProspect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return openModalQuotationDateYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return closeModalQuotationDateYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return setQuotationParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return openModalWithoutTracker; });
/* unused harmony export closeModalWithoutTracker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openModalFilterCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeModalFilterCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return setInfosModalProspect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return trackerModalValidatorHandlerBlur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return validateTrackerModalRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return storeHighligthPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return toggleSpecialistSuggestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return openModalUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return closeModalUpsell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return setUpsellPlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setUpsellSourceTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiCalls__ = __webpack_require__(6);


var searchEcommerceSettings = function searchEcommerceSettings(settings) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_49" /* SEARCH_ECOMMERCE_SETTINGS */],
    settings: settings
  };
};
var searchProviderSettings = function searchProviderSettings(settings) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_50" /* SEARCH_PROVIDER_SETTINGS */],
    settings: settings
  };
};
var addComparisonPlan = function addComparisonPlan(plan) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["b" /* ADD_COMPARISON_PLAN */],
    plan: plan
  };
};
var removeComparisonPlan = function removeComparisonPlan(planCode) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_47" /* REMOVE_COMPARISON_PLAN */],
    planCode: planCode
  };
};
var cleanComparisonPlans = function cleanComparisonPlans() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["s" /* CLEAN_COMPARISON_PLANS */]
  };
};
var fetchPlans = function fetchPlans(plans, context) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_6" /* FETCH_PLANS */],
    context: context,
    plans: plans
  };
};
var fetchCategories = function fetchCategories(category, params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["Z" /* FETCH_CATEGORIES */],
    category: category,
    params: params
  };
};
var filterPlans = function filterPlans() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_11" /* FILTER_PLANS */]
  };
};
var unselectFilterCategoryOptions = function unselectFilterCategoryOptions(type_category, category_index) {
  var option_index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_82" /* UNSELECT_FILTER_CATEGORY_OPTIONS */],
    type_category: type_category,
    category_index: category_index,
    option_index: option_index
  };
};
var applyFilterCategories = function applyFilterCategories(selected_category) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* APPLY_FILTER_CATEGORIES */],
    selected_category: selected_category
  };
};
var clearFilterCategories = function clearFilterCategories() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["x" /* CLEAR_FILTER_CATEGORIES */]
  };
};
var setSortOptions = function setSortOptions(sortOptions) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_69" /* SET_SORT_OPTIONS */],
    sortOptions: sortOptions
  };
};
var setSortOption = function setSortOption(sort_option) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_68" /* SET_SORT_OPTION */],
    sort_option: sort_option
  };
};
var setProviderFilter = function setProviderFilter(provider_option) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_65" /* SET_PROVIDER_OPTION */],
    provider_option: provider_option
  };
};
var filterPlansMobile = function filterPlansMobile() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_12" /* FILTER_PLANS_MOBILE */]
  };
};
var openModalQuotationDateWarning = function openModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var closeModalQuotationDateWarning = function closeModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var setInfosProspect = function setInfosProspect(infos) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_15" /* GET_INFOS_PROSPECT */],
    infos: infos
  };
};
var openModalQuotationDateYear = function openModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]
  };
};
var closeModalQuotationDateYear = function closeModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]
  };
};
var setQuotationParams = function setQuotationParams(_ref) {
  var begin_date = _ref.begin_date,
    end_date = _ref.end_date,
    destination = _ref.destination,
    product_code = _ref.product_code,
    context = _ref.context,
    benefits = _ref.benefits,
    queryParams = _ref.queryParams;
  Object(__WEBPACK_IMPORTED_MODULE_1__apiCalls__["getProductQuotation"])({
    begin_date: begin_date,
    end_date: end_date,
    destination: destination,
    product_code: product_code,
    context: context,
    benefits: benefits
  });
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_67" /* SET_QUOTATION_PARAMS */],
    begin_date: begin_date,
    end_date: end_date,
    destination: destination,
    queryParams: queryParams
  };
};
var openModalWithoutTracker = function openModalWithoutTracker() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_44" /* OPEN_MODAL_WITHOUT_TRACKER */]
  };
};
var closeModalWithoutTracker = function closeModalWithoutTracker() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["U" /* CLOSE_MODAL_WITHOUT_TRACKER */]
  };
};
var openModalFilterCategory = function openModalFilterCategory() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_27" /* OPEN_MODAL_FILTER_CATEGORY */]
  };
};
var closeModalFilterCategory = function closeModalFilterCategory() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["D" /* CLOSE_MODAL_FILTER_CATEGORY */]
  };
};
var setInfosModalProspect = function setInfosModalProspect(prospect) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_70" /* SET_TRACKER_INFOS_PROSPECT */],
    prospect: prospect
  };
};
var trackerModalValidatorHandlerBlur = function trackerModalValidatorHandlerBlur(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_81" /* TRACKER_MODAL_VALIDATOR_HANDLER_BLUR */],
    key: key
  };
};
var validateTrackerModalRedirect = function validateTrackerModalRedirect(destination, begin_date, end_date, couponModal) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_85" /* VALIDATE_TRACKER_MODAL_REDIRECT */],
    destination: destination,
    begin_date: begin_date,
    end_date: end_date,
    couponModal: couponModal
  };
};
var storeHighligthPlans = function storeHighligthPlans(plans) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_79" /* STORE_HIGHLIGTH_PLANS */],
    plans: plans
  };
};
var toggleSpecialistSuggestion = function toggleSpecialistSuggestion() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_80" /* TOGGLE_SPECIALIST_SUGGESTION */]
  };
};
var openModalUpsell = function openModalUpsell() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_43" /* OPEN_MODAL_UPSELL */]
  };
};
var closeModalUpsell = function closeModalUpsell() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["T" /* CLOSE_MODAL_UPSELL */]
  };
};
var setUpsellPlans = function setUpsellPlans(plans) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_71" /* SET_UPSELL_PLANS */],
    plans: plans
  };
};
var setUpsellSourceTags = function setUpsellSourceTags(tags) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_73" /* SET_UPSELL_SOURCE_TAGS */],
    tags: tags
  };
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listBenefits", function() { return listBenefits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comparePlans", function() { return comparePlans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductCoverage", function() { return getProductCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCategory", function() { return getCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductQuotation", function() { return getProductQuotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductQuotation", function() { return fetchProductQuotation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUpsellPlan", function() { return fetchUpsellPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCouponData", function() { return getCouponData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentMethods", function() { return getPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkoutPurchase", function() { return checkoutPurchase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPurchaseStatus", function() { return getPurchaseStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendEmail", function() { return sendEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAddressData", function() { return getAddressData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPurchaseData", function() { return getPurchaseData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEcommerceConfigService", function() { return fetchEcommerceConfigService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProvidersService", function() { return fetchProvidersService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSortOptionsService", function() { return fetchSortOptionsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDestinationsService", function() { return fetchDestinationsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPaymentMethodsService", function() { return fetchPaymentMethodsService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHighlightPlans", function() { return fetchHighlightPlans; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_sentry__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_purchaseStatusActions__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }









// DJANGO
var listBenefits = function listBenefits() {
  var url = "https://dev.segurospromo.com.br/services/ecommerce" + '/benefits';
  var fetchOptions = {
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };
  fetch(url, fetchOptions).then(function (response) {
    return response.json();
  }).then(function (json) {
    return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["I" /* fetchBenefitsList */])(json));
  })["catch"](function (error) {
    return console.error(error);
  });
};

// #region Comparison
var comparePlans = function comparePlans(_ref) {
  var begin_date = _ref.begin_date,
    end_date = _ref.end_date,
    destination = _ref.destination,
    product_code = _ref.product_code;
  var plans = product_code.replace(/%20/g, '+').split('+');
  function getComparationUrls(plan) {
    return "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(destination, "/").concat(begin_date, "/").concat(end_date, "/").concat(plan, "/info");
  }
  var fetchOptions = {
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };
  Promise.all(plans.map(function (plan) {
    return fetch(getComparationUrls(plan), fetchOptions);
  })).then(function (response) {
    Promise.all(response.map(function (data) {
      if (data.status !== 200) return null;
      return data.json();
    })).then(function (plansInfo) {
      var newData = [];
      plansInfo.map(function (json) {
        newData.push({
          id: json.id.toString(),
          name: json.name,
          min_age: json.price.child.min_age,
          max_age: json.price.elderly.max_age,
          cover_pregnant: json.cover_pregnancy,
          provider_code: json.provider_code,
          provider_name: json.provider.name,
          terms_url: json.term_url,
          covid_coverage: json.covid_coverage,
          travel_renewal: json.travel_renewal,
          receptive_product: json.receptive_product,
          description: json.description,
          benefits: json.benefits
        });
      });
      var data = newData;
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__["c" /* fetchComparisonProductsCoverage */])(data));
    })["catch"]();
  })["catch"]();
};
// #endregion

// #region Coverage
var getProductCoverage = function getProductCoverage(params) {
  if (!(params.hasOwnProperty('begin_date') && params.hasOwnProperty('end_date') && params.hasOwnProperty('destination') && params.hasOwnProperty('product_code'))) return false;
  var url = "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(params.destination, "/").concat(params.begin_date, "/").concat(params.end_date, "/").concat(params.product_code, "/info");
  var fetchOptions = {
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };

  // TODO: add parcels to newJson
  return fetch(url, fetchOptions).then(function (response) {
    return response.json();
  }).then(function (json) {
    var newJson = {
      id: json.id,
      name: json.name,
      min_age: json.price.child.min_age,
      max_age: json.price.elderly.max_age,
      cover_pregnant: json.cover_pregnancy,
      provider_code: json.provider_code,
      provider_name: json.provider.name,
      terms_url: json.term_url,
      covid_coverage: json.covid_coverage,
      travel_renewal: json.travel_renewal,
      receptive_product: json.receptive_product,
      description: json.description,
      benefits: json.benefits
    };
    var data = newJson;
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__["a" /* fetchProductCoverage */])(data));
    return data;
  })["catch"](function (error) {
    return console.error(error);
  });
};
// #endregion

// #region Search
var getCategory = function getCategory(params) {
  var url = "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/category");
  var fetchOptions = {
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };
  return fetch(url, fetchOptions).then(function (response) {
    return response.json();
  }).then(function (json) {
    var categories = json.categories.map(replacePropertyNames);
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["i" /* fetchCategories */])(categories, params));
    return json;
  })["catch"](function (error) {
    return console.error(error);
  });
};
function replacePropertyNames(obj) {
  var newObj = {};
  for (var prop in obj) {
    switch (prop) {
      case 'categories':
        newObj.Categories = obj[prop].map(replacePropertyNames);
        break;
      case 'id':
        newObj.ID = obj[prop];
        break;
      case 'order_priority':
        newObj.OrderPriority = obj[prop];
        break;
      case 'name':
        newObj.Name = obj[prop];
        break;
      default:
        newObj[prop] = obj[prop];
        break;
    }
  }
  return newObj;
}
var getProductQuotation = function getProductQuotation(_ref2) {
  var begin_date = _ref2.begin_date,
    end_date = _ref2.end_date,
    destination = _ref2.destination,
    product_code = _ref2.product_code,
    context = _ref2.context,
    benefits = _ref2.benefits;
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["j" /* fetchPlans */])([]));
  destination = destination.toLowerCase();
  var product_codes = [''];
  if (product_code) {
    product_codes = product_code.replace(/%20/g, '+').split('+');
  }
  var fetchOptions = {
    method: 'POST',
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw==",
      'Content-Type': 'application/json'
    }
  };
  var request_body = {
    context: context,
    end_date: end_date,
    begin_date: begin_date,
    destination: destination,
    benefits: benefits || ['42', '51', '68', '69']
  };
  var destinationSlug = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getDestinationSlugByName"])(destination) || destination;
  Promise.all(product_codes.map(function (code) {
    if (product_code) request_body.product_code = code;
    var options = _objectSpread(_objectSpread({}, fetchOptions), {}, {
      body: JSON.stringify(_objectSpread({}, request_body))
    });
    if (code) {
      return fetch("".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(destinationSlug, "/").concat(begin_date, "/").concat(end_date, "/").concat(code, "/info"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
        method: 'GET'
      }));
    }
    return fetch("".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(destinationSlug, "/").concat(begin_date, "/").concat(end_date, "/"), options);
  })).then(function (response) {
    Promise.all(response.map(function (data) {
      return data.status === 200 ? data.json() : {};
    })).then(function (json) {
      if (!json[0] && !json.code) return;
      var plans;
      if (product_codes[0]) {
        plans = json;
      } else if (json[0].length <= 1) {
        plans = json.map(function (plan) {
          return plan[0];
        });
      } else {
        var _json = _slicedToArray(json, 1);
        plans = _json[0];
      }
      var newPlans = [];
      plans.forEach(function (plan) {
        var categories = [];
        if (plan.categories !== undefined) {
          plan.categories.map(function (category) {
            categories.push(replacePropertyNames(category));
          });
        }
        var newPlan = {};
        newPlan = {
          code: plan.code ? plan.code.toString() : plan.id,
          name: plan.name,
          provider_code: plan.provider_code.toString(),
          provider_name: plan.provider_name,
          child: {
            min_age: plan.price.child.min_age,
            max_age: plan.price.child.max_age,
            price: plan.price.child.price
          },
          adult: {
            min_age: plan.price.adult.min_age,
            max_age: plan.price.adult.max_age,
            price: plan.price.adult.price
          },
          elder: {
            min_age: plan.price.elderly.min_age,
            max_age: plan.price.elderly.max_age,
            price: plan.price.elderly.price
          },
          extra: {
            special: plan.special_product,
            covid_coverage: plan.covid_coverage,
            travel_renewal: plan.travel_renewal,
            receptive_product: plan.receptive_product,
            specialist_indicator: plan.specialist_indicator,
            promotional_destination_product: plan.promotional_destination_product
          },
          terms_url: plan.term_url,
          categories: categories,
          benefits: [],
          upsell_product_id: plan.upsell_product_id
        };
        if (plan.benefits[0].code) {
          newPlan.benefits = plan.benefits;
        } else {
          plan.benefits.map(function (item) {
            return newPlan.benefits.push({
              code: item.benefits.id.toString(),
              name: item.benefits.name,
              coverage: item.coverage
            });
          });
        }
        newPlans.push(newPlan);
      });
      plans = newPlans;
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["j" /* fetchPlans */])(plans, context));
    })["catch"]();
  })["catch"]();
};
var fetchProductQuotation = function fetchProductQuotation(_ref3) {
  var begin_date = _ref3.begin_date,
    end_date = _ref3.end_date,
    destination = _ref3.destination,
    product_code = _ref3.product_code;
  var fetchOptions = {
    method: 'POST',
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw==",
      'Content-Type': 'application/json'
    }
  };
  var request_body = {
    begin_date: begin_date,
    end_date: end_date,
    destination: destination,
    greatfor: null,
    context: null,
    benefits: [],
    product_code: product_code,
    "partner": "",
    "provider": null
  };
  return fetch("".concat("https://dev.segurospromo.com.br/services/ecommerce", "/quotation"), _objectSpread(_objectSpread({}, fetchOptions), {}, {
    body: JSON.stringify(request_body)
  }));
};
var fetchUpsellPlan = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
    var begin_date, end_date, destination, product_code, destinationSlug, fetchOptions, response, plan, categories, newPlan;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          begin_date = _ref4.begin_date, end_date = _ref4.end_date, destination = _ref4.destination, product_code = _ref4.product_code;
          destinationSlug = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getDestinationSlugByName"])(destination.toLowerCase()) || destination.toLowerCase();
          fetchOptions = {
            method: 'GET',
            headers: {
              Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
            }
          };
          _context.n = 1;
          return fetch("".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(destinationSlug, "/").concat(begin_date, "/").concat(end_date, "/").concat(product_code, "/info"), fetchOptions);
        case 1:
          response = _context.v;
          if (!(response.status !== 200)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, null);
        case 2:
          _context.n = 3;
          return response.json();
        case 3:
          plan = _context.v;
          if (plan) {
            _context.n = 4;
            break;
          }
          return _context.a(2, null);
        case 4:
          categories = [];
          if (plan.categories !== undefined) {
            plan.categories.forEach(function (category) {
              categories.push(replacePropertyNames(category));
            });
          }
          newPlan = {
            code: plan.code ? plan.code.toString() : plan.id,
            name: plan.name,
            provider_code: plan.provider_code.toString(),
            provider_name: plan.provider_name,
            child: {
              min_age: plan.price.child.min_age,
              max_age: plan.price.child.max_age,
              price: plan.price.child.price
            },
            adult: {
              min_age: plan.price.adult.min_age,
              max_age: plan.price.adult.max_age,
              price: plan.price.adult.price
            },
            elder: {
              min_age: plan.price.elderly.min_age,
              max_age: plan.price.elderly.max_age,
              price: plan.price.elderly.price
            },
            extra: {
              special: plan.special_product,
              covid_coverage: plan.covid_coverage,
              travel_renewal: plan.travel_renewal,
              receptive_product: plan.receptive_product,
              specialist_indicator: plan.specialist_indicator
            },
            terms_url: plan.term_url,
            categories: categories,
            benefits: [],
            upsell_product_id: plan.upsell_product_id
          };
          if (plan.benefits && plan.benefits.length > 0 && plan.benefits[0].code) {
            newPlan.benefits = plan.benefits;
          } else if (plan.benefits) {
            plan.benefits.forEach(function (item) {
              return newPlan.benefits.push({
                code: item.benefits.id.toString(),
                name: item.benefits.name,
                coverage: item.coverage
              });
            });
          }
          return _context.a(2, newPlan);
      }
    }, _callee);
  }));
  return function fetchUpsellPlan(_x) {
    return _ref5.apply(this, arguments);
  };
}();

//DJANGO
var getCouponData = function getCouponData(coupon, product_code, begin_date, end_date, destination) {
  var isPurchasePage = function isPurchasePage() {
    return window.location.pathname.indexOf('pedido') > -1;
  };
  if (!coupon) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["o" /* clearCoupon */])());
    return;
  }
  if (coupon !== coupon.trim()) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["J" /* fetchDiscountCoupon */])({
      notFound: true
    }));
    return;
  }
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_22" /* setCouponText */])(coupon));
  var url;
  if (isPurchasePage()) url = "https://dev.segurospromo.com.br" + "/site" + '/coupon' + '/?coupon_code=' + coupon.toUpperCase() + '&product_id=' + product_code + '&travel_coverage_begin=' + begin_date + '&travel_coverage_end=' + end_date + '&travel_destination=' + destination;else url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/pesquisa-cupom/").concat(coupon.toUpperCase(), "?begin-date=").concat(begin_date, "&end-date=").concat(end_date);
  var fetchOptions = {
    headers: {
      Authorization: "Basic c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };
  fetch(url, fetchOptions).then(function (response) {
    if (response.status === 200) {
      return response.json();
    } else if (response.status === 404) __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["J" /* fetchDiscountCoupon */])({
      notFound: true
    }));
  }).then(function (json) {
    if (json.status === 0 || json.status === '0') __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["J" /* fetchDiscountCoupon */])(json));else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_22" /* setCouponText */])(''));
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["J" /* fetchDiscountCoupon */])({
        notFound: true
      }));
    }
  })["catch"](function (error) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["J" /* fetchDiscountCoupon */])({
      notFound: true
    }));
  });
};

//DJANGO
var getPaymentMethods = function getPaymentMethods(params) {
  var url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/pedido/api/payment-methods/");
  var fetchOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Authorization: "Basic c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    },
    body: JSON.stringify(params)
  };
  fetch(url, fetchOptions).then(function (response) {
    return response.json();
  }).then(function (json) {
    return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["L" /* fetchPaymentMethods */])(json));
  })["catch"](function (error) {
    return console.error(error);
  });
};
// #endregion

var checkoutPurchase = function checkoutPurchase(purchase_data) {
  var fmtDate = function fmtDate(date) {
    var spl_date = '';
    if (date.match(/^\d{2}\/\d{2}\/\d{4}/)) spl_date = date.split('/');
    return spl_date[2] + '-' + spl_date[1] + '-' + spl_date[0];
  };
  var fmtCPF = function fmtCPF(cpf) {
    return cpf.replace(/\.|\s|-/g, '');
  };
  var fmtPassport = function fmtPassport(passport) {
    return passport.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  };
  var DT_CPF = 0;
  var DT_RG = 1;
  var DT_PASSPORT = 2;
  var holder = {};
  var parcels = 1;
  var safetypay = {};
  var creditcard = {};
  var selected_bank = [];
  var selected_brand = [];
  var selected_pm = purchase_data.paymentMethods.filter(function (pm) {
    return pm.selected;
  });
  selected_pm = selected_pm[0] || '';
  if (selected_pm.slug === 'credit-card') {
    holder = {
      full_name: purchase_data.creditCard.holder_name,
      cpf: fmtCPF(purchase_data.creditCard.holder_cpf)
    };
    parcels = purchase_data.creditCard.parcels.filter(function (parcel) {
      return parcel.selected;
    })[0].times;
    selected_brand = purchase_data.creditCard.brands.filter(function (brand) {
      return brand.selected;
    });
    selected_brand = selected_brand[0] || '';
    creditcard = {
      brand: selected_brand.brand_name,
      number: purchase_data.creditCard.number.replace(/\s/g, ''),
      cvv: purchase_data.creditCard.cvv,
      expiration_year: purchase_data.creditCard.expiry_year,
      expiration_month: purchase_data.creditCard.expiry_month
    };
  } else if (selected_pm.slug === 'boleto') {
    holder = {
      full_name: purchase_data.boleto.name,
      cpf: fmtCPF(purchase_data.boleto.cpf)
    };
  } else if (selected_pm.slug === 'safetypay') {
    holder = {
      agency: purchase_data.safetypay.agency,
      full_name: purchase_data.safetypay.name,
      account: purchase_data.safetypay.account,
      cpf: fmtCPF(purchase_data.safetypay.cpf)
    };
    selected_bank = purchase_data.safetypay.banks.filter(function (bk) {
      return bk.selected;
    });
    selected_bank = selected_bank[0] || {};
    try {
      safetypay = {
        bank: selected_bank.slug,
        bank_branch: purchase_data.safetypay.agency,
        bank_account: purchase_data.safetypay.account || '',
        cpf: purchase_data.safetypay.cpf
      };
    } catch (err) {
      safetypay = {
        bank: '',
        bank_branch: '',
        bank_account: ''
      };
    }
  } else if (selected_pm.slug === 'cash') {
    holder = {
      full_name: purchase_data.cash.holderName,
      cpf: fmtCPF(purchase_data.cash.holderCpf)
    };
  } else if (selected_pm.slug === 'pix') {
    holder = {
      full_name: purchase_data.pix.name,
      cpf: fmtCPF(purchase_data.pix.cpf)
    };
  }
  var paymentMethod = selected_pm.id.toString();
  var _fmtQueryParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["fmtQueryParams"])(purchase_data.quotationParams.queryParams),
    tag = _fmtQueryParams.tag;
  var creditCouponCode = null;
  if (purchase_data.creditCoupon.code && purchase_data.creditCoupon.applied) {
    creditCouponCode = purchase_data.creditCoupon.code;
  }
  if (purchase_data.purchaseSummary.total === 0) {
    paymentMethod = null;
  }
  var fmtPurchaseData = _objectSpread({
    departure_date: purchase_data.quotationParams.departure_date,
    return_date: purchase_data.quotationParams.return_date,
    product_code: purchase_data.plans[0].code.toString(),
    destination: purchase_data.quotationParams.destination,
    payment_method_discount: purchase_data.purchaseSummary.paymentMethodDiscountPercent,
    payment_method_discount_value: parseFloat(purchase_data.purchaseSummary.paymentMethodDiscountValue),
    tags: tag,
    newflux: false,
    insureds: purchase_data.insuredForms.map(function (insured) {
      return {
        full_name: insured.name,
        document_type: insured.document_type === 'cpf' ? DT_CPF : insured.document_type === 'rg' ? DT_RG : insured.document_type === 'passport' ? DT_PASSPORT : '',
        document: insured.document_type === 'cpf' ? fmtCPF(insured.cpf) : insured.document_type === 'rg' ? insured.rg : insured.document_type === 'passport' ? fmtPassport(insured.passport) : '',
        birth_date: fmtDate(insured.birth_date),
        origin_destination: insured.incoming
      };
    }),
    cash_allowed_by: {
      username: purchase_data.cash.username,
      password: purchase_data.cash.password
    },
    holder: holder,
    payment: {
      payment_method: paymentMethod,
      parcels: parcels,
      credit_coupon_code: creditCouponCode,
      coupon_code: purchase_data.coupon && purchase_data.coupon.exists && purchase_data.coupon.text && purchase_data.coupon.text.toUpperCase()
    },
    safetypay: safetypay,
    creditcard: creditcard,
    contact: {
      phone: purchase_data.contact.phone_number.replace(/\(|\)|\s|-/g, ''),
      contact_name: purchase_data.contact.contact_name,
      email: purchase_data.contact.email
    },
    address: {
      address_cep: purchase_data.contact.cep.replace(/\.|\(|\)|\s|-/g, ''),
      address: purchase_data.contact.address,
      address_number: !purchase_data.contact.number || purchase_data.contact.number === '' ? '1' : purchase_data.contact.number,
      address_complement: purchase_data.contact.complement,
      address_district: purchase_data.contact.district,
      address_state: purchase_data.contact.state,
      address_city: purchase_data.contact.city
    },
    b2b: {
      partner: purchase_data.partner,
      partner_slug: purchase_data.partner,
      seller_slug: null,
      seller: null
    },
    extra: {
      displayedPrice: purchase_data.purchaseSummary.total,
      dateTimeTermsAccept: purchase_data.dateTimeAccept,
      coupon_discount: purchase_data.purchaseSummary.coupon_discount,
      no_discount: purchase_data.purchaseSummary.subtotal,
      device: document.documentElement.clientWidth <= 769 ? 'mobile' : 'desktop'
    },
    operators: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getOperatorsCookie"])(),
    partners: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getPartnersCookie"])()
  }, purchase_data.hasConfirmedOperator && {
    user_accepted_operator_confirmation_modal: true
  });
  var url = "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/purchase");
  var fetchOptions = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw==",
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(fmtPurchaseData)
  };
  return fetch(url, fetchOptions).then(function (response) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["Q" /* finishedPurchase */])());
    if (response.status === 200 || response.status === 202) return response.json();else if (response.status === 400 || response.status === 500) response.json().then(function (json) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_31" /* validatePurchase */])(-1, 'fail', json.message));
      if (json.message === 'Cartão inválido') {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_30" /* showInvalidCreditCardError */])());
        window.scrollTo(0, 0);
      } else if (json.type === "d0") {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_5" /* openModalPurchaseDateError */])());
      } else if (json.error === "duplicated purchase") {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_6" /* openModalPurchaseError */])());
      } else if (json.error === "coupon not available") {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["X" /* openModalCouponError */])());
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_sentry__["a" /* captureException */])(new Error('Erro inesperado na compra'), {
          url: url,
          status: response.status,
          response: json
        });
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_1" /* openModalGenericError */])());
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["V" /* hideInvalidCreditCardError */])());
      }
    });
  }).then(function (json) {
    if (json.reproved === true) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["Z" /* openModalFailPayment */])());
      return;
    }
    if (json.uuid) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_27" /* setPurchaseUuid */])(json.uuid));
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_31" /* validatePurchase */])(1, 'success'));
    } else __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_31" /* validatePurchase */])(-1, 'fail', json.message));
  })["catch"](function (error) {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["_31" /* validatePurchase */])(-1, 'fail'));
  });
};
var getPurchaseStatus = function getPurchaseStatus(uuid) {
  var url = "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/purchase/status/").concat(uuid);
  var fetchOptions = {
    method: 'GET',
    headers: {
      Authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  };
  fetch(url, fetchOptions).then(function (response) {
    return response.json();
  }).then(function (json) {
    var purchase_status = {
      actionpay_pixel_url: json.status.pixels.actionpay_pixel_url,
      meliuz_pixel_url: json.status.pixels.meliuz_pixel_url,
      cityads_pixel_url: json.status.pixels.cityads_pixel_url,
      id: json.status.id,
      status: json.status.status,
      payment_method: json.status.payment_method,
      departure_date: json.status.departure_date,
      return_date: json.status.return_date,
      parcels: json.status.parcels,
      price: json.status.price,
      product: json.status.product,
      products_id: json.status.product_id,
      provider: json.status.provider,
      destination: json.status.destination,
      contact_name: json.status.contact_name,
      coupon_code: json.status.coupon_code,
      payment: json.status.payment,
      payment_status: json.status.payment_status,
      insureds: json.status.insureds,
      created_at: json.status.created_at
    };
    if (json.status.credit_coupon) {
      purchase_status.credit_coupon = json.status.credit_coupon;
    }
    if (json.status.payment_method === 'Cartão de Crédito') {
      purchase_status.payment = _objectSpread(_objectSpread({}, purchase_status.payment), {}, {
        brand: json.status.payment.creditcard_brand,
        number: json.status.payment.creditcard_number
      });
    } else if (json.status.payment_method === 'Boleto') {
      purchase_status.status = purchase_status.status === 'Pendente Boleto' ? 'Pendente' : purchase_status.status;
      purchase_status.payment = _objectSpread(_objectSpread({}, purchase_status.payment), {}, {
        deadline: json.status.payment.dead_line.substring(0, 10),
        barcode: json.status.payment.bar_code
      });
    } else if (json.status.payment_method === 'Transferência Bancária') {
      purchase_status.status = purchase_status.status === 'Pendente Transferência' ? 'Pendente' : purchase_status.status;
      purchase_status.payment = _objectSpread(_objectSpread({}, purchase_status.payment), {}, {
        active_safetypay: {
          deadline: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatDateFromConvert"])(json.status.payment.dead_line),
          extra: json.status.payment.extra,
          holder_bank: json.status.payment.holder_bank.replaceAll('-', ' '),
          holder_cpf: json.status.payment.holder_cpf,
          redirect_url: json.status.payment.redirect_url,
          transaction_id: json.status.payment.transaction_id
        },
        bank_img_path: json.status.payment.bank_img_path.replace('segurospromo.com.br', ''),
        bank_name: json.status.payment.bank_name.replaceAll('-', ' ')
      });
    } else if (json.status.payment_method === 'PIX') {
      purchase_status.payment = _objectSpread(_objectSpread({}, purchase_status.payment), {}, {
        deadline: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatDateFromConvert"])(json.status.payment.dead_line)
      });
    }
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_purchaseStatusActions__["a" /* fetchPurchaseStatus */])(purchase_status));
  })["catch"](function (error) {
    return console.error(error);
  });
};
var sendEmail = function sendEmail(pageParams, type, toAddress) {
  var product_code = pageParams.product_code,
    destination = pageParams.destination,
    begin_date = pageParams.begin_date,
    end_date = pageParams.end_date,
    products_ids = pageParams.products_ids,
    coupon = pageParams.coupon;
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__["i" /* sendingEmail */])());
  var form = new FormData();
  form.append('to_email', toAddress);

  // TODO (Igor): remover quando for pra produção 100%
  var url = window.location.toString();
  form.append('url', url);
  if (type === 'detail') {
    url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/product-detail-email/").concat(product_code, "/").concat(destination, "/").concat(begin_date, "/").concat(end_date, "/");
  } else if (type === 'comparison') {
    url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/product-comparison-email/").concat(destination, "/").concat(begin_date, "/").concat(end_date, "/");
    form.append('products_ids', products_ids.join(' '));
  }
  url += '?no-redirect=no-redirect';
  if (coupon && coupon !== '') url += "&cupom=".concat(coupon);
  fetch(url, {
    body: form,
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      Authorization: "Basic c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.success) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__["g" /* sendEmailDone */])());
    } else {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__["h" /* sendEmailFail */])());
    }
  })["catch"](function () {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_comparisonActions__["h" /* sendEmailFail */])());
  });
};
var getAddressData = function getAddressData(cep) {
  if (cep.length < 8) return;
  if (typeof cep !== 'string') return;
  var url = "https://amocep.amopromo.com/api/v1/cep/".concat(cep.replace(/\.|\s|-/g, ''));
  var fetchOptions = {
    method: 'GET'
  };
  fetch(url, fetchOptions).then(function (response) {
    if (response.status === 200) return response.json().then(function (json) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["H" /* fetchAddress */])({
        tipo_logradouro: json.tipo_logradouro || '',
        bairro: json.neighborhood || '',
        cidade: json.city || '',
        uf: json.state || '',
        logradouro: json.street || ''
      }));
    });
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["H" /* fetchAddress */])({
      tipo_logradouro: '',
      bairro: '',
      cidade: '',
      uf: '',
      logradouro: ''
    }));
  });
};
var getPurchaseData = function getPurchaseData(data) {
  var url = "".concat("https://dev.segurospromo.com.br").concat("/site", "/pedido/api/purchase-data/").concat(data, "/");
  fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json().then(function (json) {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_purchaseActions__["N" /* fetchPurchaseData */])(json));
    });
  });
};

// Chip
// export const getChipUrl = async (uuid) => {
//   const url = `${process.env.REACT_APP_CHIP_URL}/purchase/cross-sell/${uuid}`;

//   const options = {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${process.env.REACT_APP_CHIP_BEARER}`,
//     },
//   };

//   const dataValues = await fetch(url, options)
//     .then((response) => {
//       if (response.status !== 200) return null;

//       return response.json();
//     })
//     .then((data) => data);

//   return dataValues;
// };

var fetchEcommerceConfigService = function fetchEcommerceConfigService() {
  var url = "".concat("https://dev.segurospromo.com.br/api/site", "/config/ecommerce-config/");
  var response = fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};
var fetchProvidersService = function fetchProvidersService() {
  var url = "".concat("https://dev.segurospromo.com.br/api/site", "/config/providers/");
  var response = fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};
var fetchSortOptionsService = function fetchSortOptionsService() {
  var url = "".concat("https://dev.segurospromo.com.br/api/site", "/config/sort-options/");
  var response = fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};
var fetchDestinationsService = function fetchDestinationsService() {
  var url = "".concat("https://dev.segurospromo.com.br/api/site", "/config/destinations/");
  var response = fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};
var fetchPaymentMethodsService = function fetchPaymentMethodsService() {
  var url = "".concat("https://dev.segurospromo.com.br/api/site", "/config/payment-methods/");
  var response = fetch(url, {
    method: 'GET'
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};
var fetchHighlightPlans = function fetchHighlightPlans(match) {
  var destination = match.destination,
    begin_date = match.begin_date,
    end_date = match.end_date;
  var url = "".concat("https://dev.segurospromo.com.br/services/ecommerce", "/product/destination/").concat(destination, "/").concat(begin_date, "/").concat(end_date, "/highlight");
  var response = fetch(url, {
    headers: {
      authorization: "c2VndXJvc3Byb21vOnNlZ3Vyb3Nwcm9tbw=="
    }
  }).then(function (response) {
    if (response.status !== 200) return null;
    return response.json();
  });
  return response;
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var CURRENCY = 'BRL';
function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}
function getSessionId() {
  var id = sessionStorage.getItem('sp_session_id');
  if (!id) {
    id = generateId();
    sessionStorage.setItem('sp_session_id', id);
  }
  return id;
}
function getClientId() {
  var id = localStorage.getItem('sp_client_id');
  if (!id) {
    id = generateId();
    localStorage.setItem('sp_client_id', id);
  }
  return id;
}
function push(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(_objectSpread({
    session_id: getSessionId(),
    client_id: getClientId()
  }, event));
}
function pushEcommerce(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null
  });
  push(event);
}
function formatItem(plan) {
  var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return {
    item_id: String(plan.code),
    item_name: plan.name,
    item_brand: plan.provider_code,
    item_category: 'Seguro Viagem',
    price: parseFloat(plan.price_with_coupon_discount || plan.adult && plan.adult.price) || 0,
    quantity: parseInt(quantity, 10) || 1
  };
}
var dataLayer = {
  /**
   * Disparo: SPA muda de rota / página carrega.
   * Obrigatório para calcular: taxa de conversão para busca, conversão checkout, conversão upsell.
   * @param {'home'|'search_results'|'checkout'|'checkout_upsell'|'checkout_segurados'|'checkout_pagamento'|'checkout_confirmacao'} pageType
   * @param {string} [pageTitle]
   */
  pageView: function pageView(pageType, pageTitle) {
    push({
      event: 'page_view',
      page_type: pageType,
      page_title: pageTitle || document.title,
      page_path: window.location.pathname + window.location.search
    });
  },
  /**
   * Disparo: usuário submete formulário de busca.
   * @param {string} destination
   * @param {string} beginDate  YYYY-MM-DD
   * @param {string} endDate    YYYY-MM-DD
   * @param {number} travelers
   */
  searchSubmitted: function searchSubmitted(destination, beginDate, endDate, travelers) {
    push({
      event: 'sp_search_submitted',
      search_term: destination,
      travel_begin_date: beginDate,
      travel_end_date: endDate,
      travelers: parseInt(travelers, 10) || 1
    });
  },
  /**
   * Disparo: lista de planos renderizada após busca.
   * @param {Array}  plans
   * @param {string} destination
   */
  viewItemList: function viewItemList(plans, destination) {
    pushEcommerce({
      event: 'view_item_list',
      ecommerce: {
        currency: CURRENCY,
        item_list_name: "Resultados: ".concat(destination),
        items: plans.map(function (plan, index) {
          return _objectSpread(_objectSpread({}, formatItem(plan)), {}, {
            index: index
          });
        })
      }
    });
  },
  /**
   * Disparo: usuário abre detalhes/modal de um plano específico.
   * @param {Object} plan
   */
  viewItem: function viewItem(plan) {
    pushEcommerce({
      event: 'view_item',
      ecommerce: {
        currency: CURRENCY,
        value: parseFloat(plan.price_with_coupon_discount || plan.adult && plan.adult.price) || 0,
        items: [formatItem(plan)]
      }
    });
  },
  /**
   * Disparo: usuário clica em "Selecionar".
   * @param {Object} plan
   * @param {number} quantity  número de segurados
   */
  addToCart: function addToCart(plan) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'add_to_cart',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item]
      }
    });
  },
  /**
   * Disparo: primeira etapa do checkout carregada.
   * @param {Object} plan
   * @param {number} quantity
   */
  beginCheckout: function beginCheckout(plan) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'begin_checkout',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item]
      }
    });
  },
  /**
   * Disparo: usuário seleciona / troca forma de pagamento.
   * @param {Object} plan
   * @param {number} quantity
   * @param {'credit_card'|'pix'|'boleto'} paymentMethod
   * @param {number} installments
   */
  addPaymentInfo: function addPaymentInfo(plan) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var paymentMethod = arguments.length > 2 ? arguments[2] : undefined;
    var installments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'add_payment_info',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        payment_type: paymentMethod,
        installments: parseInt(installments, 10) || 1,
        items: [item]
      }
    });
  },
  /**
   * Disparo: botão "Pagar" clicado — antes de saber o resultado.
   * @param {Object}      order          { id, grandTotal, coupon?, discount? }
   * @param {Object}      plan
   * @param {number}      quantity
   * @param {string}      paymentMethod
   * @param {number}      installments
   * @param {string|null} errorCode      null se sucesso; ex: 'declined', 'timeout', '3ds_failed'
   */
  purchaseAttempted: function purchaseAttempted(order, plan) {
    var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var paymentMethod = arguments.length > 3 ? arguments[3] : undefined;
    var installments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var errorCode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'sp_purchase_attempted',
      payment_type: paymentMethod,
      installments: parseInt(installments, 10) || 1,
      error_code: errorCode,
      ecommerce: {
        currency: CURRENCY,
        transaction_id: String(order.id),
        value: parseFloat(order.grandTotal) || item.price * item.quantity,
        coupon: order.coupon || undefined,
        items: [item]
      }
    });
  },
  /**
   * Disparo: compra confirmada.
   * @param {Object}  order   { id, grandTotal, coupon?, discount? }
   * @param {Object}  plan
   * @param {number}  quantity
   * @param {string}  paymentMethod
   * @param {number}  installments
   */
  purchase: function purchase(order, plan) {
    var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var paymentMethod = arguments.length > 3 ? arguments[3] : undefined;
    var installments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'purchase',
      ecommerce: {
        currency: CURRENCY,
        transaction_id: String(order.id),
        value: parseFloat(order.grandTotal) || item.price * item.quantity,
        coupon: order.coupon || undefined,
        discount: parseFloat(order.discount) || 0,
        payment_type: paymentMethod,
        installments: parseInt(installments, 10) || 1,
        items: [item]
      }
    });
  },
  /**
   * Disparo: usuário avança ou volta entre etapas do checkout.
   * @param {'upsell'|'segurados'|'pagamento'|'confirmacao'} stepName
   * @param {'forward'|'backward'} direction
   */
  checkoutStepView: function checkoutStepView(stepName) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'forward';
    push({
      event: 'sp_checkout_step_view',
      step_name: stepName,
      direction: direction
    });
  },
  /**
   * Disparo: tela de upsell exibida ao usuário.
   * @param {Object} basePlan     plano original selecionado
   * @param {Object} upgradePlan  plano sugerido como upgrade
   */
  upsellViewed: function upsellViewed(basePlan, upgradePlan) {
    push({
      event: 'upsell_viewed',
      base_plan_id: String(basePlan.code),
      base_plan_name: basePlan.name,
      upgrade_plan_id: String(upgradePlan.code),
      upgrade_plan_name: upgradePlan.name,
      upgrade_price_delta: parseFloat((upgradePlan.price_with_coupon_discount || upgradePlan.adult && upgradePlan.adult.price) - (basePlan.price_with_coupon_discount || basePlan.adult && basePlan.adult.price)) || 0
    });
  },
  /**
   * Disparo: usuário aceita o upgrade de plano.
   * @param {Object} upgradePlan
   * @param {number} quantity
   */
  upsellAccepted: function upsellAccepted(upgradePlan) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var item = formatItem(upgradePlan, quantity);
    pushEcommerce({
      event: 'upsell_accepted',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item]
      }
    });
  },
  /**
   * Disparo: usuário rejeita o upgrade e continua com plano original.
   * @param {Object} basePlan
   */
  upsellRejected: function upsellRejected(basePlan) {
    push({
      event: 'upsell_rejected',
      base_plan_id: String(basePlan.code),
      base_plan_name: basePlan.name
    });
  },
  /**
   * Disparo: usuário aplica filtros na listagem.
   * @param {Object} filters  { providers: [], coverage: number, benefits: [] }
   * @param {number} resultsCount
   */
  applyFilter: function applyFilter(filters, resultsCount) {
    push({
      event: 'apply_filter',
      filter_providers: filters.providers && filters.providers.join(',') || '',
      filter_coverage: filters.coverage || null,
      filter_benefits: filters.benefits && filters.benefits.join(',') || '',
      results_count: resultsCount
    });
  },
  /**
   * Disparo: usuário aplica cupom de desconto.
   * @param {string}  couponCode
   * @param {boolean} success
   */
  applyPromo: function applyPromo(couponCode, success) {
    push({
      event: 'apply_promo',
      coupon_code: couponCode,
      coupon_success: success
    });
  },
  /**
   * Disparo: usuário abre comparativo de planos.
   * @param {Array<string>} planNames
   */
  comparePlans: function comparePlans(planNames) {
    push({
      event: 'compare_plans',
      compared_plans: planNames.join(' vs ')
    });
  },
  /**
   * Push genérico para eventos legados no formato category/action/label (substitui gtmTrigger).
   * @param {string} event
   * @param {string} category
   * @param {string} action
   * @param {string} [label]
   */
  genericEvent: function genericEvent(event, category, action, label) {
    push({
      event: event,
      event_category: category,
      event_action: action,
      event_label: label
    });
  },
  /**
   * Push direto ao dataLayer — para eventos customizados sem mapeamento específico.
   * Adiciona session_id e client_id automaticamente.
   * @param {Object} data
   */
  raw: function raw(data) {
    push(data);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (dataLayer);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(138)();
}


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return REMOVE_COMPARISON_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_COMPARISON_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLEAN_COMPARISON_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return FILTER_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return SET_SORT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return SET_SORT_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return SET_PROVIDER_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return FILTER_PLANS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return FETCH_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return UNSELECT_FILTER_CATEGORY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return APPLY_FILTER_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLEAR_FILTER_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return OPEN_COMPARISON_ACCORDION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return FETCH_COMPARISON_PRODUCTS_COVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return SENDING_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SEND_EMAIL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return SEND_EMAIL_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHANGE_EMAIL_MODAL_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHANGE_EMAIL_COLLAPSE_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return GET_PRODUCT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return FETCH_PRODUCT_COVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return OPEN_COVERAGE_ACCORDION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return FETCH_DISCOUNT_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return SET_COUPON_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CLEAR_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return SET_CREDIT_COUPON_CODE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return APPLY_CREDIT_COUPON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APPLY_CREDIT_COUPON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return REMOVE_APPLIED_CREDIT_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return FETCH_PAYMENT_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_INSURED_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return REMOVE_INSURED_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHANGE_INSURED_FORM_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return FETCH_PAYMENT_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SELECT_PAYMENT_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return SELECT_CREDITCARD_BRAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return SELECT_CREDITCARD_PARCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CHANGE_CREDITCARD_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHANGE_BOLETO_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SELECT_BANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHANGE_SAFETYPAY_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHANGE_CASH_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHANGE_PIX_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHANGE_CONTACT_ATTR; });
/* unused harmony export TOGGLE_ACCEPT_TERMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return FETCH_BENEFITS_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return FINISH_PURCHASE; });
/* unused harmony export CLEAN_COOKIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return SET_PURCHASE_UUID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return VALIDATE_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return FETCH_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLEAR_ALERTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return START_PURCHASE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return END_PURCHASE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return FETCH_PURCHASE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return FETCH_PURCHASE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return FETCH_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return SET_PARTNER; });
/* unused harmony export FETCH_PLANS_SEARCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return FETCH_PLANS_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return SET_QUOTATION_PARAMS; });
/* unused harmony export FETCH_PLANS_COVERAGE */
/* unused harmony export FETCH_PLANS_COMPARISON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return UPDATE_PURCHASE_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return OPEN_MODAL_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CLOSE_MODAL_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return OPEN_DETAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLOSE_DETAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return OPEN_MODAL_FRANCHISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CLOSE_MODAL_FRANCHISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return OPEN_MODAL_OPERATOR_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CLOSE_MODAL_OPERATOR_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return OPEN_MODAL_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CLOSE_MODAL_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return OPEN_MODAL_STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return CLOSE_MODAL_STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return OPEN_MODAL_SAFETYPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CLOSE_MODAL_SAFETYPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return OPEN_MODAL_TERMS_OF_USE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return CLOSE_MODAL_TERMS_OF_USE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return OPEN_MODAL_PURCHASE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CLOSE_MODAL_PURCHASE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return OPEN_MODAL_COUPON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CLOSE_MODAL_COUPON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return OPEN_MODAL_PURCHASE_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CLOSE_MODAL_PURCHASE_DATE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return OPEN_MODAL_GENERIC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CLOSE_MODAL_GENERIC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return OPEN_MODAL_TRAVEL_RENEWAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return CLOSE_MODAL_TRAVEL_RENEWAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return OPEN_MODAL_RENEWAL_FRANCHISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CLOSE_MODAL_RENEWAL_FRANCHISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return OPEN_MODAL_RECEPTIVE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CLOSE_MODAL_RECEPTIVE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return OPEN_MODAL_PLAN_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CLOSE_MODAL_PLAN_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return OPEN_MODAL_FAIL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CLOSE_MODAL_FAIL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return SET_OPERATOR_CONFIRMATION_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return OPEN_MODAL_NOT_COVID_COVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CLOSE_MODAL_NOT_COVID_COVERAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return SHOW_INVALID_CREDIT_CARD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return HIDE_INVALID_CREDIT_CARD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return SET_USER_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CHANGE_CONFIRM_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLEAN_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCESS_IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return NEXT_STAGE_PURCHASE_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return STAGE_PAYMENT_CREDIT_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return STAGE_PAYMENT_CASH_TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return EDIT_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return SELECT_PAYMENT_ALTER_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BACK_STAGE_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BACK_STAGE_PAYMENT_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLEAN_STATES_PURCHASE_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return VALIDATOR_HANDLER_BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return GET_INFOS_PROSPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return SET_INFOS_PROSPECT_IN_PURCHASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLEAR_INFOS_PROSPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return GET_INFOS_INSUREDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return OPEN_MODAL_QUOTATION_DATE_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CLOSE_MODAL_QUOTATION_DATE_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return OPEN_MODAL_QUOTATION_DATE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CLOSE_MODAL_QUOTATION_DATE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return OPEN_MODAL_WITHOUT_TRACKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CLOSE_MODAL_WITHOUT_TRACKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SET_TRACKER_INFOS_PROSPECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return TRACKER_MODAL_VALIDATOR_HANDLER_BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return VALIDATE_TRACKER_MODAL_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return SET_BENEFITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SEARCH_ECOMMERCE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SEARCH_PROVIDER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return GLOBAL_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return GLOBAL_PROVIDER_SETGINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return PURCHASE_GET_PAYMENT_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return STORE_HIGHLIGTH_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return TOGGLE_SPECIALIST_SUGGESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return OPEN_MODAL_UPSELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return CLOSE_MODAL_UPSELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return SET_UPSELL_PLANS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return SET_UPSELL_SOURCE_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SET_UPSELL_PURCHASE; });
// #region SEARCH
var REMOVE_COMPARISON_PLAN = 'REMOVE_COMPARISON_PLAN';
var ADD_COMPARISON_PLAN = 'ADD_COMPARISON_PLAN';
var CLEAN_COMPARISON_PLANS = 'CLEAN_COMPARISON_PLANS';
var FILTER_PLANS = 'FILTER_PLANS';
var SET_SORT_OPTIONS = 'SET_SORT_OPTIONS';
var SET_SORT_OPTION = 'SET_SORT_OPTION';
var SET_PROVIDER_OPTION = 'SET_PROVIDER_OPTION';
var FILTER_PLANS_MOBILE = 'FILTER_PLANS_MOBILE';
var FETCH_CATEGORIES = 'FETCH_CATEGORIES';
var UNSELECT_FILTER_CATEGORY_OPTIONS = 'UNSELECT_FILTER_CATEGORY_OPTIONS';
var APPLY_FILTER_CATEGORIES = 'APPLY_ALL_FILTER_CATEGORIES';
var CLEAR_FILTER_CATEGORIES = 'CLEAR_ALL_FILTER_CATEGORIES';

// #endregion

// #region COMPARISON
var OPEN_COMPARISON_ACCORDION = 'OPEN_COMPARISON_ACCORDION';
var FETCH_COMPARISON_PRODUCTS_COVERAGE = 'FETCH_COMPARISON_PRODUCTS_COVERAGE';
// email
var SENDING_EMAIL = 'SENDING_EMAIL';
var SEND_EMAIL_DONE = 'SEND_EMAIL_DONE';
var SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL';
var CHANGE_EMAIL_MODAL_ATTR = 'CHANGE_EMAIL_MODAL_ATTR';
var CHANGE_EMAIL_COLLAPSE_ATTR = 'CHANGE_EMAIL_COLLAPSE_ATTR';
// #endregion

// #region COVERAGE
var GET_PRODUCT_INFO = 'GET_PRODUCT_INFO';
var FETCH_PRODUCT_COVERAGE = 'FETCH_PRODUCT_COVERAGE';
var OPEN_COVERAGE_ACCORDION = 'OPEN_COVERAGE_ACCORDION';
// #endregion

// #region PURCHASE
// coupon
var FETCH_DISCOUNT_COUPON = 'FETCH_DISCOUNT_COUPON';
var SET_COUPON_TEXT = 'SET_COUPON_TEXT';
var CLEAR_COUPON = 'CLEAR_COUPON';

// Credit Coupon
var FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS = 'FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS';
var FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR = 'FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR';
var SET_CREDIT_COUPON_CODE_TEXT = 'SET_CREDIT_COUPON_CODE_TEXT';
var APPLY_CREDIT_COUPON_SUCCESS = 'APPLY_CREDIT_COUPON_SUCCESS';
var APPLY_CREDIT_COUPON_ERROR = 'APPLY_CREDIT_COUPON_ERROR';
var REMOVE_APPLIED_CREDIT_COUPON = 'REMOVE_APPLIED_CREDIT_COUPON';

// payment info
var FETCH_PAYMENT_INFO = 'FETCH_PAYMENT_INFO';

// insured register
var ADD_INSURED_FORM = 'ADD_INSURED_FORM';
var REMOVE_INSURED_FORM = 'REMOVE_INSURED_FORM';
var CHANGE_INSURED_FORM_ATTR = 'CHANGE_INSURED_FORM_ATTR';

// payment methods
var FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';
var SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD';

// credit card
var SELECT_CREDITCARD_BRAND = 'SELECT_CREDITCARD_BRAND';
var SELECT_CREDITCARD_PARCEL = 'SELECT_CREDITCARD_PARCEL';
var CHANGE_CREDITCARD_ATTR = 'CHANGE_CREDITCARD_ATTR';

// boleto
var CHANGE_BOLETO_ATTR = 'CHANGE_BOLETO_ATTR';

// cash transfer
var SELECT_BANK = 'SELECT_BANK';
var CHANGE_SAFETYPAY_ATTR = 'CHANGE_SAFETYPAY_ATTR';

// cash
var CHANGE_CASH_ATTR = 'CHANGE_CASH_ATTR';

// pix
var CHANGE_PIX_ATTR = 'CHANGE_PIX_ATTR';

// contact form
var CHANGE_CONTACT_ATTR = 'CHANGE_CONTACT_ATTR';

// accept terms
var TOGGLE_ACCEPT_TERMS = 'TOGGLE_ACCEPT_TERMS';

// benefits
var FETCH_BENEFITS_METHODS = 'FETCH_BENEFITS_METHODS';
var FINISH_PURCHASE = 'FINISH_PURCHASE';

// clean cookies
var CLEAN_COOKIES = 'CLEAN_COOKIES';
var SET_PURCHASE_UUID = 'SET_PURCHASE_UUID';
var VALIDATE_PURCHASE = 'VALIDATE_PURCHASE';
var FETCH_ADDRESS = 'FETCH_ADDRESS';
var CLEAR_ALERTS = 'CLEAR_ALERTS';
var START_PURCHASE_LOADING = 'START_PURCHASE_LOADING';
var END_PURCHASE_LOADING = 'END_PURCHASE_LOADING';
var FETCH_PURCHASE_DATA = 'FETCH_PURCHASE_DATA';
// #endregion

// #region PURCHASE_STATUS
var FETCH_PURCHASE_STATUS = 'FETCH_PURCHASE_STATUS';
// #endregion

// #region GENERAL
var FETCH_PLANS = 'FETCH_PLANS';
var SET_PARTNER = 'SET_PARTNER';
var FETCH_PLANS_SEARCH = 'FETCH_PLANS_SEARCH';
var FETCH_PLANS_PURCHASE = 'FETCH_PLANS_PURCHASE';
var SET_QUOTATION_PARAMS = 'SET_QUOTATION_PARAMS';
var FETCH_PLANS_COVERAGE = 'FETCH_PLANS_COVERAGE';
var FETCH_PLANS_COMPARISON = 'FETCH_PLANS_COMPARISON';
var UPDATE_PURCHASE_SUMMARY = 'UPDATE_PURCHASE_SUMMARY';
// #endregion

// #region MODALS
// purchase
var OPEN_MODAL_EMAIL = 'OPEN_MODAL_EMAIL';
var CLOSE_MODAL_EMAIL = 'CLOSE_MODAL_EMAIL';
var OPEN_DETAIL_MODAL = 'OPEN_DETAIL_MODAL';
var CLOSE_DETAIL_MODAL = 'CLOSE_DETAIL_MODAL';
var OPEN_MODAL_FRANCHISE = 'OPEN_MODAL_FRANCHISE';
var CLOSE_MODAL_FRANCHISE = 'CLOSE_MODAL_FRANCHISE';
var OPEN_MODAL_OPERATOR_CONFIRMATION = 'OPEN_MODAL_OPERATOR_CONFIRMATION';
var CLOSE_MODAL_OPERATOR_CONFIRMATION = 'CLOSE_MODAL_OPERATOR_CONFIRMATION';
var OPEN_MODAL_FILTER_CATEGORY = 'OPEN_MODAL_FILTER_CATEGORY';
var CLOSE_MODAL_FILTER_CATEGORY = 'CLOSE_MODAL_FILTER_CATEGORY';
var OPEN_MODAL_STUDENT = 'OPEN_MODAL_STUDENT';
var CLOSE_MODAL_STUDENT = 'CLOSE_MODAL_STUDENT';
var OPEN_MODAL_SAFETYPAY = 'OPEN_MODAL_SAFETYPAY';
var CLOSE_MODAL_SAFETYPAY = 'CLOSE_MODAL_SAFETYPAY';
var OPEN_MODAL_TERMS_OF_USE = 'OPEN_MODAL_TERMS_OF_USE';
var CLOSE_MODAL_TERMS_OF_USE = 'CLOSE_MODAL_TERMS_OF_USE';
var OPEN_MODAL_PURCHASE_ERROR = 'OPEN_MODAL_PURCHASE_ERROR';
var CLOSE_MODAL_PURCHASE_ERROR = 'CLOSE_MODAL_PURCHASE_ERROR';
var OPEN_MODAL_COUPON_ERROR = 'OPEN_MODAL_COUPON_ERROR';
var CLOSE_MODAL_COUPON_ERROR = 'CLOSE_MODAL_COUPON_ERROR';
var OPEN_MODAL_PURCHASE_DATE_ERROR = 'OPEN_MODAL_PURCHASE_DATE_ERROR';
var CLOSE_MODAL_PURCHASE_DATE_ERROR = 'CLOSE_MODAL_PURCHASE_DATE_ERROR';
var OPEN_MODAL_GENERIC_ERROR = 'OPEN_MODAL_GENERIC_ERROR';
var CLOSE_MODAL_GENERIC_ERROR = 'CLOSE_MODAL_GENERIC_ERROR';
var OPEN_MODAL_TRAVEL_RENEWAL = 'OPEN_MODAL_TRAVEL_RENEWAL';
var CLOSE_MODAL_TRAVEL_RENEWAL = 'CLOSE_MODAL_TRAVEL_RENEWAL';
var OPEN_MODAL_RENEWAL_FRANCHISE = 'OPEN_MODAL_RENEWAL_FRANCHISE';
var CLOSE_MODAL_RENEWAL_FRANCHISE = 'CLOSE_MODAL_RENEWAL_FRANCHISE';
var OPEN_MODAL_RECEPTIVE_PRODUCT = 'OPEN_MODAL_RECEPTIVE_PRODUCT';
var CLOSE_MODAL_RECEPTIVE_PRODUCT = 'CLOSE_MODAL_RECEPTIVE_PRODUCT';
var OPEN_MODAL_PLAN_RULES = 'OPEN_MODAL_PLAN_RULES';
var CLOSE_MODAL_PLAN_RULES = 'CLOSE_MODAL_PLAN_RULES';
var OPEN_MODAL_FAIL_PAYMENT = 'OPEN_MODAL_FAIL_PAYMENT';
var CLOSE_MODAL_FAIL_PAYMENT = 'CLOSE_MODAL_FAIL_PAYMENT';
var SET_OPERATOR_CONFIRMATION_CLICKED = 'SET_OPERATOR_CONFIRMATION_CLICKED';
// #endregion

var OPEN_MODAL_NOT_COVID_COVERAGE = 'OPEN_MODAL_NOT_COVID_COVERAGE';
var CLOSE_MODAL_NOT_COVID_COVERAGE = 'CLOSE_MODAL_NOT_COVID_COVERAGE';
var SHOW_INVALID_CREDIT_CARD_ERROR = 'SHOW_INVALID_CREDIT_CARD_ERROR';
var HIDE_INVALID_CREDIT_CARD_ERROR = 'HIDE_INVALID_CREDIT_CARD_ERROR';
// #endregion

var SET_USER_DETAILS = 'SET_USER_DETAILS';

// change confirm terms in purchase
var CHANGE_CONFIRM_TERMS = 'CHANGE_CONFIRM_TERMS';

// clean errors
var CLEAN_ERRORS = 'CLEAN_ERRORS';

// version mobile
var ACCESS_IS_MOBILE = 'ACCESS_IS_MOBILE';
var NEXT_STAGE_PURCHASE_MOBILE = 'NEXT_STAGE_PURCHASE_MOBILE';
var STAGE_PAYMENT_CREDIT_CARD = 'STAGE_PAYMENT_CREDIT_CARD';
var STAGE_PAYMENT_CASH_TRANSFER = 'STAGE_PAYMENT_CASH_TRANSFER';
var EDIT_PURCHASE = 'EDIT_PURCHASE';
var SELECT_PAYMENT_ALTER_STATE = 'SELECT_PAYMENT_ALTER_STATE';
var BACK_STAGE_PURCHASE = 'BACK_STAGE_PURCHASE';
var BACK_STAGE_PAYMENT_METHOD = 'BACK_STAGE_PAYMENT_METHOD';
var CLEAN_STATES_PURCHASE_MOBILE = 'CLEAN_STATES_PURCHASE_MOBILE';
var VALIDATOR_HANDLER_BLUR = 'VALIDATOR_HANDLER_BLUR';
var GET_INFOS_PROSPECT = 'GET_INFOS_PROSPECT';
var SET_INFOS_PROSPECT_IN_PURCHASE = 'SET_INFOS_PROSPECT_IN_PURCHASE';
var CLEAR_INFOS_PROSPECT = 'CLEAR_INFOS_PROSPECT';
var GET_INFOS_INSUREDS = 'GET_INFOS_INSUREDS';

// Common types
var OPEN_MODAL_QUOTATION_DATE_WARNING = 'OPEN_MODAL_QUOTATION_DATE_WARNING';
var CLOSE_MODAL_QUOTATION_DATE_WARNING = 'CLOSE_MODAL_QUOTATION_DATE_WARNING';
var OPEN_MODAL_QUOTATION_DATE_YEAR = 'OPEN_MODAL_QUOTATION_DATE_YEAR';
var CLOSE_MODAL_QUOTATION_DATE_YEAR = 'CLOSE_MODAL_QUOTATION_DATE_YEAR';
var OPEN_MODAL_WITHOUT_TRACKER = 'OPEN_MODAL_WITHOUT_TRACKER';
var CLOSE_MODAL_WITHOUT_TRACKER = 'CLOSE_MODAL_WITHOUT_TRACKER';

// tracker modal
var SET_TRACKER_INFOS_PROSPECT = 'SET_TRACKER_INFOS_PROSPECT';
var TRACKER_MODAL_VALIDATOR_HANDLER_BLUR = 'TRACKER_MODAL_VALIDATOR_HANDLER_BLUR';
var VALIDATE_TRACKER_MODAL_REDIRECT = 'VALIDATE_TRACKER_MODAL_REDIRECT';
var SET_BENEFITS = 'SET_BENEFITS';

// Ecommerce settings
var SEARCH_ECOMMERCE_SETTINGS = "SEARCH_ECOMMERCE_SETTINGS";
var SEARCH_PROVIDER_SETTINGS = "SEARCH_PROVIDER_SETTINGS";

// DESTINATIONS
var GLOBAL_DESTINATIONS = "GLOBAL_DESTINATIONS";
var GLOBAL_PROVIDER_SETGINGS = "GLOBAL_PROVIDER_SETGINGS";

// Payment methods
var PURCHASE_GET_PAYMENT_METHODS = "PURCHASE_GET_PAYMENT_METHODS";
var STORE_HIGHLIGTH_PLANS = "STORE_HIGHLIGTH_PLANS";
var TOGGLE_SPECIALIST_SUGGESTION = "TOGGLE_SPECIALIST_SUGGESTION";
var OPEN_MODAL_UPSELL = "OPEN_MODAL_UPSELL";
var CLOSE_MODAL_UPSELL = "CLOSE_MODAL_UPSELL";
var SET_UPSELL_PLANS = "SET_UPSELL_PLANS";
var SET_UPSELL_SOURCE_TAGS = "SET_UPSELL_SOURCE_TAGS";
var SET_UPSELL_PURCHASE = "SET_UPSELL_PURCHASE";

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable jsx-a11y/href-no-hash */
var matomoTracker = {
  _growthbookInstance: null,
  _lastFilterState: null,
  // Cache para evitar disparos duplicados

  /**
   * Define a instância do GrowthBook para que o tracker possa acessar os experimentos ativos.
   * Deve ser chamado uma vez após a inicialização do GrowthBook.
   * @param {GrowthBook} gbInstance - A instância do GrowthBook.
   */
  setGrowthbookInstance: function setGrowthbookInstance(gbInstance) {
    matomoTracker._growthbookInstance = gbInstance;
  },
  /**
   * Adiciona as custom dimensions do GrowthBook ao _paq antes de cada evento.
   * Assume que as Custom Dimensions 1 e 2 estão configuradas no Matomo para:
   * CD1: Nome do Experimento (Escopo: Ação)
   * CD2: Variante do Experimento (Escopo: Ação)
   * Captura experimentos ativos, incluindo aqueles dentro de Feature Flags.
   * No seu caso, a flag "SP-Fluxo_de_compra" contém o experimento "Fluxo_de_compra_EXP".
   */
  _addGrowthbookExperimentContext: function _addGrowthbookExperimentContext() {
    if (window._paq && matomoTracker._growthbookInstance) {
      // 1. Verifica experimentos diretos
      var experiments = matomoTracker._growthbookInstance.getExperiments();
      experiments.forEach(function (exp) {
        var result = matomoTracker._growthbookInstance.run(exp);
        if (result.inExperiment) {
          window._paq.push(['setCustomDimension', 1, exp.key]);
          window._paq.push(['setCustomDimension', 2, result.variationId]);
        }
      });

      // 2. Verifica experimentos vinculados a Feature Flags (como o seu SP-Fluxo_de_compra)
      // O GrowthBook armazena os resultados das flags avaliadas
      var features = matomoTracker._growthbookInstance.getFeatures();
      Object.keys(features).forEach(function (key) {
        var result = matomoTracker._growthbookInstance.evalFeature(key);
        // Se a flag disparou um experimento (tem experimentResult)
        if (result.experimentResult && result.experimentResult.inExperiment) {
          var expName = result.experimentResult.name || result.experimentResult.key;
          window._paq.push(['setCustomDimension', 1, expName]); // Ex: Fluxo_de_compra_EXP
          window._paq.push(['setCustomDimension', 2, result.experimentResult.variationId]); // Ex: 0 ou 1
        }
      });
    }
  },
  /**
   * Limpa as custom dimensions do GrowthBook após cada evento.
   */
  _clearGrowthbookExperimentContext: function _clearGrowthbookExperimentContext() {
    if (window._paq) {
      window._paq.push(['deleteCustomDimension', 1]);
      window._paq.push(['deleteCustomDimension', 2]);
    }
  },
  /**
   * Rastreia um evento customizado.
   */

  trackEvent: function trackEvent(category, action, name, value) {
    if (window._paq) {
      matomoTracker._addGrowthbookExperimentContext();
      window._paq.push(['trackEvent', category, action, name, value]);
      matomoTracker._clearGrowthbookExperimentContext();
    }
  },
  /**
   * Rastreia visualização de página (SPA).
   */
  trackPageView: function trackPageView(customTitle) {
    if (window._paq) {
      matomoTracker._addGrowthbookExperimentContext();
      window._paq.push(["setCustomUrl", window.location.pathname + window.location.search]);
      window._paq.push(['setDocumentTitle', customTitle || document.title]);
      window._paq.push(['trackPageView']);
      matomoTracker._clearGrowthbookExperimentContext();
    }
  },
  /**
   * Define o ID do usuário no Matomo.
   * @param {string} userId - O ID do usuário logado.
   */
  setUserId: function setUserId(userId) {
    if (window._paq) {
      window._paq.push(['setUserId', userId]);
    }
  },
  /**
   * Retorna o ID do visitante do Matomo (Promise).
   */
  getMatomoVisitorId: function getMatomoVisitorId() {
    return new Promise(function (resolve) {
      if (window._paq) {
        window._paq.push([function () {
          resolve(this.getVisitorId());
        }]);
      } else {
        resolve(null);
      }
    });
  },
  /**
   * 1. Visualização de Plano (Product View)
   * Chamado quando o usuário vê os detalhes de um plano ou a lista de resultados.
   * Push estruturado para MTM data layer com evento 'view_item'
   * @param {Object} plan - Objeto com dados do plano (ex: { sku: 'MTA60', name: 'MTA 60 Am. Latina', category: 'América do Sul', price: 284.99 })
   */
  setPlanView: function setPlanView(plan) {
    if (window._paq) {
      matomoTracker._addGrowthbookExperimentContext();
      window._paq.push({
        'event': 'view_item',
        'ecommerce': {
          'items': [{
            'item_id': String(plan.sku) || null,
            // Product ID/SKU
            'item_name': plan.name,
            // Product Name
            'item_category': plan.category,
            // Product Category
            'item_price': parseFloat(plan.price) || null // Product Price
          }]
        }
      });
      matomoTracker._clearGrowthbookExperimentContext();
    }
  },
  /**
   * 2. Seleção de Plano (Add to Cart)
   * Chamado quando o usuário clica em "Selecionar Plano".
   * Push estruturado para MTM data layer com evento 'add_to_cart'
   * @param {Object} plan - Dados do plano selecionado.
   * @param {number} quantity - Número de segurados.
   */
  addPlanToCart: function addPlanToCart(plan) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    if (window._paq) {
      matomoTracker._addGrowthbookExperimentContext();
      var cartTotal = parseFloat(plan.price) * parseInt(quantity, 10);
      window._paq.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'items': [{
            'item_id': String(plan.sku) || null,
            // Product SKU/ID (required)
            'item_name': plan.name,
            // Product Name (optional)
            'item_category': plan.category,
            // Product Category (optional)
            'item_price': parseFloat(plan.price) || 0,
            // Product Price (recommended)
            'quantity': parseInt(quantity, 10) || 1 // Quantity (optional)
          }],
          'total': cartTotal // Cart total
        }
      });
      matomoTracker._clearGrowthbookExperimentContext();
    }
  },
  /**
   * 3. Finalização de Compra (Ecommerce Order)
   * Chamado na página de confirmação de pagamento.
   * Push estruturado para MTM data layer com evento 'purchase'
   * @param {Object} order - Dados da reserva (id, total, etc).
   * @param {Array} items - Lista de planos/insureds incluídos.
   */
  trackOrder: function trackOrder(order, items) {
    if (window._paq) {
      matomoTracker._addGrowthbookExperimentContext();

      // Formata os itens no padrão ecommerce.items
      var formattedItems = items.map(function (item) {
        return {
          'item_id': String(item.sku) || null,
          'item_name': item.name,
          'item_category': item.category || null,
          'item_price': parseFloat(item.price) || 0,
          'quantity': parseInt(item.quantity, 10) || 1
        };
      });
      window._paq.push({
        'event': 'purchase',
        'ecommerce': {
          'purchase': {
            'id': String(order.id),
            // Order ID (required)
            'revenue': parseFloat(order.grandTotal) || 0,
            // Grand Total (required)
            'orderSubTotal': parseFloat(order.subTotal) || 0,
            // Sub Total (optional)
            'tax': parseFloat(order.tax) || 0,
            // Tax (optional)
            'shipping': parseFloat(order.shipping) || 0,
            // Shipping (optional)
            'discount': parseFloat(order.discount) || 0 // Discount (optional)
          },
          'items': formattedItems
        }
      });
      matomoTracker._clearGrowthbookExperimentContext();
    }
  },
  /**
   * 4. Eventos de Funil Específicos (Lead Generation)
   * Rastreia interações importantes que não são venda direta.
   */
  trackSearch: function trackSearch(destination, startDate, daysInAdvance) {
    matomoTracker._addGrowthbookExperimentContext();
    matomoTracker.trackEvent('Funnel', 'Search', "".concat(destination, " | ").concat(startDate, " | ").concat(daysInAdvance, "advp"));
    matomoTracker._clearGrowthbookExperimentContext();
  },
  trackComparison: function trackComparison(planNames) {
    matomoTracker._addGrowthbookExperimentContext();
    matomoTracker.trackEvent('Funnel', 'ComparePlans', planNames.join(' vs '));
    matomoTracker._clearGrowthbookExperimentContext();
  },
  /**
   * Rastreia a aplicação de filtros na tela de resultados.
   * Evita disparos duplicados verificando se o estado mudou.
   * @param {Object} filters - Objeto contendo os filtros aplicados (ex: { providers: ['Affinity'], coverage: 100000, benefits: ['Gestante'] })
   * @param {number} resultsCount - Quantidade de planos encontrados após o filtro.
   */
  trackFilters: function trackFilters(filters, resultsCount) {
    if (window._paq) {
      // Cria um hash do estado atual para comparação
      var currentState = JSON.stringify({
        filters: filters,
        resultsCount: resultsCount
      });

      // Só dispara se o estado mudou
      if (matomoTracker._lastFilterState === currentState) {
        return; // Evita disparo duplicado
      }

      // Atualiza o cache do último estado
      matomoTracker._lastFilterState = currentState;
      matomoTracker._addGrowthbookExperimentContext();

      // Transforma o objeto de filtros em uma string legível para o Matomo
      var filterLabels = [];
      if (filters.providers && filters.providers.length > 0) filterLabels.push("Seguradoras: ".concat(filters.providers.join(',')));
      if (filters.coverage) filterLabels.push("Cobertura: ".concat(filters.coverage));
      if (filters.benefits && filters.benefits.length > 0) filterLabels.push("Benef\xEDcios: ".concat(filters.benefits.join(',')));
      var label = filterLabels.join(' | ') || 'Nenhum filtro';

      // Rastreia como um evento de interação
      window._paq.push(["trackEvent", "Search", "ApplyFilter", label, resultsCount]);
      matomoTracker._clearGrowthbookExperimentContext();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (matomoTracker);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ErrorMessage = /*#__PURE__*/function (_Component) {
  function ErrorMessage(props) {
    _classCallCheck(this, ErrorMessage);
    return _callSuper(this, ErrorMessage, [props]);
  }
  _inherits(ErrorMessage, _Component);
  return _createClass(ErrorMessage, [{
    key: "getMessage",
    value: function getMessage() {
      var message = '';
      if (this.props.field3) try {
        message = this.props.errors[this.props.field1][this.props.field2][this.props.field3];
      } catch (e) {
        message = false;
      } else if (this.props.field2) try {
        message = this.props.errors[this.props.field1][this.props.field2];
      } catch (e) {
        message = false;
      } else if (this.props.field1) try {
        message = this.props.errors[this.props.field1];
      } catch (e) {
        message = false;
      }
      return message;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.getMessage()) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          id: this.props.anchor
        });
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "error-message-div ".concat(this.props.className ? this.props.className : "")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        id: this.props.anchor,
        style: {
          color: 'red',
          fontSize: '12px',
          textDecoration: this.props.textDecoration
        },
        title: this.props.title
      }, this.getMessage()));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    errors: state.purchase.errors
  };
}, {})(ErrorMessage)));

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendToRDStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getProductPurchaseUrl; });
/* harmony export (immutable) */ __webpack_exports__["e"] = insertTagPurchaseUrl;
/* unused harmony export isPlanDisabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductPlanUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return selectPlanAndRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcCouponDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return maxValueParcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isBenefitIncluded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasBenefitCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataLayer__ = __webpack_require__(7);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


var basePathPurchase = '/pedido';
var sendToRDStation = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var lead_mail, lead_name, cookies, _i, _Object$entries, _Object$entries$_i, key, value, response, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          lead_name = '';
          cookies = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getAllCookies"])();
          for (_i = 0, _Object$entries = Object.entries(cookies); _i < _Object$entries.length; _i++) {
            _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
            if (key.trim() === 'LeadEmail') {
              lead_mail = decodeURIComponent(value);
            }
            if (key.trim() === 'LeadName') {
              lead_name = decodeURIComponent(value);
            }
          }
          _context.n = 1;
          return fetch('https://www.rdstation.com.br/api/1.3/conversions', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              token_rdstation: '904297ddf27aa488461f1936e94791d6',
              identificador: 'spctaselecionarseguro',
              email: lead_mail,
              nome: lead_name
            })
          });
        case 1:
          response = _context.v;
          if (!response.ok) {
            _context.n = 3;
            break;
          }
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          console.log('Response Data:', data);
          console.log('Success!');
          _context.n = 4;
          break;
        case 3:
          console.log('Error: ', response.statusText);
        case 4:
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error('Fetch Error:', _t);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[0, 5]]);
  }));
  return function sendToRDStation() {
    return _ref.apply(this, arguments);
  };
}();
var getProductPurchaseUrl = function getProductPurchaseUrl(match, code) {
  var newUrl = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["formatURL"])(match.params, "".concat(basePathPurchase, "/").concat(code, "/").concat(match.params.destination, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["cleanDate"])(match.params.begin_date), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["cleanDate"])(match.params.end_date), "/"));
  return newUrl;
};
function insertTagPurchaseUrl(url, newTag) {
  var _url$split = url.split('?'),
    _url$split2 = _slicedToArray(_url$split, 2),
    base = _url$split2[0],
    query = _url$split2[1];
  var params = new URLSearchParams(query || '');
  var tags = params.getAll('tag');
  if (newTag) tags.push(newTag);
  params["delete"]('tag');
  var otherQuery = params.toString();
  if (tags.length) {
    var uniqueTags = Array.from(new Set(tags));
    var tagStr = "tag=".concat(uniqueTags.join(','));
    return "".concat(base, "?").concat(otherQuery ? otherQuery + '&' : '').concat(tagStr);
  }
  return "".concat(base, "?").concat(otherQuery);
}
var isPlanDisabled = function isPlanDisabled(match, userDetails) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isSameDaySearch"])(match.params.begin_date) && !userDetails.operator_permissions;
};
var getProductPlanUrl = function getProductPlanUrl(match, code) {
  var basePath = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isB2b"])() ? '/seguro-viagem/cobertura-b2b' : '/seguro-viagem/cobertura';
  var newUrl = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["formatURL"])(match.params, "".concat(basePath, "/").concat(code, "/").concat(match.params.destination, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["cleanDate"])(match.params.begin_date), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["cleanDate"])(match.params.end_date), "/"));
  return newUrl;
};
var selectPlanAndRedirect = function selectPlanAndRedirect(productPurchaseUrl) {
  __WEBPACK_IMPORTED_MODULE_1__dataLayer__["a" /* default */].raw({
    event: 'page_pedido'
  });
  window.location.href = productPurchaseUrl;
};
var calcCouponDiscount = function calcCouponDiscount(plan, coupon) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getProductDiscount"])(plan.price.adult.price, plan.code, coupon);
};
var maxValueParcel = function maxValueParcel(price) {
  var MAX_PARCELS = 12;
  var MIN_PARCEL_VALUE = 30.0;
  var parcels = Math.min(Math.floor(price / MIN_PARCEL_VALUE), MAX_PARCELS);
  return parcels;
};
var isBenefitIncluded = function isBenefitIncluded(benefit) {
  var coverage = (benefit && benefit.coverage || '').toString().trim().toUpperCase();
  var _coverage$split$map = coverage.split('|').map(function (part) {
      return part.trim();
    }),
    _coverage$split$map2 = _slicedToArray(_coverage$split$map, 1),
    prefix = _coverage$split$map2[0];
  return prefix === 'SIM' || prefix === 'INCLUSO';
};
var hasBenefitCode = function hasBenefitCode(plan, code) {
  return (plan && plan.benefits || []).some(function (benefit) {
    return (benefit.code === code || benefit.code === Number(code)) && isBenefitIncluded(benefit);
  });
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchProductCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openCoverageAccordion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openModalQuotationDateWarning; });
/* unused harmony export closeModalQuotationDateWarning */
/* unused harmony export setUserDetails */
/* unused harmony export setInfosProspect */
/* unused harmony export openModalQuotationDateYear */
/* unused harmony export closeModalQuotationDateYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);

var getProductInfo = function getProductInfo(productInfo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_16" /* GET_PRODUCT_INFO */],
    productInfo: productInfo
  };
};
var fetchProductCoverage = function fetchProductCoverage(productCoverage) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_8" /* FETCH_PRODUCT_COVERAGE */],
    productCoverage: productCoverage
  };
};
var openCoverageAccordion = function openCoverageAccordion(code) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_22" /* OPEN_COVERAGE_ACCORDION */],
    code: code
  };
};
var openModalQuotationDateWarning = function openModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var closeModalQuotationDateWarning = function closeModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var setUserDetails = function setUserDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_74" /* SET_USER_DETAILS */],
    userDetails: data.user_details
  };
};
var setInfosProspect = function setInfosProspect(infos) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_15" /* GET_INFOS_PROSPECT */],
    infos: infos
  };
};
var openModalQuotationDateYear = function openModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]
  };
};
var closeModalQuotationDateYear = function closeModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]
  };
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getPolyfills;
/* harmony export (immutable) */ __webpack_exports__["i"] = hash;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEqualWeights;
/* harmony export (immutable) */ __webpack_exports__["k"] = inRange;
/* harmony export (immutable) */ __webpack_exports__["j"] = inNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = chooseVariation;
/* harmony export (immutable) */ __webpack_exports__["h"] = getUrlRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isURLTargeted;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBucketRanges;
/* harmony export (immutable) */ __webpack_exports__["g"] = getQueryStringOverride;
/* harmony export (immutable) */ __webpack_exports__["l"] = isIncluded;
/* harmony export (immutable) */ __webpack_exports__["b"] = decrypt;
/* harmony export (immutable) */ __webpack_exports__["r"] = toString;
/* harmony export (immutable) */ __webpack_exports__["p"] = paddedVersionString;
/* harmony export (immutable) */ __webpack_exports__["n"] = loadSDKVersion;
/* harmony export (immutable) */ __webpack_exports__["o"] = mergeQueryStrings;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAutoExperimentChangeType;
/* harmony export (immutable) */ __webpack_exports__["q"] = promiseTimeout;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
function getPolyfills() {
  return polyfills;
}
function hashFnv32a(str) {
  var hval = 0x811c9dc5;
  var l = str.length;
  for (var i = 0; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
function hash(seed, value, version) {
  // New unbiased hashing algorithm
  if (version === 2) {
    return hashFnv32a(hashFnv32a(seed + value) + "") % 10000 / 10000;
  }
  // Original biased hashing algorithm (keep for backwards compatibility)
  if (version === 1) {
    return hashFnv32a(value + seed) % 1000 / 1000;
  }

  // Unknown hash version
  return null;
}
function getEqualWeights(n) {
  if (n <= 0) return [];
  return new Array(n).fill(1 / n);
}
function inRange(n, range) {
  return n >= range[0] && n < range[1];
}
function inNamespace(hashValue, namespace) {
  var n = hash("__" + namespace[0], hashValue, 1);
  if (n === null) return false;
  return n >= namespace[1] && n < namespace[2];
}
function chooseVariation(n, ranges) {
  for (var i = 0; i < ranges.length; i++) {
    if (inRange(n, ranges[i])) {
      return i;
    }
  }
  return -1;
}
function getUrlRegExp(regexString) {
  try {
    var escaped = regexString.replace(/([^\\])\//g, "$1\\/");
    return new RegExp(escaped);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
function isURLTargeted(url, targets) {
  if (!targets.length) return false;
  var hasIncludeRules = false;
  var isIncluded = false;
  for (var i = 0; i < targets.length; i++) {
    var match = _evalURLTarget(url, targets[i].type, targets[i].pattern);
    if (targets[i].include === false) {
      if (match) return false;
    } else {
      hasIncludeRules = true;
      if (match) isIncluded = true;
    }
  }
  return isIncluded || !hasIncludeRules;
}
function _evalSimpleUrlPart(actual, pattern, isPath) {
  try {
    // Escape special regex characters and change wildcard `_____` to `.*`
    var escaped = pattern.replace(/[*.+?^${}()|[\]\\]/g, "\\$&").replace(/_____/g, ".*");
    if (isPath) {
      // When matching pathname, make leading/trailing slashes optional
      escaped = "\\/?" + escaped.replace(/(^\/|\/$)/g, "") + "\\/?";
    }
    var regex = new RegExp("^" + escaped + "$", "i");
    return regex.test(actual);
  } catch (e) {
    return false;
  }
}
function _evalSimpleUrlTarget(actual, pattern) {
  try {
    // If a protocol is missing, but a host is specified, add `https://` to the front
    // Use "_____" as the wildcard since `*` is not a valid hostname in some browsers
    var expected = new URL(pattern.replace(/^([^:/?]*)\./i, "https://$1.").replace(/\*/g, "_____"), "https://_____");

    // Compare each part of the URL separately
    var comps = [[actual.host, expected.host, false], [actual.pathname, expected.pathname, true]];
    // We only want to compare hashes if it's explicitly being targeted
    if (expected.hash) {
      comps.push([actual.hash, expected.hash, false]);
    }
    expected.searchParams.forEach(function (v, k) {
      comps.push([actual.searchParams.get(k) || "", v, false]);
    });

    // If any comparisons fail, the whole thing fails
    return !comps.some(function (data) {
      return !_evalSimpleUrlPart(data[0], data[1], data[2]);
    });
  } catch (e) {
    return false;
  }
}
function _evalURLTarget(url, type, pattern) {
  try {
    var parsed = new URL(url, "https://_");
    if (type === "regex") {
      var regex = getUrlRegExp(pattern);
      if (!regex) return false;
      return regex.test(parsed.href) || regex.test(parsed.href.substring(parsed.origin.length));
    } else if (type === "simple") {
      return _evalSimpleUrlTarget(parsed, pattern);
    }
    return false;
  } catch (e) {
    return false;
  }
}
function getBucketRanges(numVariations, coverage, weights) {
  coverage = coverage === undefined ? 1 : coverage;

  // Make sure coverage is within bounds
  if (coverage < 0) {
    if (false) {
      console.error("Experiment.coverage must be greater than or equal to 0");
    }
    coverage = 0;
  } else if (coverage > 1) {
    if (false) {
      console.error("Experiment.coverage must be less than or equal to 1");
    }
    coverage = 1;
  }

  // Default to equal weights if missing or invalid
  var equal = getEqualWeights(numVariations);
  weights = weights || equal;
  if (weights.length !== numVariations) {
    if (false) {
      console.error("Experiment.weights array must be the same length as Experiment.variations");
    }
    weights = equal;
  }

  // If weights don't add up to 1 (or close to it), default to equal weights
  var totalWeight = weights.reduce(function (w, sum) {
    return sum + w;
  }, 0);
  if (totalWeight < 0.99 || totalWeight > 1.01) {
    if (false) {
      console.error("Experiment.weights must add up to 1");
    }
    weights = equal;
  }

  // Convert weights to ranges
  var cumulative = 0;
  return weights.map(function (w) {
    var start = cumulative;
    cumulative += w;
    return [start, start + coverage * w];
  });
}
function getQueryStringOverride(id, url, numVariations) {
  if (!url) {
    return null;
  }
  var search = url.split("?")[1];
  if (!search) {
    return null;
  }
  var match = search.replace(/#.*/, "") // Get rid of anchor
  .split("&") // Split into key/value pairs
  .map(function (kv) {
    return kv.split("=", 2);
  }).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      k = _ref2[0];
    return k === id;
  }) // Look for key that matches the experiment id
  .map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      v = _ref4[1];
    return parseInt(v);
  }); // Parse the value into an integer

  if (match.length > 0 && match[0] >= 0 && match[0] < numVariations) return match[0];
  return null;
}
function isIncluded(include) {
  try {
    return include();
  } catch (e) {
    console.error(e);
    return false;
  }
}
var base64ToBuf = function base64ToBuf(b) {
  return Uint8Array.from(atob(b), function (c) {
    return c.charCodeAt(0);
  });
};
function decrypt(_x, _x2, _x3) {
  return _decrypt.apply(this, arguments);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _decrypt() {
  _decrypt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(encryptedString, decryptionKey, subtle) {
    var key, _encryptedString$spli, _encryptedString$spli2, iv, cipherText, plainTextBuffer, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          decryptionKey = decryptionKey || "";
          subtle = subtle || globalThis.crypto && globalThis.crypto.subtle || polyfills.SubtleCrypto;
          if (subtle) {
            _context.n = 1;
            break;
          }
          throw new Error("No SubtleCrypto implementation found");
        case 1:
          _context.p = 1;
          _context.n = 2;
          return subtle.importKey("raw", base64ToBuf(decryptionKey), {
            name: "AES-CBC",
            length: 128
          }, true, ["encrypt", "decrypt"]);
        case 2:
          key = _context.v;
          _encryptedString$spli = encryptedString.split("."), _encryptedString$spli2 = _slicedToArray(_encryptedString$spli, 2), iv = _encryptedString$spli2[0], cipherText = _encryptedString$spli2[1];
          _context.n = 3;
          return subtle.decrypt({
            name: "AES-CBC",
            iv: base64ToBuf(iv)
          }, key, base64ToBuf(cipherText));
        case 3:
          plainTextBuffer = _context.v;
          return _context.a(2, new TextDecoder().decode(plainTextBuffer));
        case 4:
          _context.p = 4;
          _t = _context.v;
          throw new Error("Failed to decrypt");
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[1, 4]]);
  }));
  return _decrypt.apply(this, arguments);
}
function toString(input) {
  if (typeof input === "string") return input;
  return JSON.stringify(input);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function paddedVersionString(input) {
  if (typeof input === "number") {
    input = input + "";
  }
  if (!input || typeof input !== "string") {
    input = "0";
  }
  // Remove build info and leading `v` if any
  // Split version into parts (both core version numbers and pre-release tags)
  // "v1.2.3-rc.1+build123" -> ["1","2","3","rc","1"]
  var parts = input.replace(/(^v|\+.*$)/g, "").split(/[-.]/);

  // If it's SemVer without a pre-release, add `~` to the end
  // ["1","0","0"] -> ["1","0","0","~"]
  // "~" is the largest ASCII character, so this will make "1.0.0" greater than "1.0.0-beta" for example
  if (parts.length === 3) {
    parts.push("~");
  }

  // Left pad each numeric part with spaces so string comparisons will work ("9">"10", but " 9"<"10")
  // Then, join back together into a single string
  return parts.map(function (v) {
    return v.match(/^[0-9]+$/) ? v.padStart(5, " ") : v;
  }).join("-");
}
function loadSDKVersion() {
  var version;
  try {
    // @ts-expect-error right-hand value to be replaced by build with string literal
    version = "1.8.0";
  } catch (e) {
    version = "";
  }
  return version;
}
function mergeQueryStrings(oldUrl, newUrl) {
  var currUrl;
  var redirectUrl;
  try {
    currUrl = new URL(oldUrl);
    redirectUrl = new URL(newUrl);
  } catch (e) {
    console.error("Unable to merge query strings: ".concat(e));
    return newUrl;
  }
  currUrl.searchParams.forEach(function (value, key) {
    // skip  if search param already exists in redirectUrl
    if (redirectUrl.searchParams.has(key)) {
      return;
    }
    redirectUrl.searchParams.set(key, value);
  });
  return redirectUrl.toString();
}
function isObj(x) {
  return _typeof(x) === "object" && x !== null;
}
function getAutoExperimentChangeType(exp) {
  if (exp.urlPatterns && exp.variations.some(function (variation) {
    return isObj(variation) && "urlRedirect" in variation;
  })) {
    return "redirect";
  } else if (exp.variations.some(function (variation) {
    return isObj(variation) && (variation.domMutations || "js" in variation || "css" in variation);
  })) {
    return "visual";
  }
  return "unknown";
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
function promiseTimeout(_x4, _x5) {
  return _promiseTimeout.apply(this, arguments);
}
function _promiseTimeout() {
  _promiseTimeout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(promise, timeout) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, new Promise(function (resolve) {
            var resolved = false;
            var timer;
            var finish = function finish(data) {
              if (resolved) return;
              resolved = true;
              timer && clearTimeout(timer);
              resolve(data || null);
            };
            if (timeout) {
              timer = setTimeout(function () {
                return finish();
              }, timeout);
            }
            promise.then(function (data) {
              return finish(data);
            })["catch"](function () {
              return finish();
            });
          }));
      }
    }, _callee2);
  }));
  return _promiseTimeout.apply(this, arguments);
}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(169);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_index__ = __webpack_require__(193);



var paymentMethods = [{
  id: 0,
  available: true,
  name: 'Cartão de Crédito',
  slug: 'credit-card',
  condition: 'sem juros',
  img: 'cartao_verde',
  "class": 'cartao-credito',
  active: false,
  displayOrder: false,
  selected: false,
  discount: 0
}, {
  id: 1,
  available: true,
  name: 'Boleto',
  slug: 'boleto',
  condition: '5% desconto',
  img: 'boleto',
  "class": 'boleto',
  active: false,
  displayOrder: false,
  selected: false,
  discount: 0
}, {
  id: 3,
  available: true,
  name: 'Transferência',
  slug: 'safetypay',
  condition: 'à vista',
  img: 'transferencia',
  "class": 'transferencia',
  active: false,
  displayOrder: false,
  selected: false,
  discount: 0
}, {
  id: 2,
  available: true,
  name: 'Dinheiro',
  slug: 'cash',
  img: 'dinheiro',
  "class": 'transferencia',
  active: false,
  displayOrder: false,
  selected: false,
  discount: 0
}, {
  id: 4,
  available: true,
  deadline: 0,
  name: 'Pix',
  slug: 'pix',
  condition: 'sem juros',
  img: 'pix',
  "class": 'pix',
  active: false,
  displayOrder: false,
  selected: false,
  discount: 0
}];
var sortOptionsData = [{
  name: 'lower-price',
  displayName: 'Menor preço',
  mobile: true
}, {
  name: 'special',
  displayName: 'Custo benefício',
  mobile: true
}, {
  name: 'high-price',
  displayName: 'Maior preço',
  mobile: true
}, {
  name: 'covid_coverage',
  displayName: 'Cobertura covid',
  mobile: true
}];
var errorsDefault = {
  insuredForms: [{
    cpf: false,
    name: false,
    birth_date: false,
    incoming: false
  }],
  paymentMethods: false,
  creditCard: {
    cvv: false,
    number: false,
    parcels: false,
    card_brand: false,
    expiry_year: false,
    holder_name: false,
    holder_cpf: false,
    expiry_month: false
  },
  boleto: {
    name: false,
    cpf: false
  },
  safetypay: {
    cpf: false,
    name: false,
    banks: false,
    agency: false,
    account: false
  },
  cash: {
    holderName: false,
    holderCpf: false
  },
  pix: {
    cpf: false,
    name: false
  },
  coupon: false,
  contact: {
    contact_name: false,
    email: false,
    phone_number: false
  },
  purchase_is_valid: false,
  errorsModalFranchise: false
};
var search = {
  filterCategory: [],
  filterProvider: [],
  plans: [],
  loading: false,
  userDetails: {},
  filtered_plans: [],
  comparisonPlans: [],
  suggestions_plans: [],
  provider_option: '',
  great_for_selected: '',
  providers: [],
  sortOptions: sortOptionsData,
  sort_option: sortOptionsData[1].name,
  searchState: false,
  isModalQuotationDateWarningActive: false,
  prospect: {
    exist: false,
    name: '',
    email: '',
    phone: ''
  },
  isModalQuotationDateYearActive: false,
  isModalWithoutTrackerActive: false,
  isModalFilterCategoryActive: false,
  isModalUpsellActive: false,
  modalProspect: {
    name: '',
    email: '',
    phone: '',
    errors: {
      name: false,
      email: false,
      phone: false,
      isValid: false
    }
  },
  modalProspectAvaliable: false,
  ecommerce_settings: {
    filter: false,
    modalCovid: false,
    disabled_providers: []
  },
  showSpecialistSuggestions: false,
  highlightPlans: [],
  upsellPlans: []
};
var comparison = {
  userDetails: {},
  loading: false,
  emailStatus: '',
  comparisonPlans: [],
  openedBenefitCode: '',
  comparisonPlansInfo: [],
  isModalEmailActive: false,
  emailModal: {
    emailAddress: ''
  },
  emailCollapse: {
    emailAddress: ''
  },
  isModalQuotationDateWarningActive: false,
  prospect: {
    exist: false,
    name: '',
    email: '',
    phone: ''
  },
  isModalQuotationDateYearActive: false
};
var coverage = {
  userDetails: {},
  loading: false,
  productInfo: {},
  productCoverage: {},
  rawProductCoverage: {},
  isModalQuotationDateWarningActive: false,
  prospect: {
    exist: false,
    name: '',
    email: '',
    phone: ''
  },
  isModalQuotationDateYearActive: false
};
var purchase = {
  loading: false,
  status: '',
  plan: {},
  coupon: {
    text: ''
  },
  creditCoupon: {
    code: null,
    creditAmount: 0.0,
    applied: false,
    error: null
  },
  partner: '',
  paymentInfo: {},
  paymentMethods: paymentMethods,
  payments: paymentMethods,
  insuredForms: [{
    id: 0,
    rg: '',
    cpf: '',
    name: '',
    birth_date: '',
    document_type: 'cpf',
    elder: false,
    incoming: ''
  }],
  quotationParams: {
    destination: '',
    return_date: '',
    product_code: '',
    departure_date: '',
    queryParams: ''
  },
  isInsuredFormDeletable: false,
  contact: {
    contact_name: '',
    email: '',
    phone_number: '',
    cep: '',
    city: '',
    state: '',
    number: '',
    address: '',
    district: '',
    complement: ''
  },
  creditCard: {
    cvv: '',
    number: '',
    brands: [],
    parcels: [],
    card_brand: {},
    expiry_year: '',
    available: true,
    holder_cpf: '',
    holder_name: '',
    expiry_month: ''
  },
  boleto: {
    cpf: '',
    name: '',
    available: false
  },
  safetypay: {
    cpf: '',
    name: '',
    agency: '',
    account: '',
    banks: [],
    available: false
  },
  cash: {
    available: false,
    holderName: '',
    holderCpf: ''
  },
  pix: {
    available: false,
    name: '',
    cpf: ''
  },
  acceptedTerms: false,
  dateTimeAccept: '',
  purchaseSummary: {
    total: 0,
    subtotal: 0,
    coupon_discount: 0,
    investmentPerDay: 0,
    adult: {
      qte: 1,
      price: 0
    },
    child: {
      qte: 0,
      price: 0
    },
    elder: {
      qte: 0,
      price: 0
    },
    invalid: {
      qte: 0,
      price: 0
    },
    paymentMethodDiscountValue: 0,
    paymentMethodDiscountPercent: 0,
    paymentMethodSelected: '',
    creditCouponAmountUsed: 0,
    creditCouponRemainingBalance: 0
  },
  uuid: 0,
  alert: '',
  userDetails: {},
  benefits_list: [],
  errors: errorsDefault,
  purchaseIsValid: false,
  isModalNotCovidCoverage: false,
  isModalDetailActive: false,
  isModalFranchiseActive: false,
  isModalSafetypayActive: false,
  isModalTermsOfUseActive: false,
  isModalPurchaseErrorActive: false,
  isModalPurchaseErrorDate: false,
  isModalGenericErrorActive: false,
  isModalTravelRenewalActive: false,
  isModalRenewalFranchiseActive: false,
  isModalReceptiveProductActive: false,
  isInvalidCreditCardErrorVisible: false,
  isModalPlanRulesActive: false,
  isModalFailPayment: false,
  stagePurchase: 1,
  stepDisplayMethodPayment: 0,
  stepDisplayCreditCard: 0,
  stepDisplayCashTransfer: 0,
  stepDisplayBoleto: 0,
  stepDisplayPix: 0,
  stepPaymentFinish: false,
  invalidCreditCard: {
    brand: '',
    lastDigits: ''
  },
  prospect: {
    exist: false,
    name: '',
    email: '',
    phone: ''
  },
  upsellUpgrade: sessionStorage.getItem('upsellUpgrade')
};
var purchaseStatus = {
  id: 0,
  price: 0,
  parcels: 0,
  loading: true,
  status: '',
  insureds: [],
  return_date: '',
  payment_method: '',
  departure_date: ''
};
var mobile = {
  mobileActive: window.innerWidth <= 768 ? true : false
};
var global = {
  loading: false,
  destinations: [],
  providers: [{
    id: 0,
    code: '',
    slug: '',
    name: '',
    logo: '',
    terms_url: ''
  }]
};
var initialState = {
  search: search,
  comparison: comparison,
  coverage: coverage,
  purchase: purchase,
  purchaseStatus: purchaseStatus,
  mobile: mobile,
  global: global
};
var middleware = [__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]];
var compose = function compose(enhancer) {
  return enhancer;
};
var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: 'MyApp',
  actionsBlacklist: ['REDUX_STORAGE_SAVE']
}) : compose;
var enhancer = composeEnhancers(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(void 0, middleware));

// const enhancer = applyMiddleware(...middleware);

var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers_index__["a" /* default */], initialState, enhancer);
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchComparisonProductsCoverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openComparisonAccordion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendingEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendEmailDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendEmailFail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openModalEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closeModalEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeEmailModalAttr; });
/* unused harmony export changeEmailCollapseAttr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return openModalQuotationDateWarning; });
/* unused harmony export closeModalQuotationDateWarning */
/* unused harmony export setUserDetails */
/* unused harmony export setInfosProspect */
/* unused harmony export openModalQuotationDateYear */
/* unused harmony export closeModalQuotationDateYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);

var fetchComparisonProductsCoverage = function fetchComparisonProductsCoverage(plansInfo) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_0" /* FETCH_COMPARISON_PRODUCTS_COVERAGE */],
    plansInfo: plansInfo
  };
};
var openComparisonAccordion = function openComparisonAccordion(code) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_21" /* OPEN_COMPARISON_ACCORDION */],
    code: code
  };
};
var sendingEmail = function sendingEmail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_56" /* SENDING_EMAIL */],
    status: 'sending'
  };
};
var sendEmailDone = function sendEmailDone() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_57" /* SEND_EMAIL_DONE */],
    status: 'done'
  };
};
var sendEmailFail = function sendEmailFail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_58" /* SEND_EMAIL_FAIL */],
    status: 'fail'
  };
};
var openModalEmail = function openModalEmail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_25" /* OPEN_MODAL_EMAIL */]
  };
};
var closeModalEmail = function closeModalEmail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["B" /* CLOSE_MODAL_EMAIL */]
  };
};
var changeEmailModalAttr = function changeEmailModalAttr(_ref) {
  var name = _ref.name,
    value = _ref.value;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["o" /* CHANGE_EMAIL_MODAL_ATTR */],
    name: name,
    value: value
  };
};
var changeEmailCollapseAttr = function changeEmailCollapseAttr(_ref2) {
  var name = _ref2.name,
    value = _ref2.value;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["n" /* CHANGE_EMAIL_COLLAPSE_ATTR */],
    name: name,
    value: value
  };
};
var openModalQuotationDateWarning = function openModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var closeModalQuotationDateWarning = function closeModalQuotationDateWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]
  };
};
var setUserDetails = function setUserDetails(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_74" /* SET_USER_DETAILS */],
    userDetails: data.user_details
  };
};
var setInfosProspect = function setInfosProspect(infos) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_15" /* GET_INFOS_PROSPECT */],
    infos: infos
  };
};
var openModalQuotationDateYear = function openModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]
  };
};
var closeModalQuotationDateYear = function closeModalQuotationDateYear() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]
  };
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDetectClickOutsideElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


// props: { onClickOutside: Function, enabled?: boolean, events?: string[] }
function useDetectClickOutsideElement(props) {
  var _ref = props || {},
    onClickOutside = _ref.onClickOutside,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled,
    _ref$events = _ref.events,
    events = _ref$events === void 0 ? ['click'] : _ref$events;
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var handleClickOutside = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      if (typeof onClickOutside === 'function') onClickOutside();
    }
  }, [onClickOutside]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!enabled) return;
    events.forEach(function (evt) {
      return document.addEventListener(evt, handleClickOutside);
    });
    return function () {
      events.forEach(function (evt) {
        return document.removeEventListener(evt, handleClickOutside);
      });
    };
  }, [enabled, events, handleClickOutside]);
  return {
    containerRef: containerRef
  };
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChevronRightIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var ChevronRightIcon = function ChevronRightIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$rotate = _ref.rotate,
    rotate = _ref$rotate === void 0 ? 0 : _ref$rotate,
    style = _ref.style,
    className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: _objectSpread({
      transform: "rotate(".concat(rotate, "deg)"),
      transition: 'transform 180ms ease'
    }, style),
    className: className
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62202 20.2252C7.32912 19.9323 7.32912 19.4574 7.62201 19.1645L14.7865 12L7.62201 4.8355C7.32912 4.54261 7.32912 4.06774 7.62201 3.77485C7.91491 3.48195 8.38978 3.48195 8.68267 3.77485L16.9078 12L8.68268 20.2252C8.38978 20.518 7.91491 20.518 7.62202 20.2252Z",
    fill: color
  }));
};

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var Tag = function Tag(_ref) {
  var isMobile = _ref.isMobile,
    src = _ref.src,
    alt = _ref.alt,
    label = _ref.label,
    className = _ref.className,
    customClassName = _ref.customClassName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plan-tag ".concat(isMobile ? 'mobile' : 'desktop', " ").concat(className, " ").concat(customClassName || '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: src,
    alt: alt,
    className: "img-cost"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, label));
};
var getTag = function getTag(plan) {
  var _plan$extra = plan.extra,
    covid_coverage = _plan$extra.covid_coverage,
    special = _plan$extra.special,
    travel_renewal = _plan$extra.travel_renewal;
  var tags = [{
    condition: special && travel_renewal === 'no',
    src: '/assets/images/icons/tags/bestPlan.svg',
    alt: 'melhor custo',
    className: 'tag-best-cost',
    label: 'Melhor custo benefício'
  }, {
    condition: travel_renewal !== 'no',
    src: '/assets/images/icons/tags/renewal.svg',
    alt: 'ideal para renovação',
    className: 'tag-renewal',
    label: 'Ideal para renovação'
  }, {
    condition: covid_coverage && !special,
    src: '/assets/images/icons/tags/covid.svg',
    alt: 'cobertura covid',
    className: 'tag-covid',
    label: 'Cobertura Covid'
  }];
  var firstMatchingTag = tags.find(function (tag) {
    return tag.condition;
  });
  return firstMatchingTag;
};
var Tags = function Tags(_ref2) {
  var tag = _ref2.tag,
    isMobile = _ref2.isMobile,
    customClassName = _ref2.customClassName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, tag && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    isMobile: isMobile
  }, tag, {
    customClassName: customClassName
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (Tags);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



// import { validatePurchaseMobile } from '../../../utils'
var ButtonStage = /*#__PURE__*/function (_Component) {
  function ButtonStage() {
    _classCallCheck(this, ButtonStage);
    return _callSuper(this, ButtonStage, arguments);
  }
  _inherits(ButtonStage, _Component);
  return _createClass(ButtonStage, [{
    key: "render",
    value: function render() {
      var _this = this;
      var onButtonClick = function onButtonClick() {
        window.scrollTo({
          top: 0
        });
        _this.props.stepPaymentFinish ? _this.props.nextStage(4, _this.props.stage) : _this.props.nextStage(_this.props.index, _this.props.stage);
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "button-stage",
        "data-cy": this.props['data-cy'],
        onClick: onButtonClick
      }, "Continuar");
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods,
    stepPaymentFinish: state.purchase.stepPaymentFinish
  };
}, {
  nextStage: __WEBPACK_IMPORTED_MODULE_1__actions_purchaseActions__["W" /* nextStage */]
})(ButtonStage));

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SegurosPromo_icon__ = __webpack_require__(353);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__SegurosPromo_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Help_icon__ = __webpack_require__(354);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__Help_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cart_icon__ = __webpack_require__(355);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Cart_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User_icon__ = __webpack_require__(356);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__User_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ChevronRight_icon__ = __webpack_require__(23);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__ChevronRight_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Google_icon__ = __webpack_require__(357);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Google_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Email_icon__ = __webpack_require__(358);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Email_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Close_icon__ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Close_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Menu_icon__ = __webpack_require__(359);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__Menu_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UserAnimation_icon__ = __webpack_require__(360);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__UserAnimation_icon__["a"]; });











/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pad2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toISO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDateBr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDateBrFromDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseDateBrToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseSearchFromPath; });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Shared helpers for Search Bars (Desktop/Mobile)

var pad2 = function pad2(n) {
  return String(n).padStart(2, '0');
};
var toISO = function toISO(date) {
  if (!date) return '';
  var d = date.getDate();
  var m = date.getMonth() + 1;
  var y = date.getFullYear();
  return "".concat(y, "-").concat(pad2(m), "-").concat(pad2(d));
};
var formatDateBr = function formatDateBr(isoDate) {
  if (!isoDate || typeof isoDate !== 'string') return '';
  var m = isoDate.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '';
  var _m = _slicedToArray(m, 4),
    y = _m[1],
    mo = _m[2],
    d = _m[3];
  return "".concat(d, "/").concat(mo, "/").concat(y);
};
var formatDateBrFromDate = function formatDateBrFromDate(date) {
  if (!date) return '';
  var d = date.getDate();
  var m = date.getMonth() + 1;
  var y = date.getFullYear();
  return "".concat(pad2(d), "/").concat(pad2(m), "/").concat(y);
};
var parseDateBrToDate = function parseDateBrToDate(br) {
  if (!br || typeof br !== 'string') return null;
  var m = br.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  var d = parseInt(m[1], 10);
  var mo = parseInt(m[2], 10) - 1;
  var y = parseInt(m[3], 10);
  var dt = new Date(y, mo, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null;
  return dt;
};
var parseSearchFromPath = function parseSearchFromPath() {
  var path = window.location.pathname || '';
  var idx = path.indexOf('/pesquisa/');
  if (idx === -1) return {
    destinationSlug: '',
    beginDate: '',
    endDate: ''
  };
  var sub = path.substring(idx);
  var match = sub.match(/\/pesquisa\/([^/]+)\/(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})\/?/);
  if (!match) return {
    destinationSlug: '',
    beginDate: '',
    endDate: ''
  };
  var _match = _slicedToArray(match, 4),
    destinationSlug = _match[1],
    beginDate = _match[2],
    endDate = _match[3];
  return {
    destinationSlug: destinationSlug,
    beginDate: beginDate,
    endDate: endDate
  };
};

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);


var PixDiscountTag = function PixDiscountTag(props) {
  var pixDiscount = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    if (props.paymentMethods && props.paymentMethods.length > 0) {
      var pixPayment = props.paymentMethods.find(function (method) {
        return method.slug === 'pix';
      });
      if (pixPayment && pixPayment.discount > 0) {
        return pixPayment.discount;
      }
    }
    return 5;
  }, [props.paymentMethods]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "pix-discount-tag",
    style: {
      color: props.color
    }
  }, props.isMobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/tags/pixDiscountMobile.svg",
    alt: "pix"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "no PIX")) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/tags/pixDiscount.svg",
    alt: "pix"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, pixDiscount, "% off no PIX")));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods
  };
})(PixDiscountTag));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_matomo__ = __webpack_require__(10);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }





var ActiveFilters = function ActiveFilters(_ref) {
  var filterCategory = _ref.filterCategory,
    filterProvider = _ref.filterProvider,
    unselectFilterCategoryOptions = _ref.unselectFilterCategoryOptions,
    clearFilterCategories = _ref.clearFilterCategories,
    filteredPlans = _ref.filteredPlans;
  var buildOtherParams = function buildOtherParams(searchParams) {
    var excludeKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return searchParams.filter(function (p) {
      return !excludeKeys.some(function (k) {
        return p.includes("".concat(k, "="));
      }) && p !== '';
    });
  };
  var replaceUrl = function replaceUrl(paramsArray) {
    var location = paramsArray.length > 0 ? "?".concat(paramsArray.join('&')) : window.location.pathname;
    window.history.replaceState(null, null, location);
  };
  var removeValueFromParam = function removeValueFromParam(key, value) {
    var searchParams = window.location.search.replace('?', '').split('&');
    var newParam = searchParams.find(function (param) {
      return param.includes("".concat(key, "="));
    }) || '';
    if (newParam) {
      if (newParam === "".concat(key, "=").concat(value)) {
        newParam = '';
      } else if (newParam.endsWith(",".concat(value))) {
        newParam = newParam.replace(",".concat(value), '');
      } else if (newParam.startsWith("".concat(key, "=").concat(value, ","))) {
        newParam = newParam.replace("".concat(value, ","), '');
      } else {
        newParam = newParam.replace("".concat(value, ","), '');
        newParam = newParam.replace(",".concat(value), '');
      }
    }
    var otherParams = buildOtherParams(searchParams, [key]);
    var allParams = newParam ? [].concat(_toConsumableArray(otherParams), [newParam]) : otherParams;
    replaceUrl(allParams);
  };
  var selectedCategories = filterCategory.flatMap(function (category, categoryIndex) {
    return category.Categories.map(function (option, optionIndex) {
      return option.selected && {
        key: "".concat(categoryIndex, "-").concat(optionIndex),
        name: option.Name,
        unselect: function unselect() {
          removeValueFromParam('category', option.ID);
          unselectFilterCategoryOptions('category', categoryIndex, optionIndex);
        }
      };
    }).filter(Boolean);
  });
  var selectedProviders = filterProvider.filter(function (provider) {
    return provider.selected;
  }).map(function (provider) {
    return {
      key: "provider-".concat(provider.id),
      name: provider.name,
      unselect: function unselect() {
        removeValueFromParam('provider', provider.slug);
        unselectFilterCategoryOptions('provider', filterProvider.findIndex(function (prov) {
          return prov.id === provider.id;
        }));
      }
    };
  });
  var hasSelectedFilters = selectedCategories.length > 0 || selectedProviders.length > 0;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var activeFilters = {
      providers: selectedProviders.map(function (p) {
        return p.name;
      }),
      benefits: selectedCategories.map(function (c) {
        return c.name;
      })
    };
    var filteredPlans_count = filteredPlans.length;
    __WEBPACK_IMPORTED_MODULE_4__utils_matomo__["a" /* default */].trackFilters(activeFilters, filteredPlans_count);
  }, [filterCategory, filterProvider, filteredPlans]);
  var HandleClearAll = function HandleClearAll() {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["clearFiltersFromSession"])();
    var searchParams = window.location.search.replace('?', '').split('&');
    var otherParams = buildOtherParams(searchParams, ['category', 'provider']);
    replaceUrl(otherParams);
    clearFilterCategories();
  };
  return hasSelectedFilters ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "selected-filters-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "filtros-selecionados"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Filtros Aplicados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    onClick: HandleClearAll
  }, "Limpar todos")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "ul-filtros-selecionados",
    id: "active-filters-list"
  }, selectedCategories.concat(selectedProviders).map(function (_ref2) {
    var key = _ref2.key,
      name = _ref2.name,
      unselect = _ref2.unselect;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: key
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      onClick: unselect
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: "/assets/images/x_branco.svg",
      alt: "remover filtro"
    })));
  }))) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    filteredPlans: state.search.filtered_plans
  };
}, {
  unselectFilterCategoryOptions: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["D" /* unselectFilterCategoryOptions */],
  clearFilterCategories: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["d" /* clearFilterCategories */]
})(ActiveFilters));

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CloseIcon = function CloseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: color
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96309 2.97603C3.1974 2.74171 3.5773 2.74171 3.81162 2.97603L11.9871 11.1515L20.1625 2.97603C20.3968 2.74171 20.7767 2.74171 21.011 2.97603C21.2453 3.21034 21.2453 3.59024 21.011 3.82456L12.8356 12L21.011 20.1754C21.2453 20.4098 21.2453 20.7897 21.011 21.024C20.7767 21.2583 20.3968 21.2583 20.1625 21.024L11.9871 12.8485L3.81162 21.024C3.5773 21.2583 3.1974 21.2583 2.96309 21.024C2.72877 20.7897 2.72877 20.4098 2.96309 20.1754L11.1385 12L2.96309 3.82456C2.72877 3.59024 2.72877 3.21034 2.96309 2.97603Z",
    fill: color
  }));
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalQuotationDateWarning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__ = __webpack_require__(5);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalQuotationDateWarning = /*#__PURE__*/function (_Component) {
  function ModalQuotationDateWarning(props) {
    var _this;
    _classCallCheck(this, ModalQuotationDateWarning);
    _this = _callSuper(this, ModalQuotationDateWarning, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalQuotationDateWarning, _Component);
  return _createClass(ModalQuotationDateWarning, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      this.props.closeModalQuotationDateWarning();
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(this.props.match, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), null)
      };
      this.props.history.replace(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalQuotationDateWarningActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents modalfranquia"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalHeader"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h5", null, "Informa\xE7\xE3o importante sobre sua compra")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalQuotationDateWarning,
        className: "close-btn"
      }, ' ', "\xD7", ' ')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        className: "calendar-icon",
        src: "/assets/images/calendar-new.svg",
        alt: "Voc\xEA est\xE1 pesquisando um seguro viagem para hoje"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h5", null, "Voc\xEA est\xE1 pesquisando um seguro viagem para hoje"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "Sua ap\xF3lice ser\xE1 v\xE1lida somente se for emitida antes do in\xEDcio da sua viagem."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "Em caso de d\xFAvida, ", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://segurospromo.com.br/atendimento"
      }, "fale com o nosso atendimento"), "."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "wrapper-list-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "list-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contact-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        className: "contact-icon",
        src: "/assets/images/icons/wppGreen.svg",
        alt: "Voc\xEA est\xE1 pesquisando um seguro viagem para hoje"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "WhatsApp")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "https://api.whatsapp.com/send?phone=553139727083&text=Seguros%20Promo",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "(31) 3972-7083")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "list-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contact-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        className: "contact-icon",
        src: "/assets/images/icons/phone2green.svg",
        alt: "Voc\xEA est\xE1 pesquisando um seguro viagem para hoje"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Atendimento")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "tel:(31) 4003-8442",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "(31) 4003-8442")))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalQuotationDateWarning
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar Pesquisa")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalQuotationDateWarningActive: state.comparison.isModalQuotationDateWarningActive
  };
}, {
  closeModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["f" /* closeModalQuotationDateWarning */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalQuotationDateWarning)));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var Loading = /*#__PURE__*/function (_Component) {
  function Loading() {
    _classCallCheck(this, Loading);
    return _callSuper(this, Loading, arguments);
  }
  _inherits(Loading, _Component);
  return _createClass(Loading, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_loading"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
        className: "spinner",
        width: "65px",
        height: "65px",
        viewBox: "0 0 66 66",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
        className: "path",
        fill: "none",
        strokeWidth: "6",
        strokeLinecap: "round",
        cx: "33",
        cy: "33",
        r: "30"
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["b"] = (Loading);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react/no-array-index-key */

var StatusPayment = function StatusPayment(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, props.purchase.payment_method !== "PIX" ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title-box"
  }, "Pagamento") : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box payment"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "header-box ".concat(props.theme)
  }, props.purchase.payment_method === "PIX" ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "payment-method ".concat(props.purchase.payment_method)
  }, " Instru\xE7\xF5es para pagamento ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "via ", props.purchase.payment_method), " ") : ""), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "body-box"
  }, props.children)));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusPayment);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_FEATURE_EVALUATED */
/* unused harmony export EVENT_EXPERIMENT_VIEWED */
/* harmony export (immutable) */ __webpack_exports__["b"] = evalFeature;
/* harmony export (immutable) */ __webpack_exports__["j"] = runExperiment;
/* harmony export (immutable) */ __webpack_exports__["i"] = getTrackingUserContext;
/* harmony export (immutable) */ __webpack_exports__["f"] = getExperimentResult;
/* unused harmony export getHashAttribute */
/* harmony export (immutable) */ __webpack_exports__["g"] = getStickyBucketAttributeKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllStickyBucketAssignmentDocs;
/* harmony export (immutable) */ __webpack_exports__["h"] = getStickyBucketAttributes;
/* harmony export (immutable) */ __webpack_exports__["a"] = decryptPayload;
/* harmony export (immutable) */ __webpack_exports__["d"] = getApiHosts;
/* harmony export (immutable) */ __webpack_exports__["e"] = getExperimentDedupeKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mongrule_mjs__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_mjs__ = __webpack_require__(17);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var EVENT_FEATURE_EVALUATED = "Feature Evaluated";
var EVENT_EXPERIMENT_VIEWED = "Experiment Viewed";
function getForcedFeatureValues(ctx) {
  // Merge user and global values
  var ret = new Map();
  if (ctx.global.forcedFeatureValues) {
    ctx.global.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  if (ctx.user.forcedFeatureValues) {
    ctx.user.forcedFeatureValues.forEach(function (v, k) {
      return ret.set(k, v);
    });
  }
  return ret;
}
function getForcedVariations(ctx) {
  // Merge user and global values
  if (ctx.global.forcedVariations && ctx.user.forcedVariations) {
    return _objectSpread(_objectSpread({}, ctx.global.forcedVariations), ctx.user.forcedVariations);
  } else if (ctx.global.forcedVariations) {
    return ctx.global.forcedVariations;
  } else if (ctx.user.forcedVariations) {
    return ctx.user.forcedVariations;
  } else {
    return {};
  }
}
function safeCall(_x) {
  return _safeCall.apply(this, arguments);
}
function _safeCall() {
  _safeCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fn) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fn();
        case 1:
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _safeCall.apply(this, arguments);
}
function onExperimentViewed(ctx, experiment, result) {
  var _ctx$user$experimentV;
  // Make sure a tracking callback is only fired once per unique experiment
  if (ctx.user.trackedExperiments) {
    var k = getExperimentDedupeKey(experiment, result);
    if (ctx.user.trackedExperiments.has(k)) {
      return [];
    }
    ctx.user.trackedExperiments.add(k);
  }
  if (ctx.user.enableDevMode && ctx.user.devLogs) {
    ctx.user.devLogs.push({
      experiment: experiment,
      result: result,
      timestamp: Date.now().toString(),
      logType: "experiment"
    });
  }
  var calls = [];
  if (ctx.global.trackingCallback) {
    var cb = ctx.global.trackingCallback;
    calls.push(safeCall(function () {
      return cb(experiment, result, getTrackingUserContext(ctx.user));
    }));
  }
  if (ctx.user.trackingCallback) {
    var _cb = ctx.user.trackingCallback;
    calls.push(safeCall(function () {
      return _cb(experiment, result, getTrackingUserContext(ctx.user));
    }));
  }
  if (ctx.global.eventLogger) {
    var _cb2 = ctx.global.eventLogger;
    calls.push(safeCall(function () {
      return _cb2(EVENT_EXPERIMENT_VIEWED, {
        experimentId: experiment.key,
        variationId: result.key,
        hashAttribute: result.hashAttribute,
        hashValue: result.hashValue
      }, getTrackingUserContext(ctx.user));
    }));
  }

  // Deduped above — subscribers fire once per unique experiment assignment.
  if ((_ctx$user$experimentV = ctx.user.experimentViewedSubs) !== null && _ctx$user$experimentV !== void 0 && _ctx$user$experimentV.size) {
    var user = getTrackingUserContext(ctx.user);
    ctx.user.experimentViewedSubs.forEach(function (cb) {
      try {
        cb(experiment, result, user);
      } catch (e) {
        console.error(e);
      }
    });
  }
  return calls;
}
function onFeatureUsage(ctx, key, ret) {
  // Only track a feature once, unless the assigned value changed
  if (ctx.user.trackedFeatureUsage) {
    var _ctx$user$featureUsag;
    var stringifiedValue = JSON.stringify(ret.value);
    if (ctx.user.trackedFeatureUsage[key] === stringifiedValue) return;
    ctx.user.trackedFeatureUsage[key] = stringifiedValue;
    if (ctx.user.enableDevMode && ctx.user.devLogs) {
      ctx.user.devLogs.push({
        featureKey: key,
        result: ret,
        timestamp: Date.now().toString(),
        logType: "feature"
      });
    }

    // Deduped by value above — subscribers only fire on value changes, not every eval.
    if ((_ctx$user$featureUsag = ctx.user.featureUsageSubs) !== null && _ctx$user$featureUsag !== void 0 && _ctx$user$featureUsag.size) {
      ctx.user.featureUsageSubs.forEach(function (cb) {
        try {
          cb(key, ret);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }
  if (ctx.global.onFeatureUsage) {
    var cb = ctx.global.onFeatureUsage;
    safeCall(function () {
      return cb(key, ret, getTrackingUserContext(ctx.user));
    });
  }
  if (ctx.user.onFeatureUsage) {
    var _cb3 = ctx.user.onFeatureUsage;
    safeCall(function () {
      return _cb3(key, ret);
    });
  }
  if (ctx.global.eventLogger) {
    var _cb4 = ctx.global.eventLogger;
    safeCall(function () {
      return _cb4(EVENT_FEATURE_EVALUATED, {
        feature: key,
        source: ret.source,
        value: ret.value,
        ruleId: ret.source === "defaultValue" ? "$default" : ret.ruleId || "",
        variationId: ret.experimentResult ? ret.experimentResult.key : ""
      }, getTrackingUserContext(ctx.user));
    });
  }
}
function evalFeature(id, ctx) {
  if (ctx.stack.evaluatedFeatures.has(id)) {
    "production" !== "production" && ctx.global.log("evalFeature: circular dependency detected: ".concat(ctx.stack.id, " -> ").concat(id), {
      from: ctx.stack.id,
      to: id
    });
    return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
  }
  ctx.stack.evaluatedFeatures.add(id);
  ctx.stack.id = id;

  // Global override
  var forcedValues = getForcedFeatureValues(ctx);
  if (forcedValues.has(id)) {
    "production" !== "production" && ctx.global.log("Global override", {
      id: id,
      value: forcedValues.get(id)
    });
    return getFeatureResult(ctx, id, forcedValues.get(id), "override");
  }

  // Unknown feature id
  if (!ctx.global.features || !ctx.global.features[id]) {
    "production" !== "production" && ctx.global.log("Unknown feature", {
      id: id
    });
    return getFeatureResult(ctx, id, null, "unknownFeature");
  }

  // Get the feature
  var feature = ctx.global.features[id];

  // Loop through the rules
  if (feature.rules) {
    var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
    var _iterator = _createForOfIteratorHelper(feature.rules),
      _step;
    try {
      rules: for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _rule$contextualVaria;
        var rule = _step.value;
        // If there are prerequisite flag(s), evaluate them
        if (rule.parentConditions) {
          var _iterator2 = _createForOfIteratorHelper(rule.parentConditions),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var parentCondition = _step2.value;
              ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
              var parentResult = evalFeature(parentCondition.id, ctx);
              // break out for cyclic prerequisites
              if (parentResult.source === "cyclicPrerequisite") {
                return getFeatureResult(ctx, id, null, "cyclicPrerequisite");
              }
              var evalObj = {
                value: parentResult.value
              };
              var evaled = Object(__WEBPACK_IMPORTED_MODULE_0__mongrule_mjs__["a" /* evalCondition */])(evalObj, parentCondition.condition || {}, ctx.global.savedGroups || {});
              if (!evaled) {
                // blocking prerequisite eval failed: feature evaluation fails
                if (parentCondition.gate) {
                  "production" !== "production" && ctx.global.log("Feature blocked by prerequisite", {
                    id: id,
                    rule: rule
                  });
                  return getFeatureResult(ctx, id, null, "prerequisite");
                }
                // non-blocking prerequisite eval failed: break out of parentConditions loop, jump to the next rule
                "production" !== "production" && ctx.global.log("Skip rule because prerequisite evaluation fails", {
                  id: id,
                  rule: rule
                });
                continue rules;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        // If there are filters for who is included (e.g. namespaces)
        if (rule.filters && isFilteredOut(rule.filters, ctx)) {
          "production" !== "production" && ctx.global.log("Skip rule because of filters", {
            id: id,
            rule: rule
          });
          continue;
        }

        // Feature value is being forced
        if ("force" in rule) {
          // If it's a conditional rule, skip if the condition doesn't pass
          if (rule.condition && !conditionPasses(rule.condition, ctx)) {
            "production" !== "production" && ctx.global.log("Skip rule because of condition ff", {
              id: id,
              rule: rule
            });
            continue;
          }

          // If this is a percentage rollout, skip if not included
          if (!isIncludedInRollout(ctx, rule.seed || id, rule.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !rule.disableStickyBucketing ? rule.fallbackAttribute : undefined, rule.range, rule.coverage, rule.hashVersion)) {
            "production" !== "production" && ctx.global.log("Skip rule because user not included in rollout", {
              id: id,
              rule: rule
            });
            continue;
          }
          "production" !== "production" && ctx.global.log("Force value from rule", {
            id: id,
            rule: rule
          });

          // If this was a remotely evaluated experiment, fire the tracking callbacks
          if (rule.tracks) {
            rule.tracks.forEach(function (t) {
              var calls = onExperimentViewed(ctx, t.experiment, t.result);
              if (!calls.length && ctx.global.saveDeferredTrack) {
                ctx.global.saveDeferredTrack({
                  experiment: t.experiment,
                  result: t.result,
                  user: getTrackingUserContext(ctx.user)
                });
              }
            });
          }
          return getFeatureResult(ctx, id, rule.force, "force", rule.id);
        }
        // Contextual bandit rules carry their variations under
        // `contextualVariations` so older SDKs skip them; read either field here.
        var ruleVariations = (_rule$contextualVaria = rule.contextualVariations) !== null && _rule$contextualVaria !== void 0 ? _rule$contextualVaria : rule.variations;
        if (!ruleVariations) {
          "production" !== "production" && ctx.global.log("Skip invalid rule", {
            id: id,
            rule: rule
          });
          continue;
        }

        // For experiment rules, run an experiment
        var exp = {
          variations: ruleVariations,
          key: rule.key || id
        };
        if ("coverage" in rule) exp.coverage = rule.coverage;
        if (rule.weights) exp.weights = rule.weights;
        if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
        if (rule.fallbackAttribute) exp.fallbackAttribute = rule.fallbackAttribute;
        if (rule.disableStickyBucketing) exp.disableStickyBucketing = rule.disableStickyBucketing;
        if (rule.bucketVersion !== undefined) exp.bucketVersion = rule.bucketVersion;
        if (rule.minBucketVersion !== undefined) exp.minBucketVersion = rule.minBucketVersion;
        if (rule.namespace) exp.namespace = rule.namespace;
        if (rule.meta) exp.meta = rule.meta;
        if (rule.ranges) exp.ranges = rule.ranges;
        if (rule.name) exp.name = rule.name;
        if (rule.phase) exp.phase = rule.phase;
        if (rule.seed) exp.seed = rule.seed;
        if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
        if (rule.filters) exp.filters = rule.filters;
        if (rule.condition) exp.condition = rule.condition;
        if (rule.contextualBanditRef) {
          buildContextualBanditExperiment(exp, rule.contextualBanditRef, id, ctx);
        }

        // Only return a value if the user is part of the experiment
        var _runExperiment = runExperiment(exp, id, ctx),
          result = _runExperiment.result;
        if (exp.contextualBandit && !(result.hashUsed && result.inExperiment)) {
          delete exp.contextualBandit;
        }
        ctx.global.onExperimentEval && ctx.global.onExperimentEval(exp, result);
        if (result.inExperiment && !result.passthrough) {
          return getFeatureResult(ctx, id, result.value, "experiment", rule.id, exp, result);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  "production" !== "production" && ctx.global.log("Use default value", {
    id: id,
    value: feature.defaultValue
  });

  // Fall back to using the default value
  return getFeatureResult(ctx, id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
}
function runExperiment(experiment, featureId, ctx) {
  var key = experiment.key;
  var numVariations = experiment.variations.length;

  // 1. If experiment has less than 2 variations, return immediately
  if (numVariations < 2) {
    "production" !== "production" && ctx.global.log("Invalid experiment", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2. If the context is disabled, return immediately
  if (ctx.global.enabled === false || ctx.user.enabled === false) {
    "production" !== "production" && ctx.global.log("Context disabled", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 2.5. Merge in experiment overrides from the context
  experiment = mergeOverrides(experiment, ctx);
  if (experiment.contextualBandit && experiment.weights) {
    experiment.contextualBandit = _objectSpread(_objectSpread({}, experiment.contextualBandit), {}, {
      variationWeights: experiment.weights
    });
  }

  // 2.6 New, more powerful URL targeting
  if (experiment.urlPatterns && !Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["m" /* isURLTargeted */])(ctx.user.url || "", experiment.urlPatterns)) {
    "production" !== "production" && ctx.global.log("Skip because of url targeting", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 3. If a variation is forced from a querystring, return the forced variation
  var qsOverride = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["g" /* getQueryStringOverride */])(key, ctx.user.url || "", numVariations);
  if (qsOverride !== null) {
    "production" !== "production" && ctx.global.log("Force via querystring", {
      id: key,
      variation: qsOverride
    });
    return {
      result: getExperimentResult(ctx, experiment, qsOverride, false, featureId)
    };
  }

  // 4. If a variation is forced in the context, return the forced variation
  var forcedVariations = getForcedVariations(ctx);
  if (key in forcedVariations) {
    var variation = forcedVariations[key];
    "production" !== "production" && ctx.global.log("Force via dev tools", {
      id: key,
      variation: variation
    });
    return {
      result: getExperimentResult(ctx, experiment, variation, false, featureId)
    };
  }

  // 5. Exclude if a draft experiment or not active
  if (experiment.status === "draft" || experiment.active === false) {
    "production" !== "production" && ctx.global.log("Skip because inactive", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 6. Get the hash attribute and return if empty
  var _getHashAttribute = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute.hashAttribute,
    hashValue = _getHashAttribute.hashValue;
  if (!hashValue) {
    "production" !== "production" && ctx.global.log("Skip because missing hashAttribute", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  var assigned = -1;
  var foundStickyBucket = false;
  var stickyBucketVersionIsBlocked = false;
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _getStickyBucketVaria = getStickyBucketVariation({
        ctx: ctx,
        expKey: experiment.key,
        expBucketVersion: experiment.bucketVersion,
        expHashAttribute: experiment.hashAttribute,
        expFallbackAttribute: experiment.fallbackAttribute,
        expMinBucketVersion: experiment.minBucketVersion,
        expMeta: experiment.meta
      }),
      _variation = _getStickyBucketVaria.variation,
      versionIsBlocked = _getStickyBucketVaria.versionIsBlocked;
    foundStickyBucket = _variation >= 0;
    assigned = _variation;
    stickyBucketVersionIsBlocked = !!versionIsBlocked;
  }

  // Some checks are not needed if we already have a sticky bucket
  if (!foundStickyBucket) {
    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (isFilteredOut(experiment.filters, ctx)) {
        "production" !== "production" && ctx.global.log("Skip because of filters", {
          id: key
        });
        return {
          result: getExperimentResult(ctx, experiment, -1, false, featureId)
        };
      }
    } else if (experiment.namespace && !Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["j" /* inNamespace */])(hashValue, experiment.namespace)) {
      "production" !== "production" && ctx.global.log("Skip because of namespace", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["l" /* isIncluded */])(experiment.include)) {
      "production" !== "production" && ctx.global.log("Skip because of include function", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !conditionPasses(experiment.condition, ctx)) {
      "production" !== "production" && ctx.global.log("Skip because of condition exp", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }

    // 8.05. Exclude if prerequisites are not met
    if (experiment.parentConditions) {
      var evaluatedFeatures = new Set(ctx.stack.evaluatedFeatures);
      var _iterator3 = _createForOfIteratorHelper(experiment.parentConditions),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var parentCondition = _step3.value;
          ctx.stack.evaluatedFeatures = new Set(evaluatedFeatures);
          var parentResult = evalFeature(parentCondition.id, ctx);
          // break out for cyclic prerequisites
          if (parentResult.source === "cyclicPrerequisite") {
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
          var evalObj = {
            value: parentResult.value
          };
          if (!Object(__WEBPACK_IMPORTED_MODULE_0__mongrule_mjs__["a" /* evalCondition */])(evalObj, parentCondition.condition || {}, ctx.global.savedGroups || {})) {
            "production" !== "production" && ctx.global.log("Skip because prerequisite evaluation fails", {
              id: key
            });
            return {
              result: getExperimentResult(ctx, experiment, -1, false, featureId)
            };
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !hasGroupOverlap(experiment.groups, ctx)) {
      "production" !== "production" && ctx.global.log("Skip because of groups", {
        id: key
      });
      return {
        result: getExperimentResult(ctx, experiment, -1, false, featureId)
      };
    }
  }

  // 8.2. Old style URL targeting
  if (experiment.url && !urlIsValid(experiment.url, ctx)) {
    "production" !== "production" && ctx.global.log("Skip because of url", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 9. Get the variation from the sticky bucket or get bucket ranges and choose variation
  var n = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["i" /* hash */])(experiment.seed || key, hashValue, experiment.hashVersion || 1);
  if (n === null) {
    "production" !== "production" && ctx.global.log("Skip because of invalid hash version", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }
  if (!foundStickyBucket) {
    var ranges = experiment.ranges || Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["d" /* getBucketRanges */])(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    assigned = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["a" /* chooseVariation */])(n, ranges);
  }

  // 9.5 Unenroll if any prior sticky buckets are blocked by version
  if (stickyBucketVersionIsBlocked) {
    "production" !== "production" && ctx.global.log("Skip because sticky bucket version is blocked", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId, undefined, true)
    };
  }

  // 10. Return if not in experiment
  if (assigned < 0) {
    "production" !== "production" && ctx.global.log("Skip because of coverage", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 11. Experiment has a forced variation
  if ("force" in experiment) {
    "production" !== "production" && ctx.global.log("Force variation", {
      id: key,
      variation: experiment.force
    });
    return {
      result: getExperimentResult(ctx, experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId)
    };
  }

  // 12. Exclude if in QA mode
  if (ctx.global.qaMode || ctx.user.qaMode) {
    "production" !== "production" && ctx.global.log("Skip because QA mode", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 12.5. Exclude if experiment is stopped
  if (experiment.status === "stopped") {
    "production" !== "production" && ctx.global.log("Skip because stopped", {
      id: key
    });
    return {
      result: getExperimentResult(ctx, experiment, -1, false, featureId)
    };
  }

  // 13. Build the result object
  var result = getExperimentResult(ctx, experiment, assigned, true, featureId, n, foundStickyBucket);

  // 13.5. Persist sticky bucket
  if (ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing) {
    var _generateStickyBucket = generateStickyBucketAssignmentDoc(ctx, hashAttribute, Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["r" /* toString */])(hashValue), _defineProperty({}, getStickyBucketExperimentKey(experiment.key, experiment.bucketVersion), result.key)),
      changed = _generateStickyBucket.changed,
      attrKey = _generateStickyBucket.key,
      doc = _generateStickyBucket.doc;
    if (changed) {
      // update local docs
      ctx.user.stickyBucketAssignmentDocs = ctx.user.stickyBucketAssignmentDocs || {};
      ctx.user.stickyBucketAssignmentDocs[attrKey] = doc;
      // save doc
      ctx.user.saveStickyBucketAssignmentDoc(doc);
    }
  }

  // 14. Fire the tracking callback(s)
  // Store the promise in case we're awaiting it (ex: browser url redirects)
  var trackingCalls = onExperimentViewed(ctx, experiment, result);
  if (trackingCalls.length === 0 && ctx.global.saveDeferredTrack) {
    ctx.global.saveDeferredTrack({
      experiment: experiment,
      result: result,
      user: getTrackingUserContext(ctx.user)
    });
  }
  var trackingCall = !trackingCalls.length ? undefined : trackingCalls.length === 1 ? trackingCalls[0] : Promise.all(trackingCalls).then(function () {});

  // 14.1 Keep track of completed changeIds
  "changeId" in experiment && experiment.changeId && ctx.global.recordChangeId && ctx.global.recordChangeId(experiment.changeId);

  // 15. Return the result
  "production" !== "production" && ctx.global.log("In experiment", {
    id: key,
    variation: result.variationId
  });
  return {
    result: result,
    trackingCall: trackingCall
  };
}
function getFeatureResult(ctx, key, value, source, ruleId, experiment, result) {
  var ret = {
    value: value,
    on: !!value,
    off: !value,
    source: source,
    ruleId: ruleId || ""
  };
  if (experiment) ret.experiment = experiment;
  if (result) ret.experimentResult = result;

  // Track the usage of this feature in real-time
  if (source !== "override") {
    onFeatureUsage(ctx, key, ret);
  }
  return ret;
}
function getAttributes(user) {
  return _objectSpread(_objectSpread({}, user.attributes), user.attributeOverrides);
}
function getTrackingUserContext(user) {
  return {
    attributes: getAttributes(user),
    url: user.url
  };
}
function getContextualBanditLeaf(cbDefinition, ctx) {
  var _iterator4 = _createForOfIteratorHelper(cbDefinition.contexts || []),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var context = _step4.value;
      if (conditionPasses(context.condition || {}, ctx)) {
        return {
          leafId: context.leafId,
          weights: context.weights
        };
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return null;
}
var CONTEXTUAL_BANDIT_FALLBACK_LEAF_ID = -1;
function buildContextualBanditExperiment(experiment, contextualBanditRef, id, ctx) {
  var _ctx$global$contextua, _experiment$weights;
  var cbDefinition = (_ctx$global$contextua = ctx.global.contextualBandits) === null || _ctx$global$contextua === void 0 ? void 0 : _ctx$global$contextua[contextualBanditRef];
  if (!cbDefinition) {
    "production" !== "production" && ctx.global.log("Contextual bandit ref not found in payload, using aggregate weights", {
      id: id,
      contextualBanditRef: contextualBanditRef
    });
    return;
  }
  var leaf = null;
  if (cbDefinition.contexts && cbDefinition.contexts.length) {
    try {
      leaf = getContextualBanditLeaf(cbDefinition, ctx);
    } catch (e) {
      "production" !== "production" && ctx.global.log("Contextual bandit leaf selection threw, using fallback weights", {
        id: id,
        contextualBanditRef: contextualBanditRef,
        error: e
      });
    }
  }
  if (leaf) {
    experiment.weights = leaf.weights;
    experiment.contextualBandit = {
      leafId: leaf.leafId,
      variationWeights: leaf.weights,
      banditVersion: cbDefinition.banditVersion
    };
    return;
  }
  "production" !== "production" && ctx.global.log("Contextual bandit: no matching leaf, using fallback weights", {
    id: id,
    contextualBanditRef: contextualBanditRef
  });
  experiment.contextualBandit = {
    leafId: CONTEXTUAL_BANDIT_FALLBACK_LEAF_ID,
    variationWeights: (_experiment$weights = experiment.weights) !== null && _experiment$weights !== void 0 ? _experiment$weights : Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["e" /* getEqualWeights */])(experiment.variations.length),
    banditVersion: cbDefinition.banditVersion
  };
}
function conditionPasses(condition, ctx) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__mongrule_mjs__["a" /* evalCondition */])(getAttributes(ctx.user), condition, ctx.global.savedGroups || {});
}
function isFilteredOut(filters, ctx) {
  return filters.some(function (filter) {
    var _getHashAttribute2 = getHashAttribute(ctx, filter.attribute),
      hashValue = _getHashAttribute2.hashValue;
    if (!hashValue) return true;
    var n = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["i" /* hash */])(filter.seed, hashValue, filter.hashVersion || 2);
    if (n === null) return true;
    return !filter.ranges.some(function (r) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["k" /* inRange */])(n, r);
    });
  });
}
function isIncludedInRollout(ctx, seed, hashAttribute, fallbackAttribute, range, coverage, hashVersion) {
  if (!range && coverage === undefined) return true;
  if (!range && coverage === 0) return false;
  var _getHashAttribute3 = getHashAttribute(ctx, hashAttribute, fallbackAttribute),
    hashValue = _getHashAttribute3.hashValue;
  if (!hashValue) {
    return false;
  }
  var n = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["i" /* hash */])(seed, hashValue, hashVersion || 1);
  if (n === null) return false;
  return range ? Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["k" /* inRange */])(n, range) : coverage !== undefined ? n <= coverage : true;
}
function getExperimentResult(ctx, experiment, variationIndex, hashUsed, featureId, bucket, stickyBucketUsed) {
  var inExperiment = true;
  // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
  if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
    variationIndex = 0;
    inExperiment = false;
  }
  var _getHashAttribute4 = getHashAttribute(ctx, experiment.hashAttribute, ctx.user.saveStickyBucketAssignmentDoc && !experiment.disableStickyBucketing ? experiment.fallbackAttribute : undefined),
    hashAttribute = _getHashAttribute4.hashAttribute,
    hashValue = _getHashAttribute4.hashValue;
  var meta = experiment.meta ? experiment.meta[variationIndex] : {};
  var res = {
    key: meta.key || "" + variationIndex,
    featureId: featureId,
    inExperiment: inExperiment,
    hashUsed: hashUsed,
    variationId: variationIndex,
    value: experiment.variations[variationIndex],
    hashAttribute: hashAttribute,
    hashValue: hashValue,
    stickyBucketUsed: !!stickyBucketUsed
  };
  if (meta.name) res.name = meta.name;
  if (bucket !== undefined) res.bucket = bucket;
  if (meta.passthrough) res.passthrough = meta.passthrough;
  var cb = experiment.contextualBandit;
  if (cb && hashUsed && inExperiment) {
    res.leafId = cb.leafId;
    res.variationWeights = cb.variationWeights;
    if (cb.banditVersion !== undefined) res.banditVersion = cb.banditVersion;
  }
  return res;
}
function mergeOverrides(experiment, ctx) {
  var key = experiment.key;
  var o = ctx.global.overrides;
  if (o && o[key]) {
    experiment = Object.assign({}, experiment, o[key]);
    if (typeof experiment.url === "string") {
      experiment.url = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["h" /* getUrlRegExp */])(
      // eslint-disable-next-line
      experiment.url);
    }
  }
  return experiment;
}
function getHashAttribute(ctx, attr, fallback) {
  var hashAttribute = attr || "id";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var hashValue = "";
  var attributes = getAttributes(ctx.user);
  if (attributes[hashAttribute]) {
    hashValue = attributes[hashAttribute];
  }

  // if no match, try fallback
  if (!hashValue && fallback) {
    if (attributes[fallback]) {
      hashValue = attributes[fallback];
    }
    if (hashValue) {
      hashAttribute = fallback;
    }
  }
  return {
    hashAttribute: hashAttribute,
    hashValue: hashValue
  };
}
function urlIsValid(urlRegex, ctx) {
  var url = ctx.user.url;
  if (!url) return false;
  var pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
  if (urlRegex.test(url)) return true;
  if (urlRegex.test(pathOnly)) return true;
  return false;
}
function hasGroupOverlap(expGroups, ctx) {
  var groups = ctx.global.groups || {};
  for (var i = 0; i < expGroups.length; i++) {
    if (groups[expGroups[i]]) return true;
  }
  return false;
}
function getStickyBucketVariation(_ref) {
  var ctx = _ref.ctx,
    expKey = _ref.expKey,
    expBucketVersion = _ref.expBucketVersion,
    expHashAttribute = _ref.expHashAttribute,
    expFallbackAttribute = _ref.expFallbackAttribute,
    expMinBucketVersion = _ref.expMinBucketVersion,
    expMeta = _ref.expMeta;
  expBucketVersion = expBucketVersion || 0;
  expMinBucketVersion = expMinBucketVersion || 0;
  expHashAttribute = expHashAttribute || "id";
  expMeta = expMeta || [];
  var id = getStickyBucketExperimentKey(expKey, expBucketVersion);
  var assignments = getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute);

  // users with any blocked bucket version (0 to minExperimentBucketVersion - 1) are excluded from the test
  if (expMinBucketVersion > 0) {
    for (var i = 0; i < expMinBucketVersion; i++) {
      var blockedKey = getStickyBucketExperimentKey(expKey, i);
      if (assignments[blockedKey] !== undefined) {
        return {
          variation: -1,
          versionIsBlocked: true
        };
      }
    }
  }
  var variationKey = assignments[id];
  if (variationKey === undefined)
    // no assignment found
    return {
      variation: -1
    };
  var variation = expMeta.findIndex(function (m) {
    return m.key === variationKey;
  });
  if (variation < 0)
    // invalid assignment, treat as "no assignment found"
    return {
      variation: -1
    };
  return {
    variation: variation
  };
}
function getStickyBucketExperimentKey(experimentKey, experimentBucketVersion) {
  experimentBucketVersion = experimentBucketVersion || 0;
  return "".concat(experimentKey, "__").concat(experimentBucketVersion);
}
function getStickyBucketAttributeKey(attributeName, attributeValue) {
  return "".concat(attributeName, "||").concat(attributeValue);
}
function getStickyBucketAssignments(ctx, expHashAttribute, expFallbackAttribute) {
  if (!ctx.user.stickyBucketAssignmentDocs) return {};
  var _getHashAttribute5 = getHashAttribute(ctx, expHashAttribute),
    hashAttribute = _getHashAttribute5.hashAttribute,
    hashValue = _getHashAttribute5.hashValue;
  var hashKey = getStickyBucketAttributeKey(hashAttribute, Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["r" /* toString */])(hashValue));
  var _getHashAttribute6 = getHashAttribute(ctx, expFallbackAttribute),
    fallbackAttribute = _getHashAttribute6.hashAttribute,
    fallbackValue = _getHashAttribute6.hashValue;
  var fallbackKey = fallbackValue ? getStickyBucketAttributeKey(fallbackAttribute, Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["r" /* toString */])(fallbackValue)) : null;
  var assignments = {};
  if (fallbackKey && ctx.user.stickyBucketAssignmentDocs[fallbackKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[fallbackKey].assignments || {});
  }
  if (ctx.user.stickyBucketAssignmentDocs[hashKey]) {
    Object.assign(assignments, ctx.user.stickyBucketAssignmentDocs[hashKey].assignments || {});
  }
  return assignments;
}
function generateStickyBucketAssignmentDoc(ctx, attributeName, attributeValue, assignments) {
  var key = getStickyBucketAttributeKey(attributeName, attributeValue);
  var existingAssignments = ctx.user.stickyBucketAssignmentDocs && ctx.user.stickyBucketAssignmentDocs[key] ? ctx.user.stickyBucketAssignmentDocs[key].assignments || {} : {};
  var newAssignments = _objectSpread(_objectSpread({}, existingAssignments), assignments);
  var changed = JSON.stringify(existingAssignments) !== JSON.stringify(newAssignments);
  return {
    key: key,
    doc: {
      attributeName: attributeName,
      attributeValue: attributeValue,
      assignments: newAssignments
    },
    changed: changed
  };
}
function deriveStickyBucketIdentifierAttributes(ctx, data) {
  var attributes = new Set();
  var features = data && data.features ? data.features : ctx.global.features || {};
  var experiments = data && data.experiments ? data.experiments : ctx.global.experiments || [];
  Object.keys(features).forEach(function (id) {
    var feature = features[id];
    if (feature.rules) {
      var _iterator5 = _createForOfIteratorHelper(feature.rules),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var rule = _step5.value;
          // Contextual bandit rules carry their variations under `contextualVariations`
          if (rule.variations || rule.contextualVariations) {
            attributes.add(rule.hashAttribute || "id");
            if (rule.fallbackAttribute) {
              attributes.add(rule.fallbackAttribute);
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  });
  experiments.map(function (experiment) {
    attributes.add(experiment.hashAttribute || "id");
    if (experiment.fallbackAttribute) {
      attributes.add(experiment.fallbackAttribute);
    }
  });
  return Array.from(attributes);
}
function getAllStickyBucketAssignmentDocs(_x2, _x3, _x4) {
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
function _getAllStickyBucketAssignmentDocs() {
  _getAllStickyBucketAssignmentDocs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(ctx, stickyBucketService, data) {
    var attributes;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          attributes = getStickyBucketAttributes(ctx, data);
          return _context2.a(2, stickyBucketService.getAllAssignments(attributes));
      }
    }, _callee2);
  }));
  return _getAllStickyBucketAssignmentDocs.apply(this, arguments);
}
function getStickyBucketAttributes(ctx, data) {
  var attributes = {};
  var stickyBucketIdentifierAttributes = deriveStickyBucketIdentifierAttributes(ctx, data);
  stickyBucketIdentifierAttributes.forEach(function (attr) {
    var _getHashAttribute7 = getHashAttribute(ctx, attr),
      hashValue = _getHashAttribute7.hashValue;
    attributes[attr] = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["r" /* toString */])(hashValue);
  });
  return attributes;
}
function decryptPayload(_x5, _x6, _x7) {
  return _decryptPayload.apply(this, arguments);
}
function _decryptPayload() {
  _decryptPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, decryptionKey, subtle) {
    var _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          data = _objectSpread({}, data);
          if (!data.encryptedFeatures) {
            _context3.n = 5;
            break;
          }
          _context3.p = 1;
          _t2 = JSON;
          _context3.n = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(data.encryptedFeatures, decryptionKey, subtle);
        case 2:
          data.features = _t2.parse.call(_t2, _context3.v);
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t3 = _context3.v;
          console.error(_t3);
        case 4:
          delete data.encryptedFeatures;
        case 5:
          if (!data.encryptedExperiments) {
            _context3.n = 10;
            break;
          }
          _context3.p = 6;
          _t4 = JSON;
          _context3.n = 7;
          return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(data.encryptedExperiments, decryptionKey, subtle);
        case 7:
          data.experiments = _t4.parse.call(_t4, _context3.v);
          _context3.n = 9;
          break;
        case 8:
          _context3.p = 8;
          _t5 = _context3.v;
          console.error(_t5);
        case 9:
          delete data.encryptedExperiments;
        case 10:
          if (!data.encryptedSavedGroups) {
            _context3.n = 15;
            break;
          }
          _context3.p = 11;
          _t6 = JSON;
          _context3.n = 12;
          return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(data.encryptedSavedGroups, decryptionKey, subtle);
        case 12:
          data.savedGroups = _t6.parse.call(_t6, _context3.v);
          _context3.n = 14;
          break;
        case 13:
          _context3.p = 13;
          _t7 = _context3.v;
          console.error(_t7);
        case 14:
          delete data.encryptedSavedGroups;
        case 15:
          if (!data.encryptedContextualBandits) {
            _context3.n = 20;
            break;
          }
          _context3.p = 16;
          _t8 = JSON;
          _context3.n = 17;
          return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(data.encryptedContextualBandits, decryptionKey, subtle);
        case 17:
          data.contextualBandits = _t8.parse.call(_t8, _context3.v);
          _context3.n = 19;
          break;
        case 18:
          _context3.p = 18;
          _t9 = _context3.v;
          console.error(_t9);
        case 19:
          delete data.encryptedContextualBandits;
        case 20:
          return _context3.a(2, data);
      }
    }, _callee3, null, [[16, 18], [11, 13], [6, 8], [1, 3]]);
  }));
  return _decryptPayload.apply(this, arguments);
}
function getApiHosts(options) {
  var defaultHost = options.apiHost || "https://cdn.growthbook.io";
  return {
    apiHost: defaultHost.replace(/\/*$/, ""),
    streamingHost: (options.streamingHost || defaultHost).replace(/\/*$/, ""),
    apiRequestHeaders: options.apiHostRequestHeaders,
    streamingHostRequestHeaders: options.streamingHostRequestHeaders
  };
}
function getExperimentDedupeKey(experiment, result) {
  return result.hashAttribute + result.hashValue + experiment.key + result.variationId;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(41);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_range_picker_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__date_range_picker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__date_range_picker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autocomplete__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__autocomplete__);



/* eslint-disable */
"use strict";
/* Utils */
var SEGUROS_PROMO_BASE = 'https://www.segurospromo.com.br';
// TODO: ALTERAR AQUI VIA DOCKER
var SEARCH_PAGE_BASE = "/site/pesquisa/";
var CLIENT_API_URL = "/emitir-seguros/access/";
// https://7f4d2adec03c419fa2d42db41c0915c6@log.emitir.com.br/32
var RAVENURL = '';
var ua = navigator.userAgent.toLowerCase();
function mobilechecker() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
;
function extend(obj, defaults, options) {
  var option;
  for (option in defaults) {
    obj[option] = defaults[option];
  }
  for (option in options) {
    if (defaults.hasOwnProperty(option)) {
      obj[option] = options[option];
    }
  }
}
var httpSpDo = function httpSpDo(method, url, callback, data) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState === 4) {
      if (typeof callback === "function") {
        callback(xmlHttp.responseText);
      }
    }
  };
  xmlHttp.open(method, url);
  xmlHttp.send(data);
};
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(name, value, daysToExpire) {
  daysToExpire = typeof daysToExpire !== 'undefined' ? daysToExpire : 1;
  var d = new Date();
  d.setTime(d.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = name + '=' + value + '; ' + expires + '; path=/';
}
var obj, masc;
function fMasc(objeto, mascara) {
  obj = objeto;
  masc = mascara;
  setTimeout("fMascEx()", 1);
}
function fMascEx() {
  obj.value = masc(obj.value);
}
function mTel(tel) {
  tel = tel.replace(/\D/g, "");
  tel = tel.replace(/^(\d)/, "($1");
  tel = tel.replace(/(.{3})(\d)/, "$1)$2");
  if (tel.length == 9) {
    tel = tel.replace(/(.{1})$/, "-$1");
  } else if (tel.length == 10) {
    tel = tel.replace(/(.{2})$/, "-$1");
  } else if (tel.length == 11) {
    tel = tel.replace(/(.{3})$/, "-$1");
  } else if (tel.length == 12) {
    tel = tel.replace(/(.{4})$/, "-$1");
  } else if (tel.length > 12) {
    tel = tel.replace(/(.{4})$/, "-$1");
  }
  return tel;
}
function handler(errorCode, lib) {
  if (lib.onError.hasOwnProperty(errorCode) && typeof lib.onError[errorCode] === "function") {
    lib.onError[errorCode](lib.frame);
  }
}
function Frame(options) {
  var self = this;
  var defaults = {
    destination: null,
    departureDate: null,
    returningDate: null,
    client: true,
    nullEndDate: false,
    name: null,
    onSuccess: null,
    openInNewTab: true,
    form: null,
    email: null,
    cellphone: null,
    valid: false
  };
  extend(this, defaults, options);
  this.submit = function (ev) {
    self.validate(true);
    if (!self.valid) {
      ev.preventDefault();
      return;
    }
    var subscriber = {
      name: self.name.getName(),
      cellphone: self.cellphone.getCellphone(),
      email: self.email.getEmail()
    };
    var token = btoa(JSON.stringify(subscriber));
    setCookie("sp-client", token);
  };
  this.search = function (ev) {
    ev.preventDefault();
    self.validate(true);
    if (self.valid) {
      if (self.client) {
        var subscriber = {
          name: self.name.getName(),
          cellphone: self.cellphone.getCellphone(),
          email: self.email.getEmail()
        };
        var token = btoa(JSON.stringify(subscriber));
        setCookie("sp-client", token);
        self.sendClientData(subscriber, self.afterSearch, self.afterSearch);
      } else {
        self.afterSearch();
      }
    }
  };
  this.afterSearch = function (response) {
    var urlToRedirect = SEGUROS_PROMO_BASE + SEARCH_PAGE_BASE + self.destination.getSelected().slug + '/' + self.departureDate.date.toEn().replace(/\//g, '-') + (self.returningDate ? '/' + self.returningDate.date.toEn().replace(/\//g, '-') : '');
    if (!self.onSuccess) {
      if (self.openInNewTab) {
        var win = window.open(urlToRedirect, '_blank');
        win && win.focus();
      } else {
        window.location = urlToRedirect;
      }
      return;
    }
    self.onSuccess(self, urlToRedirect);
  };
  this.sendClientData = function (subscriber, callback, afterSearch) {
    var token = btoa(JSON.stringify(subscriber));
    setCookie("sp-client", token);
    var clientUrl = SEGUROS_PROMO_BASE + CLIENT_API_URL + '?name=' + subscriber.name + '&email=' + subscriber.email + '&phone=' + self.cellphone.toPhone(subscriber.cellphone).split(')')[0] + ' ' + self.cellphone.toPhone(subscriber.cellphone).split(')')[1];
    httpSpDo('GET', clientUrl, callback);
  };
  this.validate = function (ignorePristine) {
    var error = false;
    self.destination.validate(ignorePristine);
    self.departureDate.validate(ignorePristine);
    if (self.returningDate) {
      self.returningDate.validate(ignorePristine);
    }
    if (self.client) {
      self.name.validate(ignorePristine);
      self.email.validate(ignorePristine);
      self.cellphone.validate(ignorePristine);
      if (self.email.error || self.name.error || self.cellphone.error) {
        error = true;
      }
    }
    if (error || self.destination.error || self.departureDate.error || (self.returningDate ? self.returningDate.error : false)) {
      self.valid = false;
    } else {
      self.valid = true;
    }
  };
  this.init = function () {
    if (!self.destination) console.error("Input de destino não definido");else self.destination.frame = self;
    if (!self.departureDate) console.error("Data de partida não definda");else self.departureDate.frame = self;
    if (!self.returningDate && !self.nullEndDate) {
      console.error("Data de retorno não definida");
    } else {
      if (self.returningDate) {
        self.returningDate.frame = self;
      }
    }
    if (self.client) {
      if (!self.name) console.error("Input de nome não definido");else self.name.frame = self;
      if (!self.email) console.error("Input de email não definido");else self.email.frame = self;
      if (!self.cellphone) console.error("Input de telefone não definido");else self.cellphone.frame = self;
      var cookies = getCookie('sp-client');
      var client = cookies ? JSON.parse(atob(cookies)) : null;
      if (client) {
        self.name.setName(client.name);
        self.email.setEmail(client.email);
        self.cellphone.setPhone(client.cellphone);
        self.sendClientData(client);
      }
    }

    // Setup sentry.
    var script = document.createElement('script');
    script.async = 'async';
    script.src = "https://cdn.ravenjs.com/3.1.1/raven.min.js";
    document.head.appendChild(script);
    setTimeout(function () {
      if (typeof Raven !== 'undefined') {
        Raven.config(RAVENURL).install();
      } else {
        console.log('raven not loaded');
      }
    }, 1000);
    if (!getCookie("segpromuuid")) {
      var guid = function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      };
      setCookie("segpromuuid", guid());
    }
  };
  this.init();
  if (this.form) {
    this.form.addEventListener('submit', this.submit);
  }
}
function Destination(options) {
  var self = this;
  var defaults = {
    input: null,
    optionsDiv: null,
    container: null,
    selected: null,
    offsetTop: 5,
    error: true,
    options: [],
    onChange: null,
    onError: {},
    pristine: true,
    onSelect: null,
    initialValue: ''
  };
  extend(this, defaults, options);
  this.init = function () {
    var defaultDestinations = [{
      value: "1",
      name: "Brasil",
      slug: "brasil"
    }, {
      value: "2",
      name: "América do Sul",
      slug: "america-do-sul"
    }, {
      value: "3",
      name: "Europa",
      slug: "europa"
    }, {
      value: "4",
      name: "América do Norte",
      slug: "america-do-norte"
    }, {
      value: "5",
      name: "América Central",
      slug: "america-central"
    }, {
      value: "6",
      name: "Oceania",
      slug: "oceania"
    }, {
      value: "7",
      name: "Oriente Médio",
      slug: "oriente-medio"
    }, {
      value: "8",
      name: "Ásia",
      slug: "asia"
    }, {
      value: "9",
      name: "África",
      slug: "africa"
    }, {
      value: "11",
      name: "Internacional",
      slug: "internacional"
    }, {
      value: "12",
      name: "Receptivo",
      slug: "receptivo"
    }, {
      value: "16",
      name: "Argentina",
      slug: "argentina"
    }];
    self.options = defaultDestinations;
    if (self.input) {
      this.input.value = this.initialValue || 'Destino';
      self.autoComplete = new __WEBPACK_IMPORTED_MODULE_1__autocomplete___default.a({
        minChars: 0,
        selector: self.input,
        delay: 0,
        offsetTop: self.offsetTop,
        source: function source(_, response) {
          response(defaultDestinations);
        },
        renderItem: function renderItem(item, _) {
          return '<div class="autocomplete-suggestion' + (self.selected == item.value ? ' autocomplete-suggestion-selected' : '') + '" data-val="' + item.name + '" value="' + item.value + '">' + item.name + '</div>';
        },
        onSelect: function onSelect(e, _, item) {
          e.preventDefault(); // necessário para o 'enter' não disparar a pesquisa
          self.setDestination(item.getAttribute('value'));
        }
      });
    }
  };
  this.validate = function (ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }
    if (!self.selected) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    self.error = false;
  };
  this.blur = function () {
    setTimeout(function () {
      self.frame.validate();
    }, 10);
  };
  this.focus = function () {
    self.pristine = false;
  };
  this.change = function () {
    self.onChange();
  };
  this.getSelected = function () {
    for (var i = 0; i < self.options.length; i++) {
      if (self.options[i].value == self.selected) {
        return self.options[i];
      }
    }
  };
  this.setDestination = function (option) {
    self.selected = option;
    if (self.input) {
      self.input.value = self.getSelected().name;
    }
    self.change();
  };
  if (self.input) {
    this.input.addEventListener('input', self.change);
    this.input.addEventListener('blur', self.blur);
    this.input.addEventListener('focus', self.focus);
  }
  this.init();
}
Date.prototype.addDays = function (days) {
  var dat = new Date(this.valueOf());
  dat.setDate(dat.getDate() + days);
  return dat;
};
function Period(options) {
  var self = this;
  var defaults = {
    input: null,
    container: null,
    dateContainer: null,
    onDisable: null,
    onEnable: null,
    frame: null,
    pristine: true,
    datePicker: null,
    startDatePicker: true,
    multipleCalendars: true,
    onChange: null,
    onShow: null,
    onError: null,
    error: true,
    dateFormatPrototypeName: null,
    onHide: null,
    date: null,
    min: null,
    max: null,
    mobile: mobilechecker(),
    commonCloseMethod:
    // if not safari or not firefox and so != mac os
    ua.indexOf('safari') == -1 || ua.indexOf('firefox') == -1 && ua.indexOf('mac os') != -1 ||
    // if chrome or mobile
    ua.indexOf('chrome') != -1 || mobilechecker(),
    focusloose: false,
    yPosition: null,
    onSelect: null,
    defaults: {
      min: new Date(),
      max: null,
      multipleCalendars: null,
      startDatePicker: null,
      onHide: null,
      shouldFocusOnRender: true
    }
  };
  extend(this, defaults, options);
  this.init = function () {
    var opts = {};
    extend(opts, self.defaults, {
      multipleCalendars: self.multipleCalendars,
      startDatePicker: self.startDatePicker,
      onHide: self.onHide,
      shouldFocusOnRender: true,
      min: self.min ? self.min : self.defaults.min,
      max: self.max ? self.max : self.defaults.max
    });
    self.datePicker = Object(__WEBPACK_IMPORTED_MODULE_0__date_range_picker_js__["DateRangePicker"])(self.dateContainer, {
      startOpts: opts,
      endOpts: opts
    });
    self.datePicker.on('statechange', function (_, rp) {
      var range = rp.state;
      if (self.startDatePicker) {
        self.date = range.start;
        self.frame.departureDate.hidePicker();
        self.frame.departureDate.datePicker.setSelectedStartDate(self.frame.departureDate.datePicker.state.start);
        if (!self.frame.nullEndDate) {
          self.frame.returningDate.datePicker.setSelectedStartDate(self.frame.departureDate.datePicker.state.start);
          if (!self.frame.nullEndDate && self.frame.returningDate.datePicker.state.start != self.frame.departureDate.datePicker.state.start) {
            self.frame.returningDate.datePicker.setMinDate(self.frame.departureDate.datePicker.state.start);
            self.frame.returningDate.setStartDate(self.frame.departureDate.datePicker.state.start);
            if (self.frame.departureDate.datePicker.state.end && self.frame.departureDate.datePicker.state.start > self.frame.departureDate.datePicker.state.end) {
              self.frame.returningDate.setEndDate(undefined);
              self.frame.departureDate.setEndDate(undefined);
              self.frame.departureDate.datePicker.setSelectedEndDate(undefined);
              self.frame.returningDate.datePicker.setSelectedEndDate(undefined);
              self.frame.returningDate.input.focus();
              if (self.frame.returningDate.input) {
                self.frame.returningDate.input.value = '';
              }
              self.frame.returningDate.date = undefined;
            }
          }
        } else {
          if (self.frame.departureDate.datePicker.state.start != self.frame.departureDate.datePicker.state.end) {
            self.frame.departureDate.setEndDate(self.frame.departureDate.datePicker.state.start);
            self.frame.departureDate.datePicker.setSelectedEndDate(self.frame.departureDate.datePicker.state.start);
          }
        }
      } else {
        if (self.frame.returningDate.datePicker.state.end && self.frame.returningDate.datePicker.state.end != self.frame.departureDate.datePicker.state.end) {
          self.frame.departureDate.setEndDate(self.frame.returningDate.datePicker.state.end);
          self.frame.departureDate.datePicker.setSelectedEndDate(self.frame.returningDate.datePicker.state.end);
          self.frame.returningDate.datePicker.setSelectedEndDate(self.frame.returningDate.datePicker.state.end);
          if (!self.frame.departureDate.datePicker.state.start) {
            self.frame.departureDate.input.focus();
          }
        }
        self.date = range.end;
        self.frame.returningDate.hidePicker();
      }
      self.select();
    });
    setTimeout(function () {
      self.setDatePickersInputs(self.frame.departureDate.input, self.frame.returningDate ? self.frame.returningDate.input : null);
    }, 0);
  };
  this.setDatePickersInputs = function (startInput, endInput) {
    self.datePicker.setInputs(startInput, endInput);
  };
  this.validate = function (ignorePristine) {
    if (self.pristine && !ignorePristine || self.disable) {
      return;
    }
    if (!self.date) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    self.error = false;
  };
  this.setStartDate = function (date) {
    self.datePicker.setState({
      start: date
    });
  };
  this.setMinDate = function (date) {
    self.datePicker.setState({
      min: date
    });
  };
  this.setEndDate = function (date) {
    self.datePicker.setState({
      end: date
    });
  };
  this.showPicker = function () {
    var inputPos = self.input.getBoundingClientRect();
    var cal = self.dateContainer;
    var scrollTop = window.pageYOffset;
    var inputTop = scrollTop + inputPos.top;
    var calHeight = cal.offsetHeight;
    var belowTop = inputTop + inputPos.height + 300;
    var aboveTop = inputTop - calHeight - 300;
    var isAbove = aboveTop > 0 && belowTop + calHeight > scrollTop + window.innerHeight;
    if (isAbove) {
      self.onShow(self.frame, "up");
    } else {
      self.onShow(self.frame, "down");
    }
    setTimeout(function () {
      self.dateContainer.focus();
    }, 10);
  };
  this.hidePicker = function () {
    self.onHide(self.frame);
  };
  this.focus = function (_) {
    self.pristine = false;
    self.showPicker();

    // if (!self.commonCloseMethod) {
    if (!self.mobile && ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1 && ua.indexOf('firefox') != -1) {
      self.clickHandler();
    }
  };
  this.select = function () {
    self.frame.validate();
    self.onSelect(self.frame);
    self.onChange();
  };
  self.clickHandler = function (disable) {
    var body = document.getElementsByTagName('body')[0];
    if (disable) {
      body.removeEventListener('click', dateClickHandler);
      return;
    }
    body.addEventListener('click', dateClickHandler);
  };
  var dateClickHandler = function dateClickHandler(e) {
    if (!self.container.contains(e.target) && e.target.className.indexOf('dp-next') == -1 && e.target.className.indexOf('dp-prev') == -1 && e.target.className.indexOf('dp-day') == -1) {
      self.hidePicker();
      self.clickHandler(true);
    }
  };

  // Closes datepicker when outside click

  // if (self.commonCloseMethod) {
  if (ua.indexOf('safari') == -1 && ua.indexOf('firefox') == -1 && ua.indexOf('mac os') != -1 || ua.indexOf('chrome') != -1 || self.mobile) {
    var previousTimeout;
    self.container.addEventListener('focusout', function () {
      clearTimeout(previousTimeout);
      previousTimeout = setTimeout(function () {
        if (!self.container.contains(document.activeElement)) {
          self.focusloose = true;
          setTimeout(function () {
            self.validate();
          }, 1);
          self.hidePicker();
        }
      }, 0);
    });
  }
  if (this.input) {
    this.input.addEventListener('focus', this.focus);
  }
  this.init();
}
function Name(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: false,
    onError: {},
    onChange: null
  };
  extend(this, defaults, options);
  this.getName = function () {
    return this.input.value;
  };
  this.setName = function (value) {
    this.input.value = value;
  };
  this.validate = function (ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }
    if (!self.getName()) {
      handler('INVALID_VALUE', self);
      self.error = true;
      return;
    }
    self.error = false;
  };
  this.focus = function () {
    self.pristine = false;
  };
  this.blur = function () {
    self.frame.validate();
  };
  this.change = function () {
    self.onChange();
  };
  this.input.addEventListener('focus', this.focus);
  this.input.addEventListener('input', this.change);
  this.input.addEventListener('blur', this.blur);
}
function Email(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: false,
    onError: {},
    onChange: null
  };
  extend(this, defaults, options);
  this.validateEmail = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  this.setEmail = function (value) {
    this.input.value = value;
  };
  this.getEmail = function () {
    var email = "";
    if (self.input.value && self.input.value.indexOf("@") != -1) {
      var d = self.setDomain(self.input.value.split("@")[1]);
      email = self.input.value.split("@")[0] + '@' + d;
    }
    return email;
  };
  this.validate = function (ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }
    if (!self.getEmail()) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    if (!self.validateEmail(self.input.value)) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    self.error = false;
  };
  this.setDomain = function (domain) {
    return domain.indexOf('gmail') != -1 ? 'gmail.com' : domain.indexOf('hotma') != -1 ? 'hotmail.com' : domain.indexOf('outl') != -1 ? 'outlook.com' : domain.indexOf('live') != -1 ? 'live.com' : domain.indexOf('uol') != -1 ? 'uol.com.br' : domain.indexOf('yah') != -1 ? domain.indexOf('br') ? 'yahoo.com.br' : 'yahoo.com' : domain;
  };
  this.blur = function () {
    self.frame.validate();
  };
  this.focus = function () {
    self.pristine = false;
  };
  this.change = function (ev) {
    self.onChange();
  };
  this.input.addEventListener('input', this.change);
  this.input.addEventListener('blur', self.blur);
  this.input.addEventListener('focus', self.focus);
}
function Cellphone(options) {
  var self = this;
  var defaults = {
    input: null,
    pristine: true,
    error: true,
    onError: {},
    onChange: null
  };
  extend(this, defaults, options);
  this.getCellphone = function () {
    return this.input.value.replace("(", "").replace(")", "").replace("-", "");
  };
  this.validate = function (ignorePristine) {
    if (self.pristine && !ignorePristine) {
      return;
    }
    if (!self.getCellphone()) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    if (self.getCellphone().length < 10) {
      handler("INVALID_VALUE", self);
      self.error = true;
      return;
    }
    self.error = false;
  };
  this.blur = function () {
    self.frame.validate();
  };
  this.focus = function () {
    self.pristine = false;
  };
  this.change = function (ev) {
    fMasc(this, mTel);
    self.onChange();
  };
  this.toPhone = function (value) {
    var splited = [value.slice(0, 2), value.length == 11 ? value.slice(2, 7) : value.slice(2, 6), value.length == 11 ? value.slice(7, 12) : value.slice(6, 12)];
    return '(' + splited[0] + ')' + splited[1] + '-' + splited[2];
  };
  this.setPhone = function (value) {
    this.input.value = self.toPhone(value);
  };
  this.input.addEventListener('input', this.change);
  this.input.addEventListener('focus', this.focus);
  this.input.addEventListener('blur', this.blur);
}
(function () {
  /*!eslint-enable */
  if (typeof define === 'function' && __webpack_require__(207)) {
    define('Frame', function () {
      return Frame;
    });
    define('Destination', function () {
      return Destination;
    });
    define('Period', function () {
      return Period;
    });
    define('Cellphone', function () {
      return Cellphone;
    });
    define('Name', function () {
      return Name;
    });
    define('Email', function () {
      return Email;
    });
  } else if (typeof module !== 'undefined' && module.exports) {
    /*!eslint-enable */
    module.exports = {
      Frame: Frame,
      Destination: Destination,
      Period: Period,
      Cellphone: Cellphone,
      Name: Name,
      Email: Email
    };
  } else {
    window.Frame = Frame;
    window.Destination = Destination;
    window.Period = Period;
    window.Cellphone = Cellphone;
    window.Name = Name;
    window.Email = Email;
  }
})();
var exp = {
  Frame: Frame,
  Destination: Destination,
  Period: Period,
  Cellphone: Cellphone,
  Name: Name,
  Email: Email
};
/* harmony default export */ __webpack_exports__["a"] = (exp);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(70)(module)))

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PinIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var PinIcon = function PinIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#007E47" : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12.7489 5.88165C12.7154 4.64752 12.1954 3.47667 11.3022 2.6243C10.4091 1.77194 9.21526 1.30715 7.98091 1.33125C6.74759 1.30365 5.55329 1.76428 4.65793 2.6129C3.76256 3.46152 3.23861 4.62943 3.20011 5.86245C3.08491 8.09605 5.29931 11.3537 7.71211 14.5537C7.74348 14.5912 7.78261 14.6215 7.8268 14.6425C7.87099 14.6635 7.91919 14.6746 7.96811 14.6753C8.01725 14.676 8.06591 14.6654 8.1103 14.6443C8.1547 14.6232 8.19364 14.5922 8.22411 14.5537C10.6369 11.3537 12.8577 8.09605 12.7361 5.86245L12.7489 5.88165ZM7.97451 13.8497C5.76011 10.8801 3.73131 7.85285 3.84011 5.90085C3.86861 4.83308 4.31898 3.82009 5.09264 3.08362C5.8663 2.34714 6.90023 1.94717 7.96811 1.97125C9.0366 1.94715 10.0712 2.34692 10.8459 3.08322C11.6206 3.81953 12.0723 4.83251 12.1025 5.90085C12.2241 7.85285 10.2401 10.8801 7.97451 13.8497Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M7.99992 3.44971C7.51737 3.44971 7.04568 3.59288 6.64455 3.8611C6.24342 4.12932 5.93089 4.51052 5.74652 4.95646C5.56216 5.40239 5.51424 5.893 5.60885 6.36617C5.70345 6.83935 5.93633 7.27382 6.27798 7.61458C6.61964 7.95534 7.05472 8.18707 7.52814 8.28043C8.00157 8.37379 8.49205 8.32459 8.93749 8.13905C9.38294 7.95351 9.76332 7.63998 10.0305 7.23815C10.2976 6.83632 10.4396 6.36425 10.4383 5.88171C10.4366 5.23611 10.179 4.61754 9.72187 4.16163C9.26476 3.70573 8.64551 3.4497 7.99992 3.44971ZM7.99992 7.68011C7.64423 7.68011 7.29652 7.57463 7.00078 7.37702C6.70503 7.17941 6.47453 6.89854 6.33841 6.56993C6.20229 6.24131 6.16668 5.87971 6.23607 5.53086C6.30546 5.182 6.47674 4.86156 6.72826 4.61005C6.97977 4.35854 7.30021 4.18725 7.64907 4.11786C7.99792 4.04847 8.35952 4.08409 8.68813 4.2202C9.01675 4.35632 9.29762 4.58682 9.49523 4.88257C9.69284 5.17831 9.79832 5.52602 9.79832 5.88171C9.79832 6.11788 9.7518 6.35173 9.66142 6.56993C9.57104 6.78812 9.43857 6.98637 9.27158 7.15337C9.10458 7.32036 8.90633 7.45283 8.68813 7.54321C8.46994 7.63359 8.23609 7.68011 7.99992 7.68011Z",
    fill: color
  }));
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CalendarIcon = function CalendarIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#007E47' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size + 1,
    height: size,
    viewBox: "0 0 17 16",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.51855 2.13293H15.7227V13.6932C15.7227 14.3163 15.2177 14.8214 14.5946 14.8214H2.64669C2.02364 14.8214 1.51855 14.3163 1.51855 13.6932V2.13293ZM2.51855 3.13293V13.6932C2.51855 13.764 2.57592 13.8214 2.64669 13.8214H14.5946C14.6654 13.8214 14.7227 13.764 14.7227 13.6932V3.13293H2.51855Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.6084 3.71132V1.17358H5.6084V3.71132H4.6084Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6328 3.71132V1.17358H12.6328V3.71132H11.6328Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M3.9248 10.1212H5.92019V12.1166H3.9248V10.1212Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.0711 5.0896H2.39551V4.0896H15.0711V5.0896Z",
    fill: color
  }));
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_css__);



var Dropdown = function Dropdown(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$contentClassName = _ref.contentClassName,
    contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
    style = _ref.style,
    contentStyle = _ref.contentStyle,
    _ref$closeOnEsc = _ref.closeOnEsc,
    closeOnEsc = _ref$closeOnEsc === void 0 ? true : _ref$closeOnEsc,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'menu' : _ref$role,
    id = _ref.id,
    ariaLabel = _ref.ariaLabel;
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: function onClickOutside() {
        if (isOpen && typeof onClose === 'function') onClose();
      }
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!closeOnEsc) return undefined;
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === 'Escape' && isOpen && typeof onClose === 'function') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose, closeOnEsc]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: containerRef,
    className: "".concat(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.dropdown).concat(isOpen ? " ".concat(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.open) : '').concat(className ? " ".concat(className) : ''),
    style: style,
    id: id,
    "aria-haspopup": "menu",
    "aria-expanded": !!isOpen,
    "aria-label": ariaLabel
  }, isOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.content, " ").concat(contentClassName).trim(),
    style: contentStyle,
    role: role
  }, children));
};
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_ChevronRight_icon__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_css__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var startOfDay = function startOfDay(d) {
  var nd = new Date(d);
  nd.setHours(0, 0, 0, 0);
  return nd;
};
var isSameDay = function isSameDay(a, b) {
  if (!a || !b) return false;
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
var isBefore = function isBefore(a, b) {
  return a.getTime() < b.getTime();
};
var isAfter = function isAfter(a, b) {
  return a.getTime() > b.getTime();
};
var clampDate = function clampDate(date, minDate, maxDate) {
  if (!date) return date;
  var d = date;
  if (minDate && isBefore(d, minDate)) d = minDate;
  if (maxDate && isAfter(d, maxDate)) d = maxDate;
  return d;
};
var addMonths = function addMonths(date, count) {
  var d = new Date(date);
  var day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + count);
  var month = d.getMonth();
  d.setDate(Math.min(day, daysInMonth(d.getFullYear(), month)));
  return d;
};
var daysInMonth = function daysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
};
var startOfMonth = function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
};
var endOfMonth = function endOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
};
var isWithin = function isWithin(date, start, end) {
  if (!date || !start || !end) return false;
  var t = startOfDay(date).getTime();
  var s = startOfDay(start).getTime();
  var e = startOfDay(end).getTime();
  return t >= s && t <= e;
};
var getMonthMatrix = function getMonthMatrix(monthDate) {
  var weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var first = startOfMonth(monthDate);
  var last = endOfMonth(monthDate);
  var offset = (first.getDay() - weekStartsOn + 7) % 7;
  var days = daysInMonth(first.getFullYear(), first.getMonth());
  var cells = [];
  for (var i = 0; i < offset; i++) {
    var d = new Date(first);
    d.setDate(d.getDate() - (offset - i));
    cells.push({
      date: d,
      outside: true
    });
  }
  for (var _i = 1; _i <= days; _i++) {
    var _d = new Date(first.getFullYear(), first.getMonth(), _i);
    cells.push({
      date: _d,
      outside: false
    });
  }
  var total = Math.ceil(cells.length / 7) * 7;
  for (var _i2 = cells.length; _i2 < total; _i2++) {
    var _d2 = new Date(last);
    _d2.setDate(last.getDate() + (_i2 - cells.length) + 1);
    cells.push({
      date: _d2,
      outside: true
    });
  }
  var weeks = [];
  for (var _i3 = 0; _i3 < cells.length; _i3 += 7) weeks.push(cells.slice(_i3, _i3 + 7));
  return weeks;
};
var defaultWeekdayNames = function defaultWeekdayNames() {
  var _locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pt-BR';
  var weekStartsOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var base = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];
  return base.slice(weekStartsOn).concat(base.slice(0, weekStartsOn));
};
var defaultMonthLabel = function defaultMonthLabel(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pt-BR';
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    year: 'numeric'
  }).format(date);
};
var computeNextSelection = function computeNextSelection(_ref) {
  var current = _ref.current,
    clicked = _ref.clicked,
    selectionMode = _ref.selectionMode,
    allowSameDay = _ref.allowSameDay;
  var day = startOfDay(clicked);
  var _ref2 = current || {
      startDate: null,
      endDate: null
    },
    startDate = _ref2.startDate,
    endDate = _ref2.endDate;
  if (selectionMode === 'start') {
    return {
      startDate: day,
      endDate: endDate || null,
      completed: true,
      completedWith: 'start'
    };
  }
  if (selectionMode === 'end') {
    return {
      startDate: startDate || null,
      endDate: day,
      completed: true,
      completedWith: 'end'
    };
  }
  if (startDate && endDate) {
    return {
      startDate: day,
      endDate: null,
      completed: false
    };
  }
  if (!startDate) {
    return {
      startDate: day,
      endDate: null,
      completed: false
    };
  }
  if (isAfter(day, startDate) || allowSameDay && isSameDay(day, startDate)) {
    return {
      startDate: startDate,
      endDate: day,
      completed: true,
      completedWith: 'range'
    };
  }
  return {
    startDate: day,
    endDate: null,
    completed: false
  };
};
var Day = function Day(_ref3) {
  var date = _ref3.date,
    outside = _ref3.outside,
    isToday = _ref3.isToday,
    disabled = _ref3.disabled,
    isStart = _ref3.isStart,
    isEnd = _ref3.isEnd,
    inRange = _ref3.inRange,
    onClick = _ref3.onClick,
    onMouseEnter = _ref3.onMouseEnter;
  var classNames = [__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.day];
  if (outside) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.outside);
  if (isToday) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.today);
  if (disabled) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.disabled);
  if (inRange) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.inRange);
  if (isStart) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.start);
  if (isEnd) classNames.push(__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.end);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: classNames.join(' '),
    onClick: disabled ? undefined : function () {
      return onClick(date);
    },
    onMouseEnter: disabled ? undefined : function () {
      return onMouseEnter && onMouseEnter(date);
    },
    "aria-pressed": isStart || isEnd || inRange || undefined,
    "aria-disabled": disabled || undefined,
    tabIndex: disabled ? -1 : 0
  }, date.getDate());
};
var MonthView = function MonthView(_ref4) {
  var monthDate = _ref4.monthDate,
    weekStartsOn = _ref4.weekStartsOn,
    locale = _ref4.locale,
    selection = _ref4.selection,
    hoverDate = _ref4.hoverDate,
    isDateDisabled = _ref4.isDateDisabled,
    onDayClick = _ref4.onDayClick,
    onDayHover = _ref4.onDayHover;
  var today = startOfDay(new Date());
  var weeks = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return getMonthMatrix(monthDate, weekStartsOn);
  }, [monthDate, weekStartsOn]);
  var renderDay = function renderDay(cell) {
    var d = cell.date;
    var outside = cell.outside;
    if (outside) {
      // Do not show outside days; keep grid alignment with a placeholder cell
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: d.toISOString(),
        className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.placeholder,
        "aria-hidden": true
      });
    }
    var disabled = isDateDisabled ? isDateDisabled(d) : false;
    var isToday = isSameDay(d, today);
    var _ref5 = selection || {
        startDate: null,
        endDate: null
      },
      startDate = _ref5.startDate,
      endDate = _ref5.endDate;
    var isStart = !!startDate && isSameDay(d, startDate);
    var isEnd = !!endDate && isSameDay(d, endDate);
    var inRange = false;
    if (startDate && endDate) {
      inRange = isWithin(d, startDate, endDate);
    } else if (startDate && hoverDate) {
      var s = isBefore(hoverDate, startDate) ? hoverDate : startDate;
      var e = isAfter(hoverDate, startDate) ? hoverDate : startDate;
      inRange = isWithin(d, s, e);
    }
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Day, {
      key: d.toISOString(),
      date: d,
      outside: outside,
      isToday: isToday,
      disabled: disabled,
      isStart: isStart,
      isEnd: isEnd,
      inRange: inRange,
      onClick: onDayClick,
      onMouseEnter: onDayHover
    });
  };
  var weekdayShort = defaultWeekdayNames(locale, weekStartsOn);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.month,
    "aria-label": defaultMonthLabel(monthDate, locale)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.weekdays
  }, weekdayShort.map(function (w) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: w,
      className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.weekday,
      "aria-hidden": true
    }, w);
  })), weeks.map(function (week, idx) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.week,
      key: idx,
      role: "row"
    }, week.map(renderDay));
  }));
};

/**
 * DatePicker component
 * Props:
 * - selectionMode: 'range' | 'start' | 'end' (default 'range')
 * - value: { startDate: Date|null, endDate: Date|null } (controlled)
 * - defaultValue: same shape (uncontrolled)
 * - onChange(selection, meta)
 * - onComplete(selection, meta) called when selection is complete
 * - minDate, maxDate: Date
 * - isDateDisabled: (date: Date) => boolean
 * - weekStartsOn: 0-6 (0=Sun)
 * - locale: BCP47 string (e.g., 'pt-BR')
 * - numberOfMonths: number (default 1)
 * - initialMonth: Date
 * - allowSameDay: boolean (default false)
 */
var DatePicker = function DatePicker(_ref6) {
  var _ref6$selectionMode = _ref6.selectionMode,
    selectionMode = _ref6$selectionMode === void 0 ? 'range' : _ref6$selectionMode,
    value = _ref6.value,
    defaultValue = _ref6.defaultValue,
    onChange = _ref6.onChange,
    onComplete = _ref6.onComplete,
    minDate = _ref6.minDate,
    maxDate = _ref6.maxDate,
    isDateDisabledProp = _ref6.isDateDisabled,
    _ref6$weekStartsOn = _ref6.weekStartsOn,
    weekStartsOn = _ref6$weekStartsOn === void 0 ? 0 : _ref6$weekStartsOn,
    _ref6$locale = _ref6.locale,
    locale = _ref6$locale === void 0 ? 'pt-BR' : _ref6$locale,
    _ref6$numberOfMonths = _ref6.numberOfMonths,
    numberOfMonths = _ref6$numberOfMonths === void 0 ? 1 : _ref6$numberOfMonths,
    initialMonth = _ref6.initialMonth,
    _ref6$allowSameDay = _ref6.allowSameDay,
    allowSameDay = _ref6$allowSameDay === void 0 ? false : _ref6$allowSameDay,
    className = _ref6.className,
    customHeaderClassName = _ref6.customHeaderClassName,
    _ref6$variant = _ref6.variant,
    variant = _ref6$variant === void 0 ? 'fullscreen' : _ref6$variant,
    style = _ref6.style;
  var isControlled = value !== undefined;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
      var initial = value || defaultValue || {
        startDate: null,
        endDate: null
      };
      return {
        startDate: initial.startDate ? startOfDay(initial.startDate) : null,
        endDate: initial.endDate ? startOfDay(initial.endDate) : null
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    internalSelection = _useState2[0],
    setInternalSelection = _useState2[1];
  var selection = isControlled ? value : internalSelection;
  var normalizedMin = minDate ? startOfDay(minDate) : null;
  var normalizedMax = maxDate ? startOfDay(maxDate) : null;
  var today = startOfDay(new Date());
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
      var base = initialMonth || selection && selection.startDate || today;
      var clamped = clampDate(base, normalizedMin, normalizedMax) || today;
      return startOfMonth(clamped);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMonth = _useState4[0],
    setCurrentMonth = _useState4[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var startSel = selection ? selection.startDate : null;
    if (startSel) {
      var m = startOfMonth(startSel);
      if (!isSameDay(m, startOfMonth(currentMonth))) {
        setCurrentMonth(m);
      }
    }
  }, [selection && selection.startDate]);
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState6 = _slicedToArray(_useState5, 2),
    hoverDate = _useState6[0],
    setHoverDate = _useState6[1];
  var isDateDisabled = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (date) {
    var d = startOfDay(date);
    if (normalizedMin && isBefore(d, normalizedMin)) return true;
    if (normalizedMax && isAfter(d, normalizedMax)) return true;
    if (typeof isDateDisabledProp === 'function' && isDateDisabledProp(d)) return true;
    return false;
  }, [normalizedMin, normalizedMax, isDateDisabledProp]);
  var commitSelection = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (next, meta) {
    var payload = {
      startDate: next.startDate || null,
      endDate: next.endDate || null
    };
    if (!isControlled) setInternalSelection(payload);
    if (onChange) onChange(payload, meta);
    if (next.completed && onComplete) onComplete(payload, meta);
  }, [isControlled, onChange, onComplete]);
  var handleDayClick = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (date) {
    if (isDateDisabled(date)) return;
    var next = computeNextSelection({
      current: selection,
      clicked: date,
      selectionMode: selectionMode,
      allowSameDay: allowSameDay
    });
    commitSelection(next, {
      source: 'day-click'
    });
  }, [selection, selectionMode, allowSameDay, isDateDisabled, commitSelection]);
  var handleDayHover = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (date) {
    if (isDateDisabled(date)) return;
    setHoverDate(startOfDay(date));
  }, [isDateDisabled]);
  var goPrev = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    return setCurrentMonth(function (m) {
      return addMonths(m, -1);
    });
  }, []);
  var goNext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    return setCurrentMonth(function (m) {
      return addMonths(m, 1);
    });
  }, []);
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var months = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return new Array(Math.max(1, numberOfMonths)).fill(0).map(function (_, i) {
      return addMonths(currentMonth, i);
    });
  }, [currentMonth, numberOfMonths]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: [__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.datepicker, variant === 'inline' ? __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.inline : '', className].filter(Boolean).join(' '),
    style: style,
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: [__WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.header, customHeaderClassName].filter(Boolean).join(' ')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.nav,
    onClick: goPrev,
    "aria-label": "M\xEAs anterior"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
    size: 16,
    color: "#007E47",
    rotate: 180
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.monthLabels
  }, months.map(function (m, i) {
    var full = defaultMonthLabel(m, locale); // e.g. "outubro de 2024" ou "outubro 2024"
    // Tentar extrair ano (4 dígitos). Mantém mês com capitalização original.
    var match = full.match(/^(.*?)(?:\s+de\s+)?(\d{4})$/i);
    if (!match) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: i,
        className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.monthLabel,
        "aria-live": "polite"
      }, full);
    }
    var monthText = match[1].trim();
    var yearText = match[2];
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: i,
      className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.monthLabel,
      "aria-live": "polite"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, monthText, " "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.monthYear
    }, yearText));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.nav,
    onClick: goNext,
    "aria-label": "Pr\xF3ximo m\xEAs"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
    size: 16,
    color: "#007E47"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.body
  }, months.map(function (m) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthView, {
      key: "".concat(m.getFullYear(), "-").concat(m.getMonth()),
      monthDate: m,
      weekStartsOn: weekStartsOn,
      locale: locale,
      selection: selection,
      hoverDate: hoverDate,
      isDateDisabled: isDateDisabled,
      onDayClick: handleDayClick,
      onDayHover: handleDayHover
    });
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "15",
    viewBox: "0 0 14 15"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M13.746 13.433l-2.886-3.05c.812-1.092 1.3-2.464 1.3-3.957C12.16 2.883 9.433 0 6.08 0 2.729 0 0 2.883 0 6.426c0 3.542 2.886 6.203 6.239 6.203 1.313 0 2.37-.225 3.365-.977l2.913 3.079c.17.179.392.269.615.269.222 0 .444-.09.614-.27.339-.357.339-.938 0-1.297zM1.736 6.426c0-2.53 1.95-4.59 4.345-4.59 2.394 0 4.342 2.06 4.342 4.59s-1.79 4.625-4.184 4.625c-2.395 0-4.502-2.094-4.502-4.625z"
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (SearchIcon);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppliedCouponTag; });
var AppliedCouponTag = {
  src: '/assets/images/icons/tags/coupon.svg',
  alt: 'tag-coupon',
  className: 'tag-coupon',
  label: 'Cupom aplicado'
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HoverTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_module_css__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_module_css__);


function HoverTooltip(_ref) {
  var content = _ref.content,
    _ref$anchorPercent = _ref.anchorPercent,
    anchorPercent = _ref$anchorPercent === void 0 ? 50 : _ref$anchorPercent,
    anchorProgress = _ref.anchorProgress,
    _ref$thumbPx = _ref.thumbPx,
    thumbPx = _ref$thumbPx === void 0 ? 28 : _ref$thumbPx,
    _ref$offsetY = _ref.offsetY,
    offsetY = _ref$offsetY === void 0 ? -12 : _ref$offsetY,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children;
  var percent = Math.max(0, Math.min(100, anchorPercent));
  var progress = typeof anchorProgress === 'number' ? Math.max(0, Math.min(1, anchorProgress)) : percent / 100;
  var style = {
    '--anchor-x': "".concat(percent, "%"),
    // legacy/fallback
    '--progress': progress,
    '--thumb': "".concat(thumbPx, "px"),
    '--offset-y': "".concat(offsetY, "px")
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a.wrapper, " ").concat(className),
    style: style
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a.anchor
  }, children), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a.tooltip,
    role: "tooltip"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a.tooltipInner
  }, content), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a.arrow
  })));
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TooltipIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TooltipIcon = function TooltipIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#2E2E2E" : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    "clip-path": "url(#clip0_4_20653)"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 1.76514C5.51269 1.76514 1.875 5.40282 1.875 9.89014C1.875 14.3774 5.51269 18.0151 10 18.0151C14.4873 18.0151 18.125 14.3774 18.125 9.89014C18.125 5.40282 14.4873 1.76514 10 1.76514ZM0.625 9.89014C0.625 4.71247 4.82233 0.515137 10 0.515137C15.1777 0.515137 19.375 4.71247 19.375 9.89014C19.375 15.0678 15.1777 19.2651 10 19.2651C4.82233 19.2651 0.625 15.0678 0.625 9.89014Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 8.76748C10.4142 8.76748 10.75 9.10327 10.75 9.51748V14.5175C10.75 14.9317 10.4142 15.2675 10 15.2675C9.58579 15.2675 9.25 14.9317 9.25 14.5175V9.51748C9.25 9.10327 9.58579 8.76748 10 8.76748Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M10.9972 6.47995C10.9972 7.03082 10.5507 7.47738 9.99981 7.47738C9.44894 7.47738 9.00238 7.03082 9.00238 6.47995C9.00238 5.92909 9.44894 5.48252 9.99981 5.48252C10.5507 5.48252 10.9972 5.92909 10.9972 6.47995Z",
    fill: color
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath", {
    id: "clip0_4_20653"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
    width: "20",
    height: "20",
    fill: "white"
  }))));
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SalaVipIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SalaVipIcon = function SalaVipIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#5A539C' : _ref$color,
    className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size * 13.3 / 11.9667,
    height: size,
    viewBox: "0 0 13.3 11.9667",
    fill: "none",
    className: className
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M11.3167 4.31667V1.98333C11.3167 1.62971 11.1762 1.29057 10.9261 1.04052C10.6761 0.790476 10.337 0.65 9.98333 0.65H3.31667C2.96304 0.65 2.62391 0.790476 2.37386 1.04052C2.12381 1.29057 1.98333 1.62971 1.98333 1.98333V4.31667",
    stroke: color,
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0.65 8.65C0.65 9.00362 0.790476 9.34276 1.04052 9.59281C1.29057 9.84286 1.62971 9.98333 1.98333 9.98333H11.3167C11.6703 9.98333 12.0094 9.84286 12.2595 9.59281C12.5095 9.34276 12.65 9.00362 12.65 8.65V5.98333C12.65 5.62971 12.5095 5.29057 12.2595 5.04052C12.0094 4.79048 11.6703 4.65 11.3167 4.65C10.963 4.65 10.6239 4.79048 10.3739 5.04052C10.1238 5.29057 9.98333 5.62971 9.98333 5.98333V6.98333H3.31667V5.98333C3.31667 5.62971 3.17619 5.29057 2.92614 5.04052C2.67609 4.79048 2.33696 4.65 1.98333 4.65C1.62971 4.65 1.29057 4.79048 1.04052 5.04052C0.790476 5.29057 0.65 5.62971 0.65 5.98333V8.65Z",
    stroke: color,
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M2.31667 9.98333V11.3167",
    stroke: color,
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M10.9833 9.98333V11.3167",
    stroke: color,
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChipInternacionalIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ChipInternacionalIcon = function ChipInternacionalIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#5A539C' : _ref$color,
    className = _ref.className;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size * 11.8946 / 17.3,
    height: size,
    viewBox: "0 0 11.8946 17.3",
    fill: "none",
    className: className
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M2.37973 0.65H6.87703C7.33504 0.651931 7.77359 0.835437 8.09649 1.16027L10.7343 3.79811C11.0592 4.12101 11.2427 4.55956 11.2446 5.01757V14.9203C11.2446 15.379 11.0624 15.819 10.738 16.1434C10.4136 16.4678 9.97362 16.65 9.51487 16.65H2.37973C1.92098 16.65 1.48101 16.4678 1.15663 16.1434C0.832239 15.819 0.65 15.379 0.65 14.9203V2.37973C0.65 1.92098 0.832239 1.48101 1.15663 1.15663C1.48101 0.832239 1.92098 0.65 2.37973 0.65Z",
    stroke: color,
    strokeWidth: "1.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M5.83877 7.29828C7.54026 7.29828 8.9196 8.67789 8.91982 10.3793C8.91982 12.081 7.5404 13.4604 5.83877 13.4604C4.13732 13.4602 2.75771 12.0808 2.75771 10.3793C2.75794 8.67803 4.13746 7.2985 5.83877 7.29828Z",
    stroke: color,
    strokeWidth: "0.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M5.83959 7.29828C6.13354 7.2984 6.38148 7.4375 6.57201 7.6225C6.76076 7.80582 6.91324 8.05201 7.03197 8.32465C7.26978 8.871 7.40692 9.59777 7.40697 10.3793C7.40697 11.1611 7.26986 11.8885 7.03197 12.435C6.91324 12.7076 6.76076 12.9538 6.57201 13.1371C6.38149 13.3221 6.13351 13.4603 5.83959 13.4604C5.54544 13.4604 5.29681 13.3222 5.10619 13.1371C4.91743 12.9538 4.76593 12.7076 4.6472 12.435C4.40923 11.8885 4.27123 11.1613 4.27123 10.3793C4.27127 9.59763 4.40931 8.87103 4.6472 8.32465C4.76593 8.05201 4.91743 7.80582 5.10619 7.6225C5.29681 7.43737 5.54541 7.29828 5.83959 7.29828Z",
    stroke: color,
    strokeWidth: "0.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M3.28783 9.60133H8.39053M3.28783 11.1581H8.39053",
    stroke: color,
    strokeWidth: "0.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);




var SpecialistBlock = function SpecialistBlock(_ref) {
  var showSpecialistSuggestions = _ref.showSpecialistSuggestions,
    toggleSpecialistSuggestion = _ref.toggleSpecialistSuggestion;
  var handleCheckboxChange = function handleCheckboxChange() {
    toggleSpecialistSuggestion();
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "specialist-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "text-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "N\xE3o sabe qual plano escolher?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Nossos especialistas indicam os planos mais completos para sua viagem.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "activate-block"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("label", {
    className: "custom-checkbox"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input", {
    type: "checkbox",
    checked: showSpecialistSuggestions,
    onChange: handleCheckboxChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: "checkmark"
  }), "Ativar recomenda\xE7\xE3o")));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    showSpecialistSuggestions: state.search.showSpecialistSuggestions
  };
}, {
  toggleSpecialistSuggestion: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["B" /* toggleSpecialistSuggestion */]
})(SpecialistBlock)));

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_5PNsw","headerContainer":"_2Wc8J","header":"_3bJ4u","title":"_1pKRg","description":"yaZTB","valueBubble":"TW7f-","sliderWrap":"ef97g","slider":"EQOgf","helper":"_3L448","value":"_1j3JM","currencySymbol":"_1NgWk","checkboxList":"_3NU6P","checkboxItem":"_3jJa0","checkboxLabel":"_3LAYK","checkboxInput":"_1mtnk","checkboxText":"_1pQQf","checkboxTextFlex":"_1yjsr","checkboxLabelText":"_--NSR","newTagIcon":"_1giJ6","divider":"_6QMx9","showMoreBtn":"_2xSOx","radioList":"_3TMkg","radioLabel":"kboyq","radioInput":"bmpXB","radioText":"hvDQv"};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_NewTag_icon__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_css__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }





function CheckBoxFilterBase(_ref) {
  var filterCategory = _ref.filterCategory,
    filterProvider = _ref.filterProvider,
    unselectFilterCategoryOptions = _ref.unselectFilterCategoryOptions,
    applyFilterCategories = _ref.applyFilterCategories,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? 'category' : _ref$source,
    _ref$matchIds = _ref.matchIds,
    matchIds = _ref$matchIds === void 0 ? [] : _ref$matchIds,
    _ref$providerSlugs = _ref.providerSlugs,
    providerSlugs = _ref$providerSlugs === void 0 ? [] : _ref$providerSlugs,
    title = _ref.title,
    ariaLabel = _ref.ariaLabel,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
    _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange,
    _ref$priorityProvider = _ref.priorityProviderSlugs,
    priorityProviderSlugs = _ref$priorityProvider === void 0 ? [] : _ref$priorityProvider;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
    _useState2 = _slicedToArray(_useState, 2),
    stagedSelections = _useState2[0],
    setStagedSelections = _useState2[1];
  var categoryIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (source !== 'category') return -1;
    if (!Array.isArray(filterCategory)) return -1;
    var toKey = function toKey(v) {
      return v == null ? '' : String(v);
    };
    var idsArr = Array.isArray(matchIds) ? matchIds : [matchIds];
    var idsSet = new Set(idsArr.map(toKey));
    if (idsSet.size === 0) return -1;
    var idOf = function idOf(cat) {
      if (!cat) return undefined;
      if (cat.ID !== undefined) return cat.ID;
      if (cat.Id !== undefined) return cat.Id;
      return cat.id;
    };
    return filterCategory.findIndex(function (cat) {
      return idsSet.has(toKey(idOf(cat)));
    });
  }, [source, filterCategory, matchIds]);
  var categoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (source !== 'category') return [];
    if (categoryIndex < 0) return [];
    var cat = filterCategory[categoryIndex];
    if (!cat || !Array.isArray(cat.Categories)) return [];
    return cat.Categories.map(function (opt, optionIndex) {
      var key = "category-".concat(categoryIndex, "-").concat(optionIndex);
      var reduxSelected = Boolean(opt && opt.selected);
      var selected = useStagingMode && stagedSelections[key] !== undefined ? stagedSelections[key] : reduxSelected;
      return {
        optionIndex: optionIndex,
        label: opt && (opt.Name || opt.Value) || '',
        selected: selected,
        isNew: Boolean(opt && opt.is_new),
        type: 'category',
        categoryIndex: categoryIndex
      };
    });
  }, [source, filterCategory, categoryIndex, useStagingMode, stagedSelections]);
  var providersOptions = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (source !== 'provider') return [];
    var list = Array.isArray(filterProvider) ? filterProvider : [];
    var slugSet = new Set((Array.isArray(providerSlugs) ? providerSlugs : [providerSlugs]).filter(Boolean));
    var filtered = slugSet.size > 0 ? list.filter(function (p) {
      return slugSet.has(p.slug);
    }) : list;
    var mapped = filtered.map(function (p, idx) {
      var key = "provider-".concat(idx);
      var reduxSelected = Boolean(p.selected);
      var selected = useStagingMode && stagedSelections[key] !== undefined ? stagedSelections[key] : reduxSelected;
      var priorityIndex = priorityProviderSlugs.indexOf(p.slug);
      var priority = priorityIndex >= 0 ? priorityIndex : priorityProviderSlugs.length + idx;
      return {
        optionIndex: idx,
        label: p.name || p.slug || '',
        slug: p.slug || '',
        selected: selected,
        isNew: Boolean(p.is_new),
        type: 'provider',
        priority: priority
      };
    });
    return mapped.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }, [source, filterProvider, providerSlugs, useStagingMode, stagedSelections, priorityProviderSlugs]);
  var sortedOptions = source === 'provider' ? providersOptions : categoryOptions;
  var onToggle = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (option) {
    if (!option) return;
    if (useStagingMode) {
      var key = source === 'provider' ? "provider-".concat(option.optionIndex) : "category-".concat(option.categoryIndex, "-").concat(option.optionIndex);
      setStagedSelections(function (prev) {
        var newState = _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, !option.selected));
        if (onStageChange) {
          onStageChange({
            source: source,
            categoryIndex: option.categoryIndex,
            optionIndex: option.optionIndex,
            newState: newState
          });
        }
        return newState;
      });
    } else {
      if (source === 'provider') {
        unselectFilterCategoryOptions('provider', option.optionIndex, 0);
        applyFilterCategories();
        return;
      }
      if (source === 'category') {
        if (option.categoryIndex < 0) return;
        unselectFilterCategoryOptions('category', option.categoryIndex, option.optionIndex);
        applyFilterCategories();
      }
    }
  }, [source, unselectFilterCategoryOptions, applyFilterCategories, useStagingMode, onStageChange]);
  if (sortedOptions.length === 0) return null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.container
  }, title ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.title
  }, title)) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxList,
    role: "group",
    "aria-label": ariaLabel || title
  }, sortedOptions.map(function (opt) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: "".concat(source, "-").concat(opt.optionIndex),
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxItem
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxLabel
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "checkbox",
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxInput,
      checked: opt.selected,
      onChange: function onChange() {
        return onToggle(opt);
      },
      "aria-checked": opt.selected,
      "aria-label": opt.label
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxText
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxTextFlex
    }, source === 'provider' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: "/assets/images/seguradoras/small/".concat(opt.slug, ".svg"),
      alt: opt.label || ''
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.checkboxLabelText
    }, opt.label), opt.isNew && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__assets_icons_NewTag_icon__["a" /* NewTagIcon */], null)))));
  })), showDivider ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.divider
  }) : null);
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  unselectFilterCategoryOptions: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["D" /* unselectFilterCategoryOptions */],
  applyFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["b" /* applyFilterCategories */]
})(CheckBoxFilterBase));

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var getCouponDiscount = function getCouponDiscount(total, subtotal) {
  return total < subtotal ? "".concat((100 - total / subtotal * 100).toFixed(), "% off no cupom") : '';
};
var getPaymentMethodDiscount = function getPaymentMethodDiscount(paymentMethod) {
  return paymentMethod && paymentMethod.discount > 0 ? "".concat(paymentMethod.discount, "% off para ").concat(paymentMethod.name) : '';
};
var DiscountBlock = function DiscountBlock(_ref) {
  var paymentMethods = _ref.paymentMethods,
    purchaseSummary = _ref.purchaseSummary,
    paymentMethodSlug = _ref.paymentMethodSlug;
  var subtotal = purchaseSummary.subtotal,
    total = purchaseSummary.total,
    coupon_discount = purchaseSummary.coupon_discount;
  var paymentMethod = paymentMethods.find(function (method) {
    return method.slug === paymentMethodSlug;
  });
  var couponDiscount = coupon_discount > 0 ? getCouponDiscount(total, subtotal) : '';
  var paymentMethodDiscount = getPaymentMethodDiscount(paymentMethod);
  var discounts = [couponDiscount, paymentMethodDiscount].filter(Boolean).join(' + ');
  if (!discounts) return '';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "discount"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("s", null, "R$ $", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(subtotal)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, " ($", discounts, ")"));
};
/* harmony default export */ __webpack_exports__["a"] = (DiscountBlock);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var calculateTotal = function calculateTotal(subtotal, couponDiscount, methodDiscountPercentage, total) {
  var methodDiscount = methodDiscountPercentage * total;
  return subtotal - couponDiscount - methodDiscount;
};
var PriceBlock = function PriceBlock(_ref) {
  var paymentMethods = _ref.paymentMethods,
    purchaseSummary = _ref.purchaseSummary,
    paymentMethodSlug = _ref.paymentMethodSlug;
  var subtotal = purchaseSummary.subtotal,
    coupon_discount = purchaseSummary.coupon_discount,
    total = purchaseSummary.total;
  var paymentMethod = paymentMethods.find(function (method) {
    return method.slug === paymentMethodSlug;
  });
  var methodDiscountPercentage = paymentMethod && paymentMethod.discount ? paymentMethod.discount / 100 : 0;
  var finalTotal = coupon_discount > 0 ? calculateTotal(subtotal, coupon_discount, methodDiscountPercentage, total) : calculateTotal(subtotal, 0, methodDiscountPercentage, subtotal);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "price"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Total:"), " R$ ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(finalTotal)));
};
/* harmony default export */ __webpack_exports__["a"] = (PriceBlock);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var DiscountFlagImage = function DiscountFlagImage(_ref) {
  var paymentMethod = _ref.paymentMethod,
    content = _ref.content,
    imgData = _ref.imgData;
  if (paymentMethod.discount > 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "text-method-payment"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: paymentMethod["class"]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "container-infos-payment flex"
    }, content, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "discount-flag before img-provider",
      "data-discount": paymentMethod.discount + '% de desconto'
    }, imgData ? imgData : null))));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-method-payment"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: paymentMethod["class"]
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container-infos-payment flex"
  }, content, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "img-provider",
    style: {
      paddingTop: '20px',
      marginLeft: '15px'
    }
  }, imgData ? imgData : null))));
};
/* harmony default export */ __webpack_exports__["a"] = (DiscountFlagImage);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export helpers */
/* unused harmony export setPolyfills */
/* harmony export (immutable) */ __webpack_exports__["b"] = configureCache;
/* unused harmony export clearCache */
/* harmony export (immutable) */ __webpack_exports__["c"] = refreshFeatures;
/* harmony export (immutable) */ __webpack_exports__["e"] = unsubscribe;
/* unused harmony export onHidden */
/* unused harmony export onVisible */
/* harmony export (immutable) */ __webpack_exports__["a"] = clearAutoRefresh;
/* harmony export (immutable) */ __webpack_exports__["d"] = startBackgroundSync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mjs__ = __webpack_require__(17);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

// Config settings
var cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  // Max time to keep a fetch in cache (4 hours default)
  maxAge: 1000 * 60 * 60 * 4,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true,
  maxEntries: 10,
  disableIdleStreams: false,
  idleStreamInterval: 20000,
  disableCache: false
};
var polyfills = Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["f" /* getPolyfills */])();
var helpers = {
  fetchFeaturesCall: function fetchFeaturesCall(_ref) {
    var host = _ref.host,
      clientKey = _ref.clientKey,
      headers = _ref.headers;
    return polyfills.fetch("".concat(host, "/api/features/").concat(clientKey), {
      headers: headers
    });
  },
  fetchRemoteEvalCall: function fetchRemoteEvalCall(_ref2) {
    var host = _ref2.host,
      clientKey = _ref2.clientKey,
      payload = _ref2.payload,
      headers = _ref2.headers;
    var options = {
      method: "POST",
      headers: _objectSpread({
        "Content-Type": "application/json"
      }, headers),
      body: JSON.stringify(payload)
    };
    return polyfills.fetch("".concat(host, "/api/eval/").concat(clientKey), options);
  },
  eventSourceCall: function eventSourceCall(_ref3) {
    var host = _ref3.host,
      clientKey = _ref3.clientKey,
      headers = _ref3.headers;
    if (headers) {
      return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey), {
        headers: headers
      });
    }
    return new polyfills.EventSource("".concat(host, "/sub/").concat(clientKey));
  },
  startIdleListener: function startIdleListener() {
    var idleTimeout;
    var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
    if (!isBrowser) return;
    var onVisibilityChange = function onVisibilityChange() {
      if (document.visibilityState === "visible") {
        window.clearTimeout(idleTimeout);
        onVisible();
      } else if (document.visibilityState === "hidden") {
        idleTimeout = window.setTimeout(onHidden, cacheSettings.idleStreamInterval);
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    return function () {
      return document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  },
  stopIdleListener: function stopIdleListener() {
    // No-op, replaced by startIdleListener
  }
};
try {
  if (globalThis.localStorage) {
    polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
var subscribedInstances = new Map();
var cacheInitialized = false;
var cache = new Map();
var activeFetches = new Map();
var streams = new Map();
var pollers = new Map();
var supportsSSE = new Set();
var streamingWarnings = new Set();

// Public functions
function setPolyfills(overrides) {
  Object.assign(polyfills, overrides);
}
function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
function clearCache() {
  return _clearCache.apply(this, arguments);
}

// Get or fetch features and refresh the SDK instance
function _clearCache() {
  _clearCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          cache.clear();
          activeFetches.clear();
          clearAutoRefresh();
          cacheInitialized = false;
          _context.n = 1;
          return updatePersistentCache();
        case 1:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _clearCache.apply(this, arguments);
}
function refreshFeatures(_x) {
  return _refreshFeatures.apply(this, arguments);
}

// Subscribe a GrowthBook instance to feature changes
function _refreshFeatures() {
  _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4) {
    var instance, timeout, skipCache, allowStale, backgroundSync;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          instance = _ref4.instance, timeout = _ref4.timeout, skipCache = _ref4.skipCache, allowStale = _ref4.allowStale, backgroundSync = _ref4.backgroundSync;
          if (!backgroundSync) {
            cacheSettings.backgroundSync = false;
          }
          return _context2.a(2, fetchFeaturesWithCache({
            instance: instance,
            allowStale: allowStale,
            timeout: timeout,
            skipCache: skipCache
          }));
      }
    }, _callee2);
  }));
  return _refreshFeatures.apply(this, arguments);
}
function subscribe(instance) {
  var key = getKey(instance);
  var subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
function unsubscribe(instance) {
  subscribedInstances.forEach(function (s, key) {
    s["delete"](instance);
    // Nothing left to refresh, so stop polling this key
    var poller = s.size ? undefined : pollers.get(key);
    if (poller) destroyPoller(poller, key);
  });
}
function onHidden() {
  streams.forEach(function (channel) {
    if (!channel) return;
    channel.state = "idle";
    disableChannel(channel);
  });
}
function onVisible() {
  streams.forEach(function (channel) {
    if (!channel) return;
    if (channel.state !== "idle") return;
    enableChannel(channel);
  });
}

// Private functions

var MAX_BACKOFF_MS = 1000 * 60 * 5;

// Exponential backoff. Jitter is proportional rather than flat, so that clients retrying
// against the same host spread out instead of bunching at the same offset.
function backoffDelay(base, factor, attempt) {
  return Math.min(base * Math.pow(factor, attempt) * (1 + Math.random()), MAX_BACKOFF_MS);
}

// The only place the SDK warns directly rather than through the env-gated instance.log().
// log() is debug-only, so routing a misconfiguration through it would hide the problem from
// exactly the production users it affects. Diagnostics still belong in instance.log().
function warnMisconfiguration(message) {
  console.warn("[GrowthBook] ".concat(message));
}

// Deduped per reason, so a process warns once about each distinct cause
function warnStreamingUnavailable(reason) {
  if (streamingWarnings.has(reason)) return;
  streamingWarnings.add(reason);
  warnMisconfiguration("Streaming is enabled, but not active: ".concat(reason, ". Features will not be updated in the background. Set `pollingInterval` to refresh on a timer instead, or see https://docs.growthbook.io/lib/node#refreshing-features"));
}
function updatePersistentCache() {
  return _updatePersistentCache.apply(this, arguments);
} // SWR wrapper for fetching features. May indirectly or directly start SSE streaming.
function _updatePersistentCache() {
  _updatePersistentCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var _t;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          if (polyfills.localStorage) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          _context3.n = 2;
          return polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
        case 2:
          _context3.n = 4;
          break;
        case 3:
          _context3.p = 3;
          _t = _context3.v;
        case 4:
          return _context3.a(2);
      }
    }, _callee3, null, [[0, 3]]);
  }));
  return _updatePersistentCache.apply(this, arguments);
}
function fetchFeaturesWithCache(_x2) {
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function _fetchFeaturesWithCache() {
  _fetchFeaturesWithCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref5) {
    var instance, allowStale, timeout, skipCache, key, cacheKey, now, minStaleAt, existing, res;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          instance = _ref5.instance, allowStale = _ref5.allowStale, timeout = _ref5.timeout, skipCache = _ref5.skipCache;
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          now = new Date();
          minStaleAt = new Date(now.getTime() - cacheSettings.maxAge + cacheSettings.staleTTL);
          _context4.n = 1;
          return initializeCache();
        case 1:
          existing = !cacheSettings.disableCache && !skipCache ? cache.get(cacheKey) : undefined;
          if (!(existing && (allowStale || existing.staleAt > now) && existing.staleAt > minStaleAt)) {
            _context4.n = 2;
            break;
          }
          // Restore from cache whether SSE is supported
          if (existing.sse) supportsSSE.add(key);

          // Reload features in the background if stale
          if (existing.staleAt < now) {
            fetchFeatures(instance);
          }
          // Otherwise, if we don't need to refresh now, start a background sync
          else {
            startAutoRefresh(instance);
          }
          return _context4.a(2, {
            data: existing.data,
            success: true,
            source: "cache"
          });
        case 2:
          _context4.n = 3;
          return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["q" /* promiseTimeout */])(fetchFeatures(instance), timeout);
        case 3:
          res = _context4.v;
          return _context4.a(2, res || {
            data: null,
            success: false,
            source: "timeout",
            error: new Error("Timeout")
          });
        case 4:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _fetchFeaturesWithCache.apply(this, arguments);
}
function getKey(instance) {
  var _instance$getApiInfo = instance.getApiInfo(),
    _instance$getApiInfo2 = _slicedToArray(_instance$getApiInfo, 2),
    apiHost = _instance$getApiInfo2[0],
    clientKey = _instance$getApiInfo2[1];
  return "".concat(apiHost, "||").concat(clientKey);
}
function getCacheKey(instance) {
  var baseKey = getKey(instance);
  if (!("isRemoteEval" in instance) || !instance.isRemoteEval()) return baseKey;
  var attributes = instance.getAttributes();
  var cacheKeyAttributes = instance.getCacheKeyAttributes() || Object.keys(instance.getAttributes());
  var ca = {};
  cacheKeyAttributes.forEach(function (key) {
    ca[key] = attributes[key];
  });
  var fv = instance.getForcedVariations();
  var url = instance.getUrl();
  return "".concat(baseKey, "||").concat(JSON.stringify({
    ca: ca,
    fv: fv,
    url: url
  }));
}

// Populate cache from localStorage (if available)
function initializeCache() {
  return _initializeCache.apply(this, arguments);
} // Enforce the maxEntries limit
function _initializeCache() {
  _initializeCache = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    var value, parsed, cleanupFn, _t2;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          if (!cacheInitialized) {
            _context5.n = 1;
            break;
          }
          return _context5.a(2);
        case 1:
          cacheInitialized = true;
          _context5.p = 2;
          if (!polyfills.localStorage) {
            _context5.n = 4;
            break;
          }
          _context5.n = 3;
          return polyfills.localStorage.getItem(cacheSettings.cacheKey);
        case 3:
          value = _context5.v;
          if (!cacheSettings.disableCache && value) {
            parsed = JSON.parse(value);
            if (parsed && Array.isArray(parsed)) {
              parsed.forEach(function (_ref8) {
                var _ref9 = _slicedToArray(_ref8, 2),
                  key = _ref9[0],
                  data = _ref9[1];
                cache.set(key, _objectSpread(_objectSpread({}, data), {}, {
                  staleAt: new Date(data.staleAt)
                }));
              });
            }
            cleanupCache();
          }
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t2 = _context5.v;
        case 6:
          if (!cacheSettings.disableIdleStreams) {
            cleanupFn = helpers.startIdleListener();
            if (cleanupFn) {
              helpers.stopIdleListener = cleanupFn;
            }
          }
        case 7:
          return _context5.a(2);
      }
    }, _callee5, null, [[2, 5]]);
  }));
  return _initializeCache.apply(this, arguments);
}
function cleanupCache() {
  var entriesWithTimestamps = Array.from(cache.entries()).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      value = _ref7[1];
    return {
      key: key,
      staleAt: value.staleAt.getTime()
    };
  }).sort(function (a, b) {
    return a.staleAt - b.staleAt;
  });
  var entriesToRemoveCount = Math.min(Math.max(0, cache.size - cacheSettings.maxEntries), cache.size);
  for (var i = 0; i < entriesToRemoveCount; i++) {
    cache["delete"](entriesWithTimestamps[i].key);
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, cacheKey, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  var version = data.dateUpdated || "";
  var staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  var existing = !cacheSettings.disableCache ? cache.get(cacheKey) : undefined;
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }
  if (!cacheSettings.disableCache) {
    // Update in-memory cache
    cache.set(cacheKey, {
      data: data,
      version: version,
      staleAt: staleAt,
      sse: supportsSSE.has(key)
    });
    cleanupCache();
  }
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  var instances = subscribedInstances.get(key);
  instances && instances.forEach(function (instance) {
    return refreshInstance(instance, data);
  });
}
function refreshInstance(_x3, _x4) {
  return _refreshInstance.apply(this, arguments);
} // Fetch the features payload from helper function or from in-mem injected payload
function _refreshInstance() {
  _refreshInstance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(instance, data) {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          _context6.n = 1;
          return instance.setPayload(data || instance.getPayload());
        case 1:
          return _context6.a(2);
      }
    }, _callee6);
  }));
  return _refreshInstance.apply(this, arguments);
}
function fetchFeatures(_x5) {
  return _fetchFeatures.apply(this, arguments);
} // Start SSE streaming, listens to feature payload changes and triggers a refresh or re-fetch
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(instance) {
    var _instance$getApiHosts2, apiHost, apiRequestHeaders, clientKey, remoteEval, key, cacheKey, promise, fetcher;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.n) {
        case 0:
          _instance$getApiHosts2 = instance.getApiHosts(), apiHost = _instance$getApiHosts2.apiHost, apiRequestHeaders = _instance$getApiHosts2.apiRequestHeaders;
          clientKey = instance.getClientKey();
          remoteEval = "isRemoteEval" in instance && instance.isRemoteEval();
          key = getKey(instance);
          cacheKey = getCacheKey(instance);
          promise = activeFetches.get(cacheKey);
          if (!promise) {
            fetcher = remoteEval ? helpers.fetchRemoteEvalCall({
              host: apiHost,
              clientKey: clientKey,
              payload: {
                attributes: instance.getAttributes(),
                forcedVariations: instance.getForcedVariations(),
                forcedFeatures: Array.from(instance.getForcedFeatures().entries()),
                url: instance.getUrl()
              },
              headers: apiRequestHeaders
            }) : helpers.fetchFeaturesCall({
              host: apiHost,
              clientKey: clientKey,
              headers: apiRequestHeaders
            }); // TODO: auto-retry if status code indicates a temporary error
            promise = fetcher.then(function (res) {
              if (!res.ok) {
                throw new Error("HTTP error: ".concat(res.status));
              }
              if (res.headers.get("x-sse-support") === "enabled") {
                supportsSSE.add(key);
              }
              return res.json();
            }).then(function (data) {
              onNewFeatureData(key, cacheKey, data);
              startAutoRefresh(instance);
              activeFetches["delete"](cacheKey);
              return {
                data: data,
                success: true,
                source: "network"
              };
            })["catch"](function (e) {
              "production" !== "production" && instance.log("Error fetching features", {
                apiHost: apiHost,
                clientKey: clientKey,
                error: e ? e.message : null
              });
              activeFetches["delete"](cacheKey);
              return {
                data: null,
                source: "error",
                success: false,
                error: e
              };
            });
            activeFetches.set(cacheKey, promise);
          }
          return _context7.a(2, promise);
      }
    }, _callee7);
  }));
  return _fetchFeatures.apply(this, arguments);
}
function startAutoRefresh(instance) {
  var forceSSE = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var key = getKey(instance);
  var cacheKey = getCacheKey(instance);
  var _instance$getApiHosts = instance.getApiHosts(),
    streamingHost = _instance$getApiHosts.streamingHost,
    streamingHostRequestHeaders = _instance$getApiHosts.streamingHostRequestHeaders;
  var clientKey = instance.getClientKey();
  if (forceSSE) {
    supportsSSE.add(key);
  }
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && polyfills.EventSource) {
    if (streams.has(key)) return;
    var channel = {
      src: null,
      key: key,
      host: streamingHost,
      clientKey: clientKey,
      headers: streamingHostRequestHeaders,
      cb: function cb(event) {
        try {
          if (event.type === "features-updated") {
            var instances = subscribedInstances.get(key);
            instances && instances.forEach(function (instance) {
              fetchFeatures(instance);
            });
          } else if (event.type === "features") {
            var json = JSON.parse(event.data);
            onNewFeatureData(key, cacheKey, json);
          }
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
          "production" !== "production" && instance.log("SSE Error", {
            streamingHost: streamingHost,
            clientKey: clientKey,
            error: e ? e.message : null
          });
          onSSEError(channel);
        }
      },
      errors: 0,
      state: "active"
    };
    streams.set(key, channel);
    enableChannel(channel);
  }
}
function onSSEError(channel) {
  if (channel.state === "idle") return;
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    var delay = backoffDelay(1000, 3, channel.errors - 3);
    disableChannel(channel);
    setTimeout(function () {
      if (["idle", "active"].includes(channel.state)) return;
      // A channel dropped while backing off (destroy, clearCache) must not reconnect:
      // it would open an EventSource nothing tracks or can ever close
      if (streams.get(channel.key) !== channel) return;
      enableChannel(channel);
    }, delay);
  }
}
function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
  if (channel.state === "active") {
    channel.state = "disabled";
  }
}
function enableChannel(channel) {
  try {
    channel.src = helpers.eventSourceCall({
      host: channel.host,
      clientKey: channel.clientKey,
      headers: channel.headers
    });
    channel.state = "active";
    channel.src.addEventListener("features", channel.cb);
    channel.src.addEventListener("features-updated", channel.cb);
    channel.src.onerror = function () {
      return onSSEError(channel);
    };
    channel.src.onopen = function () {
      channel.errors = 0;
      // Retire polling once the stream is confirmed open, not merely constructed -
      // a stream blocked by a proxy is exactly why someone configured polling
      var poller = pollers.get(channel.key);
      if (poller) destroyPoller(poller, channel.key);
    };
  } catch (e) {
    // A half-built connection may already be open, so close it before dropping the ref
    try {
      if (channel.src) {
        channel.src.close();
        channel.src.onerror = null;
        channel.src.onopen = null;
      }
    } catch (closeError) {
      // Ignore cleanup errors from incompatible implementations
    }
    channel.src = null;
    channel.state = "disabled";
    // Evict so the existing-key guard can't block a later retry, but only if this channel
    // is still the registered one - a stale re-connect must not evict its replacement
    if (streams.get(channel.key) === channel) streams["delete"](channel.key);
    warnStreamingUnavailable("the EventSource implementation threw an error (".concat(e ? e.message : "unknown error", ")"));
  }
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams["delete"](key);
}

// Refresh on a fixed interval. Deduped per key, so many instances sharing a clientKey poll once.
function startPolling(key, interval) {
  // setTimeout collapses an out-of-range delay to 1ms, turning a typo into a request loop
  if (!Number.isFinite(interval) || interval < 1 || interval > 2147483647) {
    warnMisconfiguration("Ignoring invalid pollingInterval (".concat(interval, "). Expected a finite number of milliseconds between 1 and 2147483647."));
    return;
  }
  if (pollers.has(key)) return;
  var poller = {
    timer: null,
    interval: interval,
    errors: 0
  };
  pollers.set(key, poller);
  scheduleNextPoll(key, poller);
}
function scheduleNextPoll(key, poller) {
  // Gentler curve than onSSEError's, since this one already starts from the
  // user's configured interval rather than a fixed 1s
  var delay = poller.errors > 0 ? backoffDelay(poller.interval, 2, poller.errors - 1) : poller.interval;
  var timer = setTimeout(function () {
    // Resolve a subscriber at poll time. The instance that started polling may have been
    // destroyed, which clears its options and would send us to the wrong host.
    var subs = subscribedInstances.get(key);
    var instance = subs && subs.values().next().value;
    if (!instance) {
      destroyPoller(poller, key);
      return;
    }

    // Bypass the cache so the interval, not staleTTL, decides how often we refresh
    fetchFeatures(instance).then(function (res) {
      poller.errors = res.success ? 0 : poller.errors + 1;
      // Don't reschedule if polling was stopped while the request was in flight
      if (pollers.get(key) === poller) {
        scheduleNextPoll(key, poller);
      }
    });
  }, delay);

  // Never hold a short-lived process (serverless, CLI) open just to poll
  if (timer.unref) timer.unref();
  poller.timer = timer;
}
function destroyPoller(poller, key) {
  if (poller.timer) clearTimeout(poller.timer);
  pollers["delete"](key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();
  streamingWarnings.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Stop any background polling
  pollers.forEach(destroyPoller);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();

  // Run the idle stream cleanup function
  helpers.stopIdleListener();
}
function startBackgroundSync(instance, options) {
  if (!options.streaming && options.pollingInterval === undefined) return;
  if (!instance.getClientKey()) {
    throw new Error("Must specify clientKey to enable streaming or polling");
  }
  if (options.streaming) {
    if (options.payload) {
      startAutoRefresh(instance, true);
    }
    if (!polyfills.EventSource) {
      warnStreamingUnavailable("no EventSource implementation is available. In Node.js, install the `eventsource` package and pass it to setPolyfills({ EventSource })");
    } else if (cacheSettings.backgroundSync && !supportsSSE.has(getKey(instance))) {
      // Keyed on supportsSSE rather than an absent stream, so an EventSource that
      // failed to start (already warned about above) doesn't also get blamed here
      warnStreamingUnavailable("the API host did not report SSE support (missing `x-sse-support` response header). This is also expected when the initial payload fetch fails");
    }
  }
  subscribe(instance);

  // Not gated on an existing stream: startAutoRefresh opens one whenever the host
  // advertises SSE, so gating here would drop the polling that was asked for if that
  // stream never connects. onopen retires the poller once it does.
  // Checked against undefined so 0 reaches startPolling's validation warning
  var key = getKey(instance);
  if (options.pollingInterval !== undefined && cacheSettings.backgroundSync) {
    startPolling(key, options.pollingInterval);
  }
}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(119);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(137);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(64);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(142);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(155);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(154);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(148);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(74);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(37);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(77);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(174)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addPreventScrollStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removePreventScrollStyle; });
var addPreventScrollStyle = function addPreventScrollStyle() {
  document.body.style.overflow = 'hidden';
};
var removePreventScrollStyle = function removePreventScrollStyle() {
  document.body.style.overflow = 'auto';
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_module_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_module_css__);
var _excluded = ["icon", "rightIcon", "label", "value", "onClick", "className", "disabled", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }


var Input = function Input(_ref) {
  var icon = _ref.icon,
    rightIcon = _ref.rightIcon,
    label = _ref.label,
    value = _ref.value,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var handleKeyDown = function handleKeyDown(e) {
    if (disabled) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (typeof onClick === 'function') onClick(e);
    }
  };
  var renderIcon = function renderIcon(node) {
    if (!node) return null;
    if (typeof node === 'string') {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: node,
        alt: "",
        "aria-hidden": "true"
      });
    }
    return node;
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    role: "button",
    tabIndex: disabled ? -1 : 0,
    className: [__WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input'], disabled ? __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input--disabled'] : '', variant === 'column' ? __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input--column'] : '', className].filter(Boolean).join(' '),
    onClick: disabled ? undefined : onClick,
    onKeyDown: handleKeyDown
  }, rest), icon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input__icon']
  }, renderIcon(icon)), (label != null || value != null) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input__texts']
  }, label != null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input__label']
  }, label), value != null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input__value']
  }, value)), rightIcon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_1__styles_module_css___default.a['v2-input__right-icon']
  }, renderIcon(rightIcon)));
};
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSearchBarCommon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_searchParsing__ = __webpack_require__(28);
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var useSearchBarCommon = function useSearchBarCommon(destinations) {
  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrolled = _useState2[0],
    setIsScrolled = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    containerHeight = _useState4[0],
    setContainerHeight = _useState4[1];
  var getDestinationName = function getDestinationName(slug) {
    if (!slug) return '';
    var list = destinations || [];
    var found = list.find(function (d) {
      return d.slug === slug;
    });
    return found ? found.name : '';
  };
  var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
      var _parseSearchFromPath = Object(__WEBPACK_IMPORTED_MODULE_2__utils_searchParsing__["d" /* parseSearchFromPath */])(),
        destinationSlug = _parseSearchFromPath.destinationSlug,
        beginDate = _parseSearchFromPath.beginDate,
        endDate = _parseSearchFromPath.endDate;
      var destinationName = getDestinationName(destinationSlug);
      var begin = Object(__WEBPACK_IMPORTED_MODULE_2__utils_searchParsing__["a" /* formatDateBr */])(beginDate);
      var end = Object(__WEBPACK_IMPORTED_MODULE_2__utils_searchParsing__["a" /* formatDateBr */])(endDate);
      var perm = '';
      if (beginDate && endDate) {
        var diff = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getDaysDiff"])(new Date(beginDate), new Date(endDate));
        perm = !Number.isNaN(diff) ? "".concat(diff, " dias") : '';
      }
      return {
        computedDestinationName: destinationName,
        beginBr: begin,
        endBr: end,
        permanence: perm
      };
    }, [destinations]),
    computedDestinationName = _useMemo.computedDestinationName,
    beginBr = _useMemo.beginBr,
    endBr = _useMemo.endBr,
    permanence = _useMemo.permanence;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var el = containerRef.current;
    setIsScrolled((window.scrollY || window.pageYOffset || 0) > 8);
    if (el) setContainerHeight(el.offsetHeight || 0);
    var ro;
    var onResizeFallback = null;
    if (typeof ResizeObserver !== 'undefined' && el) {
      ro = new ResizeObserver(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            var h = entry.contentRect && entry.contentRect.height || el.offsetHeight || 0;
            setContainerHeight(h);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      ro.observe(el);
    } else {
      onResizeFallback = function onResizeFallback() {
        if (el) setContainerHeight(el.offsetHeight || 0);
      };
      window.addEventListener('resize', onResizeFallback);
    }
    var ticking = false;
    var onScroll = function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || window.pageYOffset || 0;
          setIsScrolled(y > 8);
          ticking = false;
        });
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return function () {
      window.removeEventListener('scroll', onScroll);
      if (ro) ro.disconnect();
      if (onResizeFallback) window.removeEventListener('resize', onResizeFallback);
    };
  }, []);
  return {
    containerRef: containerRef,
    isScrolled: isScrolled,
    containerHeight: containerHeight,
    computedDestinationName: computedDestinationName,
    beginBr: beginBr,
    endBr: endBr,
    permanence: permanence
  };
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowUpPlan__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_css__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var HighligthPlans = function HighligthPlans(_ref) {
  var plans = _ref.plans,
    providers = _ref.providers,
    match = _ref.match,
    mobile = _ref.mobile,
    selectedPlans = _ref.selectedPlans,
    addComparisonPlan = _ref.addComparisonPlan,
    removeComparisonPlan = _ref.removeComparisonPlan,
    variant = _ref.variant;
  if (plans && plans.length < 3) return null;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(plansOrdenation(plans, mobile)),
    _useState2 = _slicedToArray(_useState, 2),
    orderedPlans = _useState2[0],
    setOrderedPlans = _useState2[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setOrderedPlans(plansOrdenation(plans, mobile));
  }, [plans, mobile]);
  var isV2 = (variant || '').toString().toUpperCase() === 'V2';
  var getProviderImgPath = function getProviderImgPath(providerCode) {
    var providerSlug = providers.filter(function (provider) {
      return provider.code === providerCode;
    })[0];
    var providerImgPath = providerSlug ? "/assets/images/seguradoras/".concat(providerSlug.slug, ".png") : '';
    return providerImgPath;
  };
  var basePath = '/seguro-viagem/cobertura';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "".concat(isV2 ? __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.wrapperV2 : 'highlight-plans-wrapper'),
    "data-variant": isV2 ? 'V2' : 'V1'
  }, !isV2 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, "Encontre os melhores planos para sua viagem!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(isV2 ? __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.carouselV2 : 'carroussel scroll-component scroll-component-v1')
  }, orderedPlans.map(function (plan) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ShowUpPlan__["a" /* default */], {
      key: plan.code,
      plan: plan,
      basePath: basePath,
      match: match,
      isSelected: selectedPlans.includes(plan.code),
      providerImgPath: getProviderImgPath(plan.provider_code),
      addComparisonPlan: addComparisonPlan,
      removeComparisonPlan: removeComparisonPlan,
      variant: variant
    });
  })));
};
function plansOrdenation(plans, mobile) {
  if (mobile) {
    return _toConsumableArray(plans).sort(function (a, b) {
      return a.priority - b.priority;
    });
  } else {
    var desktopOrder = [1, 0, 2];
    return _toConsumableArray(plans).sort(function (a, b) {
      return desktopOrder.indexOf(a.priority) - desktopOrder.indexOf(b.priority);
    });
  }
}
/* harmony default export */ __webpack_exports__["a"] = (HighligthPlans);

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapperV2":"_3KlD0","carouselV2":"_3zfjq","showUpPlanV2":"_2vNqN","headerV2":"_2jOz-","image":"_3Q8Ny","planName":"_2RSnb","price":"FcGdp","selected":"_31SmH","primary":"_1u6ta","benefits":"FpTfY","planInfo":"_FIwB","planBenefitValue":"_1Xuog","roofLink":"_28D3b","selectButton":"_26KFF","compareButton":"eFwka","oldPrice":"_3Tgmf","flexColumn":"_3X4g6","pricePix":"_2LcBZ","pricePerson":"_2HDyU","priceAtually":"_32Ez5"};

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_Close_icon__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_Arrow_icon__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_TwinArrow_icon__ = __webpack_require__(227);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }







/**
 * MobileFullscreenDatepicker
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - selectionMode: 'range' | 'start' | 'end' (default 'range')
 * - value: { startDate: Date|null, endDate: Date|null }
 * - onChange: (value) => void
 * - onConfirm: (value) => void
 * - minDate, maxDate
 * - allowSameDay: boolean
 * - labels: { title?, start?, end?, confirm?, clear? }
 */
var MobileFullscreenDatepicker = function MobileFullscreenDatepicker(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onBack = _ref.onBack,
    _ref$selectionMode = _ref.selectionMode,
    selectionMode = _ref$selectionMode === void 0 ? 'range' : _ref$selectionMode,
    value = _ref.value,
    onChange = _ref.onChange,
    onConfirm = _ref.onConfirm,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    allowSameDay = _ref.allowSameDay,
    _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? {} : _ref$labels;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
      return value || {
        startDate: null,
        endDate: null
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (open) setSelection(value || {
      startDate: null,
      endDate: null
    });
  }, [open]);
  var handleChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (val) {
    setSelection(val);
    if (onChange) onChange(val);
  }, [onChange]);
  var handleConfirm = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    var payload = selection;
    if (selectionMode === 'start') {
      payload = {
        startDate: selection.startDate || null,
        endDate: value && value.endDate || null
      };
    } else if (selectionMode === 'end') {
      payload = {
        startDate: value && value.startDate || null,
        endDate: selection.endDate || null
      };
    }
    if (onConfirm) onConfirm(payload);
  }, [selection, onConfirm, selectionMode, value]);
  var handleClear = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    var cleared = _objectSpread({}, selection);
    if (selectionMode === 'start') {
      cleared = {
        startDate: null,
        endDate: selection.endDate || null
      };
    } else if (selectionMode === 'end') {
      cleared = {
        startDate: selection.startDate || null,
        endDate: null
      };
    } else {
      cleared = {
        startDate: null,
        endDate: null
      };
    }
    setSelection(cleared);
    if (onChange) onChange(cleared);
  }, [onChange, selection, selectionMode]);
  if (!open) return null;
  var todayStart = function () {
    var t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  }();
  var effectiveMinDate = minDate || todayStart;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.overlay,
    role: "dialog",
    "aria-modal": "true"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.container
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("header", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.headerTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: onBack,
    role: "button",
    tabIndex: 0,
    "aria-label": "Voltar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__assets_icons_Arrow_icon__["a" /* ArrowIcon */], {
    size: 24
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.headerTitleLabel
  }, labels.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: onClose,
    role: "button",
    tabIndex: 0,
    "aria-label": "Fechar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__assets_icons_Close_icon__["a" /* CloseIcon */], {
    onClick: onClose,
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.closeIcon
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.headerBody
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.previewSelection
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.previewSelectionItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Data de ida"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, " ", selection.startDate ? selection.startDate.toLocaleDateString('pt-BR') : '---')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_TwinArrow_icon__["a" /* TwinArrowIcon */], {
    size: 28
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.previewSelectionItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Data de volta"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, " ", selection.endDate ? selection.endDate.toLocaleDateString('pt-BR') : '---'))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.main
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* default */], {
    variant: "inline",
    selectionMode: selectionMode,
    value: selection,
    onChange: handleChange,
    minDate: effectiveMinDate,
    maxDate: maxDate,
    numberOfMonths: 1,
    allowSameDay: allowSameDay,
    customHeaderClassName: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.customHeaderDatepicker
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("footer", {
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.footer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.clear,
    onClick: handleClear
  }, labels.clear || 'Limpar'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_2__styles_module_css___default.a.confirm,
    onClick: handleConfirm
  }, labels.confirm || 'Confirmar'))));
};
/* harmony default export */ __webpack_exports__["a"] = (MobileFullscreenDatepicker);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalQuotationDateYear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__ = __webpack_require__(5);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalQuotationDateYear = /*#__PURE__*/function (_Component) {
  function ModalQuotationDateYear(props) {
    var _this;
    _classCallCheck(this, ModalQuotationDateYear);
    _this = _callSuper(this, ModalQuotationDateYear, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalQuotationDateYear, _Component);
  return _createClass(ModalQuotationDateYear, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      this.props.closeModalQuotationDateWarning();
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(this.props.match, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), null)
      };
      this.props.history.replace(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalQuotationDateYearActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents modalyear"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalQuotationDateYear,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle yearmodal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/calendar-year.svg",
        alt: "Voc\xEA est\xE1 pesquisando um seguro viagem para hoje",
        className: "icon-modal"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Precisa de cobertura para mais ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " de um ano? ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "N\xF3s te ajudamos!")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "Nossa equipe vai te auxiliar a escolher o melhor plano com a dura\xE7\xE3o necess\xE1ria. Entre em contato com a gente em um dos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://segurospromo.com.br/atendimento"
      }, " nossos canais de atendimento"), "."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "list-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "WhatsApp"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "https://api.whatsapp.com/send?phone=553139727083&text=Seguros%20Promo",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "(31) 3972-7083"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Atendimento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "tel:(31) 4003-8442",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "(31) 4003-8442"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "E-mail"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "mailto: atendimento@segurospromo.com.br",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "atendimento@segurospromo.com.br"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: "https://www.segurospromo.com.br"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalQuotationDateWarning
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa"))))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalQuotationDateYearActive: state.search.isModalQuotationDateYearActive
  };
}, {
  closeModalQuotationDateYear: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["g" /* closeModalQuotationDateYear */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalQuotationDateYear)));

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalWithoutTracker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic_error_message_GenericErrorMessage__ = __webpack_require__(230);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalWithoutTracker = /*#__PURE__*/function (_Component) {
  function ModalWithoutTracker(props) {
    var _this;
    _classCallCheck(this, ModalWithoutTracker);
    _this = _callSuper(this, ModalWithoutTracker, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(ModalWithoutTracker, _Component);
  return _createClass(ModalWithoutTracker, [{
    key: "handleChange",
    value: function handleChange(e) {
      this.props.setInfosModalProspect(_objectSpread(_objectSpread({}, this.props.prospect), {}, _defineProperty({}, e.target.name, e.target.value)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var avaliableSendProspect = this.props.modalProspectAvaliable;
      var coupon = this.props.coupon;
      var couponText = 'PROMO15';
      if (coupon && coupon.status === 0) {
        couponText = coupon.text;
      }
      if (!this.props.isModalWithoutTrackerActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_modalpagamento tracker-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "logo-seguros-promo",
        src: "/assets/images/logo.png",
        alt: "Logo Seguros Promo"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Que bom que voc\xEA quer viajar com mais seguran\xE7a! Primeiro, preencha os dados abaixo, garanta a melhor condi\xE7\xE3o do mercado e um cupom de desconto!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal-label"
      }, "Nome"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        placeholder: "Nome",
        value: this.props.prospect.name,
        name: "name",
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this2.props.trackerModalValidatorHandlerBlur(e.target.name);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "errorMessage"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__generic_error_message_GenericErrorMessage__["a" /* default */], {
        errors: this.props.prospect.errors,
        anchor: "name",
        field: "name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal-label"
      }, "E-mail"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        placeholder: "email@exemplo.com",
        type: "text",
        name: "email",
        value: this.props.prospect.email,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this2.props.trackerModalValidatorHandlerBlur(e.target.name);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "errorMessage"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__generic_error_message_GenericErrorMessage__["a" /* default */], {
        errors: this.props.prospect.errors,
        anchor: "email",
        field: "email"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal-label"
      }, "Celular"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        placeholder: "(xx) 00000-0000",
        guide: true,
        name: "phone",
        inputMode: "numeric",
        value: this.props.prospect.phone,
        type: "tel",
        mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/],
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this2.props.trackerModalValidatorHandlerBlur(e.target.name);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "errorMessage"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__generic_error_message_GenericErrorMessage__["a" /* default */], {
        errors: this.props.prospect.errors,
        anchor: "phone",
        field: "phone"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cupom-text modal-label"
      }, "Cupom"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cupom-label"
      }, couponText), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "button",
        value: "ATIVAR MEU DESCONTO",
        className: "apply-button ".concat(avaliableSendProspect ? 'avaliable' : ''),
        onClick: function onClick() {
          return _this2.props.redirectToTracker(couponText);
        }
      })))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (ModalWithoutTracker);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HospitalExpenseFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SliderFilter__ = __webpack_require__(89);


var MATCH_IDS = [3];
function HospitalExpenseFilter(_ref) {
  var _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SliderFilter__["a" /* default */], {
    matchIds: MATCH_IDS,
    title: "Despesa M\xE9dica Hospitalar",
    description: "Selecione o valor desejado para suas despesas m\xE9dicas e hospitalares durante a viagem",
    infoTooltip: "\xC9 o valor m\xE1ximo de cobertura para atendimentos m\xE9dicos e hospitalares durante a viagem, como consultas, exames e interna\xE7\xF5es.",
    ariaLabel: "Despesa M\xE9dica Hospitalar",
    useStagingMode: useStagingMode,
    onStageChange: onStageChange
  });
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Tooltip__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_Tooltip_icon__ = __webpack_require__(51);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }






var formatCurrency = function formatCurrency(value) {
  if (value == null) return '';
  var n = Number(value) || 0;
  var num = n.toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return "$ ".concat(num);
};
var parseAmount = function parseAmount(text) {
  if (typeof text === 'number') return text;
  if (typeof text !== 'string') return null;
  var digits = text.replace(/\./g, '').replace(/[^0-9]/g, '');
  var num = parseInt(digits, 10);
  return Number.isNaN(num) ? null : num;
};
var findCategoryIndexByID = function findCategoryIndexByID(filterCategory, ids) {
  if (!Array.isArray(filterCategory)) return -1;
  var toKey = function toKey(v) {
    return v == null ? '' : String(v);
  };
  var list = ids == null ? [] : Array.isArray(ids) ? ids : [ids];
  if (!list.length) return -1;
  var idsSet = new Set(list.map(toKey));
  var idOf = function idOf(cat) {
    if (!cat) return undefined;
    if (cat.ID !== undefined) return cat.ID;
    if (cat.Id !== undefined) return cat.Id;
    return cat.id;
  };
  return filterCategory.findIndex(function (cat) {
    return idsSet.has(toKey(idOf(cat)));
  });
};
function SliderFilterBase(_ref) {
  var filterCategory = _ref.filterCategory,
    unselectFilterCategoryOptions = _ref.unselectFilterCategoryOptions,
    applyFilterCategories = _ref.applyFilterCategories,
    _ref$categoryId = _ref.categoryId,
    categoryId = _ref$categoryId === void 0 ? null : _ref$categoryId,
    _ref$matchIds = _ref.matchIds,
    matchIds = _ref$matchIds === void 0 ? null : _ref$matchIds,
    title = _ref.title,
    description = _ref.description,
    infoTooltip = _ref.infoTooltip,
    ariaLabel = _ref.ariaLabel,
    _ref$helperPrefix = _ref.helperPrefix,
    helperPrefix = _ref$helperPrefix === void 0 ? 'Apresentando resultados a partir de:' : _ref$helperPrefix,
    _ref$thumbPx = _ref.thumbPx,
    thumbPx = _ref$thumbPx === void 0 ? 28 : _ref$thumbPx,
    _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    stagedIndex = _React$useState2[0],
    setStagedIndex = _React$useState2[1];
  var categoryIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var ids = matchIds != null ? matchIds : categoryId;
    return findCategoryIndexByID(filterCategory, ids);
  }, [filterCategory, categoryId, matchIds]);
  var steps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (categoryIndex < 0) return [];
    var cat = filterCategory[categoryIndex];
    if (!cat || !Array.isArray(cat.Categories)) return [];
    var mapped = cat.Categories.map(function (opt, optionIndex) {
      var numeric = parseAmount(opt && (opt.Value || opt.Name) || null);
      return {
        optionIndex: optionIndex,
        numeric: numeric,
        display: opt && opt.Name || formatCurrency(numeric),
        selected: Boolean(opt && opt.selected)
      };
    }).filter(function (x) {
      return x.numeric != null;
    });
    mapped.sort(function (a, b) {
      return a.numeric - b.numeric;
    });
    return mapped;
  }, [filterCategory, categoryIndex]);
  var currentIndex = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (!steps.length) return 0;
    if (useStagingMode && stagedIndex !== null) {
      return stagedIndex;
    }
    var selectedIndices = steps.map(function (s, i) {
      return s.selected ? i : -1;
    }).filter(function (i) {
      return i >= 0;
    });
    if (!selectedIndices.length) return 0;
    return Math.max.apply(Math, _toConsumableArray(selectedIndices));
  }, [steps, useStagingMode, stagedIndex]);
  var onChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
    if (categoryIndex < 0 || !steps.length) return;
    var desired = parseInt(e.target.value, 10) || 0;
    if (useStagingMode) {
      setStagedIndex(desired);
      if (onStageChange) {
        onStageChange({
          categoryIndex: categoryIndex,
          selectedIndex: desired,
          step: steps[desired]
        });
      }
    } else {
      steps.forEach(function (s, i) {
        var shouldBeSelected = i === desired;
        if (Boolean(s.selected) !== shouldBeSelected) {
          unselectFilterCategoryOptions('category', categoryIndex, s.optionIndex);
        }
      });
      applyFilterCategories();
    }
  }, [categoryIndex, steps, unselectFilterCategoryOptions, applyFilterCategories, useStagingMode, onStageChange]);
  if (categoryIndex < 0 || !steps.length) return null;
  var current = steps[currentIndex];
  var progress = steps.length > 1 ? currentIndex / (steps.length - 1) : 0;
  var percent = Math.round(progress * 100);
  var formatted = formatCurrency(current && current.numeric);
  var numberOnly = formatted.replace(/^\$\s*/, '');
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.container
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.headerContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.header
  }, title ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.title
  }, title) : null, infoTooltip ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Tooltip__["a" /* default */], {
    content: infoTooltip
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], null)) : null), description ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.description
  }, description) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Tooltip__["a" /* default */], {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.sliderWrap,
    content: formatted,
    anchorPercent: percent,
    anchorProgress: progress,
    thumbPx: thumbPx
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.slider,
    type: "range",
    min: 0,
    max: Math.max(steps.length - 1, 0),
    step: 1,
    value: currentIndex,
    onChange: onChange,
    "aria-label": ariaLabel || title,
    style: {
      '--percent': "".concat(percent, "%")
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.helper
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, helperPrefix), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.value
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.currencySymbol
  }, "$"), " ", numberOnly)));
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    filterCategory: state.search.filterCategory
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  unselectFilterCategoryOptions: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["D" /* unselectFilterCategoryOptions */],
  applyFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["b" /* applyFilterCategories */]
})(SliderFilterBase));

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CovidCoverageFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SliderFilter__ = __webpack_require__(89);


var CATEGORY_ID = [5];
function CovidCoverageFilter(_ref) {
  var _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SliderFilter__["a" /* default */], {
    matchIds: CATEGORY_ID,
    title: "Valor da cobertura COVID-19",
    description: "Escolha o valor da cobertura para despesas relacionadas a COVID-19",
    infoTooltip: "\xC9 uma cobertura extra para despesas m\xE9dicas, como interna\xE7\xE3o e tratamentos, em caso de diagn\xF3stico positivo para COVID-19 durante a viagem.",
    ariaLabel: "Valor de Cobertura COVID-19",
    useStagingMode: useStagingMode,
    onStageChange: onStageChange
  });
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AgeRangeFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__ = __webpack_require__(56);


var CATEGORY_ID = [4];
function AgeRangeFilter(_ref) {
  var _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__["a" /* default */], {
    matchIds: CATEGORY_ID,
    title: "Idade dos viajantes",
    ariaLabel: "Idade dos Viajantes",
    useStagingMode: useStagingMode,
    onStageChange: onStageChange
  });
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BenefitsCoverageFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__ = __webpack_require__(56);


var CATEGORY_ID = [6];
function BenefitsCoverageFilter(_ref) {
  var _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__["a" /* default */], {
    matchIds: CATEGORY_ID,
    title: "Benef\xEDcios do seguro",
    ariaLabel: "Benef\xEDcios do seguro",
    initialVisibleCount: 5,
    showAllLabel: "Ver todos os benef\xEDcios",
    useStagingMode: useStagingMode,
    onStageChange: onStageChange
  });
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__ = __webpack_require__(56);


var PRIORITY_PROVIDERS = ['affinity', 'assist-card', 'coris', 'gta', 'my-travel-assist', 'sul-america', 'universal-assistance'];
var ProviderFilter = function ProviderFilter(_ref) {
  var _ref$useStagingMode = _ref.useStagingMode,
    useStagingMode = _ref$useStagingMode === void 0 ? false : _ref$useStagingMode,
    _ref$onStageChange = _ref.onStageChange,
    onStageChange = _ref$onStageChange === void 0 ? null : _ref$onStageChange;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CheckBoxFilter__["a" /* default */], {
    source: "provider",
    title: "Seguradoras",
    initialVisibleCount: 7,
    showAllLabel: "Ver todas seguradoras",
    useStagingMode: useStagingMode,
    onStageChange: onStageChange,
    priorityProviderSlugs: PRIORITY_PROVIDERS
  });
};
/* harmony default export */ __webpack_exports__["a"] = (ProviderFilter);

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"blurBackground":"_1hKZX","upsellContainer":"_2Ng8T","mobileHeader":"_1leDw","bgDecoration":"_1Tq6E","contentContainer":"_3g2rv","headerContainer":"_2oMMh","headerTitle":"_5vFEo","iconContainer":"_13WQF","queAchadoText":"_3zvV1","mainTitle":"_1Jcto","textGreen":"_2McT6","subTitle":"ypapb","textBoldLarge":"gAzyi","differencesContainer":"_3M3sQ","differencesRegularGroup":"_28PGR","differencesTitle":"_34fDh","differenceItem":"_1k9Wk","differenceDescription":"_2AI0S","diffIcon":"_2MNvp","differenceItemHighlight":"_2dRDZ","diffTextRow":"_18KkN","diffTextHighlight":"_1l1BM","valuePill":"_2NwQU","valuePillHighlight":"_14uNV","badgesRow":"_2Sqey","badgePill":"_2wOws","diffText":"_2wJd2","differenceValues":"ACtOl","valueNormal":"_3ZGuc","arrowIcon":"_2Gi3o","valueGreen":"_3537A","linkContainer":"_2VjuA","linkText":"_1wh20","cardsContainer":"_29k-4","cardNormal":"_2EhOb","tag":"_3qlT3","cardHeader":"zbhdd","cardImage":"z950K","cardTitle":"_2J8HL","priceContainer":"_1gjzX","priceRow":"Xy73E","priceValue":"_1JT5N","priceValueGreen":"W_GQ5","priceSuffix":"_3Qk8C","priceInstallment":"_2FfTW","buttonOutline":"_89Z7D","cardHighlight":"_3jA0v","buttonPrimary":"_1cKol","backButton":"_12snw"};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_globalActions__ = __webpack_require__(96);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var InfosMobile = /*#__PURE__*/function (_Component) {
  function InfosMobile() {
    _classCallCheck(this, InfosMobile);
    return _callSuper(this, InfosMobile, arguments);
  }
  _inherits(InfosMobile, _Component);
  return _createClass(InfosMobile, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (!this.props.destinations.length) {
        return null;
      }
      var destinationFiltered = this.props.destinations && this.props.destinations.filter(function (dest) {
        return dest.slug === _this.props.match.params.destination;
      });
      var destination = destinationFiltered && destinationFiltered.length ? destinationFiltered[0].name : "";
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "info-resultado-mobile flex component",
        onClick: function onClick() {
          return !_this.props.searchState && _this.props.filterPlansMobile();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", {
        className: "texto-info-mobile"
      }, "Voc\xEA pesquisou por:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", {
        className: "destino-info-mobile"
      }, "Destino: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, destination)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", {
        className: "date-info-mobile"
      }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.begin_date), " - ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.end_date))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        onClick: function onClick() {
          return _this.props.searchState && _this.props.filterPlansMobile();
        }
      }, !this.props.searchState ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        alt: "pesquisar",
        src: "/assets/images/search.svg"
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        alt: "pesquisar",
        src: "/assets/images/quit.svg"
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    searchState: state.search.searchState,
    mobile: state.mobile.mobileActive,
    destinations: state.global.destinations
  };
}, {
  filterPlansMobile: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["l" /* filterPlansMobile */],
  getDestinations: __WEBPACK_IMPORTED_MODULE_5__actions_globalActions__["a" /* getDestinations */]
})(InfosMobile)));

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDestinations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globalProviderSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);

var getDestinations = function getDestinations(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_17" /* GLOBAL_DESTINATIONS */],
    data: data
  };
};
var globalProviderSettings = function globalProviderSettings(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_18" /* GLOBAL_PROVIDER_SETGINGS */],
    data: data
  };
};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Tags__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PixDiscountTag__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_plan__ = __webpack_require__(13);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }








var codeTagSpecialistIndicator = '70';
var Plan = function Plan(props) {
  var match = props.match,
    plan = props.plan,
    providers = props.providers,
    isSelected = props.isSelected,
    position = props.position,
    openModalQuotationDateWarning = props.openModalQuotationDateWarning,
    addComparisonPlan = props.addComparisonPlan,
    showSpecialistSuggestions = props.showSpecialistSuggestions,
    paymentMethods = props.paymentMethods;
  var productUrl = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["b" /* getProductPlanUrl */])(match, plan.code);
  }, [match, plan.code]);
  var productPurchaseUrl = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["c" /* getProductPurchaseUrl */])(match, plan.code);
  }, [match, plan.code]);
  var pixDiscountMultiplier = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (paymentMethods && paymentMethods.length > 0) {
      var pixPayment = paymentMethods.find(function (method) {
        return method.slug === 'pix';
      });
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);
  var selectPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var url;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["i" /* sendToRDStation */])();
          if (!(plan.extra.specialist_indicator && showSpecialistSuggestions)) {
            _context.n = 1;
            break;
          }
          url = Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["e" /* insertTagPurchaseUrl */])(productPurchaseUrl, codeTagSpecialistIndicator);
          return _context.a(2, Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["h" /* selectPlanAndRedirect */])(url));
        case 1:
          Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["h" /* selectPlanAndRedirect */])(productPurchaseUrl);
        case 2:
          return _context.a(2);
      }
    }, _callee);
  })), [openModalQuotationDateWarning, productPurchaseUrl]);
  var provider = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return providers.find(function (provider) {
      return provider.code === plan.provider_code;
    });
  }, [providers, plan.provider_code]);
  var providerImgPath = provider ? "/assets/images/seguradoras/".concat(provider.slug, ".png") : '';
  var benefits = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var baggage = plan.benefits.find(function (benefit) {
      return benefit.code === '42' || benefit.code === 42;
    });
    var hospital = plan.benefits.find(function (benefit) {
      return benefit.code === '51' || benefit.code === 51;
    });
    return {
      baggage: baggage,
      hospital: hospital
    };
  }, [plan.benefits]);
  var tag = Object(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["b" /* getTag */])(plan);
  var isSpecialist = plan.extra.specialist_indicator && showSpecialistSuggestions;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plans".concat(isSpecialist ? ' specialist' : '').concat(isSelected ? ' selecionado' : '').concat(position === 0 ? ' first-box' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "specialist-box".concat(isSpecialist ? ' show' : ' hide')
  }, "\uD83D\uDC68\u200D\uD83D\uDCBB Recomenda\xE7\xE3o do especialista"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "triangle-topleft".concat(isSelected ? '' : ' hide').concat(position === 0 ? ' first-box' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "selecionado-ico",
    src: "/assets/images/selecionado-ico.svg",
    alt: "Selecionado"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: tag,
    isMobile: true,
    customClassName: "search-box-tag"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-body-plans".concat(tag ? '' : ' no-tag')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-container-image"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    onClick: selectPlan,
    src: providerImgPath,
    alt: ""
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-container-plan-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: tag,
    isMobile: false,
    customClassName: "search-box-tag"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plan-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "names-plans",
    onClick: selectPlan
  }, plan.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "prices-high"
  }, "Faixa et\xE1ria: ", plan.child.min_age, " a ", plan.elder.max_age, " anos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), plan.elder.min_age < plan.elder.max_age && "R$ ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatPrice"])(plan.elder.price), " maiores de ").concat(plan.adult.max_age, " anos"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plan-link desktop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], {
    to: productUrl,
    className: "url-roof",
    "data-cy": "link-ver-cobertura-completa-p".concat(position)
  }, "Ver a cobertura completa"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plan-values".concat(tag ? ' with-tag' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-plans"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Despesa M\xE9dica Hospitalar total"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, benefits.hospital && benefits.hospital.coverage || 'N/A')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-plans"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Seguro bagagem"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, benefits.baggage && benefits.baggage.coverage || 'N/A')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-body-plan-values-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-plans"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Despesa M\xE9dica Hospitalar total"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, benefits.hospital && benefits.hospital.coverage || 'N/A')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-plans"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Seguro bagagem"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, benefits.baggage && benefits.baggage.coverage || 'N/A')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-plan-link"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], {
    to: productUrl,
    className: "url-roof",
    "data-cy": "link-ver-cobertura-completa-p".concat(position)
  }, "Ver a cobertura completa"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-footer-plans"
  }, plan.price_with_coupon_discount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: true,
    customClassName: "search-applied-coupon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: false,
    customClassName: "search-applied-coupon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "old-price"
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatPrice"])(plan.adult.price))) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-footer-price-details".concat(plan.price_with_coupon_discount ? ' with-coupon-tag' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "price-atually"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatPrice"])(plan.price_with_coupon_discount || plan.adult.price)), " ", plan.parcels || 1, "x sem juros no cart\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "price-pix"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatPrice"])((plan.price_with_coupon_discount || plan.adult.price) * pixDiscountMultiplier)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PixDiscountTag__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "price-person"
  }, "/ pre\xE7o por pessoa")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "action-buttons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "compare-button".concat(plan.code),
    className: "compare-button"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "checkbox",
    defaultChecked: isSelected,
    id: "compare-button".concat(plan.code),
    onClick: function onClick() {
      return addComparisonPlan(plan);
    },
    "data-cy": "botao-comparar-p".concat(position)
  }), "Comparar Plano"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: "select-button",
    onClick: selectPlan,
    "data-cy": "botao-selecionar-seguro-p".concat(position)
  }, "Selecionar seguro")))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods
  };
})(Plan));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return runFacebook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return runYuhagent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return runGoogleAdWordsConversion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return runGoogleAdWordsConversionSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewRunGoogleAdwordsConversion; });
var runFacebook = function runFacebook(trackParam, params) {
  try {
    window.fbq.disablePushState = true;
    window.fbq('init', '1350651451690366');
    window.fbq('track', trackParam, params);
  } catch (e) {
    console.error(e);
  }
};
var runYuhagent = function runYuhagent(price, orderId) {
  var namespaces = ['__yuhagent', '__yuhagent_dev'];
  var _loop = function _loop() {
    var namespace = namespaces[i];
    window[namespace] = window[namespace] || function () {
      (window[namespace].q = window[namespace].q || []).push(arguments);
    };
    window[namespace]('order_placed', {
      value: price,
      id: orderId
    });
  };
  for (var i = 0; i < namespaces.length; i++) {
    _loop();
  }
};

// export const runGoogleAnalytics = () => {
//     try {
//         function gtag() {
//             dataLayer.push(arguments);
//         }
//         const page = getPage()

//         if (page === 'pesquisa') {
//             window.gtag("event", "conversion", {
//               send_to: "AW-797626440/2j-VCM31oZIBEMigq_wC"
//             });
//         }
//         else if (page === 'pos-compra') {
//             window.gtag("event", "conversion", {
//               send_to: "AW-797626440/oTXVCIr3oZIBEMigq_wC",
//             });
//         }
//     }
//     catch (e) {
//         console.error(e)
//     }
// }

var runGoogleAdWordsConversion = function runGoogleAdWordsConversion(id, value) {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/oTXVCIr3oZIBEMigq_wC',
  //         value,
  //         currency: 'BRL',
  //         transaction_id: id,
  //     });
  // }
  // catch (e) {
  //     console.error(e)
  // }
};
var runGoogleAdWordsConversionSearch = function runGoogleAdWordsConversionSearch() {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/2j-VCM31oZIBEMigq_wC'
  //     });
  // }
  // catch (e) {
  //     console.error(e)
  // }
};
var NewRunGoogleAdwordsConversion = function NewRunGoogleAdwordsConversion(id) {
  // try {
  //     window.gtag('event', 'conversion', {
  //         send_to: 'AW-797626440/g5CaCJ-otcQBEMigq_wC',
  //         transaction_id: id
  //     });
  // }
  // catch (e){
  //     console.log(e)
  // }
};

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__standard_loading_Loading__ = __webpack_require__(33);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var ModalEmail = /*#__PURE__*/function (_Component) {
  function ModalEmail(props) {
    var _this;
    _classCallCheck(this, ModalEmail);
    _this = _callSuper(this, ModalEmail, [props]);
    if (props.type === 'comparison') _this.state = {
      title: 'Enviar comparação por email',
      defaultMsg: 'Envie essa comparação do seu Seguro Viagem por e-mail e acesse quando quiser.',
      successMsg: 'Comparação enviada com sucesso!',
      errorMsg: 'Houve um problema no envio do email! :('
    };else if (props.type === 'detail') _this.state = {
      title: 'Enviar cobertura por e-mail',
      defaultMsg: 'Envie essa cobertura do seguro viagem por e-mail e acesse quando quiser',
      successMsg: 'Detalhes do Plano enviados com sucesso!',
      errorMsg: 'Houve um problema no envio do email! :('
    };
    _this.sendEmail = _this.sendEmail.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(ModalEmail, _Component);
  return _createClass(ModalEmail, [{
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      this.props.changeEmailModalAttr(field);
    }
  }, {
    key: "sendEmail",
    value: function sendEmail() {
      var pageParams = _objectSpread({}, this.props.match.params);
      if (this.props.type === 'comparison') pageParams = _objectSpread(_objectSpread({}, this.props.match.params), {}, {
        products_ids: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["getUrlParams"])().products_ids.replace(/%20/g, '+').split('+')
      });
      Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["sendEmail"])(pageParams, this.props.type, this.props.emailModal.emailAddress);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalEmailActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_modalemail"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modalbody"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "modalheader",
        onClick: this.props.closeModalEmail
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/circleClose.svg",
        alt: "fechar"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/plane.svg",
        alt: "enviar email"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        className: "modaltitle"
      }, this.state.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "modalcontent"
      }, this.props.emailStatus === 'done' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.state.successMsg), this.props.emailStatus === 'fail' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.state.errorMsg), this.props.emailStatus === '' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.state.defaultMsg)), this.props.emailStatus === 'sending' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__standard_loading_Loading__["a" /* Loading */], null), this.props.emailStatus !== 'sending' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modal-input-group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        key: "modal-input",
        type: "text",
        name: "emailAddress",
        className: "modalinput",
        value: this.props.email,
        onChange: this.handleChange,
        placeholder: "Seu e-mail"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        key: "modal-button",
        className: "modalbutton",
        onClick: this.sendEmail
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "modalbutton_span"
      }, "Enviar")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    emailModal: state.comparison.emailModal,
    emailStatus: state.comparison.emailStatus,
    isModalEmailActive: state.comparison.isModalEmailActive
  };
}, {
  closeModalEmail: __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__["b" /* closeModalEmail */],
  changeEmailModalAttr: __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__["a" /* changeEmailModalAttr */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalEmail)));

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMask; });
var getMask = function getMask(brand) {
  if (brand === 'amex') return {
    mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/]
  };else if (brand === 'diners') return {
    mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  };
  return {
    mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  };
};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return month_options; });
var month_options = [{
  name: '01',
  value: '01'
}, {
  name: '02',
  value: '02'
}, {
  name: '03',
  value: '03'
}, {
  name: '04',
  value: '04'
}, {
  name: '05',
  value: '05'
}, {
  name: '06',
  value: '06'
}, {
  name: '07',
  value: '07'
}, {
  name: '08',
  value: '08'
}, {
  name: '09',
  value: '09'
}, {
  name: '10',
  value: '10'
}, {
  name: '11',
  value: '11'
}, {
  name: '12',
  value: '12'
}];

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


var CardPurchaseValidation = /*#__PURE__*/function (_Component) {
  function CardPurchaseValidation() {
    _classCallCheck(this, CardPurchaseValidation);
    return _callSuper(this, CardPurchaseValidation, arguments);
  }
  _inherits(CardPurchaseValidation, _Component);
  return _createClass(CardPurchaseValidation, [{
    key: "render",
    value: function render() {
      if (!this.props.isInvalidCreditCardErrorVisible) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      var _this$props = this.props,
        ccBrand = _this$props.ccBrand,
        ccLastDigits = _this$props.ccLastDigits;
      var brand = ccBrand.charAt(0).toUpperCase() + ccBrand.slice(1);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_cardpurchasevalidation"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "container-left"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        className: "alert",
        src: "/assets/images/pagamento/alert-white.svg",
        alt: "erro"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "container-right"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-red"
      }, "N\xE3o conseguimos processar o pagamento da sua viagem com o cart\xE3o de cr\xE9dito", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, " ", brand, " final ", ccLastDigits, ", revise a forma de pagamento e tente finalizar novamente.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, " Listamos os motivos mais comuns para que voc\xEA possa verificar: "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "list"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "Algum dado inv\xE1lido (n\xFAmero do cart\xE3o, data de vencimento, c\xF3digo de seguran\xE7a);"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "Bloqueio de seguran\xE7a pela operadora do cart\xE3o;"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "Limite de cr\xE9dito indispon\xEDvel no cartao;"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "Limite de transa\xE7\xF5es do cart\xE3o virtual;"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "Uso de um cart\xE3o de d\xE9bito (aceitamos apenas cr\xE9dito).")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Se estiver com d\xFAvidas, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, "entre em contato com a operadora do seu cart\xE3o"), " para identificar o motivo (geralmente o n\xFAmero de telefone fica no verso do cart\xE3o) e ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, "finalize a compra novamente."))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isInvalidCreditCardErrorVisible: state.purchase.isInvalidCreditCardErrorVisible,
    ccBrand: state.purchase.invalidCreditCard.brand,
    ccLastDigits: state.purchase.invalidCreditCard.lastDigits
  };
}, {})(CardPurchaseValidation));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusBoleto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var StatusBoleto = /*#__PURE__*/function (_Component) {
  function StatusBoleto() {
    _classCallCheck(this, StatusBoleto);
    return _callSuper(this, StatusBoleto, arguments);
  }
  _inherits(StatusBoleto, _Component);
  return _createClass(StatusBoleto, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "container-info  ".concat(this.props.theme)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: this.props.image,
        alt: this.props.altIcon
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos"
      }, this.props.children));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1bReZ","modal":"gIKye","header":"u-tNY","headerTitle":"m6bqJ","headerSubtitle":"_1IX9b","content":"_1BwHh","section":"G6TVE","sectionHeading":"_1tNxr","timeline":"_3_u3-","timelineConnector":"_2tbe9","timelineStep":"_2dvIE","timelineBullet":"_3yS86","timelineBulletInactive":"_2l2kJ","timelineStepContent":"_3liZo","datesRow":"_396Vo","desktopPickerCard":"Baqsw","desktopPickerFooter":"InByE","desktopPickerCloseBtn":"_2ZWiM","stepLabel":"_1yvoQ","figmaInput":"UAsIY","figmaInputIcon":"_3DPSv","figmaInputTexts":"_32pG8","figmaInputLabel":"_1v3LZ","figmaInputValue":"_1-mCc","inputDropdownWrapper":"_3pUj-","destinationList":"_3F606","destinationItem":"_1C2e4","destinationDescription":"_3eUsM","durationBadge":"_1kEFn","durationValue":"_1ad0w","summaryCard":"_2e84a","purchaseItem":"o_Tna","providerImg":"YJXBi","planName":"_16DgZ","separator":"_17uOR","detailsGrid":"bePdz","detailCell":"_2sFca","detailLabel":"_2oCC-","detailValue":"_3FL3g","totalSection":"Ns_FW","totalLabel":"_zzWg","totalPrice":"qRdzF","totalCurrency":"_3EVD0","totalAmount":"_3_fSA","checkboxSection":"g9e8L","checkboxRow":"_2Yvjb","checkbox":"_1v_EV","checkboxText":"_1MvhO","confirmButton":"_3FHiw","incompatibleOverlay":"_3zDME","incompatibleCard":"_106IP","incompatibleCloseBtn":"_3NaFp","incompatibleTitleBr":"_2qsBT","incompatibleContent":"_1KrLk","incompatibleIconBg":"_3jVyY","incompatibleTitle":"_1b0iN","incompatibleBody":"_36dIR","incompatibleActions":"pZXyL","incompatiblePrimaryBtn":"_38Lo9","incompatibleSecondaryBtn":"nkHmX"};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }





var BoxValues = /*#__PURE__*/function (_Component) {
  function BoxValues() {
    var _this;
    _classCallCheck(this, BoxValues);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BoxValues, [].concat(args));
    _defineProperty(_this, "backSearch", function (e) {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(_this.props.match, "/pesquisa/".concat(_this.props.match.params.destination, "/").concat(_this.props.match.params.begin_date, "/").concat(_this.props.match.params.end_date, "/"), null)
      };
      _this.props.cleanStatesPurchaseMobile();
      _this.props.cleanErrors();
      _this.props.history.push(location);
    });
    _defineProperty(_this, "renderPrice", function () {
      var plan = _this.props.plan[0];
      if (_this.props.purchaseSummary.coupon_discount && !_this.props.purchaseSummary.total) return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])('0,00');else if (_this.props.purchaseSummary.total) return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(_this.props.purchaseSummary.total);else return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.adult.price);
    });
    return _this;
  }
  _inherits(BoxValues, _Component);
  return _createClass(BoxValues, [{
    key: "render",
    value: function render() {
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-values"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "desktop"
      }, "Resumo da compra"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-passageiros"
      }, this.props.purchaseSummary.elder.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.elder.qte, " Adulto", this.props.purchaseSummary.elder.qte > 1 ? 's' : '', ' ', "(maior de ", plan.adult.max_age, " anos)"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.elder.price))), this.props.purchaseSummary.adult.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.adult.qte, " Adulto", this.props.purchaseSummary.adult.qte > 1 ? 's' : ''), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.adult.price))), this.props.purchaseSummary.child.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.child.qte, " Crian\xE7a", this.props.purchaseSummary.child.qte > 1 ? 's' : '', " (at\xE9", ' ', plan.child.max_age, " anos)"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.child.price))), this.props.purchaseSummary.invalid.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.invalid.qte, " Adulto", this.props.purchaseSummary.invalid.qte > 1 ? 's' : '', ' ', "(idade incompat\xEDvel com o plano)")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex back-search"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: this.backSearch
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Voltar \xE0 pesquisa"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-subtotal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "title-subtotal"
      }, "Subtotal"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.subtotal || plan.adult.price))), this.props.purchaseSummary.paymentMethodDiscountValue > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Desconto ", this.props.purchaseSummary.paymentMethodSelected), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "- R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.paymentMethodDiscountValue))), this.props.purchaseSummary.coupon_discount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex coupon"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Cupom aplicado"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "- R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.coupon_discount))), this.props.purchaseSummary.creditCouponAmountUsed > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex credit-coupon-applied"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Cr\xE9ditos utilizados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "- R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.creditCouponAmountUsed))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "text-total"
      }, "Total"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "text-total"
      }, "R$ ", this.renderPrice()))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plan: state.search.plans,
    purchaseSummary: state.purchase.purchaseSummary,
    mobile: state.mobile.mobileActive
  };
}, {
  clearCoupon: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["o" /* clearCoupon */],
  cleanStatesPurchaseMobile: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["m" /* cleanStatesPurchaseMobile */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["l" /* cleanErrors */]
})(BoxValues)));

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_Chevron_icon__ = __webpack_require__(314);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }








var BoxCoupon = /*#__PURE__*/function (_Component) {
  function BoxCoupon(props) {
    var _this;
    _classCallCheck(this, BoxCoupon);
    _this = _callSuper(this, BoxCoupon, [props]);
    _this.fetchCoupon = _this.fetchCoupon.bind(_this);
    _this.textInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.state = {
      coupon: '',
      collapsed: false
    };
    return _this;
  }
  _inherits(BoxCoupon, _Component);
  return _createClass(BoxCoupon, [{
    key: "fetchCoupon",
    value: function fetchCoupon(e) {
      e.preventDefault();
      if (this.props.couponInfo.exists) return;
      var begin_date = this.props.match.params.begin_date;
      var end_date = this.props.match.params.end_date;
      var destination = this.props.match.params.destination;
      var product_code = this.props.match.params.product_code;
      Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["getCouponData"])(this.state.coupon, product_code, begin_date, end_date, destination);
      __WEBPACK_IMPORTED_MODULE_6__utils_matomo__["a" /* default */].trackEvent('Checkout', 'ApplyCoupon', this.state.coupon);
    }
  }, {
    key: "handleCouponChange",
    value: function handleCouponChange(e) {
      this.setState({
        coupon: e.target.value.toUpperCase()
      });
    }
  }, {
    key: "toggleCollapse",
    value: function toggleCollapse() {
      this.setState(function (prev) {
        return {
          collapsed: !prev.collapsed
        };
      });
    }
  }, {
    key: "onFocusCoupon",
    value: function onFocusCoupon() {
      if (this.props.mobile) {
        this.props.scrollToRef();
      }
    }
  }, {
    key: "selectedPaymentMethod",
    value: function selectedPaymentMethod(paymentMethods) {
      for (var pm in paymentMethods) {
        if (paymentMethods[pm].selected) {
          return paymentMethods[pm].id;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var couponErrorPaymentMethod = this.props.couponInfo.payment_method !== undefined && this.props.couponInfo.payment_method !== null && this.selectedPaymentMethod(this.props.payment_methods) !== this.props.couponInfo.payment_method;
      var couponError = this.props.couponInfo.exists === false || this.props.couponInfo.notFound === true;
      if (this.props.couponInfo.exists && !couponErrorPaymentMethod) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "box box-coupon exist"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "coupon-header",
          onClick: function onClick() {
            return _this2.toggleCollapse();
          }
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "text-message"
        }, "Cupom aplicado"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__assets_icons_Chevron_icon__["a" /* ChevronIcon */], {
          open: this.state.collapsed
        })), !this.state.collapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "coupon-name"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.couponInfo.text), this.props.couponInfo.discount_type === 0 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Desconto de R$", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(this.props.purchaseSummary.coupon_discount), " no seu seguro viagem") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, parseInt(this.props.couponInfo.discount, 0).toFixed(), "% OFF no seu seguro viagem")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          onClick: this.props.clearCoupon
        }, "Trocar cupom")));
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-coupon"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "coupon-header",
        onClick: function onClick() {
          return _this2.toggleCollapse();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Cupom de desconto"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__assets_icons_Chevron_icon__["a" /* ChevronIcon */], {
        open: this.state.collapsed
      })), !this.state.collapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        className: "cupom-desconto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "coupon",
        id: "cupom",
        placeholder: "Digite o cupom",
        value: this.state.coupon,
        onChange: function onChange(e) {
          return _this2.handleCouponChange(e);
        },
        onFocus: function onFocus() {
          return _this2.onFocusCoupon();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        value: "Submit",
        onClick: this.fetchCoupon
      }, "Aplicar"), couponError && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "custom-tooltip "
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", {
        className: "error"
      }, "Erro: Cupom Inv\xE1lido ou expirado")), couponErrorPaymentMethod && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "custom-tooltip "
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", {
        className: "error"
      }, "Erro: Cupom n\xE3o \xE9 v\xE1lido para o tipo de pagamento selecionado"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    couponInfo: state.purchase.coupon,
    payment_methods: state.purchase.paymentMethods,
    mobile: state.mobile.mobileActive,
    purchaseSummary: state.purchase.purchaseSummary
  };
}, {
  setCouponText: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_22" /* setCouponText */],
  clearCoupon: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["o" /* clearCoupon */]
})(BoxCoupon)));

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Tags__ = __webpack_require__(24);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var BoxPlan = /*#__PURE__*/function (_Component) {
  function BoxPlan() {
    _classCallCheck(this, BoxPlan);
    return _callSuper(this, BoxPlan, arguments);
  }
  _inherits(BoxPlan, _Component);
  return _createClass(BoxPlan, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      if (!this.props.providers[0].slug) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var providers = this.props.providers;
      var providerSlug = providers.filter(function (provider) {
        return provider.code === plan.provider_code;
      })[0].slug;
      var providerImgPath = "/assets/images/seguradoras/".concat(providerSlug, ".png");
      var destinationObject = this.props.destinations.find(function (destination) {
        return destination.slug === _this.props.match.params.destination;
      });
      var destination = destinationObject ? destinationObject.name : '';
      var isUpsell = this.props.upsellUpgrade === String(plan.code);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-plan"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "description-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "destination"
      }, destination), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "time"
      }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.begin_date), " - ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.end_date))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "description-body"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "column-img"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: providerImgPath,
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "column-description"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Tags__["a" /* default */], {
        tag: Object(__WEBPACK_IMPORTED_MODULE_5__common_Tags__["b" /* getTag */])(plan),
        isMobile: false,
        customClassName: "plan-tag"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "name-plan"
      }, plan.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "prices-high"
      }, "Faixa et\xE1ria: ", plan.child.min_age, " a ", plan.elder.max_age, " anos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), plan.elder.min_age < plan.elder.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.elder.price), "\xA0maiores de ", plan.adult.max_age, " anos")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-plans-row"
      }, plan.benefits && plan.benefits.map(function (benefit, i) {
        return benefit.code === 42 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: i
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, benefit.coverage), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Despesa m\xE9dica hospitalar"));
      }), plan.benefits && plan.benefits.map(function (benefit, i) {
        return benefit.code === 51 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: i
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, benefit.coverage), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Despesa m\xE9dica hospitalar"));
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-plans-row roof desktop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalDetail,
        className: "ver-mais"
      }, "Cobertura completa"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalPlanRules,
        className: "plan-rules"
      }, "Informa\xE7\xF5es e Regras do Plano")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-plans-row roof mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalDetail,
        className: "ver-mais"
      }, "Cobertura completa"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalPlanRules,
        className: "plan-rules"
      }, "Informa\xE7\xF5es e Regras do Plano")));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plan: state.search.plans,
    destinations: state.global.destinations,
    providers: state.global.providers,
    upsellUpgrade: state.purchase.upsellUpgrade
  };
}, {
  openModalDetail: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["Y" /* openModalDetail */],
  openModalPlanRules: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_4" /* openModalPlanRules */]
})(BoxPlan)));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_matomo__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }






var ConfirmPurchase = /*#__PURE__*/function (_Component) {
  function ConfirmPurchase() {
    var _this;
    _classCallCheck(this, ConfirmPurchase);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConfirmPurchase, [].concat(args));
    _defineProperty(_this, "finishPurchase", function () {
      var params = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["getUrlParams"])();
      var isOperatorSale = params.operator !== undefined;
      if (isOperatorSale && !_this.props.hasConfirmedOperator) {
        _this.props.openModalOperatorConfirmation();
        return;
      }
      _this.props.sendingPurchase();
      _this.props.finishPurchase().then(function (response) {
        if (response && response.reproved === true) {
          _this.props.openModalFailPayment();
          return;
        }
        if (!_this.props.purchase_is_valid) {
          _this.props.history.push("".concat(_this.props.location.pathname).concat(_this.props.location.search, "#").concat(_this.props.anchor));
        }
      })["catch"](function (error) {
        console.error('Erro ao finalizar compra:', error);
        alert('Ocorreu um erro ao processar sua compra. Tente novamente.');
      });
      __WEBPACK_IMPORTED_MODULE_5__utils_matomo__["a" /* default */].trackEvent('Checkout', 'SubmitOrder', 'Click');
    });
    return _this;
  }
  _inherits(ConfirmPurchase, _Component);
  return _createClass(ConfirmPurchase, [{
    key: "render",
    value: function render() {
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      var providers = this.props.providers;
      var provider = providers.filter(function (pr) {
        return plan.provider_code === pr.code;
      });
      var termsUrl = '';
      if (provider.length) termsUrl = provider[0].terms_url;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "confirm-purchase"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "finish-payment",
        "data-cy": "confirm-purchase",
        onClick: this.finishPurchase,
        "data-perry-send-prospect-btn": true
      }, "Efetuar compra"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "text-payment"
      }, "Ao clicar em \"efetuar compra\" voc\xEA concorda com os", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://www.segurospromo.com.br/shared/pdf/termos/termos-de-uso-e-condicoes-seguros-promo.pdf"
      }, "Termos de Uso,", ' '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        target: "_blank",
        href: termsUrl
      }, "Condi\xE7\xF5es Gerais do Seguro"), ' ', "e ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalDetail
      }, "Cobertura do Produto"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var ConfirmPurchaseWrapper = function ConfirmPurchaseWrapper(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConfirmPurchase, props);
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plan: state.search.plans,
    anchor: state.purchase.anchor,
    purchase_is_valid: state.purchase.purchase_is_valid,
    providers: state.global.providers,
    hasConfirmedOperator: state.purchase.hasConfirmedOperator
  };
}, {
  openModalDetail: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["Y" /* openModalDetail */],
  openModalFailPayment: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["Z" /* openModalFailPayment */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["l" /* cleanErrors */],
  sendingPurchase: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_21" /* sendingPurchase */],
  finishPurchase: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["P" /* finishPurchase */],
  openModalOperatorConfirmation: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_3" /* openModalOperatorConfirmation */]
})(ConfirmPurchaseWrapper)));

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_Info_icon__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_CheckCircle_icon__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_css__);







var BoxCreditCoupon = function BoxCreditCoupon(_ref) {
  var creditCoupon = _ref.creditCoupon,
    purchaseSummary = _ref.purchaseSummary,
    fetchFirstActiveCreditCoupon = _ref.fetchFirstActiveCreditCoupon,
    applyCreditCoupon = _ref.applyCreditCoupon,
    removeAppliedCreditCoupon = _ref.removeAppliedCreditCoupon,
    setCreditCouponCode = _ref.setCreditCouponCode;
  var applied = creditCoupon.applied || false;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    fetchFirstActiveCreditCoupon();
  }, [fetchFirstActiveCreditCoupon]);
  var handleApplyCoupon = function handleApplyCoupon() {
    if (creditCoupon.code) {
      applyCreditCoupon(creditCoupon.code);
    }
  };
  var handleRemoveAppliedCreditCoupon = function handleRemoveAppliedCreditCoupon() {
    if (applied) {
      removeAppliedCreditCoupon();
    }
  };
  if (creditCoupon.code === null) {
    return null;
  }
  var couponCode = creditCoupon.code || '';
  var creditAmount = creditCoupon.creditAmount || 0;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "available-coupons"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    className: "credit-balance__title"
  }, "Cr\xE9dito dispon\xEDvel"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("article", {
    className: "credit-balance__card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance__badge"
  }, "Saldo dispon\xEDvel", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__assets_icons_Info_icon__["a" /* InfoIcon */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance__form"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "text",
    name: "credit_coupon",
    className: "credit-balance__input",
    value: couponCode,
    onChange: function onChange(e) {
      return setCreditCouponCode(e.target.value);
    },
    disabled: applied
  }), applied ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "btn remove",
    onClick: handleRemoveAppliedCreditCoupon
  }, "Remover") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "btn",
    onClick: handleApplyCoupon
  }, "Usar")), creditCoupon.error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", {
    className: "coupon-card__error"
  }, "Cupom inv\xE1lido ou expirado") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "coupon-card__description"
  }, "Cr\xE9dito de", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, creditAmount.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })))))), applied && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance-feedback"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-balance-feedback__label"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_CheckCircle_icon__["a" /* CheckCircleIcon */], null), " Cr\xE9dito aplicado"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, purchaseSummary.creditCouponAmountUsed.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    creditCoupon: state.purchase.creditCoupon,
    purchaseSummary: state.purchase.purchaseSummary
  };
};
var mapDispatchToProps = {
  fetchFirstActiveCreditCoupon: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["K" /* fetchFirstActiveCreditCoupon */],
  setCreditCouponCode: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_23" /* setCreditCouponCode */],
  applyCreditCoupon: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["b" /* applyCreditCoupon */],
  removeAppliedCreditCoupon: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_12" /* removeAppliedCreditCoupon */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(BoxCreditCoupon)));

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserInitials;
function getUserInitials(name) {
  if (typeof name !== "string" || !name.trim()) return "U";
  var names = name.trim().split(" ");
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GoogleLoginButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useGoogleLogin__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Altcha__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GoogleLoginButton_css__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GoogleLoginButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__GoogleLoginButton_css__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }






var DEFAULT_ERROR = 'Não foi possível entrar com o Google. Tente novamente.';
var ERROR_DURATION = 6000;
function getApiErrorMessage(_x) {
  return _getApiErrorMessage.apply(this, arguments);
}
function _getApiErrorMessage() {
  _getApiErrorMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(response) {
    var data, message, action, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          _context2.n = 1;
          return response.json();
        case 1:
          data = _context2.v;
          message = data && data.message;
          action = data && data.action;
          return _context2.a(2, "".concat(message, " ").concat(action));
        case 2:
          _context2.p = 2;
          _t3 = _context2.v;
          return _context2.a(2, DEFAULT_ERROR);
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return _getApiErrorMessage.apply(this, arguments);
}
function GoogleLoginButton(_ref) {
  var label = _ref.label,
    refetchUser = _ref.refetchUser;
  var altchaRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState2 = _slicedToArray(_useState, 2),
    setAltchaPayload = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    setVerifying = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!error) return undefined;
    var timer = setTimeout(function () {
      return setError(null);
    }, ERROR_DURATION);
    return function () {
      return clearTimeout(timer);
    };
  }, [error]);
  var _useGoogleLogin = Object(__WEBPACK_IMPORTED_MODULE_3__hooks_useGoogleLogin__["a" /* default */])({
      clientId: "850169372117-c4028fn85pl971lpigtj5s6sorr8fjf1.apps.googleusercontent.com",
      onSuccess: function () {
        var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(code) {
          var payload, response, _t, _t2;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                setError(null);
                setLoading(true);
                _context.p = 1;
                _context.n = 2;
                return altchaRef.current.verify();
              case 2:
                payload = _context.v;
                if (payload) {
                  _context.n = 3;
                  break;
                }
                setError('Não foi possível validar o captcha. Tente novamente.');
                return _context.a(2);
              case 3:
                if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["getCookie"])('csrftoken')) {
                  _context.n = 4;
                  break;
                }
                _context.n = 4;
                return fetch("".concat("https://dev.segurospromo.com.br", "/safearea/api/v1/sessions/csrf/"), {
                  method: 'GET',
                  credentials: 'include'
                });
              case 4:
                _context.n = 5;
                return fetch("".concat("https://dev.segurospromo.com.br", "/safearea/api/v1/sessions/"), {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': Object(__WEBPACK_IMPORTED_MODULE_1__utils_js__["getCookie"])('csrftoken') || ''
                  },
                  credentials: 'include',
                  body: JSON.stringify({
                    google_code: code,
                    altcha_code: payload
                  })
                });
              case 5:
                response = _context.v;
                altchaRef.current.reset();
                if (response.ok) {
                  _context.n = 7;
                  break;
                }
                _t = setError;
                _context.n = 6;
                return getApiErrorMessage(response);
              case 6:
                _t(_context.v);
                return _context.a(2);
              case 7:
                refetchUser();
                _context.n = 9;
                break;
              case 8:
                _context.p = 8;
                _t2 = _context.v;
                setError(DEFAULT_ERROR);
              case 9:
                _context.p = 9;
                setLoading(false);
                return _context.f(9);
              case 10:
                return _context.a(2);
            }
          }, _callee, null, [[1, 8, 9, 10]]);
        }));
        function onSuccess(_x2) {
          return _onSuccess.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: function onError(err) {
        if (err && err.type === 'popup_closed') return;
        setError(DEFAULT_ERROR);
      }
    }),
    login = _useGoogleLogin.login;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "google_login"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "google_button".concat(loading ? ' google_button--loading' : ''),
    onClick: login,
    disabled: loading,
    "aria-busy": loading
  }, loading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "google_button__spinner",
    "aria-hidden": "true"
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["e" /* GoogleIcon */], null), label), error && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "custom-tooltip",
    role: "alert"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", {
    className: "error"
  }, error)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Altcha__["a" /* AltchaWidget */], {
    ref: altchaRef,
    onPayloadChange: setAltchaPayload,
    onVerifyingChange: setVerifying
  }));
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FeatureString */
/* unused harmony export FeaturesReady */
/* unused harmony export GrowthBookContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GrowthBookProvider; });
/* unused harmony export IfFeatureEnabled */
/* unused harmony export getGrowthBookSSRData */
/* unused harmony export useExperiment */
/* unused harmony export useFeature */
/* unused harmony export useFeatureIsOn */
/* unused harmony export useFeatureValue */
/* unused harmony export useGrowthBook */
/* unused harmony export useGrowthBookSSR */
/* unused harmony export withRunExperiment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__growthbook_growthbook__ = __webpack_require__(114);
/* unused harmony reexport BrowserCookieStickyBucketService */
/* unused harmony reexport ExpressCookieStickyBucketService */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__growthbook_growthbook__["a"]; });
/* unused harmony reexport LocalStorageStickyBucketService */
/* unused harmony reexport RedisStickyBucketService */
/* unused harmony reexport StickyBucketService */
/* unused harmony reexport clearCache */
/* unused harmony reexport configureCache */
/* unused harmony reexport getPolyfills */
/* unused harmony reexport helpers */
/* unused harmony reexport prefetchPayload */
/* unused harmony reexport setPolyfills */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

/** @deprecated */

var GrowthBookContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createContext"]({});

/** @deprecated */
function getGrowthBookSSRData(_x) {
  return _getGrowthBookSSRData.apply(this, arguments);
}
/** @deprecated */
function _getGrowthBookSSRData() {
  _getGrowthBookSSRData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(context) {
    var gb, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // Server-side GrowthBook instance
          gb = new __WEBPACK_IMPORTED_MODULE_0__growthbook_growthbook__["a" /* GrowthBook */](_objectSpread({}, context)); // Load feature flags from network if needed
          if (!context.clientKey) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return gb.init();
        case 1:
          data = {
            attributes: gb.getAttributes(),
            features: gb.getFeatures()
          };
          gb.destroy();
          return _context.a(2, data);
      }
    }, _callee);
  }));
  return _getGrowthBookSSRData.apply(this, arguments);
}
function useGrowthBookSSR(data) {
  var gb = useGrowthBook();

  // Only do this once to avoid infinite loops
  var isFirst = __WEBPACK_IMPORTED_MODULE_1_react__["useRef"](true);
  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}
function useExperiment(exp) {
  var _React$useContext = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](GrowthBookContext),
    growthbook = _React$useContext.growthbook;
  return growthbook.run(exp);
}
function useFeature(id) {
  var growthbook = useGrowthBook();
  return growthbook.evalFeature(id);
}
function useFeatureIsOn(id) {
  var growthbook = useGrowthBook();
  return growthbook.isOn(id);
}
function useFeatureValue(id, fallback) {
  var growthbook = useGrowthBook();
  return growthbook.getFeatureValue(id, fallback);
}
function useGrowthBook() {
  var _React$useContext2 = __WEBPACK_IMPORTED_MODULE_1_react__["useContext"](GrowthBookContext),
    growthbook = _React$useContext2.growthbook;
  if (!growthbook) {
    throw new Error("Missing or invalid GrowthBookProvider");
  }
  return growthbook;
}
function FeaturesReady(_ref) {
  var children = _ref.children,
    timeout = _ref.timeout,
    fallback = _ref.fallback;
  var gb = useGrowthBook();
  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    hitTimeout = _React$useState2[0],
    setHitTimeout = _React$useState2[1];
  var ready = gb ? gb.ready : false;
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    if (timeout && !ready) {
      var timer = setTimeout(function () {
        gb && gb.log("FeaturesReady timed out waiting for features to load", {
          timeout: timeout
        });
        setHitTimeout(true);
      }, timeout);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [timeout, ready, gb]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, ready || hitTimeout ? children : fallback || null);
}
function IfFeatureEnabled(_ref2) {
  var children = _ref2.children,
    feature = _ref2.feature;
  return useFeature(feature).on ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, children) : null;
}
function FeatureString(props) {
  var value = useFeature(props.feature).value;
  if (value !== null) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, value);
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, props["default"]);
}
var withRunExperiment = function withRunExperiment(Component) {
  var withRunExperimentWrapper = function withRunExperimentWrapper(props) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](GrowthBookContext.Consumer, null, function (_ref3) {
      var growthbook = _ref3.growthbook;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, _extends({}, props, {
        runExperiment: function runExperiment(exp) {
          return growthbook.run(exp);
        }
      }));
    });
  };
  return withRunExperimentWrapper;
};
withRunExperiment.displayName = "WithRunExperiment";
var GrowthBookProvider = function GrowthBookProvider(_ref4) {
  var children = _ref4.children,
    growthbook = _ref4.growthbook;
  // Tell growthbook how to re-render our app (for dev mode integration)

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    _ = _React$useState4[0],
    setRenderCount = _React$useState4[1];
  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(function () {
      setRenderCount(function (v) {
        return v + 1;
      });
    });
    return function () {
      growthbook.setRenderer(function () {
        // do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](GrowthBookContext.Provider, {
    value: {
      growthbook: growthbook
    }
  }, children);
};


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feature_repository_mjs__ = __webpack_require__(60);
/* unused harmony reexport setPolyfills */
/* unused harmony reexport clearCache */
/* unused harmony reexport configureCache */
/* unused harmony reexport helpers */
/* unused harmony reexport onVisible */
/* unused harmony reexport onHidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GrowthBook_mjs__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__GrowthBook_mjs__["a"]; });
/* unused harmony reexport prefetchPayload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GrowthBookClient_mjs__ = __webpack_require__(375);
/* unused harmony reexport GrowthBookMultiUser */
/* unused harmony reexport GrowthBookClient */
/* unused harmony reexport UserScopedGrowthBook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sticky_bucket_service_mjs__ = __webpack_require__(376);
/* unused harmony reexport StickyBucketService */
/* unused harmony reexport StickyBucketServiceSync */
/* unused harmony reexport LocalStorageStickyBucketService */
/* unused harmony reexport ExpressCookieStickyBucketService */
/* unused harmony reexport BrowserCookieStickyBucketService */
/* unused harmony reexport RedisStickyBucketService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mongrule_mjs__ = __webpack_require__(115);
/* unused harmony reexport evalCondition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_mjs__ = __webpack_require__(17);
/* unused harmony reexport isURLTargeted */
/* unused harmony reexport getPolyfills */
/* unused harmony reexport getAutoExperimentChangeType */
/* unused harmony reexport paddedVersionString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_mjs__ = __webpack_require__(35);
/* unused harmony reexport EVENT_EXPERIMENT_VIEWED */
/* unused harmony reexport EVENT_FEATURE_EVALUATED */








/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = evalCondition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mjs__ = __webpack_require__(17);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable @typescript-eslint/no-explicit-any */


var _regexCache = {};

// The top-level condition evaluation function
function evalCondition(obj, condition,
// Must be included for `condition` to correctly evaluate group Operators
savedGroups,
// Group ids already being resolved, to stop cycles
visited) {
  savedGroups = savedGroups || {};
  visited = visited || new Set();
  // Condition is an object, keys are either specific operators or object paths
  // values are either arguments for operators or conditions for paths
  for (var _i = 0, _Object$entries = Object.entries(condition); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    switch (k) {
      case "$or":
        if (!evalOr(obj, v, savedGroups, visited)) return false;
        break;
      case "$nor":
        if (evalOr(obj, v, savedGroups, visited)) return false;
        break;
      case "$and":
        if (!evalAnd(obj, v, savedGroups, visited)) return false;
        break;
      case "$not":
        if (evalCondition(obj, v, savedGroups, visited)) return false;
        break;
      case "$savedGroup":
        if (!evalSavedGroup(obj, v, savedGroups, visited)) return false;
        break;
      default:
        if (!evalConditionValue(v, getPath(obj, k), savedGroups, false, visited)) return false;
    }
  }
  return true;
}

/** Resolves a `$savedGroup` reference. Anything unrecognized matches nobody. */
function evalSavedGroup(obj, reference, savedGroups, visited) {
  if (!reference || _typeof(reference) !== "object" || Array.isArray(reference)) return false;
  var id = reference.id,
    attributeKey = reference.attributeKey;
  if (typeof id !== "string" || visited.has(id)) return false;
  // Falling back to the entry's attribute would check a different population
  if (attributeKey !== undefined && typeof attributeKey !== "string") return false;
  var entry = savedGroups[id];
  // Absent, or a v1 bare array
  if (!entry || Array.isArray(entry) || _typeof(entry) !== "object") return false;
  var next = new Set(visited).add(id);
  if (entry.type === "list") {
    // The override wins over the entry's own attribute
    var key = attributeKey !== null && attributeKey !== void 0 ? attributeKey : entry.attributeKey;
    if (typeof key !== "string") return false;
    if (!Array.isArray(entry.values)) return false;
    return isIn(getPath(obj, key), entry.values);
  }
  if (entry.type === "condition") {
    // A condition group has no single attribute, so any override is ignored
    if (!entry.condition || _typeof(entry.condition) !== "object") return false;
    return evalCondition(obj, entry.condition, savedGroups, next);
  }

  // A group type added after this SDK was built
  return false;
}

// Return value at dot-separated path of an object
function getPath(obj, path) {
  var parts = path.split(".");
  var current = obj;
  for (var i = 0; i < parts.length; i++) {
    if (current && _typeof(current) === "object" && parts[i] in current) {
      current = current[parts[i]];
    } else {
      return null;
    }
  }
  return current;
}

// Transform a regex string into a real RegExp object
function getRegex(regex) {
  var insensitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cacheKey = "".concat(regex).concat(insensitive ? "/i" : "");
  if (!_regexCache[cacheKey]) {
    _regexCache[cacheKey] = new RegExp(regex.replace(/([^\\])\//g, "$1\\/"), insensitive ? "i" : undefined);
  }
  return _regexCache[cacheKey];
}

// Evaluate a single value against a condition
function evalConditionValue(condition, value, savedGroups) {
  var insensitive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var visited = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Set();
  // Simple equality comparisons
  if (typeof condition === "string") {
    if (insensitive) {
      return String(value).toLowerCase() === condition.toLowerCase();
    }
    return value + "" === condition;
  }
  if (typeof condition === "number") {
    return value * 1 === condition;
  }
  if (typeof condition === "boolean") {
    return value !== null && !!value === condition;
  }
  if (condition === null) {
    return value === null;
  }
  if (Array.isArray(condition) || !isOperatorObject(condition)) {
    return JSON.stringify(value) === JSON.stringify(condition);
  }

  // This is a special operator condition and we should evaluate each one separately
  for (var op in condition) {
    if (!evalOperatorCondition(op, value, condition[op], savedGroups, visited)) {
      return false;
    }
  }
  return true;
}

// If the object has only keys that start with '$'
function isOperatorObject(obj) {
  var keys = Object.keys(obj);
  return keys.length > 0 && keys.filter(function (k) {
    return k[0] === "$";
  }).length === keys.length;
}

// Return the data type of a value
function getType(v) {
  if (v === null) return "null";
  if (Array.isArray(v)) return "array";
  var t = _typeof(v);
  if (["string", "number", "boolean", "object", "undefined"].includes(t)) {
    return t;
  }
  return "unknown";
}

// At least one element of actual must match the expected condition/value
function elemMatch(actual, expected, savedGroups, visited) {
  if (!Array.isArray(actual)) return false;
  var check = isOperatorObject(expected) ? function (v) {
    return evalConditionValue(expected, v, savedGroups, false, visited);
  } : function (v) {
    return evalCondition(v, expected, savedGroups, visited);
  };
  for (var i = 0; i < actual.length; i++) {
    var _actual$i;
    // Only skip nullish elements; falsy values like 0, "" and false are valid
    // array members and must still be tested against the condition.
    if (((_actual$i = actual[i]) !== null && _actual$i !== void 0 ? _actual$i : null) !== null && check(actual[i])) {
      return true;
    }
  }
  return false;
}
function isIn(actual, expected) {
  var insensitive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (insensitive) {
    var caseFold = function caseFold(val) {
      return typeof val === "string" ? val.toLowerCase() : val;
    };
    // Do an intersection if attribute is an array (insensitive)
    if (Array.isArray(actual)) {
      return actual.some(function (el) {
        return expected.some(function (exp) {
          return caseFold(el) === caseFold(exp);
        });
      });
    }
    return expected.some(function (exp) {
      return caseFold(actual) === caseFold(exp);
    });
  }
  // Do an intersection if attribute is an array
  if (Array.isArray(actual)) {
    return actual.some(function (el) {
      return expected.includes(el);
    });
  }
  return expected.includes(actual);
}

/**
 * Gets the array of values from a saved group. This can either be the legacy bare array
 * format, or it can pull the array from the v2 "type: list" format.
 */
function getSavedGroupArrayValues(entry) {
  // An unknown id has always behaved like an empty list. A malformed entry
  // has not, and must not: $notInGroup would pass everyone.
  if (entry === undefined) return [];
  if (Array.isArray(entry)) return entry;

  // These operators take their attribute from the condition they sit on
  if (entry && _typeof(entry) === "object" && entry.type === "list") {
    return Array.isArray(entry.values) ? entry.values : null;
  }

  // A condition group, a malformed entry, or an unknown type
  return null;
}
function isInAll(actual, expected, savedGroups) {
  var insensitive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var visited = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Set();
  if (!Array.isArray(actual)) return false;
  for (var i = 0; i < expected.length; i++) {
    var passed = false;
    for (var j = 0; j < actual.length; j++) {
      if (evalConditionValue(expected[i], actual[j], savedGroups, insensitive, visited)) {
        passed = true;
        break;
      }
    }
    if (!passed) return false;
  }
  return true;
}

// Evaluate a single operator condition
function evalOperatorCondition(operator, actual, expected, savedGroups) {
  var visited = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Set();
  switch (operator) {
    case "$veq":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) === Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$vne":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) !== Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$vgt":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) > Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$vgte":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) >= Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$vlt":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) < Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$vlte":
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(actual) <= Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["p" /* paddedVersionString */])(expected);
    case "$eq":
      return actual === expected;
    case "$ne":
      return actual !== expected;
    case "$lt":
      return actual < expected;
    case "$lte":
      return actual <= expected;
    case "$gt":
      return actual > expected;
    case "$gte":
      return actual >= expected;
    case "$exists":
      // Using `!=` and `==` instead of strict checks so it also matches for undefined
      return expected ? actual != null : actual == null;
    case "$in":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected);
    case "$ini":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected, true);
    case "$inGroup":
      {
        var values = getSavedGroupArrayValues(savedGroups[expected]);
        return values === null ? false : isIn(actual, values);
      }
    case "$notInGroup":
      {
        // No values means matching nobody. An empty list would pass everyone.
        var _values = getSavedGroupArrayValues(savedGroups[expected]);
        return _values === null ? false : !isIn(actual, _values);
      }
    case "$nin":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected);
    case "$nini":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected, true);
    case "$not":
      return !evalConditionValue(expected, actual, savedGroups, false, visited);
    case "$size":
      if (!Array.isArray(actual)) return false;
      return evalConditionValue(expected, actual.length, savedGroups, false, visited);
    case "$elemMatch":
      return elemMatch(actual, expected, savedGroups, visited);
    case "$all":
      if (!Array.isArray(expected)) return false;
      return isInAll(actual, expected, savedGroups, false, visited);
    case "$alli":
      if (!Array.isArray(expected)) return false;
      return isInAll(actual, expected, savedGroups, true, visited);
    case "$regex":
      try {
        return getRegex(expected).test(actual);
      } catch (e) {
        return false;
      }
    case "$regexi":
      try {
        return getRegex(expected, true).test(actual);
      } catch (e) {
        return false;
      }
    case "$type":
      return getType(actual) === expected;
    default:
      console.error("Unknown operator: " + operator);
      return false;
  }
}

// Recursive $or rule
function evalOr(obj, conditions, savedGroups, visited) {
  if (!conditions.length) return true;
  for (var i = 0; i < conditions.length; i++) {
    if (evalCondition(obj, conditions[i], savedGroups, visited)) {
      return true;
    }
  }
  return false;
}

// Recursive $and rule
function evalAnd(obj, conditions, savedGroups, visited) {
  for (var i = 0; i < conditions.length; i++) {
    if (!evalCondition(obj, conditions[i], savedGroups, visited)) {
      return false;
    }
  }
  return true;
}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117);
module.exports = __webpack_require__(121);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(118).enable();
  window.Promise = __webpack_require__(120);
}

// fetch() polyfill for making API calls.
__webpack_require__(62);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(36);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(61);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(61);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_App__ = __webpack_require__(135);




__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.hydrate(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_App__["a" /* default */], null), document.getElementById('root'));

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable */


// To add to window
if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__["a" /* default */];
}

if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    value: function value(searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);
      var len = o.length >>> 0;
      if (len === 0) {
        return false;
      }
      var n = fromIndex | 0;
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
      while (k < len) {
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }
      return false;
    }
  });
}
if (!String.prototype.includes) {
  Object.defineProperty(String.prototype, "includes", {
    value: function value(searchElement, fromIndex) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);
      var len = o.length >>> 0;
      if (len === 0) {
        return false;
      }
      var n = fromIndex | 0;
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
      while (k < len) {
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }
      return false;
    }
  });
}
if (!Object.keys) {
  Object.keys = function () {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !{
        toString: null
      }.propertyIsEnumerable('toString'),
      dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
      dontEnumsLength = dontEnums.length;
    return function (obj) {
      if (_typeof(obj) !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys chamado de non-object');
      }
      var result = [],
        prop,
        i;
      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }
      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }();
}
if (!Object.assign) {
  Object.defineProperty(Object, "assign", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function value(target) {
      "use strict";

      if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
      }
      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }
        nextSource = Object(nextSource);
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    }
  });
}
if ("document" in self) {
  // Full polyfill for browsers with no classList support
  // Including IE < Edge missing SVGElement.classList
  if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
    (function (view) {
      "use strict";

      if (!("Element" in view)) return;
      var classListProp = "classList",
        protoProp = "prototype",
        elemCtrProto = view.Element[protoProp],
        objCtr = Object,
        strTrim = String[protoProp].trim || function () {
          return this.replace(/^\s+|\s+$/g, "");
        },
        arrIndexOf = Array[protoProp].indexOf || function (item) {
          var i = 0,
            len = this.length;
          for (; i < len; i++) {
            if (i in this && this[i] === item) {
              return i;
            }
          }
          return -1;
        },
        // Vendors: please allow content code to instantiate DOMExceptions
        DOMEx = function DOMEx(type, message) {
          this.name = type;
          this.code = DOMException[type];
          this.message = message;
        },
        checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
          if (token === "") {
            throw new DOMEx("SYNTAX_ERR", "The token must not be empty.");
          }
          if (/\s/.test(token)) {
            throw new DOMEx("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
          }
          return arrIndexOf.call(classList, token);
        },
        ClassList = function ClassList(elem) {
          var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
            classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
            i = 0,
            len = classes.length;
          for (; i < len; i++) {
            this.push(classes[i]);
          }
          this._updateClassName = function () {
            elem.setAttribute("class", this.toString());
          };
        },
        classListProto = ClassList[protoProp] = [],
        classListGetter = function classListGetter() {
          return new ClassList(this);
        };
      // Most DOMException implementations don't allow calling DOMException's toString()
      // on non-DOMExceptions. Error's toString() is sufficient here.
      DOMEx[protoProp] = Error[protoProp];
      classListProto.item = function (i) {
        return this[i] || null;
      };
      classListProto.contains = function (token) {
        return ~checkTokenAndGetIndex(this, token + "");
      };
      classListProto.add = function () {
        var tokens = arguments,
          i = 0,
          l = tokens.length,
          token,
          updated = false;
        do {
          token = tokens[i] + "";
          if (!~checkTokenAndGetIndex(this, token)) {
            this.push(token);
            updated = true;
          }
        } while (++i < l);
        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.remove = function () {
        var tokens = arguments,
          i = 0,
          l = tokens.length,
          token,
          updated = false,
          index;
        do {
          token = tokens[i] + "";
          index = checkTokenAndGetIndex(this, token);
          while (~index) {
            this.splice(index, 1);
            updated = true;
            index = checkTokenAndGetIndex(this, token);
          }
        } while (++i < l);
        if (updated) {
          this._updateClassName();
        }
      };
      classListProto.toggle = function (token, force) {
        var result = this.contains(token),
          method = result ? force !== true && "remove" : force !== false && "add";
        if (method) {
          this[method](token);
        }
        if (force === true || force === false) {
          return force;
        } else {
          return !result;
        }
      };
      classListProto.replace = function (token, replacement_token) {
        var index = checkTokenAndGetIndex(token + "");
        if (~index) {
          this.splice(index, 1, replacement_token);
          this._updateClassName();
        }
      };
      classListProto.toString = function () {
        return this.join(" ");
      };
      if (objCtr.defineProperty) {
        var classListPropDesc = {
          get: classListGetter,
          enumerable: true,
          configurable: true
        };
        try {
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        } catch (ex) {
          // IE 8 doesn't support enumerable:true
          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
          if (ex.number === undefined || ex.number === -0x7ff5ec54) {
            classListPropDesc.enumerable = false;
            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
          }
        }
      } else if (objCtr[protoProp].__defineGetter__) {
        elemCtrProto.__defineGetter__(classListProp, classListGetter);
      }
    })(self);
  }

  // There is full or partial native classList support, so just check if we need
  // to normalize the add/remove and toggle APIs.

  (function () {
    "use strict";

    var testElement = document.createElement("_");
    testElement.classList.add("c1", "c2");

    // Polyfill for IE 10/11 and Firefox <26, where classList.add and
    // classList.remove exist but support only one argument at a time.
    if (!testElement.classList.contains("c2")) {
      var createMethod = function createMethod(method) {
        var original = DOMTokenList.prototype[method];
        DOMTokenList.prototype[method] = function (token) {
          var i,
            len = arguments.length;
          for (i = 0; i < len; i++) {
            token = arguments[i];
            original.call(this, token);
          }
        };
      };
      createMethod("add");
      createMethod("remove");
    }
    testElement.classList.toggle("c3", false);

    // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
    // support the second argument.
    if (testElement.classList.contains("c3")) {
      var _toggle = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (token, force) {
        if (1 in arguments && !this.contains(token) === !force) {
          return force;
        } else {
          return _toggle.call(this, token);
        }
      };
    }

    // replace() polyfill
    if (!("replace" in document.createElement("_").classList)) {
      DOMTokenList.prototype.replace = function (token, replacement_token) {
        var tokens = this.toString().split(" "),
          index = tokens.indexOf(token + "");
        if (~index) {
          tokens = tokens.slice(index);
          this.remove.apply(this, tokens);
          this.add(replacement_token);
          this.add.apply(this, tokens.slice(1));
        }
      };
    }
    testElement = null;
  })();
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__finally__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allSettled__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__any__ = __webpack_require__(129);




// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = __WEBPACK_IMPORTED_MODULE_0__finally__["a" /* default */];

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.any = __WEBPACK_IMPORTED_MODULE_2__any__["a" /* default */];

Promise.allSettled = __WEBPACK_IMPORTED_MODULE_1__allSettled__["a" /* default */];

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Promise);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(124).setImmediate))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(125);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(126)))

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

/* harmony default export */ __webpack_exports__["a"] = (finallyConstructor);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function allSettled(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(
        new TypeError(
          typeof arr +
            ' ' +
            arr +
            ' is not iterable(cannot read property Symbol(Symbol.iterator))'
        )
      );
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(
            val,
            function(val) {
              res(i, val);
            },
            function(e) {
              args[i] = { status: 'rejected', reason: e };
              if (--remaining === 0) {
                resolve(args);
              }
            }
          );
          return;
        }
      }
      args[i] = { status: 'fulfilled', value: val };
      if (--remaining === 0) {
        resolve(args);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (allSettled);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @constructor
 */
function AggregateError(errors, message) {
  (this.name = 'AggregateError'), (this.errors = errors);
  this.message = message || '';
}
AggregateError.prototype = Error.prototype;

function any(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError('Promise.any accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return reject();

    var rejectionReasons = [];
    for (var i = 0; i < args.length; i++) {
      try {
        P.resolve(args[i])
          .then(resolve)
          .catch(function(error) {
            rejectionReasons.push(error);
            if (rejectionReasons.length === args.length) {
              reject(
                new AggregateError(
                  rejectionReasons,
                  'All promises were rejected'
                )
              );
            }
          });
      } catch (ex) {
        reject(ex);
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (any);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=Symbol.for("react.element"),n=Symbol.for("react.portal"),p=Symbol.for("react.fragment"),q=Symbol.for("react.strict_mode"),r=Symbol.for("react.profiler"),t=Symbol.for("react.provider"),u=Symbol.for("react.context"),v=Symbol.for("react.forward_ref"),w=Symbol.for("react.suspense"),x=Symbol.for("react.memo"),y=Symbol.for("react.lazy"),z=Symbol.iterator;function A(a){if(null===a||"object"!==typeof a)return null;a=z&&a[z]||a["@@iterator"];return"function"===typeof a?a:null}
var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C=Object.assign,D={};function E(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}E.prototype.isReactComponent={};
E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}var H=G.prototype=new F;
H.constructor=G;C(H,E.prototype);H.isPureReactComponent=!0;var I=Array.isArray,J=Object.prototype.hasOwnProperty,K={current:null},L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return{$$typeof:l,type:a,key:k,ref:h,props:c,_owner:K.current}}
function N(a,b){return{$$typeof:l,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===l}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g;function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function R(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l:case n:h=!0}}if(h)return h=a,c=c(h),a=""===d?"."+Q(h,0):d,I(c)?(e="",null!=a&&(e=a.replace(P,"$&/")+"/"),R(c,b,e,"",function(a){return a})):null!=c&&(O(c)&&(c=N(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I(a))for(var g=0;g<a.length;g++){k=
a[g];var f=d+Q(k,g);h+=R(k,b,e,f,c)}else if(f=A(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q(k,g++),h+=R(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
function S(a,b,e){if(null==a)return a;var d=[],c=0;R(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b});-1===a._status&&(a._status=0,a._result=b)}if(1===a._status)return a._result.default;throw a._result;}
var U={current:null},V={transition:null},W={ReactCurrentDispatcher:U,ReactCurrentBatchConfig:V,ReactCurrentOwner:K};exports.Children={map:S,forEach:function(a,b,e){S(a,function(){b.apply(this,arguments)},e)},count:function(a){var b=0;S(a,function(){b++});return b},toArray:function(a){return S(a,function(a){return a})||[]},only:function(a){if(!O(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};exports.Component=E;exports.Fragment=p;
exports.Profiler=r;exports.PureComponent=G;exports.StrictMode=q;exports.Suspense=w;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=W;
exports.cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g}return{$$typeof:l,type:a.type,key:c,ref:k,props:d,_owner:h}};exports.createContext=function(a){a={$$typeof:u,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};
exports.forwardRef=function(a){return{$$typeof:v,render:a}};exports.isValidElement=O;exports.lazy=function(a){return{$$typeof:y,_payload:{_status:-1,_result:a},_init:T}};exports.memo=function(a,b){return{$$typeof:x,type:a,compare:void 0===b?null:b}};exports.startTransition=function(a){var b=V.transition;V.transition={};try{a()}finally{V.transition=b}};exports.unstable_act=function(){throw Error("act(...) is not supported in production builds of React.");};
exports.useCallback=function(a,b){return U.current.useCallback(a,b)};exports.useContext=function(a){return U.current.useContext(a)};exports.useDebugValue=function(){};exports.useDeferredValue=function(a){return U.current.useDeferredValue(a)};exports.useEffect=function(a,b){return U.current.useEffect(a,b)};exports.useId=function(){return U.current.useId()};exports.useImperativeHandle=function(a,b,e){return U.current.useImperativeHandle(a,b,e)};
exports.useInsertionEffect=function(a,b){return U.current.useInsertionEffect(a,b)};exports.useLayoutEffect=function(a,b){return U.current.useLayoutEffect(a,b)};exports.useMemo=function(a,b){return U.current.useMemo(a,b)};exports.useReducer=function(a,b,e){return U.current.useReducer(a,b,e)};exports.useRef=function(a){return U.current.useRef(a)};exports.useState=function(a){return U.current.useState(a)};exports.useSyncExternalStore=function(a,b,e){return U.current.useSyncExternalStore(a,b,e)};
exports.useTransition=function(){return U.current.useTransition()};exports.version="18.0.0-fc46dba67-20220329";


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(132);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(36),r=__webpack_require__(133);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(134);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataIsValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sp_frame_css__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sp_frame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sp_frame_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobile_frame_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mobile_frame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mobile_frame_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_css__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__home_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_Home__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__v2_search_index__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_Search__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__coverage_Coverage__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__purchase_Purchase__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__comparison_Comparison__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__purchase_status_PurchaseStatus__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_header_Header__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_globalActions__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__parameterManager__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__actions_mobileActions__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__error_pages_ErrorPages__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__growthbook_growthbook_react__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_matomo__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


























var applyCoupon = function applyCoupon(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      if (!window.location.pathname.includes('pedido')) Object(__WEBPACK_IMPORTED_MODULE_17__apiCalls__["getCouponData"])(Object(__WEBPACK_IMPORTED_MODULE_16__utils__["getUrlParams"])().cupom, '', _this.props.match.params.begin_date, _this.props.match.params.end_date);
      return _this;
    }
    _inherits(_class, _Component);
    return _createClass(_class, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props));
      }
    }]);
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};
var growthbook = new __WEBPACK_IMPORTED_MODULE_23__growthbook_growthbook_react__["a" /* GrowthBook */]({
  apiHost: "https://growthbook-br.amopromo.com/backend",
  clientKey: "sdk-bROoEbKNgPV1K0EG",
  enableDevMode: true,
  subscribeToChanges: true,
  trackingCallback: function trackingCallback(experiment, result) {
    var experimentId = experiment.key;
    var variationId = result.variationId;
    __WEBPACK_IMPORTED_MODULE_24__utils_matomo__["a" /* default */].trackEvent('Experiment', 'Viewed', experimentId, variationId);
    console.log("Experiment viewed:", {
      experiment: experiment,
      result: result
    });
  }
});
window._paq = window._paq || [];
window._paq.push([function () {
  try {
    __WEBPACK_IMPORTED_MODULE_24__utils_matomo__["a" /* default */].getMatomoVisitorId().then(function (matomoVisitorId) {
      growthbook.setAttributes({
        id: matomoVisitorId
      });
      growthbook.init({
        streaming: true
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_24__utils_matomo__["a" /* default */].setGrowthbookInstance(growthbook);
      });
    });
  } catch (e) {
    console.error("Erro ao definir o ID do visitante no GrowthBook:", e);
  }
}]);
var dataIsValid = function dataIsValid() {
  var url = new URL(window.location.href);
  var newParams = url.pathname.split('/').filter(function (t) {
    return t !== '';
  });
  var todayDate = new Date();
  todayDate = new Date("".concat(todayDate.getFullYear(), "-").concat(todayDate.getMonth() + 1, "-").concat(todayDate.getDate(), " 00:00"));
  var begin_date = new Date("".concat(newParams[newParams.length - 2], " 00:00:00"));
  var end_date = new Date("".concat(newParams[newParams.length - 1], " 00:00:00"));
  if (begin_date < todayDate || end_date < todayDate) {
    return false;
  }
  return true;
};
var Routes = /*#__PURE__*/function (_Component2) {
  function Routes() {
    _classCallCheck(this, Routes);
    return _callSuper(this, Routes, arguments);
  }
  _inherits(Routes, _Component2);
  return _createClass(Routes, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setPartner();
      Object(__WEBPACK_IMPORTED_MODULE_17__apiCalls__["fetchDestinationsService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_globalActions__["a" /* getDestinations */])(response.destinations));
      });
      Object(__WEBPACK_IMPORTED_MODULE_17__apiCalls__["fetchProvidersService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__actions_globalActions__["b" /* globalProviderSettings */])(response.providers));
      });
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__["O" /* fetchUserDetails */])());

      // runGoogleAnalytics();
      Object(__WEBPACK_IMPORTED_MODULE_19__parameterManager__["a" /* default */])();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location !== this.props.location) {
        window.scrollTo(0, 0);

        // runGoogleAnalytics();
        Object(__WEBPACK_IMPORTED_MODULE_19__parameterManager__["a" /* default */])();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__["T" /* getInfosProspect */])());
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__["R" /* getBenefits */])());
      Object(__WEBPACK_IMPORTED_MODULE_17__apiCalls__["fetchPaymentMethodsService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__["U" /* getPaymentMethodsAvaliable */])(response.payment_methods));
      });
    }
  }, {
    key: "setPartner",
    value: function setPartner() {
      if (this.props.match.params.partner) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__actions_purchaseActions__["_26" /* setPartner */])(this.props.match.params.partner));
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (dataIsValid()) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: this.props.match.path + "/pesquisa/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/",
          component: Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(applyCoupon(__WEBPACK_IMPORTED_MODULE_9__v2_search_index__["a" /* default */]))
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: this.props.match.path + "/seguro-viagem/comparacao/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/",
          component: Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(applyCoupon(__WEBPACK_IMPORTED_MODULE_13__comparison_Comparison__["a" /* default */]))
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: this.props.match.path + "/seguro-viagem/cobertura/:product_code/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/",
          component: Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(applyCoupon(__WEBPACK_IMPORTED_MODULE_11__coverage_Coverage__["a" /* default */]))
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: this.props.match.path + "/pedido/:product_code(\\d+)/:destination/:begin_date(\\d{4}-\\d{2}-\\d{2})/:end_date(\\d{4}-\\d{2}-\\d{2})/",
          component: Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(applyCoupon(__WEBPACK_IMPORTED_MODULE_12__purchase_Purchase__["a" /* default */]))
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: this.props.match.path + "/pedido-finalizado/:uuid/status",
          component: __WEBPACK_IMPORTED_MODULE_14__purchase_status_PurchaseStatus__["a" /* default */]
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          exact: true,
          path: this.props.match.path,
          component: __WEBPACK_IMPORTED_MODULE_8__home_Home__["a" /* default */]
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
          path: "/",
          component: __WEBPACK_IMPORTED_MODULE_22__error_pages_ErrorPages__["a" /* page404 */]
        })));
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */], {
        exact: true,
        to: this.props.match.path,
        component: __WEBPACK_IMPORTED_MODULE_8__home_Home__["a" /* default */]
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var App = /*#__PURE__*/function (_Component3) {
  function App() {
    var _this2;
    _classCallCheck(this, App);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, App, [].concat(args));
    _defineProperty(_this2, "handleResize", function () {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_mobileActions__["a" /* mobileActive */])());
    });
    return _this2;
  }
  _inherits(App, _Component3);
  return _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_24__utils_matomo__["a" /* default */].trackPageView(document.title);
      window.addEventListener('resize', function () {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_21__actions_mobileActions__["a" /* mobileActive */])());
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      window.scrollTo(0, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      growthbook.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__growthbook_growthbook_react__["b" /* GrowthBookProvider */], {
        growthbook: growthbook
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */], {
        key: 2,
        store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */]
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "App"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_header_Header__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        path: "/site",
        component: Routes
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        path: "/p/:partner",
        component: Routes
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        exact: true,
        path: "/",
        component: __WEBPACK_IMPORTED_MODULE_8__home_Home__["a" /* default */]
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        path: "/",
        component: __WEBPACK_IMPORTED_MODULE_22__error_pages_ErrorPages__["a" /* page404 */]
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */], {
        path: "/500/",
        component: __WEBPACK_IMPORTED_MODULE_22__error_pages_ErrorPages__["b" /* page500 */]
      })))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(37);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(139);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(66);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(163);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(73);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(151);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(149);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(69);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(153);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(156);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18), __webpack_require__(70)(module)))

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(71);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(73);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(74);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(164);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(37);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(172);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(41);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(75);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(176);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(180);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(41);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(182);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(42);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(79);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(42);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(186);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchReducer__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coverageReducer__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__purchaseReducer__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comparisonReducer__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__purchaseStatusReducer__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mobileReducer__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globalReducer__ = __webpack_require__(203);








/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({
  search: __WEBPACK_IMPORTED_MODULE_1__searchReducer__["a" /* default */],
  comparison: __WEBPACK_IMPORTED_MODULE_4__comparisonReducer__["a" /* default */],
  coverage: __WEBPACK_IMPORTED_MODULE_2__coverageReducer__["a" /* default */],
  purchase: __WEBPACK_IMPORTED_MODULE_3__purchaseReducer__["a" /* default */],
  purchaseStatus: __WEBPACK_IMPORTED_MODULE_5__purchaseStatusReducer__["a" /* default */],
  mobile: __WEBPACK_IMPORTED_MODULE_6__mobileReducer__["a" /* default */],
  global: __WEBPACK_IMPORTED_MODULE_7__globalReducer__["a" /* default */]
}));

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_preventScroll__ = __webpack_require__(80);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }




var newState = {};
var orderPlansCategory = function orderPlansCategory(items) {
  var renewalFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var covidCoverage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var specialistSuggestionsActive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var promotionalDestination = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var specialistSuggestions = [];
  var covid = [];
  var special = [];
  var renewal = [];
  var common = [];
  var promotional = [];
  var itemCheck = items[0] !== undefined && JSON.stringify(items[0]) !== JSON.stringify({});
  var orderingByPrice = function orderingByPrice(a, b) {
    return (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price);
  };
  if (items.length >= 1 && itemCheck) {
    for (var i = 0; i < items.length; i++) {
      if (promotionalDestination && items[i].extra.promotional_destination_product) {
        promotional.push(items[i]);
        continue;
      }
      if (items[i].extra.covid_coverage && items[i].extra.special !== true) {
        covid.push(items[i]);
        continue;
      }
      if (items[i].extra.travel_renewal !== 'no') {
        renewal.push(items[i]);
        continue;
      }
      if (specialistSuggestionsActive) {
        if (items[i].extra.special && items[i].extra.specialist_indicator !== true) {
          special.push(items[i]);
          continue;
        }
        if (items[i].extra.specialist_indicator) {
          specialistSuggestions.push(items[i]);
          continue;
        }
      } else {
        if (items[i].extra.special) {
          special.push(items[i]);
          continue;
        }
      }
      common.push(items[i]);
    }
  }
  promotional.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  specialistSuggestions.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  covid.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  special.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  renewal.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  common.sort(function (a, b) {
    return orderingByPrice(a, b);
  });
  if (renewalFirst) return [].concat(promotional, renewal, special, specialistSuggestions, covid, common);else if (covidCoverage) return [].concat(promotional, covid, special, specialistSuggestions, renewal, common);else if (specialistSuggestionsActive) return [].concat(promotional, specialistSuggestions, special, renewal, covid, common);
  return [].concat(promotional, special, specialistSuggestions, renewal, covid, common);
};
var orderPlansByFilter = function orderPlansByFilter(state) {
  var optionSelected = null;
  var filteredPlans = [];
  var categorySelected = [];
  var providerSelected = [];
  var plansFiltered = [];
  var plans = [];

  // Verificando quais categorias estão selecionadas, e separando por tipo de categoria
  state.filterCategory.map(function (category) {
    optionSelected = category.Categories.filter(function (option) {
      return option.selected === true;
    });
    if (optionSelected.length > 0) categorySelected = [].concat(_toConsumableArray(categorySelected), [_objectSpread(_objectSpread({}, category), {}, {
      plans: [],
      Categories: optionSelected
    })]);
    return true;
  });

  // Inserindo planos pertecentes a cada categoria
  categorySelected.map(function (category, i) {
    category.Categories.map(function (categorie) {
      state.plans.map(function (plan) {
        if (plan.categories) {
          var categoryPlanFiltered = plan.categories.filter(function (opt) {
            return opt.ID === categorie.ID;
          });
          if (categoryPlanFiltered.length > 0) {
            categorySelected[i].plans.push(plan);
          }
        }
      });
    });
  });

  // Verificando de o plano está em todos tipos de categoria que foram selecionados
  categorySelected.map(function (category, i) {
    category.plans.map(function (plan) {
      var validationCategories = [];
      for (var x = 0; x < categorySelected.length; x++) {
        if (x !== i) {
          if (categorySelected[x].plans.some(function (opt) {
            return opt.code === plan.code;
          })) {
            validationCategories.push(plan);
          }
        }
      }
      if (validationCategories.length === categorySelected.length - 1 && !plans.some(function (opt1) {
        return opt1.code === plan.code;
      })) {
        plans.push(plan);
      }
    });
  });
  optionSelected = state.filterProvider.filter(function (provider) {
    return provider.selected === true;
  });
  if (optionSelected.length > 0) providerSelected.push.apply(providerSelected, _toConsumableArray(optionSelected));
  var plansList = plans.length > 0 ? plans : state.plans;
  var disabledProviders = state.ecommerce_settings.disabled_providers;

  // FILTRA O PLANOS POR SEGURADORA
  providerSelected.map(function (provider) {
    filteredPlans = plansList.filter(function (p) {
      return p.provider_code === provider.code;
    });
    plansFiltered.push.apply(plansFiltered, _toConsumableArray(filteredPlans));
    return true;
  });
  if (categorySelected.length === 0 && providerSelected.length === 0) {
    var _plans;
    var removeDisabledProviders = plansList.filter(function (p) {
      return !disabledProviders.includes(p.provider_code);
    }); // Remove os provedores desabilitados
    (_plans = plans).push.apply(_plans, _toConsumableArray(removeDisabledProviders));
    // VERIFICA SE NAO HÁ CATEGORIA E SEGURADORA SELECIONADA NO FILTRO, DEVOLVENDO O DEFAULT DOS PLANOS NA PESQUISA
  } else if (providerSelected.length !== 0) {
    plans = plansFiltered;
  }

  // REFAZ O STATE PARA DEVOLVER SUGESTAO CASO NAO ENCONTRE PLANOS DEPOIS SELECIONAR OS FILTROS
  var oldState = sortPlansByOrder(calcCouponDiscount(_objectSpread(_objectSpread({}, state), {}, {
    filtered_plans: state.plans
  })));
  return _objectSpread(_objectSpread({}, state), {}, {
    filtered_plans: plans,
    suggestions_plans: oldState.filtered_plans
  });
};
var calcCouponDiscount = function calcCouponDiscount(state) {
  var rootState = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState();
  var pixDiscountPercentage = 5;
  if (rootState.purchase && rootState.purchase.paymentMethods) {
    var pixPayment = rootState.purchase.paymentMethods.find(function (method) {
      return method.slug === 'pix';
    });
    if (pixPayment && pixPayment.discount) {
      pixDiscountPercentage = pixPayment.discount;
    }
  }
  var filteredPlans = state.filtered_plans.map(function (plan) {
    if (plan) {
      var priceWithPixDiscount = plan.adult.price - plan.adult.price / 100 * pixDiscountPercentage;
      var priceWithCouponDiscount = plan ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getProductDiscount"])(plan.adult.price, plan.code, state.coupon) : 0;
      return _objectSpread(_objectSpread({}, plan), {}, {
        price_with_coupon_discount: priceWithCouponDiscount,
        price_with_discount: priceWithCouponDiscount ? plan ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getProductDiscount"])(priceWithPixDiscount, plan.code, state.coupon) : 0 : priceWithPixDiscount
      });
    }
    return {};
  });
  var plans = state.plans.map(function (plan) {
    if (plan) {
      var priceWithPixDiscount = plan.adult.price - plan.adult.price / 100 * pixDiscountPercentage;
      var priceWithCouponDiscount = plan ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getProductDiscount"])(plan.adult.price, plan.code, state.coupon) : 0;
      return _objectSpread(_objectSpread({}, plan), {}, {
        price_with_coupon_discount: priceWithCouponDiscount,
        price_with_discount: priceWithCouponDiscount ? plan ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getProductDiscount"])(priceWithPixDiscount, plan.code, state.coupon) : 0 : priceWithPixDiscount
      });
    }
    return {};
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    plans: plans,
    filtered_plans: filteredPlans
  });
};
var sortPlansByOrder = function sortPlansByOrder(state) {
  var rootState = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getState();
  var globalState = rootState.global;
  var LOWER_PRICE = state.sortOptions[0].name;
  var SPECIAL_PRICE = state.sortOptions[1].name;
  var HIGH_PRICE = state.sortOptions[2].name;
  var COVID_COVERAGE = state.sortOptions[3].name;
  var destinations = globalState.destinations || [];
  var PROMOTIONAL_DESTINATION = (destinations.filter(function (item) {
    return item.slug === state.destination;
  })[0] || {}).promotional;
  if (state.showSpecialistSuggestions) {
    var specialistSuggestions = state.filtered_plans.filter(function (plan) {
      return plan.extra.specialist_indicator;
    });
    var others = state.filtered_plans.filter(function (plan) {
      return !plan.extra.specialist_indicator;
    });
    if (state.sort_option === LOWER_PRICE) {
      return _objectSpread(_objectSpread({}, state), {}, {
        filtered_plans: [specialistSuggestions.sort(function (a, b) {
          return (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price);
        }), others.sort(function (a, b) {
          return (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price);
        })].flat()
      });
    }
    if (state.sort_option === HIGH_PRICE) {
      return _objectSpread(_objectSpread({}, state), {}, {
        filtered_plans: [specialistSuggestions.sort(function (a, b) {
          return (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price);
        }), others.sort(function (a, b) {
          return (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price);
        })].flat()
      });
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      filtered_plans: orderPlansCategory(_toConsumableArray(state.filtered_plans), false, false, true, PROMOTIONAL_DESTINATION)
    });
  }
  if (state.sort_option === LOWER_PRICE) return _objectSpread(_objectSpread({}, state), {}, {
    filtered_plans: _toConsumableArray(state.filtered_plans).sort(function (a, b) {
      return (a.price_with_coupon_discount || a.adult.price) - (b.price_with_coupon_discount || b.adult.price);
    })
  });else if (state.sort_option === SPECIAL_PRICE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      filtered_plans: orderPlansCategory(_toConsumableArray(state.filtered_plans), false, false, false, PROMOTIONAL_DESTINATION)
    });
  } else if (state.sort_option === HIGH_PRICE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      filtered_plans: _toConsumableArray(state.filtered_plans).sort(function (a, b) {
        return (b.price_with_coupon_discount || b.adult.price) - (a.price_with_coupon_discount || a.adult.price);
      })
    });
  } else if (state.sort_option === COVID_COVERAGE) {
    return _objectSpread(_objectSpread({}, state), {}, {
      filtered_plans: orderPlansCategory(_toConsumableArray(state.filtered_plans), false, true, false, PROMOTIONAL_DESTINATION)
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    filtered_plans: state.plans
  });
};
var search = function search() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_49" /* SEARCH_ECOMMERCE_SETTINGS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        ecommerce_settings: action.settings
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_50" /* SEARCH_PROVIDER_SETTINGS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        providers: action.settings,
        filterProvider: _toConsumableArray(action.settings.map(function (provider) {
          return _objectSpread(_objectSpread({}, provider), {}, {
            selected: false
          });
        }))
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_1" /* FETCH_DISCOUNT_COUPON */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        coupon: action.coupon
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["b" /* ADD_COMPARISON_PLAN */]:
      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isMobile"])() && state.comparisonPlans.length >= 2) return _objectSpread({}, state);
      if (state.comparisonPlans.length >= 4) return _objectSpread({}, state);
      return _objectSpread(_objectSpread({}, state), {}, {
        comparisonPlans: state.comparisonPlans.concat(action.plan)
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_47" /* REMOVE_COMPARISON_PLAN */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        comparisonPlans: state.comparisonPlans.filter(function (item) {
          return item.code !== action.planCode;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["s" /* CLEAN_COMPARISON_PLANS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        comparisonPlans: []
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["Z" /* FETCH_CATEGORIES */]:
      var _action$params = action.params,
        categoryUrl = _action$params.categoryUrl,
        providerUrl = _action$params.providerUrl;
      newState = _objectSpread(_objectSpread({}, state), {}, {
        filterProvider: _toConsumableArray(state.providers.map(function (provider) {
          return _objectSpread(_objectSpread({}, provider), {}, {
            selected: providerUrl.some(function (providerOption) {
              return providerOption === provider.slug;
            })
          });
        })),
        filterCategory: _toConsumableArray(action.category.map(function (category) {
          return _objectSpread(_objectSpread({}, category), {}, {
            Categories: category.Categories ? category.Categories.map(function (subCategory) {
              return _objectSpread(_objectSpread({}, subCategory), {}, {
                selected: categoryUrl.some(function (categoryOption) {
                  return Number(categoryOption) === subCategory.ID;
                })
              });
            }) : []
          });
        }))
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_6" /* FETCH_PLANS */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        plans: action.plans,
        filtered_plans: action.plans
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_11" /* FILTER_PLANS */]:
      return sortPlansByOrder(calcCouponDiscount(state));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_65" /* SET_PROVIDER_OPTION */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        provider_option: action.provider_option
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_69" /* SET_SORT_OPTIONS */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        sortOptions: action.sortOptions
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_68" /* SET_SORT_OPTION */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        sort_option: action.sort_option,
        showSpecialistSuggestions: false
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_67" /* SET_QUOTATION_PARAMS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        begin_date: action.begin_date,
        end_date: action.end_date,
        destination: action.destination,
        queryParams: action.queryParams
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_74" /* SET_USER_DETAILS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        userDetails: action.userDetails
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_12" /* FILTER_PLANS_MOBILE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchState: !state.searchState
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_27" /* OPEN_MODAL_FILTER_CATEGORY */]:
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_preventScroll__["a" /* addPreventScrollStyle */])();
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFilterCategoryActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["D" /* CLOSE_MODAL_FILTER_CATEGORY */]:
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_preventScroll__["b" /* removePreventScrollStyle */])();
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFilterCategoryActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_15" /* GET_INFOS_PROSPECT */]:
      if (action.infos) {
        return _objectSpread(_objectSpread({}, state), {}, {
          prospect: action.infos
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_44" /* OPEN_MODAL_WITHOUT_TRACKER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalWithoutTrackerActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["U" /* CLOSE_MODAL_WITHOUT_TRACKER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalWithoutTrackerActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_70" /* SET_TRACKER_INFOS_PROSPECT */]:
      var checkModalFill = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["validateTrackerModal"])(action.prospect);
      return _objectSpread(_objectSpread({}, state), {}, {
        modalProspect: action.prospect,
        modalProspectAvaliable: checkModalFill.isValid
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_81" /* TRACKER_MODAL_VALIDATOR_HANDLER_BLUR */]:
      var error = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["validateTrackerModalOnBlur"])(state.modalProspect, action.key);
      return _objectSpread(_objectSpread({}, state), {}, {
        modalProspect: _objectSpread(_objectSpread({}, state.modalProspect), {}, {
          errors: _objectSpread(_objectSpread({}, state.modalProspect.errors), {}, _defineProperty({}, action.key, error))
        })
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_85" /* VALIDATE_TRACKER_MODAL_REDIRECT */]:
      var errors = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["validateTrackerModal"])(state.modalProspect);
      if (errors.isValid) Object(__WEBPACK_IMPORTED_MODULE_0__utils__["redirectToTracker"])(action.destination, action.begin_date, action.end_date, state.modalProspect, action.couponModal);
      return _objectSpread(_objectSpread({}, state), {}, {
        modalProspect: _objectSpread(_objectSpread({}, state.modalProspect), {}, {
          errors: errors
        })
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["f" /* APPLY_FILTER_CATEGORIES */]:
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_preventScroll__["b" /* removePreventScrollStyle */])();
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(_objectSpread(_objectSpread({}, state), {}, {
        isModalFilterCategoryActive: false
      }))));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["x" /* CLEAR_FILTER_CATEGORIES */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        filterProvider: _toConsumableArray(state.providers.map(function (provider) {
          return _objectSpread(_objectSpread({}, provider), {}, {
            selected: false
          });
        })),
        filterCategory: _toConsumableArray(state.filterCategory.map(function (category) {
          return _objectSpread(_objectSpread({}, category), {}, {
            Categories: category.Categories.map(function (subCategory) {
              return _objectSpread(_objectSpread({}, subCategory), {}, {
                selected: false
              });
            })
          });
        }))
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_82" /* UNSELECT_FILTER_CATEGORY_OPTIONS */]:
      var type_category = action.type_category,
        category_index = action.category_index,
        option_index = action.option_index;
      var filterCategory = state.filterCategory,
        filterProvider = state.filterProvider;
      if (type_category === 'provider') {
        filterProvider[category_index].selected = !filterProvider[category_index].selected;
        return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(_objectSpread(_objectSpread({}, state), {}, {
          filterProvider: _toConsumableArray(filterProvider)
        }))));
      } else if (type_category === 'category') {
        filterCategory[category_index].Categories[option_index].selected = !filterCategory[category_index].Categories[option_index].selected;
        return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(_objectSpread(_objectSpread({}, state), {}, {
          filterCategory: _toConsumableArray(filterCategory)
        }))));
      }
      return {};
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_79" /* STORE_HIGHLIGTH_PLANS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        highlightPlans: action.plans
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_80" /* TOGGLE_SPECIALIST_SUGGESTION */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        showSpecialistSuggestions: !state.showSpecialistSuggestions
      });
      return sortPlansByOrder(calcCouponDiscount(orderPlansByFilter(newState)));
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_43" /* OPEN_MODAL_UPSELL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalUpsellActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["T" /* CLOSE_MODAL_UPSELL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalUpsellActive: false,
        upsellSourceTags: []
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_71" /* SET_UPSELL_PLANS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        upsellPlans: action.plans
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_actionTypes__["_73" /* SET_UPSELL_SOURCE_TAGS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        upsellSourceTags: action.tags
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (search);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HOME_PAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_PAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPARISON_PAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DETAIL_PAGE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PURCHASE_PAGE_TITLE; });
var HOME_PAGE_TITLE = 'Seguro Viagem - O Maior Comparador de Seguro Viagem do Brasil';
var SEARCH_PAGE_TITLE = 'Seguro Viagem - Resultado de pesquisa';
var COMPARISON_PAGE_TITLE = 'Seguro Viagem - Comparador';
var DETAIL_PAGE_TITLE = 'Seguro Viagem - Detalhes do Plano';
var PURCHASE_PAGE_TITLE = 'Seguro Viagem - Pagamento';

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var coverage = function coverage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_16" /* GET_PRODUCT_INFO */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        productInfo: action.productInfo
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_8" /* FETCH_PRODUCT_COVERAGE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        productCoverage: _objectSpread(_objectSpread({}, action.productCoverage), {}, {
          benefits: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["groupByCategory"])(action.productCoverage.benefits)
        }),
        rawProductCoverage: action.productCoverage.benefits
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_22" /* OPEN_COVERAGE_ACCORDION */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        productCoverage: _objectSpread(_objectSpread({}, state.productCoverage), {}, {
          benefits: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["toggleAccordion"])(state.productCoverage.benefits, action.code)
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* SET_USER_DETAILS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        userDetails: action.userDetails
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_15" /* GET_INFOS_PROSPECT */]:
      if (action.infos) {
        return _objectSpread(_objectSpread({}, state), {}, {
          prospect: action.infos
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: false
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (coverage);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }





var newState = {};
var calcCreditCard = function calcCreditCard(state) {
  if (!state.purchaseSummary || !state.creditCard.baseBrands) return _objectSpread({}, state);
  var brands = _toConsumableArray(state.creditCard.brands);
  if (!brands.length) brands = state.creditCard.baseBrands;
  var parcels = [],
    selectedParcelIndex = -1;
  var paymentMethods = _toConsumableArray(state.paymentMethods);
  var selectedBrand = brands.filter(function (brand) {
    return brand.selected;
  })[0];
  if (selectedBrand) state.creditCard.parcels.forEach(function (parcel, i) {
    if (parcel.selected) selectedParcelIndex = i + 1;
  });
  if (selectedBrand) {
    // cálculo das parcelas com base no valor mínimo
    // e quantidade máxima de parcelas
    for (var i = 1; i <= selectedBrand.max_parcels; i += 1) {
      var parcelPrice = state.purchaseSummary.total / i;
      if (parcelPrice >= selectedBrand.min_parcel_value) parcels = parcels.concat({
        times: i,
        price: parcelPrice.toFixed(2),
        selected: i === selectedParcelIndex
      });
    }
    if (parcels.length === 0 && state.purchaseSummary.total) {
      parcels = [{
        times: 1,
        price: parseFloat(state.purchaseSummary.total).toFixed(2),
        selected: true
      }];
    }
  }
  var newBrands = brands.map(function (brand) {
    var maxParcels = Math.floor(state.purchaseSummary.total / brand.min_parcel_value);
    if (state.purchaseSummary.total / brand.min_parcel_value >= brand.max_parcels) maxParcels = brand.max_parcels;else if (parseFloat(state.purchaseSummary.total) <= brand.min_parcel_value) maxParcels = 1;
    return _objectSpread(_objectSpread({}, brand), {}, {
      parcels: maxParcels
    });
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, {
      brands: newBrands,
      parcels: parcels
    }),
    paymentMethods: paymentMethods
  });
};
var setNotAvailableAlert = function setNotAvailableAlert(state, paymentMethod) {
  var validDate = new Date().addDays(2) >= Date.parse(state.quotationParams.departure_date);
  var availabilityValidations = !paymentMethod.available && paymentMethod.selected;
  var paymentMethodValidations = paymentMethod.slug === 'boleto' || paymentMethod.slug === 'safetypay';
  if (validDate && availabilityValidations && paymentMethodValidations) {
    return _objectSpread(_objectSpread({}, state), {}, {
      alert: paymentMethod.slug
    });
  }
  return _objectSpread({}, state);
};
var purchase = function purchase() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_45" /* PURCHASE_GET_PAYMENT_METHODS */]:
      var defaultMethod = state.paymentMethods.find(function (method) {
        return method.selected;
      });
      if (defaultMethod) {
        return _objectSpread(_objectSpread({}, state), {}, {
          paymentMethods: state.paymentMethods
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        payments: action.data,
        paymentMethods: state.paymentMethods.map(function (paymentMethod) {
          var payment = action.data.find(function (p) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["normalizePaymentMethodsName"])(p.slug) === paymentMethod.slug;
          });
          if (payment) {
            return _objectSpread(_objectSpread({}, paymentMethod), {}, {
              deadline: payment.deadline,
              active: payment.active,
              displayOrder: payment.display_order,
              selected: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["isSelected"])(payment),
              discount: payment.discount
            });
          }
          return paymentMethod;
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_4" /* FETCH_PAYMENT_INFO */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        paymentInfo: action.paymentInfo
      });

    // #region Coupon
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_60" /* SET_COUPON_TEXT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        coupon: {
          text: action.value
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_1" /* FETCH_DISCOUNT_COUPON */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        coupon: _objectSpread(_objectSpread({}, state.coupon), action.coupon)
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["w" /* CLEAR_COUPON */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        coupon: {
          text: state.coupon.text
        }
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    // #endregion

    // Credit Coupon
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_3" /* FETCH_FIRST_ACTIVE_CREDIT_COUPON_SUCCESS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: _objectSpread(_objectSpread({}, state.creditCoupon), {}, {
          code: action.payload.code,
          creditAmount: action.payload.credit_amount
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_2" /* FETCH_FIRST_ACTIVE_CREDIT_COUPON_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: _objectSpread(_objectSpread({}, state.creditCoupon), {}, {
          error: action.payload.msg
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["e" /* APPLY_CREDIT_COUPON_SUCCESS */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: _objectSpread(_objectSpread({}, state.creditCoupon), {}, {
          code: action.payload.code,
          creditAmount: action.payload.credit_amount,
          applied: true
        })
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["d" /* APPLY_CREDIT_COUPON_ERROR */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: _objectSpread(_objectSpread({}, state.creditCoupon), {}, {
          applied: false,
          error: action.payload.msg
        })
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_61" /* SET_CREDIT_COUPON_CODE_TEXT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: {
          code: action.value,
          creditAmount: 0.0,
          applied: false,
          error: null
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_46" /* REMOVE_APPLIED_CREDIT_COUPON */]:
      newState = _objectSpread(_objectSpread({}, state), {}, {
        creditCoupon: _objectSpread(_objectSpread({}, state.creditCoupon), {}, {
          applied: false
        })
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));

    // #region Insured
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["c" /* ADD_INSURED_FORM */]:
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread(_objectSpread({}, state), {}, {
        insuredForms: [].concat(_toConsumableArray(state.insuredForms), [action.form]),
        errors: _objectSpread(_objectSpread({}, state.errors), {}, {
          insuredForms: [].concat(_toConsumableArray(state.errors.insuredForms), [{
            cpf: false,
            rg: false,
            name: false,
            birth_date: false,
            incoming: false
          }])
        }),
        isInsuredFormDeletable: true
      })));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_48" /* REMOVE_INSURED_FORM */]:
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread(_objectSpread({}, state), {}, {
        insuredForms: state.insuredForms.length > 1 ? state.insuredForms.filter(function (_, i) {
          return i !== action.formIndex;
        }) : state.insuredForms,
        isInsuredFormDeletable: state.insuredForms.length > 2
      })));

    // TODO: Verificar Idade
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["p" /* CHANGE_INSURED_FORM_ATTR */]:
      var insuredForms = state.insuredForms.map(function (form, i) {
        return i === action.formIndex ? _objectSpread(_objectSpread({}, form), {}, _defineProperty({}, action.field, action.value)) : form;
      });
      newState = _objectSpread(_objectSpread({}, state), {}, {
        insuredForms: insuredForms
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    // #endregion

    // #region PaymentMethods
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_5" /* FETCH_PAYMENT_METHODS */]:
      action.paymentMethods.creditcard.brands[0].selected = true;
      if (action.extra.cookies && state.userDetails.authenticated) Object.keys(action.extra.cookies).forEach(function (cookie) {
        if (!cookie.startsWith('pcrid')) Object(__WEBPACK_IMPORTED_MODULE_1__utils__["removeCookie"])(cookie);
      });
      var payments = [];
      for (var i = 0; i < state.paymentMethods.length; i++) {
        if (state.paymentMethods[i].active) {
          if (state.paymentMethods[i].slug === 'credit-card') {
            payments.push(_objectSpread({}, state.paymentMethods[i]));
            continue;
          } else if (state.paymentMethods[i].slug === 'boleto') {
            payments.push(_objectSpread(_objectSpread({}, state.paymentMethods[i]), {}, {
              available: action.paymentMethods.boleto.available
            }));
          } else if (state.paymentMethods[i].slug === 'safetypay') {
            payments.push(_objectSpread(_objectSpread({}, state.paymentMethods[i]), {}, {
              available: action.paymentMethods.safetypay.available
            }));
          } else if (state.paymentMethods[i].slug === 'cash') {
            payments.push(_objectSpread(_objectSpread({}, state.paymentMethods[i]), {}, {
              available: true
            }));
            continue;
          } else if (state.paymentMethods[i].slug === 'pix') {
            payments.push(_objectSpread(_objectSpread({}, state.paymentMethods[i]), {}, {
              available: true
            }));
            continue;
          }
          state = setNotAvailableAlert(state, state.paymentMethods[i]);
        }
      }
      var data = _objectSpread(_objectSpread({}, state), {}, {
        boleto: _objectSpread(_objectSpread({}, state.boleto), {}, {
          available: action.paymentMethods.boleto.available,
          min_value: action.paymentMethods.boleto.min_value
        }),
        safetypay: _objectSpread(_objectSpread({}, state.safetypay), {}, {
          banks: action.paymentMethods.safetypay.banks,
          available: action.paymentMethods.safetypay.available,
          min_value: action.paymentMethods.safetypay.min_value
        }),
        creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, {
          available: action.paymentMethods.creditcard.available,
          baseBrands: action.paymentMethods.creditcard.brands
        })
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(data));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_55" /* SELECT_PAYMENT_METHOD */]:
      //Datalayer
      var paymentMethod = "";
      switch (action.methodIndex) {
        case 0:
          paymentMethod = "pix";
          break;
        case 1:
          paymentMethod = "boleto";
          break;
        case 2:
          paymentMethod = "cartao_de_credito";
          break;
        case 3:
          paymentMethod = "tranferencia";
          break;
      }
      __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__["a" /* default */].raw({
        event: 'selecao_meio_pagamento',
        meio_pagamento: paymentMethod
      });

      // Matomo tracking
      __WEBPACK_IMPORTED_MODULE_3__utils_matomo__["a" /* default */].trackEvent('Checkout', 'ChangePayment', paymentMethod);
      var fetchState = _objectSpread(_objectSpread({}, state), {}, {
        stepDisplayMethodPayment: action.stepDisplayMethodPayment,
        paymentMethods: state.paymentMethods.map(function (method, index) {
          return _objectSpread(_objectSpread({}, method), {}, {
            selected: index === action.methodIndex
          });
        }),
        alert: ''
      });
      var NewState = calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(fetchState));
      if (!NewState.paymentMethods[action.methodIndex].available) return _objectSpread(_objectSpread({}, state), {}, {
        paymentMethods: state.paymentMethods.map(function (method, index) {
          return _objectSpread(_objectSpread({}, method), {}, {
            selected: index === action.methodIndex
          });
        }),
        alert: state.paymentMethods[action.methodIndex].slug
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(NewState));

    // #endregion

    // #region CreditCard
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_52" /* SELECT_CREDITCARD_BRAND */]:
      var brands = state.creditCard.brands.map(function (brand, i) {
        return _objectSpread(_objectSpread({}, brand), {}, {
          selected: action.brand_index === i
        });
      });
      var regexEmpty = new RegExp(' ', 'g');
      var brandSelected = brands.filter(function (brand) {
        return brand.selected;
      })[0];
      var creditCardNumber = state.creditCard.number.replace(regexEmpty, '');
      if (brandSelected.brand_name === 'amex' && creditCardNumber.length > 15) creditCardNumber = state.creditCard.number.slice(0, 15 - creditCardNumber.length);else if (brandSelected.brand_name === 'diners' && creditCardNumber.length > 14) creditCardNumber = state.creditCard.number.slice(0, 14 - creditCardNumber.length);else creditCardNumber = state.creditCard.number;
      return calcCreditCard(_objectSpread(_objectSpread({}, state), {}, {
        creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, {
          number: creditCardNumber,
          brands: brands
        })
      }));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_53" /* SELECT_CREDITCARD_PARCEL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, {
          parcels: state.creditCard.parcels.map(function (parcel, i) {
            return _objectSpread(_objectSpread({}, parcel), {}, {
              selected: parseInt(action.parcel_index, 10) === i
            });
          })
        }),
        errors: _objectSpread(_objectSpread({}, state.errors), {}, {
          creditCard: _objectSpread(_objectSpread({}, state.errors.creditCard), {}, {
            parcels: false
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["m" /* CHANGE_CREDITCARD_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    // #region Boleto
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["i" /* CHANGE_BOLETO_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        boleto: _objectSpread(_objectSpread({}, state.boleto), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    // #region safetypay
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_51" /* SELECT_BANK */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        safetypay: _objectSpread(_objectSpread({}, state.safetypay), {}, {
          banks: state.safetypay.banks.map(function (bank, index) {
            return _objectSpread(_objectSpread({}, bank), {}, {
              selected: index === action.bankIndex
            });
          })
        }),
        errors: _objectSpread(_objectSpread({}, state.errors), {}, {
          safetypay: _objectSpread(_objectSpread({}, state.errors.safetypay), {}, {
            banks: false
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["r" /* CHANGE_SAFETYPAY_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        safetypay: _objectSpread(_objectSpread({}, state.safetypay), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    // #region Cash
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["j" /* CHANGE_CASH_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        cash: _objectSpread(_objectSpread({}, state.cash), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    // #region Cash
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["q" /* CHANGE_PIX_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        pix: _objectSpread(_objectSpread({}, state.pix), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    // #region Contact
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["l" /* CHANGE_CONTACT_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        contact: _objectSpread(_objectSpread({}, state.contact), {}, _defineProperty({}, action.field, action.value))
      });
    // #endregion

    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Y" /* FETCH_BENEFITS_METHODS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        benefits_list: action.benefits
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_6" /* FETCH_PLANS */]:
      if (action.context !== 'purchase') return _objectSpread({}, state);
      newState = _objectSpread(_objectSpread({}, state), {}, {
        plans: action.plans,
        filtered_plans: action.plans
      });
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread({}, newState)));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_7" /* FETCH_PLANS_PURCHASE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        plans: action.plans,
        filtered_plans: action.plans
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_13" /* FINISH_PURCHASE */]:
      newState = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["validatePurchase"])(state);
      if (newState.purchase_is_valid) {
        Object(__WEBPACK_IMPORTED_MODULE_2__apiCalls__["checkoutPurchase"])(newState);
      } else newState.loading = false;
      return newState;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_67" /* SET_QUOTATION_PARAMS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        quotationParams: {
          departure_date: action.departure_date,
          return_date: action.return_date,
          destination: action.destination,
          product_code: action.product_code,
          queryParams: action.queryParams
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_64" /* SET_PARTNER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        partner: action.partner
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_66" /* SET_PURCHASE_UUID */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        uuid: action.uuid
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_84" /* VALIDATE_PURCHASE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        purchaseIsValid: action.purchaseIsValid,
        status: action.status
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["X" /* FETCH_ADDRESS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        contact: _objectSpread(_objectSpread({}, state.contact), {}, {
          state: action.state,
          city: action.city,
          district: action.district,
          address: action.address
        }),
        errors: _objectSpread(_objectSpread({}, state.errors), {}, {
          contact: _objectSpread(_objectSpread({}, state.errors.contact), {}, {
            state: false,
            city: false,
            district: false,
            address: false
          })
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["v" /* CLEAR_ALERTS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        alert: ''
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_78" /* START_PURCHASE_LOADING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["W" /* END_PURCHASE_LOADING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_23" /* OPEN_DETAIL_MODAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalDetailActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["z" /* CLOSE_DETAIL_MODAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalDetailActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_34" /* OPEN_MODAL_PURCHASE_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPurchaseErrorActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["K" /* CLOSE_MODAL_PURCHASE_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPurchaseErrorActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_24" /* OPEN_MODAL_COUPON_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalCouponErrorActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["A" /* CLOSE_MODAL_COUPON_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalCouponErrorActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_33" /* OPEN_MODAL_PURCHASE_DATE_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPurchaseErrorDate: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["J" /* CLOSE_MODAL_PURCHASE_DATE_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPurchaseErrorDate: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_29" /* OPEN_MODAL_GENERIC_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalGenericErrorActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["F" /* CLOSE_MODAL_GENERIC_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalGenericErrorActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_28" /* OPEN_MODAL_FRANCHISE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFranchiseActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["E" /* CLOSE_MODAL_FRANCHISE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFranchiseActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_31" /* OPEN_MODAL_OPERATOR_CONFIRMATION */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalOperatorConfirmationActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["H" /* CLOSE_MODAL_OPERATOR_CONFIRMATION */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalOperatorConfirmationActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_30" /* OPEN_MODAL_NOT_COVID_COVERAGE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalNotCovidCoverage: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["G" /* CLOSE_MODAL_NOT_COVID_COVERAGE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalNotCovidCoverage: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_40" /* OPEN_MODAL_STUDENT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalStudentActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["Q" /* CLOSE_MODAL_STUDENT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalStudentActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_39" /* OPEN_MODAL_SAFETYPAY */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalSafetypayActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["P" /* CLOSE_MODAL_SAFETYPAY */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalSafetypayActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_41" /* OPEN_MODAL_TERMS_OF_USE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalTermsOfUseActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["R" /* CLOSE_MODAL_TERMS_OF_USE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalTermsOfUseActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_42" /* OPEN_MODAL_TRAVEL_RENEWAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalTravelRenewalActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["S" /* CLOSE_MODAL_TRAVEL_RENEWAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalTravelRenewalActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_38" /* OPEN_MODAL_RENEWAL_FRANCHISE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalRenewalFranchiseActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["O" /* CLOSE_MODAL_RENEWAL_FRANCHISE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalRenewalFranchiseActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_37" /* OPEN_MODAL_RECEPTIVE_PRODUCT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalReceptiveProductActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["N" /* CLOSE_MODAL_RECEPTIVE_PRODUCT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalReceptiveProductActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_32" /* OPEN_MODAL_PLAN_RULES */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPlanRulesActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_26" /* OPEN_MODAL_FAIL_PAYMENT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFailPayment: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["I" /* CLOSE_MODAL_PLAN_RULES */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalPlanRulesActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["C" /* CLOSE_MODAL_FAIL_PAYMENT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalFailPayment: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_19" /* HIDE_INVALID_CREDIT_CARD_ERROR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isInvalidCreditCardErrorVisible: false,
        invalidCreditCard: {
          brand: '',
          lastDigits: ''
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_75" /* SHOW_INVALID_CREDIT_CARD_ERROR */]:
      var brand = state.creditCard.brands.find(function (b) {
        return b.selected;
      }).brand_name;
      var lastDigits = state.creditCard.number.slice(-4);
      if (brand === 'amex') lastDigits = state.creditCard.number.slice(-5);
      return _objectSpread(_objectSpread({}, state), {}, {
        isInvalidCreditCardErrorVisible: true,
        invalidCreditCard: {
          brand: brand,
          lastDigits: lastDigits
        },
        stagePurchase: 2,
        stepDisplayCreditCard: 3
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_9" /* FETCH_PURCHASE_DATA */]:
      /* eslint no-case-declarations:0 */
      var isInsuredFormDeletable = action.data.insureds.length > 2;
      return calcCreditCard(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread(_objectSpread({}, state), {}, {
        insuredForms: _toConsumableArray(action.data.insureds.map(function (insured) {
          return {
            rg: '',
            cpf: insured.cpf,
            name: insured.full_name,
            birth_date: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatDate"])(insured.birth_date),
            document_type: 'cpf'
          };
        })),
        creditCard: _objectSpread(_objectSpread({}, state.creditCard), {}, {
          holder_name: action.data.holder.full_name,
          holder_cpf: action.data.holder.cpf
        }),
        boleto: _objectSpread(_objectSpread({}, state.boleto), {}, {
          name: action.data.holder.full_name,
          cpf: action.data.holder.cpf
        }),
        safetypay: _objectSpread(_objectSpread({}, state.safetypay), {}, {
          cpf: action.data.holder.cpf,
          name: action.data.holder.full_name
        }),
        isInsuredFormDeletable: isInsuredFormDeletable
      })));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* SET_USER_DETAILS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        userDetails: action.userDetails
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["k" /* CHANGE_CONFIRM_TERMS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        dateTimeAccept: action.dateTimeAccept
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["t" /* CLEAN_ERRORS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: Object(__WEBPACK_IMPORTED_MODULE_1__utils__["cleanStateErrors"])()
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_20" /* NEXT_STAGE_PURCHASE_MOBILE */]:
      newState = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["validatePurchaseMobile"])(state, action.stageValidator);
      if (newState.purchase_is_valid) {
        if (action.stageValidator === 'INSURED_RESP_CONTACT') {
          return _objectSpread(_objectSpread({}, newState), {}, {
            stagePurchase: action.index,
            stepPaymentFinish: true
          });
        }
        return _objectSpread(_objectSpread({}, newState), {}, {
          stagePurchase: action.index
        });
      }
      return newState;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_77" /* STAGE_PAYMENT_CREDIT_CARD */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        stepDisplayCreditCard: action.stepDisplayCreditCard
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_76" /* STAGE_PAYMENT_CASH_TRANSFER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        stepDisplayCashTransfer: action.stepDisplayCashTransfer
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["V" /* EDIT_PURCHASE */]:
      if (action.stagePurchase === 2) {
        return _objectSpread(_objectSpread({}, state), {}, {
          stagePurchase: action.stagePurchase,
          stepDisplayMethodPayment: 0,
          stepDisplayCreditCard: 0,
          stepDisplayCashTransfer: 0,
          stepDisplayBoleto: 0,
          stepDisplayPix: 0
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        stagePurchase: action.stagePurchase
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["h" /* BACK_STAGE_PURCHASE */]:
      if (action.stagePurchase === 4) {
        return _objectSpread(_objectSpread({}, state), {}, {
          stagePurchase: action.stagePurchase - 1,
          stepPaymentFinish: false
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        stagePurchase: action.stagePurchase - 1
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_54" /* SELECT_PAYMENT_ALTER_STATE */]:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.name, action.index));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["g" /* BACK_STAGE_PAYMENT_METHOD */]:
      if (action.condition) {
        var PaymentMethods = state.paymentMethods;
        PaymentMethods.map(function (method, i) {
          if (method.selected === true) {
            PaymentMethods[i] = _objectSpread(_objectSpread({}, method), {}, {
              selected: false
            });
          }
          return state;
        });
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils__["updatePurchaseSummaryData"])(_objectSpread(_objectSpread({}, state), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, action.name, action.index), "PaymentMethods", PaymentMethods), "stepDisplayMethodPayment", 0), "purchaseSummary", _objectSpread(_objectSpread({}, state.purchaseSummary), {}, {
          paymentMethodDiscountPercent: 0,
          paymentMethodDiscountValue: 0,
          paymentMethodSelected: ''
        }))));
      }
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.name, action.index));
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["u" /* CLEAN_STATES_PURCHASE_MOBILE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          stagePurchase: 1,
          stepDisplayMethodPayment: 0,
          stepDisplayCreditCard: 0,
          stepDisplayCashTransfer: 0,
          stepDisplayBoleto: 0,
          stepDisplayPix: 0
        });
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_86" /* VALIDATOR_HANDLER_BLUR */]:
      var errors = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["validatePurchaseOnBlur"])(action.value, action.name, action.index, state);
      return _objectSpread(_objectSpread({}, state), {}, {
        errors: errors
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_15" /* GET_INFOS_PROSPECT */]:
      if (action.infos) {
        return _objectSpread(_objectSpread({}, state), {}, {
          prospect: action.infos
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_62" /* SET_INFOS_PROSPECT_IN_PURCHASE */]:
      if (state.prospect.exist) {
        var _insuredForms = state.insuredForms.map(function (form, i) {
          return form.id === 0 ? _objectSpread({}, form) : form;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          insuredForms: _insuredForms,
          contact: _objectSpread(_objectSpread({}, state.contact), {}, {
            contact_name: state.prospect.name,
            email: state.prospect.email,
            phone_number: state.prospect.phone
          })
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["y" /* CLEAR_INFOS_PROSPECT */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        contact: _objectSpread(_objectSpread({}, state.contact), {}, {
          contact_name: '',
          email: '',
          phone_number: ''
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_59" /* SET_BENEFITS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        benefits: _toConsumableArray(action.benefits)
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_14" /* GET_INFOS_INSUREDS */]:
      if (action.payment === 1) {
        return _objectSpread(_objectSpread({}, state), {}, {
          boleto: _objectSpread(_objectSpread({}, state.boleto), {}, {
            name: state.insuredForms[0].name,
            cpf: state.insuredForms[0].cpf
          })
        });
      } else if (action.payment === 3) {
        return _objectSpread(_objectSpread({}, state), {}, {
          safetypay: _objectSpread(_objectSpread({}, state.safetypay), {}, {
            name: state.insuredForms[0].name,
            cpf: state.insuredForms[0].cpf
          })
        });
      } else if (action.payment === 4) {
        return _objectSpread(_objectSpread({}, state), {}, {
          pix: _objectSpread(_objectSpread({}, state.pix), {}, {
            name: state.insuredForms[0].name,
            cpf: state.insuredForms[0].cpf
          })
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_63" /* SET_OPERATOR_CONFIRMATION_CLICKED */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasConfirmedOperator: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_72" /* SET_UPSELL_PURCHASE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        upsellUpgrade: action.upsellProduct
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (purchase);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return captureException; });
/**
 * Captura um erro e envia para o Sentry, se disponível.
 * @param {Error|string} error - Erro (ou mensagem) a ser reportado.
 * @param {Object} [extra] - Dados extras de contexto (ex: { url, status, response }).
 */
var captureException = function captureException(error) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!window.Sentry) return;
  var exception = error instanceof Error ? error : new Error(error);
  window.Sentry.captureException(exception, {
    extra: extra
  });
};

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPurchaseStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(9);

var fetchPurchaseStatus = function fetchPurchaseStatus(purchaseStatus) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["_10" /* FETCH_PURCHASE_STATUS */],
    purchaseStatus: purchaseStatus
  };
};
/* unused harmony default export */ var _unused_webpack_default_export = (fetchPurchaseStatus);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export comparison */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var comparison = function comparison() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_0" /* FETCH_COMPARISON_PRODUCTS_COVERAGE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        comparisonPlansInfo: action.plansInfo.map(function (plan) {
          return _objectSpread(_objectSpread({}, plan), {}, {
            benefits: plan ? Object(__WEBPACK_IMPORTED_MODULE_1__utils__["groupByCategory"])(plan.benefits) : []
          });
        })
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_21" /* OPEN_COMPARISON_ACCORDION */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        openedBenefitCode: state.openedBenefitCode !== action.code ? action.code : ''
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_25" /* OPEN_MODAL_EMAIL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalEmailActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["B" /* CLOSE_MODAL_EMAIL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalEmailActive: false,
        emailStatus: ''
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_56" /* SENDING_EMAIL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailStatus: action.status
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_57" /* SEND_EMAIL_DONE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailStatus: action.status
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_58" /* SEND_EMAIL_FAIL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailStatus: action.status
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["o" /* CHANGE_EMAIL_MODAL_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailModal: _objectSpread(_objectSpread({}, state.emailModal), {}, _defineProperty({}, action.name, action.value))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["n" /* CHANGE_EMAIL_COLLAPSE_ATTR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        emailCollapse: _objectSpread(_objectSpread({}, state.emailCollapse), {}, _defineProperty({}, action.name, action.value))
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_35" /* OPEN_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["L" /* CLOSE_MODAL_QUOTATION_DATE_WARNING */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateWarningActive: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_74" /* SET_USER_DETAILS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        userDetails: action.userDetails
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_15" /* GET_INFOS_PROSPECT */]:
      if (action.infos) {
        return _objectSpread(_objectSpread({}, state), {}, {
          prospect: action.infos
        });
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_36" /* OPEN_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["M" /* CLOSE_MODAL_QUOTATION_DATE_YEAR */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isModalQuotationDateYearActive: false
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (comparison);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export purchaseStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var purchaseStatus = function purchaseStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_10" /* FETCH_PURCHASE_STATUS */]:
      return _objectSpread(_objectSpread({}, action.purchaseStatus), {}, {
        loading: false
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (purchaseStatus);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var mobile = function mobile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["a" /* ACCESS_IS_MOBILE */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        mobileActive: action.mobileActive
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (mobile);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var global = function global() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_17" /* GLOBAL_DESTINATIONS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        destinations: action.data
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["_18" /* GLOBAL_PROVIDER_SETGINGS */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        providers: action.data
      });
    default:
      return state;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (global);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_sp_frame__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var addClass = function addClass(el, className) {
  el.classList.add(className);
};
var rmClass = function rmClass(el, className) {
  el.classList.remove(className);
};
var addAttr = function addAttr(el, attrName, attrValue) {
  el.setAttribute(attrName, attrValue);
};
var rmAttr = function rmAttr(el, attrName) {
  el.removeAttribute(attrName);
};
var init = function init(component) {
  var destinationInput = document.querySelector("#destinationSp");
  var departureDateInput = document.querySelector("#departureDateInput");
  var departureDateContainer = document.querySelector("#departureDateContainer");
  var returningDateInput = document.querySelector("#returningDateInput");
  var returningDateContainer = document.querySelector("#returningDateContainer");
  var destination = new __WEBPACK_IMPORTED_MODULE_4__lib_sp_frame__["a" /* default */].Destination({
    input: destinationInput,
    onError: {
      INVALID_VALUE: function INVALID_VALUE() {
        addClass(destinationInput, "is-danger");
      }
    },
    onChange: function onChange() {
      rmClass(destinationInput, "is-danger");
      component.handleChange({
        target: {
          name: "destination",
          value: destination.getSelected().slug
        }
      });
    }
  });
  var departureDate = new __WEBPACK_IMPORTED_MODULE_4__lib_sp_frame__["a" /* default */].Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById("ex-input-departure"),
    multipleCalendars: true,
    startDatePicker: true,
    onShow: function onShow(_, drop) {
      addClass(departureDateContainer, "ex-inputs-picker-visible");
      if (drop === "up") {
        addClass(departureDateContainer, "ex-inputs-picker-up");
      } else {
        rmClass(departureDateContainer, "ex-inputs-picker-up");
      }
      if (window.innerWidth <= 640) {
        addClass(document.querySelector("html"), "overflow-hidden");
        addClass(document.querySelector("body"), "overflow-hidden");
      }
    },
    onChange: function onChange() {
      rmClass(departureDateInput, "is-danger");
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE() {
        addClass(departureDateInput, "is-danger");
      }
    },
    onHide: function onHide() {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector("html"), "overflow-hidden");
        rmClass(document.querySelector("body"), "overflow-hidden");
      }
      rmClass(departureDateContainer, "ex-inputs-picker-visible");
      rmClass(departureDateContainer, "ex-inputs-picker-up");
    },
    onSelect: function onSelect(frame) {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({
          target: {
            name: "begin_date",
            value: frame.departureDate.datePicker.state.start.toPtBr()
          }
        });
        departureDateInput.value = frame.departureDate.datePicker.state.start.toPtBr();
      }
    }
  });
  var returningDate = new __WEBPACK_IMPORTED_MODULE_4__lib_sp_frame__["a" /* default */].Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById("ex-input-return"),
    multipleCalendars: true,
    startDatePicker: false,
    onShow: function onShow(_, drop) {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector("html"), "overflow-hidden");
        addClass(document.querySelector("body"), "overflow-hidden");
      }
      addClass(returningDateContainer, "ex-inputs-picker-visible");
      if (drop === "up") {
        addClass(returningDateContainer, "ex-inputs-picker-up");
      } else {
        rmClass(returningDateContainer, "ex-inputs-picker-up");
      }
    },
    onChange: function onChange() {
      rmClass(returningDateInput, "is-danger");
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE() {
        addClass(returningDateInput, "is-danger");
      }
    },
    onHide: function onHide() {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector("html"), "overflow-hidden");
        rmClass(document.querySelector("body"), "overflow-hidden");
      }
      rmClass(returningDateContainer, "ex-inputs-picker-visible");
      rmClass(returningDateContainer, "ex-inputs-picker-up");
    },
    onDisable: function onDisable() {
      addAttr(returningDateInput, "disabled", "disabled");
    },
    onEnable: function onEnable() {
      rmAttr(returningDateInput, "disabled");
    },
    onSelect: function onSelect(frame) {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({
          target: {
            name: "end_date",
            value: frame.returningDate.datePicker.state.end.toPtBr()
          }
        });
        returningDateInput.value = frame.returningDate.datePicker.state.end.toPtBr();
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_4__lib_sp_frame__["a" /* default */].Frame({
    destination: destination,
    departureDate: departureDate,
    returningDate: returningDate,
    client: false,
    openInNewTab: false,
    trigger: document.getElementById("searchTriggerInput"),
    onSuccess: function onSuccess() {}
  });
};
var SearchBar = /*#__PURE__*/function (_Component) {
  function SearchBar(props) {
    var _this;
    _classCallCheck(this, SearchBar);
    _this = _callSuper(this, SearchBar, [props]);
    _this.state = {
      destination: "brasil",
      begin_date: "",
      end_date: ""
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.searchPlan = _this.searchPlan.bind(_this);
    _this.setQuotationParams = _this.props.setQuotationParams.bind(_this);
    _this.init = init;
    return _this;
  }
  _inherits(SearchBar, _Component);
  return _createClass(SearchBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this);
      __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].pageView('home');
    }
  }, {
    key: "searchPlan",
    value: function searchPlan() {
      __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].raw({
        event: 'page_resultados_busca'
      });
      var basePath = "/pesquisa";
      if (Object(__WEBPACK_IMPORTED_MODULE_5__utils__["isB2b"])()) basePath = "/pesquisa-b2b";
      var search = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["buildSearchWithDestinationCategories"])(this.props.destinations, this.state.destination);
      var path = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatURL"])(this.props.match.params, "".concat(basePath, "/").concat(this.state.destination, "/").concat(this.state.begin_date, "/").concat(this.state.end_date), search, !search);
      this.props.history.push(path);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (e.target.name === "begin_date" || e.target.name === "end_date") {
        var spl_date = e.target.value.split("/");
        var val = "".concat(spl_date[2], "-").concat(spl_date[1], "-").concat(spl_date[0]);
        e.target.value = val;
      }
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form_v1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "line01"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "continente",
        className: "input_container is-grouped location",
        id: "destinationSpDiv"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "location-signal",
        src: "https://www.segurospromo.com.br/images/home/point_destino.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        id: "destinationSp",
        "aria-label": "continente",
        readOnly: true,
        type: "text",
        placeholder: "Continente ou pa\xEDs de destino"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "destination",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: "",
        "data-cy": "search-frame-destino"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "arrowmenu",
        src: "https://www.segurospromo.com.br/images/home/arrow_down.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "partida",
        className: "input_container is-grouped partida ex-inputs",
        id: "ex-input-departure"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/images/home/partida.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        "aria-label": "partida",
        type: "text",
        name: "departureDate",
        placeholder: "Partida",
        id: "departureDateInput",
        readOnly: true,
        "data-cy": "search-frame-partida"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "departureDate",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "departureDateContainer",
        className: "ex-inputs-picker"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "retorno",
        className: "input_container is-grouped retorno ex-inputs",
        id: "ex-input-return"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/images/home/retorno.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        "aria-label": "retorno",
        type: "text",
        name: "Retorno",
        placeholder: "Retorno",
        id: "returningDateInput",
        readOnly: true,
        "data-cy": "search-frame-retorno"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "returningDate",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "returningDateContainer",
        className: "ex-inputs-picker"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        "aria-label": "pesquisar",
        className: "btnf-pesquisar",
        id: "searchTriggerInput",
        onClick: this.searchPlan
      }, "Pesquisar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "line02 is-stealth",
        id: "subscriberForm",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "nome",
        className: "input_container nome",
        id: "inputNameDiv"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/images/home/nome.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        "aria-label": "nome",
        type: "text",
        placeholder: "Nome",
        name: "spName",
        id: "nameSp",
        "data-cy": "search-frame-nome"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "name",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "email",
        className: "input_container email",
        id: "inputEmailDiv"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/images/home/email.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        "aria-label": "email",
        name: "spEmail",
        type: "email",
        id: "emailSp",
        placeholder: "E-mail",
        "data-cy": "search-frame-email"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "email",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "celular",
        className: "input_container celular",
        id: "inputCellphoneDiv"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/images/home/celular_novo_2.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        "aria-label": "celular",
        name: "spCellphone",
        type: "tel",
        id: "cellphoneSp",
        placeholder: "Celular",
        "data-cy": "search-frame-celular"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "danger-signal is-stealth",
        item: "cellphone",
        src: "https://www.segurospromo.com.br/images/home/alert_vermelho.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        "aria-label": "pesquisar",
        className: "btnf-pesquisar",
        id: "showSubscriber",
        "data-cy": "search-frame-pesquisar"
      }, "Pesquisar")));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var Home = /*#__PURE__*/function (_Component2) {
  function Home(props) {
    var _this2;
    _classCallCheck(this, Home);
    _this2 = _callSuper(this, Home, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_5__utils__["changeTitle"])("home");
    return _this2;
  }
  _inherits(Home, _Component2);
  return _createClass(Home, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_frame_v1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form_contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchBar, {
        setQuotationParams: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["w" /* setQuotationParams */],
        match: this.props.match,
        history: this.props.history,
        destinations: this.props.destinations
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "contact_contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "bbox_phone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box_phone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "https://www.segurospromo.com.br/shared/images/home/televendas_novo.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "TELEVENDAS:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "31 4003-8442"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "open_days"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Seg a Sex:"), " 08h \xE0s 20h"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "S\xE1bados, Domingos e feriados:"), " 10h \xE0s 16h")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    destinations: state.global.destinations
  };
}, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["w" /* setQuotationParams */]
})(Home)));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable */

(function (global, factory) {
  /*!eslint-disable */
  ( false ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.DateRangePicker = {});
  /*!eslint-enable */
})(this, function (exports) {
  'use strict';

  Date.prototype.toPtBr = function () {
    var dd = this.getDate();
    var mm = this.getMonth() + 1;
    return (dd > 9 ? '' : '0') + dd + '/' + (mm > 9 ? '' : '0') + mm + '/' + this.getFullYear();
  };
  Date.prototype.toEn = function () {
    var dd = this.getDate();
    var mm = this.getMonth() + 1;
    return this.getFullYear() + '/' + (mm > 9 ? '' : '0') + mm + '/' + (dd > 9 ? '' : '0') + dd;
  };
  /**
   * @file A generic set of mutation-free date functions.
   */

  /**
   * now returns the current date without any time values
   *
   * @returns {Date}
   */
  function now() {
    var dt = new Date();
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  /**
   * dateEq compares two dates
   *
   * @param {Date} date1 the first date
   * @param {Date} date2 the second date
   * @returns {boolean}
   */
  function datesEq(date1, date2) {
    return (date1 && date1.toDateString()) === (date2 && date2.toDateString());
  }

  /**
   * shiftDay shifts the specified date by n days
   *
   * @param {Date} dt
   * @param {number} n
   * @returns {Date}
   */
  function shiftDay(dt, n) {
    dt = new Date(dt);
    dt.setDate(dt.getDate() + n);
    return dt;
  }

  /**
   * shiftMonth shifts the specified date by a specified number of months
   *
   * @param {Date} dt
   * @param {number} n
   * @param {boolean} wrap optional, if true, does not change year
   *                       value, defaults to false
   * @returns {Date}
   */
  function shiftMonth(dt, n, wrap) {
    dt = new Date(dt);
    var dayOfMonth = dt.getDate();
    var month = dt.getMonth() + n;
    dt.setDate(1);
    dt.setMonth(wrap ? (12 + month) % 12 : month);
    dt.setDate(dayOfMonth);

    // If dayOfMonth = 31, but the target month only has 30 or 29 or whatever...
    // head back to the max of the target month
    if (dt.getDate() < dayOfMonth) {
      dt.setDate(0);
    }
    return dt;
  }

  /**
   * shiftYear shifts the specified date by n years
   *
   * @param {Date} dt
   * @param {number} n
   * @returns {Date}
   */
  function shiftYear(dt, n) {
    dt = new Date(dt);
    dt.setFullYear(dt.getFullYear() + n);
    return dt;
  }

  /**
   * dateOrParse creates a function which, given a date or string, returns a date
   *
   * @param {function} parse the function used to parse strings
   * @returns {function}
   */
  function dateOrParse(parse) {
    return function (dt) {
      return typeof dt === 'string' ? parse(dt) : dt;
    };
  }

  /**
   * constrainDate returns dt or min/max depending on whether dt is out of bounds (inclusive)
   *
   * @export
   * @param {Date} dt
   * @param {Date} min
   * @param {Date} max
   * @returns {Date}
   */
  function constrainDate(dt, min, max) {
    return dt < min ? min : dt > max ? max : dt;
  }

  /**
   * @file Utility functions for function manipulation.
   */

  /**
   * bufferFn buffers calls to fn so they only happen every ms milliseconds
   *
   * @param {number} ms number of milliseconds
   * @param {function} fn the function to be buffered
   * @returns {function}
   */
  function bufferFn(ms, fn) {
    var timeout = undefined;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, ms);
    };
  }

  /**
   * noop is a function which does nothing at all.
   */
  function noop() {}

  /**
   * copy properties from object o2 to object o1.
   *
   * @params {Object} o1
   * @params {Object} o2
   * @returns {Object}
   */
  function cp() {
    var args = arguments;
    var o1 = args[0];
    for (var i = 1; i < args.length; ++i) {
      var o2 = args[i] || {};
      for (var key in o2) {
        o1[key] = o2[key];
      }
    }
    return o1;
  }

  /**
   * @file Responsible for sanitizing and creating date picker options.
   */

  var portugueseBr = {
    days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]
  };

  /**
   * DatePickerOptions constructs a new date picker options object, overriding
   * default values with any values specified in opts.
   *
   * @param {DatePickerOptions} opts
   * @returns {DatePickerOptions}
   */
  function DatePickerOptions(opts) {
    opts = opts || {};
    opts = cp(defaults(), opts);
    var parse = dateOrParse(opts.parse);
    opts.lang = cp(portugueseBr, opts.lang);
    opts.parse = parse;
    opts.inRange = makeInRangeFn(opts);
    opts.min = parse(opts.min || shiftYear(now(), -100));
    opts.max = parse(opts.max || shiftYear(now(), 100));
    opts.hilightedDate = opts.parse(opts.hilightedDate);
    return opts;
  }
  function defaults() {
    return {
      lang: portugueseBr,
      // Possible values: dp-modal, dp-below, dp-permanent
      shouldFocusOnRender: true,
      mode: 'dp-permanent',
      startDatePicker: true,
      multipleCalendars: true,
      startDatePickerInput: null,
      endDatePickerInput: null,
      startSelectedDate: null,
      endSelectedDate: null,
      onHide: null,
      // The date to hilight initially if the date picker has no
      // initial value.
      hilightedDate: now(),
      format: function format(dt) {
        return dt.getMonth() + 1 + '/' + dt.getDate() + '/' + dt.getFullYear();
      },
      parse: function parse(str) {
        var date = new Date(str);
        return isNaN(date) ? now() : date;
      },
      dateClass: function dateClass() {},
      inRange: function inRange() {
        return true;
      }
    };
  }
  function makeInRangeFn(opts) {
    var inRange = opts.inRange; // Cache this version, and return a variant

    return function (dt, dp) {
      return inRange(dt, dp) && opts.min <= dt && opts.max >= dt;
    };
  }

  /**
   * on attaches an event handler to the specified element, and returns an
   * off function which can be used to remove the handler.
   *
   * @param {string} evt the name of the event to handle
   * @param {HTMLElement} el the element to attach to
   * @param {function} handler the event handler
   * @returns {function} the off function
   */
  function on(evt, el, handler) {
    el.addEventListener(evt, handler, true);
    return function () {
      el.removeEventListener(evt, handler, true);
    };
  }
  var CustomEvent = shimCustomEvent();
  function shimCustomEvent() {
    var CustomEvent = window.CustomEvent;
    if (typeof CustomEvent !== 'function') {
      CustomEvent = function CustomEvent(event, params) {
        params = params || {
          bubbles: false,
          cancelable: false,
          detail: undefined
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      };
      CustomEvent.prototype = window.Event.prototype;
    }
    return CustomEvent;
  }

  /**
   * @file Manages the calendar / day-picker view.
   */

  var dayPicker = {
    onClick: {
      'dp-day': selectDay,
      'dp-next': gotoNextMonth,
      'dp-prev': gotoPrevMonth,
      'dp-close': close,
      'dp-departure-selected-date': toChooseDepartureDate,
      'dep-selected-date-span': toChooseDepartureDate,
      'dp-returning-selected-date': toChooseReturningDate,
      'ret-selected-date-span': toChooseReturningDate
    },
    render: render
  };

  /**
   * view renders the calendar (day picker) as an HTML string.
   *
   * @param {DatePickerContext} context the date picker being rendered
   * @returns {string}
   */
  function render(dp) {
    var opts = dp.opts;
    var lang = opts.lang;
    var state = dp.state;
    var dayNames = lang.days;
    var dayOffset = opts.dayOffset || 0;
    var selectedDate = state.selectedDate;
    var hilightedDate = state.hilightedDate;
    var hilightedMonth = hilightedDate.getMonth();
    return '<div class="dp-cal">' + '<header class="dp-cal-title">' + '<span class="dp-cal-title-span">' + 'Escolha a ' + (opts.startDatePicker ? 'ida' : 'volta') + '</span>' + '<a  style="background-color: none;" class="dp-close" ></a>' + '</header>' + '<header class="dp-cal-selected-dates">' + '<div class="selected-dates-dp">' + '<div class=' + (opts.startDatePicker ? '"dp-departure-selected-date to-select-date-picker"' : '"dp-departure-selected-date"') + '>' + 'Data de ida <br />' + '<span class="dep-selected-date-span">' + (opts.startSelectedDate ? new Date(opts.startSelectedDate).toPtBr() : '-') + '</span>' + '</div>' + '<div class=' + (!opts.startDatePicker ? '"dp-returning-selected-date to-select-date-picker"' : '"dp-returning-selected-date"') + '>' + 'Data de volta <br />' + '<span class="ret-selected-date-span">' + (opts.endSelectedDate ? new Date(opts.endSelectedDate).toPtBr() : '-') + '</span>' + '</div>' + '</div>' + '</header>' + '<div class="dp-cal-header">' + '<button tabindex="-1" type="button" class="dp-prev">Prev</button>' + '<button tabindex="-1" type="button" class="dp-cal-month">' + lang.months[hilightedMonth] + '</button>' + '<button tabindex="-1" type="button" class="dp-cal-year">' + hilightedDate.getFullYear() + '</button>' + '<button tabindex="-1" type="button" class="dp-next">Next</button>' + (!opts.multipleCalendars ? '<button tabindex="-1" type="button" class="dp-next dp-next-single">Next</button>' : '') + '</div>' + '<div class="dp-days">' + dayNames.map(function (name, i) {
      return '<span class="dp-col-header">' + dayNames[(i + dayOffset) % dayNames.length] + '</span>';
    }).join('') + mapDays(hilightedDate, dayOffset, function (date) {
      var isNotInMonth = date.getMonth() !== hilightedMonth;
      var isDisabled = !opts.inRange(date);
      var className = 'dp-day';
      className += isNotInMonth ? ' dp-edge-day' : '';
      className += datesEq(date, hilightedDate) ? ' dp-current' : '';
      className += datesEq(date, selectedDate) ? ' dp-selected' : '';
      className += isDisabled ? ' dp-day-disabled' : '';
      className += ' ' + opts.dateClass(date, dp);
      return '<button tabindex="-1" type="button" class="' + className + '" data-date="' + date.getTime() + '">' + date.getDate() + '</button>';
    }) + '</div>' + '</div>';
  }
  function close(e, dp) {
    dp.opts.onHide();
  }
  function toChooseDepartureDate(e, dp) {
    dp.opts.startDatePickerInput.focus();
  }
  function toChooseReturningDate(e, dp) {
    dp.opts.endDatePickerInput.focus();
  }
  function gotoNextMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    var newHilightedDate = shiftMonth(hilightedDate, 1);
    dp.setState({
      hilightedDate: newHilightedDate
    });
  }
  function gotoPrevMonth(e, dp) {
    var hilightedDate = dp.state.hilightedDate;
    var newHilightedDate = shiftMonth(hilightedDate, -1);
    dp.setState({
      hilightedDate: newHilightedDate
    });
  }
  function selectDay(e, dp) {
    dp.setState({
      selectedDate: new Date(parseInt(e.target.getAttribute('data-date'))),
      isStartDate: dp.opts.startDatePicker
    });
  }
  function mapDays(currentDate, dayOffset, fn) {
    var result = '';
    var iter = new Date(currentDate);
    iter.setDate(1);
    iter.setDate(1 - iter.getDay() + dayOffset);

    // If we are showing monday as the 1st of the week,
    // and the monday is the 2nd of the month, the sunday won't
    // show, so we need to shift backwards
    if (dayOffset && iter.getDate() === dayOffset + 1) {
      iter.setDate(dayOffset - 6);
    }

    // We are going to have 6 weeks always displayed to keep a consistent
    // calendar size
    for (var day = 0; day < 6 * 7; ++day) {
      result += fn(iter);
      iter.setDate(iter.getDate() + 1);
    }
    return result;
  }
  var views = {
    day: dayPicker
  };
  function BaseMode(input, emit, opts) {
    var detatchInputEvents; // A function that detaches all events from the input
    var closing = false; // A hack to prevent calendar from re-opening when closing.
    var selectedDate; // The currently selected date
    var dp = {
      // The root DOM element for the date picker, initialized on first open.
      el: undefined,
      opts: opts,
      shouldFocusOnBlur: true,
      shouldFocusOnRender: true,
      state: initialState(),
      adjustPosition: noop,
      containerHTML: '<div class="dp"></div>',
      attachToDom: function attachToDom() {
        document.body.appendChild(dp.el);
      },
      updateInput: function updateInput(selectedDate) {
        var e = new CustomEvent('change', {
          bubbles: true
        });
        e.simulated = true;
        input.value = selectedDate ? opts.format(selectedDate) : '';
        input.dispatchEvent(e);
      },
      computeSelectedDate: function computeSelectedDate() {
        return opts.parse(input.value);
      },
      currentView: function currentView() {
        return views[dp.state.view];
      },
      open: function open() {
        if (closing) {
          return;
        }
        if (!dp.el) {
          dp.el = createContainerElement(opts, dp.containerHTML);
          attachContainerEvents(dp);
        }
        selectedDate = constrainDate(dp.computeSelectedDate(), opts.min, opts.max);
        dp.state.hilightedDate = selectedDate || opts.hilightedDate;
        dp.state.view = 'day';
        dp.attachToDom();
        dp.render();
        emit('open');
      },
      hasFocus: function hasFocus() {
        var focused = document.activeElement;
        return dp.el && dp.el.contains(focused) && focused.className.indexOf('dp-focuser') < 0;
      },
      render: function render() {
        if (!dp.el) {
          return;
        }
        var hadFocus = dp.hasFocus();
        var html = dp.currentView().render(dp);
        html && (dp.el.firstChild.innerHTML = html);
        dp.adjustPosition();
        if (hadFocus || dp.shouldFocusOnRender) {
          focusCurrent(dp);
        }
      },
      // Conceptually similar to setState in React, updates
      // the view state and re-renders.
      setState: function setState(state) {
        for (var key in state) {
          dp.state[key] = state[key];
        }
        emit('statechange');
        dp.render();
      }
    };

    // Builds the initial view state
    // selectedDate is a special case and causes changes to hilightedDate
    // hilightedDate is set on open, so remains undefined initially
    // view is the current view (day, month, year)
    function initialState() {
      return {
        get selectedDate() {
          return selectedDate;
        },
        set selectedDate(dt) {
          if (dt && !opts.inRange(dt)) {
            return;
          }
          if (dt) {
            selectedDate = new Date(dt);
            dp.state.hilightedDate = selectedDate;
          } else {
            selectedDate = dt;
          }
          dp.updateInput(selectedDate);
          emit('select');
          // dp.close();
        },
        view: 'day'
      };
    }
    return dp;
  }
  function createContainerElement(opts, containerHTML) {
    var el = document.createElement('div');
    el.className = opts.mode;
    el.innerHTML = containerHTML;
    return el;
  }
  function focusCurrent(dp) {
    var current = dp.el.querySelector('.dp-current');
    return current && current.focus();
  }
  function attachContainerEvents(dp) {
    var el = dp.el;
    var calEl = el.querySelector('.dp');

    // Hack to get iOS to show active CSS states
    el.ontouchstart = noop;
    function onClick(e) {
      e.target.className.split(' ').forEach(function (evt) {
        var handler = dp.currentView().onClick[evt];
        handler && handler(e, dp);
      });
    }

    // The calender fires a blur event *every* time we redraw
    // this means we need to buffer the blur event to see if
    // it still has no focus after redrawing, and only then
    // do we return focus to the input. A possible other approach
    // would be to set context.redrawing = true on redraw and
    // set it to false in the blur event.

    var eventToDispatch = 'mousedown';
    on(eventToDispatch, calEl, function (e) {
      e.target.focus && e.target.focus(); // IE hack
      if (document.activeElement !== e.target) {
        e.preventDefault();
        focusCurrent(dp);
      }
    });
    on('click', el, onClick);
  }

  /**
   * @file Defines the permanent date picker behavior.
   */

  function PermanentMode(root, emit, opts) {
    var dp = BaseMode(root, emit, opts);
    dp.close = noop;
    dp.destroy = noop;
    dp.updateInput = noop;
    dp.shouldFocusOnRender = opts.shouldFocusOnRender;
    dp.computeSelectedDate = function () {
      return opts.hilightedDate;
    };
    dp.attachToDom = function () {
      root.appendChild(dp.el);
    };
    dp.open();
    return dp;
  }

  /**
   * @file Defines the various date picker modes (modal, dropdown, permanent)
   */

  function Mode(input, emit, opts) {
    input = input && input.tagName ? input : document.querySelector(input);
    return PermanentMode(input, emit, opts);
  }

  /**
   * @file Defines simple event emitter behavior.
   */

  /**
   * Emitter constructs a new emitter object which has on/off methods.
   *
   * @returns {EventEmitter}
   */
  function Emitter() {
    var handlers = {};
    function onOne(name, handler) {
      (handlers[name] = handlers[name] || []).push(handler);
    }
    function onMany(fns) {
      for (var name in fns) {
        onOne(name, fns[name]);
      }
    }
    return {
      on: function on(name, handler) {
        if (handler) {
          onOne(name, handler);
        } else {
          onMany(name);
        }
        return this;
      },
      emit: function emit(name, arg) {
        (handlers[name] || []).forEach(function (handler) {
          handler(name, arg);
        });
      },
      off: function off(name, handler) {
        if (!name) {
          handlers = {};
        } else if (!handler) {
          handlers[name] = [];
        } else {
          handlers[name] = (handlers[name] || []).filter(function (h) {
            return h !== handler;
          });
        }
        return this;
      }
    };
  }

  /**
   * @file The root date picker file, defines public exports for the library.
   */

  /**
  * The date picker language configuration
  * @typedef {Object} LangOptions
  * @property {Array.<string>} [days] - Days of the week
  * @property {Array.<string>} [months] - Months of the year
  * @property {string} today - The label for the 'today' button
  * @property {string} close - The label for the 'close' button
  * @property {string} clear - The label for the 'clear' button
  */

  /**
  * The configuration options for a date picker.
  *
  * @typedef {Object} DatePickerOptions
  * @property {LangOptions} [lang] - Configures the label text, defaults to portugueseBr
  * @property {('dp-modal'|'dp-below'|'dp-permanent')} [mode] - The date picker mode, defaults to 'dp-modal'
  * @property {(string|Date)} [hilightedDate] - The date to hilight if no date is selected
  * @property {function(string|Date):Date} [parse] - Parses a date, the complement of the "format" function
  * @property {function(Date):string} [format] - Formats a date for displaying to user
  * @property {function(Date):string} [dateClass] - Associates a custom CSS class with a date
  * @property {function(Date):boolean} [inRange] - Indicates whether or not a date is selectable
  * @property {(string|Date)} [min] - The minimum selectable date (inclusive, default 100 years ago)
  * @property {(string|Date)} [max] - The maximum selectable date (inclusive, default 100 years from now)
  */

  /**
  * The state values for the date picker
  *
  * @typedef {Object} DatePickerState
  * @property {string} view - The current view 'day' | 'month' | 'year'
  * @property {Date} selectedDate - The date which has been selected by the user
  * @property {Date} hilightedDate - The date which is currently hilighted / active
  */

  /**
  * An instance of TinyDatePicker
  *
  * @typedef {Object} DatePicker
  * @property {DatePickerState} state - The values currently displayed.
  * @property {function} on - Adds an event handler
  * @property {function} off - Removes an event handler
  * @property {function} setState - Changes the current state of the date picker
  * @property {function} open - Opens the date picker
  * @property {function} close - Closes the date picker
  * @property {function} destroy - Destroys the date picker (removing all handlers from the input, too)
  */

  /**
   * TinyDatePicker constructs a new date picker for the specified input
   *
   * @param {HTMLElement | string} input The input or CSS selector associated with the datepicker
   * @param {DatePickerOptions} opts The options for initializing the date picker
   * @returns {DatePicker}
   */
  function TinyDatePicker(input, opts) {
    var emitter = Emitter();
    var options = DatePickerOptions(opts);
    var mode = Mode(input, emit, options);
    var me = {
      get state() {
        return mode.state;
      },
      update: updateOptions,
      on: emitter.on,
      off: emitter.off,
      setState: mode.setState,
      open: mode.open,
      close: mode.close,
      destroy: mode.destroy
    };
    function updateOptions(opt, newValue) {
      options[opt] = newValue;
    }
    function emit(evt) {
      emitter.emit(evt, me);
    }
    return me;
  }

  // A date range picker built on top of TinyDatePicker;

  var TinyDatePicker$1 = TinyDatePicker;

  /**
  * The state values for the date range picker
  *
  * @typedef {Object} DateRangeState
  * @property {Date} start - The start date (can be null)
  * @property {Date} end - The end date (can be null)
  */

  /**
  * An instance of TinyDatePicker
  *
  * @typedef {Object} DateRangePickerInst
  * @property {DateRangeState} state - The start / end dates
  * @property {function} on - Adds an event handler
  * @property {function} off - Removes an event handler
  * @property {function} setState - Changes the current state of the date picker
  */

  /**
   * TinyDatePicker constructs a new date picker for the specified input
   *
   * @param {HTMLElement} input The input associated with the datepicker
   * @returns {DateRangePickerInst}
   */
  function DateRangePicker(container, opts) {
    opts = opts || {};
    var emitter = Emitter();
    var root = renderInto(container, opts.endOpts.multipleCalendars);
    var hoverDate;
    var state = {
      start: undefined,
      end: undefined
    };
    var start = TinyDatePicker(root.querySelector('.dr-cal-start'), cp({}, opts.startOpts, {
      mode: 'dp-permanent',
      dateClass: dateClass
    }));
    var end = opts.endOpts.multipleCalendars ? TinyDatePicker(root.querySelector('.dr-cal-end'), cp({}, opts.endOpts, {
      mode: 'dp-permanent',
      hilightedDate: shiftMonth(start.state.hilightedDate, 1),
      dateClass: dateClass
    })) : null;
    var handlers = {
      'statechange': onStateChange,
      'select': dateSelected
    };
    var me = {
      state: state,
      setState: setState,
      setMinDate: setMinDate,
      setSelectedStartDate: setSelectedStartDate,
      setSelectedEndDate: setSelectedEndDate,
      setInputs: setInputs,
      on: emitter.on,
      off: emitter.off,
      rerender: rerender
    };
    start.on(handlers);
    end && end.on(handlers);
    function onStateChange(_, dp) {
      // strate
      var d1 = start.state.hilightedDate;
      if (end) {
        var d2 = end.state.hilightedDate;
        var diff = diffMonths(d1, d2);
        if (diff === 1) {
          return;
        }
      }
      if (dp === start && end) {
        end.setState({
          hilightedDate: shiftMonth(dp.state.hilightedDate, 1)
        });
      } else if (end) {
        start.setState({
          hilightedDate: shiftMonth(dp.state.hilightedDate, -1)
        });
      }
    }
    function dateSelected(_, dp) {
      setTimeout(function () {
        var dt = dp.state.selectedDate;
        var isStartDate = dp.state.isStartDate;
        if (isStartDate) {
          setState({
            start: dt,
            end: me.state.end < dt && undefined
          });
        } else {
          setState({
            end: dt
          });
        }
      }, 0);
    }
    function setInputs(startInput, endInput) {
      start.update('startDatePickerInput', startInput);
      if (endInput) {
        start.update('endDatePickerInput', endInput);
      }
      rerender();
    }
    function setMinDate(newDate) {
      start.update('min', newDate);
      start.setState({
        hilightedDate: shiftMonth(newDate, end ? 0 : 0)
      });
      end && end.update('min', newDate);
      rerender();
    }
    function setSelectedStartDate(newDate) {
      start.update('startSelectedDate', newDate);
      end && end.update('startSelectedDate', newDate);
      if (newDate && end) {
        end.setState({
          hilightedDate: shiftMonth(newDate, 1)
        });
      }
      rerender();
    }
    function setSelectedEndDate(newDate) {
      start.update('endSelectedDate', newDate);
      end && end.update('endSelectedDate', newDate);
      if (newDate) {
        start.setState({
          hilightedDate: newDate
        });
      }
      rerender();
    }
    function setState(newState) {
      for (var key in newState) {
        state[key] = newState[key];
      }
      emitter.emit('statechange', me);
      rerender();
    }
    function rerender() {
      start.setState({});
      end && end.setState({});
      if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {}
    }

    // Hack to avoid a situation where iOS requires double-clicking to select
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      root.addEventListener('mouseover', function mouseOverDate(e) {
        if (e.target.classList.contains('dp-day')) {
          var dt = new Date(parseInt(e.target.dataset.date));
          var changed = !datesEq(dt, hoverDate);
          if (changed) {
            hoverDate = dt;
            if (!opts.startOpts.startDatePicker || opts.startOpts.startDatePicker && state.end) {
              rerender();
            }
          }
        }
      });
    }
    function dateClass(dt) {
      var rangeClass = (state.end || hoverDate) && state.start && inRange(dt, state.end || hoverDate, state.start);
      var selectedClass = datesEq(dt, state.start) ? 'dr-selected-start' : datesEq(dt, state.end) ? 'dr-selected-end' : '';
      return (rangeClass ? 'dr-in-range ' : '') + selectedClass;
    }
    return me;
  }
  function renderInto(container, multiplePickers) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    container.innerHTML = '<div class="dr-cals">' + '<div class="dr-cal-start"></div>' + (multiplePickers ? '<div class="dr-cal-end"></div>' : '') + '</div>';
    return container.querySelector('.dr-cals');
  }
  function toMonths(dt) {
    return dt.getYear() * 12 + dt.getMonth();
  }
  function diffMonths(d1, d2) {
    return toMonths(d2) - toMonths(d1);
  }
  function inRange(dt, start, end) {
    return dt < end && dt >= start || dt <= start && dt > end;
  }
  exports.TinyDatePicker = TinyDatePicker$1;
  exports.DateRangePicker = DateRangePicker;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable */

var autoComplete = function () {
  // "use strict";
  function autoComplete(options) {
    if (!document.querySelector) return;

    // helpers
    function hasClass(el, className) {
      return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
    }
    function addEvent(el, type, handler) {
      if (el.attachEvent) el.attachEvent('on' + type, handler);else el.addEventListener(type, handler);
    }
    function removeEvent(el, type, handler) {
      // if (el.removeEventListener) not working in IE11
      if (el.detachEvent) el.detachEvent('on' + type, handler);else el.removeEventListener(type, handler);
    }
    function live(elClass, event, cb, context) {
      addEvent(context || document, event, function (e) {
        var found,
          el = e.target || e.srcElement;
        while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
        if (found) cb.call(el, e);
      });
    }
    var o = {
      selector: 0,
      source: 0,
      minChars: 3,
      delay: 150,
      offsetLeft: 0,
      offsetTop: 1,
      cache: 1,
      menuClass: '',
      renderItem: function renderItem(item, search) {
        // escape special characters
        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
        return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
      },
      onSelect: function onSelect(e, term, item) {}
    };
    for (var k in options) {
      if (options.hasOwnProperty(k)) o[k] = options[k];
    }

    // init
    var elems = _typeof(o.selector) === 'object' ? [o.selector] : document.querySelectorAll(o.selector);
    for (var i = 0; i < elems.length; i++) {
      var that = elems[i];

      // create suggestions container "sc"
      that.sc = document.createElement('div');
      that.sc.className = 'autocomplete-suggestions ' + o.menuClass;
      that.autocompleteAttr = that.getAttribute('autocomplete');
      that.setAttribute('autocomplete', 'off');
      that.cache = {};
      that.last_val = '';
      that.updateSC = function (resize, next) {
        var rect = that.getBoundingClientRect();
        that.sc.style.left = Math.round(rect.left + (window.pageXOffset || document.documentElement.scrollLeft) + o.offsetLeft) + 'px';
        that.sc.style.top = Math.round(rect.bottom + (window.pageYOffset || document.documentElement.scrollTop) + o.offsetTop) + 'px';
        that.sc.style.width = Math.round(rect.right - rect.left) + 'px'; // outerWidth
        if (!resize) {
          that.sc.style.display = 'block';
          if (!that.sc.maxHeight) {
            that.sc.maxHeight = parseInt((window.getComputedStyle ? getComputedStyle(that.sc, null) : that.sc.currentStyle).maxHeight);
          }
          if (!that.sc.suggestionHeight) that.sc.suggestionHeight = that.sc.querySelector('.autocomplete-suggestion').offsetHeight;
          if (that.sc.suggestionHeight) if (!next) that.sc.scrollTop = 0;else {
            var scrTop = that.sc.scrollTop,
              selTop = next.getBoundingClientRect().top - that.sc.getBoundingClientRect().top;
            if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0) that.sc.scrollTop = selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;else if (selTop < 0) that.sc.scrollTop = selTop + scrTop;
          }
        }
      };
      addEvent(window, 'resize', that.updateSC);
      document.body.appendChild(that.sc);

      // live('autocomplete-suggestion', 'mouseleave', function(e){
      //     var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
      //     if (sel) setTimeout(function(){ sel.className = sel.className.replace('selected', ''); }, 20);
      // }, that.sc);

      // live('autocomplete-suggestion', 'mouseover', function(e){
      //     var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
      //     if (sel) sel.className = sel.className.replace('selected', '');
      //     this.className += ' selected';
      // }, that.sc);

      live('autocomplete-suggestion', 'mousedown', function (e) {
        if (hasClass(this, 'autocomplete-suggestion')) {
          // else outside click
          var v = this.getAttribute('data-val');
          that.value = v;
          o.onSelect(e, v, this);
          that.sc.style.display = 'none';
        }
      }, that.sc);
      that.blurHandler = function () {
        try {
          var over_sb = document.querySelector('.autocomplete-suggestions:hover');
        } catch (e) {
          var over_sb = 0;
        }
        if (!over_sb) {
          that.last_val = that.value;
          that.sc.style.display = 'none';
          setTimeout(function () {
            that.sc.style.display = 'none';
          }, 350); // hide suggestions on fast input
        } else if (that !== document.activeElement) setTimeout(function () {
          that.focus();
        }, 20);
      };
      addEvent(that, 'blur', that.blurHandler);
      var suggest = function suggest(data) {
        var val = that.value;
        that.cache[val] = data;
        if (data.length && val.length >= o.minChars) {
          var s = '';
          for (var i = 0; i < data.length; i++) s += o.renderItem(data[i], val);
          that.sc.innerHTML = s;
          that.updateSC(0);
        } else that.sc.style.display = 'none';
      };
      that.keydownHandler = function (e) {
        var key = window.event ? e.keyCode : e.which;
        // down (40), up (38)
        if ((key === 40 || key === 38) && that.sc.innerHTML) {
          var next,
            sel = that.sc.querySelector('.autocomplete-suggestion.selected');
          if (!sel) {
            next = key === 40 ? that.sc.querySelector('.autocomplete-suggestion') : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
            next.className += ' selected';
            that.value = next.getAttribute('data-val');
          } else {
            next = key === 40 ? sel.nextSibling : sel.previousSibling;
            if (next) {
              sel.className = sel.className.replace('selected', '');
              next.className += ' selected';
              that.value = next.getAttribute('data-val');
            } else {
              sel.className = sel.className.replace('selected', '');
              that.value = that.last_val;
              next = 0;
            }
          }
          that.updateSC(0, next);
          return false;
        }
        // esc
        else if (key === 27) {
          that.value = that.last_val;
          that.sc.style.display = 'none';
        }
        // enter
        else if (key === 13 || key === 9) {
          var sel = that.sc.querySelector('.autocomplete-suggestion.selected');
          if (sel && that.sc.style.display !== 'none') {
            o.onSelect(e, sel.getAttribute('data-val'), sel);
            setTimeout(function () {
              that.sc.style.display = 'none';
            }, 20);
          }
        }
      };
      addEvent(that, 'keydown', that.keydownHandler);
      that.keyupHandler = function (e) {
        var key = window.event ? e.keyCode : e.which;
        if (!key || (key < 35 || key > 40) && key !== 13 && key !== 27) {
          var val = that.value;
          if (val.length >= o.minChars) {
            if (val !== that.last_val) {
              that.last_val = val;
              clearTimeout(that.timer);
              if (o.cache) {
                if (val in that.cache) {
                  suggest(that.cache[val]);
                  return;
                }
                // no requests if previous suggestions were empty
                for (var i = 1; i < val.length - o.minChars; i++) {
                  var part = val.slice(0, val.length - i);
                  if (part in that.cache && !that.cache[part].length) {
                    suggest([]);
                    return;
                  }
                }
              }
              that.timer = setTimeout(function () {
                o.source(val, suggest);
              }, o.delay);
            }
          } else {
            that.last_val = val;
            that.sc.style.display = 'none';
          }
        }
      };
      addEvent(that, 'keyup', that.keyupHandler);
      that.focusHandler = function (e) {
        that.last_val = '\n';
        that.keyupHandler(e);
      };
      if (!o.minChars) addEvent(that, 'click', that.focusHandler);
    }

    // public destroy method
    this.destroy = function () {
      for (var i = 0; i < elems.length; i++) {
        var that = elems[i];
        removeEvent(window, 'resize', that.updateSC);
        removeEvent(that, 'blur', that.blurHandler);
        removeEvent(that, 'focus', that.focusHandler);
        removeEvent(that, 'keydown', that.keydownHandler);
        removeEvent(that, 'keyup', that.keyupHandler);
        if (that.autocompleteAttr) that.setAttribute('autocomplete', that.autocompleteAttr);else that.removeAttribute('autocomplete');
        document.body.removeChild(that.sc);
        that = null;
      }
    };
  }
  return autoComplete;
}();

/* eslint-enable */

(function () {
  if (true)
    // eslint-disable-line no-undef
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return autoComplete;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // eslint-disable-line no-undef
  else if (typeof module !== 'undefined' && module.exports) module.exports = autoComplete;else window.autoComplete = autoComplete;
})();

/***/ }),
/* 207 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_searchBarDesktop__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__v2_search_components_plansTable__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_searchBarMobile__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_search_plans_table_SpecialistBlock__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_search_comparison_bar_ComparisonBar_module__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_year_ModalQuotationDateYear__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_modal_without_tracker_ModalWithoutTracker__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_filter__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_filter_components_FloatingFilter__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_helmet__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_V2_upsell__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_module_css__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_module_css__);


















function Search(props) {
  var mobile = props.mobile;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _ref = props.match.params || {},
      destination = _ref.destination,
      begin_date = _ref.begin_date,
      end_date = _ref.end_date;
    if (destination && begin_date && end_date) {
      var formattedDate = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["formatDateToMonthYear"])(begin_date);
      var daysInAdvance = Object(__WEBPACK_IMPORTED_MODULE_11__utils__["getDaysInAdvance"])(begin_date);
      __WEBPACK_IMPORTED_MODULE_16__utils_matomo__["a" /* default */].trackSearch(destination, formattedDate, daysInAdvance);
    }
    if (begin_date && Object(__WEBPACK_IMPORTED_MODULE_11__utils__["isSameDaySearch"])(begin_date) && !(props.userDetails && props.userDetails.operator_permissions)) {
      props.openModalQuotationDateWarning();
    }
    if (begin_date && end_date && Object(__WEBPACK_IMPORTED_MODULE_11__utils__["quotationDateYear"])(begin_date, end_date)) {
      props.openModalQuotationDateYear();
    }
    if (props.location && Object(__WEBPACK_IMPORTED_MODULE_11__utils__["verifyOriginSearchUrl"])(props.location.search)) {
      props.openModalWithoutTracker();
    }
  }, [props.match && props.match.params && props.match.params.begin_date, props.match && props.match.params && props.match.params.end_date, props.match && props.match.params && props.match.params.destination, props.location && props.location.search, props.userDetails && props.userDetails.operator_permissions]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_helmet__["a" /* Helmet */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("body", {
    className: __WEBPACK_IMPORTED_MODULE_17__styles_module_css___default.a.body
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", null, mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_searchBarMobile__["a" /* default */], null), !mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_searchBarDesktop__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_17__styles_module_css___default.a.grid
  }, !mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("aside", {
    className: __WEBPACK_IMPORTED_MODULE_17__styles_module_css___default.a.aside
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_search_plans_table_SpecialistBlock__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_filter__["a" /* Filters */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: __WEBPACK_IMPORTED_MODULE_17__styles_module_css___default.a.plansTable
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__v2_search_components_plansTable__["a" /* default */], null), mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_filter_components_FloatingFilter__["a" /* FloatingFilter */], null)), props.comparisonPlans.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_search_comparison_bar_ComparisonBar_module__["a" /* default */], null), props.isModalQuotationDateWarningActive && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__["a" /* default */], null), props.isModalQuotationDateYearActive && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_year_ModalQuotationDateYear__["a" /* default */], null), props.isModalWithoutTrackerActive && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_modal_without_tracker_ModalWithoutTracker__["a" /* default */], {
    isModalWithoutTrackerActive: props.isModalWithoutTrackerActive,
    prospect: props.modalProspect,
    modalProspectAvaliable: props.modalProspectAvaliable,
    setInfosModalProspect: props.setInfosModalProspect,
    trackerModalValidatorHandlerBlur: props.trackerModalValidatorHandlerBlur,
    coupon: props.coupon,
    redirectToTracker: function redirectToTracker(cupom) {
      props.validateTrackerModalRedirect(props.match.params.destination, props.match.params.begin_date, props.match.params.end_date, cupom);
    }
  }), props.isModalUpsellActive && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_V2_upsell__["a" /* default */], null)));
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    comparisonPlans: state.search.comparisonPlans,
    userDetails: state.search.userDetails,
    coupon: state.purchase.coupon,
    mobile: state.mobile.mobileActive,
    isModalWithoutTrackerActive: state.search.isModalWithoutTrackerActive,
    isModalQuotationDateWarningActive: state.search.isModalQuotationDateWarningActive,
    isModalQuotationDateYearActive: state.search.isModalQuotationDateYearActive,
    isModalFilterCategoryActive: state.search.isModalFilterCategoryActive,
    isModalUpsellActive: state.search.isModalUpsellActive,
    modalProspect: state.search.modalProspect,
    modalProspectAvaliable: state.search.modalProspectAvaliable,
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    ecommerce_settings: state.search.ecommerce_settings,
    providers: state.global.providers,
    destinations: state.global.destinations
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  searchEcommerceSettings: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["s" /* searchEcommerceSettings */],
  searchProviderSettings: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["t" /* searchProviderSettings */],
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["r" /* removeComparisonPlan */],
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["w" /* setQuotationParams */],
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["n" /* openModalQuotationDateWarning */],
  openModalQuotationDateYear: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["o" /* openModalQuotationDateYear */],
  openModalWithoutTracker: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["q" /* openModalWithoutTracker */],
  closeModalFilterCategory: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["e" /* closeModalFilterCategory */],
  setInfosModalProspect: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["u" /* setInfosModalProspect */],
  trackerModalValidatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["C" /* trackerModalValidatorHandlerBlur */],
  validateTrackerModalRedirect: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["E" /* validateTrackerModalRedirect */],
  applyFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["b" /* applyFilterCategories */],
  clearFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["d" /* clearFilterCategories */]
})(Search));

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_V2_input__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_Pin_icon__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_hooks_useSearchBarCommon__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_V2_dropdown__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_V2_datepicker__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_search_searchbar_SearchIcon__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__ = __webpack_require__(23);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
















var SearchBarDesktop = function SearchBarDesktop(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      startDate: null,
      endDate: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    destinationDropdownOpen = _useState4[0],
    setDestinationDropdownOpen = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDatepickerOpen = _useState6[0],
    setIsDatepickerOpen = _useState6[1];
  var dateInputsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var datepickerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useSearchBarCommon = Object(__WEBPACK_IMPORTED_MODULE_9__search_hooks_useSearchBarCommon__["a" /* useSearchBarCommon */])(props.destinations),
    containerRef = _useSearchBarCommon.containerRef,
    isScrolled = _useSearchBarCommon.isScrolled,
    containerHeight = _useSearchBarCommon.containerHeight,
    computedDestinationName = _useSearchBarCommon.computedDestinationName,
    beginBr = _useSearchBarCommon.beginBr,
    endBr = _useSearchBarCommon.endBr,
    permanence = _useSearchBarCommon.permanence;
  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState8 = _slicedToArray(_useState7, 2),
    userDestinationSlug = _useState8[0],
    setUserDestinationSlug = _useState8[1];
  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState0 = _slicedToArray(_useState9, 2),
    userBeginBr = _useState0[0],
    setUserBeginBr = _useState0[1];
  var _useState1 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState10 = _slicedToArray(_useState1, 2),
    userEndBr = _useState10[0],
    setUserEndBr = _useState10[1];
  var handleOpenDatepicker = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
    if (datepickerRef.current && e && datepickerRef.current.contains(e.target)) return;
    if (!isDatepickerOpen) {
      var beginBrValue = userBeginBr != null ? userBeginBr : beginBr || '';
      var endBrValue = userEndBr != null ? userEndBr : endBr || '';
      var start = Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["c" /* parseDateBrToDate */])(beginBrValue);
      var end = Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["c" /* parseDateBrToDate */])(endBrValue);
      setRange({
        startDate: start,
        endDate: end
      });
    }
    setIsDatepickerOpen(function (prev) {
      return !prev;
    });
  }, [isDatepickerOpen, userBeginBr, userEndBr, beginBr, endBr]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!isDatepickerOpen) return undefined;
    var onDocMouseDown = function onDocMouseDown(e) {
      if (!dateInputsRef.current) return;
      if (!dateInputsRef.current.contains(e.target)) {
        setIsDatepickerOpen(false);
      }
    };
    var onKeyDown = function onKeyDown(e) {
      if (e.key === 'Escape') setIsDatepickerOpen(false);
    };
    document.addEventListener('mousedown', onDocMouseDown);
    document.addEventListener('keydown', onKeyDown);
    return function () {
      document.removeEventListener('mousedown', onDocMouseDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [isDatepickerOpen]);
  var searchPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    var _parseSearchFromPath = Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["d" /* parseSearchFromPath */])(),
      pathDestSlug = _parseSearchFromPath.destinationSlug,
      pathBegin = _parseSearchFromPath.beginDate,
      pathEnd = _parseSearchFromPath.endDate;
    var beginISO = range.startDate ? Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["e" /* toISO */])(range.startDate) : pathBegin || '';
    var endISO = range.endDate ? Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["e" /* toISO */])(range.endDate) : pathEnd || '';
    var destination = userDestinationSlug || pathDestSlug;
    var isValidISO = function isValidISO(s) {
      return /^(\d{4})-(\d{2})-(\d{2})$/.test(s || '');
    };
    if (!isValidISO(beginISO) || !isValidISO(endISO) || !destination) {
      return;
    }
    if (props.cleanComparisonPlans) props.cleanComparisonPlans();
    var search = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["buildSearchWithDestinationCategories"])(props.destinations, destination);
    var path = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatURL"])(props.match && props.match.params ? props.match.params : {}, "/pesquisa/".concat(destination, "/").concat(beginISO, "/").concat(endISO), search, !search);
    if (props.history && props.history.push) props.history.push(path);
    var diffDays = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["getDaysDiff"])(new Date(beginISO), new Date(endISO));
    __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].raw({
      event: 'envio_form_cotacao',
      page_category: 'home',
      tipo_envio: 'novo_lead',
      cotacao: {
        destino: destination,
        data_embarque: beginISO,
        data_desembarque: endISO,
        tempo_permanencia: !Number.isNaN(diffDays) ? diffDays : undefined
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].searchSubmitted(destination, beginISO, endISO);
  }, [userDestinationSlug, range.startDate, range.endDate]);
  var displayedDestinationName = function () {
    if (userDestinationSlug) {
      var found = (props.destinations || []).find(function (d) {
        return d.slug === userDestinationSlug;
      });
      return found ? found.name : '';
    }
    return computedDestinationName || '';
  }();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, isScrolled && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      height: containerHeight
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: containerRef,
    className: [__WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.container, isScrolled ? __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.fixed : '', isScrolled ? __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.scrolled : ''].filter(Boolean).join(' ')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.content
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationInput
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Pin_icon__["a" /* PinIcon */], null),
    label: "Destino:",
    value: displayedDestinationName,
    onClick: function onClick() {
      return setDestinationDropdownOpen(!destinationDropdownOpen);
    },
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.input,
    disabled: props.isLoading,
    rightIcon: destinationDropdownOpen ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
      size: 24,
      color: "#007E47",
      rotate: 270
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
      size: 24,
      color: "#007E47",
      rotate: 90
    })
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_V2_dropdown__["a" /* default */], {
    isOpen: destinationDropdownOpen,
    onClose: function onClose() {
      return setDestinationDropdownOpen(false);
    }
  }, props.destinations && props.destinations.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationList
  }, props.destinations.map(function (d) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: d.id,
      className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationItem,
      onClick: function onClick() {
        setUserDestinationSlug(d.slug);
        setDestinationDropdownOpen(false);
      }
    }, d.name, (d.slug === 'brasil' || d.slug === 'receptivo') && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.description
    }, d.slug === 'brasil' ? 'Para viagens dentro do Brasil' : 'Para quem vem visitar o Brasil'));
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.dateInputs,
    ref: dateInputsRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.dateRow,
    onClick: handleOpenDatepicker
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], null),
    label: "Embarque no Brasil:",
    value: userBeginBr != null ? userBeginBr : beginBr || '',
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.input
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.separator
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], null),
    label: "Desembarque no Brasil:",
    value: userEndBr != null ? userEndBr : endBr || '',
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.input
  })), isDatepickerOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: datepickerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_V2_datepicker__["a" /* default */], {
    selectionMode: "range",
    value: range,
    onChange: function onChange(sel) {
      return setRange(sel);
    },
    onComplete: function onComplete(sel) {
      setUserBeginBr(Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["b" /* formatDateBrFromDate */])(sel.startDate));
      setUserEndBr(Object(__WEBPACK_IMPORTED_MODULE_10__search_utils_searchParsing__["b" /* formatDateBrFromDate */])(sel.endDate));
      setIsDatepickerOpen(false); // fecha ao selecionar as datas
    },
    minDate: new Date(),
    weekStartsOn: 7 // semana iniciando na segunda
    ,
    numberOfMonths: 2,
    locale: "pt-BR",
    allowSameDay: true
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.permanence
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.permanenceRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.permanenceLabel
  }, "Perman\xEAncia:")), permanence), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.searchButton,
    type: "button",
    onClick: searchPlan
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_search_searchbar_SearchIcon__["a" /* default */], null)))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    destinations: state.global.destinations
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["w" /* setQuotationParams */],
  cleanComparisonPlans: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["c" /* cleanComparisonPlans */]
})(SearchBarDesktop)));

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"v2-input":"_1Dm6d","v2-input--column":"SdFxH","v2-input--disabled":"dG7Og","v2-input__icon":"_22sWV","v2-input__texts":"_1pTzx","v2-input__label":"_1Eo1j","v2-input__value":"_107cE","v2-input__right-icon":"_34PIg"};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"kmb8m","scrolled":"_2VrXw","fixed":"_22Pl7","content":"_1B3uF","dateInputs":"_12N5Q","dateRow":"FSouO","separator":"_3-4zp","destinationInput":"_2l8G2","destinationList":"_3Jfkz","destinationItem":"_1r84U","description":"_1VXEE","searchButton":"_2oDWG","permanence":"_3cIxm","permanenceRow":"_17ZE1","permanenceLabel":"_3u-5X","input":"_10szH"};

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"_1PbK8","open":"_26dpm"};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"datepicker":"_2tyS3","inline":"_1HAX0","header":"_1KFwl","nav":"_1-F5D","monthLabels":"_23Nfm","monthLabel":"YHcrd","monthYear":"DDRZC","body":"_3GSLm","month":"_6PZe_","weekdays":"_3D2Sh","weekday":"_1BPGk","week":"_2-dqk","placeholder":"_3kMob","day":"TS5ZD","outside":"xRYqA","today":"_1D5wz","disabled":"_1qNFW","inRange":"-N31w","start":"_3uhOF","end":"wjN4U"};

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_search_plans_table_HighligthPlans__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_module_css__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orderPlanDropdown__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plan__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_search_plans_table_SpecialistBlock__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_search_plans_table_Filters_ActiveFilters__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__skeleton__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
















var PlansTable = function PlansTable(props) {
  var selectedPlans = (props.comparisonPlans || []).map(function (plan) {
    return plan.code;
  });
  var processHighlightPlans = function processHighlightPlans(plans) {
    return plans.map(function (plan) {
      var priceWithDiscount = Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["a" /* calcCouponDiscount */])(plan, props.coupon);
      var finalPrice = priceWithDiscount || plan.price.adult.price;
      return _objectSpread(_objectSpread({}, plan), {}, {
        price_with_coupon_discount: priceWithDiscount,
        parcels: Object(__WEBPACK_IMPORTED_MODULE_7__utils_plan__["g" /* maxValueParcel */])(finalPrice)
      });
    });
  };
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    var loadHighlightPlans = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var highlightPlans, processedPlans, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["fetchHighlightPlans"])(props.match.params);
            case 1:
              highlightPlans = _context.v;
              processedPlans = processHighlightPlans(highlightPlans);
              props.storeHighligthPlans(processedPlans);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('[PlansTable V2] Error fetching highlight plans:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function loadHighlightPlans() {
        return _ref.apply(this, arguments);
      };
    }();
    loadHighlightPlans();
  }, [props.match && props.match.params && props.match.params.destination, props.match && props.match.params && props.match.params.begin_date, props.match && props.match.params && props.match.params.end_date]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (props.highlightPlans.length > 0) {
      var processedPlans = processHighlightPlans(props.highlightPlans);
      props.storeHighligthPlans(processedPlans);
    }
  }, [props.coupon]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    props.setQuotationParams({
      destination: props.match.params.destination,
      begin_date: props.match.params.begin_date,
      end_date: props.match.params.end_date,
      context: 'search',
      benefits: ['51', '42', '57', '55', '45', '56', '5', '68', '69']
    });
  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (props.providers && props.providers.length > 0) {
      if (props.searchProviderSettings) {
        props.searchProviderSettings(props.providers);
      }
      try {
        var search = props.location ? props.location.search : window.location.search;
        var params = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["getFilterSearchUrl"])(search || '');
        Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["getCategory"])(params);
      } catch (e) {
        console.error('[PlansTable V2] Erro ao aplicar filtros da URL:', e);
      }
    }
  }, [props.providers, props.location && props.location.search]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    var _ref2 = props.match.params || {},
      destination = _ref2.destination;
    if (destination) {
      if (window._paq) {
        window._paq.push(['setEcommerceView', false, false, destination]);
      }
      __WEBPACK_IMPORTED_MODULE_14__utils_matomo__["a" /* default */].trackPageView("Pesquisa: ".concat(destination));
      __WEBPACK_IMPORTED_MODULE_15__utils_dataLayer__["a" /* default */].pageView('search_results', "Pesquisa: ".concat(destination));
    }
  }, [props.match && props.match.params && props.match.params.destination]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    var _ref3 = props.match.params || {},
      destination = _ref3.destination;
    if (props.filtered_plans && props.filtered_plans.length > 0 && destination) {
      __WEBPACK_IMPORTED_MODULE_15__utils_dataLayer__["a" /* default */].viewItemList(props.filtered_plans, destination);
    }
  }, [props.filtered_plans && props.filtered_plans.length, props.match && props.match.params && props.match.params.destination]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.container
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_search_plans_table_HighligthPlans__["a" /* default */], {
    mobile: props.mobile,
    providers: props.providers,
    match: props.match,
    selectedPlans: selectedPlans,
    addComparisonPlan: props.addComparisonPlan,
    removeComparisonPlan: props.removeComparisonPlan,
    userDetails: props.userDetails,
    plans: props.highlightPlans,
    variant: "V2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.plansContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.plansHeader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.plansHeaderText
  }, props.loading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.loadingText
  }, "Buscando seguros viagem...") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Encontramos ", props.filtered_plans && props.filtered_plans.length || 0, " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "seguros viagem")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Escolhemos os melhores planos para sua viagem de acordo com seu destino e tempo de perman\xEAncia."))), !props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__orderPlanDropdown__["a" /* default */], null)), props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_search_plans_table_Filters_ActiveFilters__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.plansList, " ").concat(props.showSpecialistSuggestions ? __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.withSuggestions : '')
  }, props.loading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__skeleton__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__skeleton__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__skeleton__["a" /* default */], null)) : props.mobile ? function () {
    var list = props.filtered_plans || [];
    if (list.length === 0) return null;
    var _list = _toArray(list),
      first = _list[0],
      rest = _arrayLikeToArray(_list).slice(1);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plan__["a" /* default */], {
      key: first.code || 'plan-0',
      plan: first,
      match: props.match
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_search_plans_table_SpecialistBlock__["a" /* default */], null), rest.map(function (plan, idx) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plan__["a" /* default */], {
        key: plan.code || "plan-".concat(idx + 1),
        plan: plan,
        match: props.match
      });
    }));
  }() : (props.filtered_plans || []).map(function (plan, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plan__["a" /* default */], {
      key: plan.code || index,
      plan: plan,
      match: props.match
    });
  }), props.filtered_plans && props.filtered_plans.length === 0 && !props.loading && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_8__styles_module_css___default.a.noPlansFound
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Ops!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "N\xE3o h\xE1 planos com a combina\xE7\xE3o de filtro selecionada para esta ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " viagem, tente outra combina\xE7\xE3o.")))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    loading: state.search.loading,
    end_date: state.search.end_date,
    providers: state.global.providers,
    begin_date: state.search.begin_date,
    destination: state.search.destination,
    sortOptions: state.search.sortOptions,
    sort_option: state.search.sort_option,
    filtered_plans: state.search.filtered_plans,
    suggestions_plans: state.search.suggestions_plans,
    comparisonPlans: state.search.comparisonPlans,
    searchState: state.search.searchState,
    mobile: state.mobile.mobileActive,
    userDetails: state.search.userDetails,
    providerOption: state.search.provider_option,
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    highlightPlans: state.search.highlightPlans,
    benefits: state.purchase.benefits,
    coupon: state.purchase.coupon,
    showSpecialistSuggestions: state.search.showSpecialistSuggestions
  };
}, {
  storeHighligthPlans: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["A" /* storeHighligthPlans */],
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["r" /* removeComparisonPlan */],
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["w" /* setQuotationParams */],
  searchProviderSettings: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["t" /* searchProviderSettings */]
})(PlansTable)));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Tags__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_module_css__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }












// TODO: add the code of the tag of the highlight
var codeTagHighlight = '71';
var ShowUpPlan = function ShowUpPlan(_ref) {
  var plan = _ref.plan,
    isSelected = _ref.isSelected,
    basePath = _ref.basePath,
    match = _ref.match,
    userDetails = _ref.userDetails,
    providerImgPath = _ref.providerImgPath,
    openModalQuotationDateWarning = _ref.openModalQuotationDateWarning,
    addComparisonPlan = _ref.addComparisonPlan,
    removeComparisonPlan = _ref.removeComparisonPlan,
    paymentMethods = _ref.paymentMethods,
    coupon = _ref.coupon,
    variant = _ref.variant,
    openModalUpsell = _ref.openModalUpsell,
    setUpsellPlans = _ref.setUpsellPlans,
    setUpsellSourceTags = _ref.setUpsellSourceTags;
  var upsellPlanRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var upsellFetchedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (plan.upsell_product_id == null || upsellFetchedRef.current) return;
    upsellFetchedRef.current = true;
    var _match$params = match.params,
      destination = _match$params.destination,
      begin_date = _match$params.begin_date,
      end_date = _match$params.end_date;
    Object(__WEBPACK_IMPORTED_MODULE_7__apiCalls__["fetchUpsellPlan"])({
      begin_date: begin_date,
      end_date: end_date,
      destination: destination,
      product_code: plan.upsell_product_id
    }).then(function (data) {
      upsellPlanRef.current = data;
    });
  }, [plan.upsell_product_id, match.params]);
  var pixDiscountMultiplier = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (paymentMethods && paymentMethods.length > 0) {
      var pixPayment = paymentMethods.find(function (method) {
        return method.slug === 'pix';
      });
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);
  var selectPlan = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var tags, productPurchaseUrl, upsellPlanData, _match$params2, destination, begin_date, end_date, normalizedPlan;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_plan__["i" /* sendToRDStation */])();
            tags = [codeTagHighlight];
            productPurchaseUrl = Object(__WEBPACK_IMPORTED_MODULE_6__utils_plan__["e" /* insertTagPurchaseUrl */])(Object(__WEBPACK_IMPORTED_MODULE_6__utils_plan__["c" /* getProductPurchaseUrl */])(match, plan.code), tags.join(','));
            if (!(plan.upsell_product_id != null)) {
              _context.n = 3;
              break;
            }
            upsellPlanData = upsellPlanRef.current;
            if (upsellPlanData) {
              _context.n = 2;
              break;
            }
            _match$params2 = match.params, destination = _match$params2.destination, begin_date = _match$params2.begin_date, end_date = _match$params2.end_date;
            _context.n = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_7__apiCalls__["fetchUpsellPlan"])({
              begin_date: begin_date,
              end_date: end_date,
              destination: destination,
              product_code: plan.upsell_product_id
            });
          case 1:
            upsellPlanData = _context.v;
          case 2:
            if (!(upsellPlanData && upsellPlanData.code)) {
              _context.n = 3;
              break;
            }
            normalizedPlan = _objectSpread(_objectSpread({}, plan), {}, {
              adult: plan.adult || plan.price && plan.price.adult
            });
            setUpsellSourceTags([codeTagHighlight]);
            setUpsellPlans([normalizedPlan, upsellPlanData]);
            return _context.a(2, openModalUpsell());
          case 3:
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_plan__["h" /* selectPlanAndRedirect */])(productPurchaseUrl);
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function selectPlan() {
      return _ref2.apply(this, arguments);
    };
  }();
  var tag = null;
  var productUrl = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatURL"])(match.params, "".concat(basePath, "/").concat(plan.code, "/").concat(match.params.destination, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["cleanDate"])(match.params.begin_date), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["cleanDate"])(match.params.end_date), "/"));
  var benefitsBaggage = plan.benefits.filter(function (benefit) {
    return benefit.code === '42' || benefit.code === 42;
  })[0];
  var benefitsHospital = plan.benefits.filter(function (benefit) {
    return benefit.code === '51' || benefit.code === 51;
  })[0];
  var priceWithCouponDiscount = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils__["getProductDiscount"])(plan.price.adult.price, plan.code, coupon);
  }, [coupon, plan.code, plan.price.adult.price]);
  var price = priceWithCouponDiscount || plan.price.adult.price;
  var parcels = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6__utils_plan__["g" /* maxValueParcel */])(price) || 1;
  }, [price]);
  var isV2 = (variant || '').toString().toUpperCase() === 'V2';
  var formatBenefitsCoverage = function formatBenefitsCoverage(benefit) {
    if (!isV2) return benefit;
    var match = benefit.match(/[\d.,]+/);
    return "$ " + match[0];
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? "".concat(__WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.showUpPlanV2, " ").concat(isSelected ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.selected : '', " ").concat(plan.priority !== 0 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.secondary : __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.primary) : "show-up-plan".concat(isSelected ? ' selecionado' : '').concat(plan.priority !== 0 ? ' secondary' : ' primary'),
    "data-variant": isV2 ? 'V2' : undefined
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "triangle-topleft".concat(isSelected ? '' : ' hide')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "selecionado-ico",
    src: "/assets/images/selecionado-ico.svg",
    alt: "Selecionado"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: tag,
    isMobile: false
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: tag,
    isMobile: true
  }), isV2 && priceWithCouponDiscount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: true,
    customClassName: isV2 ? '' : 'search-applied-coupon-v1'
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: false,
    customClassName: isV2 ? '' : 'search-applied-coupon-v1'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.headerV2 : 'header'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.image : 'image'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    onClick: selectPlan,
    src: providerImgPath,
    alt: ""
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.planName : ''
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    onClick: selectPlan
  }, plan.name))), !isV2 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-footer-plan"
  }, priceWithCouponDiscount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: true,
    customClassName: "search-applied-coupon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_4__common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: false,
    customClassName: "search-applied-coupon"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "old-price"
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(plan.price.adult.price))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "price"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "price-pix"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(price * pixDiscountMultiplier)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "price-person"
  }, "/ Por pessoa no PIX")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "price-atually"
  }, "ou R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(price), " em at\xE9 ", parcels, "x sem juros no cart\xE3o"))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.price
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    children: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.flexColumn
  }, priceWithCouponDiscount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.oldPrice
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(plan.price.adult.price)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.pricePix
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(price * pixDiscountMultiplier)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.pricePerson
  }, "/ pre\xE7o por pessoa"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.priceAtually
  }, "ou R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(price), " at\xE9 ", parcels, "x s/juros no cart\xE3o")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.benefits : 'benefits'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.planInfo : 'plan-info'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Despesa M\xE9dica Hospitalar"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.planBenefitValue : 'plan-info-benefit'
  }, formatBenefitsCoverage(benefitsHospital.coverage))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.planInfo : 'plan-info'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Seguro bagagem"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.planBenefitValue : 'plan-info-benefit'
  }, formatBenefitsCoverage(benefitsBaggage.coverage))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.roofLink : 'link'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], {
    to: productUrl,
    className: "url-roof"
  }, "Ver a cobertura completa"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.selectButton : 'select-button',
    onClick: selectPlan
  }, "Selecionar seguro"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "compare-button".concat(plan.code),
    className: isV2 ? __WEBPACK_IMPORTED_MODULE_9__styles_module_css___default.a.compareButton : 'compare-button'
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    name: "",
    type: "checkbox",
    defaultChecked: isSelected,
    id: "compare-button".concat(plan.code),
    onClick: function onClick() {
      if (isSelected) {
        removeComparisonPlan(plan.code);
      } else {
        addComparisonPlan(_objectSpread({}, plan));
      }
    }
  }), "Comparar Plano"));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods,
    coupon: state.purchase.coupon
  };
}, {
  openModalUpsell: __WEBPACK_IMPORTED_MODULE_8__actions_searchActions__["p" /* openModalUpsell */],
  setUpsellPlans: __WEBPACK_IMPORTED_MODULE_8__actions_searchActions__["y" /* setUpsellPlans */],
  setUpsellSourceTags: __WEBPACK_IMPORTED_MODULE_8__actions_searchActions__["z" /* setUpsellSourceTags */]
})(ShowUpPlan));

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1fCSh","plansContainer":"_2BZMz","plansHeader":"_2lLQc","plansHeaderText":"_3lZIq","plansList":"_24lxm","withSuggestions":"_2r8zJ","noPlansFound":"_1-BzL","loadingText":"_1bH84"};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_ChevronRight_icon__ = __webpack_require__(23);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }






var OrderPlanDropdown = function OrderPlanDropdown(_ref) {
  var sortOptions = _ref.sortOptions,
    sort_option = _ref.sort_option,
    setSortOption = _ref.setSortOption;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var buttonRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var handleToggle = function handleToggle() {
    setIsOpened(!isOpened);
  };
  var selectedSortOptionObj = sortOptions.find(function (sort) {
    return sort.name === sort_option;
  });
  var selectedSortOption = selectedSortOptionObj ? selectedSortOptionObj.displayName : '';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.filterDropdown,
    "data-cy": "filtro-ordenar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
    ref: buttonRef,
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.btnFilter,
    onClick: handleToggle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, selectedSortOption)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
    size: 24,
    rotate: isOpened ? 270 : 90
  })), isOpened && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.dropdownMenu,
    onClick: handleToggle
  }, sortOptions.map(function (option, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
      key: index,
      className: "".concat(__WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.dropdownItem, " ").concat(option.name === sort_option ? __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.active : ''),
      onClick: function onClick() {
        return setSortOption(option.name);
      }
    }, option.displayName);
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    sortOptions: state.search.sortOptions,
    sort_option: state.search.sort_option,
    searchState: state.search.searchState
  };
}, {
  setSortOption: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["x" /* setSortOption */]
})(OrderPlanDropdown)));

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"filterDropdown":"TUtRU","btnFilter":"_3PG2d","dropdownMenu":"qiD6O","dropdownItem":"_395KK"};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Tags__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_Tags_defaultTags__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_search_plans_table_PixDiscountTag__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Tooltip__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_Tooltip_icon__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_SalaVip_icon__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_icons_ChipInternacional_icon__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_css__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__styles_module_css__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


















var codeTagSpecialistIndicator = '70';
var codeTagPromotionalDestination = '83';
var benefitCodeSalaVip = '68';
var benefitCodeChipInternacional = '69';
var Plan = function Plan(_ref) {
  var match = _ref.match,
    plan = _ref.plan,
    paymentMethods = _ref.paymentMethods,
    showSpecialistSuggestions = _ref.showSpecialistSuggestions,
    mobile = _ref.mobile,
    providers = _ref.providers,
    coupon = _ref.coupon,
    addComparisonPlan = _ref.addComparisonPlan,
    removeComparisonPlan = _ref.removeComparisonPlan,
    openModalUpsell = _ref.openModalUpsell,
    setUpsellPlans = _ref.setUpsellPlans,
    _ref$comparisonPlans = _ref.comparisonPlans,
    comparisonPlans = _ref$comparisonPlans === void 0 ? [] : _ref$comparisonPlans,
    destinations = _ref.destinations;
  var upsellPlanRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);
  var upsellFetchedRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(false);
  var hoverTimerRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);
  var handleMouseEnter = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function () {
    hoverTimerRef.current = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__["a" /* default */].viewItem(plan);
    }, 500);
  }, [plan]);
  var handleMouseLeave = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function () {
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }
  }, []);
  var productUrl = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["b" /* getProductPlanUrl */])(match, plan.code);
  }, [match, plan.code]);
  var productPurchaseUrl = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["c" /* getProductPurchaseUrl */])(match, plan.code);
  }, [match, plan.code]);
  var pixDiscountMultiplier = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    if (paymentMethods && paymentMethods.length > 0) {
      var pixPayment = paymentMethods.find(function (method) {
        return method.slug === 'pix';
      });
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);
  var basePrice = plan.adult.price;
  var priceWithCouponDiscount = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["getProductDiscount"])(basePrice, plan.code, coupon);
  }, [coupon, basePrice, plan.code]);
  var finalPrice = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return priceWithCouponDiscount || plan.price_with_coupon_discount || basePrice;
  }, [priceWithCouponDiscount, plan.price_with_coupon_discount, basePrice]);
  var parcels = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["g" /* maxValueParcel */])(finalPrice) || 1;
  }, [finalPrice]);
  var selectPlan = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["i" /* sendToRDStation */])();
    var tags = [];
    if (plan.extra.specialist_indicator && showSpecialistSuggestions) {
      tags.push(codeTagSpecialistIndicator);
    }
    var foundDestination = destinations.find(function (destination) {
      return destination.slug === match.params.destination;
    });
    if (foundDestination && foundDestination.promotional) {
      tags.push(codeTagPromotionalDestination);
    }
    Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["h" /* selectPlanAndRedirect */])(Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["e" /* insertTagPurchaseUrl */])(productPurchaseUrl, tags));
  }, [plan, match, destinations, showSpecialistSuggestions, productPurchaseUrl, __WEBPACK_IMPORTED_MODULE_8__utils_plan__["h" /* selectPlanAndRedirect */], __WEBPACK_IMPORTED_MODULE_8__utils_plan__["e" /* insertTagPurchaseUrl */]]);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    if (plan.upsell_product_id == null || upsellFetchedRef.current) return;
    upsellFetchedRef.current = true;
    var _match$params = match.params,
      destination = _match$params.destination,
      begin_date = _match$params.begin_date,
      end_date = _match$params.end_date;
    Object(__WEBPACK_IMPORTED_MODULE_7__apiCalls__["fetchUpsellPlan"])({
      begin_date: begin_date,
      end_date: end_date,
      destination: destination,
      product_code: plan.upsell_product_id
    }).then(function (data) {
      upsellPlanRef.current = data;
    });
  }, [plan.upsell_product_id, match.params]);
  var checkUpsellIsAvailable = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useCallback"])(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var upsellPlanData, _match$params2, destination, begin_date, end_date;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(plan.upsell_product_id != null)) {
            _context.n = 3;
            break;
          }
          upsellPlanData = upsellPlanRef.current;
          if (upsellPlanData) {
            _context.n = 2;
            break;
          }
          _match$params2 = match.params, destination = _match$params2.destination, begin_date = _match$params2.begin_date, end_date = _match$params2.end_date;
          _context.n = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_7__apiCalls__["fetchUpsellPlan"])({
            begin_date: begin_date,
            end_date: end_date,
            destination: destination,
            product_code: plan.upsell_product_id
          });
        case 1:
          upsellPlanData = _context.v;
        case 2:
          if (!(upsellPlanData && upsellPlanData.code)) {
            _context.n = 3;
            break;
          }
          setUpsellPlans([plan, upsellPlanData]);
          return _context.a(2, openModalUpsell());
        case 3:
          return _context.a(2, selectPlan());
      }
    }, _callee);
  })), [plan, match.params, setUpsellPlans, openModalUpsell]);
  var provider = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return providers.find(function (provider) {
      return provider.code === plan.provider_code;
    });
  }, [providers, plan.provider_code]);
  var providerImgPath = provider ? "/assets/images/seguradoras/".concat(provider.slug, ".png") : '';
  var benefits = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    var baggage = plan.benefits.find(function (benefit) {
      return benefit.code === '42' || benefit.code === 42;
    });
    var hospital = plan.benefits.find(function (benefit) {
      return benefit.code === '51' || benefit.code === 51;
    });
    var medicament = plan.benefits.find(function (benefit) {
      return benefit.code === '5' || benefit.code === 5;
    });
    var telemedicine = plan.benefits.find(function (benefit) {
      return benefit.code === '56' || benefit.code === 56;
    });
    return {
      baggage: baggage,
      hospital: hospital,
      medicament: medicament,
      telemedicine: telemedicine
    };
  }, [plan.benefits]);
  var hasSalaVip = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["d" /* hasBenefitCode */])(plan, benefitCodeSalaVip);
  }, [plan.benefits]);
  var hasChipInternacional = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_plan__["d" /* hasBenefitCode */])(plan, benefitCodeChipInternacional);
  }, [plan.benefits]);
  var hasSingleHighlight = hasSalaVip !== hasChipInternacional;
  var tag = Object(__WEBPACK_IMPORTED_MODULE_4__components_common_Tags__["b" /* getTag */])(plan);
  var isSpecialist = plan.extra.specialist_indicator && showSpecialistSuggestions;
  var isSelected = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useMemo"])(function () {
    return (comparisonPlans || []).some(function (p) {
      return p && String(p.code) === String(plan.code);
    });
  }, [comparisonPlans, plan.code]);
  var formatBenefitsCoverage = function formatBenefitsCoverage(benefitCoverage) {
    if (!benefitCoverage || typeof benefitCoverage !== 'string') return 'Não';
    var match = benefitCoverage.match(/[\d.,]+/);
    if (!match || !match[0]) return 'Não';
    return "$ ".concat(match[0]);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planGrid + (isSpecialist ? " ".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.specialistPlan) : '') + (isSelected ? " ".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.selected) : ''),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.specialistBox, " ").concat(isSpecialist ? '' : __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.hide)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    role: "img",
    "aria-label": "Recomenda\xE7\xE3o do especialista"
  }, "\uD83D\uDC68\u200D\uD83D\uDCBB"), ' ', "Recomenda\xE7\xE3o do especialista"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.triangleTopleft, " ").concat(isSelected ? '' : __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.hide)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.selecionadoIco,
    src: "/assets/images/selecionado-ico.svg",
    alt: "Selecionado"
  })), !mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planHeader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.col1
  }, "Plano e benef\xEDcios"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.col2
  }, "Total por segurado")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planContent
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.col1
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planInfo
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_Tags__["a" /* default */], {
    tag: tag,
    isMobile: true
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_Tags__["a" /* default */], {
    tag: tag
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planNameContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planNameRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.image
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
    src: providerImgPath,
    alt: ""
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planName
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, plan.name), !mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planDetails
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.detailItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Faixa et\xE1ria: ", plan.child.min_age, " a ", plan.elder.max_age, " anos")), plan.elder.max_age !== plan.adult.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planDetailsSeparator
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.detailItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Maiores de ", plan.elder.min_age, " anos: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "R$ ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["formatPrice"])(plan.elder.price))))))))), mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planAgeDetails
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Faixa et\xE1ria: ", plan.child.min_age, " a ", plan.adult.max_age, " anos"), plan.elder.max_age !== plan.adult.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Maiores de ", plan.elder.min_age, " anos: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "R$ ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["formatPrice"])(plan.elder.price)))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.benefits
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.group
  }, hasSalaVip ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightItem, " ").concat(hasSingleHighlight ? __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightItemAligned : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.withTooltip
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightLabel
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__assets_icons_SalaVip_icon__["a" /* SalaVipIcon */], {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightIcon
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Acesso a ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "Sala VIP"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Tooltip__["a" /* default */], {
    content: "Espere seu voo em salas VIP de aeroportos: poltronas, wi-fi, comida e bebida inclusos, sem precisar de cart\xE3o premium."
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], {
    color: "#5A539C"
  })))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.benefitItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, "Despesa M\xE9dica Hospitalar"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, benefits.hospital && formatBenefitsCoverage(benefits.hospital.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.benefitItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, "Reembolso de medicamentos"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, benefits.medicament && formatBenefitsCoverage(benefits.medicament.coverage) || 'Não'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.group
  }, hasChipInternacional ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightItem, " ").concat(hasSingleHighlight ? __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightItemAligned : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.withTooltip
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightLabel
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__assets_icons_ChipInternacional_icon__["a" /* ChipInternacionalIcon */], {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.highlightIcon
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "Inclui ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "Chip Internacional"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Tooltip__["a" /* default */], {
    content: "Chip com internet internacional para voc\xEA usar durante toda a viagem."
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], {
    color: "#5A539C"
  })))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.benefitItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, "Seguro de Bagagem Extraviada"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, benefits.baggage && formatBenefitsCoverage(benefits.baggage.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.benefitItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.withTooltip
  }, "Possui Telemedicina?", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Tooltip__["a" /* default */], {
    content: "\xC9 a cobertura para consultas m\xE9dicas realizadas \xE0 dist\xE2ncia, por videochamada ou telefone, para orienta\xE7\xE3o em casos de baixa complexidade."
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], null))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, benefits.telemedicine && benefits.telemedicine.coverage || 'Não')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.link
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], {
    to: productUrl,
    "data-cy": "link-ver-cobertura-completa"
  }, "Ver a cobertura completa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.col2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.planInfoPrice
  }, priceWithCouponDiscount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_5__components_common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: true,
    customClassName: "search-applied-coupon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_Tags__["a" /* default */], {
    tag: __WEBPACK_IMPORTED_MODULE_5__components_common_Tags_defaultTags__["a" /* AppliedCouponTag */],
    isMobile: false,
    customClassName: "search-applied-coupon"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.priceContainer
  }, priceWithCouponDiscount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.oldPrice
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_9__utils__["formatPrice"])(basePrice)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.priceCreditCard
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_9__utils__["formatPrice"])(finalPrice)), " ", parcels, "x sem juros no cart\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.pricePix
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.row
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_9__utils__["formatPrice"])(finalPrice * pixDiscountMultiplier)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_search_plans_table_PixDiscountTag__["a" /* default */], {
    color: "#292828"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", null, "/ por pessoa no PIX"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.buttons
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.selectPlanButton,
    onClick: checkUpsellIsAvailable,
    "data-cy": "btn-selecionar-plano"
  }, "Selecionar plano"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_15__styles_module_css___default.a.comparisonButton,
    onClick: function onClick() {
      if (isSelected) {
        removeComparisonPlan(plan.code);
      } else {
        addComparisonPlan(_objectSpread({}, plan));
      }
    },
    "data-cy": "btn-comparar-plano"
  }, "Comparar plano"))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods,
    showSpecialistSuggestions: state.search.showSpecialistSuggestions,
    mobile: state.mobile.mobileActive,
    providers: state.global.providers,
    coupon: state.purchase.coupon,
    comparisonPlans: state.search.comparisonPlans,
    destinations: state.global.destinations
  };
}, {
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["n" /* openModalQuotationDateWarning */],
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["r" /* removeComparisonPlan */],
  openModalUpsell: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["p" /* openModalUpsell */],
  setUpsellPlans: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["y" /* setUpsellPlans */]
})(Plan)));

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1t9-m","anchor":"_2Il9P","tooltip":"_1Kle6","tooltipInner":"_2GF15","arrow":"_1fHVZ"};

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"planGrid":"_2tIqY","specialistPlan":"_1SxHn","triangleTopleft":"_16HuN","selecionadoIco":"_1nvlt","hide":"_3WLBZ","selected":"bz2Fr","planHeader":"_1z1Ja","col1":"_2J_Tn","col2":"rLJTU","planContent":"_3zHu4","planInfo":"_2eIQK","planInfoPrice":"UOwPV","planNameRow":"_1xcxZ","image":"_2qI0k","planName":"MEAre","planDetails":"_3uZ_M","planDetailsSeparator":"_1xnmb","planAgeDetails":"_1sQ8O","benefits":"_3EYwU","group":"HKuDr","benefitItem":"_3Wu7B","link":"_1-iRe","oldPrice":"_188Md","priceContainer":"_3E4F6","priceCreditCard":"_2ZlIl","pricePix":"_1I64T","row":"jql3f","buttons":"_2eWcN","selectPlanButton":"_1B9PM","comparisonButton":"jzp2I","specialistBox":"_4xeI0","withTooltip":"_3OrZZ","highlightItem":"_3BV_d","highlightItemAligned":"_2dc7H","highlightLabel":"_2Ot8h"};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var PlanSkeleton = function PlanSkeleton() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '24px',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      gap: '24px',
      height: '250px',
      width: '100%',
      boxSizing: 'border-box',
      marginBottom: '24px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flex: '0 0 200px',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '60px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '80%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '60%',
      height: '16px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      gap: '24px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '20px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flex: '0 0 250px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '16px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '120px',
      height: '30px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '180px',
      height: '24px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '48px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px',
      marginTop: 'auto'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      width: '100%',
      height: '48px',
      backgroundColor: '#f0f0f0',
      borderRadius: '4px'
    }
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (PlanSkeleton);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_V2_input__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_Pin_icon__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hooks_useSearchBarCommon__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_V2_dropdown__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_V2_datepicker_mobile_fullscreen__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_search_searchbar_SearchIcon__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_icons_Close_icon__ = __webpack_require__(31);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

















var SearchBarMobile = function SearchBarMobile(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      startDate: null,
      endDate: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    destinationDropdownOpen = _useState4[0],
    setDestinationDropdownOpen = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMobileDatepickerOpen = _useState6[0],
    setIsMobileDatepickerOpen = _useState6[1];
  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('range'),
    _useState8 = _slicedToArray(_useState7, 2),
    datepickMode = _useState8[0],
    setDatepickMode = _useState8[1];
  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isInputSectionOpen = _useState0[0],
    setIsInputSectionOpen = _useState0[1];
  var _useSearchBarCommon = Object(__WEBPACK_IMPORTED_MODULE_9__hooks_useSearchBarCommon__["a" /* useSearchBarCommon */])(props.destinations),
    containerRef = _useSearchBarCommon.containerRef,
    isScrolled = _useSearchBarCommon.isScrolled,
    containerHeight = _useSearchBarCommon.containerHeight,
    computedDestinationName = _useSearchBarCommon.computedDestinationName,
    beginBr = _useSearchBarCommon.beginBr,
    endBr = _useSearchBarCommon.endBr,
    permanence = _useSearchBarCommon.permanence;
  var _useState1 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState10 = _slicedToArray(_useState1, 2),
    userDestinationSlug = _useState10[0],
    setUserDestinationSlug = _useState10[1];
  var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState12 = _slicedToArray(_useState11, 2),
    userBeginBr = _useState12[0],
    setUserBeginBr = _useState12[1];
  var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState14 = _slicedToArray(_useState13, 2),
    userEndBr = _useState14[0],
    setUserEndBr = _useState14[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var body = document.body;
    var lock = function lock() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      body.dataset.scrollY = String(scrollY);
      body.style.position = 'fixed';
      body.style.top = "-".concat(scrollY, "px");
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
    };
    var unlock = function unlock() {
      var y = parseInt(body.dataset.scrollY || '0', 10) || 0;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.overflow = '';
      delete body.dataset.scrollY;
      window.scrollTo(0, y);
    };
    if (isInputSectionOpen) {
      lock();
    } else if (body.style.position === 'fixed') {
      unlock();
    }
    return function () {
      if (body.style.position === 'fixed') {
        unlock();
      }
    };
  }, [isInputSectionOpen]);
  var openDatepickerFor = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (mode) {
    var beginBrValue = userBeginBr != null ? userBeginBr : beginBr || '';
    var endBrValue = userEndBr != null ? userEndBr : endBr || '';
    var start = Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["c" /* parseDateBrToDate */])(beginBrValue);
    var end = Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["c" /* parseDateBrToDate */])(endBrValue);
    setRange({
      startDate: start,
      endDate: end
    });
    var effective = mode;
    if (!start && !end) {
      effective = 'range';
    } else if (start && end) {
      effective = 'range';
    } else if (mode !== 'start' && mode !== 'end') {
      effective = 'range';
    }
    setDatepickMode(effective);
    setIsMobileDatepickerOpen(true);
  }, [userBeginBr, userEndBr, beginBr, endBr]);
  var searchPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    var _parseSearchFromPath = Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["d" /* parseSearchFromPath */])(),
      pathDestSlug = _parseSearchFromPath.destinationSlug,
      pathBegin = _parseSearchFromPath.beginDate,
      pathEnd = _parseSearchFromPath.endDate;
    var beginISO = range.startDate ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["e" /* toISO */])(range.startDate) : pathBegin || '';
    var endISO = range.endDate ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["e" /* toISO */])(range.endDate) : pathEnd || '';
    var destination = userDestinationSlug || pathDestSlug;
    var isValidISO = function isValidISO(s) {
      return /^(\d{4})-(\d{2})-(\d{2})$/.test(s || '');
    };
    if (!isValidISO(beginISO) || !isValidISO(endISO) || !destination) {
      return;
    }
    if (props.cleanComparisonPlans) props.cleanComparisonPlans();
    var search = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["buildSearchWithDestinationCategories"])(props.destinations, destination);
    var path = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatURL"])(props.match && props.match.params ? props.match.params : {}, "/pesquisa/".concat(destination, "/").concat(beginISO, "/").concat(endISO), search, !search);
    if (props.history && props.history.push) props.history.push(path);
    var diffDays = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["getDaysDiff"])(new Date(beginISO), new Date(endISO));
    __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].raw({
      event: 'envio_form_cotacao',
      page_category: 'home',
      tipo_envio: 'novo_lead',
      cotacao: {
        destino: destination,
        data_embarque: beginISO,
        data_desembarque: endISO,
        tempo_permanencia: !Number.isNaN(diffDays) ? diffDays : undefined
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].searchSubmitted(destination, beginISO, endISO);
  }, [userDestinationSlug, range.startDate, range.endDate]);
  var handleCloseAll = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    setIsMobileDatepickerOpen(false);
    setIsInputSectionOpen(false);
    setDestinationDropdownOpen(false);
  }, []);
  var displayedDestinationName = function () {
    if (userDestinationSlug) {
      var found = (props.destinations || []).find(function (d) {
        return d.slug === userDestinationSlug;
      });
      return found ? found.name : '';
    }
    return computedDestinationName || '';
  }();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, isScrolled && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      height: containerHeight
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: containerRef,
    className: [__WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.container, isScrolled ? __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.fixed : '', isScrolled ? __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.scrolled : ''].filter(Boolean).join(' ')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.content
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.search
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destination,
    onClick: function onClick() {
      return setIsInputSectionOpen(true);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.item
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Pin_icon__["a" /* PinIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, displayedDestinationName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.item
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "".concat(userBeginBr != null ? userBeginBr : beginBr || '', " - ").concat(userEndBr != null ? userEndBr : endBr || '', " ")), "(", permanence, ")"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.searchButton,
    type: "button",
    onClick: function onClick() {
      return setIsInputSectionOpen(true);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_search_searchbar_SearchIcon__["a" /* default */], null))))), isInputSectionOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.overlay,
    onClick: handleCloseAll
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.inputSection
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.inputSectionContent
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Editar pesquisa"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.closeIcon,
    onClick: handleCloseAll
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__assets_icons_Close_icon__["a" /* CloseIcon */], {
    size: 24
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.flexContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationInput
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Pin_icon__["a" /* PinIcon */], {
      size: 24
    }),
    label: "Destino:",
    value: displayedDestinationName,
    onClick: function onClick(e) {
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
      setDestinationDropdownOpen(function (prev) {
        return !prev;
      });
    },
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.input,
    disabled: props.isLoading,
    rightIcon: destinationDropdownOpen ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
      size: 24,
      color: "#007E47",
      rotate: 270
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
      size: 24,
      color: "#007E47",
      rotate: 90
    })
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_V2_dropdown__["a" /* default */], {
    isOpen: destinationDropdownOpen,
    onClose: function onClose() {
      return setDestinationDropdownOpen(false);
    }
  }, props.destinations && props.destinations.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationList
  }, props.destinations.map(function (d) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: d.id,
      className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.destinationItem,
      onClick: function onClick() {
        setUserDestinationSlug(d.slug);
        setDestinationDropdownOpen(false);
      }
    }, d.name, (d.slug === 'brasil' || d.slug === 'receptivo') && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.description
    }, d.slug === 'brasil' ? 'Para viagens dentro do Brasil' : 'Para quem vem visitar o Brasil'));
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.inputGroup
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], {
      size: 24
    }),
    label: "Embarque no Brasil:",
    value: userBeginBr != null ? userBeginBr : beginBr || '',
    variant: "column",
    onClick: function onClick() {
      return openDatepickerFor('start');
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_V2_input__["a" /* default */], {
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Calendar_incon__["a" /* CalendarIcon */], {
      size: 24
    }),
    label: "Desembarque no Brasil:",
    value: userEndBr != null ? userEndBr : endBr || '',
    variant: "column",
    onClick: function onClick() {
      return openDatepickerFor('end');
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_11__styles_module_css___default.a.updateSearchButton,
    onClick: searchPlan
  }, "Atualizar pesquisa"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_V2_datepicker_mobile_fullscreen__["a" /* default */], {
    open: isMobileDatepickerOpen,
    selectionMode: datepickMode,
    value: range,
    onChange: function onChange(val) {
      setRange(val);
    },
    onConfirm: function onConfirm(val) {
      setRange(val);
      setUserBeginBr(Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["b" /* formatDateBrFromDate */])(val.startDate));
      setUserEndBr(Object(__WEBPACK_IMPORTED_MODULE_10__utils_searchParsing__["b" /* formatDateBrFromDate */])(val.endDate));
      setIsMobileDatepickerOpen(false);
    },
    onBack: function onBack() {
      return setIsMobileDatepickerOpen(false);
    },
    onClose: handleCloseAll,
    minDate: new Date(),
    allowSameDay: true,
    labels: {
      title: 'Editar pesquisa'
    }
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    destinations: state.global.destinations
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["w" /* setQuotationParams */],
  cleanComparisonPlans: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["c" /* cleanComparisonPlans */]
})(SearchBarMobile)));

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_19-lz","scrolled":"_3h7n4","fixed":"_105iC","overlay":"_1dXvT","content":"_3H8we","searchButton":"_1s3S9","search":"_1jUKs","destination":"_13w1X","item":"EF9Tw","inputSection":"_2N2Pg","flexContainer":"_2IQtu","header":"_2QF_U","closeIcon":"_1E82D","destinationInput":"_1pAX1","destinationList":"_2M4Rn","destinationItem":"_24nkz","description":"_9TMYg","inputGroup":"_2lkin","input":"_3b25M","updateSearchButton":"boOE1"};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"MIwuS","container":"_2yi5R","header":"TgWkA","headerTitle":"_6ypd9","headerTitleLabel":"_3yiKZ","headerBody":"_3aYEa","previewSelection":"Ko6nm","previewSelectionItem":"_39aDp","main":"oCu7C","footer":"_2pgl_","confirm":"_39byI","clear":"_1ot-_","customHeaderDatepicker":"_12pAX"};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ArrowIcon = function ArrowIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#2E2E2E" : _ref$color,
    rotate = _ref.rotate;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.237305 8.13147C0.237305 7.71726 0.573091 7.38147 0.987305 7.38147H15.0131C15.4273 7.38147 15.7631 7.71726 15.7631 8.13147C15.7631 8.54568 15.4273 8.88147 15.0131 8.88147H0.987305C0.573091 8.88147 0.237305 8.54568 0.237305 8.13147Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94111 1.1778C8.234 1.47069 8.234 1.94557 7.94111 2.23846L1.51763 8.66193C1.22474 8.95482 0.749868 8.95482 0.456975 8.66193C0.164081 8.36904 0.164081 7.89416 0.456975 7.60127L6.88045 1.1778C7.17334 0.884907 7.64821 0.884907 7.94111 1.1778Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94097 15.0853C7.64808 15.3782 7.17321 15.3782 6.88031 15.0853L0.456844 8.6618C0.163951 8.36891 0.163951 7.89403 0.456844 7.60114C0.749737 7.30825 1.22461 7.30825 1.5175 7.60114L7.94097 14.0246C8.23387 14.3175 8.23387 14.7924 7.94097 15.0853Z",
    fill: "#2E2E2E"
  }));
};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TwinArrowIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var TwinArrowIcon = function TwinArrowIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 28 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#007E47' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size + 1,
    viewBox: "0 0 28 29",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7046 19.3342C22.7046 19.7691 22.352 20.1217 21.9171 20.1217L4.94535 20.1217C4.51043 20.1217 4.15785 19.7691 4.15785 19.3342C4.15785 18.8992 4.51043 18.5467 4.94535 18.5467L21.9171 18.5467C22.352 18.5467 22.7046 18.8992 22.7046 19.3342Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5256 24.7253C16.2181 24.4177 16.2181 23.9191 16.5256 23.6116L21.36 18.7772C21.6675 18.4697 22.1661 18.4697 22.4737 18.7772C22.7812 19.0848 22.7812 19.5834 22.4737 19.8909L17.6393 24.7253C17.3318 25.0328 16.8332 25.0328 16.5256 24.7253Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5258 13.943C16.8334 13.6354 17.332 13.6354 17.6395 13.943L22.4737 18.7772C22.7812 19.0848 22.7812 19.5834 22.4737 19.8909C22.1661 20.1985 21.6677 20.1986 21.3602 19.891L16.5258 15.0567C16.2183 14.7491 16.2183 14.2505 16.5258 13.943Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29558 9.66543C5.29558 9.23051 5.64815 8.87793 6.08307 8.87793L23.0548 8.87793C23.4897 8.87793 23.8423 9.23051 23.8423 9.66543C23.8423 10.1004 23.4897 10.4529 23.0548 10.4529L6.08307 10.4529C5.64815 10.4529 5.29558 10.1004 5.29558 9.66543Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4745 4.27432C11.7821 4.58186 11.7821 5.08048 11.4745 5.38802L6.64015 10.2224C6.33261 10.5299 5.834 10.5299 5.52646 10.2224C5.21892 9.91484 5.21892 9.41622 5.52646 9.10868L10.3608 4.27432C10.6684 3.96678 11.167 3.96678 11.4745 4.27432Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4743 15.0566C11.1668 15.3642 10.6682 15.3642 10.3606 15.0566L5.52646 10.2224C5.21892 9.91484 5.21892 9.41622 5.52646 9.10868C5.834 8.80115 6.33242 8.80105 6.63996 9.10858L11.4743 13.9429C11.7819 14.2505 11.7819 14.7491 11.4743 15.0566Z",
    fill: color
  }));
};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_module_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_module_css__);






var ComparisonBarModule = function ComparisonBarModule(props) {
  var comparePlans = function comparePlans() {
    var selectedPlans = props.plans.map(function (plan) {
      return plan.code;
    });
    var basePath = '/seguro-viagem/comparacao';
    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isB2b"])()) basePath = '/seguro-viagem/comparacao-b2b';
    var location = {
      pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(props.match.params, "".concat(basePath, "/").concat(props.match.params.destination, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(props.match.params.begin_date), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(props.match.params.end_date), "/?products_ids=").concat(selectedPlans.join('+')))
    };
    props.history.push(location);
  };
  var plans = [{}, {}, {}, {}];
  if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isMobile"])()) plans = [{}, {}];
  plans = plans.map(function (plan, i) {
    return props.plans[i] || plan;
  });
  var getProviderImgPath = function getProviderImgPath(providerCode) {
    var provider = props.providers.find(function (p) {
      return p.code === providerCode;
    });
    return provider ? "/assets/images/seguradoras/".concat(provider.slug, ".png") : '';
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.planos
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.component
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.planosComparar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.escolha
  }, "Escolha de 2 a 4 planos para fazer uma compara\xE7\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.planosSelecionados
  }, plans.map(function (plan, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: i,
      className: "".concat(__WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.itemSelectedPlans, " ").concat(!plan.code ? __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.notSelected : ''),
      onClick: function onClick() {
        return plan.code && props.removeComparisonPlan(plan.code);
      }
    }, plan.code ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a["delete"]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: "/assets/images/pagamento/excluir.svg",
      alt: "Excluir plano"
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.mini
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: getProviderImgPath(plan.provider_code),
      alt: plan.provider_code ? 'Provider logo' : 'Sem logo'
    }))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "desktop"
    }, "Selecione outro seguro para comparar"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "mobile"
    }, "Selecione outro plano")));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_5__styles_module_css___default.a.btnCompare,
    onClick: comparePlans,
    disabled: props.plans.length <= 1,
    "data-cy": "botao-comparar"
  }, "Comparar"))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    plans: state.search.comparisonPlans,
    providers: state.global.providers
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["r" /* removeComparisonPlan */]
})(ComparisonBarModule)));

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"planos":"X15aF","component":"_2FgZY","planosComparar":"Q8uMT","escolha":"_3nFQc","planosSelecionados":"_1edOF","itemSelectedPlans":"FkahO","delete":"CFxvJ","mini":"_1_8Po","notSelected":"mzGpy","desktop":"IE8W_","mobile":"_1R4ZE","btnCompare":"_37RdM"};

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var GenericErrorMessage = /*#__PURE__*/function (_Component) {
  function GenericErrorMessage() {
    _classCallCheck(this, GenericErrorMessage);
    return _callSuper(this, GenericErrorMessage, arguments);
  }
  _inherits(GenericErrorMessage, _Component);
  return _createClass(GenericErrorMessage, [{
    key: "getMessage",
    value: function getMessage() {
      var message = '';
      try {
        message = this.props.errors[this.props.field];
      } catch (e) {
        message = false;
      }
      return message;
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.getMessage()) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          id: this.props.anchor
        });
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        id: this.props.anchor,
        className: "generic-error-message"
      }, this.getMessage());
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (GenericErrorMessage);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_search_plans_table_Filters_ActiveFilters__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HospitalExpenseFilter__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CovidCoverageFilter__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AgeRangeFilter__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_BenefitsCoverageFilter__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProviderFilter__ = __webpack_require__(93);









var Filters = function Filters(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.filtersContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__styles_module_css___default.a.filterTitle
  }, "Filtrar"), !props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_search_plans_table_Filters_ActiveFilters__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_HospitalExpenseFilter__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ProviderFilter__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_AgeRangeFilter__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_BenefitsCoverageFilter__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_CovidCoverageFilter__["a" /* default */], null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    mobile: state.mobile.mobileActive
  };
};
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {})(Filters));

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"filtersContainer":"_3Vfa4","filterTitle":"_3FCzg"};

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewTagIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var NewTagIcon = function NewTagIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 58 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 22 : _ref$height;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "14 10 58 22",
    preserveAspectRatio: "none",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M22.308 31.5H68.3997C69.7805 31.5 70.8997 30.3807 70.8997 29V13C70.8997 11.6193 69.7805 10.5 68.3997 10.5H22.308C21.4701 10.5 20.6882 10.92 20.2249 11.6182L14.9164 19.6182C14.361 20.4556 14.361 21.5444 14.9164 22.3818L20.2249 30.3818C20.6882 31.08 21.4701 31.5 22.308 31.5Z",
    fill: "#FFE187",
    stroke: "#DBAE25"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M26.3997 15.6998L27.6262 19.4695L31.5926 19.4695L28.383 21.7998L29.6094 25.5695L26.3997 23.2391L23.1901 25.5695L24.4165 21.7998L21.2069 19.4695L25.1732 19.4695L26.3997 15.6998Z",
    fill: "url(#starGrad0_256_2899)",
    stroke: "#DBAE25",
    strokeWidth: "0.6",
    strokeLinejoin: "round"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M41.5658 24.9998H39.0365L36.429 19.9705H36.3851C36.4014 20.1235 36.416 20.3074 36.429 20.5222C36.4421 20.7371 36.4535 20.9568 36.4632 21.1814C36.473 21.4028 36.4779 21.6029 36.4779 21.782V24.9998H34.7689V17.8611H37.2884L39.8861 22.822H39.9154C39.9056 22.6658 39.8958 22.4851 39.8861 22.28C39.8763 22.0717 39.8665 21.8617 39.8568 21.6501C39.8503 21.4386 39.847 21.2514 39.847 21.0886V17.8611H41.5658V24.9998ZM49.7884 21.4207C49.7884 21.9708 49.7217 22.4721 49.5882 22.9246C49.458 23.3738 49.2529 23.7611 48.973 24.0867C48.693 24.4122 48.3333 24.6628 47.8939 24.8386C47.4544 25.0111 46.9287 25.0974 46.3167 25.0974C45.7178 25.0974 45.1986 25.0111 44.7591 24.8386C44.3229 24.6628 43.9632 24.4138 43.68 24.0916C43.3968 23.766 43.1869 23.377 43.0501 22.9246C42.9134 22.4721 42.8451 21.9675 42.8451 21.4109C42.8451 20.6687 42.9671 20.0242 43.2113 19.4773C43.4587 18.9272 43.8395 18.5024 44.3539 18.2029C44.8682 17.9001 45.5257 17.7488 46.3265 17.7488C47.1403 17.7488 47.8011 17.9001 48.3089 18.2029C48.82 18.5056 49.1943 18.932 49.432 19.4822C49.6696 20.0323 49.7884 20.6785 49.7884 21.4207ZM44.8763 21.4207C44.8763 21.8503 44.9251 22.2198 45.0228 22.5291C45.1205 22.8383 45.2751 23.0759 45.4867 23.2419C45.6983 23.408 45.9749 23.491 46.3167 23.491C46.6716 23.491 46.9531 23.408 47.1615 23.2419C47.3731 23.0759 47.5244 22.8383 47.6156 22.5291C47.71 22.2198 47.7572 21.8503 47.7572 21.4207C47.7572 20.7761 47.6497 20.2667 47.4349 19.8923C47.2201 19.518 46.8506 19.3308 46.3265 19.3308C45.9782 19.3308 45.6966 19.4154 45.4818 19.5847C45.2702 19.754 45.1156 19.9949 45.0179 20.3074C44.9235 20.6199 44.8763 20.991 44.8763 21.4207ZM57.2445 17.8611L54.9056 24.9998H52.6351L50.306 17.8611H52.474L53.4456 21.4792C53.4815 21.616 53.5221 21.7917 53.5677 22.0066C53.6165 22.2182 53.6605 22.4298 53.6996 22.6414C53.7419 22.8529 53.7679 23.0255 53.7777 23.1589C53.7907 23.0255 53.8151 22.8546 53.8509 22.6462C53.8867 22.4379 53.9258 22.2296 53.9681 22.0212C54.0137 21.8097 54.056 21.6355 54.0951 21.4988L55.0863 17.8611H57.2445ZM64.7005 21.4207C64.7005 21.9708 64.6338 22.4721 64.5003 22.9246C64.3701 23.3738 64.165 23.7611 63.8851 24.0867C63.6052 24.4122 63.2455 24.6628 62.806 24.8386C62.3665 25.0111 61.8408 25.0974 61.2289 25.0974C60.6299 25.0974 60.1107 25.0111 59.6712 24.8386C59.235 24.6628 58.8753 24.4138 58.5921 24.0916C58.3089 23.766 58.099 23.377 57.9622 22.9246C57.8255 22.4721 57.7572 21.9675 57.7572 21.4109C57.7572 20.6687 57.8792 20.0242 58.1234 19.4773C58.3708 18.9272 58.7516 18.5024 59.266 18.2029C59.7803 17.9001 60.4378 17.7488 61.2386 17.7488C62.0524 17.7488 62.7132 17.9001 63.221 18.2029C63.7321 18.5056 64.1065 18.932 64.3441 19.4822C64.5817 20.0323 64.7005 20.6785 64.7005 21.4207ZM59.7884 21.4207C59.7884 21.8503 59.8372 22.2198 59.9349 22.5291C60.0326 22.8383 60.1872 23.0759 60.3988 23.2419C60.6104 23.408 60.8871 23.491 61.2289 23.491C61.5837 23.491 61.8652 23.408 62.0736 23.2419C62.2852 23.0759 62.4365 22.8383 62.5277 22.5291C62.6221 22.2198 62.6693 21.8503 62.6693 21.4207C62.6693 20.7761 62.5619 20.2667 62.347 19.8923C62.1322 19.518 61.7627 19.3308 61.2386 19.3308C60.8903 19.3308 60.6087 19.4154 60.3939 19.5847C60.1823 19.754 60.0277 19.9949 59.93 20.3074C59.8356 20.6199 59.7884 20.991 59.7884 21.4207Z",
    fill: "#E6AC00"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient", {
    id: "starGrad0_256_2899",
    x1: "21.2069",
    y1: "15.6998",
    x2: "31.5926",
    y2: "25.5695",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
    stopColor: "#FFF6C8"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
    offset: "0.5",
    stopColor: "#FFD75E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
    offset: "1",
    stopColor: "#E8A400"
  }))));
};

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FloatButtonFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FloatingFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_Filter_icon__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_Close_icon__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HospitalExpenseFilter__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProviderFilter__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AgeRangeFilter__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BenefitsCoverageFilter__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CovidCoverageFilter__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OrderRadioFilter__ = __webpack_require__(237);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }













var FloatButtonFilter = function FloatButtonFilter(_ref) {
  var clearFilterCategories = _ref.clearFilterCategories,
    applyFilterCategories = _ref.applyFilterCategories,
    unselectFilterCategoryOptions = _ref.unselectFilterCategoryOptions,
    filterCategory = _ref.filterCategory,
    filterProvider = _ref.filterProvider;
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    drawerisOpen = _React$useState2[0],
    setDrawerisOpen = _React$useState2[1];
  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    stagedChanges = _React$useState4[0],
    setStagedChanges = _React$useState4[1];
  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filterKey = _React$useState6[0],
    setFilterKey = _React$useState6[1];
  var handleStageChange = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (change) {
    setStagedChanges(function (prev) {
      return [].concat(_toConsumableArray(prev), [change]);
    });
  }, []);
  var handleCloseWithoutApply = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    setStagedChanges([]);
    setFilterKey(function (prev) {
      return prev + 1;
    });
    setDrawerisOpen(false);
  }, []);
  var updateURLWithFilters = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    var currentParams = new URLSearchParams(window.location.search);
    var otherParams = [];
    currentParams.forEach(function (value, key) {
      if (key !== 'category' && key !== 'provider') {
        otherParams.push("".concat(key, "=").concat(value));
      }
    });
    var categoryIds = [];
    if (filterCategory && Array.isArray(filterCategory)) {
      filterCategory.forEach(function (cat) {
        if (cat.Categories && Array.isArray(cat.Categories)) {
          cat.Categories.forEach(function (opt) {
            if (opt.selected) {
              var id = opt.ID || opt.Id || opt.id;
              if (id !== undefined && id !== null) {
                categoryIds.push(id);
              }
            }
          });
        }
      });
    }
    var providerSlugs = [];
    if (filterProvider && Array.isArray(filterProvider)) {
      filterProvider.forEach(function (provider) {
        if (provider.selected) {
          var slug = provider.slug || provider.name;
          if (slug) {
            providerSlugs.push(slug);
          }
        }
      });
    }
    var allParams = [].concat(otherParams);
    if (categoryIds.length > 0) {
      allParams.push("category=".concat(categoryIds.join(',')));
    }
    if (providerSlugs.length > 0) {
      allParams.push("provider=".concat(providerSlugs.join(',')));
    }
    var newUrl = allParams.length > 0 ? "?".concat(allParams.join('&')) : window.location.pathname;
    window.history.replaceState(null, null, newUrl);
  }, [filterCategory, filterProvider]);
  var handleApplyFilters = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    var checkboxChanges = stagedChanges.filter(function (c) {
      return c.source && !c.step;
    });
    var sliderChanges = stagedChanges.filter(function (c) {
      return c.step;
    });
    checkboxChanges.forEach(function (change) {
      if (change.source === 'provider') {
        unselectFilterCategoryOptions('provider', change.optionIndex, 0);
      } else if (change.source === 'category') {
        unselectFilterCategoryOptions('category', change.categoryIndex, change.optionIndex);
      }
    });
    sliderChanges.forEach(function (change) {
      var categoryIndex = change.categoryIndex,
        step = change.step;
      if (step && step.optionIndex !== undefined) {
        unselectFilterCategoryOptions('category', categoryIndex, step.optionIndex);
      }
    });
    applyFilterCategories();
    updateURLWithFilters();
    handleCloseWithoutApply();
  }, [stagedChanges, unselectFilterCategoryOptions, applyFilterCategories, updateURLWithFilters, handleCloseWithoutApply]);
  var handleClearFilters = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils__["clearFiltersFromSession"])();
    var searchParams = window.location.search.replace('?', '').split('&');
    var otherParams = searchParams.filter(function (p) {
      return !['category=', 'provider='].some(function (k) {
        return p.startsWith(k);
      }) && p;
    });
    var location = otherParams.length > 0 ? "?".concat(otherParams.join('&')) : window.location.pathname;
    window.history.replaceState(null, null, location);
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.startTransition(function () {
      setStagedChanges([]);
      setFilterKey(function (prev) {
        return prev + 1;
      });
      clearFilterCategories();
    });
  }, [clearFilterCategories]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    var onKeyDown = function onKeyDown(e) {
      if (e.key === 'Escape') handleCloseWithoutApply();
    };
    window.addEventListener('keydown', onKeyDown);
    return function () {
      return window.removeEventListener('keydown', onKeyDown);
    };
  }, [handleCloseWithoutApply]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    if (drawerisOpen) {
      var prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return function () {
        document.body.style.overflow = prevOverflow;
      };
    }
  }, [drawerisOpen]);
  var handleOpenDrawer = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    setDrawerisOpen(true);
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingFilter
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingButtonFilter,
    onClick: handleOpenDrawer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons_Filter_icon__["a" /* FilterIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Filtrar e ordenar"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingFilterDrawer, " ").concat(drawerisOpen ? __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.open : __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.closed),
    "aria-hidden": !drawerisOpen,
    role: "dialog",
    "aria-modal": "true"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingFilterDrawerHeader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Filtrar e ordenar"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.closeIcon,
    onClick: handleCloseWithoutApply
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__assets_icons_Close_icon__["a" /* CloseIcon */], {
    size: 24
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingFilterDrawerBody,
    key: filterKey
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OrderRadioFilter__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__HospitalExpenseFilter__["a" /* default */], {
    useStagingMode: true,
    onStageChange: handleStageChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProviderFilter__["a" /* default */], {
    useStagingMode: true,
    onStageChange: handleStageChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AgeRangeFilter__["a" /* default */], {
    useStagingMode: true,
    onStageChange: handleStageChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BenefitsCoverageFilter__["a" /* default */], {
    useStagingMode: true,
    onStageChange: handleStageChange
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CovidCoverageFilter__["a" /* default */], {
    useStagingMode: true,
    onStageChange: handleStageChange
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.floatingFilterDrawerFooter
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.clearButton,
    onClick: handleClearFilters
  }, "Limpar filtros"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: __WEBPACK_IMPORTED_MODULE_11__floatingStyles_module_css___default.a.applyButton,
    onClick: handleApplyFilters
  }, "Aplicar filtros"))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider
  };
};
var ConnectedFloatingFilter = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  clearFilterCategories: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["d" /* clearFilterCategories */],
  applyFilterCategories: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["b" /* applyFilterCategories */],
  unselectFilterCategoryOptions: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["D" /* unselectFilterCategoryOptions */]
})(FloatButtonFilter);
var FloatingFilter = ConnectedFloatingFilter;
/* unused harmony default export */ var _unused_webpack_default_export = (ConnectedFloatingFilter);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var FilterIcon = function FilterIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size - 3,
    viewBox: "0 0 14 11",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95552 0.355957H1.5537C1.38287 0.355974 1.21568 0.405603 1.07252 0.498815C0.929366 0.592027 0.816365 0.724809 0.747247 0.881027C0.678129 1.03724 0.655865 1.21017 0.683167 1.37881C0.71047 1.54744 0.78616 1.70451 0.90104 1.83094L0.906151 1.83656L4.10795 5.25428V7.85635C4.10795 7.85624 4.10795 7.85646 4.10795 7.85635C4.10794 7.89664 4.11199 8.15509 4.11959 8.4078C4.12342 8.53512 4.12829 8.66622 4.13431 8.7708C4.13728 8.82233 4.14083 8.87309 4.14528 8.91583C4.14743 8.93656 4.1505 8.96242 4.15506 8.98861C4.1559 8.99423 4.16818 9.07686 4.21209 9.159C4.28055 9.28708 4.37958 9.39627 4.50039 9.47687L6.02675 10.4943C6.02704 10.4945 6.02734 10.4947 6.02764 10.4949C6.16015 10.5836 6.31426 10.6348 6.47356 10.6429C6.63322 10.651 6.79208 10.6156 6.93316 10.5404C7.07424 10.4652 7.19223 10.3531 7.27451 10.2161C7.3568 10.079 7.40028 9.92216 7.40031 9.7623V5.25428L10.6073 1.83098C10.722 1.70469 10.7976 1.54778 10.825 1.37935C10.8524 1.21092 10.8303 1.03817 10.7615 0.882034C10.6926 0.725901 10.5799 0.593094 10.4371 0.499716C10.2943 0.406339 10.1275 0.356401 9.95681 0.355959L9.95552 0.355957ZM9.682 1.35596L6.63853 4.60476C6.48551 4.7682 6.40028 4.98383 6.40031 5.20772C6.40031 5.20767 6.40031 5.20777 6.40031 5.20772V9.54149L5.13168 8.69587C5.12687 8.60741 5.12265 8.49444 5.11914 8.37774C5.11542 8.25408 5.1126 8.12977 5.11071 8.03239L5.1086 7.91084L5.10809 7.87272L5.10797 7.86113C5.10795 7.85847 5.10795 7.85724 5.10795 7.85702V5.20787C5.10795 5.20782 5.10795 5.20792 5.10795 5.20787C5.10798 4.98398 5.02285 4.76831 4.86983 4.60487L1.82625 1.35596H9.682Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8282 1.81293H11.7007V0.812927H13.8282V1.81293Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8282 5.77698L9.01221 5.77698L9.01221 4.77698L13.8282 4.77698L13.8282 5.77698Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8282 9.74097L9.01221 9.74097L9.01221 8.74097L13.8282 8.74097L13.8282 9.74097Z",
    fill: "#007E47"
  }));
};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"floatingFilter":"_2J0o2","floatingButtonFilter":"_1HYlQ","floatingFilterDrawer":"_2YXot","open":"_3MBiZ","closed":"ojD_9","floatingFilterDrawerHeader":"_2aVGb","closeIcon":"_6uExO","floatingFilterDrawerBody":"_3dS2Y","floatingFilterDrawerFooter":"_2jt4R","clearButton":"_3zFML","applyButton":"_1YfHP"};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OrderRadioFilter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RadioFilter__ = __webpack_require__(238);


function OrderRadioFilter() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RadioFilter__["a" /* default */], {
    title: "Ordenar por",
    ariaLabel: "Ordenar por",
    showDivider: true
  });
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_module_css__);




function RadioFilterBase(_ref) {
  var _ref$sortOptions = _ref.sortOptions,
    sortOptions = _ref$sortOptions === void 0 ? [] : _ref$sortOptions,
    sort_option = _ref.sort_option,
    setSortOption = _ref.setSortOption,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Ordenar por' : _ref$title,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'Ordenar por' : _ref$ariaLabel,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider;
  var options = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (!Array.isArray(sortOptions)) return [];
    return sortOptions.map(function (opt, index) {
      return {
        id: opt.name || "option-".concat(index),
        label: opt.displayName || '',
        value: opt.name || '',
        selected: sort_option === (opt.name || opt.value)
      };
    });
  }, [sortOptions, sort_option]);
  var handleChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) {
    if (value && value !== sort_option) {
      setSortOption(value);
    }
  }, [sort_option, setSortOption]);
  if (!options.length) return null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.container
  }, title ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.title
  }, title)) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.radioList,
    role: "radiogroup",
    "aria-label": ariaLabel
  }, options.map(function (opt) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      key: opt.id,
      className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.radioLabel
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      name: "sort-option",
      className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.radioInput,
      value: opt.value,
      checked: opt.selected,
      onChange: function onChange() {
        return handleChange(opt.value);
      },
      "aria-label": opt.label
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.radioText
    }, opt.label));
  })), showDivider ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_module_css___default.a.divider
  }) : null);
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    sortOptions: state.search.sortOptions || [],
    sort_option: state.search.sort_option
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  setSortOption: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["x" /* setSortOption */]
})(RadioFilterBase));

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_StarCircle_icon__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_Hospital_icon__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_icons_Bagage_icon__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_Pharmacy_icon__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_Phone_icon__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icons_Tooltip_icon__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_icons_SalaVip_icon__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_icons_ChipInternacional_icon__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_v2_common_Tooltip__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PlanCards__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_module_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__styles_module_css__);





















var Upsell = function Upsell(_ref) {
  var closeModalUpsell = _ref.closeModalUpsell,
    upsellPlans = _ref.upsellPlans,
    coupon = _ref.coupon,
    paymentMethods = _ref.paymentMethods,
    match = _ref.match,
    history = _ref.history,
    setUpsellPurchase = _ref.setUpsellPurchase;
  if (!upsellPlans || upsellPlans.length < 2 || !upsellPlans[0] || !upsellPlans[1] || !upsellPlans[0].code || !upsellPlans[1].code) {
    return null;
  }
  var currentPlan = upsellPlans[0];
  var upgradePlan = upsellPlans[1];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    __WEBPACK_IMPORTED_MODULE_19__utils_dataLayer__["a" /* default */].pageView('checkout_upsell');
    __WEBPACK_IMPORTED_MODULE_19__utils_dataLayer__["a" /* default */].upsellViewed(currentPlan, upgradePlan);
  }, []);
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_3__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: closeModalUpsell,
      enabled: true
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  var pixDiscountMultiplier = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (paymentMethods && paymentMethods.length > 0) {
      var pixPayment = paymentMethods.find(function (method) {
        return method.slug === 'pix';
      });
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);
  var calculatePlanPrices = function calculatePlanPrices(plan) {
    if (!plan) return {};
    var basePrice = plan.adult && plan.adult.price;
    var priceWithCouponDiscount = Object(__WEBPACK_IMPORTED_MODULE_17__utils__["getProductDiscount"])(basePrice, plan.code, coupon);
    var finalPrice = priceWithCouponDiscount || plan.price_with_coupon_discount || basePrice;
    var parcels = Object(__WEBPACK_IMPORTED_MODULE_16__utils_plan__["g" /* maxValueParcel */])(finalPrice) || 1;
    return {
      basePrice: basePrice,
      priceWithCouponDiscount: priceWithCouponDiscount,
      finalPrice: finalPrice,
      parcels: parcels
    };
  };
  var currentPrices = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return calculatePlanPrices(currentPlan);
  }, [currentPlan, coupon]);
  var upgradePrices = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return calculatePlanPrices(upgradePlan);
  }, [upgradePlan, coupon]);
  var getPlanBenefits = function getPlanBenefits(plan) {
    if (!plan || !plan.benefits) return {};
    return {
      baggage: plan.benefits.find(function (benefit) {
        return benefit.code === '42' || benefit.code === 42;
      }),
      hospital: plan.benefits.find(function (benefit) {
        return benefit.code === '51' || benefit.code === 51;
      }),
      medicament: plan.benefits.find(function (benefit) {
        return benefit.code === '5' || benefit.code === 5;
      }),
      telemedicine: plan.benefits.find(function (benefit) {
        return benefit.code === '56' || benefit.code === 56;
      }),
      salaVip: plan.benefits.find(function (benefit) {
        return benefit.code === '68' || benefit.code === 68;
      }),
      chip: plan.benefits.find(function (benefit) {
        return benefit.code === '69' || benefit.code === 69;
      })
    };
  };
  var currentBenefits = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return getPlanBenefits(currentPlan);
  }, [currentPlan]);
  var upgradeBenefits = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return getPlanBenefits(upgradePlan);
  }, [upgradePlan]);
  var currentHasSalaVip = Object(__WEBPACK_IMPORTED_MODULE_16__utils_plan__["f" /* isBenefitIncluded */])(currentBenefits.salaVip);
  var upgradeHasSalaVip = Object(__WEBPACK_IMPORTED_MODULE_16__utils_plan__["f" /* isBenefitIncluded */])(upgradeBenefits.salaVip);
  var currentHasChipInternacional = Object(__WEBPACK_IMPORTED_MODULE_16__utils_plan__["f" /* isBenefitIncluded */])(currentBenefits.chip);
  var upgradeHasChipInternacional = Object(__WEBPACK_IMPORTED_MODULE_16__utils_plan__["f" /* isBenefitIncluded */])(upgradeBenefits.chip);
  var hasHighlightBenefits = currentHasSalaVip || upgradeHasSalaVip || currentHasChipInternacional || upgradeHasChipInternacional;
  var formatBenefitsCoverage = function formatBenefitsCoverage(benefitCoverage) {
    if (!benefitCoverage || typeof benefitCoverage !== 'string') return null;
    var match = benefitCoverage.match(/[\d.,]+/);
    if (!match || !match[0]) return benefitCoverage;
    return "U$ ".concat(match[0]);
  };
  var comparePlans = function comparePlans() {
    if (!currentPlan || !upgradePlan || !currentPlan.code || !upgradePlan.code) {
      return;
    }
    var _match$params = match.params,
      destination = _match$params.destination,
      begin_date = _match$params.begin_date,
      end_date = _match$params.end_date;
    var basePath = '/seguro-viagem/comparacao';
    var productsIds = "".concat(currentPlan.code, "+").concat(upgradePlan.code);
    var url = "".concat(basePath, "/").concat(destination, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_17__utils__["cleanDate"])(begin_date), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_17__utils__["cleanDate"])(end_date), "/?products_ids=").concat(productsIds);
    setUpsellPurchase(upgradePlan.code);
    history.push(Object(__WEBPACK_IMPORTED_MODULE_17__utils__["formatURL"])(match.params, url));
  };
  var calculateUpgradePricePerDay = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var _match$params2 = match.params,
      begin_date = _match$params2.begin_date,
      end_date = _match$params2.end_date;
    if (!begin_date || !end_date) return 0;
    var start = new Date(begin_date);
    var end = new Date(end_date);
    var diffTime = Math.abs(end - start);
    var period = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    if (period <= 0) return 0;
    var priceDiff = upgradePrices.finalPrice * pixDiscountMultiplier - currentPrices.finalPrice * pixDiscountMultiplier;
    return priceDiff / period;
  }, [match.params, currentPrices.finalPrice, upgradePrices.finalPrice, pixDiscountMultiplier]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.blurBackground
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.upsellContainer,
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.bgDecoration
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.mobileHeader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.backButton,
    onClick: closeModalUpsell,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      transform: 'rotate(180deg)',
      display: 'flex'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], {
    width: 16,
    height: 16
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Olha o que encontramos!"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.contentContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.headerContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.headerTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.iconContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_StarCircle_icon__["a" /* StarCircle */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.queAchadoText
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "EXCLUSIVO PARA VOC\xCA"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.mainTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Viaje com "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.textGreen
  }, "muito mais seguran\xE7a"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, " por quase o mesmo pre\xE7o"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.subTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Por "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.textBoldLarge
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_17__utils__["formatPrice"])(calculateUpgradePricePerDay)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, " a mais por dia voc\xEA "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.textBoldLarge
  }, "viaja bem mais tranquilo")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differencesContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differencesTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "PRINCIPAIS DIFEREN\xC7AS")), (currentHasSalaVip || upgradeHasSalaVip) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItemHighlight
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__assets_icons_SalaVip_icon__["a" /* SalaVipIcon */], {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIconImg,
    size: 20
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffTextRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffTextHighlight
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Aceso a "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Sala VIP")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__views_v2_common_Tooltip__["a" /* default */], {
    content: "Espere seu voo em salas VIP de aeroportos: poltronas, wi-fi, comida e bebida inclusos, sem precisar de cart\xE3o premium."
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], {
    color: "#5A539C"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valuePill
  }, currentHasSalaVip ? 'INCLUSO' : 'NÃO INCLUSO'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], {
    color: "#5A539C"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valuePillHighlight
  }, upgradeHasSalaVip ? 'INCLUSO' : 'NÃO INCLUSO'))), (currentHasChipInternacional || upgradeHasChipInternacional) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItemHighlight
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__assets_icons_ChipInternacional_icon__["a" /* ChipInternacionalIcon */], {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIconImg,
    size: 20
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffTextRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffTextHighlight
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Inclui "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Chip Internacional")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__views_v2_common_Tooltip__["a" /* default */], {
    content: "Chip com internet internacional para voc\xEA usar durante toda a viagem."
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__assets_icons_Tooltip_icon__["a" /* TooltipIcon */], {
    color: "#5A539C"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valuePill
  }, currentHasChipInternacional ? 'INCLUSO' : 'NÃO INCLUSO'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], {
    color: "#5A539C"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valuePillHighlight
  }, upgradeHasChipInternacional ? 'INCLUSO' : 'NÃO INCLUSO'))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differencesRegularGroup
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_Hospital_icon__["a" /* Hospital */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffText
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Despesa m\xE9dica hospitalar (DMH)"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueNormal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, currentBenefits.hospital && formatBenefitsCoverage(currentBenefits.hospital.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueGreen
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, upgradeBenefits.hospital && formatBenefitsCoverage(upgradeBenefits.hospital.coverage) || 'Não')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItem,
    style: hasHighlightBenefits ? {
      borderBottom: 'none'
    } : undefined
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__assets_icons_Bagage_icon__["a" /* Bagage */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffText
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Seguro de Bagagem Extraviada"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueNormal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, currentBenefits.baggage && formatBenefitsCoverage(currentBenefits.baggage.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueGreen
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, upgradeBenefits.baggage && formatBenefitsCoverage(upgradeBenefits.baggage.coverage) || 'Não')))), !hasHighlightBenefits && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItem
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__assets_icons_Pharmacy_icon__["a" /* Pharmacy */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffText
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Reembolso de medicamentos"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueNormal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, currentBenefits.medicament && formatBenefitsCoverage(currentBenefits.medicament.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueGreen
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, upgradeBenefits.medicament && formatBenefitsCoverage(upgradeBenefits.medicament.coverage) || 'Não')))), !hasHighlightBenefits && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceItem,
    style: {
      borderBottom: 'none'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceDescription
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__assets_icons_Phone_icon__["a" /* Phone */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.diffText
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Telemedicina"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.differenceValues
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueNormal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, currentBenefits.telemedicine && formatBenefitsCoverage(currentBenefits.telemedicine.coverage) || 'Não')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.arrowIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ArrowRight_icon__["a" /* ArrowRight */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.valueGreen
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, upgradeBenefits.telemedicine && formatBenefitsCoverage(upgradeBenefits.telemedicine.coverage) || 'Sim')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.linkContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.linkText,
    onClick: comparePlans
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Clique aqui para ver a compara\xE7\xE3o completa")))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_20__styles_module_css___default.a.cardsContainer,
    style: {
      display: 'contents'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_PlanCards__["a" /* default */], {
    upsellPlans: upsellPlans,
    currentPrices: currentPrices,
    upgradePrices: upgradePrices,
    pixDiscountMultiplier: pixDiscountMultiplier
  }))));
};
var mapStateProps = function mapStateProps(state) {
  return {
    upsellPlans: state.search.upsellPlans,
    coupon: state.purchase.coupon,
    paymentMethods: state.purchase.paymentMethods
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateProps, {
  closeModalUpsell: __WEBPACK_IMPORTED_MODULE_4__actions_searchActions__["h" /* closeModalUpsell */],
  setUpsellPurchase: __WEBPACK_IMPORTED_MODULE_18__actions_purchaseActions__["_29" /* setUpsellPurchase */]
})(Upsell)));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StarCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var StarCircle = function StarCircle(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 28 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#007E47' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "14",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M9.52112 22.5708C9.14612 22.5708 8.78362 22.4583 8.45862 22.2208C7.90862 21.8208 7.64612 21.1583 7.75862 20.4958L8.40862 16.7458C8.43362 16.5833 8.38362 16.4208 8.25862 16.3083L5.49612 13.6583C5.00862 13.1833 4.83362 12.4958 5.03362 11.8583C5.24612 11.2083 5.79612 10.7458 6.47112 10.6458L10.2961 10.0958C10.4711 10.0708 10.6086 9.97084 10.6836 9.82084L12.3961 6.40834C12.6961 5.79584 13.3086 5.42084 13.9961 5.42084C14.6836 5.42084 15.2961 5.79584 15.5961 6.40834L17.3086 9.82084C17.3836 9.97084 17.5336 10.0708 17.6961 10.0958L21.5211 10.6458C22.1961 10.7458 22.7586 11.2083 22.9586 11.8583C23.1711 12.4958 22.9961 13.1958 22.4961 13.6583L19.7336 16.3208C19.6086 16.4333 19.5586 16.5958 19.5836 16.7583L20.2336 20.5083C20.3461 21.1708 20.0836 21.8333 19.5336 22.2333C18.9836 22.6333 18.2586 22.6958 17.6461 22.3708L14.2336 20.5958C14.0836 20.5208 13.8961 20.5208 13.7461 20.5958L10.3336 22.3708C10.0711 22.5083 9.78362 22.5708 9.50862 22.5708H9.52112ZM14.0086 6.67084C13.9336 6.67084 13.6711 6.69584 13.5461 6.95834L11.8336 10.3708C11.5711 10.8958 11.0711 11.2583 10.4961 11.3333L6.67112 11.8833C6.38362 11.9208 6.28362 12.1458 6.24612 12.2333C6.22112 12.3208 6.17112 12.5458 6.37112 12.7458L9.13362 15.4083C9.55862 15.8208 9.74612 16.4083 9.64612 16.9833L8.99612 20.7333C8.94612 21.0083 9.12112 21.1583 9.19612 21.2208C9.25862 21.2708 9.48362 21.4083 9.75862 21.2583L13.1711 19.4833C13.6961 19.2208 14.3086 19.2208 14.8211 19.4833L18.2336 21.2583C18.5086 21.4083 18.7336 21.2583 18.7961 21.2208C18.8711 21.1708 19.0461 21.0083 18.9961 20.7333L18.3461 16.9833C18.2461 16.4083 18.4336 15.8208 18.8586 15.4083L21.6211 12.7458C21.8211 12.5458 21.7836 12.3208 21.7461 12.2333C21.7211 12.1458 21.6211 11.9208 21.3211 11.8833L17.4961 11.3333C16.9211 11.2458 16.4211 10.8958 16.1586 10.3708L14.4461 6.95834C14.3211 6.69584 14.0711 6.67084 13.9836 6.67084H14.0086Z",
    fill: "white"
  }));
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hospital; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Hospital = function Hospital(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M17.625 6.27273H15V5.04545C15 3.918 14.1593 3 13.125 3H10.875C9.84075 3 9 3.918 9 5.04545V6.27273H6.375C4.51425 6.27273 3 7.92464 3 9.95455V17.3182C3 19.3481 4.51425 21 6.375 21H17.625C19.4858 21 21 19.3481 21 17.3182V9.95455C21 7.92464 19.4858 6.27273 17.625 6.27273ZM9.75 5.04545C9.75 4.36882 10.2548 3.81818 10.875 3.81818H13.125C13.7452 3.81818 14.25 4.36882 14.25 5.04545V6.27273H9.75V5.04545ZM20.25 17.3182C20.25 18.8973 19.0725 20.1818 17.625 20.1818H6.375C4.9275 20.1818 3.75 18.8973 3.75 17.3182V9.95455C3.75 8.37545 4.9275 7.09091 6.375 7.09091H17.625C19.0725 7.09091 20.25 8.37545 20.25 9.95455V17.3182Z",
    fill: "#636363",
    stroke: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M14.625 14.0455C14.832 14.0455 15 13.8622 15 13.6364C15 13.4106 14.832 13.2273 14.625 13.2273H12.375V10.7727C12.375 10.5469 12.207 10.3636 12 10.3636C11.793 10.3636 11.625 10.5469 11.625 10.7727V13.2273H9.375C9.168 13.2273 9 13.4106 9 13.6364C9 13.8622 9.168 14.0455 9.375 14.0455H11.625V16.5C11.625 16.7258 11.793 16.9091 12 16.9091C12.207 16.9091 12.375 16.7258 12.375 16.5V14.0455H14.625Z",
    fill: "#007E47",
    stroke: "#007E47"
  }));
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bagage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Bagage = function Bagage(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#636363' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93063 19.561C8.3934 19.561 7.95789 19.9965 7.95789 20.5337C7.95789 21.071 8.3934 21.5065 8.93063 21.5065C9.46787 21.5065 9.90338 21.071 9.90338 20.5337C9.90338 19.9965 9.46787 19.561 8.93063 19.561ZM10.9579 20.5337C10.9579 21.6533 10.0503 22.561 8.93063 22.561C7.81101 22.561 6.90338 21.6533 6.90338 20.5337C6.90338 19.4141 7.81101 18.5065 8.93063 18.5065C10.0503 18.5065 10.9579 19.4141 10.9579 20.5337Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0691 19.5611C14.5319 19.5611 14.0964 19.9966 14.0964 20.5338C14.0964 21.0711 14.5319 21.5066 15.0691 21.5066C15.6064 21.5066 16.0419 21.0711 16.0419 20.5338C16.0419 19.9966 15.6064 19.5611 15.0691 19.5611ZM17.0964 20.5338C17.0964 21.6535 16.1887 22.5611 15.0691 22.5611C13.9495 22.5611 13.0419 21.6535 13.0419 20.5338C13.0419 19.4142 13.9495 18.5066 15.0691 18.5066C16.1887 18.5066 17.0964 19.4142 17.0964 20.5338Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25574 7.70549C5.25574 6.38718 6.32444 5.31848 7.64275 5.31848H16.3581C17.6764 5.31848 18.7451 6.38718 18.7451 7.70549V17.354C18.7451 18.6723 17.6764 19.741 16.3581 19.741H7.64275C6.32444 19.741 5.25574 18.6723 5.25574 17.354V7.70549ZM7.64275 6.81848C7.15287 6.81848 6.75574 7.21561 6.75574 7.70549V17.354C6.75574 17.8438 7.15287 18.241 7.64275 18.241H16.3581C16.8479 18.241 17.2451 17.8438 17.2451 17.354V7.70549C17.2451 7.21561 16.8479 6.81848 16.3581 6.81848H7.64275Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33923 1.96655C8.33923 1.55234 8.67502 1.21655 9.08923 1.21655H14.9106C15.3249 1.21655 15.6606 1.55234 15.6606 1.96655C15.6606 2.38077 15.3249 2.71655 14.9106 2.71655H9.08923C8.67502 2.71655 8.33923 2.38077 8.33923 1.96655Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7731 1.28577C11.1873 1.28577 11.5231 1.62155 11.5231 2.03577V5.63951C11.5231 6.05372 11.1873 6.38951 10.7731 6.38951C10.3589 6.38951 10.0231 6.05372 10.0231 5.63951V2.03577C10.0231 1.62155 10.3589 1.28577 10.7731 1.28577Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2277 1.28577C13.6419 1.28577 13.9777 1.62155 13.9777 2.03577V5.63951C13.9777 6.05372 13.6419 6.38951 13.2277 6.38951C12.8135 6.38951 12.4777 6.05372 12.4777 5.63951V2.03577C12.4777 1.62155 12.8135 1.28577 13.2277 1.28577Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79407 8.8396H15.2066V10.3396H8.79407V8.8396Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79407 11.8579H15.2066V13.3579H8.79407V11.8579Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79407 14.877H15.2066V16.377H8.79407V14.877Z",
    fill: "#007E47"
  }));
};

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pharmacy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Pharmacy = function Pharmacy(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("mask", {
    id: "path-1-outside-1_1_20849",
    maskUnits: "userSpaceOnUse",
    x: "4",
    y: "1",
    width: "17",
    height: "22",
    fill: "black"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
    fill: "white",
    x: "4",
    y: "1",
    width: "17",
    height: "22"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M15.416 2C16.5642 2 17.4998 2.93399 17.5 4.08301C17.5 5.09967 16.767 5.94543 15.8037 6.12793L15.8252 8.25391C15.8269 8.48134 16.0138 8.66689 16.2412 8.66699C18.317 8.66699 20 10.3495 20 12.417V18.25C20 20.3174 18.3173 21.9999 16.25 22H8.75C6.68255 22 5 20.3175 5 18.25V12.417C5 10.3495 6.68255 8.66699 8.75 8.66699C8.97995 8.66694 9.16699 8.47914 9.16699 8.25V6.12402C8.21702 5.93069 7.5 5.08967 7.5 4.08301C7.50018 2.93406 8.43491 2.00012 9.58301 2H15.416ZM10 6.16699V8.25C10 8.93914 9.43911 9.49995 8.75 9.5C7.14171 9.5 5.83301 10.8087 5.83301 12.417V18.25C5.83301 19.8583 7.14171 21.167 8.75 21.167H16.25C17.8582 21.1668 19.166 19.8582 19.166 18.25L19.167 12.417C19.167 10.8088 17.8591 9.50022 16.251 9.5C15.5602 9.5 14.999 8.94511 14.9922 8.2627L14.9717 6.16699H10ZM9.58301 2.83301C8.89406 2.83312 8.33318 3.39406 8.33301 4.08301C8.33301 4.7721 8.89396 5.33289 9.58301 5.33301H15.416C16.1052 5.33301 16.666 4.77217 16.666 4.08301C16.6658 3.39399 16.1051 2.83301 15.416 2.83301H9.58301Z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M15.416 2C16.5642 2 17.4998 2.93399 17.5 4.08301C17.5 5.09967 16.767 5.94543 15.8037 6.12793L15.8252 8.25391C15.8269 8.48134 16.0138 8.66689 16.2412 8.66699C18.317 8.66699 20 10.3495 20 12.417V18.25C20 20.3174 18.3173 21.9999 16.25 22H8.75C6.68255 22 5 20.3175 5 18.25V12.417C5 10.3495 6.68255 8.66699 8.75 8.66699C8.97995 8.66694 9.16699 8.47914 9.16699 8.25V6.12402C8.21702 5.93069 7.5 5.08967 7.5 4.08301C7.50018 2.93406 8.43491 2.00012 9.58301 2H15.416ZM10 6.16699V8.25C10 8.93914 9.43911 9.49995 8.75 9.5C7.14171 9.5 5.83301 10.8087 5.83301 12.417V18.25C5.83301 19.8583 7.14171 21.167 8.75 21.167H16.25C17.8582 21.1668 19.166 19.8582 19.166 18.25L19.167 12.417C19.167 10.8088 17.8591 9.50022 16.251 9.5C15.5602 9.5 14.999 8.94511 14.9922 8.2627L14.9717 6.16699H10ZM9.58301 2.83301C8.89406 2.83312 8.33318 3.39406 8.33301 4.08301C8.33301 4.7721 8.89396 5.33289 9.58301 5.33301H15.416C16.1052 5.33301 16.666 4.77217 16.666 4.08301C16.6658 3.39399 16.1051 2.83301 15.416 2.83301H9.58301Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M17.5 4.08301H17.8V4.08296L17.5 4.08301ZM15.8037 6.12793L15.7479 5.83317L15.5012 5.87991L15.5037 6.13096L15.8037 6.12793ZM15.8252 8.25391L16.1252 8.25171L16.1252 8.25087L15.8252 8.25391ZM16.2412 8.66699L16.2411 8.96699H16.2412V8.66699ZM16.25 22V22.3H16.25L16.25 22ZM8.75 8.66699V8.96699H8.75006L8.75 8.66699ZM9.16699 6.12402H9.46699V5.87893L9.22682 5.83005L9.16699 6.12402ZM7.5 4.08301L7.2 4.08296V4.08301H7.5ZM9.58301 2V1.7H9.58298L9.58301 2ZM10 6.16699V5.86699H9.7V6.16699H10ZM8.75 9.5V9.8H8.75002L8.75 9.5ZM16.25 21.167V21.467H16.25L16.25 21.167ZM19.166 18.25L18.866 18.25V18.25H19.166ZM19.167 12.417L19.467 12.417V12.417H19.167ZM16.251 9.5L16.251 9.2H16.251V9.5ZM14.9922 8.2627L14.6922 8.26563L14.6922 8.26567L14.9922 8.2627ZM14.9717 6.16699L15.2717 6.16406L15.2688 5.86699H14.9717V6.16699ZM9.58301 2.83301V2.53301H9.58296L9.58301 2.83301ZM8.33301 4.08301L8.03301 4.08293V4.08301H8.33301ZM9.58301 5.33301L9.58296 5.63301H9.58301V5.33301ZM16.666 4.08301H16.966V4.08293L16.666 4.08301ZM15.416 2V2.3C16.3987 2.3 17.1998 3.0999 17.2 4.08305L17.5 4.08301L17.8 4.08296C17.7998 2.76808 16.7297 1.7 15.416 1.7V2ZM17.5 4.08301H17.2C17.2 4.95185 16.5732 5.67682 15.7479 5.83317L15.8037 6.12793L15.8596 6.42269C16.9609 6.21404 17.8 5.2475 17.8 4.08301H17.5ZM15.8037 6.12793L15.5037 6.13096L15.5252 8.25694L15.8252 8.25391L16.1252 8.25087L16.1037 6.1249L15.8037 6.12793ZM15.8252 8.25391L15.5252 8.2561C15.5281 8.6484 15.849 8.96682 16.2411 8.96699L16.2412 8.66699L16.2413 8.36699C16.1786 8.36696 16.1256 8.31429 16.1252 8.25171L15.8252 8.25391ZM16.2412 8.66699V8.96699C18.1518 8.96699 19.7 10.5157 19.7 12.417H20H20.3C20.3 10.1833 18.4822 8.36699 16.2412 8.36699V8.66699ZM20 12.417H19.7V18.25H20H20.3V12.417H20ZM20 18.25H19.7C19.7 20.1517 18.1517 21.6999 16.25 21.7L16.25 22L16.25 22.3C18.483 22.2998 20.3 20.4831 20.3 18.25H20ZM16.25 22V21.7H8.75V22V22.3H16.25V22ZM8.75 22V21.7C6.84823 21.7 5.3 20.1518 5.3 18.25H5H4.7C4.7 20.4832 6.51687 22.3 8.75 22.3V22ZM5 18.25H5.3V12.417H5H4.7V18.25H5ZM5 12.417H5.3C5.3 10.5152 6.84823 8.96699 8.75 8.96699V8.66699V8.36699C6.51687 8.36699 4.7 10.1838 4.7 12.417H5ZM8.75 8.66699L8.75006 8.96699C9.14598 8.96691 9.46699 8.6445 9.46699 8.25H9.16699H8.86699C8.86699 8.31378 8.81393 8.36698 8.74994 8.36699L8.75 8.66699ZM9.16699 8.25H9.46699V6.12402H9.16699H8.86699V8.25H9.16699ZM9.16699 6.12402L9.22682 5.83005C8.41351 5.66453 7.8 4.94392 7.8 4.08301H7.5H7.2C7.2 5.23543 8.02052 6.19685 9.10716 6.418L9.16699 6.12402ZM7.5 4.08301L7.8 4.08305C7.80015 3.09982 8.60054 2.3001 9.58304 2.3L9.58301 2L9.58298 1.7C8.26928 1.70013 7.2002 2.7683 7.2 4.08296L7.5 4.08301ZM9.58301 2V2.3H15.416V2V1.7H9.58301V2ZM10 6.16699H9.7V8.25H10H10.3V6.16699H10ZM10 8.25H9.7C9.7 8.77343 9.27344 9.19996 8.74998 9.2L8.75 9.5L8.75002 9.8C9.60478 9.79994 10.3 9.10485 10.3 8.25H10ZM8.75 9.5V9.2C6.97602 9.2 5.53301 10.643 5.53301 12.417H5.83301H6.13301C6.13301 10.9743 7.30739 9.8 8.75 9.8V9.5ZM5.83301 12.417H5.53301V18.25H5.83301H6.13301V12.417H5.83301ZM5.83301 18.25H5.53301C5.53301 20.024 6.97602 21.467 8.75 21.467V21.167V20.867C7.30739 20.867 6.13301 19.6926 6.13301 18.25H5.83301ZM8.75 21.167V21.467H16.25V21.167V20.867H8.75V21.167ZM16.25 21.167L16.25 21.467C18.024 21.4668 19.466 20.0238 19.466 18.25H19.166H18.866C18.866 19.6927 17.6924 20.8669 16.25 20.867L16.25 21.167ZM19.166 18.25L19.466 18.25L19.467 12.417L19.167 12.417L18.867 12.4169L18.866 18.25L19.166 18.25ZM19.167 12.417H19.467C19.467 10.6432 18.0249 9.20025 16.251 9.2L16.251 9.5L16.2509 9.8C17.6933 9.8002 18.867 10.9744 18.867 12.417H19.167ZM16.251 9.5V9.2C15.7232 9.2 15.2973 8.77607 15.2922 8.25972L14.9922 8.2627L14.6922 8.26567C14.7006 9.11414 15.3973 9.8 16.251 9.8V9.5ZM14.9922 8.2627L15.2922 8.25976L15.2717 6.16406L14.9717 6.16699L14.6717 6.16993L14.6922 8.26563L14.9922 8.2627ZM14.9717 6.16699V5.86699H10V6.16699V6.46699H14.9717V6.16699ZM9.58301 2.83301L9.58296 2.53301C8.72834 2.53315 8.03323 3.22838 8.03301 4.08293L8.33301 4.08301L8.63301 4.08308C8.63314 3.55974 9.05978 3.1331 9.58306 3.13301L9.58301 2.83301ZM8.33301 4.08301H8.03301C8.03301 4.93784 8.72831 5.63286 9.58296 5.63301L9.58301 5.33301L9.58306 5.03301C9.0596 5.03292 8.63301 4.60636 8.63301 4.08301H8.33301ZM9.58301 5.33301V5.63301H15.416V5.33301V5.03301H9.58301V5.33301ZM15.416 5.33301V5.63301C16.2708 5.63301 16.966 4.93786 16.966 4.08301H16.666H16.366C16.366 4.60649 15.9395 5.03301 15.416 5.03301V5.33301ZM16.666 4.08301L16.966 4.08293C16.9658 3.22836 16.2708 2.53301 15.416 2.53301V2.83301V3.13301C15.9393 3.13301 16.3659 3.55962 16.366 4.08308L16.666 4.08301ZM15.416 2.83301V2.53301H9.58301V2.83301V3.13301H15.416V2.83301Z",
    fill: "#636363",
    mask: "url(#path-1-outside-1_1_20849)"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M15.125 15.5455C15.332 15.5455 15.5 15.3622 15.5 15.1364C15.5 14.9106 15.332 14.7273 15.125 14.7273H12.875V12.2727C12.875 12.0469 12.707 11.8636 12.5 11.8636C12.293 11.8636 12.125 12.0469 12.125 12.2727V14.7273H9.875C9.668 14.7273 9.5 14.9106 9.5 15.1364C9.5 15.3622 9.668 15.5455 9.875 15.5455H12.125V18C12.125 18.2258 12.293 18.4091 12.5 18.4091C12.707 18.4091 12.875 18.2258 12.875 18V15.5455H15.125Z",
    fill: "#007E47",
    stroke: "#007E47"
  }));
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Phone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Phone = function Phone(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M19.6554 22.3126C19.5804 22.3126 19.4904 22.3126 19.4154 22.3126C16.3404 21.9826 13.3704 20.9176 10.7904 19.2526C8.40542 17.7376 6.33542 15.6676 4.80542 13.2676C3.12542 10.6726 2.07542 7.67262 1.73042 4.61262C1.70042 4.23762 1.73042 3.86262 1.85042 3.50262C1.97042 3.14262 2.15042 2.82762 2.40542 2.55762C2.66042 2.28762 2.96042 2.06262 3.30542 1.91262C3.65042 1.76262 4.01042 1.68762 4.38542 1.68762H7.26542C7.94042 1.68762 8.54043 1.91262 9.02042 2.33262C9.51543 2.75262 9.83043 3.33762 9.92043 3.98262C10.0404 4.85262 10.2504 5.70762 10.5504 6.51762C10.7304 6.99762 10.7754 7.50762 10.6554 8.01762C10.5504 8.51262 10.2954 8.97762 9.93542 9.33762L9.12542 10.1476C10.3104 12.0526 11.9154 13.6576 13.8204 14.8426L14.6304 14.0326C14.9904 13.6726 15.4554 13.4176 15.9504 13.3126C16.4454 13.2076 16.9704 13.2526 17.4504 13.4176C18.2604 13.7176 19.1154 13.9276 19.9854 14.0476C20.6454 14.1376 21.2304 14.4676 21.6504 14.9626C22.0704 15.4576 22.2954 16.0876 22.2804 16.7476V19.6126C22.2804 19.9876 22.2054 20.3476 22.0554 20.6926C21.9054 21.0376 21.6954 21.3376 21.4104 21.5926C21.1404 21.8476 20.8104 22.0426 20.4654 22.1626C20.1954 22.2526 19.9104 22.2976 19.6104 22.2976L19.6554 22.3126ZM7.29542 3.18762H4.40042C4.23542 3.18762 4.08542 3.21762 3.93542 3.29262C3.78542 3.35262 3.65042 3.45762 3.54542 3.57762C3.44042 3.69762 3.35042 3.83262 3.30542 3.99762C3.26042 4.16262 3.23042 4.31262 3.24542 4.47762C3.54542 7.29762 4.52043 10.0726 6.08043 12.4576C7.49043 14.6776 9.39542 16.5826 11.6154 17.9926C14.0004 19.5376 16.7604 20.5276 19.5804 20.8276C19.7304 20.8276 19.8954 20.8276 20.0454 20.7676C20.2104 20.7076 20.3454 20.6326 20.4654 20.5276C20.5854 20.4226 20.6754 20.2876 20.7504 20.1376C20.8104 19.9876 20.8554 19.8226 20.8554 19.6576V16.7776C20.8554 16.4776 20.7654 16.1926 20.5854 15.9676C20.4054 15.7426 20.1354 15.6076 19.8504 15.5626C18.8754 15.4276 17.9154 15.1876 17.0004 14.8576C16.7904 14.7826 16.5654 14.7676 16.3404 14.8126C16.1154 14.8576 15.9204 14.9626 15.7554 15.1276L14.5404 16.3426C14.3004 16.5826 13.9254 16.6276 13.6404 16.4626C11.1204 15.0226 9.03543 12.9376 7.59543 10.4176C7.43043 10.1176 7.47542 9.75762 7.71543 9.51762L8.93043 8.30262C9.08043 8.15262 9.18543 7.94262 9.24543 7.73262C9.29043 7.50762 9.27542 7.28262 9.20043 7.07262C8.85542 6.14262 8.61543 5.18262 8.48042 4.20762C8.43542 3.93762 8.30042 3.68262 8.09042 3.48762C7.88042 3.30762 7.61042 3.20262 7.32543 3.20262L7.29542 3.18762Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M21.625 5.18182C21.832 5.18182 22 4.99855 22 4.77273C22 4.54691 21.832 4.36364 21.625 4.36364H19.375V1.90909C19.375 1.68327 19.207 1.5 19 1.5C18.793 1.5 18.625 1.68327 18.625 1.90909V4.36364H16.375C16.168 4.36364 16 4.54691 16 4.77273C16 4.99855 16.168 5.18182 16.375 5.18182H18.625V7.63636C18.625 7.86218 18.793 8.04545 19 8.04545C19.207 8.04545 19.375 7.86218 19.375 7.63636V5.18182H21.625Z",
    fill: "#007E47",
    stroke: "#007E47"
  }));
};

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowRight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ArrowRight = function ArrowRight(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#007E47" : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.7629 12C19.7629 12.4142 19.4272 12.75 19.0129 12.75L4.98718 12.75C4.57297 12.75 4.23718 12.4142 4.23718 12C4.23718 11.5858 4.57297 11.25 4.98718 11.25L19.0129 11.25C19.4272 11.25 19.7629 11.5858 19.7629 12Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.0589 18.9537C11.766 18.6608 11.766 18.1859 12.0589 17.893L18.4824 11.4695C18.7753 11.1766 19.2501 11.1766 19.543 11.4695C19.8359 11.7624 19.8359 12.2373 19.543 12.5302L13.1196 18.9537C12.8267 19.2466 12.3518 19.2466 12.0589 18.9537Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.0591 5.0462C12.352 4.75331 12.8269 4.75331 13.1198 5.0462L19.5433 11.4697C19.8362 11.7626 19.8362 12.2374 19.5433 12.5303C19.2504 12.8232 18.7755 12.8232 18.4826 12.5303L12.0591 6.10686C11.7663 5.81397 11.7663 5.33909 12.0591 5.0462Z",
    fill: color
  }));
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_module_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_module_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_SalaVip_icon__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_icons_ChipInternacional_icon__ = __webpack_require__(53);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }











var TagUpsell = '84';
var PlanCard = function PlanCard(_ref) {
  var plan = _ref.plan,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    buttonText = _ref.buttonText,
    prices = _ref.prices,
    pixDiscountMultiplier = _ref.pixDiscountMultiplier,
    providers = _ref.providers,
    match = _ref.match,
    setUpsellPurchase = _ref.setUpsellPurchase,
    _ref$sourceTags = _ref.sourceTags,
    sourceTags = _ref$sourceTags === void 0 ? [] : _ref$sourceTags;
  if (!plan) return null;
  var productPurchaseUrl = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_plan__["c" /* getProductPurchaseUrl */])(match, plan.code);
  }, [match, plan.code]);
  var hasSalaVip = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_plan__["d" /* hasBenefitCode */])(plan, '68');
  }, [plan]);
  var hasChipInternacional = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_plan__["d" /* hasBenefitCode */])(plan, '64');
  }, [plan]);
  var _ref2 = prices || {},
    finalPrice = _ref2.finalPrice,
    parcels = _ref2.parcels;
  var provider = providers.find(function (p) {
    return p.code === plan.provider_code;
  });
  var providerImgPath = provider ? "/assets/images/seguradoras/".concat(provider.slug, ".png") : '';
  var selectPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    var tags = _toConsumableArray(sourceTags);
    if (highlight) {
      __WEBPACK_IMPORTED_MODULE_7__utils_matomo__["a" /* default */].trackEvent('Conversão_Upsell', 'Clicou em fazer o upgrade - e foi para próxima etapa');
      __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].upsellAccepted(plan);
      setUpsellPurchase(plan.code);
      tags.push(TagUpsell);
    } else {
      __WEBPACK_IMPORTED_MODULE_7__utils_matomo__["a" /* default */].trackEvent('Conversão_Upsell', 'Continuar com cobertura básica');
      __WEBPACK_IMPORTED_MODULE_8__utils_dataLayer__["a" /* default */].upsellRejected(plan);
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_plan__["h" /* selectPlanAndRedirect */])(Object(__WEBPACK_IMPORTED_MODULE_4__utils_plan__["e" /* insertTagPurchaseUrl */])(productPurchaseUrl, tags));
  }, [productPurchaseUrl, highlight, setUpsellPurchase, plan.code, sourceTags]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: highlight ? __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardHighlight : __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardNormal
  }, highlight && !(hasSalaVip && hasChipInternacional) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.tag
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    role: "img",
    "aria-label": "dobro de seguran\xE7a"
  }, "\uD83D\uDEE1\uFE0F"), ' ', "Mais seguran\xE7a"), hasSalaVip && hasChipInternacional && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.badgesRow
  }, hasSalaVip && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.badgePill
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__assets_icons_SalaVip_icon__["a" /* SalaVipIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Sala VIP")), hasChipInternacional && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.badgePill
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__assets_icons_ChipInternacional_icon__["a" /* ChipInternacionalIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Chip Internacional"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardHeader
  }, providerImgPath && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    alt: plan.name,
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardImage,
    src: providerImgPath
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardTitle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, plan.name))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceValue, " ").concat(highlight ? __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceValueGreen : '')
  }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(finalPrice * pixDiscountMultiplier)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceSuffix
  }, "/ pre\xE7o por pessoa")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.priceInstallment
  }, "ou R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(finalPrice), " at\xE9 ", parcels, "x s/ juros no cart\xE3o")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: highlight ? __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.buttonPrimary : __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.buttonOutline,
    onClick: selectPlan
  }, buttonText));
};
var PlanCards = function PlanCards(_ref3) {
  var upsellPlans = _ref3.upsellPlans,
    currentPrices = _ref3.currentPrices,
    upgradePrices = _ref3.upgradePrices,
    pixDiscountMultiplier = _ref3.pixDiscountMultiplier,
    providers = _ref3.providers,
    match = _ref3.match,
    setUpsellPurchase = _ref3.setUpsellPurchase,
    upsellSourceTags = _ref3.upsellSourceTags;
  var currentPlan = upsellPlans && upsellPlans[0];
  var upgradePlan = upsellPlans && upsellPlans[1];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_6__styles_module_css___default.a.cardsContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlanCard, {
    plan: upgradePlan,
    buttonText: "Garantir cobertura recomendada",
    highlight: true,
    prices: upgradePrices,
    pixDiscountMultiplier: pixDiscountMultiplier,
    providers: providers,
    match: match,
    setUpsellPurchase: setUpsellPurchase,
    sourceTags: upsellSourceTags
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlanCard, {
    plan: currentPlan,
    buttonText: "Continuar com cobertura b\xE1sica",
    highlight: false,
    prices: currentPrices,
    pixDiscountMultiplier: pixDiscountMultiplier,
    providers: providers,
    match: match,
    sourceTags: upsellSourceTags
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    providers: state.global.providers,
    upsellSourceTags: state.search.upsellSourceTags || []
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  setUpsellPurchase: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["_29" /* setUpsellPurchase */]
})(PlanCards)));

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"_2CMK6","grid":"_3mpVe","aside":"_1EByM","plansTable":"aDLWz"};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_rdstation__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_search_searchbar_SearchBar__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_search_searchbar_SearchBarMobile__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_search_plans_table_PlansTable__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_search_comparison_bar_ComparisonBar__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_search_modal_filter_category_ModalFilterCategory__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_modal_quotation_date_year_ModalQuotationDateYear__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_modal_without_tracker_ModalWithoutTracker__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Search_css__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SeoFunctions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(20);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }


















var Search = /*#__PURE__*/function (_Component) {
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["changeTitle"])('search', props.match.params.destination);
    _this.handleApplyFilterCategory = _this.handleApplyFilterCategory.bind(_this);
    _this.handleClearAllFilterCategory = _this.handleClearAllFilterCategory.bind(_this);
    _this.state = {
      destinations: _this.props.destinations || []
    };
    return _this;
  }
  _inherits(Search, _Component);
  return _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_14__SeoFunctions__["d" /* runGoogleAdWordsConversionSearch */])();
      this.sendLoginTriggerToRDStation();
      Object(__WEBPACK_IMPORTED_MODULE_15__apiCalls__["fetchEcommerceConfigService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["s" /* searchEcommerceSettings */])(response.data));
      });
      Object(__WEBPACK_IMPORTED_MODULE_15__apiCalls__["fetchProvidersService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["t" /* searchProviderSettings */])(response.providers));
      });
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isSameDaySearch"])(this.props.match.params.begin_date) && !this.props.userDetails.operator_permissions) {
        this.props.openModalQuotationDateWarning();
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["quotationDateYear"])(this.props.match.params.begin_date, this.props.match.params.end_date)) {
        this.props.openModalQuotationDateYear();
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["verifyOriginSearchUrl"])(this.props.location.search)) {
        this.props.openModalWithoutTracker();
      }
    }
  }, {
    key: "sendLoginTriggerToRDStation",
    value: function sendLoginTriggerToRDStation() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var authCookie = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["getAuthCookie"])();
      if (!authCookie) {
        return;
      }
      var userName = '';
      var userEmail = '';
      try {
        var authData = JSON.parse(authCookie || '{}');
        if (authData.isAuthenticated) {
          userName = authData.username || '';
          userEmail = authData.email || '';
        }
      } catch (e) {
        return;
      }
      var destination = props.match.params.destination || '';
      var loginTriggerEventData = {
        name: userName,
        email: userEmail,
        searchParams: "".concat(destination, "/").concat(props.match.params.begin_date, "/").concat(props.match.params.end_date),
        departureDate: props.match.params.begin_date,
        returnDate: props.match.params.end_date
      };
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_rdstation__["a" /* triggerRdStationVerify */])(loginTriggerEventData);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.destinations !== this.props.destinations) {
        this.setState({
          destinations: this.props.destinations
        });
      }

      // mover lógica do antigo componentWillReceiveProps
      if (prevProps.location !== this.props.location) {
        this.props.setQuotationParams({
          destination: this.props.match.params.destination,
          begin_date: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(this.props.match.params.begin_date),
          end_date: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(this.props.match.params.end_date),
          context: 'search',
          product_code: '',
          benefits: [],
          queryParams: this.props.location.search
        });
      }

      // reenviar trigger de login quando parâmetros relevantes mudarem
      if (prevProps.location !== this.props.location || prevProps.match.params.destination !== this.props.match.params.destination || prevProps.match.params.begin_date !== this.props.match.params.begin_date || prevProps.match.params.end_date !== this.props.match.params.end_date) {
        this.sendLoginTriggerToRDStation();
      }
    }
  }, {
    key: "handleApplyFilterCategory",
    value: function handleApplyFilterCategory() {
      var _this$props = this.props,
        filterCategory = _this$props.filterCategory,
        filterProvider = _this$props.filterProvider;
      var categoryList = [];
      var providersList = [];
      filterCategory.forEach(function (category) {
        category.Categories.forEach(function (option) {
          if (option.selected === true) categoryList.push(option.ID);
        });
      });
      filterProvider.forEach(function (provider) {
        if (provider.selected === true) providersList.push(provider.slug);
      });
      var newUrlParams = '';
      var searchParams = window.location.search.replace('?', '').split('&');
      searchParams = searchParams.filter(function (oldCategory) {
        return !oldCategory.includes('category=') && !oldCategory.includes('provider=');
      });
      searchParams.forEach(function (param, index) {
        if (param === '') return;
        newUrlParams += index > 0 ? "&".concat(param) : "?".concat(param);
      });
      var location = newUrlParams;
      if (categoryList.length > 0) {
        if (newUrlParams !== '') {
          location += "&category=".concat(categoryList);
        } else {
          location += "?category=".concat(categoryList);
        }
      }
      if (providersList.length > 0) {
        if (newUrlParams !== '' || location.length > 1) {
          location += "&provider=".concat(providersList);
        } else {
          location += "?provider=".concat(providersList);
        }
      }
      window.history.replaceState(null, null, location);
      try {
        var _require = __webpack_require__(1),
          getFilterSearchUrl = _require.getFilterSearchUrl;
        var _require2 = __webpack_require__(6),
          getCategory = _require2.getCategory;
        var params = getFilterSearchUrl(location || window.location.search);
        getCategory(params);
      } catch (e) {}
      this.props.applyFilterCategories();
      var filtersWrapper = document.getElementById('filters-wrapper');
      if (filtersWrapper) {
        filtersWrapper.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "handleClearAllFilterCategory",
    value: function handleClearAllFilterCategory() {
      var newUrlParams = '';
      var location = '';
      var searchParams = window.location.search.replace('?', '').split('&');
      searchParams = searchParams.filter(function (oldCategory) {
        return !oldCategory.includes('category=') && !oldCategory.includes('provider=');
      });
      searchParams.forEach(function (param, index) {
        if (param === '') return;
        newUrlParams += index > 0 ? "&".concat(param) : "?".concat(param);
      });
      if (newUrlParams !== '') {
        location = newUrlParams;
      } else {
        location = window.location.pathname;
      }
      this.props.clearFilterCategories();
      window.history.replaceState(null, null, location);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.destinations) return null;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_main clearfixs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "listagem-planos".concat(this.props.comparisonPlans && this.props.comparisonPlans.length ? ' with-comparision' : '')
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "resultado-filtro"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component search-frame"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "listagem-planos"
      }, this.props.mobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_search_searchbar_SearchBarMobile__["a" /* default */], {
        searchPlan: this.searchPlan,
        destinations: this.props.destinations
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_search_searchbar_SearchBar__["a" /* default */], {
        destinations: this.props.destinations
      }), this.props.isModalWithoutTrackerActive ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_search_plans_table_PlansTable__["a" /* default */], {
        settings: this.props.ecommerce_settings,
        providers: this.props.providers,
        destinations: this.props.destinations
      })))), this.props.comparisonPlans && this.props.comparisonPlans.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_search_comparison_bar_ComparisonBar__["a" /* default */], {
        destinations: this.props.destinations
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_modal_quotation_date_year_ModalQuotationDateYear__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_modal_without_tracker_ModalWithoutTracker__["a" /* default */], {
        isModalWithoutTrackerActive: this.props.isModalWithoutTrackerActive,
        prospect: this.props.modalProspect,
        modalProspectAvaliable: this.props.modalProspectAvaliable,
        setInfosModalProspect: this.props.setInfosModalProspect,
        trackerModalValidatorHandlerBlur: this.props.trackerModalValidatorHandlerBlur,
        coupon: this.props.coupon,
        redirectToTracker: function redirectToTracker(cupom) {
          _this2.props.validateTrackerModalRedirect(_this2.props.match.params.destination, _this2.props.match.params.begin_date, _this2.props.match.params.end_date, cupom);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_search_modal_filter_category_ModalFilterCategory__["a" /* default */], {
        activeModal: this.props.isModalFilterCategoryActive,
        closeModal: this.props.closeModalFilterCategory,
        category: this.props.filterCategory,
        providers: this.props.filterProvider,
        applyFilter: this.handleApplyFilterCategory,
        clearFilter: this.handleClearAllFilterCategory
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var mapStateToProps = function mapStateToProps(state) {
  return {
    comparisonPlans: state.search.comparisonPlans,
    userDetails: state.search.userDetails,
    coupon: state.purchase.coupon,
    mobile: state.mobile.mobileActive,
    isModalWithoutTrackerActive: state.search.isModalWithoutTrackerActive,
    isModalFilterCategoryActive: state.search.isModalFilterCategoryActive,
    modalProspect: state.search.modalProspect,
    modalProspectAvaliable: state.search.modalProspectAvaliable,
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    ecommerce_settings: state.search.ecommerce_settings,
    providers: state.global.providers,
    destinations: state.global.destinations
  };
};
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  searchEcommerceSettings: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["s" /* searchEcommerceSettings */],
  searchProviderSettings: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["t" /* searchProviderSettings */],
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["r" /* removeComparisonPlan */],
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["w" /* setQuotationParams */],
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["n" /* openModalQuotationDateWarning */],
  openModalQuotationDateYear: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["o" /* openModalQuotationDateYear */],
  openModalWithoutTracker: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["q" /* openModalWithoutTracker */],
  closeModalFilterCategory: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["e" /* closeModalFilterCategory */],
  setInfosModalProspect: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["u" /* setInfosModalProspect */],
  trackerModalValidatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["C" /* trackerModalValidatorHandlerBlur */],
  validateTrackerModalRedirect: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["E" /* validateTrackerModalRedirect */],
  applyFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["b" /* applyFilterCategories */],
  clearFilterCategories: __WEBPACK_IMPORTED_MODULE_2__actions_searchActions__["d" /* clearFilterCategories */]
})(Search));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sendToRdStationLoginTriggerSearch */
/* harmony export (immutable) */ __webpack_exports__["a"] = triggerRdStationVerify;
function sendToRdStationLoginTriggerSearch(data) {
  return fetch('https://www.rdstation.com.br/api/1.3/conversions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: "Bearer 904297ddf27aa488461f1936e94791d6"
    },
    body: JSON.stringify({
      token_rdstation: '904297ddf27aa488461f1936e94791d6',
      identificador: 'sp_login',
      email: data.email,
      nome: data.name,
      searchParams: data.searchParams,
      departureDate: data.departureDate,
      returnDate: data.returnDate
    })
  });
}
function triggerRdStationVerify(newData) {
  if (!newData) return;
  var storedDataRaw = localStorage.getItem('lastLoginTriggerSearch');
  var storedData = storedDataRaw ? JSON.parse(storedDataRaw) : null;
  var isEqual = JSON.stringify(storedData) === JSON.stringify(newData);
  if (!isEqual) {
    localStorage.setItem('lastLoginTriggerSearch', JSON.stringify(newData));
    sendToRdStationLoginTriggerSearch(newData);
  }
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchIcon__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_sp_frame__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }








var addClass = function addClass(el, className) {
  el.classList.add(className);
};
var rmClass = function rmClass(el, className) {
  el.classList.remove(className);
};
var addAttr = function addAttr(el, attrName, attrValue) {
  el.setAttribute(attrName, attrValue);
};
var rmAttr = function rmAttr(el, attrName) {
  el.removeAttribute(attrName);
};
var init = function init(component, initialValues) {
  var destinationInput = document.querySelector('#destinationSp');
  var departureDateInput = document.querySelector('#departureDateInput');
  var departureDateContainer = document.querySelector('#departureDateContainer');
  var returningDateInput = document.querySelector('#returningDateInput');
  var returningDateContainer = document.querySelector('#returningDateContainer');
  var mobile = window.innerWidth <= 800;
  var destination = new __WEBPACK_IMPORTED_MODULE_5__lib_sp_frame__["a" /* default */].Destination({
    initialValue: initialValues.destination,
    input: destinationInput,
    onError: {
      INVALID_VALUE: function INVALID_VALUE() {
        addClass(destinationInput, 'is-danger');
      }
    },
    onChange: function onChange() {
      rmClass(destinationInput, 'is-danger');
      component.handleChange({
        target: {
          name: 'destination',
          value: destination.getSelected().slug
        }
      });
    }
  });
  var departureDate = new __WEBPACK_IMPORTED_MODULE_5__lib_sp_frame__["a" /* default */].Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById('ex-input-departure'),
    multipleCalendars: true,
    startDatePicker: true,
    onShow: function onShow(frame, drop) {
      addClass(departureDateContainer, 'ex-inputs-picker-visible');
      drop === 'up' ? addClass(departureDateContainer, 'ex-inputs-picker-up') : rmClass(departureDateContainer, 'ex-inputs-picker-up');
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
    },
    onChange: function onChange() {
      rmClass(departureDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE(Frame) {
        departureDateInput.value = '';
        component.handleChange({
          target: {
            name: 'begin_date',
            value: ''
          }
        });
        addClass(departureDateInput, 'is-danger');
      }
    },
    onHide: function onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(departureDateContainer, 'ex-inputs-picker-visible');
      rmClass(departureDateContainer, 'ex-inputs-picker-up');
    },
    onSelect: function onSelect(Frame) {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({
          target: {
            name: 'begin_date',
            value: Frame.departureDate.datePicker.state.start.toPtBr()
          }
        });
        this.input.value = mobile ? Frame.departureDate.datePicker.state.start.toPtBr() : Object(__WEBPACK_IMPORTED_MODULE_6__utils__["showDateVerbose"])(Frame.departureDate.datePicker.state.start.toPtBr());
        frame.returningDate.validate();
      }
    }
  });
  var returningDate = new __WEBPACK_IMPORTED_MODULE_5__lib_sp_frame__["a" /* default */].Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById('ex-input-return'),
    multipleCalendars: true,
    startDatePicker: false,
    onShow: function onShow(frame, drop) {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
      addClass(returningDateContainer, 'ex-inputs-picker-visible');
      drop === 'up' ? addClass(returningDateContainer, 'ex-inputs-picker-up') : rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onChange: function onChange(Frame) {
      rmClass(returningDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE(Frame) {
        returningDateInput.value = '';
        component.handleChange({
          target: {
            name: 'end_date',
            value: ''
          }
        });
        addClass(returningDateInput, 'is-danger');
      }
    },
    onHide: function onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(returningDateContainer, 'ex-inputs-picker-visible');
      rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onDisable: function onDisable() {
      addAttr(returningDateInput, 'disabled', 'disabled');
    },
    onEnable: function onEnable() {
      rmAttr(returningDateInput, 'disabled');
    },
    onSelect: function onSelect(Frame) {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({
          target: {
            name: 'end_date',
            value: Frame.returningDate.datePicker.state.end.toPtBr()
          }
        });
        this.input.value = mobile ? Frame.returningDate.datePicker.state.end.toPtBr() : Object(__WEBPACK_IMPORTED_MODULE_6__utils__["showDateVerbose"])(Frame.returningDate.datePicker.state.end.toPtBr());
      }
    }
  });
  var frame = new __WEBPACK_IMPORTED_MODULE_5__lib_sp_frame__["a" /* default */].Frame({
    destination: destination,
    departureDate: departureDate,
    returningDate: returningDate,
    client: false,
    openInNewTab: false
  });
  var beginDate = new Date(parseInt(initialValues.begin_date.split('/')[2], 0), parseInt(initialValues.begin_date.split('/')[1], 0) - 1, parseInt(initialValues.begin_date.split('/')[0], 0));
  var endDate = new Date(parseInt(initialValues.end_date.split('/')[2], 0), parseInt(initialValues.end_date.split('/')[1], 0) - 1, parseInt(initialValues.end_date.split('/')[0], 0));
  frame.departureDate.setStartDate(beginDate);
  frame.returningDate.setStartDate(beginDate);
  frame.departureDate.setEndDate(endDate);
  frame.returningDate.setEndDate(endDate);
};
var SearchBar = /*#__PURE__*/function (_Component) {
  function SearchBar(props) {
    var _this;
    _classCallCheck(this, SearchBar);
    _this = _callSuper(this, SearchBar, [props]);
    _defineProperty(_this, "dateDifference", function (startDate, endDate) {
      var date1 = new Date(startDate);
      var date2 = new Date(endDate);
      var difference_In_Time = date2.getTime() - date1.getTime();
      var difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
      return difference_In_Days;
    });
    _this.state = {
      destination: props.match.params.destination || '',
      begin_date: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["cleanDate"])(props.match.params.begin_date) || '',
      end_date: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["cleanDate"])(props.match.params.end_date) || '',
      destinationSelectOpen: false,
      destinations: props.destinations || []
    };
    _this.init = init.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.searchPlan = _this.searchPlan.bind(_this);
    _this.setQuotationParams = _this.props.setQuotationParams.bind(_this);
    return _this;
  }
  _inherits(SearchBar, _Component);
  return _createClass(SearchBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this, {
        destination: this.getDestinationDisplay(this.state.destination),
        begin_date: this.formatDate(this.state.begin_date),
        end_date: this.formatDate(this.state.end_date)
      });
    }
  }, {
    key: "getDestinationDisplay",
    value: function getDestinationDisplay(slug) {
      var display = this.props.destinations.filter(function (destination) {
        return destination.slug === slug;
      });
      if (display.length === 0) return this.state.destination;
      return display[0].name;
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var spl = date.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (!spl) return '';
      return "".concat(spl[3], "/").concat(spl[2], "/").concat(spl[1]);
    }
  }, {
    key: "searchPlan",
    value: function searchPlan() {
      var destination = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["getDestinationSlugByName"])(this.state.destination) || this.state.destination.toLocaleLowerCase();
      if (this.formatDate(this.state.begin_date) !== '' && this.formatDate(this.state.end_date) !== '') {
        this.props.cleanComparisonPlans();
        // this.props.filterPlansMobile();

        var search = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["buildSearchWithDestinationCategories"])(this.props.destinations, destination);
        var path = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatURL"])(this.props.match.params, "/pesquisa/".concat(destination, "/").concat(this.state.begin_date, "/").concat(this.state.end_date), search, !search);
        this.props.history.push(path);
      }
      __WEBPACK_IMPORTED_MODULE_7__utils_dataLayer__["a" /* default */].raw({
        event: 'envio_form_cotacao',
        page_category: 'home',
        tipo_envio: 'novo_lead',
        cotacao: {
          destino: destination,
          data_embarque: this.state.begin_date,
          data_desembarque: this.state.end_date,
          tempo_permanencia: this.dateDifference(this.state.begin_date, this.state.end_date)
        }
      });
      __WEBPACK_IMPORTED_MODULE_7__utils_dataLayer__["a" /* default */].searchSubmitted(destination, this.state.begin_date, this.state.end_date);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (e.target.name === 'begin_date' || e.target.name === 'end_date') {
        var spl_date = e.target.value.split('/');
        var val = "".concat(spl_date[2], "-").concat(spl_date[1], "-").concat(spl_date[0]);
        e.target.value = val;
      }
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: "render",
    value: function render() {
      var diffDays = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["getDaysDiff"])(new Date(this.state.begin_date), new Date(this.state.end_date));
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "filtro flex section-search"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "you-search"
      }, "Voc\xEA pesquisou por:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        className: "flex buscar-destino ",
        id: "date_container"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "continente",
        className: "group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "destiny",
        className: "label-content label-destiny",
        "data-title": "Destino"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        id: "destinationSp",
        className: "control destiny",
        type: "text",
        name: "destination",
        value: this.getDestinationDisplay(this.state.destination),
        readOnly: true,
        "data-cy": "search-frame-destino"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/arrowUp.svg",
        alt: "icone seta",
        className: "label-destiny-chevron"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "ex-input-departure",
        className: "ex-inputs group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "departureDateInput",
        className: "label-content",
        "data-title": "Partida"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "control go",
        name: "departureDate",
        value: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["showDateVerbose"])(this.state.begin_date) || 'Ida',
        type: "text",
        id: "departureDateInput",
        readOnly: true,
        "data-cy": "search-frame-partida"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "departureDateContainer",
        className: "ex-inputs-picker"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "ex-input-return",
        className: "ex-inputs group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "returningDateInput",
        className: "label-content",
        "data-title": "Retorno"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "control return last-back",
        name: "returningDate",
        value: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["showDateVerbose"])(this.state.end_date) || '',
        type: "text",
        id: "returningDateInput",
        readOnly: true,
        "data-cy": "search-frame-retorno"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "returningDateContainer",
        className: "ex-inputs-picker"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        className: "ic-button"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        name: "submit",
        value: "",
        className: "button-search update",
        id: "searchBtn",
        onClick: this.searchPlan,
        "data-cy": "search-frame-pesquisar"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SearchIcon__["a" /* default */], null), "Buscar"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "days-permanence"
      }, "Perman\xEAncia: ", !Number.isNaN(diffDays) && diffDays + ' dias')));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    destinations: state.global.destinations
  };
}, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["w" /* setQuotationParams */],
  cleanComparisonPlans: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["c" /* cleanComparisonPlans */]
})(SearchBar)));

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__infos_mobile_InfosMobile__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Searchbar_css__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Searchbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Searchbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_sp_frame__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint class-methods-use-this:0 */








var addClass = function addClass(el, className) {
  el.classList.add(className);
};
var rmClass = function rmClass(el, className) {
  el.classList.remove(className);
};
var addAttr = function addAttr(el, attrName, attrValue) {
  el.setAttribute(attrName, attrValue);
};
var rmAttr = function rmAttr(el, attrName) {
  el.removeAttribute(attrName);
};
var init = function init(component, initialValues) {
  var destinationInput = document.querySelector('#destinationSp');
  var departureDateInput = document.querySelector('#departureDateInput');
  var departureDateContainer = document.querySelector('#departureDateContainer');
  var returningDateInput = document.querySelector('#returningDateInput');
  var returningDateContainer = document.querySelector('#returningDateContainer');
  var mobile = window.innerWidth <= 800;
  var destination = new __WEBPACK_IMPORTED_MODULE_6__lib_sp_frame__["a" /* default */].Destination({
    initialValue: initialValues.destination,
    input: destinationInput,
    onError: {
      INVALID_VALUE: function INVALID_VALUE() {
        addClass(destinationInput, 'is-danger');
      }
    },
    onChange: function onChange() {
      rmClass(destinationInput, 'is-danger');
      component.handleChange({
        target: {
          name: 'destination',
          value: destination.getSelected().slug
        }
      });
    }
  });
  var departureDate = new __WEBPACK_IMPORTED_MODULE_6__lib_sp_frame__["a" /* default */].Period({
    input: departureDateInput,
    dateContainer: departureDateContainer,
    container: document.getElementById('ex-input-departure'),
    multipleCalendars: true,
    startDatePicker: true,
    onShow: function onShow(frame, drop) {
      addClass(departureDateContainer, 'ex-inputs-picker-visible');
      drop === 'up' ? addClass(departureDateContainer, 'ex-inputs-picker-up') : rmClass(departureDateContainer, 'ex-inputs-picker-up');
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
    },
    onChange: function onChange() {
      rmClass(departureDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE(Frame) {
        departureDateInput.value = '';
        component.handleChange({
          target: {
            name: 'begin_date',
            value: ''
          }
        });
        addClass(departureDateInput, 'is-danger');
      }
    },
    onHide: function onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(departureDateContainer, 'ex-inputs-picker-visible');
      rmClass(departureDateContainer, 'ex-inputs-picker-up');
    },
    onSelect: function onSelect(Frame) {
      if (frame.departureDate.datePicker.state.start) {
        component.handleChange({
          target: {
            name: 'begin_date',
            value: Frame.departureDate.datePicker.state.start.toPtBr()
          }
        });
        this.input.value = mobile ? Frame.departureDate.datePicker.state.start.toPtBr() : Object(__WEBPACK_IMPORTED_MODULE_7__utils__["showDateVerbose"])(Frame.departureDate.datePicker.state.start.toPtBr());
        frame.returningDate.validate();
      }
    }
  });
  var returningDate = new __WEBPACK_IMPORTED_MODULE_6__lib_sp_frame__["a" /* default */].Period({
    input: returningDateInput,
    dateContainer: returningDateContainer,
    container: document.getElementById('ex-input-return'),
    multipleCalendars: true,
    startDatePicker: false,
    onShow: function onShow(frame, drop) {
      if (window.innerWidth <= 640) {
        addClass(document.querySelector('html'), 'overflow-hidden');
        addClass(document.querySelector('body'), 'overflow-hidden');
      }
      addClass(returningDateContainer, 'ex-inputs-picker-visible');
      drop === 'up' ? addClass(returningDateContainer, 'ex-inputs-picker-up') : rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onChange: function onChange(Frame) {
      rmClass(returningDateInput, 'is-danger');
    },
    onError: {
      INVALID_VALUE: function INVALID_VALUE(Frame) {
        returningDateInput.value = '';
        component.handleChange({
          target: {
            name: 'end_date',
            value: ''
          }
        });
        addClass(returningDateInput, 'is-danger');
      }
    },
    onHide: function onHide(Frame) {
      if (window.innerWidth <= 640) {
        rmClass(document.querySelector('html'), 'overflow-hidden');
        rmClass(document.querySelector('body'), 'overflow-hidden');
      }
      rmClass(returningDateContainer, 'ex-inputs-picker-visible');
      rmClass(returningDateContainer, 'ex-inputs-picker-up');
    },
    onDisable: function onDisable() {
      addAttr(returningDateInput, 'disabled', 'disabled');
    },
    onEnable: function onEnable() {
      rmAttr(returningDateInput, 'disabled');
    },
    onSelect: function onSelect(Frame) {
      if (frame.returningDate.datePicker.state.end) {
        component.handleChange({
          target: {
            name: 'end_date',
            value: Frame.returningDate.datePicker.state.end.toPtBr()
          }
        });
        this.input.value = mobile ? Frame.returningDate.datePicker.state.end.toPtBr() : Object(__WEBPACK_IMPORTED_MODULE_7__utils__["showDateVerbose"])(Frame.returningDate.datePicker.state.end.toPtBr());
      }
    }
  });
  var frame = new __WEBPACK_IMPORTED_MODULE_6__lib_sp_frame__["a" /* default */].Frame({
    destination: destination,
    departureDate: departureDate,
    returningDate: returningDate,
    client: false,
    openInNewTab: false
  });
  var beginDate = new Date(parseInt(initialValues.begin_date.split('/')[2], 0), parseInt(initialValues.begin_date.split('/')[1], 0) - 1, parseInt(initialValues.begin_date.split('/')[0], 0));
  var endDate = new Date(parseInt(initialValues.end_date.split('/')[2], 0), parseInt(initialValues.end_date.split('/')[1], 0) - 1, parseInt(initialValues.end_date.split('/')[0], 0));
  frame.departureDate.setStartDate(beginDate);
  frame.returningDate.setStartDate(beginDate);
  frame.departureDate.setEndDate(endDate);
  frame.returningDate.setEndDate(endDate);
};
var SearchBarMobile = /*#__PURE__*/function (_Component) {
  function SearchBarMobile(props) {
    var _this;
    _classCallCheck(this, SearchBarMobile);
    _this = _callSuper(this, SearchBarMobile, [props]);
    _this.state = {
      destination: props.match.params.destination || '',
      begin_date: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["cleanDate"])(props.match.params.begin_date) || '',
      end_date: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["cleanDate"])(props.match.params.end_date) || '',
      infoStyle: {},
      searchbarStyle: {
        display: 'none'
      },
      destinations: props.destinations || []
    };
    _this.init = init.bind(_this);
    _this.searchPlan = _this.searchPlan.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.setQuotationParams = _this.props.setQuotationParams.bind(_this);
    return _this;
  }
  _inherits(SearchBarMobile, _Component);
  return _createClass(SearchBarMobile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this, {
        destination: this.getDestinationDisplay(this.state.destination),
        begin_date: this.formatDate(this.state.begin_date),
        end_date: this.formatDate(this.state.end_date)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.destinations !== this.props.destinations) {
        this.setState({
          destinations: this.props.destinations
        });
      }
    }
  }, {
    key: "getDestinationDisplay",
    value: function getDestinationDisplay(slug) {
      if (!this.state.destinations.length) return '';
      var display = this.state.destinations.filter(function (destination) {
        return destination.slug === slug;
      });
      if (!display.length) return '';
      return display[0].name;
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var spl = date.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (!spl) return '';
      return "".concat(spl[3], "/").concat(spl[2], "/").concat(spl[1]);
    }
  }, {
    key: "searchPlan",
    value: function searchPlan() {
      if (this.formatDate(this.state.begin_date) !== '' && this.formatDate(this.state.end_date) !== '') {
        this.props.cleanComparisonPlans();
        this.props.filterPlansMobile();
        var path = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatURL"])(this.props.match.params, "/pesquisa/".concat(this.state.destination, "/").concat(this.state.begin_date, "/").concat(this.state.end_date));
        this.props.history.push(path);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (e.target.name === 'begin_date' || e.target.name === 'end_date') {
        var splDate = e.target.value.split('/');
        var val = "".concat(splDate[2], "-").concat(splDate[1], "-").concat(splDate[0]);
        e.target.value = val;
      }
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component search-mobile ".concat(this.props.searchState && 'open')
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "search-mobile-plans"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__infos_mobile_InfosMobile__["a" /* default */], {
        destinations: this.props.destinations
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "text-searchbar"
      }, "Editar pesquisa"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        id: "date_container"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        htmlFor: "continente",
        className: "group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "destiny",
        className: "label-content label-destiny",
        "data-title": "Destino"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        id: "destinationSp",
        className: "control destiny",
        type: "text",
        name: "destination",
        value: this.getDestinationDisplay(this.state.destination) || '',
        readOnly: true,
        "data-cy": "search-frame-destino"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "group-ex-input-departure-return-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "ex-input-departure",
        className: "ex-inputs group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "departureDateInput",
        className: "label-content",
        "data-title": "Partida"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "control go",
        name: "departureDate",
        value: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatDate"])(this.state.begin_date) || 'Ida',
        type: "text",
        id: "departureDateInput",
        readOnly: true,
        "data-cy": "search-frame-partida"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "departureDateContainer",
        className: "ex-inputs-picker"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "ex-input-return",
        className: "ex-inputs group"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "returningDateInput",
        className: "label-content",
        "data-title": "Retorno"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "control return last-back",
        name: "returningDate",
        value: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatDate"])(this.state.end_date) || '',
        type: "text",
        id: "returningDateInput",
        readOnly: true,
        "data-cy": "search-frame-retorno"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        id: "returningDateContainer",
        className: "ex-inputs-picker"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-submit",
        "data-cy": "search-frame-mobile-pesquisar"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "button",
        name: "submit",
        value: "Atualizar pesquisa",
        className: "control update",
        id: "searchBtn",
        onClick: this.searchPlan
      })))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    searchState: state.search.searchState,
    destinations: state.global.destinations
  };
}, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["w" /* setQuotationParams */],
  cleanComparisonPlans: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["c" /* cleanComparisonPlans */],
  filterPlansMobile: __WEBPACK_IMPORTED_MODULE_5__actions_searchActions__["l" /* filterPlansMobile */]
})(SearchBarMobile)));

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_standard_loading_Loading__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__infos_mobile_InfosMobile__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Filters_FilterWrapper__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Filters_ActiveFilters__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlansListing__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SpecialistBlock__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Plan__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HighligthPlans__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_plan__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
















function PlansTableWrapper(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PlansTable, props);
}
var PlansTable = /*#__PURE__*/function (_Component) {
  function PlansTable(props) {
    var _this;
    _classCallCheck(this, PlansTable);
    _this = _callSuper(this, PlansTable, [props]);
    _defineProperty(_this, "processHighlightPlans", function (plans) {
      return plans.map(function (plan) {
        var priceWithDiscount = Object(__WEBPACK_IMPORTED_MODULE_12__utils_plan__["a" /* calcCouponDiscount */])(plan, _this.props.coupon);
        var finalPrice = priceWithDiscount || plan.price.adult.price;
        return _objectSpread(_objectSpread({}, plan), {}, {
          price_with_coupon_discount: priceWithDiscount,
          parcels: Object(__WEBPACK_IMPORTED_MODULE_12__utils_plan__["g" /* maxValueParcel */])(finalPrice)
        });
      });
    });
    _defineProperty(_this, "reprocessHighlightPlansWithCoupon", function () {
      if (_this.state.originalHighlightPlans.length > 0) {
        var processedPlans = _this.processHighlightPlans(_this.state.originalHighlightPlans);
        _this.props.storeHighligthPlans(processedPlans);
      }
    });
    _defineProperty(_this, "loadHighlightPlans", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var highlightPlans, processedPlans, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["fetchHighlightPlans"])(_this.props.match.params);
          case 1:
            highlightPlans = _context.v;
            _this.setState({
              originalHighlightPlans: highlightPlans
            });
            processedPlans = _this.processHighlightPlans(highlightPlans);
            _this.props.storeHighligthPlans(processedPlans);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('Erro ao carregar planos em destaque:', _t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    })));
    _this.state = {
      originalHighlightPlans: []
    };
    _this.setProviderFilter = _this.setProviderFilter.bind(_this);
    _this.setSortOption = _this.setSortOption.bind(_this);
    _this.addComparisonPlan = _this.addComparisonPlan.bind(_this);
    _this.changeLocation = _this.changeLocation.bind(_this);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    _this.setQuotationParams = _this.props.setQuotationParams.bind(_this);
    _this.handleUnselectFilterCategory = _this.handleUnselectFilterCategory.bind(_this);
    _this.handleClearAllFilterCategory = _this.handleClearAllFilterCategory.bind(_this);
    return _this;
  }
  _inherits(PlansTable, _Component);
  return _createClass(PlansTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadHighlightPlans();
      this.setQuotationParams({
        begin_date: Object(__WEBPACK_IMPORTED_MODULE_15__utils__["cleanDate"])(this.props.match.params.begin_date),
        end_date: Object(__WEBPACK_IMPORTED_MODULE_15__utils__["cleanDate"])(this.props.match.params.end_date),
        destination: this.props.match.params.destination,
        context: 'search',
        benefits: ['51', '42', '57', '55', '45', '68', '69']
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.coupon !== this.props.coupon) {
        this.reprocessHighlightPlansWithCoupon();
      }

      // Fix footer position for desktop only when comparison plans bottomsheet
      if (!this.props.mobile && this.props.comparisonPlans && this.props.comparisonPlans.length > 0) {
        var compFooter = document.getElementsByClassName('comp_footer hide-mobile');
        if (compFooter && compFooter.length) {
          compFooter[0].style = 'padding-bottom: 150px';
        }
      } else {
        // rollback footer position
        var _compFooter = document.getElementsByClassName('comp_footer hide-mobile');
        if (_compFooter && _compFooter.length) {
          _compFooter[0].style = '';
        }
      }
    }
  }, {
    key: "setProviderFilter",
    value: function setProviderFilter(value) {
      this.props.setProviderFilter(value);
      this.props.filterPlans();
    }
  }, {
    key: "setSortOption",
    value: function setSortOption(value) {
      this.props.setSortOption(value);
      this.props.filterPlans();
    }
  }, {
    key: "goToSearchPage",
    value: function goToSearchPage() {
      this.props.history.push('/site');
    }
  }, {
    key: "addComparisonPlan",
    value: function addComparisonPlan(plan) {
      var equalPlans = this.props.comparisonPlans.filter(function (comparisonPlan) {
        return comparisonPlan.code === plan.code;
      });
      if (equalPlans.length > 0) this.props.removeComparisonPlan(plan.code);else if (this.props.comparisonPlans.length < 4) this.props.addComparisonPlan(plan);
    }
  }, {
    key: "changeLocation",
    value: function changeLocation(location) {
      this.props.history.push(Object(__WEBPACK_IMPORTED_MODULE_15__utils__["formatURL"])(this.props.match.params, location.pathname));
    }
  }, {
    key: "handleClearAllFilterCategory",
    value: function handleClearAllFilterCategory() {
      var newUrlParams = '';
      var location = '';
      var searchParams = window.location.search.replace('?', '').split('&');
      searchParams = searchParams.filter(function (oldCategory) {
        return !oldCategory.includes('category=') && !oldCategory.includes('provider=');
      });
      searchParams.forEach(function (param, index) {
        if (param === '') return;
        newUrlParams += index > 0 ? "&".concat(param) : "?".concat(param);
      });
      if (newUrlParams !== '') {
        location = newUrlParams;
      } else {
        location = window.location.pathname;
      }
      this.props.clearFilterCategories();
      window.history.replaceState(null, null, location);
    }
  }, {
    key: "handleUnselectFilterCategory",
    value: function handleUnselectFilterCategory(type_category, category_index) {
      var option_index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var searchParams = window.location.search.replace('?', '').split('&');
      var newUrl = '';
      if (type_category === 'category') {
        var categorySelected = this.props.filterCategory[category_index].Categories[option_index].ID;
        var newCategoryParam = searchParams.find(function (param) {
          return param.includes('category=');
        }) || '';
        if (newCategoryParam) {
          if (newCategoryParam === "category=".concat(categorySelected)) {
            newCategoryParam = '';
          } else if (newCategoryParam.endsWith(",".concat(categorySelected))) {
            newCategoryParam = newCategoryParam.replace(",".concat(categorySelected), '');
          } else {
            newCategoryParam = newCategoryParam.replace("".concat(categorySelected, ","), '');
          }
        }
        var otherParams = searchParams.filter(function (param) {
          return !param.includes('category=') && param !== '';
        });
        var allParams = newCategoryParam ? [].concat(_toConsumableArray(otherParams), [newCategoryParam]) : otherParams;
        newUrl = allParams.length > 0 ? "?".concat(allParams.join('&')) : window.location.pathname;
      } else if (type_category === 'provider') {
        var providerSelected = this.props.filterProvider[category_index].slug;
        var newProviderParam = searchParams.find(function (param) {
          return param.includes('provider=');
        }) || '';
        if (newProviderParam) {
          if (newProviderParam === "provider=".concat(providerSelected)) {
            newProviderParam = '';
          } else if (newProviderParam.endsWith(",".concat(providerSelected))) {
            newProviderParam = newProviderParam.replace(",".concat(providerSelected), '');
          } else {
            newProviderParam = newProviderParam.replace("".concat(providerSelected, ","), '');
          }
        }
        var _otherParams = searchParams.filter(function (param) {
          return !param.includes('provider=') && param !== '';
        });
        var _allParams = newProviderParam ? [].concat(_toConsumableArray(_otherParams), [newProviderParam]) : _otherParams;
        newUrl = _allParams.length > 0 ? "?".concat(_allParams.join('&')) : window.location.pathname;
      }
      this.props.unselectFilterCategoryOptions(type_category, category_index, option_index);
      window.history.replaceState(null, null, newUrl);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var selectedPlans = (this.props.comparisonPlans || []).map(function (plan) {
        return plan.code;
      });
      if (this.props.loading) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_standard_loading_Loading__["b" /* default */], null);
      var filteredPlans = Object(__WEBPACK_IMPORTED_MODULE_15__utils__["maxValueParcel"])(this.props.filtered_plans || []);
      var suggestedPlans = Object(__WEBPACK_IMPORTED_MODULE_15__utils__["maxValueParcel"])(this.props.suggestions_plans || []);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "resultado-filtro"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__infos_mobile_InfosMobile__["a" /* default */], {
        destinations: this.props.destinations
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HighligthPlans__["a" /* default */], {
        mobile: this.props.mobile,
        providers: this.props.providers,
        match: this.props.match,
        selectedPlans: selectedPlans,
        addComparisonPlan: this.addComparisonPlan,
        userDetails: this.props.userDetails,
        plans: this.props.highlightPlans
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "filter-specialist-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Filters_FilterWrapper__["a" /* default */], {
        providers: this.props.providers,
        sortOptions: this.props.sortOptions,
        sort_option: this.props.sort_option,
        selectedSortOption: this.props.sort_option,
        setSortOption: this.setSortOption,
        setProviderFilter: this.setProviderFilter,
        mobile: this.props.mobile,
        provider: this.props.providerOption,
        openModalFilterCategory: this.props.openModalFilterCategory,
        handleClearAllFilterCategory: this.handleClearAllFilterCategory,
        handleUnselectFilterCategory: this.handleUnselectFilterCategory,
        filterCategory: this.props.filterCategory,
        filterProvider: this.props.filterProvider,
        settings: this.props.settings,
        plansLength: this.props.filtered_plans && this.props.filtered_plans.length || 0
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SpecialistBlock__["a" /* default */], null)), !this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Filters_ActiveFilters__["a" /* default */], {
        filterCategory: this.props.filterCategory,
        filterProvider: this.props.filterProvider,
        handleUnselectFilterCategory: this.handleUnselectFilterCategory,
        handleClearAllFilterCategory: this.handleClearAllFilterCategory,
        variant: "v1"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, filteredPlans.length === 0 && suggestedPlans.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "filter-box-not-found"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "ops"
      }, "Ops!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "N\xE3o h\xE1 planos com a combina\xE7\xE3o de filtro selecionada para esta", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " viagem, tente outra combina\xE7\xE3o.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "suggestion-plans-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Talvez voc\xEA se interesse por estas op\xE7\xF4es:")), suggestedPlans.map(function (plan, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Plan__["a" /* default */], {
          plan: plan,
          key: plan.code,
          match: _this2.props.match,
          changeLocation: _this2.changeLocation,
          getProductInfo: _this2.props.getProductInfo,
          addComparisonPlan: _this2.addComparisonPlan,
          history: _this2.props.history,
          isSelected: selectedPlans.indexOf(plan.code.toString()) >= 0,
          mobile: _this2.props.mobile,
          mobileActive: function mobileActive() {
            return _this2.props.mobileActive();
          },
          openModalQuotationDateWarning: function openModalQuotationDateWarning() {
            return _this2.props.openModalQuotationDateWarning();
          },
          userDetails: _this2.props.userDetails,
          position: i,
          providers: _this2.props.providers,
          showSpecialistSuggestions: _this2.props.showSpecialistSuggestions
        });
      })), filteredPlans[0] !== undefined && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PlansListing__["a" /* default */], {
        filteredPlans: filteredPlans,
        selectedPlans: selectedPlans,
        match: this.props.match,
        changeLocation: this.changeLocation,
        getProductInfo: this.props.getProductInfo,
        addComparisonPlan: this.addComparisonPlan,
        history: this.props.history,
        mobile: this.props.mobile,
        mobileActive: function mobileActive() {
          return _this2.props.mobileActive();
        },
        openModalQuotationDateWarning: function openModalQuotationDateWarning() {
          return _this2.props.openModalQuotationDateWarning();
        },
        userDetails: this.props.userDetails,
        providers: this.props.providers,
        showSpecialistSuggestions: this.props.showSpecialistSuggestions
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    loading: state.search.loading,
    end_date: state.search.end_date,
    providers: state.search.providers,
    begin_date: state.search.begin_date,
    destination: state.search.destination,
    sortOptions: state.search.sortOptions,
    sort_option: state.search.sort_option,
    filtered_plans: state.search.filtered_plans,
    suggestions_plans: state.search.suggestions_plans,
    comparisonPlans: state.search.comparisonPlans,
    searchState: state.search.searchState,
    mobile: state.mobile.mobileActive,
    userDetails: state.search.userDetails,
    providerOption: state.search.provider_option,
    filterCategory: state.search.filterCategory,
    filterProvider: state.search.filterProvider,
    highlightPlans: state.search.highlightPlans,
    benefits: state.purchase.benefits,
    coupon: state.purchase.coupon,
    showSpecialistSuggestions: state.search.showSpecialistSuggestions
  };
}, {
  filterPlans: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["k" /* filterPlans */],
  setSortOption: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["x" /* setSortOption */],
  getProductInfo: __WEBPACK_IMPORTED_MODULE_13__actions_coverageActions__["b" /* getProductInfo */],
  setProviderFilter: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["v" /* setProviderFilter */],
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["a" /* addComparisonPlan */],
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["w" /* setQuotationParams */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["r" /* removeComparisonPlan */],
  filterPlansMobile: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["l" /* filterPlansMobile */],
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["n" /* openModalQuotationDateWarning */],
  openModalFilterCategory: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["m" /* openModalFilterCategory */],
  clearFilterCategories: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["d" /* clearFilterCategories */],
  unselectFilterCategoryOptions: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["D" /* unselectFilterCategoryOptions */],
  storeHighligthPlans: __WEBPACK_IMPORTED_MODULE_14__actions_searchActions__["A" /* storeHighligthPlans */]
})(PlansTableWrapper)));

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Filter__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActiveFilters__ = __webpack_require__(30);



var FilterWrapper = function FilterWrapper(_ref) {
  var providers = _ref.providers,
    sortOptions = _ref.sortOptions,
    sort_option = _ref.sort_option,
    selectedSortOption = _ref.selectedSortOption,
    setSortOption = _ref.setSortOption,
    setProviderFilter = _ref.setProviderFilter,
    mobile = _ref.mobile,
    provider = _ref.provider,
    openModalFilterCategory = _ref.openModalFilterCategory,
    handleClearAllFilterCategory = _ref.handleClearAllFilterCategory,
    handleUnselectFilterCategory = _ref.handleUnselectFilterCategory,
    filterCategory = _ref.filterCategory,
    filterProvider = _ref.filterProvider,
    settings = _ref.settings,
    plansLength = _ref.plansLength;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var containsProvider = window.location.href.includes('provider=');
    var filtersWrapper = document.getElementById('filters-wrapper');
    if (filtersWrapper && containsProvider) {
      filtersWrapper.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "filter-wrapper",
    id: "filters-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "wrapper-column"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "plans-headsup"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "plans-quantity"
  }, "Encontramos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", {
    className: "text-green"
  }, plansLength || 0, " seguros viagem")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Escolhemos os melhores planos para sua viagem de acordo com seu destino e tempo de perman\xEAncia.")), plansLength > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Filter__["a" /* default */], {
    setSortOption: setSortOption,
    providers: providers,
    sortOptions: sortOptions,
    sort_option: sort_option,
    selectedSortOption: selectedSortOption,
    setProviderFilter: setProviderFilter,
    mobile: mobile,
    provider: provider,
    openModalFilterCategory: openModalFilterCategory,
    clearFilter: handleClearAllFilterCategory,
    unselectFilterCategoryOptions: handleUnselectFilterCategory,
    filterCategory: filterCategory,
    filterProvider: filterProvider,
    ecommerce_config: settings
  })), mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ActiveFilters__["a" /* default */], {
    filterCategory: filterCategory,
    filterProvider: filterProvider,
    handleUnselectFilterCategory: handleUnselectFilterCategory,
    handleClearAllFilterCategory: handleClearAllFilterCategory,
    variant: "v1"
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (FilterWrapper);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var Filter = function Filter(_ref) {
  var sort_option = _ref.sort_option,
    sortOptions = _ref.sortOptions,
    ecommerce_config = _ref.ecommerce_config,
    openModalFilterCategory = _ref.openModalFilterCategory,
    setSortOption = _ref.setSortOption;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var buttonRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var selectedSortOptionObj = sortOptions.find(function (sort) {
    return sort.name === sort_option;
  });
  var selectedSortOption = selectedSortOptionObj ? selectedSortOptionObj.displayName : '';
  var handleToggle = function handleToggle() {
    return setIsOpened(function (prev) {
      return !prev;
    });
  };
  var dropdownWidth = buttonRef.current && buttonRef.current.offsetWidth ? buttonRef.current.offsetWidth : 185;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
    className: "plans-filtering-section"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "plans-filtering-list"
  }, ecommerce_config.filter && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "btn-filter categoria-filtro",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof openModalFilterCategory === 'function') openModalFilterCategory();
    },
    "data-cy": "filtrar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/filter.svg",
    alt: "Icone filtro"
  }), "Filtrar por"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, isOpened && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "overlay-dropdown",
    onClick: handleToggle,
    "aria-hidden": "true"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "filter-dropdown",
    "data-cy": "filtro-ordenar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    ref: buttonRef,
    className: "btn-filter ordenar-filtro",
    onClick: handleToggle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/switch.svg",
    alt: "Icone shape",
    className: "icon-shape-filtro"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, selectedSortOption)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/arrowUp.svg",
    alt: "Icon arrow",
    className: "icon-arrow-filtro-".concat(isOpened ? 'open' : '')
  })), isOpened && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "filter-dropdown-content open",
    style: {
      width: "".concat(dropdownWidth, "px"),
      maxWidth: 'none'
    },
    onClick: handleToggle
  }, sortOptions.map(function (option, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      key: index,
      className: "filter-dropdown-item ".concat(index > 0 ? 'filter-divider' : ''),
      onClick: function onClick() {
        return setSortOption(option.name);
      }
    }, option.displayName);
  }))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Filter);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Plan__ = __webpack_require__(97);




var PlansListing = function PlansListing(_ref) {
  var filteredPlans = _ref.filteredPlans,
    selectedPlans = _ref.selectedPlans,
    match = _ref.match,
    changeLocation = _ref.changeLocation,
    getProductInfo = _ref.getProductInfo,
    addComparisonPlan = _ref.addComparisonPlan,
    history = _ref.history,
    mobile = _ref.mobile,
    _mobileActive = _ref.mobileActive,
    _openModalQuotationDateWarning = _ref.openModalQuotationDateWarning,
    userDetails = _ref.userDetails,
    providers = _ref.providers,
    showSpecialistSuggestions = _ref.showSpecialistSuggestions;
  var firstPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return filteredPlans[0];
  }, [filteredPlans]);
  var isFirstPlanComparisionSelected = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return !!selectedPlans.find(function (code) {
      return code === firstPlan.code || '';
    });
  }, [selectedPlans, firstPlan]);
  var isFirstPlanSpecialist = firstPlan.extra.specialist_indicator && showSpecialistSuggestions;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_2__apiCalls__["getCategory"])(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getFilterSearchUrl"])(window.location.search));
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "tb-resultado-filtro",
    key: 2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "head-resultado-filtro flex".concat(isFirstPlanSpecialist ? ' yellow-border' : '').concat(isFirstPlanComparisionSelected ? ' purple-border' : '', " ")
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "item-head"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Seguradora")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "item-head"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Plano")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "item-head"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Despesa m\xE9dica e seguro bagagem")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "item-head flex"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Total por segurado"))), filteredPlans.map(function (plan, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Plan__["a" /* default */], {
      plan: plan,
      key: plan.code,
      match: match,
      changeLocation: changeLocation,
      getProductInfo: getProductInfo,
      addComparisonPlan: addComparisonPlan,
      history: history,
      isSelected: selectedPlans.indexOf(plan.code.toString()) >= 0,
      mobile: mobile,
      mobileActive: function mobileActive() {
        return _mobileActive();
      },
      openModalQuotationDateWarning: function openModalQuotationDateWarning() {
        return _openModalQuotationDateWarning();
      },
      userDetails: userDetails,
      position: i,
      providers: providers,
      showSpecialistSuggestions: showSpecialistSuggestions
    });
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (PlansListing);

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComparisonItem__ = __webpack_require__(261);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var ComparisonBar = /*#__PURE__*/function (_Component) {
  function ComparisonBar(props) {
    var _this;
    _classCallCheck(this, ComparisonBar);
    _this = _callSuper(this, ComparisonBar, [props]);
    _this.comparePlans = _this.comparePlans.bind(_this);
    return _this;
  }
  _inherits(ComparisonBar, _Component);
  return _createClass(ComparisonBar, [{
    key: "comparePlans",
    value: function comparePlans() {
      var selectedPlans = this.props.plans.map(function (plan) {
        return plan.code;
      });
      var basePath = '/seguro-viagem/comparacao';
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isB2b"])()) basePath = '/seguro-viagem/comparacao-b2b';
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match.params, basePath + '/' + this.props.match.params.destination + '/' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(this.props.match.params.begin_date) + '/' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["cleanDate"])(this.props.match.params.end_date) + '/?products_ids=' + selectedPlans.join('+'))
      };
      this.props.history.push(location);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var plans = [{}, {}, {}, {}];
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isMobile"])()) plans = [{}, {}];
      plans = plans.map(function (plan, i) {
        return _this2.props.plans[i] || plan;
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "planos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "planos-comparar flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "escolha"
      }, "Escolha de 2 a 4 planos para fazer uma compara\xE7\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "planos-selecionados flex"
      }, plans.map(function (plan, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ComparisonItem__["a" /* default */], {
          key: i,
          removeComparisonPlan: _this2.props.removeComparisonPlan,
          plan: plan,
          position: i,
          providers: _this2.props.providers
        });
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "btn-compare",
        onClick: this.comparePlans,
        disabled: this.props.plans.length <= 1,
        "data-cy": "botao-comparar"
      }, "Comparar"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var mapStateToProps = function mapStateToProps(state) {
  return {
    plans: state.search.comparisonPlans,
    providers: state.global.providers
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  addComparisonPlan: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["a" /* addComparisonPlan */],
  removeComparisonPlan: __WEBPACK_IMPORTED_MODULE_3__actions_searchActions__["r" /* removeComparisonPlan */]
})(ComparisonBar)));

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ComparisonItem = function ComparisonItem(_ref) {
  var plan = _ref.plan,
    providers = _ref.providers,
    removeComparisonPlan = _ref.removeComparisonPlan,
    position = _ref.position;
  if (!plan.code) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "item-selected-plans not-selected"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "desktop"
    }, "Selecione outro seguro para comparar"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "mobile"
    }, "Selecione outro plano"));
  }
  var providerImgPath = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var provider = providers.find(function (provider) {
      return provider.code === plan.provider_code;
    });
    return provider ? "/assets/images/seguradoras/".concat(provider.slug, ".png") : '';
  }, [providers, plan.provider_code]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "item-selected-plans",
    onClick: function onClick() {
      return removeComparisonPlan(plan.code);
    },
    "data-cy": "plano-selecionado-p".concat(position)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "delete"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/pagamento/excluir.svg",
    alt: "Excluir plano"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "mini"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: providerImgPath,
    alt: plan.provider_code ? 'Provider logo' : 'Sem logo'
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (ComparisonItem);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



function ModalFilterCategory(_ref) {
  var category = _ref.category,
    providers = _ref.providers,
    applyFilter = _ref.applyFilter,
    clearFilter = _ref.clearFilter,
    closeModal = _ref.closeModal,
    activeModal = _ref.activeModal;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(category),
    _useState2 = _slicedToArray(_useState, 2),
    stateCategory = _useState2[0],
    setStateCategory = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(providers),
    _useState4 = _slicedToArray(_useState3, 2),
    stateProvider = _useState4[0],
    setStateProvider = _useState4[1];
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_2__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: closeModal,
      enabled: activeModal
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  var toggleOptionFilter = function toggleOptionFilter(type, categoryIndex) {
    var optionIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (type === 'provider') {
      var updatedProviders = _toConsumableArray(stateProvider);
      updatedProviders[categoryIndex].selected = !updatedProviders[categoryIndex].selected;
      setStateProvider(updatedProviders);
    } else if (type === 'category') {
      var updatedCategories = _toConsumableArray(stateCategory);
      updatedCategories[categoryIndex].Categories[optionIndex].selected = !updatedCategories[categoryIndex].Categories[optionIndex].selected;
      setStateCategory(updatedCategories);
    }
  };
  var getIconPath = function getIconPath(selected) {
    return selected ? '/assets/images/check_dark_green.svg' : '/assets/images/checkbox-uncheked.svg';
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setStateCategory(category);
    setStateProvider(providers);
  }, [category, providers]);
  var BenefitsFilters = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var benefitCategory = stateCategory.find(function (cat) {
      return cat.ID === BENEFIT_CATEGORY_ID;
    });
    if (!benefitCategory) return null;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "divider"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "category-title"
    }, benefitCategory.Name), benefitCategory.Categories.map(function (option, optionIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: optionIndex,
        className: "option-item",
        onClick: function onClick() {
          return toggleOptionFilter('category', 3, optionIndex);
        },
        "data-cy": "filtro-".concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["FormatCategoryName"])(benefitCategory.Name), "-").concat(optionIndex)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: getIconPath(option.selected),
        alt: "check-box"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "option-filter-item"
      }, option.Name));
    }));
  }, [stateCategory]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_modalpagamento mobile-roof filter".concat(!activeModal ? ' hide-comp-modal' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalcontents filter",
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "contents"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modaltop filter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title white"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/filter_white.svg",
    alt: "icone filtro",
    className: "icon-filtro"
  }), "Filtros"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: function onClick() {
      closeModal();
    },
    className: "close-btn",
    "data-cy": "botao-fechar-filtro"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/close_white.svg",
    alt: "close modal"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalmiddle wrap noBorder"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "lista-categorias-filtro"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "lista-categorias-filtro-left"
  }, stateCategory.map(function (cat, categoryIndex) {
    return cat.ID !== BENEFIT_CATEGORY_ID && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: categoryIndex,
      className: "cat".concat(cat.ID, " ").concat(categoryIndex > 0 ? 'divider' : '')
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "category-title"
    }, cat.Name), cat.Categories.map(function (option, optionIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: optionIndex,
        className: "option-item",
        onClick: function onClick() {
          return toggleOptionFilter('category', categoryIndex, optionIndex);
        },
        "data-cy": "filtro-".concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["FormatCategoryName"])(cat.Name), "-").concat(optionIndex)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: getIconPath(option.selected),
        alt: "check-box"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "option-filter-item"
      }, option.Name));
    }));
  }), BenefitsFilters), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "lista-categorias-filtro-right"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "divider"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "category-title"
  }, "Seguradoras"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "option-itembox"
  }, stateProvider.map(function (provider, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: index,
      className: "option-item",
      onClick: function onClick() {
        return toggleOptionFilter('provider', index);
      },
      "data-cy": "filtro-seguradora-".concat(provider.slug)
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: getIconPath(provider.selected),
      alt: "uncheked"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "option-filter-item"
    }, provider.name));
  })))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalfooter filter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "buttons-lista-modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn-filter-limpar",
    onClick: function onClick() {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils__["clearFiltersFromSession"])();
      clearFilter();
    },
    "data-cy": "botao-limpar-filtro"
  }, "Limpar filtros")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn-filter-aplicar",
    onClick: function onClick() {
      applyFilter();
    },
    "data-cy": "botao-aplicar-filtro"
  }, "Aplicar filtros")))))));
}
var BENEFIT_CATEGORY_ID = 6;
/* harmony default export */ __webpack_exports__["a"] = (ModalFilterCategory);

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Coverage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_coverage_bottom_bar_BottomBar__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_coverage_accordion_Accordion__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comparison_modal_email_ModalEmail__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_coverage_current_purchase_CurrentPurchase__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__ = __webpack_require__(32);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }










var Coverage = /*#__PURE__*/function (_Component) {
  function Coverage(props) {
    var _this;
    _classCallCheck(this, Coverage);
    _this = _callSuper(this, Coverage, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_2__utils__["changeTitle"])('detail');
    Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["getProductQuotation"])(_objectSpread({}, props.match.params));
    return _this;
  }
  _inherits(Coverage, _Component);
  return _createClass(Coverage, [{
    key: "render",
    value: function render() {
      if (this.props.plans.length <= 0) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_main clearfixs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_coverage_current_purchase_CurrentPurchase__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_coverage_accordion_Accordion__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_comparison_modal_email_ModalEmail__["a" /* default */], {
        type: "detail"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_coverage_bottom_bar_BottomBar__["a" /* default */], null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    productInfo: state.coverage.productInfo,
    productCoverage: state.coverage.productCoverage,
    userDetails: state.comparison.userDetails
  };
}, {
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_7__actions_coverageActions__["d" /* openModalQuotationDateWarning */]
})(Coverage));

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__ = __webpack_require__(16);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var BottomBar = /*#__PURE__*/function (_Component) {
  function BottomBar(props) {
    var _this;
    _classCallCheck(this, BottomBar);
    _this = _callSuper(this, BottomBar, [props]);
    _this.purchasePlan = _this.purchasePlan.bind(_this);
    return _this;
  }
  _inherits(BottomBar, _Component);
  return _createClass(BottomBar, [{
    key: "purchasePlan",
    value: function purchasePlan() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(this.props.match.params, "/pedido/".concat(this.props.match.params.product_code, "/").concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"))
      };
      this.props.history.push(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.plans[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plans[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "purchase-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component "
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "purchase-fixed"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "section-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "real-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, plan.price_with_coupon_discount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.price_with_coupon_discount || plan.adult.price)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.adult && plan.adult.price))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, " 12x sem juros")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "price-pix"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, plan.price_with_coupon_discount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.price_with_coupon_discount - 0.05 * plan.price_with_coupon_discount)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", plan.adult && Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.adult.price - (0.05 * plan.adult.price).toFixed(2)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/pixDiscountFlag.svg",
        alt: "pix flag"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "real-price"
      }, "/pre\xE7o por pessoa")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "button-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "btn-comprar ",
        onClick: this.purchasePlan
      }, "Comprar")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    userDetails: state.coverage.userDetails
  };
}, {
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__["d" /* openModalQuotationDateWarning */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(BottomBar)));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Accordion */
/* unused harmony export AccordionContainer */
/* unused harmony export AccordionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var Accordion = /*#__PURE__*/function (_Component) {
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _callSuper(this, Accordion, [props]);
    _this.openCloseAccordion = _this.openCloseAccordion.bind(_this);
    _this.divRef = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();
    _this.lastElementPositionDelta = null;
    return _this;
  }
  _inherits(Accordion, _Component);
  return _createClass(Accordion, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      if (!this.divRef.current) return;
      this.lastElementPositionDelta = this.divRef.current.getBoundingClientRect().y;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.divRef.current) return;
      var currentElementPosition = this.divRef.current.getBoundingClientRect().y + window.scrollY;
      if (!prevProps.opened && this.props.opened) window.scrollTo(window.scrollX, currentElementPosition - this.lastElementPositionDelta);
    }
  }, {
    key: "openCloseAccordion",
    value: function openCloseAccordion() {
      this.props.openCoverageAccordion(this.props.code);
      if (!this.props.opened) {
        __WEBPACK_IMPORTED_MODULE_5__utils_dataLayer__["a" /* default */].genericEvent('sg_event', 'sp_cobertura', 'click_abrir_accordion', 'mais_detalhes');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var containerClass = 'accordion ';
      containerClass += this.props.opened ? 'active' : '';
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", {
        onClick: this.openCloseAccordion,
        ref: this.divRef
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: containerClass
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "desc"
      }, this.props.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "valor"
      }, this.props.coverage)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: this.props.opened ? 'more-icon open' : 'more-icon'
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "acc-panel panel"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr", {
        className: this.props.position % 2 === 0 ? 'line-separator even-color' : 'line-separator odd-color'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, this.props.content)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionContainer = /*#__PURE__*/function (_Component2) {
  function AccordionContainer() {
    _classCallCheck(this, AccordionContainer);
    return _callSuper(this, AccordionContainer, arguments);
  }
  _inherits(AccordionContainer, _Component2);
  return _createClass(AccordionContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "box-detalhes"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "header-box-detalhes"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, this.props.title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "body-box-detalhes"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "list-descricao"
      }, this.props.benefits.map(function (benefit, i) {
        var content = _this2.props.benefits_list.filter(function (b) {
          return b.code === benefit.code;
        });
        content = content.length >= 1 ? content[0].long_description : '';
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Accordion, _extends({}, benefit, {
          key: benefit.code,
          content: content,
          position: i,
          openCoverageAccordion: _this2.props.openCoverageAccordion
        }));
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionGroup = /*#__PURE__*/function (_Component3) {
  function AccordionGroup(props) {
    var _this3;
    _classCallCheck(this, AccordionGroup);
    _this3 = _callSuper(this, AccordionGroup, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["getProductCoverage"])(_this3.props.match.params);
    Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["listBenefits"])();
    return _this3;
  }
  _inherits(AccordionGroup, _Component3);
  return _createClass(AccordionGroup, [{
    key: "render",
    value: function render() {
      var _this4 = this;
      var categories = this.props.productCoverage.benefits;
      var accordionContainers = [];
      if (categories) Object.keys(categories).forEach(function (category) {
        return accordionContainers.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccordionContainer, {
          title: category,
          key: category,
          benefits: categories[category],
          benefits_list: _this4.props.benefits_list,
          openCoverageAccordion: _this4.props.openCoverageAccordion
        }));
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "detalhes-cobertura"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "component"
      }, accordionContainers));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    productInfo: state.coverage.productInfo,
    productCoverage: state.coverage.productCoverage,
    benefits_list: state.purchase.benefits_list
  };
}, {
  openCoverageAccordion: __WEBPACK_IMPORTED_MODULE_4__actions_coverageActions__["c" /* openCoverageAccordion */]
})(AccordionGroup)));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Tags__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_plans_table_PixDiscountTag__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CurrentPurchase_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CurrentPurchase_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CurrentPurchase_css__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }









var CurrentPurchase = /*#__PURE__*/function (_Component) {
  function CurrentPurchase(props) {
    var _this;
    _classCallCheck(this, CurrentPurchase);
    _this = _callSuper(this, CurrentPurchase, [props]);
    _defineProperty(_this, "sendToRDStation", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var lead_mail, lead_name, cookies, _i, _Object$entries, _Object$entries$_i, key, value, response, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            lead_name = '';
            cookies = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["getAllCookies"])();
            for (_i = 0, _Object$entries = Object.entries(cookies); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
              if (key.trim() === 'LeadEmail') {
                lead_mail = decodeURIComponent(value);
              }
              if (key.trim() === 'LeadName') {
                lead_name = decodeURIComponent(value);
              }
            }
            _context.n = 1;
            return fetch('https://www.rdstation.com.br/api/1.3/conversions', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                token_rdstation: '904297ddf27aa488461f1936e94791d6',
                identificador: 'ver_cobertura_comprar',
                email: lead_mail,
                nome: lead_name
              })
            });
          case 1:
            response = _context.v;
            if (!response.ok) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return response.json();
          case 2:
            data = _context.v;
            console.log('Response Data:', data);
            console.log('Success!');
            _context.n = 4;
            break;
          case 3:
            console.log('Error: ', response.statusText);
          case 4:
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error('Fetch Error:', _t);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[0, 5]]);
    })));
    _defineProperty(_this, "purchasePlan", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var location;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this.sendToRDStation();
            location = {
              pathname: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatURL"])(_this.props.match.params, "/pedido/".concat(_this.props.match.params.product_code, "/").concat(_this.props.match.params.destination, "/").concat(_this.props.match.params.begin_date, "/").concat(_this.props.match.params.end_date, "/"))
            };
            _this.props.history.push(location);
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _this.purchasePlan = _this.purchasePlan.bind(_this);
    return _this;
  }
  _inherits(CurrentPurchase, _Component);
  return _createClass(CurrentPurchase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bar = document.querySelector('.top-detail-coverage');
      var list = document.querySelector('.detalhes-cobertura');
      if (list && bar && !this.props.mobile) window.addEventListener('scroll', function () {
        if (window.scrollY > 139) {
          bar.classList.add('fixedd');
          list.style.marginTop = '100px';
        } else {
          bar.classList.remove('fixedd');
          list.style.marginTop = '5px';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.props.plans[0] || !this.props.destinations[0] || !this.props.providers[0] || !this.props.providers[0].slug) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var pixDiscountMultiplier = 0.95;
      if (this.props.paymentMethods && this.props.paymentMethods.length > 0) {
        var pixPayment = this.props.paymentMethods.find(function (method) {
          return method.slug === 'pix';
        });
        if (pixPayment && pixPayment.discount > 0) {
          pixDiscountMultiplier = (100 - pixPayment.discount) / 100;
        }
      }
      var plan = this.props.plans[0] || {
        provider_code: '2',
        provider_name: '',
        name: '',
        adult: {
          price: 0
        },
        extra: {
          special: '',
          travel_renewal: 'no'
        },
        elder: {}
      };
      var destinations = this.props.destinations;
      var providers = this.props.providers;
      var destination = destinations.filter(function (destination) {
        return destination.slug === _this2.props.match.params.destination;
      })[0].name;
      var providerSlug = providers.filter(function (provider) {
        return provider.code === plan.provider_code;
      })[0].slug;
      var termsUrl = providers.filter(function (provider) {
        return provider.slug === providerSlug;
      })[0].terms_url;
      var provider_img_path = "/assets/images/seguradoras/".concat(providerSlug, ".png");
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "top-detail-coverage"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
        className: "top-detail-title"
      }, "Resumo da cobertura"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "content-resume-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "details-insured-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
        tag: Object(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["b" /* getTag */])(plan),
        isMobile: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "details-group-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "brand-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "img-insured",
        src: provider_img_path,
        alt: "Logo - Seguradora"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "info-plan"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-principal"
      }, this.props.productCoverage.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-span-normal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Faixa et\xE1ria: ", this.props.productCoverage.min_age, " a ", this.props.productCoverage.max_age, " anos", ' '), plan.elder.min_age < plan.elder.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        style: {
          marginLeft: '5px'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, "R$", ' ', this.props.plans.length > 0 && "".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(this.props.plans[0].elder.price), " maiores de ").concat(this.props.plans[0].adult.max_age)))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "details-group-mobile-info"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-title-normal"
      }, destination), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "span-small"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["convertDate"])(this.props.match.params.begin_date), " -", ' ', Object(__WEBPACK_IMPORTED_MODULE_5__utils__["convertDate"])(this.props.match.params.end_date))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "send-mail more-details"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: termsUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Ver condi\xE7\xF5es gerais")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "details-insured-desktop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "brand-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        className: "img-insured",
        src: provider_img_path,
        alt: "Logo - Seguradora"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "group-details-info-desktop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "info-plan"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-principal"
      }, this.props.productCoverage.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-span-normal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Faixa et\xE1ria: ", this.props.productCoverage.min_age, " a ", this.props.productCoverage.max_age, " anos"), plan.elder.min_age < plan.elder.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, "R$", ' ', this.props.plans.length > 0 && "".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(this.props.plans[0].elder.price), " maiores de ").concat(this.props.plans[0].adult.max_age)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "send-mail more-details"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: termsUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Ver condi\xE7\xF5es gerais")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "p-title-normal"
      }, destination), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "span-small"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, Object(__WEBPACK_IMPORTED_MODULE_5__utils__["convertDate"])(this.props.match.params.begin_date), " -", ' ', Object(__WEBPACK_IMPORTED_MODULE_5__utils__["convertDate"])(this.props.match.params.end_date))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalEmail,
        className: "btn-send-details-email"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/plane.svg"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Enviar cobertura por e-mail"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "info-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["a" /* default */], {
        tag: Object(__WEBPACK_IMPORTED_MODULE_3__common_Tags__["b" /* getTag */])(plan)
      }), plan.price_with_coupon_discount ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "old-price"
      }, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(plan.adult.price)) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "value"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(plan.price_with_coupon_discount || plan.adult.price)), ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, ' ', Object(__WEBPACK_IMPORTED_MODULE_5__utils__["getMaxParcel"])(plan.price_with_coupon_discount || plan.adult.price), "x sem juros no cart\xE3o")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "value-pix"
      }, "R$", ' ', Object(__WEBPACK_IMPORTED_MODULE_5__utils__["formatPrice"])(plan.price_with_coupon_discount ? (plan.price_with_coupon_discount * pixDiscountMultiplier).toFixed(2) : (plan.adult.price * pixDiscountMultiplier).toFixed(2)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__search_plans_table_PixDiscountTag__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        type: "button",
        className: "btn-purchase",
        onClick: this.purchasePlan
      }, "Comprar"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalEmail,
        className: "btn-mobile-send-details-email"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/plane.svg"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Enviar cobertura por e-mail")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    userDetails: state.coverage.userDetails,
    mobile: state.mobile.mobileActive,
    productCoverage: state.coverage.productCoverage,
    providers: state.global.providers,
    destinations: state.global.destinations,
    paymentMethods: state.purchase.paymentMethods
  };
}, {
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_6__actions_coverageActions__["d" /* openModalQuotationDateWarning */],
  openModalEmail: __WEBPACK_IMPORTED_MODULE_7__actions_comparisonActions__["e" /* openModalEmail */]
})(CurrentPurchase)));

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Purchase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Purchase_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Purchase_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Purchase_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_standard_loading_Loading__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_stage_payment_StagePayment__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_purchase_accordion_Accordion__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_purchase_payment_info_PaymentInfo__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_purchase_modal_franchise_ModalFranchise__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_purchase_modal_student_ModalStudent__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_purchase_modal_safetypay_ModalSafetypay__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_purchase_modal_operator_confirmation_v2_ModalOperatorConfirmationV2__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_purchase_insured_register_InsuredRegister__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_purchase_purchase_contact_PurchaseContact__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_purchase_modal_terms_of_use_ModalTermsOfUse__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_purchase_modal_purchase_error_ModalPurchaseError__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_purchase_modal_generic_error_ModalGenericError__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_purchase_modal_coupon_error_ModalCouponError__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_purchase_modal_purchase_date_error_ModalPurchaseDateError__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_purchase_modal_plans_rules_ModalPlansRules__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_purchase_purchase_description_PurchaseDescription__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_purchase_purchase_contact_PurchaseContactMobile__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_purchase_purchase_description_PurchaseDescriptionMobile__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_purchase_purchase_summary_PurchaseSummary__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_purchase_modal_travel_renewal_ModalTravelRenewal__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_purchase_modal_travel_renewal_franchise_ModalTravelRenewalFranchise__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_purchase_modal_receptive_product_ModalReceptiveProduct__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_purchase_modal_not_covid_coverage__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_purchase_card_purchase_validation_CardPurchaseValidation__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_common_BoxAlert__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_purchase_modal_fail_payment_ModalFailPayment__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__utils_matomo__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





































var productIsFranchise = function productIsFranchise(benefitsList) {
  var franchise = benefitsList.filter(function (item) {
    return item.code === '500';
  });
  if (!franchise.length) return false;
  if (franchise[0].coverage.toUpperCase() === 'NAO' || franchise[0].coverage.toUpperCase() === 'NÃO') return false;
  return true;
};
var productIsStudent = function productIsStudent(benefitsList) {
  var student = benefitsList.filter(function (item) {
    return item.code === '501';
  });
  if (!student.length) return false;
  if (student[0].coverage.toUpperCase() === 'NAO' || student[0].coverage.toUpperCase() === 'NÃO') return false;
  return true;
};
var productIsTravelRenewal = function productIsTravelRenewal(benefitsList) {
  if (benefitsList.travel_renewal.toUpperCase() === 'EXCLUSIVE') {
    return true;
  }
  return false;
};
var isReceptiveProduct = function isReceptiveProduct(benefitsList) {
  if (benefitsList.receptive_product) {
    return true;
  }
  return false;
};
var LoadingOverlay = /*#__PURE__*/function (_Component) {
  function LoadingOverlay(props) {
    var _this;
    _classCallCheck(this, LoadingOverlay);
    _this = _callSuper(this, LoadingOverlay, [props]);
    _this.style = {
      backgroundColor: 'rgba(255,255,255,0.6)',
      zIndex: '999'
    };
    _this.innerStyle = {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)'
    };
    return _this;
  }
  _inherits(LoadingOverlay, _Component);
  return _createClass(LoadingOverlay, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_modalemail",
        style: this.style
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: this.innerStyle
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_standard_loading_Loading__["b" /* default */], null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var Purchase = /*#__PURE__*/function (_Component2) {
  function Purchase(props) {
    var _this2;
    _classCallCheck(this, Purchase);
    _this2 = _callSuper(this, Purchase, [props]);
    _defineProperty(_this2, "backSearch", function (e) {
      _this2.props.cleanErrors();
      _this2.props.history.go(-1);
    });
    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["changeTitle"])('purchase');
    _this2.setQuotationParams = _this2.props.setQuotationParams.bind(_this2);
    _this2._checkoutStarted = false;
    _this2.state = {
      showSameDayAlert: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["isSameDaySearch"])(_this2.props.match.params.begin_date)
    };
    return _this2;
  }
  _inherits(Purchase, _Component2);
  return _createClass(Purchase, [{
    key: "toggleAlert",
    value: function toggleAlert() {
      this.setState({
        showSameDayAlert: !this.state.showSameDayAlert
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.style = '';
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;
      var destination = this.props.match.params.destination;
      var endDate = this.props.match.params.end_date;
      var beginDate = this.props.match.params.begin_date;
      var productCode = this.props.match.params.product_code;
      var queryParam = this.props.location.search;
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["fetchPaymentMethodsService"])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["U" /* getPaymentMethodsAvaliable */])(response.payment_methods));
      });
      this.setQuotationParams({
        destination: destination,
        end_date: endDate,
        context: 'purchase',
        begin_date: beginDate,
        product_code: productCode,
        queryParams: queryParam
      });
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["getPaymentMethods"])({
        destination: destination,
        return_date: endDate,
        departure_date: beginDate,
        product_code: productCode
      });
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["getProductCoverage"])({
        destination: destination,
        end_date: endDate,
        begin_date: beginDate,
        product_code: productCode
      }).then(function (json) {
        if (productIsFranchise(json.benefits) && productIsTravelRenewal(json)) {
          _this3.props.openModalRenewalFranchise();
          _this3.props.closeModalFranchise();
          _this3.props.closeModalTravelRenewal();
          _this3.props.closeModalReceptiveProduct();
        } else if (productIsFranchise(json.benefits)) {
          _this3.props.openModalFranchise();
          _this3.props.closeModalRenewalFranchise();
          _this3.props.closeModalTravelRenewal();
          _this3.props.closeModalReceptiveProduct();
        } else if (productIsTravelRenewal(json)) {
          _this3.props.openModalTravelRenewal();
          _this3.props.closeModalFranchise();
          _this3.props.closeModalRenewalFranchise();
          _this3.props.closeModalReceptiveProduct();
        } else if (isReceptiveProduct(json)) {
          _this3.props.openModalReceptiveProduct();
          _this3.props.closeModalFranchise();
          _this3.props.closeModalRenewalFranchise();
          _this3.props.closeModalTravelRenewal();
        } else {
          _this3.props.closeModalFranchise();
          _this3.props.closeModalRenewalFranchise();
          _this3.props.closeModalTravelRenewal();
          _this3.props.closeModalReceptiveProduct();
        }
        if (productIsStudent(json.benefits)) _this3.props.openModalStudent();else _this3.props.closeModalStudent();
      });
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["listBenefits"])();
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["getCouponData"])(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["getUrlParams"])().cupom || this.props.coupon.text, productCode, beginDate, endDate, destination);
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["getUrlParams"])().data) Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["getPurchaseData"])(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["getUrlParams"])().data);
      __WEBPACK_IMPORTED_MODULE_36__utils_matomo__["a" /* default */].trackPageView('Checkout');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.prospect.exist && this.props.prospect.exist) {
        this.props.setInfosProspectInPurchase();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      if (props.purchaseIsValid === 1) {
        props.history.push(Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(props.match.params, "/pedido-finalizado/".concat(props.uuid, "/status/")));
      }
      if (!this._checkoutStarted && props.productCoverage && props.productCoverage.id) {
        this._checkoutStarted = true;
        __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__["a" /* default */].pageView('checkout');
        __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__["a" /* default */].beginCheckout({
          code: props.productCoverage.id,
          name: props.productCoverage.name,
          provider_code: props.productCoverage.provider_name,
          price_with_coupon_discount: props.value
        });
      }
      __WEBPACK_IMPORTED_MODULE_4__utils_dataLayer__["a" /* default */].raw({
        event: 'payment',
        ecommerce: {
          payment: {
            product: {
              id: props.productCoverage.id,
              provider: props.productCoverage.provider_name,
              name: props.productCoverage.name,
              value: props.value
            }
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_main clearfixs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_purchase_stage_payment_StagePayment__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", {
        className: "pagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component component-pagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cards-resumo"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__components_purchase_card_purchase_validation_CardPurchaseValidation__["a" /* default */], null), this.state.showSameDayAlert && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__components_common_BoxAlert__["a" /* default */], {
        image: "/assets/images/icons/warning-red.svg",
        altIcon: "icon-warning",
        theme: "alert",
        title: "Voc\xEA est\xE1 pesquisando um seguro para viajar hoje",
        onClose: function onClose() {
          return _this4.toggleAlert();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Sua ap\xF3lice ser\xE1 v\xE1lida somente se for emitida antes do in\xEDcio da sua viagem. Para d\xFAvidas, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://segurospromo.com.br/atendimento"
      }, "fale diretamente com nosso atendimento")), ".")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_purchase_insured_register_InsuredRegister__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_purchase_payment_info_PaymentInfo__["a" /* default */], {
        paramsUrl: this.props.match.params
      }), this.props.mobile && this.props.stagePurchase === 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_purchase_purchase_summary_PurchaseSummary__["a" /* default */], {
        destinations: this.props.destinations
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), this.props.mobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_purchase_purchase_contact_PurchaseContactMobile__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__components_purchase_purchase_description_PurchaseDescriptionMobile__["a" /* default */], {
        destinations: this.props.destinations
      })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_purchase_purchase_contact_PurchaseContact__["a" /* default */], null))), !this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "component component-description"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_purchase_purchase_description_PurchaseDescription__["a" /* default */], null)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_purchase_accordion_Accordion__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_purchase_modal_safetypay_ModalSafetypay__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_purchase_modal_operator_confirmation_v2_ModalOperatorConfirmationV2__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_purchase_modal_franchise_ModalFranchise__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__components_purchase_modal_not_covid_coverage__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_purchase_modal_student_ModalStudent__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_purchase_modal_terms_of_use_ModalTermsOfUse__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_purchase_modal_purchase_error_ModalPurchaseError__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_purchase_modal_generic_error_ModalGenericError__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_purchase_modal_coupon_error_ModalCouponError__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__components_purchase_modal_purchase_date_error_ModalPurchaseDateError__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__components_purchase_modal_travel_renewal_ModalTravelRenewal__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components_purchase_modal_travel_renewal_franchise_ModalTravelRenewalFranchise__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__components_purchase_modal_receptive_product_ModalReceptiveProduct__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__components_purchase_modal_plans_rules_ModalPlansRules__["a" /* default */], {
        productCoverage: this.props.productCoverage,
        isModalPlanRulesActive: this.props.isModalPlanRulesActive,
        closeModalPlanRules: this.props.closeModalPlanRules
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__components_purchase_modal_fail_payment_ModalFailPayment__["a" /* default */], {
        creditcard: this.props.creditcard,
        isModalFailPaymentActive: this.props.isModalFailPaymentActive,
        closeModalFailPayment: this.props.closeModalFailPayment
      }), this.props.loading === true && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingOverlay, null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    coupon: state.purchase.coupon,
    value: state.purchase.purchaseSummary.adult.price,
    uuid: state.purchase.uuid,
    benefits_list: state.purchase.benefits_list,
    purchaseIsValid: state.purchase.purchaseIsValid,
    productCoverage: state.coverage.productCoverage,
    loading: state.purchase.loading,
    mobile: state.mobile.mobileActive,
    isModalPlanRulesActive: state.purchase.isModalPlanRulesActive,
    isModalFailPaymentActive: state.purchase.isModalFailPayment,
    stagePurchase: state.purchase.stagePurchase,
    destinations: state.global.destinations,
    creditcard: state.purchase.creditCard,
    prospect: state.search.prospect
  };
}, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_28" /* setQuotationParams */],
  fetchPlansPurchase: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["M" /* fetchPlansPurchase */],
  openModalFranchise: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_0" /* openModalFranchise */],
  closeModalFranchise: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["t" /* closeModalFranchise */],
  closeModalPlanRules: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["x" /* closeModalPlanRules */],
  closeModalFailPayment: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["s" /* closeModalFailPayment */],
  openModalStudent: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_10" /* openModalStudent */],
  closeModalStudent: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["D" /* closeModalStudent */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["l" /* cleanErrors */],
  setInfosProspectInPurchase: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_24" /* setInfosProspectInPurchase */],
  openModalTravelRenewal: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_11" /* openModalTravelRenewal */],
  openModalRenewalFranchise: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_8" /* openModalRenewalFranchise */],
  closeModalTravelRenewal: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["F" /* closeModalTravelRenewal */],
  closeModalRenewalFranchise: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["B" /* closeModalRenewalFranchise */],
  openModalReceptiveProduct: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_7" /* openModalReceptiveProduct */],
  closeModalReceptiveProduct: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["A" /* closeModalReceptiveProduct */],
  openModalNotCovidCoverage: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["_2" /* openModalNotCovidCoverage */],
  closeModalNotCovidCoverage: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["v" /* closeModalNotCovidCoverage */]
})(Purchase)));

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_matomo__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }







var StagePayment = /*#__PURE__*/function (_Component) {
  function StagePayment(props) {
    var _this;
    _classCallCheck(this, StagePayment);
    _this = _callSuper(this, StagePayment, [props]);
    _defineProperty(_this, "getStepTitle", function () {
      var payments = [{
        value: _this.props.stepDisplayCreditCard,
        name: 'stepDisplayCreditCard'
      }, {
        value: _this.props.stepDisplayCashTransfer,
        name: 'stepDisplayCashTransfer'
      }, {
        value: _this.props.stepDisplayBoleto,
        name: 'stepDisplayBoleto'
      }, {
        value: _this.props.stepDisplayPix,
        name: 'stepDisplayPix'
      }];
      var selected_payment = payments.filter(function (payment) {
        return payment.value > 0;
      }) || [{
        value: 0
      }];
      if (_this.props.stagePurchase === 1) {
        return 'Compra - Segurados';
      } else if (_this.props.stagePurchase === 2) {
        if (selected_payment.length !== 0) {
          if (selected_payment[0].name === 'stepDisplayCreditCard') {
            if (selected_payment[0].value === 1) return 'Compra - Selecione o cartão';
            if (selected_payment[0].value === 2) return 'Compra - Parcelamento';
            if (selected_payment[0].value === 3) return 'Compra - Dados do cartão';
          } else if (selected_payment[0].name === 'stepDisplayCashTransfer') {
            if (selected_payment[0].value === 1) return 'Compra - Selecione o banco';
            if (selected_payment[0].value === 2) return 'Compra - Dados da transferência';
          } else {
            if (selected_payment[0].value === 1) return 'Compra - Responsável pelo pagamento';
          }
        }
        return 'Compra - Forma de pagamento';
      } else if (_this.props.stagePurchase === 3) {
        return 'Compra - Contato da compra';
      } else {
        return 'Compra - Tudo pronto!';
      }
    });
    _defineProperty(_this, "getStepName", function () {
      var stageMap = {
        1: 'segurados',
        2: 'pagamento',
        3: 'contato',
        4: 'confirmacao'
      };
      return stageMap[_this.props.stagePurchase] || 'segurados';
    });
    _defineProperty(_this, "trackCurrentStep", function () {
      if (_this.props.mobile) {
        __WEBPACK_IMPORTED_MODULE_5__utils_matomo__["a" /* default */].trackPageView(_this.getStepTitle());
      }
    });
    _defineProperty(_this, "backStage", function () {
      var payments = [{
        value: _this.props.stepDisplayCreditCard,
        name: 'stepDisplayCreditCard'
      }, {
        value: _this.props.stepDisplayCashTransfer,
        name: 'stepDisplayCashTransfer'
      }, {
        value: _this.props.stepDisplayBoleto,
        name: 'stepDisplayBoleto'
      }, {
        value: _this.props.stepDisplayPix,
        name: 'stepDisplayPix'
      }];
      var selected_payment = payments.filter(function (payment) {
        return payment.value > 0;
      }) || [{
        value: 0
      }];
      if (selected_payment.length !== 0) {
        if (selected_payment[0].value === 1 && _this.props.stagePurchase === 2) {
          _this.props.backStagePaymentMethod(selected_payment[0].value - 1, selected_payment[0].name, true);
        } else if (selected_payment[0].value > 1 && _this.props.stagePurchase === 2) {
          _this.props.backStagePaymentMethod(selected_payment[0].value - 1, selected_payment[0].name, false);
        } else {
          _this.props.backStagePurchase(_this.props.stagePurchase);
        }
      } else {
        _this.props.backStagePurchase(_this.props.stagePurchase);
      }
    });
    _defineProperty(_this, "title", function () {
      var payments = [{
        value: _this.props.stepDisplayCreditCard,
        name: 'stepDisplayCreditCard'
      }, {
        value: _this.props.stepDisplayCashTransfer,
        name: 'stepDisplayCashTransfer'
      }, {
        value: _this.props.stepDisplayBoleto,
        name: 'stepDisplayBoleto'
      }, {
        value: _this.props.stepDisplayPix,
        name: 'stepDisplayPix'
      }];
      var selected_payment = payments.filter(function (payment) {
        return payment.value > 0;
      }) || [{
        value: 0
      }];
      if (_this.props.stagePurchase === 1) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Segurados");
      } else if (_this.props.stagePurchase === 2) {
        if (selected_payment.length !== 0) {
          if (selected_payment[0].name === 'stepDisplayCreditCard') {
            if (selected_payment[0].value === 1) {
              return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Selecione o cart\xE3o");
            }
          } else if (selected_payment[0].name === 'stepDisplayCashTransfer') {
            if (selected_payment[0].value === 1) {
              return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Selecione o banco");
            }
          } else {
            if (selected_payment[0].value === 1) {
              return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Respons\xE1vel pelo pagamento");
            }
          }
        }
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Forma de pagamento");
      } else if (_this.props.stagePurchase === 3) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Contato da compra");
      } else {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Tudo pronto!");
      }
    });
    _defineProperty(_this, "backSearch", function (e) {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(_this.props.match, "/pesquisa/".concat(_this.props.match.params.destination, "/").concat(_this.props.match.params.begin_date, "/").concat(_this.props.match.params.end_date, "/"), null)
      };
      _this.props.cleanStatesPurchaseMobile();
      _this.props.cleanErrors();
      _this.props.history.push(location);
    });
    _this.backStage = _this.backStage.bind(_this);
    _this.title = _this.title.bind(_this);
    return _this;
  }
  _inherits(StagePayment, _Component);
  return _createClass(StagePayment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.trackCurrentStep();
      __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].checkoutStepView(this.getStepName(), 'forward');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var mobileJustActivated = !prevProps.mobile && this.props.mobile;
      var stepChanged = prevProps.stagePurchase !== this.props.stagePurchase || prevProps.stepDisplayCreditCard !== this.props.stepDisplayCreditCard || prevProps.stepDisplayCashTransfer !== this.props.stepDisplayCashTransfer || prevProps.stepDisplayBoleto !== this.props.stepDisplayBoleto || prevProps.stepDisplayPix !== this.props.stepDisplayPix;
      if (mobileJustActivated || stepChanged) {
        this.trackCurrentStep();
      }
      if (prevProps.stagePurchase !== this.props.stagePurchase) {
        var direction = this.props.stagePurchase > prevProps.stagePurchase ? 'forward' : 'backward';
        __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].checkoutStepView(this.getStepName(), direction);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.mobile) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "stage-payment"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "back-stage",
        onClick: this.props.stagePurchase === 1 ? this.backSearch : this.backStage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/leftArrow.svg",
        alt: ""
      }), " ", this.title()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "stage-count"
      }, this.props.stagePurchase !== 4 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Etapa ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "0", this.props.stagePurchase), " de ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "03"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    stepDisplayCreditCard: state.purchase.stepDisplayCreditCard,
    stepDisplayCashTransfer: state.purchase.stepDisplayCashTransfer,
    stepDisplayBoleto: state.purchase.stepDisplayBoleto,
    stepDisplayPix: state.purchase.stepDisplayPix
  };
}, {
  backStagePurchase: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["d" /* backStagePurchase */],
  backStagePaymentMethod: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["c" /* backStagePaymentMethod */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["l" /* cleanErrors */],
  cleanStatesPurchaseMobile: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["m" /* cleanStatesPurchaseMobile */]
})(StagePayment)));

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Accordion */
/* unused harmony export AccordionContainer */
/* unused harmony export AccordionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_coverageActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable */









var Accordion = /*#__PURE__*/function (_Component) {
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _callSuper(this, Accordion, [props]);
    _this.state = {
      isActive: false
    };
    _this.openCloseAccordion = _this.openCloseAccordion.bind(_this);
    return _this;
  }
  _inherits(Accordion, _Component);
  return _createClass(Accordion, [{
    key: "openCloseAccordion",
    value: function openCloseAccordion() {
      this.props.openCoverageAccordion(this.props.code);
    }
  }, {
    key: "render",
    value: function render() {
      var containerClass = 'accordion ' + (this.props.opened ? 'active' : '');
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "tableline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "text"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.props.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.props.coverage)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionContainer = /*#__PURE__*/function (_Component2) {
  function AccordionContainer() {
    _classCallCheck(this, AccordionContainer);
    return _callSuper(this, AccordionContainer, arguments);
  }
  _inherits(AccordionContainer, _Component2);
  return _createClass(AccordionContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var content = "";
      return [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "tableheader"
      }, this.props.title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "tablecontents"
      }, this.props.benefits.map(function (benefit, i) {
        var content = _this2.props.benefits_list.filter(function (b, i) {
          return b.code == benefit.code;
        });
        content = content.length >= 1 ? content[0].long_description : '';
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Accordion, _extends({}, benefit, {
          key: benefit.code,
          content: content,
          openCoverageAccordion: _this2.props.openCoverageAccordion
        }));
      }))];
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionGroup = /*#__PURE__*/function (_Component3) {
  function AccordionGroup(props) {
    var _this3;
    _classCallCheck(this, AccordionGroup);
    _this3 = _callSuper(this, AccordionGroup, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["getProductCoverage"])(_this3.props.match.params);
    Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["listBenefits"])();
    return _this3;
  }
  _inherits(AccordionGroup, _Component3);
  return _createClass(AccordionGroup, [{
    key: "render",
    value: function render() {
      var categories = this.props.productCoverage.benefits;
      var accordionContainers = [];
      for (var category in categories) accordionContainers.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccordionContainer, {
        title: category,
        key: category,
        benefits: categories[category],
        benefits_list: this.props.benefits_list,
        openCoverageAccordion: this.props.openCoverageAccordion
      }));
      var begin_date = this.props.match.params.begin_date,
        end_date = this.props.match.params.end_date;
      var b_date = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatDate"])(begin_date);
      var e_date = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatDate"])(end_date);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "modaltable"
      }, accordionContainers);
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var CoverageModal = function CoverageModal(props) {
  if (!props.isModalDetailActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_7__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: props.closeModalDetail
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "comp_modalpagamento mobile-roof"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "modalcontents mobile-modal",
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "contents"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "modaltop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "title"
  }, "Detalhes da cobertura:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    onClick: props.closeModalDetail,
    className: "close-btn"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
    src: "/assets/images/icons/close.svg",
    alt: "close button"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "modalmiddle"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccordionGroup, props)))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    productInfo: state.coverage.productInfo,
    productCoverage: state.coverage.productCoverage,
    benefits_list: state.purchase.benefits_list,
    isModalDetailActive: state.purchase.isModalDetailActive
  };
};
var mapDispatchToProps = {
  openCoverageAccordion: __WEBPACK_IMPORTED_MODULE_5__actions_coverageActions__["c" /* openCoverageAccordion */],
  closeModalDetail: __WEBPACK_IMPORTED_MODULE_6__actions_purchaseActions__["r" /* closeModalDetail */]
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(CoverageModal)));

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentInfo_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentInfo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Cash__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Boleto__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditCard__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CashTransfer__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pix__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Alert__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mobile_PaymentMethodMobile__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__desktop_inputs_getCreditCardInput__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__desktop_inputs_getBoletoInput__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__desktop_inputs_getPixInput__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }















var PaymentMethod = /*#__PURE__*/function (_Component) {
  function PaymentMethod() {
    _classCallCheck(this, PaymentMethod);
    return _callSuper(this, PaymentMethod, arguments);
  }
  _inherits(PaymentMethod, _Component);
  return _createClass(PaymentMethod, [{
    key: "componentWillMount",
    value: function componentWillMount(props) {
      var today = new Date();
      var deadline = today.addDays(1);
      var year = deadline.getUTCFullYear();
      var month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      var day = deadline.getUTCDate().toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      this.deadline = "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "render",
    value: function render() {
      var payments = [];
      this.props.paymentMethods.sort(function (a, b) {
        return a.displayOrder > b.displayOrder ? 1 : b.displayOrder > a.displayOrder ? -1 : 0;
      });
      for (var i = 0; i < this.props.paymentMethods.length; i++) {
        var method = this.props.paymentMethods[i];
        if (method.active && method.available) {
          if (method.slug === 'credit-card') {
            payments.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
              key: "credit-card-".concat(i)
            }, Object(__WEBPACK_IMPORTED_MODULE_11__desktop_inputs_getCreditCardInput__["a" /* default */])(this.props, i)));
          } else if (method.slug === 'boleto') {
            payments.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
              key: "boleto-".concat(i)
            }, Object(__WEBPACK_IMPORTED_MODULE_12__desktop_inputs_getBoletoInput__["a" /* default */])(this.props, i)));
          } else if (method.slug === 'pix') {
            payments.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
              key: "pix-".concat(i)
            }, Object(__WEBPACK_IMPORTED_MODULE_13__desktop_inputs_getPixInput__["a" /* default */])(this.props, i)));
          }
        }
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-opcoes-pagamento desktop radio-input"
      }, payments);
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var PaymentInfo = /*#__PURE__*/function (_Component2) {
  function PaymentInfo(props) {
    var _this;
    _classCallCheck(this, PaymentInfo);
    _this = _callSuper(this, PaymentInfo, [props]);
    _this.paymentMethods = [{
      id: 0,
      render: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CreditCard__["a" /* default */], null)
    }, {
      id: 1,
      render: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Boleto__["a" /* default */], null)
    }, {
      id: 3,
      render: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CashTransfer__["a" /* default */], {
        banks: _this.props.banks,
        selectBank: _this.props.selectBank
      })
    }, {
      id: 2,
      render: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Cash__["a" /* default */], null)
    }, {
      id: 4,
      render: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Pix__["a" /* default */], null)
    }];
    return _this;
  }
  _inherits(PaymentInfo, _Component2);
  return _createClass(PaymentInfo, [{
    key: "render",
    value: function render() {
      var selectedPaymentMethod = this.props.paymentMethods.filter(function (method) {
        return method.selected;
      })[0];
      var safetypayMinValue = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["formatPrice"])(this.props.safetypay.min_value);
      var boletoMinValue = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["formatPrice"])(this.props.boleto.min_value);
      var paymentMethod = {};
      var pmComponent = null;
      if (selectedPaymentMethod) {
        paymentMethod = this.paymentMethods.filter(function (method) {
          return method.id === selectedPaymentMethod.id;
        }).pop();
        if (paymentMethod) {
          pmComponent = paymentMethod.render;
        }
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-forma-pagamento",
        style: {
          display: this.props.stagePurchase !== 2 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
        className: "card-forma-pagamento-header",
        style: {
          display: this.props.stepDisplayMethodPayment === 0 && this.props.mobile ? 'block' : 'none'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "mobile"
      }, "Selecione a forma de pagamento:")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "body-box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          display: this.props.stepDisplayMethodPayment !== 0 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "mobile"
      }, this.props.alert === 'boleto' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Alert__["a" /* default */], {
        onClose: this.props.clearAlerts
      }, "A op\xE7\xE3o de pagamento por boleto est\xE1 dispon\xEDvel somente para valores", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "acima de R$\xA0", boletoMinValue), " e com ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "prazo de 2 dias"), " para a viagem.")), !this.props.mobile ? this.props.purchaseSummary.total > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "payment-desktop-header"
      }, "Forma de pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PaymentMethod, {
        fetchPaymentMethods: this.props.fetchPaymentMethods,
        paymentMethods: this.props.paymentMethods,
        selectedPaymentMethod: this.props.selectedPaymentMethod,
        selectPaymentMethod: this.props.selectPaymentMethod,
        brands: this.props.brands,
        openModalSafetypay: this.props.openModalSafetypay,
        userDetails: this.props.userDetails,
        partner: this.props.paramsUrl.partner
      })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__mobile_PaymentMethodMobile__["a" /* default */], {
        fetchPaymentMethods: this.props.fetchPaymentMethods,
        selectedPaymentMethod: this.props.selectedPaymentMethod,
        selectPaymentMethod: this.props.selectPaymentMethod
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "desktop"
      }, this.props.alert === 'boleto' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Alert__["a" /* default */], {
        onClose: this.props.clearAlerts
      }, "A op\xE7\xE3o de pagamento por boleto est\xE1 dispon\xEDvel somente para valores", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "acima de R$\xA0", boletoMinValue), " e com ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "prazo de 2 dias"), " para a viagem.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-forma-pagamento",
        style: this.props.purchaseSummary.total === 0 ? {
          borderTop: 'none'
        } : {}
      }, pmComponent))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    alert: state.purchase.alert,
    banks: state.purchase.banks,
    safetypay: state.purchase.safetypay,
    boleto: state.purchase.boleto,
    paymentMethods: state.purchase.paymentMethods,
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    stepDisplayMethodPayment: state.purchase.stepDisplayMethodPayment,
    stepDisplayCreditCard: state.purchase.stepDisplayCreditCard,
    plan: state.search.plans,
    brands: state.purchase.creditCard.brands,
    userDetails: state.purchase.userDetails,
    purchaseSummary: state.purchase.purchaseSummary
  };
}, {
  fetchPaymentMethods: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["L" /* fetchPaymentMethods */],
  selectPaymentMethod: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_19" /* selectPaymentMethod */],
  selectBank: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_14" /* selectBank */],
  clearAlerts: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["n" /* clearAlerts */],
  selectPaymentCreditCard: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_18" /* selectPaymentCreditCard */],
  openModalSafetypay: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_9" /* openModalSafetypay */]
})(PaymentInfo));

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__ = __webpack_require__(12);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var HolderInfo = /*#__PURE__*/function (_Component) {
  function HolderInfo() {
    _classCallCheck(this, HolderInfo);
    return _callSuper(this, HolderInfo, arguments);
  }
  _inherits(HolderInfo, _Component);
  return _createClass(HolderInfo, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "",
        className: "label-form"
      }, "Respons\xE1vel pelo pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "holderName",
        value: this.props.holderName,
        onChange: this.props.handleChange,
        placeholder: "Nome completo"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "holderName",
        field1: "cash",
        field2: "holderName"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "",
        className: "label-form"
      }, "CPF"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        name: "holderCpf",
        type: "tel",
        value: this.props.holderCpf,
        onChange: this.props.handleChange,
        placeholder: "000.000.000-00",
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        guide: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "holderCpf",
        field1: "cash",
        field2: "holderCpf"
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var Cash = /*#__PURE__*/function (_Component2) {
  function Cash(props) {
    var _this;
    _classCallCheck(this, Cash);
    _this = _callSuper(this, Cash, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(Cash, _Component2);
  return _createClass(Cash, [{
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      this.props.changeCashAttr(field);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-dinheiro"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HolderInfo, {
        handleChange: this.handleChange,
        username: this.props.username,
        holderName: this.props.holderName,
        holderCpf: this.props.holderCpf
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
  return {
    username: state.purchase.cash.username,
    password: state.purchase.cash.password,
    holderName: state.purchase.cash.holderName,
    holderCpf: state.purchase.cash.holderCpf
  };
}, {
  changeCashAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["f" /* changeCashAttr */]
})(Cash)));

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__standard_button_stage_ButtonStage__ = __webpack_require__(25);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var Boleto = /*#__PURE__*/function (_Component) {
  function Boleto(props) {
    var _this;
    _classCallCheck(this, Boleto);
    _this = _callSuper(this, Boleto, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(Boleto, _Component);
  return _createClass(Boleto, [{
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      this.props.changeBoletoAttr(field);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.props.paymentMethods.find(function (element) {
        return element.slug === 'boleto';
      }).available) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var boletoErrors = this.props.errors.boleto;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-boleto",
        style: {
          display: this.props.stepDisplayBoleto !== 1 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "title boleto-title"
      }, "Respons\xE1vel pelo pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "name",
        value: this.props.boleto.name,
        placeholder: "Nome completo",
        onChange: this.handleChange,
        className: "".concat(boletoErrors.name ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'boleto_name');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "boleto_name",
        field1: "boleto",
        field2: "name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_text_mask___default.a, {
        name: "cpf",
        guide: true,
        type: "tel",
        placeholder: "CPF",
        className: "".concat(boletoErrors.cpf ? 'with-error' : ''),
        onChange: this.handleChange,
        value: this.props.boleto.cpf,
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'boleto_cpf');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "boleto_cpf",
        field1: "boleto",
        field2: "cpf"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "transfer-infos payment",
        onClick: function onClick(_) {
          return _this2.props.getInfosInsureds(1);
        }
      }, "Copiar dados do primeiro segurado"), this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__standard_button_stage_ButtonStage__["a" /* default */], {
        "data-cy": "step-payment-data",
        index: 3,
        stage: "INSURED_PAYMENT_PURCHASE"
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    boleto: state.purchase.boleto,
    paymentMethods: state.purchase.paymentMethods,
    mobile: state.mobile.mobileActive,
    stepDisplayBoleto: state.purchase.stepDisplayBoleto,
    errors: state.purchase.errors
  };
}, {
  changeBoletoAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["e" /* changeBoletoAttr */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_32" /* validatorHandlerBlur */],
  getInfosInsureds: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["S" /* getInfosInsureds */]
})(Boleto)));

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreditCard_CardInfo__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditCard_CardInfoMobile__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditCard_CardBrand__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreditCard_CardBrandMobile__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CreditCard_PaymentDeadline__ = __webpack_require__(282);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }









var CreditCard = /*#__PURE__*/function (_Component) {
  function CreditCard() {
    _classCallCheck(this, CreditCard);
    return _callSuper(this, CreditCard, arguments);
  }
  _inherits(CreditCard, _Component);
  return _createClass(CreditCard, [{
    key: "render",
    value: function render() {
      var selected_brand = this.props.brands.filter(function (brand) {
        return brand.selected;
      })[0];
      var parcel_option, parcels;
      if (selected_brand !== undefined) {
        parcel_option = selected_brand.max_parcels;
        parcels = [];
        for (var i = parcel_option; i > 0; i--) {
          parcels = parcels.concat({
            times: i,
            price: this.props.final_price / i
          });
        }
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "area-cartao-credito"
      }, !this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CreditCard_CardBrand__["a" /* default */], {
        brands: this.props.brands,
        selectCreditCardBrand: this.props.selectCreditCardBrand
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "area-dados-cartoes flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "flex area-form-cartao"
      }, !this.props.mobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CreditCard_CardInfo__["a" /* default */], {
        paymentOption: "credit",
        errors: this.props.errors,
        creditCard: this.props.creditCard,
        changeCreditCardAttr: this.props.changeCreditCardAttr,
        brands: this.props.brands,
        validatorHandlerBlur: this.props.validatorHandlerBlur,
        selectCreditCardBrand: this.props.selectCreditCardBrand
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CreditCard_CardInfoMobile__["a" /* default */], {
        paymentOption: "credit",
        errors: this.props.errors,
        creditCard: this.props.creditCard,
        changeCreditCardAttr: this.props.changeCreditCardAttr,
        brands: this.props.brands,
        parcels: this.props.parcels,
        selectPaymentCreditCard: this.props.selectPaymentCreditCard,
        stepDisplayCreditCard: 3,
        boxEditCard: this.props.boxEditCard,
        validatorHandlerBlur: this.props.validatorHandlerBlur,
        selectCreditCardBrand: this.props.selectCreditCardBrand,
        selectCreditCardParcel: this.props.selectCreditCardParcel
      })), this.props.parcels.length ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CreditCard_PaymentDeadline__["a" /* default */], {
        parcels: this.props.parcels,
        selectCreditCardParcel: this.props.selectCreditCardParcel
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    creditCard: state.purchase.creditCard,
    errors: state.purchase.errors.creditCard,
    brands: state.purchase.creditCard.brands,
    parcels: state.purchase.creditCard.parcels,
    final_price: state.purchase.purchaseSummary.total,
    mobile: state.mobile.mobileActive,
    stepDisplayCreditCard: state.purchase.stepDisplayCreditCard
  };
}, {
  changeCreditCardAttr: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["i" /* changeCreditCardAttr */],
  selectCreditCardBrand: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_16" /* selectCreditCardBrand */],
  selectCreditCardParcel: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_17" /* selectCreditCardParcel */],
  selectPaymentCreditCard: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_18" /* selectPaymentCreditCard */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["_32" /* validatorHandlerBlur */]
})(CreditCard)));

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_masks__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_creditCard__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }






var CardInfo = /*#__PURE__*/function (_Component) {
  function CardInfo(props) {
    var _this;
    _classCallCheck(this, CardInfo);
    _this = _callSuper(this, CardInfo, [props]);
    _defineProperty(_this, "handlePaste", function (e) {
      var pastedText = e.clipboardData.getData('text');
      if (pastedText.length > 0) {
        var detectedBrand = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["detectCardBrand"])(pastedText);
        if (detectedBrand) {
          e.preventDefault();
          var brandIndex = _this.props.brands.findIndex(function (b) {
            return b.brand_name === detectedBrand;
          });
          if (brandIndex !== -1 && !_this.props.brands[brandIndex].selected) {
            _this.props.selectCreditCardBrand(brandIndex);
          }
          _this.props.changeCreditCardAttr({
            name: 'number',
            value: pastedText
          });
        }
      }
    });
    _defineProperty(_this, "getCachedMask", function () {
      var current_brand = _this.getCurrentBrand();
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils_masks__["a" /* getMask */])(current_brand).mask;
    });
    _this.state = {
      selectedYear: '',
      selectedMonth: '',
      currentBrand: ''
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.calculateAvailableYears();
    return _this;
  }
  _inherits(CardInfo, _Component);
  return _createClass(CardInfo, [{
    key: "calculateAvailableYears",
    value: function calculateAvailableYears() {
      var now = new Date().getUTCFullYear();
      var year_options = [];
      for (var i = 0; i < 20; i++) {
        year_options.push(now + i);
      }
      this.year_options = year_options;
    }
  }, {
    key: "getCurrentBrand",
    value: function getCurrentBrand() {
      var brand_selected = this.props.brands.find(function (brand) {
        return brand.selected;
      });
      return brand_selected ? brand_selected.brand_name : null;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      if (field.name === 'number') {
        var detectedBrand = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["detectCardBrand"])(field.value);
        if (detectedBrand) {
          var brandIndex = this.props.brands.findIndex(function (b) {
            return b.brand_name === detectedBrand;
          });
          if (brandIndex !== -1 && !this.props.brands[brandIndex].selected) {
            this.props.selectCreditCardBrand(brandIndex);
          }
        }
      }
      this.props.changeCreditCardAttr(field);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var brand_selected = this.props.brands.map(function (brand, i) {
        if (brand.selected) {
          return brand.brand_name;
        }
        return '';
      });
      var creditCardErrors = this.props.errors;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "a-form desktop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Dados do cart\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        guide: false,
        name: "number",
        id: "cc-number",
        inputMode: "numeric",
        onChange: this.handleChange,
        onPaste: this.handlePaste,
        placeholder: "N\xFAmero do cart\xE3o",
        value: this.props.creditCard.number,
        mask: this.getCachedMask(),
        className: "".concat(creditCardErrors.number ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_number');
          _this2.forceUpdate();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "number"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1 row"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "holder_name",
        id: "cc-holder-name",
        placeholder: "Nome do titular",
        onChange: this.handleChange,
        className: "".concat(creditCardErrors.holder_name ? 'with-error' : ''),
        value: this.props.creditCard.holder_name,
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_holdername');
          _this2.forceUpdate();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "holder_name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        guide: true,
        name: "holder_cpf",
        type: "tel",
        placeholder: "CPF",
        value: this.props.creditCard.holder_cpf,
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        id: "cc-holder-cpf",
        onChange: this.handleChange,
        className: "".concat(creditCardErrors.holder_cpf ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_holdercpf');
          _this2.forceUpdate();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "holder_cpf"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1 row"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-select"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        name: "expiry_month",
        id: "cc-expiry-month",
        onChange: this.handleChange,
        className: "mes ".concat(creditCardErrors.expiry_month ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_month');
        },
        value: this.props.creditCard.expiry_month || ''
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: "",
        disabled: true,
        hidden: true
      }, "M\xEAs"), __WEBPACK_IMPORTED_MODULE_4__utils_creditCard__["a" /* month_options */].map(function (month, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          value: month.value,
          key: i
        }, month.name);
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "expiry_month"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-select"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        name: "expiry_year",
        id: "cc-expiry-year",
        onChange: this.handleChange,
        className: "ano ".concat(creditCardErrors.expiry_year ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_year');
        },
        value: this.props.creditCard.expiry_year || ''
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: "",
        disabled: true,
        hidden: true
      }, "Ano"), this.year_options.map(function (year, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          value: year,
          key: i
        }, year);
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "expiry_year"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1 row"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        type: "text",
        name: "cvv",
        guide: false,
        inputMode: "numeric",
        mask: [/\d/, /\d/, /\d/, /\d/],
        id: "cc-verfication-code",
        onChange: this.handleChange,
        value: this.props.creditCard.cvv,
        placeholder: "CVV",
        className: "".concat(creditCardErrors.cvv ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          _this2.props.validatorHandlerBlur(e.target.value, 'creditcard_cvv');
          _this2.forceUpdate();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "number",
        field1: "creditCard",
        field2: "cvv"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cvv-row"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cols image-card"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: brand_selected[0] === 'amex' ? '/assets/images/cvv-icon-2.svg' : '/assets/images/cvv-icon.svg',
        alt: "cvv-card",
        className: "img-brand"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "cols instruction"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "text-credit-card"
      }, brand_selected[0] === 'amex' ? '4' : '3', " digitos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "atr\xE1s do ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "cart\xE3o."))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (CardInfo);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_masks__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_creditCard__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__standard_button_stage_ButtonStage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__card_purchase_validation_CardPurchaseValidation__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var CardInfoMobile = function CardInfoMobile(props) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedYear = _useState2[0],
    setSelectedYear = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedMonth = _useState4[0],
    setSelectedMonth = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.creditCard.cvv),
    _useState6 = _slicedToArray(_useState5, 2),
    cvv = _useState6[0],
    setCvv = _useState6[1];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    setCvv(props.creditCard.cvv);
  }, [props.creditCard.cvv]);
  var year_options = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var now = new Date().getUTCFullYear();
    return Array.from({
      length: 20
    }, function (_, i) {
      return now + i;
    });
  }, []);
  var cleanNumber = function cleanNumber(number) {
    return number.replace(/\D/g, '');
  };
  var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
      var number = props.creditCard.number || '';
      var brand = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["detectCardBrand"])(number);
      var valid = brand && Object(__WEBPACK_IMPORTED_MODULE_7__utils__["validateCreditCard"])(brand, cleanNumber(number), 'number');
      return {
        detectedBrand: brand,
        cardValid: !!valid
      };
    }, [props.creditCard.number]),
    detectedBrand = _useMemo.detectedBrand,
    cardValid = _useMemo.cardValid;
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    if (name === 'expiry_month') setSelectedMonth(value);
    if (name === 'expiry_year') setSelectedYear(value);
    if (name === 'cvv') setCvv(value);
    if (name === 'number') {
      var currentBrand = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["detectCardBrand"])(value);
      if (currentBrand) {
        var brandIndex = props.brands.findIndex(function (b) {
          return b.brand_name === currentBrand;
        });
        if (brandIndex !== -1 && !props.brands[brandIndex].selected) {
          props.selectCreditCardBrand(brandIndex);
        }
      }
    }
    props.changeCreditCardAttr({
      name: name,
      value: value
    });
  };
  var cardErrors = props.errors;
  var hasCvvError = !!cardErrors.cvv;
  var input_credit_card = Object(__WEBPACK_IMPORTED_MODULE_2__utils_masks__["a" /* getMask */])(detectedBrand);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "a-form mobile",
    style: {
      display: props.stepDisplayCreditCard !== 3 ? 'none' : 'block'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Informe os dados do seu cart\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__card_purchase_validation_CardPurchaseValidation__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols",
    style: {
      flex: 2
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
    guide: false,
    type: "tel",
    name: "number",
    id: "cc-number",
    inputMode: "numeric",
    onChange: handleChange,
    mask: input_credit_card.mask,
    value: props.creditCard.number || '',
    className: "".concat(cardErrors.number ? 'with-error' : ''),
    placeholder: "N\xFAmero do cart\xE3o",
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_number');
    },
    keepCharPositions: true
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-brandcard"
  }, detectedBrand && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/home/home/cards/v2/".concat(detectedBrand, ".svg"),
    alt: detectedBrand
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "number",
    field1: "creditCard",
    field2: "number"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input-cols input-parcels"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols",
    style: {
      flex: 2
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
    id: "card-installments",
    name: "parcels",
    disabled: !cardValid,
    onChange: function onChange(e) {
      var idx = props.parcels.findIndex(function (p) {
        return p.times === Number(e.target.value);
      });
      if (idx !== -1) props.selectCreditCardParcel(idx);
    },
    value: props.parcels.find(function (p) {
      return p.selected;
    }) && props.parcels.find(function (p) {
      return p.selected;
    }).times || ''
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
    value: "",
    disabled: true
  }, "Selecione o parcelamento:"), cardValid && props.parcels.map(function (parcel, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
      value: parcel.times,
      key: i
    }, parcel.times, "x de R$ ", parcel.price);
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "creditCard_parcels",
    field1: "creditCard",
    field2: 'parcels'
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input-cols input-date"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
    name: "expiry_month",
    form: "",
    id: "cc-expiry-month",
    onChange: handleChange,
    className: "mes ".concat(cardErrors.expiry_month ? 'with-error' : ''),
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_month');
      setSelectedMonth(e.target.value);
    },
    value: selectedMonth
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }, "M\xEAs"), __WEBPACK_IMPORTED_MODULE_3__utils_creditCard__["a" /* month_options */].map(function (month, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
      value: month.value,
      key: i
    }, month.name);
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "number",
    field1: "creditCard",
    field2: "expiry_month"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
    name: "expiry_year",
    id: "cc-expiry-year",
    onChange: handleChange,
    className: "ano ".concat(cardErrors.expiry_year ? 'with-error' : ''),
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_year');
      setSelectedYear(e.target.value);
    },
    value: selectedYear
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
    value: "",
    disabled: true,
    hidden: true
  }, "Ano"), year_options.map(function (year, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
      value: year,
      key: i
    }, year);
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "number",
    field1: "creditCard",
    field2: "expiry_year"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input-cols input-cvv".concat(hasCvvError ? ' with-error' : '')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols input-credit"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
    type: "tel",
    name: "cvv",
    guide: false,
    inputMode: "numeric",
    mask: [/\d/, /\d/, /\d/, /\d/],
    id: "cc-verfication-code",
    onChange: handleChange,
    value: cvv,
    placeholder: "CVV",
    className: "".concat(cardErrors.cvv ? 'with-error' : ''),
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_cvv');
      setCvv(e.target.value);
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    className: "form-error-message",
    anchor: "number",
    field1: "creditCard",
    field2: "cvv"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols image-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: detectedBrand === 'amex' ? '/assets/images/cvv-icon-2.svg' : '/assets/images/cvv-icon.svg',
    alt: "cvv-card",
    className: "img-brand"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "cols instruction"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "text-credit-card"
  }, detectedBrand === 'amex' ? '4' : '3', " digitos ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "atr\xE1s do ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "cart\xE3o."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "text",
    name: "holder_name",
    id: "cc-holder-name",
    placeholder: "Nome do titular",
    onChange: handleChange,
    value: props.creditCard.holder_name,
    className: "".concat(cardErrors.holder_name ? 'with-error' : ''),
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_holdername');
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "number",
    field1: "creditCard",
    field2: "holder_name"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "row-input"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
    guide: true,
    name: "holder_cpf",
    type: "tel",
    value: props.creditCard.holder_cpf,
    mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    id: "cc-holder-cpf",
    placeholder: "CPF",
    onChange: handleChange,
    className: "upper ".concat(cardErrors.holder_cpf ? 'with-error' : ''),
    onBlur: function onBlur(e) {
      props.validatorHandlerBlur(e.target.value, 'creditcard_holdercpf');
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__error_message_ErrorMessage__["a" /* default */], {
    anchor: "number",
    field1: "creditCard",
    field2: "holder_cpf"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__standard_button_stage_ButtonStage__["a" /* default */], {
    "data-cy": "step-payment-data",
    index: 3,
    stage: "INSURED_PAYMENT_PURCHASE"
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (CardInfoMobile);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CardBrand = function CardBrand(_ref) {
  var brands = _ref.brands,
    selectCreditCardBrand = _ref.selectCreditCardBrand;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "area-cartoes flex"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "area-bandeiras"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "lista-cartoes radio-input"
  }, brands.map(function (card, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: index
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      id: "card".concat(index),
      name: "c1",
      checked: card.selected,
      onChange: function onChange() {
        return selectCreditCardBrand(index);
      }
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: "card".concat(index)
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      src: "/assets/images/home/home/cards/v2/".concat(card.brand_name, ".svg"),
      alt: "".concat(card.brand_name, " logo")
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "cartao-titulo"
    }, card.parcels > 1 ? "At\xE9 ".concat(card.parcels, "x") : 'À vista')));
  }))));
};
/* harmony default export */ __webpack_exports__["a"] = (CardBrand);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var CardBrandMobile = /*#__PURE__*/function (_Component) {
  function CardBrandMobile(props) {
    var _this;
    _classCallCheck(this, CardBrandMobile);
    _this = _callSuper(this, CardBrandMobile, [props]);
    _defineProperty(_this, "selectBrand", function (i) {
      _this.props.selectPaymentCreditCard(2);
      _this.props.selectCreditCardBrand(i);
    });
    _this.selectBrand = _this.selectBrand.bind(_this);
    return _this;
  }
  _inherits(CardBrandMobile, _Component);
  return _createClass(CardBrandMobile, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-cartoes flex mobile",
        style: {
          display: this.props.stepDisplayCreditCard !== 1 && !this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Selecione a bandeira do seu cart\xE3o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-bandeiras"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-cartoes radio-input"
      }, this.props.brands.map(function (card, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "",
          key: i,
          onClick: function onClick() {
            return _this2.selectBrand(i);
          }
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          type: "radio",
          id: 'card' + i,
          name: "c1",
          checked: card.selected,
          onChange: function onChange() {
            return _this2.selectBrand(i);
          }
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
          htmlFor: 'card' + i
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
          src: "/assets/images/home/home/cards/v2/".concat(card.brand_name, ".svg"),
          alt: ""
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "cartao-titulo"
        }, card.brand_name, " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), card.parcels >= 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small", null, "At\xE9 ", card.parcels, "x sem juros"))));
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* unused harmony default export */ var _unused_webpack_default_export = (CardBrandMobile);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var PaymentDeadline = function PaymentDeadline(props) {
  var selectParcel = function selectParcel(i) {
    props.selectPaymentCreditCard(3);
    props.selectCreditCardParcel(i);
  };
  if (!props.parcels) return null;
  if (props.type === 'mobile') return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "list-parcelas-mobile",
    style: {
      display: props.stepDisplayCreditCard !== 2 ? 'none' : 'block'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Op\xE7\xF5es de parcelamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, props.parcels.map(function (parcels, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: 'radio' + i,
      key: i
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "".concat(parcels.selected && 'checked')
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, parcels.times, " ", parcels.times > 1 ? 'parcelas' : 'parcela', ' '), ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, parcels.times, "x de R$ ", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["formatPrice"])(parcels.price)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      index: i,
      checked: parcels.selected,
      id: 'radio' + i,
      name: "parcela",
      onChange: function onChange(_) {
        return selectParcel(i);
      },
      onClick: function onClick(_) {
        return selectParcel(i);
      }
    })));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__error_message_ErrorMessage__["a" /* default */], {
    anchor: "creditCard_parcels",
    field1: "creditCard",
    field2: 'parcels'
  }));
  var halfwayIndex = Math.ceil(props.parcels.length / 2);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "flex parcelamento-desktop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, "Selecione a quantidade de parcelas"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "list-parcelas"
  }, props.parcels.map(function (parcels, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "".concat(parcels.selected && 'checked', " item ").concat(i >= halfwayIndex ? 'second-half' : ''),
      key: i,
      onClick: function onClick(_) {
        return props.selectCreditCardParcel(i);
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: 'radio' + i,
      className: "label-form"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "radio",
      index: i,
      checked: parcels.selected ? true : false,
      id: 'radio' + i,
      name: "parcela",
      onChange: function onChange(_) {
        return props.selectCreditCardParcel(i);
      }
    }), parcels.times, "x R$ ", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["formatPrice"])(parcels.price)));
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      marginTop: '20px'
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__error_message_ErrorMessage__["a" /* default */], {
    anchor: "creditCard_parcels",
    field1: "creditCard",
    field2: 'parcels',
    style: {
      marginTop: 'unset',
      marginBottom: 'unset'
    }
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (PaymentDeadline);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__standard_button_stage_ButtonStage__ = __webpack_require__(25);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }








var HolderInfo = /*#__PURE__*/function (_Component) {
  function HolderInfo(props) {
    _classCallCheck(this, HolderInfo);
    return _callSuper(this, HolderInfo, [props]);
  }
  _inherits(HolderInfo, _Component);
  return _createClass(HolderInfo, [{
    key: "render",
    value: function render() {
      var _this = this;
      var selected_bank = this.props.banks.filter(function (bank) {
        return bank.selected;
      })[0];
      var hasFormError = this.props.errors && Object.values(this.props.errors.safetypay).some(function (value) {
        return value !== false;
      });
      var transferErrors = this.props.errors.safetypay;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        style: {
          display: this.props.stepDisplayCashTransfer !== 2 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4", {
        className: "title-cash-transfer"
      }, "Dados da transfer\xEAncia"), selected_bank && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "infos-cash-transfer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
        src: "/assets/images/banks/".concat(selected_bank.slug, ".svg"),
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("strong", {
        className: "bank-name"
      }, selected_bank.name), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("form", {
        className: "transfer-form".concat(hasFormError ? " with-error" : "")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
        type: "text",
        name: "name",
        value: this.props.name,
        placeholder: 'Nome do titular',
        onChange: this.props.handleChange,
        className: transferErrors.name ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this.props.validatorHandlerBlur(e.target.value, 'transf_name');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__error_message_ErrorMessage__["a" /* default */], {
        anchor: "safetypay_name",
        field1: "safetypay",
        field2: "name",
        className: "form-error"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        name: "cpf",
        guide: true,
        type: "tel",
        value: this.props.cpf,
        placeholder: 'CPF',
        onChange: this.props.handleChange,
        className: transferErrors.cpf ? 'with-error' : '',
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        onBlur: function onBlur(e) {
          return _this.props.validatorHandlerBlur(e.target.value, 'transf_cpf');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__error_message_ErrorMessage__["a" /* default */], {
        anchor: "safetypay_cpf",
        field1: "safetypay",
        field2: "cpf",
        className: "form-error"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        type: "tel",
        name: "agency",
        pattern: "\\d*",
        placeholder: 'Agência',
        inputMode: "numeric",
        value: this.props.agency,
        guide: false,
        className: transferErrors.agency ? 'with-error' : '',
        mask: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["maskCashTransferAgency"])(selected_bank ? selected_bank : ''),
        onChange: this.props.handleChange,
        onBlur: function onBlur(e) {
          return _this.props.validatorHandlerBlur(e.target.value, 'transf_agency');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__error_message_ErrorMessage__["a" /* default */], {
        anchor: "safetypay_agency",
        field1: "safetypay",
        field2: "agency",
        className: "form-error"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        type: "tel",
        name: "account",
        pattern: "\\d*",
        placeholder: 'Conta',
        inputMode: "numeric",
        value: this.props.account,
        guide: false,
        className: transferErrors.account ? 'with-error' : '',
        mask: Object(__WEBPACK_IMPORTED_MODULE_5__utils__["maskCashTransferAccount"])(selected_bank ? selected_bank : ''),
        onChange: this.props.handleChange,
        onBlur: function onBlur(e) {
          return _this.props.validatorHandlerBlur(e.target.value, 'transf_account');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__error_message_ErrorMessage__["a" /* default */], {
        anchor: "safetypay_account",
        field1: "safetypay",
        field2: "account",
        className: "form-error"
      })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
        className: "transfer-infos payment",
        onClick: function onClick(_) {
          return _this.props.getInfosInsureds(3);
        }
      }, "Copiar dados do primeiro segurado"));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
var CardBank = /*#__PURE__*/function (_Component2) {
  function CardBank(props) {
    var _this2;
    _classCallCheck(this, CardBank);
    _this2 = _callSuper(this, CardBank, [props]);
    _defineProperty(_this2, "selectBank", function (i) {
      _this2.props.selectBankCashTransfer(2);
      _this2.props.selectBank(i);
    });
    _this2.selectBank = _this2.selectBank.bind(_this2);
    return _this2;
  }
  _inherits(CardBank, _Component2);
  return _createClass(CardBank, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "area-bandeiras ".concat(this.props.errors.safetypay.banks ? 'is-invalid' : ''),
        style: {
          display: this.props.stepDisplayCashTransfer !== 1 && this.props.mobile ? 'none' : 'flex'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h4", {
        className: "mobile"
      }, "Selecione o seu banco"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul", {
        className: "lista-bancos radio-input"
      }, this.props.banks.map(function (bank, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", {
          className: "",
          key: index
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
          type: "radio",
          id: bank.slug,
          name: "name",
          checked: bank.selected,
          onClick: function onClick() {
            return _this3.selectBank(index);
          },
          onChange: function onChange() {
            return _this3.selectBank(index);
          }
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
          htmlFor: bank.slug
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
          src: "/assets/images/banks/".concat(bank.slug, ".svg"),
          alt: ""
        }), _this3.props.mobile && bank.name)));
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("u", {
        onClick: this.props.openModalSafetypay,
        className: "text-safetypay mobile"
      }, "Clique aqui para ver as condi\xE7\xF5es via SafetyPay"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", {
        className: "bank-error-message"
      }, this.props.errors.safetypay.banks || null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
var CashTransfer = /*#__PURE__*/function (_Component3) {
  function CashTransfer(props) {
    var _this4;
    _classCallCheck(this, CashTransfer);
    _this4 = _callSuper(this, CashTransfer, [props]);
    _this4.handleChange = _this4.handleChange.bind(_this4);
    return _this4;
  }
  _inherits(CashTransfer, _Component3);
  return _createClass(CashTransfer, [{
    key: "componentWillMount",
    value: function componentWillMount(props) {
      var today = new Date();
      var deadline = today.addDays(1);
      var year = deadline.getUTCFullYear();
      var month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      var day = deadline.getUTCDate().toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      this.deadline = "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      this.props.changeCashTransferAttr(field);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.paymentMethods.find(function (element) {
        return element.slug === 'safetypay';
      }).available) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "area-transferencia"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "area-bancos flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(CardBank, {
        banks: this.props.banks,
        errors: this.props.errors,
        selectBank: this.props.selectBank,
        stepDisplayCashTransfer: this.props.stepDisplayCashTransfer,
        selectBankCashTransfer: this.props.selectBankCashTransfer,
        mobile: this.props.mobile,
        openModalSafetypay: this.props.openModalSafetypay
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(HolderInfo, {
        name: this.props.name,
        cpf: this.props.cpf,
        handleChange: this.handleChange,
        banks: this.props.banks,
        mobile: this.props.mobile,
        stepDisplayCashTransfer: this.props.stepDisplayCashTransfer,
        validatorHandlerBlur: this.props.validatorHandlerBlur,
        getInfosInsureds: this.props.getInfosInsureds,
        errors: this.props.errors
      }), this.props.mobile && this.props.stepDisplayCashTransfer === 2 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__standard_button_stage_ButtonStage__["a" /* default */], {
        "data-cy": "step-payment-data",
        index: 3,
        stage: "INSURED_PAYMENT_PURCHASE"
      }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
  return {
    cpf: state.purchase.safetypay.cpf,
    name: state.purchase.safetypay.name,
    banks: state.purchase.safetypay.banks,
    paymentMethods: state.purchase.paymentMethods,
    errors: state.purchase.errors,
    mobile: state.mobile.mobileActive,
    stepDisplayCashTransfer: state.purchase.stepDisplayCashTransfer
  };
}, {
  selectBank: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_14" /* selectBank */],
  openModalSafetypay: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_9" /* openModalSafetypay */],
  changeCashTransferAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["g" /* changeCashTransferAttr */],
  selectBankCashTransfer: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_15" /* selectBankCashTransfer */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_32" /* validatorHandlerBlur */],
  getInfosInsureds: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["S" /* getInfosInsureds */]
})(CashTransfer)));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__standard_button_stage_ButtonStage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BoxInfos__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }









var Pix = /*#__PURE__*/function (_Component) {
  function Pix(props) {
    var _this;
    _classCallCheck(this, Pix);
    _this = _callSuper(this, Pix, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _inherits(Pix, _Component);
  return _createClass(Pix, [{
    key: "handleChange",
    value: function handleChange(e) {
      var field = {
        name: e.target.name,
        value: e.target.value
      };
      this.props.changePixAttr(field);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.props.paymentMethods.find(function (element) {
        return element.slug === 'pix';
      }).available) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var deadline = this.props.paymentMethods.find(function (element) {
        return element.slug === 'pix';
      }).deadline;
      var pixErrors = this.props.errors.pix;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "area-pix",
        style: {
          display: this.props.stepDisplayPix !== 1 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "title",
        style: this.props.purchaseSummary.total === 0 ? {
          paddingTop: 0
        } : {}
      }, "Respons\xE1vel pelo pagamento"), this.props.purchaseSummary.total !== 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_BoxInfos__["a" /* default */], {
        image: "/assets/images/icons/warning.svg",
        altIcon: "icon-warning",
        theme: "warning"
      }, "Lembrando que seu pagamento dever\xE1 ser realizado em at\xE9 ".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["deadlineForText"])(deadline), " ap\xF3s finalizar a compra.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        id: "pix_name",
        name: "name",
        value: this.props.pix.name,
        placeholder: "Nome completo",
        onChange: this.handleChange,
        className: "".concat(pixErrors.name ? 'with-error' : ''),
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'pix_name');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "pix_name",
        field1: "pix",
        field2: "name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "input-form1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_text_mask___default.a, {
        name: "cpf",
        guide: true,
        type: "tel",
        placeholder: "CPF",
        onChange: this.handleChange,
        value: this.props.pix.cpf,
        className: "".concat(pixErrors.cpf ? 'with-error' : ''),
        mask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'pix_cpf');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__error_message_ErrorMessage__["a" /* default */], {
        anchor: "pix_cpf",
        field1: "pix",
        field2: "cpf"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "transfer-infos payment",
        onClick: function onClick() {
          return _this2.props.getInfosInsureds(4);
        }
      }, "Copiar dados do primeiro segurado"), this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__standard_button_stage_ButtonStage__["a" /* default */], {
        "data-cy": "step-payment-data",
        index: 3,
        stage: "INSURED_PAYMENT_PURCHASE"
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    pix: state.purchase.pix,
    paymentMethods: state.purchase.paymentMethods,
    mobile: state.mobile.mobileActive,
    stepDisplayPix: state.purchase.stepDisplayPix,
    errors: state.purchase.errors,
    purchaseSummary: state.purchase.purchaseSummary
  };
}, {
  changePixAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["k" /* changePixAttr */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_32" /* validatorHandlerBlur */],
  getInfosInsureds: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["S" /* getInfosInsureds */]
})(Pix)));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var Alert = /*#__PURE__*/function (_Component) {
  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _callSuper(this, Alert, [props]);
    _this.onClose = _this.props.onClose.bind(_this);
    return _this;
  }
  _inherits(Alert, _Component);
  return _createClass(Alert, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp-alert"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "iconleft"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/infoico.svg",
        alt: "info icon"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, this.props.children));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Alert);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inputs_getPixInput__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inputs_getBoletoInput__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inputs_getCreditCardInput__ = __webpack_require__(289);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }






var selectMethodPayment = function selectMethodPayment(index, paymentMethod, props) {
  if (paymentMethod === 'credit-card') {
    props.selectPaymentMethodAlterStage(3, 'stepDisplayCreditCard', 3);
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'boleto') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayBoleto');
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'safetypay') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayCashTransfer');
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'pix') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayPix');
    props.selectPaymentMethod(index);
  }
};
var PaymentMethodMobile = /*#__PURE__*/function (_Component) {
  function PaymentMethodMobile() {
    var _this;
    _classCallCheck(this, PaymentMethodMobile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PaymentMethodMobile, [].concat(args));
    _defineProperty(_this, "state", {
      activePayment: false
    });
    return _this;
  }
  _inherits(PaymentMethodMobile, _Component);
  return _createClass(PaymentMethodMobile, [{
    key: "componentWillMount",
    value: function componentWillMount(props) {
      var today = new Date();
      var deadline = today.addDays(1);
      var year = deadline.getUTCFullYear();
      var month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      var day = deadline.getUTCDate().toLocaleString('pt-BR', {
        minimumIntegerDigits: 2
      });
      this.deadline = "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      if (this.props.brands.length !== 0) {
        this.parcels = this.props.brands.reduce(function (prev, current) {
          return prev.parcels > current.parcels ? prev : current;
        });
      }
      var payments = [];
      this.props.paymentMethods.sort(function (a, b) {
        return a.displayOrder > b.displayOrder ? 1 : b.displayOrder > a.displayOrder ? -1 : 0;
      });
      for (var i = 0; i < this.props.paymentMethods.length; i++) {
        if (this.props.paymentMethods[i].active) {
          if (this.props.paymentMethods[i].slug === 'credit-card') payments.push(Object(__WEBPACK_IMPORTED_MODULE_5__inputs_getCreditCardInput__["a" /* default */])(this.props, plan, this.parcels, selectMethodPayment, i));else if (this.props.paymentMethods[i].slug === 'boleto') payments.push(Object(__WEBPACK_IMPORTED_MODULE_4__inputs_getBoletoInput__["a" /* default */])(this.props, plan, selectMethodPayment, i));else if (this.props.paymentMethods[i].slug === 'pix') payments.push(Object(__WEBPACK_IMPORTED_MODULE_3__inputs_getPixInput__["a" /* default */])(this.props, plan, selectMethodPayment, i));
        }
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-opcoes-pagamento mobile",
        style: {
          display: this.props.stagePurchase !== 2 && this.props.mobile ? 'none' : 'flex'
        }
      }, payments);
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    paymentMethods: state.purchase.paymentMethods,
    purchaseSummary: state.purchase.purchaseSummary,
    couponInfo: state.purchase.coupon,
    stagePurchase: state.purchase.stagePurchase,
    plan: state.search.plans,
    brands: state.purchase.creditCard.brands
  };
}, {
  selectPaymentMethodAlterStage: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["_20" /* selectPaymentMethodAlterStage */]
})(PaymentMethodMobile));

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DiscountBlock__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PriceBlock__ = __webpack_require__(58);




var getPixInput = function getPixInput(props, plan, selectMethodPayment, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    key: props.paymentMethods[i].id,
    "data-cy": "method-pix"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "".concat(props.paymentMethods[i]["class"], "  opcao"),
    onClick: function onClick() {
      return selectMethodPayment(i, 'pix', props);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "mobile-payment-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "icon-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/pagamento/".concat(props.paymentMethods[i].img, ".svg"),
    alt: "pagamento"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "uppercase"
  }, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "desc-info"
  }, "O pagamento deve ser realizado em at\xE9 ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["deadlineForText"])(props.paymentMethods[i].deadline), " ap\xF3s finalizar a compra."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DiscountBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "pix"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PriceBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "pix"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "small-payment"
  }, "Exclusivo para pagamento no Pix")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "advancer-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null))));
};
/* harmony default export */ __webpack_exports__["a"] = (getPixInput);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountBlock__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriceBlock__ = __webpack_require__(58);



var getBoletoInput = function getBoletoInput(props, plan, selectMethodPayment, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    key: props.paymentMethods[i].id,
    "data-cy": "method-bankslip"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "".concat(props.paymentMethods[1]["class"], "  opcao"),
    onClick: function onClick() {
      return selectMethodPayment(i, 'boleto', props);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "mobile-payment-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "icon-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/pagamento/".concat(props.paymentMethods[1].img, ".svg"),
    alt: "pagamento"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "desc-info"
  }, "Pague seu seguro viagem com o boleto e ganhe desconto"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DiscountBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "boleto"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PriceBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "boleto"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "small-payment"
  }, "Exclusivo para pagamento no boleto")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "advancer-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null))));
};
/* harmony default export */ __webpack_exports__["a"] = (getBoletoInput);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountBlock__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriceBlock__ = __webpack_require__(58);



var getCreditCardInput = function getCreditCardInput(props, plan, parcels, selectMethodPayment, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    key: props.paymentMethods[i].id,
    "data-cy": "method-credit-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "".concat(props.paymentMethods[i]["class"], "  opcao"),
    onClick: function onClick() {
      return selectMethodPayment(i, 'credit-card', props);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "mobile-payment-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "icon-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/pagamento/".concat(props.paymentMethods[i].img, ".svg"),
    alt: "pagamento"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "name-payment-mobile"
  }, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "desc-info"
  }, "American Express, Visa, Mastercard Elo, Diners Club Internacional"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DiscountBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "credit-card"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PriceBlock__["a" /* default */], {
    paymentMethods: props.paymentMethods,
    purchaseSummary: props.purchaseSummary,
    paymentMethodSlug: "credit-card"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "small-payment"
  }, "Pague em at\xE9 ", parcels ? parcels.parcels : '12', "x sem Juros")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "advancer-payment-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null))));
};
/* harmony default export */ __webpack_exports__["a"] = (getCreditCardInput);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__ = __webpack_require__(59);


var getCreditCardInput = function getCreditCardInput(props, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "radio",
    name: "methodPayment",
    onChange: function onChange() {
      return props.selectPaymentMethod(i);
    },
    checked: props.paymentMethods[i].selected,
    id: props.paymentMethods[i]["class"]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__["a" /* default */], {
    paymentMethod: props.paymentMethods[i],
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: props.paymentMethods[i]["class"]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "American Express, Visa, Mastercard, Elo, Diners Club Internacional, Hipercard"))
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (getCreditCardInput);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__ = __webpack_require__(59);


var getBoletoInput = function getBoletoInput(props, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "radio",
    name: "methodPayment",
    onChange: function onChange() {
      return props.selectPaymentMethod(i);
    },
    checked: !!props.paymentMethods[i].selected,
    id: props.paymentMethods[i]["class"]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__["a" /* default */], {
    paymentMethod: props.paymentMethods[i],
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
      htmlFor: props.paymentMethods[i]["class"]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Pague seu seguro viagem com o boleto e ganhe desconto"))
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (getBoletoInput);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);



var getPixInput = function getPixInput(props, i) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "radio",
    name: "methodPayment",
    onChange: function onChange() {
      return props.selectPaymentMethod(i);
    },
    checked: !!props.paymentMethods[i].selected,
    id: props.paymentMethods[i]["class"]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DiscountFlagImage__["a" /* default */], {
    paymentMethod: props.paymentMethods[i],
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", null, props.paymentMethods[i].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "info-pix"
    }, "O pagamento deve ser realizado em at\xE9 ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["deadlineForText"])(props.paymentMethods[i].deadline), " ap\xF3s finalizar a compra."))),
    imgData: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
      className: "pay-me-icon",
      src: "/assets/images/pagamento/payMeeIcon.png",
      alt: "icone da plataforma payMee"
    })
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (getPixInput);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalFranchise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalFranchise = /*#__PURE__*/function (_Component) {
  function ModalFranchise(props) {
    var _this;
    _classCallCheck(this, ModalFranchise);
    _this = _callSuper(this, ModalFranchise, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    _this.covidCoverage = false;
    return _this;
  }
  _inherits(ModalFranchise, _Component);
  return _createClass(ModalFranchise, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match.params, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), window.location.search)
      };
      this.props.closeModalFranchise();
      this.props.history.push(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalFranchiseActive || this.props.errorsModalFranchise) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      var benefits = this.props.rawProductCoverage;
      var franchise = benefits.filter(function (benefit) {
        return benefit.code === '500';
      });
      franchise = franchise.length && franchise[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal",
        onClick: this.props.closeModalFranchise
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalFranchise,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Confirma o seguro viagem com franquia?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "O seguro viagem escolhido \xE9 uma excelente op\xE7\xE3o, mas aten\xE7\xE3o, para acionar Despesas M\xE9dicas Hospitalares (DMH) existe uma franquia de ", franchise.coverage, ". Os demais benef\xEDcios est\xE3o isentos de franquia.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalFranchise
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    benefits: state.purchase.benefits_list,
    rawProductCoverage: state.coverage.rawProductCoverage,
    isModalFranchiseActive: state.purchase.isModalFranchiseActive,
    errorsModalFranchise: state.purchase.errors.errorsModalFranchise,
    plan: state.purchase.plans
  };
}, {
  closeModalFranchise: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["t" /* closeModalFranchise */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalFranchise)));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalStudent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalStudent = /*#__PURE__*/function (_Component) {
  function ModalStudent(props) {
    var _this;
    _classCallCheck(this, ModalStudent);
    _this = _callSuper(this, ModalStudent, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalStudent, _Component);
  return _createClass(ModalStudent, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match.params, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), '', true),
        search: window.location.search
      };
      this.props.history.push(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalStudentActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title center"
      }, "Confirma o seguro viagem com finalidade estudantil? "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalStudent,
        className: "close-btn"
      }, " \xD7 ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle",
        style: {
          margin: '10px 40px 30px 40px'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Este seguro viagem s\xF3 tem cobertura pra quem vai estudar. Se for o seu caso aproveite a economia, se n\xE3o for escolha outro seguro viagem. Na d\xFAvida entre em contato conosco!")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalStudent
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    benefits: state.purchase.benefits_list,
    rawProductCoverage: state.coverage.rawProductCoverage,
    isModalStudentActive: state.purchase.isModalStudentActive
  };
}, {
  closeModalStudent: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["D" /* closeModalStudent */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalStudent)));

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalSafetypay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalSafetypay = /*#__PURE__*/function (_Component) {
  function ModalSafetypay() {
    _classCallCheck(this, ModalSafetypay);
    return _callSuper(this, ModalSafetypay, arguments);
  }
  _inherits(ModalSafetypay, _Component);
  return _createClass(ModalSafetypay, [{
    key: "render",
    value: function render() {
      if (!this.props.isModalSafetypayActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento safetypay-modal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Instru\xE7\xF5es para pagamento via SafetyPay"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalSafetypay,
        className: "close-btn ".concat(this.props.mobile && ' mobile')
      }, ' ', "\xD7", ' ')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "modallist"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "listcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "listline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "ico"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/valor-safety.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "text"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Transfira o valor exato da sua compra"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "listline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "ico"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/not-allowed.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "text"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "N\xE3o "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "utilize contas de Pessoa Jur\xEDdica"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "listline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "ico"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/not-allowed.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "text"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "N\xE3o "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "utilize Conta Poupan\xE7a"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "listline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "ico"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/not-allowed.svg",
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "text"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Pague somente por meio do Internet Banking do banco acima. N\xE3o dispon\xEDvel para caixa eletr\xF4nico, telefone ou pela ag\xEAncia banc\xE1ria.")))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalbotton"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Importante ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), ' '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, "Para prosseguir com a contrata\xE7\xE3o, \xE9 necess\xE1rio concordar com os termos e condi\xE7\xF5es de uso de cada seguradora.")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalSafetypayActive: state.purchase.isModalSafetypayActive,
    mobile: state.mobile.mobileActive
  };
}, {
  closeModalSafetypay: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["C" /* closeModalSafetypay */]
})(ModalSafetypay));

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalOperatorConfirmationV2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_preventScroll__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ModalOperatorConfirmationV2View__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ModalPlanIncompatible__ = __webpack_require__(300);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }










var daysDifference = function daysDifference(startDate, endDate) {
  var diffTime = Math.abs(new Date(endDate) - new Date(startDate));
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};
var INCOMPATIBLE_PLAN_TAG_ID = 91;
var ModalOperatorConfirmationV2 = function ModalOperatorConfirmationV2(_ref) {
  var isModalOperatorConfirmationActive = _ref.isModalOperatorConfirmationActive,
    openModalOperatorConfirmation = _ref.openModalOperatorConfirmation,
    closeModalOperatorConfirmation = _ref.closeModalOperatorConfirmation,
    setOperatorConfirmationClicked = _ref.setOperatorConfirmationClicked,
    cleanStatesPurchaseMobile = _ref.cleanStatesPurchaseMobile,
    cleanErrors = _ref.cleanErrors,
    plans = _ref.plans,
    providers = _ref.providers,
    destinations = _ref.destinations,
    history = _ref.history,
    match = _ref.match;
  var hasCheckedParams = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var originalTrip = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({
    destination: match.params.destination || '',
    beginDate: match.params.begin_date || '',
    endDate: match.params.end_date || ''
  });
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
    _useState4 = _slicedToArray(_useState3, 2),
    destinationSlug = _useState4[0],
    setDestinationSlug = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState6 = _slicedToArray(_useState5, 2),
    destinationDropdownOpen = _useState6[0],
    setDestinationDropdownOpen = _useState6[1];
  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      startDate: null,
      endDate: null
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    range = _useState8[0],
    setRange = _useState8[1];
  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isMobileDatepickerOpen = _useState0[0],
    setIsMobileDatepickerOpen = _useState0[1];
  var _useState1 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('range'),
    _useState10 = _slicedToArray(_useState1, 2),
    datepickMode = _useState10[0],
    setDatepickMode = _useState10[1];
  var _useState11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDesktopPickerOpen = _useState12[0],
    setIsDesktopPickerOpen = _useState12[1];
  var _useState13 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('range'),
    _useState14 = _slicedToArray(_useState13, 2),
    desktopPickerMode = _useState14[0],
    setDesktopPickerMode = _useState14[1];
  var _useState15 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isConfirming = _useState16[0],
    setIsConfirming = _useState16[1];
  var _useState17 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showIncompatible = _useState18[0],
    setShowIncompatible = _useState18[1];
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (hasCheckedParams.current) return;
    var params = Object(__WEBPACK_IMPORTED_MODULE_3__utils__["getUrlParams"])();
    if (params.operator !== undefined) openModalOperatorConfirmation();
    hasCheckedParams.current = true;
  }, [openModalOperatorConfirmation]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isModalOperatorConfirmationActive) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_preventScroll__["a" /* addPreventScrollStyle */])();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_preventScroll__["b" /* removePreventScrollStyle */])();
    }
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_preventScroll__["b" /* removePreventScrollStyle */])();
    };
  }, [isModalOperatorConfirmationActive]);
  var openDatepickerFor = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (mode) {
    var startDate = range.startDate,
      endDate = range.endDate;
    var effective = mode;
    if (!startDate && !endDate) {
      effective = 'range';
    } else if (startDate && endDate) {
      effective = 'range';
    } else if (mode !== 'start' && mode !== 'end') {
      effective = 'range';
    }
    if (typeof window !== 'undefined' && window.innerWidth >= 769) {
      setDesktopPickerMode(effective);
      setIsDesktopPickerOpen(true);
    } else {
      setDatepickMode(effective);
      setIsMobileDatepickerOpen(true);
    }
  }, [range]);
  var findDestinationBySlug = function findDestinationBySlug(slug) {
    if (!slug || !destinations) {
      return null;
    }
    return destinations.find(function (d) {
      return d.slug === slug;
    });
  };
  var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
      if (!providers || !plans || !plans.length) return {
        providerName: '',
        providerImgPath: ''
      };
      var currentPlan = plans[0];
      var provider = providers.find(function (p) {
        return String(p.id) === String(currentPlan.provider_code);
      });
      if (!provider) return {
        providerName: '',
        providerImgPath: ''
      };
      return {
        providerName: provider.name,
        providerImgPath: "/assets/images/seguradoras/".concat(provider.slug, ".png")
      };
    }, [providers, plans]),
    providerName = _useMemo.providerName,
    providerImgPath = _useMemo.providerImgPath;
  var selectedDestination = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    if (!destinationSlug || !destinations) {
      return '';
    }
    return destinations.find(function (d) {
      return d.slug === destinationSlug;
    });
  }, [destinationSlug, destinations]);
  var hasClientAltered = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var _originalTrip$current = originalTrip.current,
      destination = _originalTrip$current.destination,
      beginDate = _originalTrip$current.beginDate,
      endDate = _originalTrip$current.endDate;
    var EQUIVALENT_DESTINATIONS = [new Set(['america-do-sul', 'argentina'])];
    if (!destination && !beginDate && !endDate) {
      return false;
    }
    var originalDestination = findDestinationBySlug(destination);
    var isDestinationAmericaDoSulEquivalent = function isDestinationAmericaDoSulEquivalent(a, b) {
      return EQUIVALENT_DESTINATIONS.some(function (pair) {
        return pair.has(a) && pair.has(b);
      });
    };
    var originalDestinationSlug = originalDestination ? originalDestination.slug : null;
    if (originalDestination && originalDestination.promotion_destination_slug) {
      originalDestinationSlug = originalDestination.promotion_destination_slug;
    }
    var selectedDestinationSlug = destinationSlug;
    if (selectedDestination && selectedDestination.promotion_destination_slug) {
      selectedDestinationSlug = selectedDestination.promotion_destination_slug;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.startDate) !== beginDate || Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.endDate) !== endDate) {
      return true;
    }

    // Consider america-do-sul equivalent destinations to avoid false positives.
    if (isDestinationAmericaDoSulEquivalent(selectedDestinationSlug, originalDestinationSlug)) {
      return false;
    }
    if (selectedDestinationSlug !== originalDestinationSlug) {
      return true;
    }
    return false;
  }, [destinationSlug, range]);
  var isFormComplete = !!(destinationSlug && range.startDate && range.endDate);
  var plan = plans && plans[0];
  var elderPrice = plan && plan.elder && plan.elder.price;
  var hasElderRange = plan && plan.elder && plan.elder.min_age < plan.elder.max_age;
  var departureBr = Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["b" /* formatDateBrFromDate */])(range.startDate);
  var returnBr = Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["b" /* formatDateBrFromDate */])(range.endDate);
  var tripDays = range.startDate && range.endDate ? daysDifference(range.startDate, range.endDate) : null;
  var handleConfirm = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    if (!destinationSlug || !range.startDate || !range.endDate || !plans || !plans.length) {
      return;
    }
    setIsConfirming(true);
    Object(__WEBPACK_IMPORTED_MODULE_7__apiCalls__["fetchProductQuotation"])({
      begin_date: Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.startDate),
      end_date: Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.endDate),
      destination: destinationSlug,
      product_code: String(plans[0].code)
    }).then(function (res) {
      return res.ok ? res.json() : Promise.reject();
    }).then(function (data) {
      if (data && data[0] && String(data[0].code) === String(plans[0].code)) {
        closeModalOperatorConfirmation();
        var url = "/pedido/".concat(String(plans[0].code), "/").concat(destinationSlug, "/").concat(Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.startDate), "/").concat(Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.endDate), "/");
        history.push({
          pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(match.params, url, null, true),
          search: hasClientAltered ? "?tag=".concat(INCOMPATIBLE_PLAN_TAG_ID) : undefined
        });
      } else {
        setShowIncompatible(true);
      }
    })["catch"](function () {
      setShowIncompatible(true);
    }).then(function () {
      setIsConfirming(false);
    });
  }, [destinationSlug, range, plans, closeModalOperatorConfirmation, hasClientAltered]);
  var handleChooseOtherPlan = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    cleanStatesPurchaseMobile();
    cleanErrors();
    history.push({
      pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(match.params, '/pesquisa/' + destinationSlug + '/' + Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.startDate) + '/' + Object(__WEBPACK_IMPORTED_MODULE_6__views_v2_search_utils_searchParsing__["e" /* toISO */])(range.endDate) + '/', null, true),
      search: "?tag=".concat(INCOMPATIBLE_PLAN_TAG_ID)
    });
  }, [cleanStatesPurchaseMobile, cleanErrors, history, match, destinationSlug, range]);
  var handleContactSupport = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    window.open('https://api.whatsapp.com/send?phone=553139727083&text=Seguros%20Promo', '_blank');
  }, []);
  if (!isModalOperatorConfirmationActive) return null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, showIncompatible ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ModalPlanIncompatible__["a" /* default */], {
    onClose: function onClose() {
      setShowIncompatible(false);
    },
    onChooseOtherPlan: handleChooseOtherPlan,
    onContactSupport: handleContactSupport
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ModalOperatorConfirmationV2View__["a" /* default */], {
    destinations: destinations,
    selectedDestinationName: selectedDestination ? selectedDestination.name : '',
    destinationDropdownOpen: destinationDropdownOpen,
    onToggleDestinationDropdown: function onToggleDestinationDropdown() {
      setDestinationDropdownOpen(function (prev) {
        return !prev;
      });
    },
    onSelectDestination: function onSelectDestination(slug) {
      if (slug) setDestinationSlug(slug);
      setDestinationDropdownOpen(false);
    },
    departureBr: departureBr,
    returnBr: returnBr,
    tripDays: tripDays,
    onOpenDatepicker: openDatepickerFor,
    isMobileDatepickerOpen: isMobileDatepickerOpen,
    datepickMode: datepickMode,
    range: range,
    onRangeChange: setRange,
    onDatepickerConfirm: function onDatepickerConfirm(val) {
      setRange(val);
      setIsMobileDatepickerOpen(false);
    },
    onDatepickerBack: function onDatepickerBack() {
      setIsMobileDatepickerOpen(false);
    },
    onDatepickerClose: function onDatepickerClose() {
      setIsMobileDatepickerOpen(false);
    },
    isDesktopPickerOpen: isDesktopPickerOpen,
    desktopPickerMode: desktopPickerMode,
    onDesktopPickerChange: function onDesktopPickerChange(val) {
      setRange(val);
    },
    onDesktopPickerComplete: function onDesktopPickerComplete(val) {
      setRange(val);
      setIsDesktopPickerOpen(false);
    },
    onDesktopPickerClose: function onDesktopPickerClose() {
      setIsDesktopPickerOpen(false);
    },
    plan: plan,
    providerImgPath: providerImgPath,
    providerName: providerName,
    elderPrice: elderPrice,
    hasElderRange: hasElderRange,
    isChecked: isChecked,
    isFormComplete: isFormComplete,
    isConfirming: isConfirming,
    onCheckChange: function onCheckChange(e) {
      setIsChecked(e.target.checked);
      if (e.target.checked) setOperatorConfirmationClicked();
    },
    onConfirm: handleConfirm
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isModalOperatorConfirmationActive: state.purchase.isModalOperatorConfirmationActive,
    plans: state.purchase.plans,
    providers: state.global.providers,
    destinations: state.global.destinations
  };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, {
  openModalOperatorConfirmation: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["_3" /* openModalOperatorConfirmation */],
  closeModalOperatorConfirmation: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["w" /* closeModalOperatorConfirmation */],
  setOperatorConfirmationClicked: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["_25" /* setOperatorConfirmationClicked */],
  cleanStatesPurchaseMobile: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["m" /* cleanStatesPurchaseMobile */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["l" /* cleanErrors */]
})(ModalOperatorConfirmationV2)));

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalOperatorConfirmationV2View */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__V2_dropdown__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__V2_datepicker__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__V2_datepicker_mobile_fullscreen__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_icons_Pin_icon__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_Calendar_incon__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_icons_ChevronRight_icon__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_icons_Plane_icon__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_icons_Clock_icon__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css__);











var ModalOperatorConfirmationV2View = function ModalOperatorConfirmationV2View(_ref) {
  var destinations = _ref.destinations,
    selectedDestinationName = _ref.selectedDestinationName,
    destinationDropdownOpen = _ref.destinationDropdownOpen,
    onToggleDestinationDropdown = _ref.onToggleDestinationDropdown,
    onSelectDestination = _ref.onSelectDestination,
    departureBr = _ref.departureBr,
    returnBr = _ref.returnBr,
    tripDays = _ref.tripDays,
    onOpenDatepicker = _ref.onOpenDatepicker,
    isMobileDatepickerOpen = _ref.isMobileDatepickerOpen,
    datepickMode = _ref.datepickMode,
    range = _ref.range,
    onRangeChange = _ref.onRangeChange,
    onDatepickerConfirm = _ref.onDatepickerConfirm,
    onDatepickerBack = _ref.onDatepickerBack,
    onDatepickerClose = _ref.onDatepickerClose,
    plan = _ref.plan,
    providerImgPath = _ref.providerImgPath,
    providerName = _ref.providerName,
    elderPrice = _ref.elderPrice,
    hasElderRange = _ref.hasElderRange,
    isDesktopPickerOpen = _ref.isDesktopPickerOpen,
    desktopPickerMode = _ref.desktopPickerMode,
    onDesktopPickerChange = _ref.onDesktopPickerChange,
    onDesktopPickerComplete = _ref.onDesktopPickerComplete,
    onDesktopPickerClose = _ref.onDesktopPickerClose,
    isChecked = _ref.isChecked,
    isFormComplete = _ref.isFormComplete,
    isConfirming = _ref.isConfirming,
    onCheckChange = _ref.onCheckChange,
    onConfirm = _ref.onConfirm;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.overlay
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.modal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.header
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.headerTitle
  }, "Quase l\xE1! Revise seu pedido"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.headerSubtitle
  }, "Por favor, confira atentamente os ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "dados da viagem"), " (destino, datas) e o", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Plano de Seguro Viagem que foi escolhido."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.content
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.section
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.sectionHeading
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__assets_icons_Plane_icon__["a" /* PlaneIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Verifique sua viagem")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timeline
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineConnector
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineStep
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineStepContent
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.stepLabel
  }, "Qual \xE9 o destino?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.inputDropdownWrapper
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInput,
    role: "button",
    tabIndex: 0,
    onClick: onToggleDestinationDropdown,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && onToggleDestinationDropdown();
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__assets_icons_Pin_icon__["a" /* PinIcon */], {
    size: 20
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputTexts
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputLabel
  }, "Destino"), selectedDestinationName && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputValue
  }, selectedDestinationName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assets_icons_ChevronRight_icon__["a" /* ChevronRightIcon */], {
    size: 24,
    color: "#9e9e9e",
    rotate: destinationDropdownOpen ? 270 : 90
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__V2_dropdown__["a" /* default */], {
    isOpen: destinationDropdownOpen,
    onClose: function onClose() {
      return onSelectDestination(null);
    }
  }, destinations && destinations.length > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.destinationList
  }, destinations.map(function (d) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      key: d.id || d.slug,
      className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.destinationItem,
      onClick: function onClick() {
        return onSelectDestination(d.slug);
      }
    }, d.name, (d.slug === 'brasil' || d.slug === 'receptivo') && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.destinationDescription
    }, d.slug === 'brasil' ? 'Para viagens dentro do Brasil' : 'Para quem vem visitar o Brasil'));
  }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineBullet
  }, "1")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineStep
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineStepContent
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.stepLabel
  }, "Quando voc\xEA viaja?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.datesRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInput,
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return onOpenDatepicker('start');
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && onOpenDatepicker('start');
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Calendar_incon__["a" /* CalendarIcon */], {
    size: 20
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputTexts
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputLabel
  }, "Embarque no Brasil"), departureBr && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputValue
  }, departureBr))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInput,
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return onOpenDatepicker('end');
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && onOpenDatepicker('end');
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputIcon
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_Calendar_incon__["a" /* CalendarIcon */], {
    size: 20
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputTexts
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputLabel
  }, "Desembarque no Brasil"), returnBr && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.figmaInputValue
  }, returnBr)))), isDesktopPickerOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: onDesktopPickerClose,
    style: {
      position: 'fixed',
      inset: 0,
      zIndex: 0
    }
  }), isDesktopPickerOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.desktopPickerCard
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__V2_datepicker__["a" /* default */], {
    variant: "inline",
    selectionMode: desktopPickerMode,
    value: range,
    onChange: onDesktopPickerChange,
    onComplete: onDesktopPickerComplete,
    minDate: new Date(),
    allowSameDay: true,
    numberOfMonths: 2
  })), tripDays && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.durationBadge
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Dura\xE7\xE3o da viagem:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.durationValue
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__assets_icons_Clock_icon__["a" /* ClockIcon */], null), tripDays, " dias"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.timelineBulletInactive
  }, "2")))), plan && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.summaryCard
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.purchaseItem
  }, providerImgPath && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: providerImgPath,
    alt: providerName,
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.providerImg
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.planName
  }, plan.name)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.separator
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailsGrid
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailCell
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailLabel
  }, "Faixa et\xE1ria:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailValue
  }, plan.child && plan.elder ? "".concat(plan.child.min_age, " a ").concat(plan.elder.max_age, " anos") : '—')), hasElderRange && elderPrice && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailCell
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailLabel
  }, "Valor acima de ", plan.elder.min_age, " anos:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.detailValue
  }, "R$", Object(__WEBPACK_IMPORTED_MODULE_7__utils__["formatPrice"])(elderPrice))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.checkboxSection
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.checkboxRow
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
    type: "checkbox",
    id: "operator-confirm-v2",
    checked: isChecked,
    onChange: onCheckChange,
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.checkbox
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "operator-confirm-v2",
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.checkboxText
  }, "Ao prosseguir, declaro que ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "revisei e confirmei"), " todos os dados acima (datas, destino e plano). Entendo que \xE9 minha responsabilidade garantir que as informa\xE7\xF5es est\xE3o corretas e, em caso de erro, a empresa n\xE3o se responsabiliza por preju\xEDzos decorrentes."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_10__stylesV2_module_css___default.a.confirmButton,
    disabled: !isFormComplete || !isChecked || isConfirming,
    onClick: onConfirm
  }, "Confirmar ir para o pagamento"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__V2_datepicker_mobile_fullscreen__["a" /* default */], {
    open: isMobileDatepickerOpen,
    selectionMode: datepickMode,
    value: range,
    onChange: onRangeChange,
    onConfirm: onDatepickerConfirm,
    onBack: onDatepickerBack,
    onClose: onDatepickerClose,
    minDate: new Date(),
    allowSameDay: true,
    labels: {
      title: 'Selecione as datas'
    }
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalOperatorConfirmationV2View);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlaneIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var PlaneIcon = function PlaneIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 18 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#007E47' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 18 16",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 10V8H7V10H0ZM0 6V4H11V6H0ZM0 2V0H11V2H0ZM9 16V12.925L14.525 7.425C14.675 7.275 14.8417 7.16667 15.025 7.1C15.2083 7.03333 15.3917 7 15.575 7C15.775 7 15.9667 7.0375 16.15 7.1125C16.3333 7.1875 16.5 7.3 16.65 7.45L17.575 8.375C17.7083 8.525 17.8125 8.69167 17.8875 8.875C17.9625 9.05833 18 9.24167 18 9.425C18 9.60833 17.9667 9.79583 17.9 9.9875C17.8333 10.1792 17.725 10.35 17.575 10.5L12.075 16H9ZM16.5 9.425L15.575 8.5L16.5 9.425ZM10.5 14.5H11.45L14.475 11.45L14.025 10.975L13.55 10.525L10.5 13.55V14.5ZM14.025 10.975L13.55 10.525L14.475 11.45L14.025 10.975Z",
    fill: color
  }));
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClockIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ClockIcon = function ClockIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 15 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "7.5",
    cy: "7.5",
    r: "6.5",
    stroke: color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M7.5 4V7.5L9.5 9.5",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalPlanIncompatible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons_Warning_icon__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_Chat_icon__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css__);




var ModalPlanIncompatible = function ModalPlanIncompatible(_ref) {
  var onClose = _ref.onClose,
    onChooseOtherPlan = _ref.onChooseOtherPlan,
    onContactSupport = _ref.onContactSupport;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleOverlay
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleCard
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleContent
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleIconBg
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__assets_icons_Warning_icon__["a" /* WarningIcon */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleTitle
  }, "Dados da viagem ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleTitleBr
  }), " incompat\xEDveis com o plano"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleBody
  }, "O ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "destino ou as datas selecionadas"), " n\xE3o s\xE3o cobertos pelo plano selecionado pelo seu vendedor. Por favor, escolha um plano compat\xEDvel ou fale com um atendente para ajustar sua cota\xE7\xE3o.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleActions
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatiblePrimaryBtn,
    onClick: onChooseOtherPlan
  }, "Escolher outro plano"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_3__stylesV2_module_css___default.a.incompatibleSecondaryBtn,
    onClick: onContactSupport || onClose
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons_Chat_icon__["a" /* ChatIcon */], null), "Falar com atendente"))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalPlanIncompatible);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WarningIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var WarningIcon = function WarningIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#BA1A1A' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 21L12 0L24 21H0ZM3.775 18.75H20.225L12 4.375L3.775 18.75ZM12 17.5C12.3167 17.5 12.5833 17.3917 12.8 17.175C13.0167 16.9583 13.125 16.6917 13.125 16.375C13.125 16.0583 13.0167 15.7917 12.8 15.575C12.5833 15.3583 12.3167 15.25 12 15.25C11.6833 15.25 11.4167 15.3583 11.2 15.575C10.9833 15.7917 10.875 16.0583 10.875 16.375C10.875 16.6917 10.9833 16.9583 11.2 17.175C11.4167 17.3917 11.6833 17.5 12 17.5ZM10.875 14H13.125V8.75H10.875V14Z",
    fill: color
  }));
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChatIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ChatIcon = function ChatIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#007E47' : _ref$color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M7 9H17M7 13H13",
    stroke: "white",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InsuredForm__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__standard_button_stage_ButtonStage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InsuredRegister_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InsuredRegister_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__InsuredRegister_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_matomo__ = __webpack_require__(10);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }










var InsuredRegister = /*#__PURE__*/function (_Component) {
  function InsuredRegister(props) {
    var _this;
    _classCallCheck(this, InsuredRegister);
    _this = _callSuper(this, InsuredRegister, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleChangeAddSegurados = _this.handleChangeAddSegurados.bind(_this);
    return _this;
  }
  _inherits(InsuredRegister, _Component);
  return _createClass(InsuredRegister, [{
    key: "handleChange",
    value: function handleChange(e, formId) {
      var field = {
        name: e.target.name,
        value: e.target.value,
        formId: formId
      };
      this.props.changeInsuredFormAttr(field);
    }
  }, {
    key: "handleChangeAddSegurados",
    value: function handleChangeAddSegurados() {
      __WEBPACK_IMPORTED_MODULE_7__utils_dataLayer__["a" /* default */].genericEvent('sg_event', 'sp_pagamento', 'click_botao', 'Adicionar segurados');
      __WEBPACK_IMPORTED_MODULE_9__utils_matomo__["a" /* default */].trackEvent('Checkout', 'AddInsured', 'Click');
      this.props.addInsuredForm();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "card-segurados",
        style: {
          display: this.props.stagePurchase !== 1 && this.props.mobile ? 'none' : 'flex'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "card-segurados-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
        className: "desktop"
      }, "Identifica\xE7\xE3o dos Segurados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
        className: "mobile"
      }, "Informe os dados dos segurados")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "body-box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "segurados".concat(this.props.match.params.destination === 'receptivo' ? ' incoming-form' : '')
      }, this.props.insuredForms.map(function (form, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InsuredForm__["a" /* default */], _extends({}, form, {
          key: i,
          index: i,
          errors: _this2.props.errors,
          handleChange: _this2.handleChange,
          userDetails: _this2.props.userDetails,
          canDelete: _this2.props.isInsuredFormDeletable,
          removeInsuredForm: _this2.props.removeInsuredForm,
          validatorHandlerBlur: _this2.props.validatorHandlerBlur,
          destination: _this2.props.match.params.destination
        }));
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
        type: "button",
        name: "btn-add-segurados",
        id: "btn-add-segurados",
        className: "add-segurados",
        onClick: function onClick() {
          return _this2.handleChangeAddSegurados();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", {
        alt: "add",
        src: "/assets/images/icons/add.svg"
      }), "Adicionar segurados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__standard_button_stage_ButtonStage__["a" /* default */], {
        "data-cy": "insured-step",
        index: 2,
        stage: "INSURED_CONTACT"
      }), plan.elder.min_age < plan.elder.max_age && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", {
        className: "info-elder-mobile"
      }, "Para maiores de ", plan.adult.max_age, " anos, o valor do seguro viagem \xE9", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_6__utils__["formatPrice"])(plan.elder.price)), " por pessoa."))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    insuredForms: state.purchase.insuredForms,
    isInsuredFormDeletable: state.purchase.isInsuredFormDeletable,
    errors: state.purchase.errors,
    userDetails: state.purchase.userDetails,
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    purchaseSummary: state.purchase.purchaseSummary,
    plan: state.search.plans
  };
}, {
  addInsuredForm: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["a" /* addInsuredForm */],
  removeInsuredForm: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_13" /* removeInsuredForm */],
  changeInsuredFormAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["j" /* changeInsuredFormAttr */],
  finishPurchase: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["P" /* finishPurchase */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_32" /* validatorHandlerBlur */]
})(InsuredRegister)));

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InsuredRegister_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InsuredRegister_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InsuredRegister_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__incomingOptions_json__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__incomingOptions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__incomingOptions_json__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }






var InsuredForm = /*#__PURE__*/function (_Component) {
  function InsuredForm(props) {
    var _this;
    _classCallCheck(this, InsuredForm);
    _this = _callSuper(this, InsuredForm, [props]);
    _defineProperty(_this, "handleToggle", function () {
      _this.setState(function (prevState) {
        return {
          isOpened: !prevState.isOpened
        };
      });
    });
    _defineProperty(_this, "fmtIncomingName", function (incoming) {
      var incomingObj = __WEBPACK_IMPORTED_MODULE_5__incomingOptions_json___default.a.find(function (option) {
        return option.value === incoming;
      });
      return incomingObj ? incomingObj.name : incoming;
    });
    _defineProperty(_this, "handleClickOutside", function (e) {
      if (_this.dropdownRef.current && !_this.dropdownRef.current.contains(e.target)) {
        _this.setState({
          isOpened: false
        });
      }
    });
    _this.handleChangeRemoveInsured = _this.handleChangeRemoveInsured.bind(_this);
    _this.state = {
      isOpened: false
    };
    _this.dropdownRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    return _this;
  }
  _inherits(InsuredForm, _Component);
  return _createClass(InsuredForm, [{
    key: "handleChangeRemoveInsured",
    value: function handleChangeRemoveInsured(insuredIndex) {
      __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__["a" /* default */].genericEvent('sg_event', 'sp_pagamento', 'click_botao', 'remover_segurados');
      this.props.removeInsuredForm(insuredIndex);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.isOpened) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var errors = this.props.errors.insuredForms[this.props.index];
      var hasError = errors && (errors.name || errors.birth_date || errors.cpf || errors.passport || errors.incoming);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        action: "",
        className: "form-segurados".concat(hasError ? ' with-error' : '')
      }, this.props.canDelete && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "delete-insured mobile",
        onClick: function onClick() {
          return _this2.props.removeInsuredForm(_this2.props.index);
        }
      }, "Remover"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-input".concat(errors && errors.name ? ' input-with-error' : '')
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        maxLength: 128,
        name: "name",
        value: this.props.name,
        onChange: function onChange(e) {
          return _this2.props.handleChange(e, _this2.props.index);
        },
        placeholder: "Nome completo",
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'name', _this2.props.index);
        },
        className: "".concat(errors && errors.name ? 'form-segurados-input-error' : '')
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "insuredForms_".concat(this.props.index, "_name"),
        field1: "insuredForms",
        field2: this.props.index,
        field3: "name",
        className: "form-segurados-error"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-input".concat(errors && errors.birth_date ? ' input-with-error' : '')
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        guide: true,
        name: "birth_date",
        value: this.props.birth_date,
        type: "tel",
        placeholder: "Data de nascimento",
        keepCharPositions: true,
        mask: [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/],
        onChange: function onChange(e) {
          return _this2.props.handleChange(e, _this2.props.index);
        },
        className: "".concat(errors && errors.birth_date ? 'form-segurados-input-error' : ''),
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'birth_date', _this2.props.index);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "insuredForms_".concat(this.props.index, "_birth_date"),
        field1: "insuredForms",
        field2: this.props.index,
        field3: "birth_date",
        className: "form-segurados-error"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-input".concat(errors && errors.cpf ? ' input-with-error' : '')
      }, this.props.destination === 'receptivo' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "document-options"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "option"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "radio",
        id: "cpf-option",
        name: "document_type",
        value: "cpf",
        checked: this.props.document_type === 'cpf',
        onChange: function onChange(e) {
          return _this2.props.handleChange(e, _this2.props.index);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "cpf-option"
      }, "CPF")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "option"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "radio",
        id: "passaporte-option",
        name: "document_type",
        value: "passport",
        checked: this.props.document_type === 'passport',
        onChange: function onChange(e) {
          return _this2.props.handleChange(e, _this2.props.index);
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
        htmlFor: "passaporte-option"
      }, "Passaporte"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_text_mask___default.a, {
        placeholder: this.props.document_type === 'cpf' ? 'CPF' : 'Passaporte',
        guide: this.props.document_type === 'cpf',
        value: this.props[this.props.document_type] || '',
        type: "tel",
        mask: this.props.document_type === 'cpf' ? [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/] : [/[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/],
        name: this.props.document_type,
        onChange: function onChange(e) {
          return _this2.props.handleChange(e, _this2.props.index);
        },
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, _this2.props.document_type, _this2.props.index);
        },
        style: {
          textTransform: 'uppercase'
        },
        className: "".concat(errors && (errors.cpf || errors.passport) ? 'form-segurados-input-error' : '')
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "insuredForms_".concat(this.props.index, "_").concat(this.props.document_type),
        field1: "insuredForms",
        field2: this.props.index,
        field3: this.props.document_type,
        title: "Obs: Crian\xE7as de 0 a 5 anos solicitamos que seja preenchido com o CPF do titular.",
        textDecoration: "underline",
        className: "form-segurados-error"
      })), this.props.destination === 'receptivo' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-input".concat(errors && errors.incoming ? ' input-with-error' : '', " "),
        ref: this.dropdownRef
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-input".concat(errors && errors.incoming ? ' input-with-error' : '', " select-input")
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        maxLength: 128,
        name: "incoming",
        value: this.fmtIncomingName(this.props.incoming),
        placeholder: "Pa\xEDs de origem",
        className: "".concat(errors && errors.incoming ? 'form-segurados-input-error' : '', " ").concat(this.state.isOpened ? 'form-segurados-cs-select-focus' : ''),
        onChange: function onChange(e) {
          _this2.props.handleChange(e, _this2.props.index);
          _this2.setState({
            isOpened: true
          });
        },
        onBlur: function onBlur(e) {
          return _this2.props.validatorHandlerBlur(e.target.value, 'incoming', _this2.props.index);
        },
        onClick: function onClick() {
          return _this2.handleToggle();
        },
        ref: this.dropdownRef
      }), this.state.isOpened && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "form-segurados-cs-select"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "form-segurados-cs-select-list"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "placeholder"
      }, "Pais de origem"), __WEBPACK_IMPORTED_MODULE_5__incomingOptions_json___default.a.filter(function (option) {
        return !_this2.props.incoming || option.name.toLowerCase().includes(_this2.props.incoming.toLowerCase());
      }).map(function (option, index) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: index,
          className: "option",
          onClick: function onClick() {
            _this2.props.handleChange({
              target: {
                name: 'incoming',
                value: option.value
              }
            }, _this2.props.index);
            _this2.props.validatorHandlerBlur(option.value, 'incoming', _this2.props.index);
            _this2.handleToggle();
          }
        }, option.name);
      }), __WEBPACK_IMPORTED_MODULE_5__incomingOptions_json___default.a.filter(function (option) {
        return !_this2.props.incoming || option.name.toLowerCase().includes(_this2.props.incoming.toLowerCase());
      }).length === 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "fallback"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Nenhum resultado encontrado para ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "\"", this.props.incoming, "\""), ".")))), !this.state.isOpened && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "tooltip-container"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/tooltipCircle.svg",
        alt: "Info"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        "class": "chat-bubble tooltip"
      }, "Informe o pa\xEDs de onde voc\xEA est\xE1 partindo para sua viagem ao Brasil."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__error_message_ErrorMessage__["a" /* default */], {
        anchor: "insuredForms_".concat(this.props.index, "_incoming"),
        field1: "insuredForms",
        field2: this.props.index,
        field3: "incoming",
        className: "form-segurados-error"
      }))), this.props.canDelete && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "delete-insured desktop",
        onClick: function onClick() {
          return _this2.props.removeInsuredForm(_this2.props.index);
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        alt: "delete",
        src: "/assets/images/icons/circleDelete.svg"
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (InsuredForm);

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = [{"name":"Afeganistão","value":"afghanistan"},{"name":"Albânia","value":"albania"},{"name":"Argélia","value":"algeria"},{"name":"Andorra","value":"andorra"},{"name":"Angola","value":"angola"},{"name":"Antígua e Barbuda","value":"antigua-and-barbuda"},{"name":"Argentina","value":"argentina"},{"name":"Armênia","value":"armenia"},{"name":"Austrália","value":"australia"},{"name":"Áustria","value":"austria"},{"name":"Azerbaijão","value":"azerbaijan"},{"name":"Bahamas","value":"bahamas"},{"name":"Bahrein","value":"bahrain"},{"name":"Bangladesh","value":"bangladesh"},{"name":"Barbados","value":"barbados"},{"name":"Bielorrússia","value":"belarus"},{"name":"Bélgica","value":"belgium"},{"name":"Belize","value":"belize"},{"name":"Benim","value":"benin"},{"name":"Butão","value":"bhutan"},{"name":"Bolívia","value":"bolivia"},{"name":"Bósnia e Herzegovina","value":"bosnia-and-herzegovina"},{"name":"Botsuana","value":"botswana"},{"name":"Brasil","value":"brazil"},{"name":"Brunei","value":"brunei"},{"name":"Bulgária","value":"bulgaria"},{"name":"Burquina Faso","value":"burkina-faso"},{"name":"Burundi","value":"burundi"},{"name":"Cabo Verde","value":"cabo-verde"},{"name":"Camboja","value":"cambodia"},{"name":"Camarões","value":"cameroon"},{"name":"Canadá","value":"canada"},{"name":"República Centro-Africana","value":"central-african-republic"},{"name":"Chade","value":"chad"},{"name":"Chile","value":"chile"},{"name":"China","value":"china"},{"name":"Colômbia","value":"colombia"},{"name":"Comores","value":"comoros"},{"name":"Congo (Brazzaville)","value":"congo-congo-brazzaville"},{"name":"Congo (Kinshasa)","value":"congo-congo-kinshasa"},{"name":"Costa Rica","value":"costa-rica"},{"name":"Croácia","value":"croatia"},{"name":"Cuba","value":"cuba"},{"name":"Chipre","value":"cyprus"},{"name":"Tchéquia","value":"czechia"},{"name":"Dinamarca","value":"denmark"},{"name":"Djibuti","value":"djibouti"},{"name":"Dominica","value":"dominica"},{"name":"República Dominicana","value":"dominican-republic"},{"name":"Equador","value":"ecuador"},{"name":"Egito","value":"egypt"},{"name":"El Salvador","value":"el-salvador"},{"name":"Guiné Equatorial","value":"equatorial-guinea"},{"name":"Eritreia","value":"eritrea"},{"name":"Estônia","value":"estonia"},{"name":"Eswatini","value":"eswatini"},{"name":"Etiópia","value":"ethiopia"},{"name":"Fiji","value":"fiji"},{"name":"Finlândia","value":"finland"},{"name":"França","value":"france"},{"name":"Gabão","value":"gabon"},{"name":"Gâmbia","value":"gambia"},{"name":"Geórgia","value":"georgia"},{"name":"Alemanha","value":"germany"},{"name":"Gana","value":"ghana"},{"name":"Grécia","value":"greece"},{"name":"Granada","value":"grenada"},{"name":"Guatemala","value":"guatemala"},{"name":"Guiné","value":"guinea"},{"name":"Guiné-Bissau","value":"guinea-bissau"},{"name":"Guiana","value":"guyana"},{"name":"Haiti","value":"haiti"},{"name":"Honduras","value":"honduras"},{"name":"Hungria","value":"hungary"},{"name":"Islândia","value":"iceland"},{"name":"Índia","value":"india"},{"name":"Indonésia","value":"indonesia"},{"name":"Irã","value":"iran"},{"name":"Iraque","value":"iraq"},{"name":"Irlanda","value":"ireland"},{"name":"Israel","value":"israel"},{"name":"Itália","value":"italy"},{"name":"Jamaica","value":"jamaica"},{"name":"Japão","value":"japan"},{"name":"Jordânia","value":"jordan"},{"name":"Cazaquistão","value":"kazakhstan"},{"name":"Quênia","value":"kenya"},{"name":"Kiribati","value":"kiribati"},{"name":"Coreia do Norte","value":"korea-north"},{"name":"Coreia do Sul","value":"korea-south"},{"name":"Kuwait","value":"kuwait"},{"name":"Quirguistão","value":"kyrgyzstan"},{"name":"Laos","value":"laos"},{"name":"Letônia","value":"latvia"},{"name":"Líbano","value":"lebanon"},{"name":"Lesoto","value":"lesotho"},{"name":"Libéria","value":"liberia"},{"name":"Líbia","value":"libya"},{"name":"Liechtenstein","value":"liechtenstein"},{"name":"Lituânia","value":"lithuania"},{"name":"Luxemburgo","value":"luxembourg"},{"name":"Madagáscar","value":"madagascar"},{"name":"Malawi","value":"malawi"},{"name":"Malásia","value":"malaysia"},{"name":"Maldivas","value":"maldives"},{"name":"Mali","value":"mali"},{"name":"Malta","value":"malta"},{"name":"Ilhas Marshall","value":"marshall-islands"},{"name":"Mauritânia","value":"mauritania"},{"name":"Maurício","value":"mauritius"},{"name":"México","value":"mexico"},{"name":"Micronésia","value":"micronesia"},{"name":"Moldávia","value":"moldova"},{"name":"Mônaco","value":"monaco"},{"name":"Mongólia","value":"mongolia"},{"name":"Montenegro","value":"montenegro"},{"name":"Marrocos","value":"morocco"},{"name":"Moçambique","value":"mozambique"},{"name":"Mianmar","value":"myanmar"},{"name":"Namíbia","value":"namibia"},{"name":"Nauru","value":"nauru"},{"name":"Nepal","value":"nepal"},{"name":"Holanda","value":"netherlands"},{"name":"Nova Zelândia","value":"new-zealand"},{"name":"Nicarágua","value":"nicaragua"},{"name":"Níger","value":"niger"},{"name":"Nigéria","value":"nigeria"},{"name":"Macedônia do Norte","value":"north-macedonia"},{"name":"Noruega","value":"norway"},{"name":"Omã","value":"oman"},{"name":"Paquistão","value":"pakistan"},{"name":"Palau","value":"palau"},{"name":"Palestina","value":"palestine"},{"name":"Panamá","value":"panama"},{"name":"Papua Nova Guiné","value":"papua-new-guinea"},{"name":"Paraguai","value":"paraguay"},{"name":"Peru","value":"peru"},{"name":"Filipinas","value":"philippines"},{"name":"Polônia","value":"poland"},{"name":"Portugal","value":"portugal"},{"name":"Catar","value":"qatar"},{"name":"Romênia","value":"romania"},{"name":"Rússia","value":"russia"},{"name":"Ruanda","value":"rwanda"},{"name":"São Cristóvão e Nevis","value":"saint-kitts-and-nevis"},{"name":"Santa Lúcia","value":"saint-lucia"},{"name":"São Vicente e Granadinas","value":"saint-vincent-and-the-grenadines"},{"name":"Samoa","value":"samoa"},{"name":"San Marino","value":"san-marino"},{"name":"São Tomé e Príncipe","value":"sao-tome-and-principe"},{"name":"Arábia Saudita","value":"saudi-arabia"},{"name":"Senegal","value":"senegal"},{"name":"Sérvia","value":"serbia"},{"name":"Seicheles","value":"seychelles"},{"name":"Serra Leoa","value":"sierra-leone"},{"name":"Singapura","value":"singapore"},{"name":"Eslováquia","value":"slovakia"},{"name":"Eslovênia","value":"slovenia"},{"name":"Ilhas Salomão","value":"solomon-islands"},{"name":"Somália","value":"somalia"},{"name":"África do Sul","value":"south-africa"},{"name":"Sudão do Sul","value":"south-sudan"},{"name":"Espanha","value":"spain"},{"name":"Sri Lanka","value":"sri-lanka"},{"name":"Sudão","value":"sudan"},{"name":"Suriname","value":"suriname"},{"name":"Suécia","value":"sweden"},{"name":"Suíça","value":"switzerland"},{"name":"Síria","value":"syria"},{"name":"Taiwan","value":"taiwan"},{"name":"Tajiquistão","value":"tajikistan"},{"name":"Tanzânia","value":"tanzania"},{"name":"Tailândia","value":"thailand"},{"name":"Timor-Leste","value":"timor-leste"},{"name":"Togo","value":"togo"},{"name":"Tonga","value":"tonga"},{"name":"Trinidad e Tobago","value":"trinidad-and-tobago"},{"name":"Tunísia","value":"tunisia"},{"name":"Turquia","value":"turkey"},{"name":"Turcomenistão","value":"turkmenistan"},{"name":"Tuvalu","value":"tuvalu"},{"name":"Uganda","value":"uganda"},{"name":"Ucrânia","value":"ukraine"},{"name":"Emirados Árabes Unidos","value":"united-arab-emirates"},{"name":"Reino Unido","value":"united-kingdom"},{"name":"Estados Unidos","value":"united-states"},{"name":"Uruguai","value":"uruguay"},{"name":"Uzbequistão","value":"uzbekistan"},{"name":"Vanuatu","value":"vanuatu"},{"name":"Vaticano","value":"vatican-city"},{"name":"Venezuela","value":"venezuela"},{"name":"Vietnã","value":"vietnam"},{"name":"Iémen","value":"yemen"},{"name":"Zâmbia","value":"zambia"},{"name":"Zimbábue","value":"zimbabwe"}]

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCalls__ = __webpack_require__(6);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var states = [{
  name: 'Rondônia',
  value: 'RO'
}, {
  name: 'Acre',
  value: 'AC'
}, {
  name: 'Amazonas',
  value: 'AM'
}, {
  name: 'Roraima',
  value: 'RR'
}, {
  name: 'Pará',
  value: 'PA'
}, {
  name: 'Amapá',
  value: 'AP'
}, {
  name: 'Tocantins',
  value: 'TO'
}, {
  name: 'Maranhão',
  value: 'MA'
}, {
  name: 'Piauí',
  value: 'PI'
}, {
  name: 'Ceará',
  value: 'CE'
}, {
  name: 'Rio Grande do Norte',
  value: 'RN'
}, {
  name: 'Paraíba',
  value: 'PB'
}, {
  name: 'Pernambuco',
  value: 'PE'
}, {
  name: 'Alagoas',
  value: 'AL'
}, {
  name: 'Sergipe',
  value: 'SE'
}, {
  name: 'Bahia',
  value: 'BA'
}, {
  name: 'Minas Gerais',
  value: 'MG'
}, {
  name: 'Espírito Santo',
  value: 'ES'
}, {
  name: 'Rio de Janeiro',
  value: 'RJ'
}, {
  name: 'São Paulo',
  value: 'SP'
}, {
  name: 'Paraná',
  value: 'PR'
}, {
  name: 'Santa Catarina',
  value: 'SC'
}, {
  name: 'Rio Grande do Sul',
  value: 'RS'
}, {
  name: 'Mato Grosso do Sul',
  value: 'MS'
}, {
  name: 'Mato Grosso',
  value: 'MT'
}, {
  name: 'Goiás',
  value: 'GO'
}, {
  name: 'Distrito Federal',
  value: 'DF'
}].sort(function (a, b) {
  return a.name.localeCompare(b.name);
});
var PurchaseContact = /*#__PURE__*/function (_Component) {
  function PurchaseContact(props) {
    var _this;
    _classCallCheck(this, PurchaseContact);
    _this = _callSuper(this, PurchaseContact, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.states = states;
    return _this;
  }
  _inherits(PurchaseContact, _Component);
  return _createClass(PurchaseContact, [{
    key: "handleChange",
    value: function handleChange(e) {
      if (e.target.name === 'cep' && e.target.value.length === 10) {
        Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["getAddressData"])(e.target.value);
      }
      this.props.changeContactAttr({
        name: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "getDestinationName",
    value: function getDestinationName() {
      var _this2 = this;
      var destinations = this.props.destinations;
      var destination = destinations.find(function (destination) {
        return destination.slug === _this2.props.destination;
      });
      var destinationName = destination && destination.name;
      return destinationName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var formErrors = this.props.errors.contact;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-contato-compra"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "header-box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Dados do contato da compra")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "guidance-box-item"
      }, "Preencha os campos abaixo com seus melhores dados, para recebimento de todas informa\xE7\xF5es a respeito do seu seguro viagem."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        action: "",
        method: "",
        className: "form-contato-compra"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "destination",
        value: this.getDestinationName(),
        "data-perry-destination": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "departure_date",
        value: this.props.departure_date,
        "data-perry-departure-date": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "return_date",
        value: this.props.return_date,
        "data-perry-return-date": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gcontato"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "contact_name",
        value: this.props.contact.contact_name,
        placeholder: "Contato",
        className: formErrors.contact_name ? 'with-error' : '',
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_name');
        },
        "data-perry-name": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_contact_name",
        field1: "contact",
        field2: "contact_name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gemail"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "email",
        value: this.props.contact.email,
        placeholder: "E-mail",
        className: "desktop".concat(formErrors.email ? ' with-error' : ''),
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_email');
        },
        "data-perry-email": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_email",
        field1: "contact",
        field2: "email"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo g-telefone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_text_mask___default.a, {
        placeholder: "Telefone",
        guide: true,
        name: "phone_number",
        inputMode: "numeric",
        className: formErrors.phone_number ? 'with-error' : '',
        value: this.props.contact.phone_number,
        mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/],
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_phone');
        },
        "data-perry-phone": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_phone_number",
        field1: "contact",
        field2: "phone_number"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gcep"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_text_mask___default.a, {
        type: "text",
        name: "cep",
        inputMode: "numeric",
        value: this.props.contact.cep,
        placeholder: "CEP",
        onChange: this.handleChange,
        guide: true,
        className: formErrors.cep ? 'with-error' : '',
        mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_cep');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_cep",
        field1: "contact",
        field2: "cep"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gendereco"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "address",
        value: this.props.contact.address,
        placeholder: "Endere\xE7o",
        onChange: this.handleChange,
        className: formErrors.address ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_address');
        },
        maxLength: 45
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_address",
        field1: "contact",
        field2: "address"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gnumero"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        placeholder: "N\xFAmero",
        name: "number",
        value: this.props.contact.number,
        onChange: this.handleChange,
        maxLength: "20",
        className: formErrors.number ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_number');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_number",
        field1: "contact",
        field2: "number"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gcomplemento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "complement",
        value: this.props.contact.complement,
        placeholder: "Complemento",
        className: formErrors.complement ? 'with-error' : '',
        onChange: this.handleChange,
        maxLength: "20"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_complement",
        field1: "contact",
        field2: "complement"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gbairro"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "district",
        placeholder: "Bairro",
        className: formErrors.district ? 'with-error' : '',
        value: this.props.contact.district,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_district');
        },
        maxLength: 40
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_district",
        field1: "contact",
        field2: "district"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gcdade"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "city",
        placeholder: "Cidade",
        className: formErrors.city ? 'with-error' : '',
        value: this.props.contact.city,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_city');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_city",
        field1: "contact",
        field2: "city"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo gestado"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        name: "state",
        value: this.props.contact.state,
        placeholder: "Estado",
        className: formErrors.state ? ' with-error' : '',
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_state');
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: ""
      }, "Estado"), this.states.map(function (state, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          key: i,
          value: state.value,
          defaultValue: state.value === _this3.props.contact.state.toUpperCase()
        }, state.name);
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_state",
        field1: "contact",
        field2: "state"
      }))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    contact: state.purchase.contact,
    errors: state.purchase.errors,
    departure_date: state.purchase.quotationParams.departure_date,
    return_date: state.purchase.quotationParams.return_date,
    destination: state.purchase.quotationParams.destination,
    destinations: state.global.destinations || []
  };
}, {
  changeContactAttr: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["h" /* changeContactAttr */],
  finishPurchase: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["P" /* finishPurchase */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_32" /* validatorHandlerBlur */]
})(PurchaseContact));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalTermsOfUse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalTermsOfUse = /*#__PURE__*/function (_Component) {
  function ModalTermsOfUse() {
    _classCallCheck(this, ModalTermsOfUse);
    return _callSuper(this, ModalTermsOfUse, arguments);
  }
  _inherits(ModalTermsOfUse, _Component);
  return _createClass(ModalTermsOfUse, [{
    key: "render",
    value: function render() {
      var selectedPlan = this.props.plans.length && this.props.plans[0];
      var provider = this.props.providers.filter(function (pr) {
        return selectedPlan.provider_code === pr.code;
      });
      var providerName = '';
      var termsUrl = '';
      if (provider.length) {
        providerName = provider[0].name;
        termsUrl = provider[0].terms_url;
      }
      if (!this.props.isModalTermsOfUseActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Termos de uso ", providerName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalTermsOfUse,
        className: "close-btn"
      }, " \xD7 ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Sugerimos uma leitura detalhada do documento antes de finalizar a compra."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Link para download do Termo em PORTUGU\xCAS:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: termsUrl,
        target: "_blank",
        className: "button"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "CLIQUE AQUI"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/attention.svg",
        alt: ""
      }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalbotton"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Importante:"), " para prosseguir com a contrata\xE7\xE3o, \xE9 necess\xE1rio concordar com os termos e condi\xE7\xF5es de uso de cada seguradora."))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalTermsOfUseActive: state.purchase.isModalTermsOfUseActive,
    plans: state.search.plans,
    providers: state.global.providers
  };
}, {
  closeModalTermsOfUse: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["E" /* closeModalTermsOfUse */]
})(ModalTermsOfUse));

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalPurchaseError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalPurchaseError = /*#__PURE__*/function (_Component) {
  function ModalPurchaseError() {
    _classCallCheck(this, ModalPurchaseError);
    return _callSuper(this, ModalPurchaseError, arguments);
  }
  _inherits(ModalPurchaseError, _Component);
  return _createClass(ModalPurchaseError, [{
    key: "render",
    value: function render() {
      if (!this.props.isModalPurchaseErrorActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Pedido duplicado:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalPurchaseError,
        className: "close-btn"
      }, " ", "\xD7", " ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/alert.svg",
        alt: "erro"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "J\xE1 existe um pedido aberto com os mesmos dados de compra inseridos.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Por favor, verifique seu e-mail (inclusive a caixa de spam e lixo eletr\xF4nico) para acompanhar seus pedidos. Em caso de d\xFAvida entre em contato conosco"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, "31 4003-8442"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalbotton"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Importante:"), " Ao finalizar o seu pedido voc\xEA receber\xE1 um e-mail com a solicita\xE7\xE3o da compra e instru\xE7\xF5es para pagamento de acordo com o banco escolhido."))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalPurchaseErrorActive: state.purchase.isModalPurchaseErrorActive
  };
}, {
  closeModalPurchaseError: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["z" /* closeModalPurchaseError */]
})(ModalPurchaseError));

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalGenericError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalGenericError = /*#__PURE__*/function (_Component) {
  function ModalGenericError() {
    _classCallCheck(this, ModalGenericError);
    return _callSuper(this, ModalGenericError, arguments);
  }
  _inherits(ModalGenericError, _Component);
  return _createClass(ModalGenericError, [{
    key: "render",
    value: function render() {
      if (!this.props.isModalGenericErrorActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Erro Inesperado"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalGenericError,
        className: "close-btn"
      }, " ", "\xD7", " ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/alert.svg",
        alt: "erro"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Ops! Algo n\xE3o saiu como esperado!")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Tivemos um imprevisto ao processar sua solicita\xE7\xE3o, mas fica tranquilo: n\xE3o foi nada com voc\xEA e seus dados est\xE3o seguros."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "O que voc\xEA pode fazer agora:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        style: {
          listStyle: 'none',
          padding: 0,
          marginTop: '10px'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "\u2022 Tente novamente em alguns instantes"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "\u2022 Atualize a p\xE1gina"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, "\u2022 Ou entre em contato com nosso atendimento"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", null, "31 4003-8442"))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalGenericErrorActive: state.purchase.isModalGenericErrorActive
  };
}, {
  closeModalGenericError: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["u" /* closeModalGenericError */]
})(ModalGenericError));

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalCouponError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalCouponError = /*#__PURE__*/function (_Component) {
  function ModalCouponError(props) {
    var _this;
    _classCallCheck(this, ModalCouponError);
    _this = _callSuper(this, ModalCouponError, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalCouponError, _Component);
  return _createClass(ModalCouponError, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      window.history.go(-1);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalCouponError) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Cupom indispon\xEDvel"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalCouponError,
        className: "close-btn"
      }, ' ', "\xD7", ' ')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/alert.svg",
        alt: "erro"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "O cupom utilizado n\xE3o \xE9 v\xE1lido para esta compra ou est\xE1 expirado.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, "Por favor, volte \xE0 tela inicial para realizar uma nova cota\xE7\xE3o ou ajustar sua escolha sem este cupom.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalbotton"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button full",
        onClick: this.goToSearchPage,
        style: {
          marginTop: '10px'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 tela inicial"))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalCouponError: state.purchase.isModalCouponErrorActive
  };
}, {
  closeModalCouponError: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["q" /* closeModalCouponError */]
})(ModalCouponError));

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalPurchaseDateError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var ModalPurchaseDateError = /*#__PURE__*/function (_Component) {
  function ModalPurchaseDateError(props) {
    var _this;
    _classCallCheck(this, ModalPurchaseDateError);
    _this = _callSuper(this, ModalPurchaseDateError, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalPurchaseDateError, _Component);
  return _createClass(ModalPurchaseDateError, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      window.history.go(-1);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalPurchaseErrorDate) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents contents-purchase-error"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modaltop purchase-error"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "title"
      }, "Hor\xE1rio de compra indispon\xEDvel"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalPurchaseDateError,
        className: "close-btn"
      }, ' ', "\xD7", ' ')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle purchase-error"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/calendar-error.svg",
        alt: "erro"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "Compras de seguro viagem com inicio vig\xEAncia na data de hoje hoje s\xF3 podem ser feitas at\xE9 as 23h30.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("b", null, "Por favor, volte \xE0 tela inicial para ajustar sua escolha."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalbotton purchase-error"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button full",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 tela inicial"))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalPurchaseErrorDate: state.purchase.isModalPurchaseErrorDate
  };
}, {
  closeModalPurchaseDateError: __WEBPACK_IMPORTED_MODULE_2__actions_purchaseActions__["y" /* closeModalPurchaseDateError */]
})(ModalPurchaseDateError));

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);


var ModalPlanRules = function ModalPlanRules(_ref) {
  var isModalPlanRulesActive = _ref.isModalPlanRulesActive,
    closeModalPlanRules = _ref.closeModalPlanRules,
    productCoverage = _ref.productCoverage;
  if (!isModalPlanRulesActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: closeModalPlanRules
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_modalpagamento mobile-roof"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalcontents mobile-modal",
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "contents"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modaltop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title"
  }, "Informa\xE7\xF5es e Regras do Plano"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: closeModalPlanRules,
    className: "close-btn"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/close.svg",
    alt: "bot\xE3o de fechar janela",
    style: {
      height: '14px'
    }
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalmiddle"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "modaltable"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "tableheader"
  }, "Observa\xE7\xF5es e Restri\xE7\xF5es"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modal-text-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, productCoverage.description ? productCoverage.description : 'Leia as condições gerais para conferir as inclusões e exclusões deste plano de seguro.')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modal-text-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: productCoverage.terms_url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Ver condi\xE7\xF5es gerais")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "tableheader title"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Prazos e regras"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Remarca\xE7\xE3o ou Altera\xE7\xE3o")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modal-text-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "A", ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "solicita\xE7\xE3o para altera\xE7\xE3o ou remarca\xE7\xE3o das datas e/ou destino deve ser realizada antes do in\xEDcio da vig\xEAncia"), ", ou seja, at\xE9 um dia antes da data de in\xEDcio da cobertura contratada. Haver\xE1 cobran\xE7a da diferen\xE7a de tarifa e c\xE2mbio, se houver.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "tableheader"
  }, "Cancelamento com cr\xE9dito"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modal-text-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Desde que antes da vig\xEAncia, o cancelamento com cr\xE9dito integral pode ser solicitado a qualquer momento ap\xF3s a aprova\xE7\xE3o do pedido.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "tableheader"
  }, "Cancelamento com reembolso"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modal-text-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Em ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "at\xE9 7 dias ap\xF3s a compra"), " o reembolso ser\xE1 integral."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ap\xF3s o prazo de 7 dias, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "haver\xE1 a aplica\xE7\xE3o de multa de R$50,00 ou 20% do valor total da compra"), ", que ser\xE1 descontado do valor a ser reembolsado."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "aviso"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Lembrando que todas as solicita\xE7\xF5es de cancelamento ou altera\xE7\xE3o, independente da data da compra, s\xF3 ser\xE3o realizadas desde que a solicita\xE7\xE3o ocorra antes da vig\xEAncia do seguro."))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalPlanRules);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxValues__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BoxCoupon__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BoxPlan__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmPurchase__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__box_credit_coupon_index__ = __webpack_require__(110);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }






var PurchaseDescription = /*#__PURE__*/function (_Component) {
  function PurchaseDescription() {
    _classCallCheck(this, PurchaseDescription);
    return _callSuper(this, PurchaseDescription, arguments);
  }
  _inherits(PurchaseDescription, _Component);
  return _createClass(PurchaseDescription, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", {
        className: "title-section",
        key: 1
      }, "Resumo da compra:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-descricao",
        key: 2,
        style: {
          width: '100%',
          position: 'sticky',
          top: '0'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-descricao-block"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "item-1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BoxCoupon__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__box_credit_coupon_index__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BoxValues__["a" /* default */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "item-2"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BoxPlan__["a" /* default */], null))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "item-3"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ConfirmPurchase__["a" /* default */], null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (PurchaseDescription);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChevronIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ChevronIcon = function ChevronIcon(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: "coupon-chevron ".concat(open ? 'open' : ''),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2256 16.3779C19.9328 16.6708 19.4579 16.6708 19.165 16.3779L12.0005 9.2134L4.83599 16.3779C4.5431 16.6708 4.06823 16.6708 3.77533 16.3779C3.48244 16.085 3.48244 15.6101 3.77533 15.3172L12.0005 7.09208L20.2256 15.3172C20.5185 15.6101 20.5185 16.085 20.2256 16.3779Z",
    fill: "#373737"
  }));
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var InfoIcon = function InfoIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: "coupon-card__badge-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12.01",
    y2: "8"
  }));
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckCircleIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CheckCircleIcon = function CheckCircleIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    clipPath: "url(#clip0_86_1160)"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8Z",
    fill: "#EFEDFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4247 5.57576C11.659 5.81008 11.659 6.18997 11.4247 6.42429L7.42466 10.4243C7.19034 10.6586 6.81044 10.6586 6.57613 10.4243L4.57613 8.42429C4.34181 8.18997 4.34181 7.81008 4.57613 7.57576C4.81044 7.34145 5.19034 7.34145 5.42465 7.57576L7.00039 9.1515L10.5761 5.57576C10.8104 5.34145 11.1903 5.34145 11.4247 5.57576Z",
    fill: "#EFEDFF"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath", {
    id: "clip0_86_1160"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__standard_button_stage_ButtonStage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_address__ = __webpack_require__(319);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }








var PurchaseContactMobile = /*#__PURE__*/function (_Component) {
  function PurchaseContactMobile(props) {
    var _this;
    _classCallCheck(this, PurchaseContactMobile);
    _this = _callSuper(this, PurchaseContactMobile, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.states = __WEBPACK_IMPORTED_MODULE_7__utils_address__["a" /* states */];
    return _this;
  }
  _inherits(PurchaseContactMobile, _Component);
  return _createClass(PurchaseContactMobile, [{
    key: "handleChange",
    value: function handleChange(e) {
      if (e.target.name === 'cep' && e.target.value.length === 10) {
        Object(__WEBPACK_IMPORTED_MODULE_6__apiCalls__["getAddressData"])(e.target.value);
      }
      this.props.changeContactAttr({
        name: e.target.name,
        value: e.target.value
      });
    }
  }, {
    key: "getDestinationName",
    value: function getDestinationName() {
      var _this2 = this;
      var destinations = this.props.destinations;
      var destination = destinations.find(function (destination) {
        return destination.slug === _this2.props.destination;
      });
      var destinationName = destination && destination.name;
      return destinationName;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var formErrors = this.props.errors.contact;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-contato-compra mobile",
        style: {
          display: this.props.stagePurchase !== 3 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "body-box-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "title"
      }, "Dados do contato da compra"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "guidance-mobile"
      }, "Preencha os campos abaixo com seus melhores dados, para recebimento de todas informa\xE7\xF5es", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "a respeito do seu seguro viagem."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form", {
        action: "",
        method: "",
        className: "form-contato-compra"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "destination",
        value: this.getDestinationName(),
        "data-perry-destination": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "departure_date",
        value: this.props.departure_date,
        "data-perry-departure-date": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "hidden",
        name: "return_date",
        value: this.props.return_date,
        "data-perry-return-date": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos-mobile contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gcontato"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "contact_name",
        placeholder: "Nome do Contato",
        value: this.props.contact.contact_name,
        onChange: this.handleChange,
        className: formErrors.contact_name ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_name');
        },
        "data-perry-name": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_contact_name",
        field1: "contact",
        field2: "contact_name"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gemail"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "email",
        name: "email",
        value: this.props.contact.email,
        onChange: this.handleChange,
        placeholder: "E-mail",
        className: formErrors.email ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_email');
        },
        "data-perry-email": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_email",
        field1: "contact",
        field2: "email"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile g-telefone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_text_mask___default.a, {
        guide: true,
        name: "phone_number",
        inputMode: "numeric",
        value: this.props.contact.phone_number,
        type: "tel",
        placeholder: "Telefone",
        mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/],
        onChange: this.handleChange,
        className: formErrors.phone_number ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_phone');
        },
        "data-perry-phone": true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_phone_number",
        field1: "contact",
        field2: "phone_number"
      }), this.props.prospect.exist && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "transfer-infos",
        onClick: this.props.clearInfosProspect,
        type: "button"
      }, "Limpar campos"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title address"
      }, "Endere\xE7o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_text_mask___default.a, {
        type: "tel",
        name: "cep",
        inputMode: "numeric",
        value: this.props.contact.cep,
        onChange: this.handleChange,
        guide: true,
        placeholder: "CEP",
        className: formErrors.cep ? 'with-error' : '',
        mask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_cep');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_cep",
        field1: "contact",
        field2: "cep"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gendereco"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "address",
        placeholder: "Endere\xE7o",
        value: this.props.contact.address,
        onChange: this.handleChange,
        className: formErrors.address ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_address');
        },
        maxLength: 50
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_address",
        field1: "contact",
        field2: "address"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gnumero"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "number",
        placeholder: "N\xFAmero",
        className: formErrors.number ? 'with-error' : '',
        value: this.props.contact.number,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_number');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_number",
        field1: "contact",
        field2: "number"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gcomplemento"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "complement",
        placeholder: "Complemento",
        className: formErrors.complement ? 'with-error' : '',
        value: this.props.contact.complement,
        onChange: this.handleChange,
        maxLength: 20
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_complement",
        field1: "contact",
        field2: "complement"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contatos-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gbairro"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "district",
        placeholder: "Bairro",
        className: formErrors.district ? 'with-error' : '',
        value: this.props.contact.district,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_district');
        },
        maxLength: 50
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_district",
        field1: "contact",
        field2: "district"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gcdade"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        name: "city",
        placeholder: "Cidade",
        value: this.props.contact.city,
        onChange: this.handleChange,
        className: formErrors.city ? 'with-error' : '',
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_city');
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_city",
        field1: "contact",
        field2: "city"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "grupo-campo-mobile gestado"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", {
        className: formErrors.state ? 'with-error' : '',
        name: "state",
        value: this.props.contact.state,
        onChange: this.handleChange,
        onBlur: function onBlur(e) {
          return _this3.props.validatorHandlerBlur(e.target.value, 'contact_state');
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
        value: ""
      }, "Estado"), this.states.map(function (state, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", {
          key: i,
          value: state.value,
          defaultValue: state.value === _this3.props.contact.state.toUpperCase()
        }, state.name);
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__error_message_ErrorMessage__["a" /* default */], {
        anchor: "contact_state",
        field1: "contact",
        field2: "state"
      })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__standard_button_stage_ButtonStage__["a" /* default */], {
        "data-cy": "step-contact-data",
        index: 4,
        stage: "INSURED_RESP_CONTACT"
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    contact: state.purchase.contact,
    errors: state.purchase.errors,
    mobile: state.mobile.mobileActive,
    stagePurchase: state.purchase.stagePurchase,
    prospect: state.purchase.prospect,
    departure_date: state.purchase.quotationParams.departure_date,
    return_date: state.purchase.quotationParams.return_date,
    destination: state.purchase.quotationParams.destination,
    destinations: state.global.destinations || []
  };
}, {
  changeContactAttr: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["h" /* changeContactAttr */],
  finishPurchase: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["P" /* finishPurchase */],
  validatorHandlerBlur: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["_32" /* validatorHandlerBlur */],
  clearInfosProspect: __WEBPACK_IMPORTED_MODULE_5__actions_purchaseActions__["p" /* clearInfosProspect */]
})(PurchaseContactMobile));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return states; });
var states = [{
  name: 'Rondônia',
  value: 'RO'
}, {
  name: 'Acre',
  value: 'AC'
}, {
  name: 'Amazonas',
  value: 'AM'
}, {
  name: 'Roraima',
  value: 'RR'
}, {
  name: 'Pará',
  value: 'PA'
}, {
  name: 'Amapá',
  value: 'AP'
}, {
  name: 'Tocantins',
  value: 'TO'
}, {
  name: 'Maranhão',
  value: 'MA'
}, {
  name: 'Piauí',
  value: 'PI'
}, {
  name: 'Ceará',
  value: 'CE'
}, {
  name: 'Rio Grande do Norte',
  value: 'RN'
}, {
  name: 'Paraíba',
  value: 'PB'
}, {
  name: 'Pernambuco',
  value: 'PE'
}, {
  name: 'Alagoas',
  value: 'AL'
}, {
  name: 'Sergipe',
  value: 'SE'
}, {
  name: 'Bahia',
  value: 'BA'
}, {
  name: 'Minas Gerais',
  value: 'MG'
}, {
  name: 'Espírito Santo',
  value: 'ES'
}, {
  name: 'Rio de Janeiro',
  value: 'RJ'
}, {
  name: 'São Paulo',
  value: 'SP'
}, {
  name: 'Paraná',
  value: 'PR'
}, {
  name: 'Santa Catarina',
  value: 'SC'
}, {
  name: 'Rio Grande do Sul',
  value: 'RS'
}, {
  name: 'Mato Grosso do Sul',
  value: 'MS'
}, {
  name: 'Mato Grosso',
  value: 'MT'
}, {
  name: 'Goiás',
  value: 'GO'
}, {
  name: 'Distrito Federal',
  value: 'DF'
}].sort(function (a, b) {
  return a.name.localeCompare(b.name);
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BoxValues__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BoxCoupon__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BoxPlan__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConfirmPurchase__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BoxInsureds__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BoxPaymentMethod__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BoxContact__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__box_credit_coupon_index__ = __webpack_require__(110);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }













var PurchaseDescriptionMobile = /*#__PURE__*/function (_Component) {
  function PurchaseDescriptionMobile(props) {
    var _this;
    _classCallCheck(this, PurchaseDescriptionMobile);
    _this = _callSuper(this, PurchaseDescriptionMobile, [props]);
    _defineProperty(_this, "backSearch", function (e) {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(_this.props.match, "/pesquisa/".concat(_this.props.match.params.destination, "/").concat(_this.props.match.params.begin_date, "/").concat(_this.props.match.params.end_date, "/"), null)
      };
      _this.props.cleanStatesPurchaseMobile();
      _this.props.cleanErrors();
      _this.props.history.push(location);
    });
    var begin_date = _this.props.match.params.begin_date.split('-'),
      end_date = _this.props.match.params.end_date.split('-');

    // TODO: use --> this.props.destinations.filter(destination => destination.slug === this.props.match.params.destination)[0].name;
    _this.destination = 'teste';
    _this.begin_date = "".concat(begin_date[2], "/").concat(begin_date[1], "/").concat(begin_date[0]);
    _this.end_date = "".concat(end_date[2], "/").concat(end_date[1], "/").concat(end_date[0]);
    _this.card_descricao = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.editCupom = _this.editCupom.bind(_this);
    _this.scrollToRef = _this.scrollToRef.bind(_this);
    return _this;
  }
  _inherits(PurchaseDescriptionMobile, _Component);
  return _createClass(PurchaseDescriptionMobile, [{
    key: "selectedPaymentMethod",
    value: function selectedPaymentMethod(paymentMethods) {
      for (var pm in paymentMethods) {
        if (paymentMethods[pm].selected) {
          return paymentMethods[pm].id;
        }
      }
    }
  }, {
    key: "scrollToRef",
    value: function scrollToRef() {
      this.card_descricao.current.scroll(0, 250);
    }
  }, {
    key: "editCupom",
    value: function editCupom() {
      this.card_descricao.current.scroll(0, 250);
      this.props.clearCoupon();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var couponErrorPaymentMethod = this.props.couponInfo.payment_method !== undefined && this.props.couponInfo.payment_method !== null && this.selectedPaymentMethod(this.props.payment_methods) !== this.props.couponInfo.payment_method;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "card-descricao mobile",
        ref: this.card_descricao,
        key: 2,
        style: {
          display: this.props.stagePurchase !== 4 && this.props.mobile ? 'none' : 'block'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title-descricao"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "title-descricao__title"
      }, "Revise seu pedido"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Verifique todos os dados dos segurados e da compra antes de finalizar a compra.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BoxCoupon__["a" /* default */], {
        scrollToRef: function scrollToRef() {
          return _this2.scrollToRef();
        }
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__box_credit_coupon_index__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BoxValues__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Destino e cobertura"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: this.backSearch,
        "data-cy": "edit-destination",
        className: "edit-btn"
      }, "Editar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__BoxPlan__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Segurados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: function onClick(_) {
          return _this2.props.editPurchase(1);
        },
        "data-cy": "edit-insureds",
        className: "edit-btn"
      }, "Editar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BoxInsureds__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Forma de pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: function onClick(_) {
          return _this2.props.editPurchase(2);
        },
        "data-cy": "edit-payment-method",
        className: "edit-btn"
      }, "Editar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__BoxPaymentMethod__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title-box"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Contato da compra"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: function onClick(_) {
          return _this2.props.editPurchase(3);
        },
        "data-cy": "edit-contact-data",
        className: "edit-btn"
      }, "Editar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BoxContact__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ConfirmPurchase__["a" /* default */], null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    stagePurchase: state.purchase.stagePurchase,
    mobile: state.mobile.mobileActive,
    couponInfo: state.purchase.coupon,
    payment_methods: state.purchase.paymentMethods
  };
}, {
  cleanErrors: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["l" /* cleanErrors */],
  editPurchase: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["G" /* editPurchase */],
  cleanStatesPurchaseMobile: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["m" /* cleanStatesPurchaseMobile */],
  clearCoupon: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["o" /* clearCoupon */]
})(PurchaseDescriptionMobile)));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var BoxInsureds = /*#__PURE__*/function (_Component) {
  function BoxInsureds() {
    _classCallCheck(this, BoxInsureds);
    return _callSuper(this, BoxInsureds, arguments);
  }
  _inherits(BoxInsureds, _Component);
  return _createClass(BoxInsureds, [{
    key: "render",
    value: function render() {
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-insured"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "insureds"
      }, this.props.insuredForms.map(function (insured, i) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          key: i
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "insured-name"
        }, insured.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "insured-document"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, insured.document_type === 'cpf' ? 'CPF' : 'Passaporte', ":"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, insured.document_type === 'cpf' ? insured.cpf : insured.passport)));
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plan: state.search.plans,
    insuredForms: state.purchase.insuredForms
  };
})(BoxInsureds)));

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var BoxPaymentMethod = /*#__PURE__*/function (_Component) {
  function BoxPaymentMethod() {
    _classCallCheck(this, BoxPaymentMethod);
    return _callSuper(this, BoxPaymentMethod, arguments);
  }
  _inherits(BoxPaymentMethod, _Component);
  return _createClass(BoxPaymentMethod, [{
    key: "render",
    value: function render() {
      var paymentMethod = this.props.payment_methods.filter(function (payment) {
        return payment.selected;
      })[0] || {
        slug: '',
        name: ''
      };
      var brandSelected = this.props.brands.map(function (brand) {
        if (brand.selected) {
          return brand.brand_name;
        }
        return false;
      });
      var parcelSelected = this.props.parcels.map(function (parcel, i) {
        if (parcel.selected) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            key: i
          }, parcel.times, "x de R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(parcel.price));
        }
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          key: i
        });
      });
      var imgBrand = this.props.brands.map(function (brand, i) {
        if (brand.selected) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
            key: i,
            src: "/assets/images/home/home/cards/".concat(brand.brand_name, ".svg"),
            alt: ""
          });
        }
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          key: i
        });
      });
      var selectedBank = this.props.banks.filter(function (bank) {
        return bank.selected;
      })[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-payment"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "payment-method"
      }, paymentMethod.slug === 'credit-card' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, imgBrand), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", {
        className: "name-brand"
      }, brandSelected), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), parcelSelected)) : paymentMethod.slug === 'safetypay' ? selectedBank !== undefined && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/banks/".concat(selectedBank.slug, ".svg"),
        alt: ""
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Transfer\xEAncia"), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, selectedBank.name))) : paymentMethod.slug === 'boleto' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/boleto.svg",
        alt: "boleto"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Boleto"))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/pix.svg",
        alt: "pix"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Pix")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    payment_methods: state.purchase.paymentMethods,
    parcels: state.purchase.creditCard.parcels,
    brands: state.purchase.creditCard.brands,
    banks: state.purchase.safetypay.banks
  };
})(BoxPaymentMethod)));

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var BoxContact = /*#__PURE__*/function (_Component) {
  function BoxContact() {
    _classCallCheck(this, BoxContact);
    return _callSuper(this, BoxContact, arguments);
  }
  _inherits(BoxContact, _Component);
  return _createClass(BoxContact, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box box-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "contact-infos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, this.props.contact.contact_name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.contact.email), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.contact.phone_number)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "row-contact"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Endere\xE7o"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.contact.address, ", ", this.props.contact.number, " - ", this.props.contact.district, ","), ' ', /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.contact.city, ", ", this.props.contact.state, " ", this.props.contact.cep))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    contact: state.purchase.contact
  };
})(BoxContact)));

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Tags__ = __webpack_require__(24);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }






var PurchaseSummary = /*#__PURE__*/function (_Component) {
  function PurchaseSummary(props) {
    var _this;
    _classCallCheck(this, PurchaseSummary);
    _this = _callSuper(this, PurchaseSummary, [props]);
    _defineProperty(_this, "state", {
      active: false
    });
    _defineProperty(_this, "activeSummary", function () {
      _this.setState({
        active: !_this.state.active
      });
    });
    _defineProperty(_this, "backSearch", function (e) {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatURL"])(_this.props.match, "/pesquisa/".concat(_this.props.match.params.destination, "/").concat(_this.props.match.params.begin_date, "/").concat(_this.props.match.params.end_date, "/"), null)
      };
      _this.props.cleanStatesPurchaseMobile();
      _this.props.cleanErrors();
      _this.props.history.push(location);
    });
    _defineProperty(_this, "renderPrice", function () {
      var plan = _this.props.plan[0];
      if (_this.props.purchaseSummary.coupon_discount && !_this.props.purchaseSummary.total) return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])('0,00');else if (_this.props.purchaseSummary.total) return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(_this.props.purchaseSummary.total);else return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(plan.adult.price);
    });
    _this.activeSummary = _this.activeSummary.bind();
    var destinationFiltered = _this.props.destinations.filter(function (destination) {
      return destination.slug === _this.props.match.params.destination;
    });
    _this.destination = _this.props.destinations && destinationFiltered.length ? destinationFiltered[0].name : '';
    return _this;
  }
  _inherits(PurchaseSummary, _Component);
  return _createClass(PurchaseSummary, [{
    key: "render",
    value: function render() {
      if (!this.props.plan[0]) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      var plan = this.props.plan[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "purchase-summary ".concat(this.state.active && 'active'),
        style: {
          display: this.props.stagePurchase === 4 ? 'none' : 'block'
        }
      }, !this.state.active && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "purchase-summary-disable",
        onClick: this.activeSummary
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "disable-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ver resumo da compra: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "R$ ", this.renderPrice())), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/up.svg",
        alt: ""
      }))), this.state.active && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "purchase-summary-info"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "info-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Resumo da compra"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        onClick: this.activeSummary
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/pagamento/up.svg",
        alt: "",
        className: "rotate-svg"
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "info-body"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-plan box-insured"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-passageiros"
      }, this.props.purchaseSummary.elder.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.elder.qte, " Adulto", this.props.purchaseSummary.elder.qte > 1 ? 's' : '', " (maior de ", plan.adult.max_age, " anos)"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.elder.price))), this.props.purchaseSummary.adult.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.adult.qte, " Adulto", this.props.purchaseSummary.adult.qte > 1 ? 's' : ''), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.adult.price))), this.props.purchaseSummary.child.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.child.qte, " Crian\xE7a", this.props.purchaseSummary.child.qte > 1 ? 's' : '', " (at\xE9 ", plan.child.max_age, " anos)"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.child.price))), this.props.purchaseSummary.invalid.qte > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.props.purchaseSummary.invalid.qte, " Adulto", this.props.purchaseSummary.invalid.qte > 1 ? 's' : '', " (idade incompat\xEDvel com o plano)"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "back-search",
        onClick: this.backSearch
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("u", null, "Voltar \xE0 pesquisa"))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "lista-subtotal"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "title-subtotal"
      }, "Subtotal"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.subtotal || plan.adult.price))), this.props.purchaseSummary.paymentMethodDiscountValue > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Desconto ", this.props.purchaseSummary.paymentMethodSelected), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "- R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.paymentMethodDiscountValue))), this.props.purchaseSummary.coupon_discount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Desconto Cupom"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "- R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.coupon_discount))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: "flex row-total"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "text-total"
      }, "Total"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "total-resumo-compra"
      }, "R$ ", this.renderPrice())))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-plan plan-bottomsheet-mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Tags__["a" /* default */], {
        plan: plan,
        isMobile: true
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
        className: "plan-title"
      }, plan.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "more-info-plan"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "more-info-plan-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/destiny.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Destino:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, this.destination)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "more-info-plan-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/calendar.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.begin_date), " -", ' ', Object(__WEBPACK_IMPORTED_MODULE_3__utils__["convertDate"])(this.props.match.params.end_date))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "more-info-plan-item"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/cash.svg",
        alt: ""
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Pre\xE7o por dia:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(this.props.purchaseSummary.investmentPerDay)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "more-info-plan-links"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "ver-mais green",
        onClick: this.props.openModalDetail
      }, "Cobertura completa"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        onClick: this.props.openModalPlanRules,
        className: "plan-rules purple"
      }, "Informa\xE7\xF5es e Regras do Plano"))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    plan: state.search.plans,
    couponInfo: state.purchase.coupon,
    payment_methods: state.purchase.paymentMethods,
    purchaseSummary: state.purchase.purchaseSummary,
    stagePurchase: state.purchase.stagePurchase
  };
}, {
  clearCoupon: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["o" /* clearCoupon */],
  setCouponText: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_22" /* setCouponText */],
  openModalDetail: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["Y" /* openModalDetail */],
  openModalPlanRules: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["_4" /* openModalPlanRules */],
  cleanErrors: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["l" /* cleanErrors */],
  cleanStatesPurchaseMobile: __WEBPACK_IMPORTED_MODULE_4__actions_purchaseActions__["m" /* cleanStatesPurchaseMobile */]
})(PurchaseSummary)));

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalTravelRenewal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalTravelRenewal = /*#__PURE__*/function (_Component) {
  function ModalTravelRenewal(props) {
    var _this;
    _classCallCheck(this, ModalTravelRenewal);
    _this = _callSuper(this, ModalTravelRenewal, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalTravelRenewal, _Component);
  return _createClass(ModalTravelRenewal, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), window.location.search)
      };
      this.props.closeModalTravelRenewal();
      this.props.history.replace(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalTravelRenewalActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal",
        onClick: this.props.closeModalTravelRenewal
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalTravelRenewal,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Aten\xE7\xE3o! Este plano \xE9 espec\xEDfico para quem ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " j\xE1 est\xE1 em viagem!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "Se este n\xE3o for o seu caso, clique em Voltar \xE0 Pesquisa para escolher um outro plano. ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " Para prosseguir, clique em Continuar.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalTravelRenewal
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalTravelRenewalActive: state.purchase.isModalTravelRenewalActive
  };
}, {
  closeModalTravelRenewal: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["F" /* closeModalTravelRenewal */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalTravelRenewal)));

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalTravelRenewalFranchise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalTravelRenewalFranchise = /*#__PURE__*/function (_Component) {
  function ModalTravelRenewalFranchise(props) {
    var _this;
    _classCallCheck(this, ModalTravelRenewalFranchise);
    _this = _callSuper(this, ModalTravelRenewalFranchise, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalTravelRenewalFranchise, _Component);
  return _createClass(ModalTravelRenewalFranchise, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), window.location.search)
      };
      this.props.closeModalRenewalFranchise();
      this.props.history.replace(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalRenewalFranchiseActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      var benefits = this.props.rawProductCoverage;
      var franchise = benefits.filter(function (benefit) {
        return benefit.code === '500';
      });
      franchise = franchise.length && franchise[0];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal",
        onClick: this.props.closeModalRenewalFranchise
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalRenewalFranchise,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Aten\xE7\xE3o! Este plano possui franquia e \xE9 ", !this.props.mobile && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br", null), " espec\xEDfico para quem j\xE1 est\xE1 em viagem!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "O seguro viagem escolhido \xE9 uma excelente op\xE7\xE3o para quem j\xE1 est\xE1 viajando, mas aten\xE7\xE3o, para acionar Despesas M\xE9dicas Hospitalares (DMH) existe uma franquia de ", franchise.coverage, ".")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalRenewalFranchise
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    benefits: state.purchase.benefits_list,
    rawProductCoverage: state.coverage.rawProductCoverage,
    isModalRenewalFranchiseActive: state.purchase.isModalRenewalFranchiseActive,
    mobile: state.mobile.mobileActive
  };
}, {
  closeModalRenewalFranchise: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["B" /* closeModalRenewalFranchise */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalTravelRenewalFranchise)));

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalReceptiveProduct */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }





var ModalReceptiveProduct = /*#__PURE__*/function (_Component) {
  function ModalReceptiveProduct(props) {
    var _this;
    _classCallCheck(this, ModalReceptiveProduct);
    _this = _callSuper(this, ModalReceptiveProduct, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalReceptiveProduct, _Component);
  return _createClass(ModalReceptiveProduct, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match, "/pesquisa/".concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date, "/"), window.location.search)
      };
      this.props.closeModalReceptiveProduct();
      this.props.history.replace(location);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalReceptiveProductActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal",
        onClick: this.props.closeModalReceptiveProduct
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modalcontents",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: this.props.closeModalReceptiveProduct,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3", null, "Confirma que est\xE1 comprando um seguro Brasil Receptivo?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "text-middle"
      }, "O seguro de viagem escolhido \xE9 uma excelente op\xE7\xE3o, mas aten\xE7\xE3o, este plano \xE9 exclusivo para passageiros que moram no exterior e vir\xE3o ao Brasil. Caso sua viagem, seja de uma cidade para outra dentro do Brasil, este n\xE3o \xE9 o seguro ideal para voc\xEA.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalReceptiveProduct
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalReceptiveProductActive: state.purchase.isModalReceptiveProductActive
  };
}, {
  closeModalReceptiveProduct: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["A" /* closeModalReceptiveProduct */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalReceptiveProduct)));

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalNotCovidCoverage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__ = __webpack_require__(4);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var ModalNotCovidCoverage = /*#__PURE__*/function (_Component) {
  function ModalNotCovidCoverage(props) {
    var _this;
    _classCallCheck(this, ModalNotCovidCoverage);
    _this = _callSuper(this, ModalNotCovidCoverage, [props]);
    _this.goToSearchPage = _this.goToSearchPage.bind(_this);
    return _this;
  }
  _inherits(ModalNotCovidCoverage, _Component);
  return _createClass(ModalNotCovidCoverage, [{
    key: "goToSearchPage",
    value: function goToSearchPage() {
      this.props.closeModalNotCovidCoverage();
      this.props.history.go(-1);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.isModalNotCovidCoverage) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      var benefits = this.props.rawProductCoverage;
      var franchise = benefits.filter(function (benefit) {
        return benefit.code === '500';
      });
      franchise = franchise.length && franchise[0];
      var franchiseCoverage = franchise.coverage.toUpperCase() === 'NAO' || franchise.coverage.toUpperCase() === 'NÃO';
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_modalpagamento quotationDateWarning-modal franchise-modal",
        onClick: this.props.closeModalNotCovidCoverage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalcontents",
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        onClick: this.props.closeModalNotCovidCoverage,
        className: "close-btn"
      }, " \xD7 "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "contents"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "modalmiddle"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Aten\xE7\xE3o as exig\xEAncias dos pa\xEDses"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "Esse seguro \xE9 uma excelente op\xE7\xE3o, mas aten\xE7\xE3o ao viajar para o Chile e/ou Argentina, pois esses pa\xEDses exigem coberturas espec\xEDficas para COVID-19"), !franchiseCoverage && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "text-middle"
      }, "O seguro viagem escolhido \xE9 uma excelente op\xE7\xE3o, mas aten\xE7\xE3o, para acionar Despesas M\xE9dicas Hospitalares (DMH) existe uma franquia de ", franchise.coverage, ". Os demais benef\xEDcios est\xE3o isentos de franquia.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.goToSearchPage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "choosecontainer continue"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "optionone"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "button",
        onClick: this.props.closeModalNotCovidCoverage
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Continuar")))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    isModalNotCovidCoverage: state.purchase.isModalNotCovidCoverage,
    rawProductCoverage: state.coverage.rawProductCoverage
  };
}, {
  closeModalNotCovidCoverage: __WEBPACK_IMPORTED_MODULE_3__actions_purchaseActions__["v" /* closeModalNotCovidCoverage */]
})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(ModalNotCovidCoverage)));

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusBoleto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }

var StatusBoleto = /*#__PURE__*/function (_Component) {
  function StatusBoleto() {
    _classCallCheck(this, StatusBoleto);
    return _callSuper(this, StatusBoleto, arguments);
  }
  _inherits(StatusBoleto, _Component);
  return _createClass(StatusBoleto, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "container-alert  ".concat(this.props.theme)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "icon-content"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: this.props.image,
        alt: this.props.altIcon
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "title"
      }, this.props.title)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/close-circle.svg",
        className: "close-icon",
        alt: "close",
        onClick: this.props.onClose
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos"
      }, this.props.children));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__ = __webpack_require__(22);


var ModalFailPayment = function ModalFailPayment(_ref) {
  var isModalFailPaymentActive = _ref.isModalFailPaymentActive,
    closeModalFailPayment = _ref.closeModalFailPayment,
    creditcard = _ref.creditcard;
  if (!isModalFailPaymentActive) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
  var _useDetectClickOutsid = Object(__WEBPACK_IMPORTED_MODULE_1__hooks_useDetectClickOutsideElement__["a" /* useDetectClickOutsideElement */])({
      onClickOutside: closeModalFailPayment
    }),
    containerRef = _useDetectClickOutsid.containerRef;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_modalpagamento mobile-roof"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalcontents mobile-modal failPaymentModal",
    ref: containerRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "contents"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modaltop"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title"
  }, "Erro ao finalizar o seu pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    onClick: closeModalFailPayment,
    className: "close-btn"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/icons/close.svg",
    alt: "bot\xE3o de fechar janela",
    style: {
      height: '14px'
    }
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalmiddle modalMiddlefailPayment"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/ic-fail-payment.svg",
    alt: "",
    className: "fail-payment-icon",
    style: {
      width: '243.975px',
      height: '170px'
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, "N\xE3o conseguimos processar o pagamento do seu seguro viagem."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "modalMiddleFailPaymentText"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "flex-start-column"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Revise seus dados de pagamento e tente finalizar novamente."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Confira os motivos mais comuns para isso acontecer:")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "flex-start-column ulFailPayment"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Algum dado foi digitado errado (n\xFAmero do cart\xE3o, data de vencimento, c\xF3digo de seguran\xE7a);"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Limite de cr\xE9dito indispon\xEDvel no cart\xE3o;"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Limite de transa\xE7\xF5es do cart\xE3o virtual;"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Uso de um cart\xE3o de d\xE9bito (aceitamos apenas cr\xE9dito)."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null, "Bloqueio de seguran\xE7a pela operadora do cart\xE3o;")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "flex-start-column"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Em caso de d\xFAvidas, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "entre em contato com a operadora do seu cart\xE3o"), " (geralmente o n\xFAmero de telefone fica no verso do cart\xE3o) e finalize a compra novamente."))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: "btn",
    onClick: closeModalFailPayment,
    "data-cy": "close-modal-fail-payment"
  }, "Revisar pagamento"))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ModalFailPayment);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_comparison_modal_email_ModalEmail__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comparison_accordion_Accordion__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_comparison_comparison_bar_ComparisonBar__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__ = __webpack_require__(32);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint prefer-template: 0 camelcase: 0 */











var ComparisonAlert = /*#__PURE__*/function (_Component) {
  function ComparisonAlert() {
    _classCallCheck(this, ComparisonAlert);
    return _callSuper(this, ComparisonAlert, arguments);
  }
  _inherits(ComparisonAlert, _Component);
  return _createClass(ComparisonAlert, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_main clearfixs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "area-lista-comparacao"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", {
        style: {
          textAlign: 'center',
          color: '#007e47'
        }
      }, "\xC9 poss\xEDvel comparar apenas 2 produtos em telas pequenas. Para ver todos os planos da compara\xE7\xE3o abra esta p\xE1gina em um dispositivo de tela maior!")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var Comparison = /*#__PURE__*/function (_Component2) {
  function Comparison(props) {
    var _this;
    _classCallCheck(this, Comparison);
    _this = _callSuper(this, Comparison, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["changeTitle"])('comparison');
    var _getUrlParams = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["getUrlParams"])(),
      products_ids = _getUrlParams.products_ids;
    var products_ids_arr = products_ids.replace(/%20/g, '+').split('+');
    var unique_products_ids_arr = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["removeDuplicates"])(products_ids_arr);
    var basePath = '/seguro-viagem/comparacao';
    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["isB2b"])()) basePath = '/seguro-viagem/comparacao-b2b';
    if (products_ids_arr.length !== unique_products_ids_arr.length) {
      var location = {
        pathname: Object(__WEBPACK_IMPORTED_MODULE_8__utils__["formatURL"])(_this.props.match.params, basePath + '/' + _this.props.match.params.destination + '/' + _this.props.match.params.begin_date + '/' + _this.props.match.params.end_date + '/', window.location.search.replace(/products_ids=[0-9,]+/, 'products_ids=' + unique_products_ids_arr.join('+')))
      };
      _this.props.history.push(location);
    }
    return _this;
  }
  _inherits(Comparison, _Component2);
  return _createClass(Comparison, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["isMobile"])() && Object(__WEBPACK_IMPORTED_MODULE_8__utils__["getUrlParams"])().products_ids.replace(/%20/g, '+').split('+').length > 2) return;
      var _getUrlParams2 = Object(__WEBPACK_IMPORTED_MODULE_8__utils__["getUrlParams"])(),
        products_ids = _getUrlParams2.products_ids;
      Object(__WEBPACK_IMPORTED_MODULE_5__apiCalls__["comparePlans"])({
        destination: this.props.match.params.destination,
        begin_date: this.props.match.params.begin_date,
        end_date: this.props.match.params.end_date,
        product_code: products_ids
      });
      Object(__WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["w" /* setQuotationParams */])({
        context: 'comparison',
        product_code: products_ids,
        end_date: this.props.match.params.end_date,
        begin_date: this.props.match.params.begin_date,
        destination: this.props.match.params.destination
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["isMobile"])() && Object(__WEBPACK_IMPORTED_MODULE_8__utils__["getUrlParams"])().products_ids.replace(/%20/g, '+').split('+').length > 2) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ComparisonAlert, null);
      if (!this.props.plans.length) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("main", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "comp_main clearfixs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_comparison_comparison_bar_ComparisonBar__["a" /* default */], {
        destinations: this.props.destinations
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_comparison_accordion_Accordion__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_comparison_modal_email_ModalEmail__["a" /* default */], {
        type: "comparison"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_modal_quotation_date_warning_ModalQuotationDateWarning__["a" /* default */], null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    isModalEmailActive: state.comparison.isModalEmailActive,
    userDetails: state.comparison.userDetails,
    destinations: state.global.destinations
  };
}, {
  setQuotationParams: __WEBPACK_IMPORTED_MODULE_6__actions_searchActions__["w" /* setQuotationParams */],
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_7__actions_comparisonActions__["f" /* openModalQuotationDateWarning */]
})(Comparison));

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AccordionGroupSet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var Accordion = /*#__PURE__*/function (_Component) {
  function Accordion(props) {
    var _this;
    _classCallCheck(this, Accordion);
    _this = _callSuper(this, Accordion, [props]);
    var benefits = props.benefits.map(function (list) {
      if (list === undefined) {
        return 0;
      }
      return list.filter(function (benefit) {
        return parseInt(benefit.code, 0) === parseInt(props.benefitCode, 0);
      })[0];
    });
    _this.state = {
      benefits: benefits.reverse()
    };
    _this.openDescription = _this.openDescription.bind(_this);
    return _this;
  }
  _inherits(Accordion, _Component);
  return _createClass(Accordion, [{
    key: "openDescription",
    value: function openDescription() {
      this.props.openComparisonAccordion(this.props.benefitCode);
      if (!this.props.opened) {
        __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].genericEvent('sg_event', 'sp_comparacao', 'click_botao', '+detalhes');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var containerClass = "row-plano flex ".concat(this.props.opened ? 'active' : '');
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "row-acc ".concat(this.props.last)
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: containerClass,
        onClick: this.openDescription
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "col-plano desc accordion-compare"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "sigla"
      }, this.props.name)), !Object(__WEBPACK_IMPORTED_MODULE_5__utils__["isMobile"])() && [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        key: 3,
        className: "col-plano"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.state.benefits[3] && this.state.benefits[3].coverage || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "nao"
      }), "-"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        key: 2,
        className: "col-plano"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.state.benefits[2] && this.state.benefits[2].coverage || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "nao"
      }), "-")))], /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        key: 1,
        className: "col-plano"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.state.benefits[1] && this.state.benefits[1].coverage || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "nao"
      }), "-"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        key: 0,
        className: "col-plano"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, this.state.benefits[0] && this.state.benefits[0].coverage || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "nao"
      }), "-"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: this.props.opened ? 'more-icon open comparation' : 'more-icon comparation'
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "acc-panel-compare"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr", {
        className: this.props.position % 2 === 0 ? 'line-separator even-color' : 'line-separator odd-color'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null, this.props.content), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        className: "fechar-panel",
        onClick: this.openDescription
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionGroup = /*#__PURE__*/function (_Component2) {
  function AccordionGroup() {
    _classCallCheck(this, AccordionGroup);
    return _callSuper(this, AccordionGroup, arguments);
  }
  _inherits(AccordionGroup, _Component2);
  return _createClass(AccordionGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var lastSize = 0;
      var longestItem = 0;
      this.props.benefits.forEach(function (item, i) {
        if (item !== undefined && item.length > lastSize) {
          lastSize = item.length;
          longestItem = i;
        }
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "item-lista"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, this.props.title), this.props.benefits[longestItem].map(function (benefit, i) {
        var content = _this2.props.benefits_list.filter(function (b) {
          return b.code === benefit.code;
        });
        content = content.length >= 1 ? content[0].long_description : '';
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Accordion, {
          name: benefit.name,
          key: benefit.name,
          benefits: _this2.props.benefits,
          benefitIterator: i,
          benefitCode: benefit.code,
          content: content,
          opened: _this2.props.openedBenefitCode === benefit.code,
          longestItem: longestItem,
          position: i,
          openComparisonAccordion: _this2.props.openComparisonAccordion,
          last: i === _this2.props.benefits[longestItem].length - 1 ? 'last' : ''
        });
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "separador"
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var AccordionGroupSet = /*#__PURE__*/function (_Component3) {
  function AccordionGroupSet(props) {
    var _this3;
    _classCallCheck(this, AccordionGroupSet);
    _this3 = _callSuper(this, AccordionGroupSet, [props]);
    Object(__WEBPACK_IMPORTED_MODULE_4__apiCalls__["listBenefits"])();
    return _this3;
  }
  _inherits(AccordionGroupSet, _Component3);
  return _createClass(AccordionGroupSet, [{
    key: "render",
    value: function render() {
      var _this4 = this;
      if (!this.props.comparisonPlansInfo.length) return null;
      var accordionContainers = [];
      var benefits = this.props.comparisonPlansInfo.map(function (plan) {
        return plan.benefits;
      });
      var categories = Object.keys(benefits[0]);
      categories.forEach(function (category) {
        var benefitPerCat = [];
        benefits.forEach(function (benefit) {
          return benefitPerCat.push(benefit[category]);
        });
        accordionContainers.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccordionGroup, {
          title: category,
          key: category,
          benefits: benefitPerCat,
          benefits_list: _this4.props.benefits_list,
          openedBenefitCode: _this4.props.openedBenefitCode,
          openComparisonAccordion: _this4.props.openComparisonAccordion
        }));
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "area-lista-comparacao"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "lista-comparacao"
      }, accordionContainers)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    comparisonPlansInfo: state.comparison.comparisonPlansInfo,
    benefits_list: state.purchase.benefits_list,
    openedBenefitCode: state.comparison.openedBenefitCode
  };
}, {
  openComparisonAccordion: __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__["d" /* openComparisonAccordion */]
})(AccordionGroupSet)));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComparisonBar_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComparisonBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ComparisonBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__search_plans_table_PixDiscountTag__ = __webpack_require__(29);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }







var PlanInfo = /*#__PURE__*/function (_Component) {
  function PlanInfo(props) {
    var _this;
    _classCallCheck(this, PlanInfo);
    _this = _callSuper(this, PlanInfo, [props]);
    _this.goToPurchasePage = _this.goToPurchasePage.bind(_this);
    return _this;
  }
  _inherits(PlanInfo, _Component);
  return _createClass(PlanInfo, [{
    key: "goToPurchasePage",
    value: function goToPurchasePage(e) {
      e.onClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      var link = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatURL"])(this.props.match.params, "/pedido/".concat(this.props.plan.code, "/").concat(this.props.match.params.destination, "/").concat(this.props.match.params.begin_date, "/").concat(this.props.match.params.end_date));
      var purchaseBtnClass = this.props.disabled ? 'desligado' : '';
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "flex box-plano-new"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "name-plan"
      }, this.props.plan.name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "span-small"
      }, "Faixa et\xE1ria: ", this.props.plan.child.min_age, " a ", this.props.plan.elder.max_age, " anos"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        href: this.props.plan.terms_url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "link-cond"
      }, "Ver condi\xE7\xF5es gerais"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "price-mobile"
      }, this.props.plan.price_with_coupon_discount > 0 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "first-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("s", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatPrice"])(this.props.plan.adult.price))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "first-price"
      }, " "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "real-price"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "R$", this.props.plan.price_with_coupon_discount > 0 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, " ", Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatPrice"])(this.props.plan.price_with_coupon_discount), " ") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, " ", Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatPrice"])(this.props.plan.adult && this.props.plan.adult.price), " ")), Object(__WEBPACK_IMPORTED_MODULE_4__utils__["getMaxParcel"])(this.props.plan.adult && this.props.plan.adult.price), "x sem juros"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "price-pix"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_4__utils__["formatPrice"])(this.props.plan.price_with_discount)), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__search_plans_table_PixDiscountTag__["a" /* default */], {
        isMobile: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isMobile"])()
      })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */], {
        to: link,
        onClick: this.goToPurchasePage,
        className: "comprar-plano flex ".concat(purchaseBtnClass),
        title: ""
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
var ComparisonBar = /*#__PURE__*/function (_Component2) {
  function ComparisonBar(props) {
    var _this2;
    _classCallCheck(this, ComparisonBar);
    _this2 = _callSuper(this, ComparisonBar, [props]);
    _this2.openModalEmail = _this2.props.openModalEmail.bind(_this2);
    var begin_date = _this2.props.match.params.begin_date.split('-'),
      end_date = _this2.props.match.params.end_date.split('-');
    var destination;
    if (_this2.props.destinations.filter(function (dest) {
      return dest.slug === _this2.props.match.params.destination;
    })[0] !== undefined) {
      destination = _this2.props.destinations.filter(function (dest) {
        return dest.slug === _this2.props.match.params.destination;
      })[0].name;
    } else {
      destination = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["getDestinationBySlug"])(_this2.props.match.params.destination);
    }
    _this2.destination = destination;
    _this2.begin_date = "".concat(begin_date[2], "/").concat(begin_date[1], "/").concat(begin_date[0]);
    _this2.end_date = "".concat(end_date[2], "/").concat(end_date[1], "/").concat(end_date[0]);
    _this2.goBack = _this2.goBack.bind(_this2);
    return _this2;
  }
  _inherits(ComparisonBar, _Component2);
  return _createClass(ComparisonBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bar = document.querySelector('.comparacao-planos');
      var list = document.querySelector('.area-lista-comparacao');
      if (list && bar) window.addEventListener('scroll', function () {
        if (window.scrollY > 120) {
          bar.classList.add('fixedd');
          list.style.marginTop = '250px';
        } else {
          bar.classList.remove('fixedd');
          list.style.marginTop = '5px';
        }
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.props.history.go(-1);
    }
  }, {
    key: "render",
    value: function render() {
      var termsUrl = [];
      var providers = this.props.providers;
      var plan_comparison = _toConsumableArray(this.props.plans).reverse();
      plan_comparison.forEach(function (plan) {
        var item = providers.filter(function (provider) {
          return provider.name === plan.provider_name;
        });
        if (item.terms_url) termsUrl.push(item.terms_url);
        if (item[0]) termsUrl.push(item[0].terms_url);
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", {
        className: "comparacao-planos"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
        onClick: this.goBack,
        className: "link-back-search"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/icons/arrowLeft.svg",
        alt: "voltar"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Voltar \xE0 pesquisa")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "header-compare"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "header-info-comparacao"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3", null, "Compare os planos:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: "new-box-details-comparation"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "p-green"
      }, "Voc\xEA pesquisou por:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", {
        className: "p-principal"
      }, this.destination), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
        className: "span-small"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, Object(__WEBPACK_IMPORTED_MODULE_4__utils__["convertDate"])(this.props.match.params.begin_date), " - ", Object(__WEBPACK_IMPORTED_MODULE_4__utils__["convertDate"])(this.props.match.params.end_date)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", {
        onClick: this.props.openModalEmail,
        className: "btn-send-comparison-email"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
        src: "/assets/images/icons/plane.svg"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Enviar compara\xE7\xE3o por e-mail"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        className: ""
      }, plan_comparison && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", {
        className: "lista-compara"
      }, plan_comparison[3] && !Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isMobile"])() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PlanInfo, {
        openModalQuotationDateWarning: this.props.openModalQuotationDateWarning,
        plan: plan_comparison[3],
        terms_url: termsUrl[3],
        key: 4,
        match: this.props.match,
        isUpsell: String(plan_comparison[3].code) === this.props.upsellUpgrade
      }), plan_comparison[2] && !Object(__WEBPACK_IMPORTED_MODULE_4__utils__["isMobile"])() && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PlanInfo, {
        openModalQuotationDateWarning: this.props.openModalQuotationDateWarning,
        plan: plan_comparison[2],
        terms_url: termsUrl[2],
        key: 3,
        match: this.props.match,
        isUpsell: String(plan_comparison[2].code) === this.props.upsellUpgrade
      }), plan_comparison[1] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PlanInfo, {
        openModalQuotationDateWarning: this.props.openModalQuotationDateWarning,
        plan: plan_comparison[1],
        terms_url: termsUrl[1],
        key: 2,
        match: this.props.match,
        isUpsell: String(plan_comparison[1].code) === this.props.upsellUpgrade
      }), plan_comparison[0] && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PlanInfo, {
        openModalQuotationDateWarning: this.props.openModalQuotationDateWarning,
        plan: plan_comparison[0],
        terms_url: termsUrl[0],
        key: 1,
        match: this.props.match,
        isUpsell: String(plan_comparison[0].code) === this.props.upsellUpgrade
      }))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    plans: state.search.plans,
    userDetails: state.comparison.userDetails,
    destinations: state.global.destinations,
    providers: state.global.providers,
    upsellUpgrade: state.purchase.upsellUpgrade
  };
}, {
  openModalEmail: __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__["e" /* openModalEmail */],
  openModalQuotationDateWarning: __WEBPACK_IMPORTED_MODULE_3__actions_comparisonActions__["f" /* openModalQuotationDateWarning */]
})(ComparisonBar)));

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PostPurchase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_standard_loading_Loading__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SeoFunctions__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_purchase_status_StatusBoleto__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_purchase_status_StatusSafetypay__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_purchase_status_StatusCreditCard__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_purchase_status_StatusPurchase__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_purchase_status_StatusInsureds__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_purchase_status_StatusFooter__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_purchase_status_StatusBoxSuccess__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_purchase_status_SafeareaBox__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_purchase_status_StatusPix__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__status_credit_coupon__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_purchase_status_RaBanner__ = __webpack_require__(350);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }









// components PurchaseStatus











var PostPurchase = /*#__PURE__*/function (_Component) {
  function PostPurchase(props) {
    var _this;
    _classCallCheck(this, PostPurchase);
    _this = _callSuper(this, PostPurchase, [props]);
    _defineProperty(_this, "POLL_INITIAL_INTERVAL", 15000);
    _defineProperty(_this, "POLL_MAX_INTERVAL", 60000);
    _defineProperty(_this, "POLL_MAX_DURATION", 20 * 60000);
    _defineProperty(_this, "pollingTimer", null);
    _defineProperty(_this, "pollingStart", null);
    _defineProperty(_this, "pollingInterval", _this.POLL_INITIAL_INTERVAL);
    _defineProperty(_this, "pollingStarted", false);
    _defineProperty(_this, "startPolling", function () {
      _this.pollingStart = Date.now();
      _this.pollingInterval = _this.POLL_INITIAL_INTERVAL;
      _this.scheduleNextPoll();
    });
    _defineProperty(_this, "scheduleNextPoll", function () {
      var elapsed = Date.now() - _this.pollingStart;
      if (elapsed >= _this.POLL_MAX_DURATION) return;
      var remaining = _this.POLL_MAX_DURATION - elapsed;
      var delay = Math.min(_this.pollingInterval, remaining);
      _this.pollingTimer = setTimeout(function () {
        Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["getPurchaseStatus"])(_this.props.match.params.uuid);
        _this.pollingInterval = Math.min(_this.pollingInterval * 2, _this.POLL_MAX_INTERVAL);
        _this.scheduleNextPoll();
      }, delay);
    });
    _defineProperty(_this, "stopPolling", function () {
      if (_this.pollingTimer) {
        clearTimeout(_this.pollingTimer);
        _this.pollingTimer = null;
      }
    });
    _defineProperty(_this, "boxPayment", function (purchase) {
      if (purchase.price === 0) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
      }
      if (purchase.payment_method === 'Cartão de Crédito') return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_purchase_status_StatusCreditCard__["a" /* default */], {
        purchase: purchase
      });else if (purchase.payment_method === 'Boleto') return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_purchase_status_StatusBoleto__["a" /* default */], {
        purchase: purchase
      });else if (purchase.payment_method === 'Transferência Bancária') return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_purchase_status_StatusSafetypay__["a" /* default */], {
        purchase: purchase
      });else if (purchase.payment_method === 'PIX') return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_purchase_status_StatusPix__["a" /* default */], {
        purchase: purchase
      });else return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
    });
    Object(__WEBPACK_IMPORTED_MODULE_5__utils__["changeTitle"])('purchase');
    return _this;
  }
  _inherits(PostPurchase, _Component);
  return _createClass(PostPurchase, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      Object(__WEBPACK_IMPORTED_MODULE_3__apiCalls__["getPurchaseStatus"])(this.props.match.params.uuid);
      Object(__WEBPACK_IMPORTED_MODULE_5__utils__["HeaderAndFooterPayment"])(this.props.location.pathname);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils__["removeOperatorCookies"])();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.purchase.id && this.props.purchase.id) {
        var p = this.props.purchase;
        __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].pageView('checkout_confirmacao');
        __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].purchase({
          id: p.id,
          grandTotal: p.price,
          coupon: p.coupon_code,
          discount: p.discount
        }, {
          code: p.product_id,
          name: p.product,
          provider_code: p.provider,
          price_with_coupon_discount: p.price
        }, p.insureds ? p.insureds.length : 1, p.payment_method);
        Object(__WEBPACK_IMPORTED_MODULE_7__SeoFunctions__["e" /* runYuhagent */])(p.price, p.id);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopPolling();
      var compHeader = document.getElementsByClassName('comp_header clearfixs');
      if (compHeader.length > 0) {
        compHeader[0].style = 'position: static';
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var purchase = nextProps.purchase,
        mobile = nextProps.mobile;
      var isPix = purchase.payment_method === 'PIX';
      var isPending = purchase.payment_status === 'Pendente';
      if (isPix && isPending && !this.pollingStarted) {
        this.pollingStarted = true;
        this.startPolling();
      } else if (this.pollingStarted && purchase.payment_status && !isPending) {
        this.stopPolling();
      }
      __WEBPACK_IMPORTED_MODULE_6__utils_dataLayer__["a" /* default */].raw({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step: purchase.parcels,
              option: purchase.payment_method,
              coupon_code: purchase.coupon_code
            },
            products: [{
              name: purchase.product,
              id: purchase.id,
              price: purchase.price,
              brand: purchase.provider,
              device: mobile ? 'mobile' : 'desktop',
              quantity: 1
            }]
          }
        }
      });
      var selectedFilters = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["getFiltersFromSession"])();
      if (selectedFilters) {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils__["clearFiltersFromSession"])();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.loading) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_standard_loading_Loading__["b" /* default */], null);
      if (!this.props.purchase.id) return null;
      var _this$props$purchase = this.props.purchase,
        price = _this$props$purchase.price,
        id = _this$props$purchase.id;
      Object(__WEBPACK_IMPORTED_MODULE_7__SeoFunctions__["c" /* runGoogleAdWordsConversion */])(id, price);
      Object(__WEBPACK_IMPORTED_MODULE_7__SeoFunctions__["a" /* NewRunGoogleAdwordsConversion */])(id);
      Object(__WEBPACK_IMPORTED_MODULE_7__SeoFunctions__["b" /* runFacebook */])('Purchase', {
        value: price,
        currency: 'BRL',
        contents: [{
          id: id
        }]
      });

      // Matomo track order
      var order = {
        id: id,
        grandTotal: price,
        subTotal: 0,
        discount: this.props.purchase.discount || 0
      };
      var destinationObj = this.props.destination && this.props.destination.find(function (dest) {
        return dest.name === _this2.props.purchase.destination;
      });
      var destinationSlug = destinationObj ? destinationObj.slug : this.props.purchase.destination;
      var items = [{
        sku: this.props.purchase.product_id,
        name: this.props.purchase.product,
        category: destinationSlug,
        price: price,
        quantity: this.props.purchase.insureds.length
      }];
      if (this.props.mobile) {
        var compHeader = document.getElementsByClassName('comp_header payment');
        if (compHeader && compHeader.length) {
          compHeader[0].style = 'display: block; height: 68px;';
        }
      }
      var purchase = this.props.purchase;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "container-status"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_purchase_status_StatusBoxSuccess__["a" /* default */], {
        purchase: purchase
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_purchase_status_SafeareaBox__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_purchase_status_RaBanner__["a" /* default */], null), this.boxPayment(purchase), purchase.credit_coupon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__status_credit_coupon__["a" /* StatusCreditCoupon */], {
        creditCoupon: purchase.credit_coupon,
        createdAt: purchase.created_at
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_purchase_status_StatusPurchase__["a" /* default */], {
        purchase: purchase
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_purchase_status_StatusInsureds__["a" /* default */], {
        insureds: purchase.insureds
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_purchase_status_StatusFooter__["a" /* default */], {
        purchase: purchase
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var PostPurchaseWithFeature = function PostPurchaseWithFeature(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PostPurchase, props);
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    loading: state.purchaseStatus.loading,
    purchase: state.purchaseStatus,
    mobile: state.mobile.mobileActive,
    destination: state.global.destinations
  };
}, {})(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(PostPurchaseWithFeature)));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusBoleto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPayment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__ = __webpack_require__(7);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }




var StatusBoleto = /*#__PURE__*/function (_Component) {
  function StatusBoleto(props) {
    var _this;
    _classCallCheck(this, StatusBoleto);
    _this = _callSuper(this, StatusBoleto, [props]);
    _defineProperty(_this, "copyBarcode", function (e) {
      __WEBPACK_IMPORTED_MODULE_3__utils_dataLayer__["a" /* default */].genericEvent('sg_event', 'sp_pos_compra', 'click_botao', 'copiar_codigo_de_barras');
      var copyText = _this.barCode.current;
      var range = document.createRange();
      range.selectNode(copyText);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      _this.setState({
        textButtonBarcode: 'Código de barras copiado',
        buttonCopyed: true
      });
    });
    _this.barCode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.state = {
      textButtonBarcode: 'Copiar código de barras',
      buttonCopyed: false
    };
    return _this;
  }
  _inherits(StatusBoleto, _Component);
  return _createClass(StatusBoleto, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var purchase = this.props.purchase;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StatusPayment__["a" /* default */], {
        purchase: purchase,
        theme: "Boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "flex-boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos-payment"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "image-boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/icons/boleto.svg",
        alt: "boleto"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos-boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, purchase.payment_method), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Total R$ ", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["formatPrice"])(purchase.price)))), Object(__WEBPACK_IMPORTED_MODULE_2__utils__["getPurchasePending"])(purchase.status) ? purchase.payment.barcode && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "get-boleto"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        href: purchase.payment.boleto_url,
        target: "_blank",
        className: "ver-boleto"
      }, "Ver boleto")) : purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "get-boleto"
      }, "O boleto est\xE1 dispon\xEDvel no seu e-mail.") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null)), purchase.payment.barcode && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["getPurchasePending"])(purchase.status) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "barcode-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "deadline"
      }, "Vencimento ", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["formatDate"])(purchase.payment.deadline))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "barcode-bar",
        ref: this.barCode
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, purchase.payment.barcode)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "barcode-footer"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "warning-mail"
      }, "O boleto tamb\xE9m est\xE1 dispon\xEDvel no seu e-mail."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "copy-barcode"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: this.state.buttonCopyed ? 'active' : '',
        onClick: function onClick(e) {
          return _this2.copyBarcode(e);
        }
      }, this.state.textButtonBarcode))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusSafetypay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CashTransferInstruction__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusPayment__ = __webpack_require__(34);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }




var StatusSafetypay = /*#__PURE__*/function (_Component) {
  function StatusSafetypay() {
    _classCallCheck(this, StatusSafetypay);
    return _callSuper(this, StatusSafetypay, arguments);
  }
  _inherits(StatusSafetypay, _Component);
  return _createClass(StatusSafetypay, [{
    key: "render",
    value: function render() {
      var purchase = this.props.purchase;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StatusPayment__["a" /* default */], {
        purchase: purchase
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "safetypay"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "payment-safetypay"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "bank"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: purchase.payment.bank_img_path,
        alt: "bank",
        width: "30px"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos-safetypay"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, purchase.payment.bank_name), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Total"), " R$ ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(purchase.price))), Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getPurchasePending"])(purchase.status) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "warning-safetypay-deadline"
      }, purchase.payment.active_safetypay && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Aten\xE7\xE3o:"), " A compra somente ser\xE1 conclu\xEDda se o pagamento for realizado at\xE9 as ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["getHoursDateGMT"])(purchase.payment.active_safetypay.deadline), "h do dia ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, Object(__WEBPACK_IMPORTED_MODULE_1__utils__["dateFormatGMT"])(purchase.payment.active_safetypay.deadline)))) : purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "warning-safetypay-deadline"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Aten\xE7\xE3o:"), " As informa\xE7\xF5es para realizar a transfer\xEAncia banc\xE1ria est\xE3o dispon\xEDveis no seu e-mail.") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), purchase.payment.active_safetypay && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, purchase.payment.active_safetypay.extra ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "warning-instructions"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, " Siga as intru\xE7\xF5es abaixo e garanta sua reserva:  ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CashTransferInstruction__["a" /* default */], {
        purchase: purchase
      })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "warning-instructions"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Aten\xE7\xE3o:"), " As informa\xE7\xF5es para realizar a transfer\xEAncia banc\xE1ria est\xE3o dispon\xEDveis no seu e-mail.")), purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Importante:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-steps"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/mail/cash.png",
        alt: "cash"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Transfira o valor exato da sua compra: R$ ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(purchase.price))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-steps"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/mail/forbidden.png",
        alt: "pj"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "N\xE3o utilize contas de Pessoa Jur\xEDdica;")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-steps"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/mail/forbidden.png",
        alt: "not-account"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "N\xE3o utilize Conta Poupan\xE7a;")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-steps"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/mail/forbidden.png",
        alt: "internet-banking"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Pague somente por meio do Internet Banking do banco acima. N\xE3o dispon\xEDvel para caixa eletr\xF4nico, telefone ou pela ag\xEAncia banc\xE1ria.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-steps"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/mail/deadline.png",
        alt: "payment-date"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "O pagamento dever\xE1 ser realizado dentro do prazo estabelecido para que seja reconhecido como v\xE1lido. N\xE3o agende o pagamento para outra data."))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null)));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var CashTransferInstruction = function CashTransferInstruction(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "steps-payment"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "steps"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "1 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Acesse o APP ou o site do ", props.purchase.payment.bank_name, ".")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "2 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "No menu de servi\xE7os, selecione Transfer\xEAncia Banc\xE1ria")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "3 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Informe a ag\xEAncia: ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch, " e conta-corrente: ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "4 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Confirme o nome do favorecido:  ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_name)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "5 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Efetue o pagamento no valor exato de R$ ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(props.purchase.price))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "6 - "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "PRONTO! O pagamento do seu pedido ser\xE1 confirmado para Seguros Promo"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-box"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-box-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "De: sua conta"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "bank-image"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: props.purchase.payment.bank_img_path,
    className: "img-bank",
    alt: props.purchase.payment.bank_name
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-box-cpf"
  }, "CPF: ", props.purchase.payment.active_safetypay.holder_cpf), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-box-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Para: conta do PayMee"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "bank-image"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: props.purchase.payment.bank_img_path,
    className: "img-bank",
    alt: props.bank_name
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-bank-branch"
  }, "Ag\xEAncia: ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "icon-copy",
    id: "agency-copy",
    src: "/assets/images/icon-copy.svg",
    alt: "icone para copiar ag\xEAncia",
    onClick: function onClick() {
      navigator.clipboard.writeText(props.purchase.payment.active_safetypay.extra.instructions.beneficiary_branch);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-bank-account"
  }, "Conta Corrente: ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "icon-copy",
    id: "account-copy",
    src: "/assets/images/icon-copy.svg",
    alt: "icone para copiar conta",
    onClick: function onClick() {
      navigator.clipboard.writeText(props.purchase.payment.active_safetypay.extra.instructions.beneficiary_account);
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-bank-beneficiary"
  }, "Favorecido: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null, props.purchase.payment.active_safetypay.extra.instructions.beneficiary_name)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-bank-document"
  }, "CNPJ: ", props.purchase.payment.active_safetypay.extra.instructions.beneficiary_document), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "step-bank-price"
  }, "Valor a ser pago: ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "R$ ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatPrice"])(props.purchase.price)))));
};
/* harmony default export */ __webpack_exports__["a"] = (CashTransferInstruction);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusCreditCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPayment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }



var StatusCreditCard = /*#__PURE__*/function (_Component) {
  function StatusCreditCard() {
    _classCallCheck(this, StatusCreditCard);
    return _callSuper(this, StatusCreditCard, arguments);
  }
  _inherits(StatusCreditCard, _Component);
  return _createClass(StatusCreditCard, [{
    key: "render",
    value: function render() {
      var purchase = this.props.purchase;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StatusPayment__["a" /* default */], {
        purchase: purchase,
        theme: "credit"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "credit"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Cart\xE3o de cr\xE9dito"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "brand"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: "/assets/images/home/home/cards/".concat(purchase.payment.brand, ".svg"),
        alt: "brand"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "infos-credit"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, purchase.payment.brand)), " (final ", purchase.payment.number, ") ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Pagamento"), " ", purchase.parcels, "x de R$ ", Object(__WEBPACK_IMPORTED_MODULE_2__utils__["formatPrice"])(purchase.price / purchase.parcels)))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1);


var StatusPurchase = function StatusPurchase(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title-box"
  }, "Dados do pedido"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-post-purchase"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-plan-purchase-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/seguradoras/".concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["cleanProviderName"])(props.purchase.provider), ".png"),
    alt: "Seguradora",
    className: "logo-seguradora"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Plano:"), "\xA0", props.purchase.product)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "infos-body"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Seguradora:"), "\xA0", props.purchase.provider), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Destino:"), "\xA0", props.purchase.destination), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Per\xEDodo:"), "\xA0", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatDate"])(props.purchase.departure_date), " a ", Object(__WEBPACK_IMPORTED_MODULE_1__utils__["formatDate"])(props.purchase.return_date)))));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusPurchase);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react/no-array-index-key */

var StatusInsureds = function StatusInsureds(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title-box"
  }, "Segurados"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-insureds"
  }, props.insureds.map(function (insured, i) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "infos-insureds",
      key: i
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, insured.full_name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, insured.document_type === 2 ? 'Passaporte:' : 'CPF:'), "\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, insured.document));
  })));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusInsureds);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var StatusFooter = function StatusFooter(props) {
  if (props.purchase.cityads_pixel_url) {
    var script = document.createElement('script');
    script.src = props.purchase.cityads_pixel_url;
    script.async = true;
    document.body.appendChild(script);
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "msg-tks"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "img-s2",
    src: "/assets/images/s2.svg",
    alt: "icon-grate"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " Obrigado pela prefer\xEAncia. ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " \xC9 um prazer poder lhe atender!"), props.purchase.actionpay_pixel_url && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: props.purchase.actionpay_pixel_url,
    width: "1",
    height: "1",
    alt: "pixel"
  }), props.purchase.meliuz_pixel_url && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: props.purchase.meliuz_pixel_url,
    width: "1",
    height: "1",
    alt: "pixel"
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusFooter);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dataLayer__ = __webpack_require__(7);


var StatusBoxSuccess = function StatusBoxSuccess(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dataLayerHandler();
  }, []);
  var dateDifference = function dateDifference() {
    var date1 = new Date(props.purchase.departure_date);
    var date2 = new Date(props.purchase.return_date);
    var difference_In_Time = date2.getTime() - date1.getTime();
    var difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
    return difference_In_Days;
  };
  var dataLayerHandler = function dataLayerHandler() {
    __WEBPACK_IMPORTED_MODULE_1__utils_dataLayer__["a" /* default */].raw({
      event: 'confirmacao_pedido',
      dados_pedido: {
        id_pedido: props.purchase.id,
        plano: props.purchase.product,
        seguradora: props.purchase.provider,
        meio_de_pagamento: props.purchase.payment_method,
        destino: props.purchase.destination,
        data_embarque: props.purchase.departure_date,
        data_desembarque: props.purchase.return_date,
        tempo_permanencia: dateDifference()
      }
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box success",
    style: {
      zIndex: 4
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "success-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "img-success",
    src: "/assets/images/check-sucess.svg",
    alt: "Selecionado"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "success-body"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, props.purchase.payment_status === 'Aprovado' ? 'Pagamento confirmado com sucesso!' : 'Pedido recebido com sucesso!'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-order-number"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box-green"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-number-purchase"
  }, "N\xFAmero do seu pedido:\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "number-purchase"
  }, props.purchase.id)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "text-success-info"
  }, props.purchase.payment_status === 'Aprovado' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ol\xE1, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, props.purchase.contact_name.split(" ")[0]), "! Recebemos o seu pagamento, que foi processado com sucesso e o pedido est\xE1 em andamento para a emiss\xE3o da sua ap\xF3lice.", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Em breve, voc\xEA receber\xE1 os detalhes da ap\xF3lice no e-mail cadastrado no pedido. Qualquer d\xFAvida adicional, entraremos em contato por e-mail.", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Vamos juntos construir e manter a seguran\xE7a.", " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.segurospromo.com.br/atendimento/",
    rel: "noopener noreferrer",
    target: "__blank"
  }, "Pode contar com a gente!")) : props.purchase.payment_method === "Boleto" ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ol\xE1, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, props.purchase.contact_name.split(" ")[0]), "! Recebemos o seu pedido, assim que identificarmos o pagamento do boleto iremos prosseguir com a emiss\xE3o da sua ap\xF3lice. O boleto tem prazo de compensa\xE7\xE3o de 1 a 2 dias \xFAteis.") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ol\xE1, ", props.purchase.contact_name.split(" ")[0], "! Recebemos o seu pedido, neste momento ele est\xE1 sendo processado e o pagamento est\xE1 sendo analisado por nossa equipe."), props.purchase.payment_status !== 'Aprovado' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Em breve, voc\xEA receber\xE1 os detalhes e atualiza\xE7\xE3o do seu pedido no seu e-mail. Caso tenha alguma d\xFAvida, entre em contato com a nossa", " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.segurospromo.com.br/atendimento/",
    rel: "noopener noreferrer",
    target: "__blank"
  }, "central de atendimento"), "."))));
};
/* harmony default export */ __webpack_exports__["a"] = (StatusBoxSuccess);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SafeareaBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SafeareaBox = function SafeareaBox(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "box safearea-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "safearea-img-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "safearea-icon",
    src: "/assets/images/mail/area-cliente.png",
    alt: "\xC1rea do cliente"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "safearea-text-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "safearea-text"
  }, "Acompanhe o status", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "\xA0do seu pedido na nossa\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/area-do-cliente/",
    className: "safearea-link"
  }, "\xC1rea do Cliente"), ".")));
};
/* harmony default export */ __webpack_exports__["a"] = (SafeareaBox);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusPix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPayment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BoxInfos__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }




var StatusPix = /*#__PURE__*/function (_Component) {
  function StatusPix(props) {
    var _this;
    _classCallCheck(this, StatusPix);
    _this = _callSuper(this, StatusPix, [props]);
    _defineProperty(_this, "copyBarcode", function () {
      var copyText = _this.barCode.current;
      var range = document.createRange();
      range.selectNode(copyText);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      _this.setState({
        textButtonCopied: "Copiado!"
      });
    });
    _defineProperty(_this, "urlImageValidationHandler", function (path) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.src = path;
        img.onload = function () {
          return resolve(true);
        };
        img.onerror = function () {
          return resolve(false);
        };
      });
    });
    _defineProperty(_this, "isImageURLValid", function (url) {
      _this.urlImageValidationHandler(url).then(function (result) {
        _this.setState({
          isURLValid: result
        });
      });
    });
    _this.barCode = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
    _this.isImageURLValid(_this.props.purchase.payment.qrcode_url);
    _this.state = {
      textButtonCopied: "Copiar código",
      isURLValid: false
    };
    return _this;
  }
  _inherits(StatusPix, _Component);
  return _createClass(StatusPix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (window.location.hash === '#btncopyqrcode') {
        setTimeout(function () {
          var element = document.getElementById('btncopyqrcode');
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        }, 100);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var purchase = this.props.purchase;
      if (purchase.payment_status === 'Aprovado') {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "title-box"
        }, "Pagamentos"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "box payment"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "header-box credit"
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "body-box"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "credit"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Pagamento"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "PIX"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "brand",
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
          src: "/assets/images/pagamento/pix.svg",
          alt: "PIX",
          style: {
            width: '40px',
            flexShrink: 0
          }
        }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "infos-credit",
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Valor pago:"), "\xA0R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(purchase.price)))))));
      }
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__StatusPayment__["a" /* default */], {
        purchase: purchase
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "pix"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_BoxInfos__["a" /* default */], {
        image: "/assets/images/icons/alert.svg",
        altIcon: "icon-warning",
        theme: "warning"
      }, "Siga as intru\xE7\xF5es de pagamento abaixo para prosseguir com a emiss\xE3o da sua ap\xF3lice. Fa\xE7a o pagamento o mais r\xE1pido poss\xEDvel e garanta seu seguro."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "pix-rules"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "1 -"), " No aplicativo do seu banco, localize a op\xE7\xE3o PIX e selecione Pagar."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "pix-rules"
      }, purchase.payment.qrcode_url ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "desktop"
      }, this.state.isURLValid ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2 -"), " Escolha a op\xE7\xE3o ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Ler QR Code"), " e aproxime a c\xE2mera do seu celular ou ent\xE3o a op\xE7\xE3o ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Pix Copia e Cola"), " e copie a chave abaixo.") : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2 -"), " Escolha a op\xE7\xE3o ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Pix Copia e Cola"), " e copie a chave abaixo.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "mobile"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2 -"), "Escolha a op\xE7\xE3o ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Pix Copia e Cola"), " e copie a chave abaixo."), this.state.isURLValid && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-pix-payment desktop"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title"
      }, " Ler QR Code"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "subtitle"
      }, "Aproxime a c\xE2mera do seu celular para ler a imagem"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
        src: purchase.payment.qrcode_url,
        alt: "Qrcode pagamento pix"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "separation desktop"
      }, "OU")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "box-pix-payment"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "title"
      }, "Pix Copia e Cola"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "subtitle"
      }, "Copie o c\xF3digo e cole no aplicativo do seu banco. ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Lembre-se, n\xE3o se trata de um boleto banc\xE1rio.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        type: "text",
        value: purchase.payment.pix_code,
        className: "input-code",
        ref: this.barCode
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "button-copy",
        onClick: this.copyBarcode,
        id: "btncopyqrcode"
      }, this.state.textButtonCopied)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "help-pix"
      }, "Voc\xEA tem at\xE9 ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["getHoursDateGMT"])(purchase.payment.deadline), " para efetuar o pagamento."))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "2 -"), " Veja as instru\xE7\xF5es de pagamento que ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "foram enviadas para o seu e-mail"), ".")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "pix-rules"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "3 -"), " Confira os dados e efetue o pagamento:", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Valor:"), " R$ ", Object(__WEBPACK_IMPORTED_MODULE_3__utils__["formatPrice"])(purchase.price), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "Favorecido:"), " PayMee Brasil Servi\xE7os de Pagamento SA"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "pix-rules"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "4 - Agora \xE9 s\xF3 aguardar!"), " Acompanhe no seu e-mail o status e as atualiza\xE7\xF5es do seu pedido."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_BoxInfos__["a" /* default */], {
        image: "/assets/images/icons/phone.svg",
        altIcon: "icon-phone",
        theme: "success pos-payment"
      }, "Entre em contato em um dos nosso canais de atendimento caso n\xE3o receba o e-mail de compra aprovada em at\xE9 2hs ap\xF3s o pagamento.")));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusCreditCoupon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons_Wallet_icon__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_icons_ArrowDown_icon__ = __webpack_require__(349);




var StatusCreditCoupon = function StatusCreditCoupon(props) {
  var amount_used = props.creditCoupon.amount_used || 0;
  var remaining_balance = props.creditCoupon.remaining_balance || 0;
  var createdAtformatted = new Date(props.createdAt).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "credit-summary-card"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons_Wallet_icon__["a" /* WalletIcon */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", {
    className: "card-title"
  }, "Resumo dos cr\xE9ditos")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "transaction-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "transaction-item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "transaction-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "icon-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__assets_icons_ArrowDown_icon__["a" /* ArrowDownIcon */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "transaction-details"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "transaction-name"
  }, "Saldo utilizado"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "transaction-date"
  }, createdAtformatted))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "transaction-amount"
  }, amount_used.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", {
    className: "divider"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "footer-label"
  }, "Saldo dispon\xEDvel"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "footer-value"
  }, remaining_balance.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }))));
};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WalletIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var WalletIcon = function WalletIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M24.0974 23.1875H6.15992C5.44242 23.1875 4.77742 22.9075 4.26992 22.4C3.77992 21.8925 3.48242 21.21 3.48242 20.51V6.15998C3.48242 5.45998 3.76242 4.77748 4.26992 4.26998C4.77742 3.76248 5.44242 3.48248 6.15992 3.48248H21.4024C21.8924 3.48248 22.2774 3.86748 22.2774 4.35748C22.2774 4.84748 21.8924 5.23248 21.4024 5.23248H6.15992C5.91492 5.23248 5.68742 5.33748 5.51242 5.49498C5.33742 5.65248 5.24992 5.89748 5.24992 6.14248C5.24992 6.38748 5.35492 6.61498 5.51242 6.78998C5.66992 6.96498 5.91492 7.05248 6.15992 7.05248H24.0974C24.5699 7.05248 25.0249 7.24498 25.3574 7.57748C25.6899 7.90998 25.8824 8.36498 25.8824 8.81998V21.3675C25.8824 21.84 25.7074 22.2775 25.3749 22.61C25.0424 22.9425 24.5874 23.135 24.1149 23.135L24.0974 23.1875ZM5.24992 8.67998V20.5275C5.24992 20.7725 5.35492 21 5.51242 21.175C5.68742 21.35 5.91492 21.4375 6.15992 21.4375H24.0974V8.85498L6.15992 8.83748C5.84492 8.83748 5.52992 8.78498 5.24992 8.67998Z",
    fill: "#3C3769"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M20.0721 16.03C20.8071 16.03 21.4196 15.435 21.4196 14.6825C21.4196 13.93 20.8246 13.335 20.0721 13.335C19.3196 13.335 18.7246 13.93 18.7246 14.6825C18.7246 15.435 19.3196 16.03 20.0721 16.03Z",
    fill: "#3C3769"
  }));
};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowDownIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ArrowDownIcon = function ArrowDownIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: "arrow-icon",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
    points: "19 12 12 19 5 12"
  }));
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var RaBanner = function RaBanner() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "ra-banner-2025"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/ra/selo2026.svg",
    alt: "ra-banner",
    className: "ra-img"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "ra-banner-textBox"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", {
    className: "ra-banner-title"
  }, "Pr\xEAmio RA 2026"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "ra-banner-subtitle"
  }, "Agora que j\xE1 finalizou o seu pedido, que tal deixar seu voto para o Seguros Promo no pr\xEAmio Reclame Aqui 2026? J\xE1 somos parte da hist\xF3ria da sua viagem, agora voc\xEA pode fazer parte da nossa!"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reclameaqui.com.br/premio/votacao/seguros/seguros-viagem?utm_source=category_link&utm_campaign=premio_cat_tKLwc-o5FeJ8ScB1",
    className: "ra-banner-link"
  }, "Clique aqui para votar."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "ra-banner-subtitle"
  }, "Para votar \xE9 simples, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "https://www.reclameaqui.com.br/premio/votacao/seguros/seguros-viagem?utm_source=category_link&utm_campaign=premio_cat_tKLwc-o5FeJ8ScB1",
    className: "ra-banner-link"
  }, "acesse a p\xE1gina da vota\xE7\xE3o"), ", fa\xE7a o login na sua conta do Reclame Aqui e ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "v\xE1 at\xE9 a nossa categoria \u201CSeguros\u201D em \u201CSeguros de viagem\u201D."), " Pronto, agora \xE9 s\xF3 votar no Seguros Promo."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "ra-banner-subtitle"
  }, "Agradecemos por votar na gente!"))));
};
/* harmony default export */ __webpack_exports__["a"] = (RaBanner);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trigger_auth_buttonAuth_ButtonAuth__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trigger_auth_headerNav_HeaderNav__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__trigger_auth_alertTrigger_AlertTrigger__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_icons_index__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useCurrentUser__ = __webpack_require__(368);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }







var Header = function Header() {
  var _useCurrentUser = Object(__WEBPACK_IMPORTED_MODULE_6__hooks_useCurrentUser__["a" /* default */])(),
    user = _useCurrentUser.user,
    isLoading = _useCurrentUser.isLoading,
    refetch = _useCurrentUser.refetch;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var dialogRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (modalOpen && dialogRef.current) {
      dialogRef.current.showModal();
    } else if (dialogRef.current) {
      dialogRef.current.close();
    }
  }, [modalOpen]);
  var handleOpenMenu = function handleOpenMenu() {
    return setModalOpen(true);
  };
  var handleCloseMenu = function handleCloseMenu() {
    return setModalOpen(false);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header_logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/",
    className: "logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_index__["h" /* SegurosPromoIcon */], {
    size: 199
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header_safe-area",
    id: "safearea"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/atendimento/"
  }, "Ajuda"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__trigger_auth_buttonAuth_ButtonAuth__["a" /* default */], {
    user: user,
    isLoadingUser: isLoading,
    refetchUser: refetch
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container-menu-mobile"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__trigger_auth_buttonAuth_ButtonAuth__["a" /* default */], {
    mobile: true,
    onOpenMenu: handleOpenMenu,
    user: user,
    isLoadingUser: isLoading,
    refetchUser: refetch
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("dialog", {
    ref: dialogRef,
    className: "comp_header_menu_container",
    tabIndex: "-1",
    id: "comp_header_menu_modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header_menu_head"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/",
    className: "logo"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_index__["h" /* SegurosPromoIcon */], null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__trigger_auth_buttonAuth_ButtonAuth__["a" /* default */], {
    mobile: true,
    close: true,
    onOpenMenu: handleCloseMenu,
    user: user,
    isLoadingUser: isLoading,
    refetchUser: refetch
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header_menu_content"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "comp_header_menu_content_wrapper",
    id: "mobile-auth-content"
  }, user ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__trigger_auth_headerNav_HeaderNav__["a" /* default */], {
    baseURL: "https://dev.segurospromo.com.br",
    isAuthenticated: true,
    isMobile: true,
    user: user
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__trigger_auth_alertTrigger_AlertTrigger__["a" /* default */], {
    baseURL: "https://dev.segurospromo.com.br" || '',
    authURL: "https://dev.safearea.api.segurospromo.com.br/api" || '',
    refetchUser: refetch
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/atendimento/",
    "class": "link"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__assets_icons_index__["f" /* Help */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Ajuda"))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Header));

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_initialName__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleLoginButton__ = __webpack_require__(112);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var ButtonAuth = function ButtonAuth(_ref) {
  var mobile = _ref.mobile,
    onOpenMenu = _ref.onOpenMenu,
    close = _ref.close,
    user = _ref.user,
    isLoadingUser = _ref.isLoadingUser,
    refetchUser = _ref.refetchUser;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalOpen = _useState4[0],
    setModalOpen = _useState4[1];
  var dropdownRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [modalOpen]);
  var openMobileModal = function openMobileModal() {
    setModalOpen(true);
    if (onOpenMenu) {
      onOpenMenu();
    }
  };
  var setRedirectLink = function setRedirectLink(type) {
    var currentURL = window.location.href;
    var baseURL = "".concat("https://dev.segurospromo.com.br", "/area-do-cliente/");
    window.location.href = "".concat(baseURL).concat(type, "?redirect=").concat(encodeURIComponent(currentURL));
  };
  var renderDropdown = function renderDropdown() {
    if (isLoadingUser) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "loading"
      }, "Carregando...");
    }
    if (!user) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "container_alert_description"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        className: "text_description"
      }, "Garanta descontos exclusivos e encontre os menores pre\xE7os do mercado!")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "container_auth_social"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GoogleLoginButton__["a" /* default */], {
        label: "Acessar com o Google",
        refetchUser: refetchUser
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: "button_email",
        onClick: function onClick() {
          return setRedirectLink('login');
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["d" /* EmailIcon */], null), "Acessar com e-mail"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        className: "close_link",
        onClick: function onClick() {
          return setDropdownOpen(false);
        }
      }, "Continuar sem benef\xEDcios"));
    }
    var initials = Object(__WEBPACK_IMPORTED_MODULE_1__utils_initialName__["a" /* getUserInitials */])(user.name || '');
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "logged_in_header"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "avatar_user_large"
    }, initials), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "logged_in_header_text"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ol\xE1, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, user.name || ''), "!"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
      className: "nav_menu"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: "nav_menu_items"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "items"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "".concat("https://dev.segurospromo.com.br", "/area-do-cliente/meu-perfil"),
      className: "dropdown_item"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["j" /* UserIcon */], {
      size: 24,
      color: "#007E47"
    }), "Ver minha conta")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
      className: "items"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
      href: "".concat("https://dev.segurospromo.com.br", "/area-do-cliente/meus-pedidos"),
      className: "dropdown_item"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["a" /* CartIcon */], {
      size: 24,
      color: "#007E47"
    }), "Meus pedidos")))));
  };
  if (isLoadingUser) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      type: "button",
      className: "btn-out",
      disabled: true
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Carregando..."));
  }
  var nameInitial = user ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_initialName__["a" /* getUserInitials */])(user.name) : '';
  if (mobile) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      type: "button",
      className: "comp_header_menu",
      onClick: openMobileModal
    }, close ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["c" /* CloseIcon */], {
      color: "#2E2E2E"
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["g" /* MenuIcon */], {
      color: "#373737"
    }), user ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "avatar_user_small"
    }, nameInitial) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["i" /* UserAnimationIcon */], {
      color: "#2E2E2E"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: close ? 'badge-mobile-close' : 'badge-mobile',
      id: "mobile-cart-badge"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "badge-number"
    }, "1"))), !user && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "tooltip-container visible"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "tooltip-text"
    }, "Acesse ou crie sua conta")));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "login-trigger-container",
    ref: dropdownRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    type: "button",
    className: "btn-out",
    onClick: function onClick() {
      return setDropdownOpen(!dropdownOpen);
    }
  }, user ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "avatar_user_small"
  }, nameInitial) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["i" /* UserAnimationIcon */], {
    color: "#2E2E2E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "badge",
    id: "cart-badge"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "badge-number"
  }, "1"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    id: "login-btn-text"
  }, user ? user.name.split(' ')[0] : 'Entrar')), dropdownOpen && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "login-dropdown show"
  }, renderDropdown()));
};
/* harmony default export */ __webpack_exports__["a"] = (ButtonAuth);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SegurosPromoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var SegurosPromoIcon = function SegurosPromoIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 44 : _ref$size;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 199 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    id: "marca-aplicacoes-segurospromo_sp-monocromatica-horizontal-branco copy"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path",
    d: "M34.2943 26.2209L20.6767 12.6058L0 12.5811L13.6397 26.2209H34.2943Z",
    fill: "#2D6D44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_2",
    d: "M30.0777 5.92505C26.6697 2.45486 22.0101 0.5 17.1463 0.5C12.2825 0.5 7.62286 2.45486 4.21494 5.92505C2.34725 7.81615 0.90956 10.088 0 12.5854H34.2926C33.383 10.088 31.9454 7.81615 30.0777 5.92505Z",
    fill: "#79A53D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_3",
    d: "M0 26.2212C0.928964 28.5713 2.36442 30.6879 4.20425 32.4203C11.3522 39.1933 22.942 39.1933 30.09 32.4203C31.9298 30.6879 33.3653 28.5713 34.2943 26.2212L0 26.2212Z",
    fill: "#79A53D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_4",
    d: "M52.7524 22.7238C52.7524 22.0964 53.1577 21.8382 53.6379 21.8382H54.4495C54.9659 21.8382 55.1501 22.2444 55.1139 22.945C55.0399 24.2738 55.3351 25.7498 56.8842 25.7498C58.5082 25.7498 58.9136 24.569 58.9136 23.167C58.9136 21.58 57.4746 20.4733 56.2947 19.6247C54.8919 18.5911 52.8995 16.8208 52.8995 14.4962C52.8995 11.5443 54.3755 9.77313 57.0693 9.77313C59.763 9.77313 61.0942 10.9909 61.0942 14.6064C61.0942 15.2708 60.651 15.492 60.2087 15.492H59.3971C58.8799 15.492 58.6957 15.0866 58.7327 14.3852C58.8067 13.2415 58.6587 11.9497 57.0725 11.9497C55.8178 11.9497 55.1534 12.8353 55.1534 14.164C55.1534 15.64 56.113 16.6358 57.1095 17.3709C58.6554 18.5179 61.165 20.3968 61.165 22.9458C61.165 25.2704 60.3896 27.9271 56.8842 27.9271C54.2283 27.9263 52.7524 26.3763 52.7524 22.7238Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M68.1015 9.77332C64.301 9.77332 63.4894 13.4628 63.4894 18.8503C63.4894 24.237 64.264 27.9265 68.0629 27.9248C70.8668 27.9248 72.0846 26.2293 72.0846 22.909C72.0846 22.2446 71.6414 22.0234 71.199 22.0234H70.5716C70.0552 22.0234 69.8702 22.4288 69.9072 23.1302C69.9451 23.9048 69.834 25.7499 68.1361 25.7499C66.3674 25.7499 65.9982 23.7576 65.9982 19.1085H71.902C72.0519 18.1063 72.1382 17.0957 72.1602 16.0826C72.1602 11.3965 70.9055 9.77332 68.1015 9.77332ZM69.9091 15.3821C69.9091 16.1936 69.8721 16.71 69.8359 17.1524H66.0338C66.0338 13.3889 66.5872 11.9499 68.1001 11.9499C69.6509 11.9499 69.9091 13.3527 69.9091 15.3821Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M83.6168 9.89462C82.9943 9.89462 82.2781 10.2638 81.7593 10.971C81.4828 10.6993 81.1695 10.4679 80.8285 10.2836C80.7989 10.2688 80.7681 10.253 80.7358 10.2366L80.7358 10.2366C80.3737 10.0515 79.835 9.77621 78.8345 9.77621C76.2961 9.77621 74.6286 11.6979 74.6286 15.8314C74.6286 18.4421 75.3176 20.182 76.4376 21.089C75.7123 21.6686 75.3144 22.4662 75.3144 23.5903C75.3144 24.642 75.677 25.3672 76.2928 25.9831C74.9517 26.9262 74.2265 28.5938 74.2265 30.3707C74.2265 33.1261 75.9302 35.4827 79.1206 35.4827C82.311 35.4827 84.0156 33.1261 84.0156 30.3707C84.0156 27.6153 82.3118 25.1493 79.1206 25.1493C78.8293 25.1538 78.5386 25.1783 78.2507 25.2225C77.8157 24.9322 77.5624 24.4241 77.5624 23.5903C77.5624 22.6858 77.9604 22.1036 78.4669 21.8504C78.5212 21.8504 78.5847 21.8594 78.6482 21.8685L78.6483 21.8685C78.7118 21.8775 78.7753 21.8865 78.8295 21.8865C81.3671 21.8865 83.0354 19.9649 83.0354 15.8314C83.0354 14.4228 82.843 13.2873 82.4977 12.3927C82.6989 12.3538 82.9029 12.3315 83.1078 12.3261C83.3972 12.3261 83.5789 12.3622 83.9054 12.544C84.0432 12.6408 84.2081 12.6915 84.3765 12.6887C84.7392 12.6887 84.9201 12.4716 84.9201 12.109V11.0187C84.9217 10.2572 84.3782 9.89462 83.6168 9.89462ZM79.1203 27.3947C80.9293 27.3947 81.768 28.7004 81.768 30.368C81.768 32.0355 80.9334 33.3413 79.1203 33.3413C77.3072 33.3413 76.4743 32.0355 76.4743 30.368C76.4743 28.7004 77.3081 27.3947 79.1203 27.3947ZM76.8734 15.8287C76.8734 18.1853 77.2689 19.9623 78.8312 19.9623C80.3179 19.9623 80.7891 18.1853 80.7891 15.8287C80.7891 13.4721 80.3179 11.6952 78.8312 11.6952C77.2722 11.6952 76.8734 13.4721 76.8734 15.8287Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_5",
    d: "M86.2554 23.9052V10.6946C86.249 10.5068 86.3207 10.3248 86.4534 10.1918C86.5862 10.0589 86.7682 9.98697 86.956 9.99323H88.0644C88.2522 9.98697 88.4342 10.0589 88.567 10.1918C88.6998 10.3248 88.7715 10.5068 88.765 10.6946V23.9052C88.765 24.9741 89.1712 25.6023 90.315 25.6023C90.9794 25.6023 91.9751 25.3441 92.7497 24.9379V10.6946C92.7432 10.5067 92.815 10.3245 92.948 10.1915C93.081 10.0585 93.2632 9.98674 93.4511 9.99323H94.5603C94.7483 9.98674 94.9305 10.0585 95.0634 10.1915C95.1964 10.3245 95.2682 10.5067 95.2617 10.6946V25.1583C95.2617 26.0069 95.5569 26.3391 96.1843 26.3391V26.7814C96.1843 27.2978 95.6671 27.9252 94.3753 27.9252C93.6739 27.9252 93.1205 27.63 92.8952 26.7814C92.0097 27.4458 90.8289 27.9252 89.6481 27.9252C87.7676 27.9269 86.2554 26.8933 86.2554 23.9052Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_6",
    d: "M98.8741 27.0044V10.6947C98.8676 10.5069 98.9393 10.3249 99.0721 10.1919C99.2049 10.059 99.3868 9.98706 99.5746 9.99332H100.681C100.87 9.98613 101.053 10.0576 101.186 10.1907C101.32 10.3237 101.392 10.5063 101.385 10.6947V11.1741C102.418 10.2145 103.489 9.99332 103.934 9.99332C104.709 9.99332 105.263 10.3625 105.263 11.1371V12.2439C105.263 12.6131 105.078 12.8343 104.709 12.8343C104.538 12.8318 104.372 12.7807 104.229 12.6871C103.901 12.5021 103.713 12.4659 103.418 12.4659C102.311 12.4659 101.389 13.1664 101.389 13.1664V27.0044C101.395 27.1923 101.323 27.3745 101.19 27.5075C101.057 27.6404 100.875 27.7123 100.687 27.7058H99.5763C99.3882 27.7125 99.2058 27.6408 99.0726 27.5078C98.9395 27.3748 98.8676 27.1924 98.8741 27.0044Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M111.087 9.77332C108.209 9.77332 106.585 11.8397 106.585 18.8503C106.585 25.8601 108.21 27.9265 111.088 27.9265C113.966 27.9265 115.588 25.861 115.588 18.8503C115.588 11.8397 113.965 9.77332 111.087 9.77332ZM111.089 11.9869C112.232 11.9869 113.081 12.3931 113.081 18.8503H113.079C113.079 25.3068 112.232 25.713 111.089 25.713C109.945 25.713 109.096 25.3076 109.096 18.8503C109.096 12.3931 109.945 11.9869 111.089 11.9869Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_7",
    d: "M117.913 22.7238C117.913 22.0964 118.318 21.8382 118.798 21.8382H119.61C120.127 21.8382 120.311 22.2444 120.274 22.945C120.201 24.2738 120.495 25.7498 122.045 25.7498C123.668 25.7498 124.074 24.569 124.074 23.167C124.074 21.5801 122.635 20.4733 121.455 19.6247C120.057 18.5911 118.06 16.8208 118.06 14.4962C118.06 11.5443 119.54 9.77313 122.229 9.77313C124.918 9.77313 126.252 10.9909 126.252 14.6064C126.252 15.2708 125.808 15.492 125.366 15.492H124.555C124.037 15.492 123.853 15.0866 123.89 14.3852C123.963 13.2415 123.816 11.9497 122.229 11.9497C120.975 11.9497 120.311 12.8353 120.311 14.164C120.311 15.64 121.27 16.6358 122.266 17.3709C123.816 18.5146 126.325 20.396 126.325 22.9417C126.325 25.2663 125.55 27.923 122.049 27.923C119.393 27.9263 117.913 26.3763 117.913 22.7238Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape_4",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M133.521 26.5982C133.852 27.2988 134.738 27.8892 136.14 27.8892C139.277 27.8892 140.937 25.3796 140.937 18.8484C140.937 12.3171 139.277 9.80838 136.14 9.80838C134.849 9.80838 133.705 10.3248 133.262 11.2843C132.856 10.2878 132.008 9.99257 130.974 9.99257H129.683C129.495 9.98607 129.313 10.0579 129.18 10.1909C129.047 10.3238 128.975 10.506 128.982 10.694V34.9738C128.976 35.1616 129.048 35.3436 129.181 35.4764C129.313 35.6092 129.496 35.6809 129.683 35.6744H132.819C133.007 35.6806 133.189 35.6089 133.322 35.4761C133.455 35.3434 133.527 35.1616 133.521 34.9738V26.5982ZM133.522 13.4283C133.852 13.2568 134.219 13.1681 134.591 13.1701V13.1668C135.66 13.1668 136.398 13.647 136.4 18.8495C136.4 24.0882 135.659 24.5314 134.591 24.5314C134.219 24.5333 133.852 24.4447 133.522 24.2732V13.4283Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_8",
    d: "M150.716 14.718C150.531 14.7012 150.353 14.6375 150.199 14.533C149.942 14.3827 149.648 14.3062 149.35 14.3118C148.243 14.3118 147.357 15.0132 147.357 15.0132V27.0043C147.364 27.1921 147.292 27.3741 147.159 27.5071C147.027 27.64 146.845 27.7119 146.657 27.7057H143.521C143.333 27.7122 143.151 27.6404 143.018 27.5074C142.885 27.3744 142.813 27.1922 142.819 27.0043V10.6946C142.813 10.5067 142.885 10.3245 143.018 10.1915C143.151 10.0585 143.333 9.98674 143.521 9.99323H144.849C145.881 9.99323 146.62 10.5466 146.878 11.4322C147.727 10.5096 148.796 9.99323 149.904 9.99323C150.679 9.99323 151.232 10.3624 151.232 11.137V14.0889C151.232 14.4598 151.084 14.718 150.716 14.718Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape_5",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M151.971 18.8503C151.971 25.8601 154.59 27.9265 157.948 27.9265C161.342 27.9265 163.925 25.861 163.925 18.8503C163.925 11.8397 161.342 9.77332 157.948 9.77332C154.59 9.77332 151.971 11.8405 151.971 18.8503ZM156.509 18.8536C156.509 13.6141 156.988 13.2079 157.948 13.2079V13.2046C158.906 13.2046 159.386 13.615 159.386 18.8536C159.386 24.0923 158.907 24.4985 157.948 24.4985C156.988 24.4985 156.509 24.0931 156.509 18.8536Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Path_9",
    d: "M184.439 27.7053H181.303C181.115 27.7115 180.933 27.6396 180.8 27.5067C180.667 27.3737 180.596 27.1917 180.602 27.0039V14.4964C180.602 13.5738 180.233 13.2046 179.458 13.2046C178.855 13.2246 178.263 13.3759 177.723 13.6478V27.0039C177.73 27.1917 177.658 27.3737 177.525 27.5067C177.393 27.6396 177.211 27.7115 177.023 27.7053H173.887C173.699 27.7118 173.517 27.64 173.384 27.507C173.251 27.374 173.179 27.1918 173.185 27.0039V14.4964C173.185 13.5738 172.816 13.2046 172.042 13.2046C171.438 13.2247 170.846 13.3759 170.307 13.6478V27.0039C170.314 27.1917 170.242 27.3737 170.109 27.5067C169.977 27.6396 169.795 27.7115 169.607 27.7053H166.47C166.282 27.7115 166.1 27.6396 165.967 27.5067C165.835 27.3737 165.763 27.1917 165.769 27.0039V10.6942C165.763 10.5064 165.835 10.3244 165.967 10.1914C166.1 10.0585 166.282 9.98658 166.47 9.99284H168.279C169.165 9.99284 169.939 10.399 170.198 11.2476C171.143 10.293 172.433 9.76072 173.777 9.77165C175.438 9.77165 176.507 10.399 177.098 11.4688C178.13 10.5092 179.385 9.77165 181.193 9.77165C183.886 9.77165 185.14 11.3948 185.14 14.3837V27.0039C185.147 27.1918 185.075 27.374 184.942 27.507C184.809 27.64 184.627 27.7118 184.439 27.7053Z",
    fill: "#636363"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    id: "Shape_6",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M186.95 18.8503C186.95 25.8601 189.569 27.9265 192.927 27.9265C196.322 27.9265 198.904 25.861 198.904 18.8503C198.904 11.8397 196.322 9.77332 192.927 9.77332C189.569 9.77332 186.95 11.8405 186.95 18.8503ZM191.488 18.8536C191.488 13.6141 191.967 13.2079 192.927 13.2079V13.2046C193.89 13.2046 194.366 13.615 194.366 18.8536C194.366 24.0923 193.886 24.4985 192.927 24.4985C191.967 24.4985 191.488 24.0931 191.488 18.8536Z",
    fill: "#636363"
  })));
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Help; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var Help = function Help(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M13.0061 17.0397C12.8072 17.2389 12.5635 17.3385 12.275 17.3385C11.9865 17.3385 11.7426 17.2391 11.5433 17.0402C11.3441 16.8414 11.2445 16.5977 11.2445 16.3091C11.2445 16.0206 11.3439 15.7767 11.5428 15.5775C11.7417 15.3782 11.9854 15.2786 12.2739 15.2786C12.5624 15.2786 12.8063 15.3781 13.0056 15.5769C13.2048 15.7758 13.3044 16.0195 13.3044 16.308C13.3044 16.5966 13.205 16.8404 13.0061 17.0397Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12.9294 14.0122H11.5069C11.5069 13.2944 11.5944 12.7574 11.7693 12.4012C11.9442 12.0449 12.3633 11.5675 13.0266 10.9689C13.3298 10.7033 13.5791 10.428 13.7748 10.143C13.9704 9.858 14.0682 9.54383 14.0682 9.20052C14.0682 8.80796 13.9254 8.44812 13.6397 8.121C13.354 7.79386 12.9126 7.63028 12.3153 7.63028C11.7285 7.63028 11.286 7.78932 10.988 8.10738C10.6901 8.42543 10.4795 8.75222 10.3564 9.08777L9.05835 8.56697C9.29414 7.95678 9.6883 7.42659 10.2408 6.9764C10.7934 6.52619 11.4914 6.30109 12.3348 6.30109C13.1885 6.30109 13.928 6.54562 14.5531 7.03468C15.1782 7.52376 15.4907 8.20319 15.4907 9.07297C15.4907 9.58552 15.3725 10.03 15.136 10.4063C14.8996 10.7827 14.5592 11.1931 14.1148 11.6374C13.6031 12.1285 13.2808 12.5226 13.148 12.8199C13.0152 13.1173 12.9424 13.5147 12.9294 14.0122Z",
    fill: "#2E2E2E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.3112 1.75145C6.83671 1.75145 2.39873 6.18943 2.39873 11.664C2.39873 17.1385 6.83671 21.5765 12.3112 21.5765C17.7858 21.5765 22.2237 17.1385 22.2237 11.664C22.2237 6.18943 17.7858 1.75145 12.3112 1.75145ZM1.19873 11.664C1.19873 5.52669 6.17397 0.551453 12.3112 0.551453C18.4485 0.551453 23.4237 5.52669 23.4237 11.664C23.4237 17.8012 18.4485 22.7765 12.3112 22.7765C6.17397 22.7765 1.19873 17.8012 1.19873 11.664Z",
    fill: "#2E2E2E"
  }));
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CartIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var CartIcon = function CartIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.54975 3.00659H1.05029V2.00659H3.22128L5.83087 8.39025C5.85294 8.44424 5.90547 8.47951 5.9638 8.47951H11.1762C11.228 8.47951 11.2758 8.45162 11.3013 8.40653L13.4564 4.59086H6.34637V3.59086H15.1697L12.172 8.89832C11.9691 9.25744 11.5887 9.47951 11.1762 9.47951H5.9638C5.49932 9.47951 5.08098 9.19858 4.90523 8.76864L2.54975 3.00659Z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.81178 11.0042L4.94639 8.6702L5.84575 9.10739L4.71114 11.4414C4.66478 11.5368 4.73424 11.6478 4.84029 11.6478H13.2722V12.6478H4.84029C3.99573 12.6478 3.44254 11.7638 3.81178 11.0042Z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M6.61235 14.0981C6.61235 14.6606 6.15636 15.1166 5.59387 15.1166C5.03139 15.1166 4.5754 14.6606 4.5754 14.0981C4.5754 13.5356 5.03139 13.0796 5.59387 13.0796C6.15636 13.0796 6.61235 13.5356 6.61235 14.0981Z",
    fill: "#007E47"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12.5116 14.0981C12.5116 14.6606 12.0556 15.1166 11.4931 15.1166C10.9306 15.1166 10.4746 14.6606 10.4746 14.0981C10.4746 13.5356 10.9306 13.0796 11.4931 13.0796C12.0556 13.0796 12.5116 13.5356 12.5116 14.0981Z",
    fill: "#007E47"
  }));
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var UserIcon = function UserIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99982 1.59497C6.5723 1.59497 5.41507 2.7522 5.41507 4.17972C5.41507 5.60724 6.5723 6.76447 7.99982 6.76447C9.42734 6.76447 10.5846 5.60724 10.5846 4.17972C10.5846 2.7522 9.42734 1.59497 7.99982 1.59497ZM4.41507 4.17972C4.41507 2.19992 6.02002 0.594971 7.99982 0.594971C9.97962 0.594971 11.5846 2.19992 11.5846 4.17972C11.5846 6.15952 9.97962 7.76447 7.99982 7.76447C6.02002 7.76447 4.41507 6.15952 4.41507 4.17972Z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.55034 9.3939C5.02741 9.3939 2.98218 11.4391 2.98218 13.9621C2.98218 14.0358 3.04196 14.0956 3.1157 14.0956H12.8845C12.9582 14.0956 13.018 14.0358 13.018 13.9621C13.018 11.4391 10.9728 9.3939 8.44984 9.3939H7.55034ZM1.98218 13.9621C1.98218 10.8869 4.47513 8.3939 7.55034 8.3939H8.44984C11.525 8.3939 14.018 10.8869 14.018 13.9621C14.018 14.5881 13.5105 15.0956 12.8845 15.0956H3.1157C2.48967 15.0956 1.98218 14.5881 1.98218 13.9621Z"
  }));
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var GoogleIcon = function GoogleIcon() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    "clip-path": "url(#clip0_1369_34832)"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M23.447 9.91355L13.6577 9.91309C13.2254 9.91309 12.875 10.2634 12.875 10.6957V13.823C12.875 14.2552 13.2254 14.6056 13.6576 14.6056H19.1704C18.5667 16.1722 17.4401 17.4842 16.0026 18.3178L18.3532 22.387C22.124 20.2062 24.3532 16.3799 24.3532 12.0965C24.3532 11.4866 24.3083 11.0506 24.2184 10.5597C24.15 10.1867 23.8262 9.91355 23.447 9.91355Z",
    fill: "#167EE6"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12.3518 19.3043C9.65398 19.3043 7.2988 17.8303 6.03387 15.649L1.96484 17.9944C4.03555 21.5832 7.91464 24 12.3518 24C14.5286 24 16.5825 23.4139 18.3518 22.3925V22.387L16.0012 18.3177C14.926 18.9414 13.6817 19.3043 12.3518 19.3043Z",
    fill: "#12B347"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M18.3516 22.3925V22.387L16.0009 18.3177C14.9257 18.9413 13.6815 19.3043 12.3516 19.3043V24C14.5283 24 16.5823 23.4139 18.3516 22.3925Z",
    fill: "#0F993E"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M5.04722 12C5.04722 10.6702 5.41013 9.42607 6.03361 8.3509L1.96458 6.00555C0.937594 7.76932 0.351562 9.81766 0.351562 12C0.351562 14.1823 0.937594 16.2306 1.96458 17.9944L6.03361 15.6491C5.41013 14.5739 5.04722 13.3298 5.04722 12Z",
    fill: "#FFD500"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12.3518 4.69566C14.1111 4.69566 15.7271 5.32078 16.9893 6.36061C17.3007 6.61711 17.7532 6.59859 18.0385 6.31336L20.2542 4.09758C20.5779 3.77395 20.5548 3.24422 20.2091 2.94431C18.0943 1.10967 15.3428 0 12.3518 0C7.91464 0 4.03555 2.41673 1.96484 6.00558L6.03387 8.35092C7.2988 6.16969 9.65398 4.69566 12.3518 4.69566Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M16.989 6.36061C17.3004 6.61711 17.753 6.59859 18.0382 6.31336L20.254 4.09758C20.5776 3.77395 20.5545 3.24422 20.2088 2.94431C18.0941 1.10963 15.3425 0 12.3516 0V4.69566C14.1108 4.69566 15.7268 5.32078 16.989 6.36061Z",
    fill: "#D93F21"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath", {
    id: "clip0_1369_34832"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white",
    transform: "translate(0.351562)"
  }))));
};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var EmailIcon = function EmailIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92924 3.8007L8 8.05014L14.0708 3.8007C13.9684 3.46364 13.6532 3.21542 13.2846 3.21542H2.71543C2.34678 3.21542 2.03159 3.46364 1.92924 3.8007ZM14.1057 4.99688L8.28673 9.07008C8.11457 9.19059 7.88543 9.19059 7.71327 9.07008L1.89429 4.99688V11.9634C1.89429 12.4139 2.26494 12.7846 2.71543 12.7846H13.2846C13.7351 12.7846 14.1057 12.4139 14.1057 11.9634V4.99688ZM0.894287 4.03657C0.894287 3.0338 1.71266 2.21542 2.71543 2.21542H13.2846C14.2873 2.21542 15.1057 3.03379 15.1057 4.03657V11.9634C15.1057 12.9662 14.2873 13.7846 13.2846 13.7846H2.71543C1.71266 13.7846 0.894287 12.9662 0.894287 11.9634V4.03657Z"
  }));
};

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var MenuIcon = function MenuIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 28 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "line-one",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.72819C0 7.28344 0.359451 6.9229 0.802857 6.9229H21.4129C21.8563 6.9229 22.2158 7.28344 22.2158 7.72819C22.2158 8.17295 21.8563 8.53349 21.4129 8.53349H0.802857C0.359451 8.53349 0 8.17295 0 7.72819Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "line-two",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.0419C0 13.5971 0.359451 13.2366 0.802857 13.2366H21.4129C21.8563 13.2366 22.2158 13.5971 22.2158 14.0419C22.2158 14.4866 21.8563 14.8472 21.4129 14.8472H0.802857C0.359451 14.8472 0 14.4866 0 14.0419Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "line-three",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.3552C0 19.9105 0.359451 19.5499 0.802857 19.5499H21.4129C21.8563 19.5499 22.2158 19.9105 22.2158 20.3552C22.2158 20.8 21.8563 21.1605 21.4129 21.1605H0.802857C0.359451 21.1605 0 20.8 0 20.3552Z",
    fill: color
  }));
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAnimationIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var UserAnimationIcon = function UserAnimationIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 22 : _ref$size,
    color = _ref.color;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    id: "default-avatar",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "head-user",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 2.19308C9.03688 2.19308 7.44569 3.78428 7.44569 5.74712C7.44569 7.70996 9.03688 9.30115 10.9997 9.30115C12.9626 9.30115 14.5538 7.70996 14.5538 5.74712C14.5538 3.78428 12.9626 2.19308 10.9997 2.19308ZM6.07069 5.74712C6.07069 3.02489 8.27749 0.818085 10.9997 0.818085C13.7219 0.818085 15.9288 3.02489 15.9288 5.74712C15.9288 8.46935 13.7219 10.6761 10.9997 10.6761C8.27749 10.6761 6.07069 8.46935 6.07069 5.74712Z",
    fill: color
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "body-user",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3817 12.9166C6.91266 12.9166 4.10046 15.7288 4.10046 19.1978C4.10046 19.2992 4.18266 19.3814 4.28405 19.3814H17.7161C17.8175 19.3814 17.8997 19.2992 17.8997 19.1978C17.8997 15.7288 15.0875 12.9166 11.6185 12.9166H10.3817ZM2.72546 19.1978C2.72546 14.9694 6.15327 11.5416 10.3817 11.5416H11.6185C15.8469 11.5416 19.2747 14.9694 19.2747 19.1978C19.2747 20.0586 18.5769 20.7564 17.7161 20.7564H4.28405C3.42327 20.7564 2.72546 20.0586 2.72546 19.1978Z",
    fill: color
  }));
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var GOOGLE_SCRIPT_URL = 'https://accounts.google.com/gsi/client';
function useGoogleLogin(_ref) {
  var clientId = _ref.clientId,
    onSuccess = _ref.onSuccess,
    onError = _ref.onError;
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    scriptLoaded = _useState2[0],
    setScriptLoaded = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState4 = _slicedToArray(_useState3, 2),
    codeClient = _useState4[0],
    setCodeClient = _useState4[1];
  var onSuccessRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(onSuccess);
  var onErrorRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(onError);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    onSuccessRef.current = onSuccess;
    onErrorRef.current = onError;
  }, [onSuccess, onError]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (window.google && window.google.accounts && window.google.accounts.oauth2) {
      setScriptLoaded(true);
      return;
    }
    var script = document.createElement('script');
    script.src = GOOGLE_SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.onload = function () {
      return setScriptLoaded(true);
    };
    script.onerror = function () {
      if (onErrorRef.current) {
        onErrorRef.current(new Error('Falha ao carregar script do Google'));
      }
    };
    document.body.appendChild(script);
  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!scriptLoaded) return;
    var client = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      scope: 'openid email profile',
      ux_mode: 'popup',
      callback: function callback(response) {
        if (response.code) {
          if (onSuccessRef.current) onSuccessRef.current(response.code);
        } else {
          if (onErrorRef.current) {
            onErrorRef.current(new Error('Código de autorização não retornado pelo Google'));
          }
        }
      },
      error_callback: function error_callback(error) {
        if (onErrorRef.current) onErrorRef.current(error);
      }
    });
    setCodeClient(client);
  }, [scriptLoaded, clientId]);
  var login = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    if (!codeClient) return;
    codeClient.requestCode();
  }, [codeClient]);
  return {
    login: login,
    isReady: scriptLoaded
  };
}
/* harmony default export */ __webpack_exports__["a"] = (useGoogleLogin);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AltchaWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_altcha__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_altcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_altcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_altcha_dist_i18n_pt_br_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_altcha_dist_i18n_pt_br_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_altcha_dist_i18n_pt_br_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



var AltchaWidget = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (_ref, ref) {
  var onPayloadChange = _ref.onPayloadChange,
    onVerifyingChange = _ref.onVerifyingChange;
  var widgetRef = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"])(ref, function () {
    return {
      reset: function reset() {
        if (widgetRef.current) widgetRef.current.reset();
        onPayloadChange(null);
      },
      verify: function () {
        var _verify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var widget, result;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                widget = widgetRef.current;
                if (widget) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2, null);
              case 1:
                widget.show();
                _context.n = 2;
                return widget.verify();
              case 2:
                result = _context.v;
                return _context.a(2, result && result.payload || null);
            }
          }, _callee);
        }));
        function verify() {
          return _verify.apply(this, arguments);
        }
        return verify;
      }()
    };
  });
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    var widget = widgetRef.current;
    if (!widget) return;
    var handleStateChange = function handleStateChange(ev) {
      var _ev$detail = ev.detail,
        state = _ev$detail.state,
        payload = _ev$detail.payload;
      onPayloadChange(state === 'verified' && payload ? payload : null);
      if (onVerifyingChange) onVerifyingChange(state === 'verifying');
    };
    widget.addEventListener('statechange', handleStateChange);
    return function () {
      return widget.removeEventListener('statechange', handleStateChange);
    };
  }, [onPayloadChange, onVerifyingChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("altcha-widget", {
    ref: widgetRef,
    challenge: "https://captcha.amopromo.com/v1/challenge?apiKey=key_1k2qfddj00ta1tdufp9",
    language: "pt-br",
    display: "bar",
    configuration: JSON.stringify({
      minDuration: 500
    })
  });
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

var _globalThis$document, _Batch, _globalThis$window;
function _superPropGet(t, o, e, r) { var p = _get2(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get2() { return _get2 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get2.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var DEV = false;
var is_array = Array.isArray;
var index_of = Array.prototype.indexOf;
var includes = Array.prototype.includes;
var array_from = Array.from;
var object_keys = Object.keys;
var define_property = Object.defineProperty;
var get_descriptor = Object.getOwnPropertyDescriptor;
var get_descriptors = Object.getOwnPropertyDescriptors;
var object_prototype = Object.prototype;
var array_prototype = Array.prototype;
var get_prototype_of = Object.getPrototypeOf;
var is_extensible = Object.isExtensible;
var noop = function noop() {};
function run_all(arr) {
  for (var i = 0; i < arr.length; i++) {
    arr[i]();
  }
}
function deferred() {
  var resolve;
  var reject;
  var promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}
var DERIVED = 1 << 1;
var EFFECT = 1 << 2;
var RENDER_EFFECT = 1 << 3;
var MANAGED_EFFECT = 1 << 24;
var BLOCK_EFFECT = 1 << 4;
var BRANCH_EFFECT = 1 << 5;
var ROOT_EFFECT = 1 << 6;
var BOUNDARY_EFFECT = 1 << 7;
var PAUSED = 1 << 8;
var CONNECTED = 1 << 9;
var CLEAN = 1 << 10;
var DIRTY = 1 << 11;
var MAYBE_DIRTY = 1 << 12;
var INERT = 1 << 13;
var DESTROYED = 1 << 14;
var REACTION_RAN = 1 << 15;
var DESTROYING = 1 << 25;
var EFFECT_TRANSPARENT = 1 << 16;
var EAGER_EFFECT = 1 << 17;
var HEAD_EFFECT = 1 << 18;
var EFFECT_PRESERVED = 1 << 19;
var USER_EFFECT = 1 << 20;
var WAS_MARKED = 1 << 16;
var REACTION_IS_UPDATING = 1 << 21;
var ASYNC = 1 << 22;
var ERROR_VALUE = 1 << 23;
var STATE_SYMBOL = /* @__PURE__ */Symbol("$state");
var COMPONENT_SYMBOL = /* @__PURE__ */Symbol("component");
var LEGACY_PROPS = /* @__PURE__ */Symbol("legacy props");
var LOADING_ATTR_SYMBOL = /* @__PURE__ */Symbol("");
var ATTRIBUTES_CACHE = /* @__PURE__ */Symbol("attributes");
var CLASS_CACHE = /* @__PURE__ */Symbol("class");
var STYLE_CACHE = /* @__PURE__ */Symbol("style");
var TEXT_CACHE = /* @__PURE__ */Symbol("text");
var FORM_RESET_HANDLER = /* @__PURE__ */Symbol("form reset");
var STALE_REACTION = new (/*#__PURE__*/function (_Error) {
  function StaleReactionError() {
    var _this;
    _classCallCheck(this, StaleReactionError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StaleReactionError, [].concat(args));
    _defineProperty(_this, "name", "StaleReactionError");
    _defineProperty(_this, "message", "The reaction that called `getAbortSignal()` was re-run or destroyed");
    return _this;
  }
  _inherits(StaleReactionError, _Error);
  return _createClass(StaleReactionError);
}(/*#__PURE__*/_wrapNativeSuper(Error)))();
var IS_XHTML =
// We gotta write it like this because after downleveling the pure comment may end up in the wrong location
!!((_globalThis$document = globalThis.document) !== null && _globalThis$document !== void 0 && _globalThis$document.contentType) && /* @__PURE__ */globalThis.document.contentType.includes("xml");
var TEXT_NODE = 3;
var COMMENT_NODE = 8;
function equals(value) {
  return value === this.v;
}
function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a !== null && _typeof(a) === "object" || typeof a === "function";
}
function safe_equals(value) {
  return !safe_not_equal(value, this.v);
}
function lifecycle_outside_component(name) {
  {
    throw new Error("https://svelte.dev/e/lifecycle_outside_component");
  }
}
function async_derived_orphan() {
  {
    throw new Error("https://svelte.dev/e/async_derived_orphan");
  }
}
function effect_in_teardown(rune) {
  {
    throw new Error("https://svelte.dev/e/effect_in_teardown");
  }
}
function effect_in_unowned_derived() {
  {
    throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
  }
}
function effect_orphan(rune) {
  {
    throw new Error("https://svelte.dev/e/effect_orphan");
  }
}
function effect_update_depth_exceeded() {
  {
    throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
  }
}
function hydration_failed() {
  {
    throw new Error("https://svelte.dev/e/hydration_failed");
  }
}
function state_descriptors_fixed() {
  {
    throw new Error("https://svelte.dev/e/state_descriptors_fixed");
  }
}
function state_prototype_fixed() {
  {
    throw new Error("https://svelte.dev/e/state_prototype_fixed");
  }
}
function state_unsafe_mutation() {
  {
    throw new Error("https://svelte.dev/e/state_unsafe_mutation");
  }
}
function svelte_boundary_reset_onerror() {
  {
    throw new Error("https://svelte.dev/e/svelte_boundary_reset_onerror");
  }
}
var tracing_mode_flag = false;
var TEMPLATE_FRAGMENT = 1;
var TEMPLATE_USE_IMPORT_NODE = 1 << 1;
var HYDRATION_START = "[";
var HYDRATION_START_ELSE = "[!";
var HYDRATION_START_FAILED = "[?";
var HYDRATION_END = "]";
var HYDRATION_ERROR = {};
var UNINITIALIZED = /* @__PURE__ */Symbol("uninitialized");
var NAMESPACE_HTML = "http://www.w3.org/1999/xhtml";
var NAMESPACE_SVG = "http://www.w3.org/2000/svg";
var NAMESPACE_MATHML = "http://www.w3.org/1998/Math/MathML";
var ATTACHMENT_KEY = "@attach";
var component_context = null;
function set_component_context(context) {
  component_context = context;
}
function push(props) {
  var runes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var fn = arguments.length > 2 ? arguments[2] : undefined;
  component_context = {
    p: component_context,
    i: false,
    c: null,
    e: null,
    s: props,
    x: null,
    r: (/** @type {Effect} */
    active_effect),
    l: null
  };
}
function pop(component2) {
  var context = /** @type {ComponentContext} */
  component_context;
  var effects = context.e;
  if (effects !== null) {
    context.e = null;
    var _iterator = _createForOfIteratorHelper(effects),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var fn = _step.value;
        create_user_effect(fn);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (component2 !== void 0) {
    context.x = component2;
  }
  context.i = true;
  component_context = context.p;
  return mark_as_component(component2);
}
function mark_as_component() {
  var component2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  define_property(component2, COMPONENT_SYMBOL, {
    value: true
  });
  return component2;
}
function is_runes() {
  return true;
}
var micro_tasks = [];
function run_micro_tasks() {
  var tasks = micro_tasks;
  micro_tasks = [];
  run_all(tasks);
}
function queue_micro_task(fn) {
  if (micro_tasks.length === 0 && !is_flushing_sync) {
    var tasks = micro_tasks;
    queueMicrotask(function () {
      if (tasks === micro_tasks) run_micro_tasks();
    });
  }
  micro_tasks.push(fn);
}
function flush_tasks() {
  while (micro_tasks.length > 0) {
    run_micro_tasks();
  }
}
function derived_inert() {
  {
    console.warn("https://svelte.dev/e/derived_inert");
  }
}
function hydration_mismatch(location2) {
  {
    console.warn("https://svelte.dev/e/hydration_mismatch");
  }
}
function select_multiple_invalid_value() {
  {
    console.warn("https://svelte.dev/e/select_multiple_invalid_value");
  }
}
function svelte_boundary_reset_noop() {
  {
    console.warn("https://svelte.dev/e/svelte_boundary_reset_noop");
  }
}
var hydrating = false;
function set_hydrating(value) {
  hydrating = value;
}
var hydrate_node;
function set_hydrate_node(node) {
  if (node === null) {
    hydration_mismatch();
    throw HYDRATION_ERROR;
  }
  return hydrate_node = node;
}
function hydrate_next() {
  return set_hydrate_node(/* @__PURE__ */get_next_sibling(hydrate_node));
}
function reset(node) {
  if (!hydrating) return;
  if (/* @__PURE__ */get_next_sibling(hydrate_node) !== null) {
    hydration_mismatch();
    throw HYDRATION_ERROR;
  }
  hydrate_node = node;
}
function next() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  if (hydrating) {
    var i = count;
    var node = hydrate_node;
    while (i--) {
      node = /** @type {TemplateNode} */
      /* @__PURE__ */get_next_sibling(node);
    }
    hydrate_node = node;
  }
}
function skip_nodes() {
  var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var depth = 0;
  var node = hydrate_node;
  while (true) {
    if (node.nodeType === COMMENT_NODE) {
      var data = /** @type {Comment} */
      node.data;
      if (data === HYDRATION_END) {
        if (depth === 0) return node;
        depth -= 1;
      } else if (data === HYDRATION_START || data === HYDRATION_START_ELSE ||
      // "[1", "[2", etc. for if blocks
      data[0] === "[" && !isNaN(Number(data.slice(1)))) {
        depth += 1;
      }
    }
    var next2 = /** @type {TemplateNode} */
    /* @__PURE__ */get_next_sibling(node);
    if (remove) node.remove();
    node = next2;
  }
}
function read_hydration_instruction(node) {
  if (!node || node.nodeType !== COMMENT_NODE) {
    hydration_mismatch();
    throw HYDRATION_ERROR;
  }
  return /** @type {Comment} */node.data;
}
function proxy(value) {
  if (_typeof(value) !== "object" || value === null || STATE_SYMBOL in value || COMPONENT_SYMBOL in value) {
    return value;
  }
  var prototype = get_prototype_of(value);
  if (prototype !== object_prototype && prototype !== array_prototype) {
    return value;
  }
  var sources = /* @__PURE__ */new Map();
  var is_proxied_array = is_array(value);
  var version = /* @__PURE__ */state(0);
  var parent_version = update_version;
  var with_parent = function with_parent(fn) {
    if (update_version === parent_version) {
      return fn();
    }
    var reaction = active_reaction;
    var version2 = update_version;
    set_active_reaction(null);
    set_update_version(parent_version);
    var result = fn();
    set_active_reaction(reaction);
    set_update_version(version2);
    return result;
  };
  if (is_proxied_array) {
    sources.set("length", /* @__PURE__ */state(/** @type {any[]} */
    value.length));
  }
  return new Proxy(/** @type {any} */
  value, {
    defineProperty: function defineProperty(_, prop2, descriptor) {
      if (!("value" in descriptor) || descriptor.configurable === false || descriptor.enumerable === false || descriptor.writable === false) {
        state_descriptors_fixed();
      }
      var s = sources.get(prop2);
      if (s === void 0) {
        with_parent(function () {
          var s2 = /* @__PURE__ */state(descriptor.value);
          sources.set(prop2, s2);
          return s2;
        });
      } else {
        _set(s, descriptor.value, true);
      }
      return true;
    },
    deleteProperty: function deleteProperty(target, prop2) {
      var s = sources.get(prop2);
      if (s === void 0) {
        if (prop2 in target) {
          var s2 = with_parent(function () {
            return /* @__PURE__ */state(UNINITIALIZED);
          });
          sources.set(prop2, s2);
          increment(version);
        }
      } else {
        _set(s, UNINITIALIZED);
        increment(version);
      }
      return true;
    },
    get: function get(target, prop2, receiver) {
      var _get_descriptor;
      if (prop2 === STATE_SYMBOL) {
        return value;
      }
      var s = sources.get(prop2);
      var exists = prop2 in target;
      if (s === void 0 && (!exists || (_get_descriptor = get_descriptor(target, prop2)) !== null && _get_descriptor !== void 0 && _get_descriptor.writable)) {
        s = with_parent(function () {
          var p = proxy(exists ? target[prop2] : UNINITIALIZED);
          var s2 = /* @__PURE__ */state(p);
          return s2;
        });
        sources.set(prop2, s);
      }
      if (s !== void 0) {
        var v = _get(s);
        return v === UNINITIALIZED ? void 0 : v;
      }
      return Reflect.get(target, prop2, receiver);
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop2) {
      var descriptor = Reflect.getOwnPropertyDescriptor(target, prop2);
      if (descriptor && "value" in descriptor) {
        var s = sources.get(prop2);
        if (s) descriptor.value = _get(s);
      } else if (descriptor === void 0) {
        var source2 = sources.get(prop2);
        var value2 = source2 === null || source2 === void 0 ? void 0 : source2.v;
        if (source2 !== void 0 && value2 !== UNINITIALIZED) {
          return {
            enumerable: true,
            configurable: true,
            value: value2,
            writable: true
          };
        }
      }
      return descriptor;
    },
    has: function has(target, prop2) {
      var _get_descriptor2;
      if (prop2 === STATE_SYMBOL) {
        return true;
      }
      var s = sources.get(prop2);
      var has = s !== void 0 && s.v !== UNINITIALIZED || Reflect.has(target, prop2);
      if (s !== void 0 || active_effect !== null && (!has || (_get_descriptor2 = get_descriptor(target, prop2)) !== null && _get_descriptor2 !== void 0 && _get_descriptor2.writable)) {
        if (s === void 0) {
          s = with_parent(function () {
            var p = has ? proxy(target[prop2]) : UNINITIALIZED;
            var s2 = /* @__PURE__ */state(p);
            return s2;
          });
          sources.set(prop2, s);
        }
        var value2 = _get(s);
        if (value2 === UNINITIALIZED) {
          return false;
        }
      }
      return has;
    },
    set: function set(target, prop2, value2, receiver) {
      var s = sources.get(prop2);
      var has = prop2 in target;
      if (is_proxied_array && prop2 === "length") {
        for (var i = value2; i < /** @type {Source<number>} */
        s.v; i += 1) {
          var other_s = sources.get(i + "");
          if (other_s !== void 0) {
            _set(other_s, UNINITIALIZED);
          } else if (i in target) {
            other_s = with_parent(function () {
              return /* @__PURE__ */state(UNINITIALIZED);
            });
            sources.set(i + "", other_s);
          }
        }
      }
      if (s === void 0) {
        var _get_descriptor3;
        if (!has || (_get_descriptor3 = get_descriptor(target, prop2)) !== null && _get_descriptor3 !== void 0 && _get_descriptor3.writable) {
          s = with_parent(function () {
            return /* @__PURE__ */state(void 0);
          });
          _set(s, proxy(value2));
          sources.set(prop2, s);
        }
      } else {
        has = s.v !== UNINITIALIZED;
        var p = with_parent(function () {
          return proxy(value2);
        });
        _set(s, p);
      }
      var descriptor = Reflect.getOwnPropertyDescriptor(target, prop2);
      if (descriptor !== null && descriptor !== void 0 && descriptor.set) {
        descriptor.set.call(receiver, value2);
      }
      if (!has) {
        if (is_proxied_array && typeof prop2 === "string") {
          var ls = /** @type {Source<number>} */
          sources.get("length");
          var n = Number(prop2);
          if (Number.isInteger(n) && n >= ls.v) {
            _set(ls, n + 1);
          }
        }
        increment(version);
      }
      return true;
    },
    ownKeys: function ownKeys(target) {
      _get(version);
      var own_keys = Reflect.ownKeys(target).filter(function (key3) {
        var source3 = sources.get(key3);
        return source3 === void 0 || source3.v !== UNINITIALIZED;
      });
      var _iterator2 = _createForOfIteratorHelper(sources),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            key2 = _step2$value[0],
            source2 = _step2$value[1];
          if (source2.v !== UNINITIALIZED && !(key2 in target)) {
            own_keys.push(key2);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return own_keys;
    },
    setPrototypeOf: function setPrototypeOf() {
      state_prototype_fixed();
    }
  });
}
function get_proxied_value(value) {
  try {
    if (value !== null && _typeof(value) === "object" && STATE_SYMBOL in value) {
      return value[STATE_SYMBOL];
    }
  } catch (_unused) {}
  return value;
}
function is(a, b) {
  return Object.is(get_proxied_value(a), get_proxied_value(b));
}
var $window;
var $document;
var is_firefox;
var first_child_getter;
var next_sibling_getter;
function init_operations() {
  if ($window !== void 0) {
    return;
  }
  $window = window;
  $document = document;
  is_firefox = /Firefox/.test(navigator.userAgent);
  var element_prototype = Element.prototype;
  var node_prototype = Node.prototype;
  var text_prototype = Text.prototype;
  first_child_getter = get_descriptor(node_prototype, "firstChild").get;
  next_sibling_getter = get_descriptor(node_prototype, "nextSibling").get;
  if (is_extensible(element_prototype)) {
    element_prototype[CLASS_CACHE] = void 0;
    element_prototype[ATTRIBUTES_CACHE] = null;
    element_prototype[STYLE_CACHE] = void 0;
    element_prototype.__e = void 0;
  }
  if (is_extensible(text_prototype)) {
    text_prototype[TEXT_CACHE] = void 0;
  }
}
function create_text() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return document.createTextNode(value);
}
// @__NO_SIDE_EFFECTS__
function get_first_child(node) {
  return /** @type {TemplateNode | null} */first_child_getter.call(node);
}
// @__NO_SIDE_EFFECTS__
function get_next_sibling(node) {
  return /** @type {TemplateNode | null} */next_sibling_getter.call(node);
}
function child(node, is_text) {
  if (!hydrating) {
    return /* @__PURE__ */get_first_child(node);
  }
  var child2 = /* @__PURE__ */get_first_child(hydrate_node);
  if (child2 === null) {
    child2 = hydrate_node.appendChild(create_text());
  } else if (is_text && child2.nodeType !== TEXT_NODE) {
    var _child;
    var text2 = create_text();
    (_child = child2) === null || _child === void 0 || _child.before(text2);
    set_hydrate_node(text2);
    return text2;
  }
  if (is_text) {
    merge_text_nodes(/** @type {Text} */
    child2);
  }
  set_hydrate_node(child2);
  return child2;
}
function first_child(node) {
  var is_text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!hydrating) {
    var first = /* @__PURE__ */get_first_child(node);
    if (first instanceof Comment && first.data === "") return /* @__PURE__ */get_next_sibling(first);
    return first;
  }
  if (is_text) {
    var _hydrate_node;
    if (((_hydrate_node = hydrate_node) === null || _hydrate_node === void 0 ? void 0 : _hydrate_node.nodeType) !== TEXT_NODE) {
      var _hydrate_node2;
      var text2 = create_text();
      (_hydrate_node2 = hydrate_node) === null || _hydrate_node2 === void 0 || _hydrate_node2.before(text2);
      set_hydrate_node(text2);
      return text2;
    }
    merge_text_nodes(/** @type {Text} */
    hydrate_node);
  }
  return hydrate_node;
}
function only_child(node) {
  var is_text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!hydrating) {
    return /* @__PURE__ */get_first_child(node);
  }
  var first = child(node, is_text);
  reset(node);
  return first;
}
function sibling(node) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var is_text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var next_sibling = hydrating ? hydrate_node : node;
  var last_sibling;
  while (count--) {
    last_sibling = next_sibling;
    next_sibling = /** @type {TemplateNode} */
    /* @__PURE__ */get_next_sibling(next_sibling);
  }
  if (!hydrating) {
    return next_sibling;
  }
  if (is_text) {
    var _next_sibling;
    if (((_next_sibling = next_sibling) === null || _next_sibling === void 0 ? void 0 : _next_sibling.nodeType) !== TEXT_NODE) {
      var text2 = create_text();
      if (next_sibling === null) {
        var _last_sibling;
        (_last_sibling = last_sibling) === null || _last_sibling === void 0 || _last_sibling.after(text2);
      } else {
        next_sibling.before(text2);
      }
      set_hydrate_node(text2);
      return text2;
    }
    merge_text_nodes(/** @type {Text} */
    next_sibling);
  }
  set_hydrate_node(next_sibling);
  return next_sibling;
}
function clear_text_content(node) {
  node.textContent = "";
}
function should_defer_append() {
  return false;
}
function create_element(tag, namespace, is2) {
  if (namespace == null || namespace === NAMESPACE_HTML) {
    return /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */is2 ? document.createElement(tag, {
      is: is2
    }) : document.createElement(tag);
  }
  return /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */is2 ? document.createElementNS(namespace, tag, {
    is: is2
  }) : document.createElementNS(namespace, tag);
}
function merge_text_nodes(text2) {
  if (/** @type {string} */
  text2.nodeValue.length < 65536) {
    return;
  }
  var next2 = text2.nextSibling;
  while (next2 !== null && next2.nodeType === TEXT_NODE) {
    next2.remove();
    text2.nodeValue += /** @type {string} */
    next2.nodeValue;
    next2 = text2.nextSibling;
  }
}
function handle_error(error) {
  var effect2 = active_effect;
  if (effect2 === null) {
    active_reaction.f |= ERROR_VALUE;
    return error;
  }
  if ((effect2.f & REACTION_RAN) === 0 && (effect2.f & EFFECT) === 0) {
    throw error;
  }
  invoke_error_boundary(error, effect2);
}
function invoke_error_boundary(error, effect2) {
  if (effect2 !== null && (effect2.f & DESTROYED) !== 0) {
    return;
  }
  while (effect2 !== null) {
    if ((effect2.f & BOUNDARY_EFFECT) !== 0 && (effect2.f & (DESTROYED | DESTROYING)) === 0) {
      if ((effect2.f & REACTION_RAN) === 0) {
        throw error;
      }
      try {
        effect2.b.error(error);
        return;
      } catch (e) {
        error = e;
      }
    }
    effect2 = effect2.parent;
  }
  throw error;
}
var STATUS_MASK = -7169;
function set_signal_status(signal, status) {
  signal.f = signal.f & STATUS_MASK | status;
}
function update_derived_status(derived2) {
  if ((derived2.f & CONNECTED) !== 0 || derived2.deps === null) {
    set_signal_status(derived2, CLEAN);
  } else {
    set_signal_status(derived2, MAYBE_DIRTY);
  }
}
function clear_marked(deps) {
  if (deps === null) return;
  var _iterator3 = _createForOfIteratorHelper(deps),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var dep = _step3.value;
      if ((dep.f & DERIVED) === 0 || (dep.f & WAS_MARKED) === 0) {
        continue;
      }
      dep.f ^= WAS_MARKED;
      clear_marked(/** @type {Derived} */
      dep.deps);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
function _defer_effect(effect2, dirty_effects, maybe_dirty_effects) {
  if ((effect2.f & DIRTY) !== 0) {
    dirty_effects.add(effect2);
  } else if ((effect2.f & MAYBE_DIRTY) !== 0) {
    maybe_dirty_effects.add(effect2);
  }
  clear_marked(effect2.deps);
  set_signal_status(effect2, CLEAN);
}
function subscribe_to_store(store2, run, invalidate) {
  if (store2 == null) {
    run(void 0);
    return noop;
  }
  var unsub = untrack(function () {
    return store2.subscribe(run,
    // @ts-expect-error
    invalidate);
  });
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}
var subscriber_queue = [];
function writable(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var stop = null;
  var subscribers = /* @__PURE__ */new Set();
  function set2(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        var run_queue = !subscriber_queue.length;
        var _iterator4 = _createForOfIteratorHelper(subscribers),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var subscriber = _step4.value;
            subscriber[1]();
            subscriber_queue.push(subscriber, value);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (run_queue) {
          for (var i = 0; i < subscriber_queue.length; i += 2) {
            subscriber_queue[i][0](subscriber_queue[i + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update(fn) {
    set2(fn(/** @type {T} */
    value));
  }
  function subscribe(run) {
    var invalidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    var subscriber = [run, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set2, update) || noop;
    }
    run(/** @type {T} */
    value);
    return function () {
      subscribers["delete"](subscriber);
      if (subscribers.size === 0 && stop) {
        stop();
        stop = null;
      }
    };
  }
  return {
    set: set2,
    update: update,
    subscribe: subscribe
  };
}
function get$1(store2) {
  var value;
  subscribe_to_store(store2, function (_) {
    return value = _;
  })();
  return value;
}
var IS_UNMOUNTED = /* @__PURE__ */Symbol("unmounted");
function store_get(store2, store_name, stores) {
  var _stores$store_name;
  var entry = (_stores$store_name = stores[store_name]) !== null && _stores$store_name !== void 0 ? _stores$store_name : stores[store_name] = {
    store: null,
    source: /* @__PURE__ */mutable_source(void 0),
    unsubscribe: noop
  };
  if (entry.store !== store2 && !(IS_UNMOUNTED in stores)) {
    entry.unsubscribe();
    entry.store = store2 !== null && store2 !== void 0 ? store2 : null;
    if (store2 == null) {
      entry.source.v = void 0;
      entry.unsubscribe = noop;
    } else {
      var is_synchronous_callback = true;
      entry.unsubscribe = subscribe_to_store(store2, function (v) {
        if (is_synchronous_callback) {
          entry.source.v = v;
        } else {
          _set(entry.source, v);
        }
      });
      is_synchronous_callback = false;
    }
  }
  if (store2 && IS_UNMOUNTED in stores) {
    return get$1(store2);
  }
  return _get(entry.source);
}
function setup_stores() {
  var stores = {};
  function cleanup() {
    teardown(function () {
      for (var store_name in stores) {
        var ref = stores[store_name];
        ref.unsubscribe();
      }
      define_property(stores, IS_UNMOUNTED, {
        enumerable: false,
        value: true
      });
    });
  }
  return [stores, cleanup];
}
function autofocus(dom, value) {
  if (value) {
    var body = document.body;
    dom.autofocus = true;
    queue_micro_task(function () {
      if (document.activeElement === body) {
        dom.focus();
      }
    });
  }
}
var listening_to_form_reset = false;
function add_form_reset_listener() {
  if (!listening_to_form_reset) {
    listening_to_form_reset = true;
    document.addEventListener("reset", function (evt) {
      Promise.resolve().then(function () {
        if (!evt.defaultPrevented) {
          var _iterator5 = _createForOfIteratorHelper(/**@type {HTMLFormElement} */
            evt.target.elements),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _e$FORM_RESET_HANDLER;
              var e = _step5.value;
              (_e$FORM_RESET_HANDLER = e[FORM_RESET_HANDLER]) === null || _e$FORM_RESET_HANDLER === void 0 || _e$FORM_RESET_HANDLER.call(e);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possibility of stopPropagation)
    {
      capture: true
    });
  }
}
function without_reactive_context(fn) {
  var previous_reaction = active_reaction;
  var previous_effect = active_effect;
  set_active_reaction(null);
  set_active_effect(null);
  try {
    return fn();
  } finally {
    set_active_reaction(previous_reaction);
    set_active_effect(previous_effect);
  }
}
function listen_to_event_and_reset_event(element, event2, handler) {
  var on_reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : handler;
  element.addEventListener(event2, function () {
    return without_reactive_context(handler);
  });
  var prev = /** @type {any} */
  element[FORM_RESET_HANDLER];
  if (prev) {
    element[FORM_RESET_HANDLER] = function () {
      prev();
      on_reset(true);
    };
  } else {
    element[FORM_RESET_HANDLER] = function () {
      return on_reset(true);
    };
  }
  add_form_reset_listener();
}
function flatten(blockers, sync, async, fn) {
  var d = derived;
  var pending = blockers.filter(function (b) {
    return !b.settled;
  });
  var deriveds = sync.map(d);
  if (async.length === 0 && pending.length === 0) {
    fn(deriveds);
    return;
  }
  var parent = /** @type {Effect} */
  active_effect;
  var restore = capture();
  var blocker_promise = pending.length === 1 ? pending[0].promise : pending.length > 1 ? Promise.all(pending.map(function (b) {
    return b.promise;
  })) : null;
  function finish(async2) {
    if ((parent.f & DESTROYED) !== 0) {
      return;
    }
    restore();
    try {
      fn([].concat(_toConsumableArray(deriveds), _toConsumableArray(async2)));
    } catch (error) {
      invoke_error_boundary(error, parent);
    }
    unset_context();
  }
  var decrement_pending = increment_pending();
  if (async.length === 0) {
    blocker_promise.then(function () {
      return finish([]);
    })["finally"](decrement_pending);
    return;
  }
  function run() {
    Promise.all(async.map(function (expression) {
      return /* @__PURE__ */async_derived(expression);
    })).then(finish)["catch"](function (error) {
      return invoke_error_boundary(error, parent);
    })["finally"](decrement_pending);
  }
  if (blocker_promise) {
    blocker_promise.then(function () {
      restore();
      run();
      unset_context();
    });
  } else {
    run();
  }
}
function capture() {
  var previous_effect = /** @type {Effect} */
  active_effect;
  var previous_reaction = active_reaction;
  var previous_component_context = component_context;
  var previous_batch2 = /** @type {Batch} */
  current_batch;
  return function restore() {
    var activate_batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    set_active_effect(previous_effect);
    set_active_reaction(previous_reaction);
    set_component_context(previous_component_context);
    if (activate_batch && (previous_effect.f & DESTROYED) === 0) {
      previous_batch2 === null || previous_batch2 === void 0 || previous_batch2.activate();
      previous_batch2 === null || previous_batch2 === void 0 || previous_batch2.apply();
    }
  };
}
function unset_context() {
  var _current_batch;
  var deactivate_batch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  set_active_effect(null);
  set_active_reaction(null);
  set_component_context(null);
  if (deactivate_batch) (_current_batch = current_batch) === null || _current_batch === void 0 || _current_batch.deactivate();
}
function increment_pending() {
  var effect2 = /** @type {Effect} */
  active_effect;
  var boundary2 = effect2.b;
  var batch = /** @type {Batch} */
  current_batch;
  var blocking = !!(boundary2 !== null && boundary2 !== void 0 && boundary2.is_rendered());
  boundary2 === null || boundary2 === void 0 || boundary2.update_pending_count(1, batch);
  batch.increment(blocking, effect2);
  return function () {
    boundary2 === null || boundary2 === void 0 || boundary2.update_pending_count(-1, batch);
    batch.decrement(blocking, effect2);
  };
}
// @__NO_SIDE_EFFECTS__
function derived(fn) {
  var flags2 = DERIVED | DIRTY;
  if (active_effect !== null) {
    active_effect.f |= EFFECT_PRESERVED;
  }
  var signal = {
    ctx: component_context,
    deps: null,
    effects: null,
    equals: equals,
    f: flags2,
    fn: fn,
    reactions: null,
    rv: 0,
    v: (/** @type {V} */
    UNINITIALIZED),
    wv: 0,
    parent: active_effect,
    ac: null
  };
  return signal;
}
var OBSOLETE = /* @__PURE__ */Symbol("obsolete");
// @__NO_SIDE_EFFECTS__
function async_derived(fn, label, location2) {
  var parent = /** @type {Effect | null} */
  active_effect;
  if (parent === null) {
    async_derived_orphan();
  }
  var promise = /** @type {Promise<V>} */
  /** @type {unknown} */
  void 0;
  var signal = source(/** @type {V} */
  UNINITIALIZED);
  var should_suspend = !active_reaction;
  var deferreds = /* @__PURE__ */new Set();
  async_effect(function () {
    var effect2 = /** @type {Effect} */
    active_effect;
    var d = deferred();
    promise = d.promise;
    try {
      Promise.resolve(fn()).then(d.resolve, function (e) {
        if (e !== STALE_REACTION) d.reject(e);
      })["finally"](unset_context);
    } catch (error) {
      d.reject(error);
      unset_context();
    }
    var batch = /** @type {Batch} */
    current_batch;
    if (should_suspend) {
      var _parent$b;
      if ((effect2.f & REACTION_RAN) !== 0) {
        var decrement_pending = increment_pending();
      }
      if (// boundary can be null if the async derived is inside an $effect.root not connected to the component render tree
      (_parent$b = parent.b) !== null && _parent$b !== void 0 && _parent$b.is_rendered()) {
        var _batch$async_deriveds;
        (_batch$async_deriveds = batch.async_deriveds.get(effect2)) === null || _batch$async_deriveds === void 0 || _batch$async_deriveds.reject(OBSOLETE);
      } else {
        var _iterator6 = _createForOfIteratorHelper(deferreds.values()),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var d2 = _step6.value;
            d2.reject(OBSOLETE);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
      deferreds.add(d);
      batch.async_deriveds.set(effect2, d);
    }
    var handler = function handler(value) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;
      decrement_pending === null || decrement_pending === void 0 || decrement_pending();
      deferreds["delete"](d);
      if (error === OBSOLETE) return;
      batch.activate();
      if (error) {
        signal.f |= ERROR_VALUE;
        internal_set(signal, error);
      } else {
        if ((signal.f & ERROR_VALUE) !== 0) {
          signal.f ^= ERROR_VALUE;
        }
        internal_set(signal, value);
      }
      batch.deactivate();
    };
    d.promise.then(handler, function (e) {
      return handler(null, e || "unknown");
    });
  });
  teardown(function () {
    var _iterator7 = _createForOfIteratorHelper(deferreds),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var d = _step7.value;
        d.reject(OBSOLETE);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  });
  return new Promise(function (fulfil) {
    function next2(p) {
      function go() {
        if (p === promise) {
          fulfil(signal);
        } else {
          next2(promise);
        }
      }
      p.then(go, go);
    }
    next2(promise);
  });
}
// @__NO_SIDE_EFFECTS__
function user_derived(fn) {
  var d = /* @__PURE__ */derived(fn);
  push_reaction_value(d);
  return d;
}
function destroy_derived_effects(derived2) {
  var effects = derived2.effects;
  if (effects !== null) {
    derived2.effects = null;
    for (var i = 0; i < effects.length; i += 1) {
      destroy_effect(/** @type {Effect} */
      effects[i]);
    }
  }
}
function execute_derived(derived2) {
  var value;
  var prev_active_effect = active_effect;
  var parent = derived2.parent;
  if (!is_destroying_effect && parent !== null && derived2.v !== UNINITIALIZED &&
  // if it was never evaluated before, it's guaranteed to fail downstream, so we try to execute instead
  (parent.f & (DESTROYED | INERT)) !== 0) {
    derived_inert();
    return derived2.v;
  }
  set_active_effect(parent);
  {
    try {
      derived2.f &= ~WAS_MARKED;
      destroy_derived_effects(derived2);
      value = update_reaction(derived2);
    } finally {
      set_active_effect(prev_active_effect);
    }
  }
  return value;
}
function update_derived(derived2) {
  var value = execute_derived(derived2);
  if (!derived2.equals(value)) {
    var _current_batch2;
    derived2.wv = increment_write_version();
    if (!((_current_batch2 = current_batch) !== null && _current_batch2 !== void 0 && _current_batch2.is_fork) || derived2.deps === null) {
      if (current_batch !== null) {
        var _previous_batch;
        current_batch.capture(derived2, value, true);
        (_previous_batch = previous_batch) === null || _previous_batch === void 0 || _previous_batch.capture(derived2, value, true);
      } else {
        derived2.v = value;
      }
      if (derived2.deps === null) {
        set_signal_status(derived2, CLEAN);
        return;
      }
    }
  }
  if (is_destroying_effect) {
    return;
  }
  if (batch_values !== null) {
    var _current_batch3;
    if (effect_tracking() || (_current_batch3 = current_batch) !== null && _current_batch3 !== void 0 && _current_batch3.is_fork) {
      batch_values.set(derived2, value);
    }
  } else {
    update_derived_status(derived2);
  }
}
function freeze_derived_effects(derived2) {
  if (derived2.effects === null) return;
  var _iterator8 = _createForOfIteratorHelper(derived2.effects),
    _step8;
  try {
    var _loop = function _loop() {
      var e = _step8.value;
      if (e.teardown || e.ac) {
        var _e$teardown;
        (_e$teardown = e.teardown) === null || _e$teardown === void 0 || _e$teardown.call(e);
        if (e.ac !== null) {
          without_reactive_context(function () {
            e.ac.abort(STALE_REACTION);
            e.ac = null;
          });
        }
        if (e.fn !== null) e.teardown = noop;
        remove_reactions(e, 0);
        destroy_effect_children(e);
      }
    };
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
}
function unfreeze_derived_effects(derived2) {
  if (derived2.effects === null) return;
  var _iterator9 = _createForOfIteratorHelper(derived2.effects),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var e = _step9.value;
      if (e.teardown && e.fn !== null) {
        update_effect(e);
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
}
var first_batch = null;
var last_batch = null;
var current_batch = null;
var previous_batch = null;
var batch_values = null;
var last_scheduled_effect = null;
var is_flushing_sync = false;
var is_processing = false;
var collected_effects = null;
var legacy_updates = null;
var flush_count = 0;
var source_stacks = /* @__PURE__ */new Set();
var uid = 1;
var _started = /*#__PURE__*/new WeakMap();
var _prev = /*#__PURE__*/new WeakMap();
var _next = /*#__PURE__*/new WeakMap();
var _commit_callbacks = /*#__PURE__*/new WeakMap();
var _discard_callbacks = /*#__PURE__*/new WeakMap();
var _pending = /*#__PURE__*/new WeakMap();
var _blocking_pending = /*#__PURE__*/new WeakMap();
var _deferred = /*#__PURE__*/new WeakMap();
var _roots = /*#__PURE__*/new WeakMap();
var _new_effects = /*#__PURE__*/new WeakMap();
var _dirty_effects = /*#__PURE__*/new WeakMap();
var _maybe_dirty_effects = /*#__PURE__*/new WeakMap();
var _skipped_branches = /*#__PURE__*/new WeakMap();
var _unskipped_branches = /*#__PURE__*/new WeakMap();
var _decrement_queued = /*#__PURE__*/new WeakMap();
var _Batch_brand = /*#__PURE__*/new WeakSet();
var Batch = /*#__PURE__*/function () {
  function Batch() {
    _classCallCheck(this, Batch);
    _classPrivateMethodInitSpec(this, _Batch_brand);
    _defineProperty(this, "id", uid++);
    /** True as soon as `#process` was called */
    _classPrivateFieldInitSpec(this, _started, false);
    _defineProperty(this, "linked", true);
    /** @type {Batch | null} */
    _classPrivateFieldInitSpec(this, _prev, null);
    /** @type {Batch | null} */
    _classPrivateFieldInitSpec(this, _next, null);
    /** @type {Map<Effect, ReturnType<typeof deferred<any>>>} */
    _defineProperty(this, "async_deriveds", /* @__PURE__ */new Map());
    /**
     * The current values of any signals that are updated in this batch.
     * Tuple format: [value, is_derived] (note: is_derived is false for deriveds, too, if they were overridden via assignment)
     * They keys of this map are identical to `this.#previous`
     * @type {Map<Value, [any, boolean]>}
     */
    _defineProperty(this, "current", /* @__PURE__ */new Map());
    /**
     * The values of any signals (sources and deriveds) that are updated in this batch _before_ those updates took place.
     * They keys of this map are identical to `this.#current`
     * @type {Map<Value, any>}
     */
    _defineProperty(this, "previous", /* @__PURE__ */new Map());
    /**
     * When the batch is committed (and the DOM is updated), we need to remove old branches
     * and append new ones by calling the functions added inside (if/each/key/etc) blocks
     * @type {Set<(batch: Batch) => void>}
     */
    _classPrivateFieldInitSpec(this, _commit_callbacks, /* @__PURE__ */new Set());
    /**
     * If a fork is discarded, we need to destroy any effects that are no longer needed
     * @type {Set<(batch: Batch) => void>}
     */
    _classPrivateFieldInitSpec(this, _discard_callbacks, /* @__PURE__ */new Set());
    /**
     * The number of async effects that are currently in flight
     */
    _classPrivateFieldInitSpec(this, _pending, 0);
    /**
     * Async effects that are currently in flight, _not_ inside a pending boundary
     * @type {Map<Effect, number>}
     */
    _classPrivateFieldInitSpec(this, _blocking_pending, /* @__PURE__ */new Map());
    /**
     * A deferred that resolves when the batch is committed, used with `settled()`
     * TODO replace with Promise.withResolvers once supported widely enough
     * @type {{ promise: Promise<void>, resolve: (value?: any) => void, reject: (reason: unknown) => void } | null}
     */
    _classPrivateFieldInitSpec(this, _deferred, null);
    /**
     * The root effects that need to be flushed
     * @type {Effect[]}
     */
    _classPrivateFieldInitSpec(this, _roots, []);
    /**
     * Effects created while this batch was active.
     * @type {Effect[]}
     */
    _classPrivateFieldInitSpec(this, _new_effects, []);
    /**
     * Deferred effects (which run after async work has completed) that are DIRTY
     * @type {Set<Effect>}
     */
    _classPrivateFieldInitSpec(this, _dirty_effects, /* @__PURE__ */new Set());
    /**
     * Deferred effects that are MAYBE_DIRTY
     * @type {Set<Effect>}
     */
    _classPrivateFieldInitSpec(this, _maybe_dirty_effects, /* @__PURE__ */new Set());
    /**
     * A map of branches that still exist, but will be destroyed when this batch
     * is committed — we skip over these during `process`.
     * The value contains child effects that were dirty/maybe_dirty before being reset,
     * so they can be rescheduled if the branch survives.
     * @type {Map<Effect, { d: Effect[], m: Effect[] }>}
     */
    _classPrivateFieldInitSpec(this, _skipped_branches, /* @__PURE__ */new Map());
    /**
     * Inverse of #skipped_branches which we need to tell prior batches to unskip them when committing
     * @type {Set<Effect>}
     */
    _classPrivateFieldInitSpec(this, _unskipped_branches, /* @__PURE__ */new Set());
    _defineProperty(this, "is_fork", false);
    _classPrivateFieldInitSpec(this, _decrement_queued, false);
    if (last_batch === null) {
      first_batch = last_batch = this;
    } else {
      _classPrivateFieldSet(_next, last_batch, this);
      _classPrivateFieldSet(_prev, this, last_batch);
    }
    last_batch = this;
  }
  return _createClass(Batch, [{
    key: "skip_effect",
    value:
    /**
     * Add an effect to the #skipped_branches map and reset its children
     * @param {Effect} effect
     */
    function skip_effect(effect2) {
      if (!_classPrivateFieldGet(_skipped_branches, this).has(effect2)) {
        _classPrivateFieldGet(_skipped_branches, this).set(effect2, {
          d: [],
          m: []
        });
      }
      _classPrivateFieldGet(_unskipped_branches, this)["delete"](effect2);
    }
    /**
     * Remove an effect from the #skipped_branches map and reschedule
     * any tracked dirty/maybe_dirty child effects
     * @param {Effect} effect
     * @param {(e: Effect) => void} callback
     */
  }, {
    key: "unskip_effect",
    value: function unskip_effect(effect2) {
      var _this2 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
        return _this2.schedule(e);
      };
      var tracked = _classPrivateFieldGet(_skipped_branches, this).get(effect2);
      if (tracked) {
        _classPrivateFieldGet(_skipped_branches, this)["delete"](effect2);
        var _iterator0 = _createForOfIteratorHelper(tracked.d),
          _step0;
        try {
          for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
            var e = _step0.value;
            set_signal_status(e, DIRTY);
            callback(e);
          }
        } catch (err) {
          _iterator0.e(err);
        } finally {
          _iterator0.f();
        }
        var _iterator1 = _createForOfIteratorHelper(tracked.m),
          _step1;
        try {
          for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
            e = _step1.value;
            set_signal_status(e, MAYBE_DIRTY);
            callback(e);
          }
        } catch (err) {
          _iterator1.e(err);
        } finally {
          _iterator1.f();
        }
      }
      _classPrivateFieldGet(_unskipped_branches, this).add(effect2);
    }
  }, {
    key: "capture",
    value:
    /**
     * Associate a change to a given source with the current
     * batch, noting its previous and current values
     * @param {Value} source
     * @param {any} value
     * @param {boolean} [is_derived]
     */
    function capture(source2, value) {
      var is_derived = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (source2.v !== UNINITIALIZED && !this.previous.has(source2)) {
        this.previous.set(source2, source2.v);
      }
      if ((source2.f & ERROR_VALUE) === 0) {
        var _batch_values;
        this.current.set(source2, [value, is_derived]);
        (_batch_values = batch_values) === null || _batch_values === void 0 || _batch_values.set(source2, value);
      }
      if (!this.is_fork) {
        source2.v = value;
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      current_batch = this;
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      current_batch = null;
      batch_values = null;
    }
  }, {
    key: "flush",
    value: function flush() {
      try {
        if (DEV) ;
        is_processing = true;
        current_batch = this;
        _assertClassBrand(_Batch_brand, this, _process).call(this);
      } finally {
        flush_count = 0;
        last_scheduled_effect = null;
        collected_effects = null;
        legacy_updates = null;
        is_processing = false;
        current_batch = null;
        batch_values = null;
        old_values.clear();
      }
    }
  }, {
    key: "discard",
    value: function discard() {
      var _classPrivateFieldGet2;
      var _iterator10 = _createForOfIteratorHelper(_classPrivateFieldGet(_discard_callbacks, this)),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var fn = _step10.value;
          fn(this);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
      _classPrivateFieldGet(_discard_callbacks, this).clear();
      var _iterator11 = _createForOfIteratorHelper(this.async_deriveds.values()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var deferred2 = _step11.value;
          deferred2.reject(OBSOLETE);
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      _assertClassBrand(_Batch_brand, this, _unlink).call(this);
      (_classPrivateFieldGet2 = _classPrivateFieldGet(_deferred, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.resolve();
    }
    /**
     * @param {Effect} effect
     */
  }, {
    key: "register_created_effect",
    value: function register_created_effect(effect2) {
      _classPrivateFieldGet(_new_effects, this).push(effect2);
    }
  }, {
    key: "increment",
    value:
    /**
     * @param {boolean} blocking
     * @param {Effect} effect
     */
    function increment(blocking, effect2) {
      _classPrivateFieldSet(_pending, this, _classPrivateFieldGet(_pending, this) + 1);
      if (blocking) {
        var _classPrivateFieldGet3;
        var blocking_pending_count = (_classPrivateFieldGet3 = _classPrivateFieldGet(_blocking_pending, this).get(effect2)) !== null && _classPrivateFieldGet3 !== void 0 ? _classPrivateFieldGet3 : 0;
        _classPrivateFieldGet(_blocking_pending, this).set(effect2, blocking_pending_count + 1);
      }
    }
    /**
     * @param {boolean} blocking
     * @param {Effect} effect
     */
  }, {
    key: "decrement",
    value: function decrement(blocking, effect2) {
      var _this3 = this;
      _classPrivateFieldSet(_pending, this, _classPrivateFieldGet(_pending, this) - 1);
      if (blocking) {
        var _classPrivateFieldGet4;
        var blocking_pending_count = (_classPrivateFieldGet4 = _classPrivateFieldGet(_blocking_pending, this).get(effect2)) !== null && _classPrivateFieldGet4 !== void 0 ? _classPrivateFieldGet4 : 0;
        if (blocking_pending_count === 1) {
          _classPrivateFieldGet(_blocking_pending, this)["delete"](effect2);
        } else {
          _classPrivateFieldGet(_blocking_pending, this).set(effect2, blocking_pending_count - 1);
        }
      }
      if (_classPrivateFieldGet(_decrement_queued, this)) return;
      _classPrivateFieldSet(_decrement_queued, this, true);
      queue_micro_task(function () {
        _classPrivateFieldSet(_decrement_queued, _this3, false);
        if (_this3.linked) {
          _this3.flush();
        }
      });
    }
    /**
     * @param {Set<Effect>} dirty_effects
     * @param {Set<Effect>} maybe_dirty_effects
     */
  }, {
    key: "transfer_effects",
    value: function transfer_effects(dirty_effects, maybe_dirty_effects) {
      var _iterator12 = _createForOfIteratorHelper(dirty_effects),
        _step12;
      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var e = _step12.value;
          _classPrivateFieldGet(_dirty_effects, this).add(e);
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
      var _iterator13 = _createForOfIteratorHelper(maybe_dirty_effects),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _e = _step13.value;
          _classPrivateFieldGet(_maybe_dirty_effects, this).add(_e);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
      dirty_effects.clear();
      maybe_dirty_effects.clear();
    }
    /** @param {(batch: Batch) => void} fn */
  }, {
    key: "oncommit",
    value: function oncommit(fn) {
      _classPrivateFieldGet(_commit_callbacks, this).add(fn);
    }
    /** @param {(batch: Batch) => void} fn */
  }, {
    key: "ondiscard",
    value: function ondiscard(fn) {
      _classPrivateFieldGet(_discard_callbacks, this).add(fn);
    }
  }, {
    key: "settled",
    value: function settled() {
      var _classPrivateFieldGet5;
      return ((_classPrivateFieldGet5 = _classPrivateFieldGet(_deferred, this)) !== null && _classPrivateFieldGet5 !== void 0 ? _classPrivateFieldGet5 : _classPrivateFieldSet(_deferred, this, deferred())).promise;
    }
  }, {
    key: "apply",
    value: function apply() {
      {
        batch_values = null;
        return;
      }
    }
    /**
     *
     * @param {Effect} effect
     */
  }, {
    key: "schedule",
    value: function schedule(effect2) {
      var _effect2$b;
      last_scheduled_effect = effect2;
      if ((_effect2$b = effect2.b) !== null && _effect2$b !== void 0 && _effect2$b.is_pending && (effect2.f & (EFFECT | RENDER_EFFECT | MANAGED_EFFECT)) !== 0 && (effect2.f & REACTION_RAN) === 0) {
        effect2.b.defer_effect(effect2);
        return;
      }
      var e = effect2;
      while (e.parent !== null) {
        e = e.parent;
        var flags2 = e.f;
        if (collected_effects !== null && e === active_effect) {
          if ((active_reaction === null || (active_reaction.f & DERIVED) === 0) && true) {
            return;
          }
        }
        if ((flags2 & (ROOT_EFFECT | BRANCH_EFFECT)) !== 0) {
          if ((flags2 & CLEAN) === 0) {
            return;
          }
          e.f ^= CLEAN;
        }
      }
      _classPrivateFieldGet(_roots, this).push(e);
    }
  }], [{
    key: "ensure",
    value: function ensure() {
      if (current_batch === null) {
        var batch = current_batch = new Batch();
        if (!is_processing && !is_flushing_sync) {
          queue_micro_task(function () {
            if (!_classPrivateFieldGet(_started, batch)) {
              batch.flush();
            }
          });
        }
      }
      return current_batch;
    }
  }]);
}();
_Batch = Batch;
function _is_deferred() {
  if (this.is_fork) return true;
  var _iterator46 = _createForOfIteratorHelper(_classPrivateFieldGet(_blocking_pending, this).keys()),
    _step46;
  try {
    for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
      var effect2 = _step46.value;
      var e = effect2;
      var skipped = false;
      while (e.parent !== null) {
        if (_classPrivateFieldGet(_skipped_branches, this).has(e)) {
          skipped = true;
          break;
        }
        e = e.parent;
      }
      if (!skipped) {
        return true;
      }
    }
  } catch (err) {
    _iterator46.e(err);
  } finally {
    _iterator46.f();
  }
  return false;
}
function _process() {
  var _classPrivateFieldGet6;
  _classPrivateFieldSet(_started, this, true);
  if (flush_count++ > 1e3) {
    _assertClassBrand(_Batch_brand, this, _unlink).call(this);
    infinite_loop_guard();
  }
  var _iterator47 = _createForOfIteratorHelper(_classPrivateFieldGet(_dirty_effects, this)),
    _step47;
  try {
    for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
      var _e3 = _step47.value;
      _classPrivateFieldGet(_maybe_dirty_effects, this)["delete"](_e3);
      set_signal_status(_e3, DIRTY);
      this.schedule(_e3);
    }
  } catch (err) {
    _iterator47.e(err);
  } finally {
    _iterator47.f();
  }
  var _iterator48 = _createForOfIteratorHelper(_classPrivateFieldGet(_maybe_dirty_effects, this)),
    _step48;
  try {
    for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
      var _e4 = _step48.value;
      set_signal_status(_e4, MAYBE_DIRTY);
      this.schedule(_e4);
    }
  } catch (err) {
    _iterator48.e(err);
  } finally {
    _iterator48.f();
  }
  var roots = _classPrivateFieldGet(_roots, this);
  _classPrivateFieldSet(_roots, this, []);
  this.apply();
  var effects = collected_effects = [];
  var render_effects = [];
  var updates = legacy_updates = [];
  var _iterator49 = _createForOfIteratorHelper(roots),
    _step49;
  try {
    for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
      var root2 = _step49.value;
      try {
        _assertClassBrand(_Batch_brand, this, _traverse).call(this, root2, effects, render_effects);
      } catch (e) {
        reset_all(root2);
        if (!_assertClassBrand(_Batch_brand, this, _is_deferred).call(this)) this.discard();
        throw e;
      }
    }
  } catch (err) {
    _iterator49.e(err);
  } finally {
    _iterator49.f();
  }
  current_batch = null;
  if (updates.length > 0) {
    var batch = _Batch.ensure();
    var _iterator50 = _createForOfIteratorHelper(updates),
      _step50;
    try {
      for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
        var e = _step50.value;
        batch.schedule(e);
      }
    } catch (err) {
      _iterator50.e(err);
    } finally {
      _iterator50.f();
    }
  }
  collected_effects = null;
  legacy_updates = null;
  if (_assertClassBrand(_Batch_brand, this, _is_deferred).call(this)) {
    _assertClassBrand(_Batch_brand, this, _defer_effects).call(this, render_effects);
    _assertClassBrand(_Batch_brand, this, _defer_effects).call(this, effects);
    var _iterator51 = _createForOfIteratorHelper(_classPrivateFieldGet(_skipped_branches, this)),
      _step51;
    try {
      for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
        var _step51$value = _slicedToArray(_step51.value, 2),
          _e2 = _step51$value[0],
          t = _step51$value[1];
        reset_branch(_e2, t);
      }
    } catch (err) {
      _iterator51.e(err);
    } finally {
      _iterator51.f();
    }
    if (updates.length > 0) {
      var _current_batch4;
      /** @type {unknown} */
      _assertClassBrand(_Batch_brand, _current_batch4 = current_batch, _process).call(_current_batch4);
    }
    return;
  }
  var earlier_batch = _assertClassBrand(_Batch_brand, this, _find_earlier_batch).call(this);
  if (earlier_batch) {
    _assertClassBrand(_Batch_brand, this, _defer_effects).call(this, render_effects);
    _assertClassBrand(_Batch_brand, this, _defer_effects).call(this, effects);
    _assertClassBrand(_Batch_brand, earlier_batch, _merge).call(earlier_batch, this);
    return;
  }
  _classPrivateFieldGet(_dirty_effects, this).clear();
  _classPrivateFieldGet(_maybe_dirty_effects, this).clear();
  var _iterator52 = _createForOfIteratorHelper(_classPrivateFieldGet(_commit_callbacks, this)),
    _step52;
  try {
    for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
      var fn = _step52.value;
      fn(this);
    }
  } catch (err) {
    _iterator52.e(err);
  } finally {
    _iterator52.f();
  }
  _classPrivateFieldGet(_commit_callbacks, this).clear();
  previous_batch = this;
  flush_queued_effects(render_effects);
  flush_queued_effects(effects);
  previous_batch = null;
  (_classPrivateFieldGet6 = _classPrivateFieldGet(_deferred, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.resolve();
  var next_batch = /** @type {Batch | null} */
  /** @type {unknown} */
  current_batch;
  if (_classPrivateFieldGet(_pending, this) === 0 && (_classPrivateFieldGet(_roots, this).length === 0 || next_batch !== null)) {
    _assertClassBrand(_Batch_brand, this, _unlink).call(this);
  }
  if (_classPrivateFieldGet(_roots, this).length > 0) {
    if (next_batch !== null) {
      var _classPrivateFieldGet7;
      var batch2 = next_batch;
      (_classPrivateFieldGet7 = _classPrivateFieldGet(_roots, batch2)).push.apply(_classPrivateFieldGet7, _toConsumableArray(_classPrivateFieldGet(_roots, this).filter(function (r2) {
        return !_classPrivateFieldGet(_roots, batch2).includes(r2);
      })));
    } else {
      next_batch = this;
    }
  }
  if (next_batch !== null) {
    var _next_batch;
    old_values.clear();
    _assertClassBrand(_Batch_brand, _next_batch = next_batch, _process).call(_next_batch);
  }
}
/**
 * Traverse the effect tree, executing effects or stashing
 * them for later execution as appropriate
 * @param {Effect} root
 * @param {Effect[]} effects
 * @param {Effect[]} render_effects
 */
function _traverse(root2, effects, render_effects) {
  root2.f ^= CLEAN;
  var effect2 = root2.first;
  while (effect2 !== null) {
    var flags2 = effect2.f;
    var is_branch = (flags2 & (BRANCH_EFFECT | ROOT_EFFECT)) !== 0;
    var is_skippable_branch = is_branch && (flags2 & CLEAN) !== 0;
    var skip = is_skippable_branch || (flags2 & INERT) !== 0 || _classPrivateFieldGet(_skipped_branches, this).has(effect2);
    if (!skip && effect2.fn !== null) {
      if (is_branch) {
        effect2.f ^= CLEAN;
      } else if ((flags2 & EFFECT) !== 0) {
        effects.push(effect2);
      } else if (is_dirty(effect2)) {
        if ((flags2 & BLOCK_EFFECT) !== 0) _classPrivateFieldGet(_maybe_dirty_effects, this).add(effect2);
        update_effect(effect2);
      }
      var child2 = effect2.first;
      if (child2 !== null) {
        effect2 = child2;
        continue;
      }
    }
    while (effect2 !== null) {
      var next2 = effect2.next;
      if (next2 !== null) {
        effect2 = next2;
        break;
      }
      effect2 = effect2.parent;
    }
  }
}
function _find_earlier_batch() {
  var batch = _classPrivateFieldGet(_prev, this);
  while (batch !== null) {
    if (!batch.is_fork) {
      var _iterator53 = _createForOfIteratorHelper(this.current),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _step53$value = _slicedToArray(_step53.value, 2),
            value = _step53$value[0],
            _step53$value$ = _slicedToArray(_step53$value[1], 2),
            is_derived = _step53$value$[1];
          if (batch.current.has(value) && !is_derived) {
            return batch;
          }
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
    }
    batch = _classPrivateFieldGet(_prev, batch);
  }
  return null;
}
/**
 * @param {Batch} batch
 */
function _merge(batch) {
  var _this16 = this;
  var _iterator54 = _createForOfIteratorHelper(batch.current),
    _step54;
  try {
    for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
      var _step54$value = _slicedToArray(_step54.value, 2),
        source2 = _step54$value[0],
        value = _step54$value[1];
      if (!this.previous.has(source2) && batch.previous.has(source2)) {
        this.previous.set(source2, batch.previous.get(source2));
      }
      this.current.set(source2, value);
    }
  } catch (err) {
    _iterator54.e(err);
  } finally {
    _iterator54.f();
  }
  var _iterator55 = _createForOfIteratorHelper(batch.async_deriveds),
    _step55;
  try {
    for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
      var _step55$value = _slicedToArray(_step55.value, 2),
        effect2 = _step55$value[0],
        deferred2 = _step55$value[1];
      var d = this.async_deriveds.get(effect2);
      if (d) deferred2.promise.then(d.resolve)["catch"](d.reject);
    }
  } catch (err) {
    _iterator55.e(err);
  } finally {
    _iterator55.f();
  }
  batch.async_deriveds.clear();
  this.transfer_effects(_classPrivateFieldGet(_dirty_effects, batch), _classPrivateFieldGet(_maybe_dirty_effects, batch));
  var _mark = function mark(value) {
    var reactions = value.reactions;
    if (reactions === null) return;
    if ((value.f & DERIVED) !== 0 && (value.f & (DIRTY | MAYBE_DIRTY)) === 0) {
      return;
    }
    var _iterator56 = _createForOfIteratorHelper(reactions),
      _step56;
    try {
      for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
        var reaction = _step56.value;
        var flags2 = reaction.f;
        if ((flags2 & DERIVED) !== 0) {
          _mark(/** @type {Derived} */
          reaction);
        } else {
          var effect2 = /** @type {Effect} */
          reaction;
          if (flags2 & (ASYNC | BLOCK_EFFECT) && !_this16.async_deriveds.has(effect2)) {
            _classPrivateFieldGet(_maybe_dirty_effects, _this16)["delete"](effect2);
            set_signal_status(effect2, DIRTY);
            _this16.schedule(effect2);
          }
        }
      }
    } catch (err) {
      _iterator56.e(err);
    } finally {
      _iterator56.f();
    }
  };
  var _iterator57 = _createForOfIteratorHelper(this.current.keys()),
    _step57;
  try {
    for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
      var _source = _step57.value;
      _mark(_source);
    }
  } catch (err) {
    _iterator57.e(err);
  } finally {
    _iterator57.f();
  }
  this.oncommit(function () {
    return batch.discard();
  });
  _assertClassBrand(_Batch_brand, batch, _unlink).call(batch);
  current_batch = this;
  _assertClassBrand(_Batch_brand, this, _process).call(this);
}
/**
 * @param {Effect[]} effects
 */
function _defer_effects(effects) {
  for (var i = 0; i < effects.length; i += 1) {
    _defer_effect(effects[i], _classPrivateFieldGet(_dirty_effects, this), _classPrivateFieldGet(_maybe_dirty_effects, this));
  }
}
function _commit() {
  var _this17 = this;
  var _loop7 = function _loop7(batch) {
      is_earlier = batch.id < _this17.id;
      sources = [];
      var _iterator58 = _createForOfIteratorHelper(_this17.current),
        _step58;
      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var _step58$value = _slicedToArray(_step58.value, 2),
            source3 = _step58$value[0],
            _step58$value$ = _slicedToArray(_step58$value[1], 2),
            value = _step58$value$[0],
            is_derived = _step58$value$[1];
          if (batch.current.has(source3)) {
            batch_value = /** @type {[any, boolean]} */
            batch.current.get(source3)[0];
            if (is_earlier && value !== batch_value) {
              batch.current.set(source3, [value, is_derived]);
            } else {
              continue;
            }
          }
          sources.push(source3);
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }
      if (is_earlier) {
        var _iterator59 = _createForOfIteratorHelper(_this17.async_deriveds),
          _step59;
        try {
          for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
            var _step59$value = _slicedToArray(_step59.value, 2),
              effect2 = _step59$value[0],
              deferred2 = _step59$value[1];
            var d = batch.async_deriveds.get(effect2);
            if (d) deferred2.promise.then(d.resolve)["catch"](d.reject);
          }
        } catch (err) {
          _iterator59.e(err);
        } finally {
          _iterator59.f();
        }
      }
      current = _toConsumableArray(batch.current.keys()).filter(function (source3) {
        return ! /** @type {[any, boolean]} */
        batch.current.get(source3)[1];
      });
      if (!_classPrivateFieldGet(_started, batch) || current.length === 0) return 1; // continue
      others = current.filter(function (source3) {
        return !_this17.current.has(source3);
      });
      if (others.length === 0) {
        if (is_earlier) {
          batch.discard();
        }
      } else if (sources.length > 0) {
        if (is_earlier) {
          var _iterator60 = _createForOfIteratorHelper(_classPrivateFieldGet(_unskipped_branches, _this17)),
            _step60;
          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var unskipped = _step60.value;
              batch.unskip_effect(unskipped, function (e) {
                if ((e.f & (BLOCK_EFFECT | ASYNC)) !== 0) {
                  batch.schedule(e);
                } else {
                  var _batch;
                  _assertClassBrand(_Batch_brand, _batch = batch, _defer_effects).call(_batch, [e]);
                }
              });
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
        }
        batch.activate();
        marked = /* @__PURE__ */new Set();
        checked = /* @__PURE__ */new Map();
        for (var _i6 = 0, _sources = sources; _i6 < _sources.length; _i6++) {
          source2 = _sources[_i6];
          mark_effects(source2, others, marked, checked);
        }
        checked = /* @__PURE__ */new Map();
        current_unequal = _toConsumableArray(batch.current).filter(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
            c = _ref8[0],
            v1 = _ref8[1];
          var v2 = _this17.current.get(c);
          if (!v2) return true;
          return v2[0] !== v1[0] || v2[1] !== v1[1];
        }).map(function (_ref9) {
          var _ref0 = _slicedToArray(_ref9, 1),
            c = _ref0[0];
          return c;
        });
        if (current_unequal.length > 0) {
          var _iterator61 = _createForOfIteratorHelper(_classPrivateFieldGet(_new_effects, _this17)),
            _step61;
          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var _effect2 = _step61.value;
              if ((_effect2.f & (DESTROYED | INERT | EAGER_EFFECT)) === 0 && depends_on(_effect2, current_unequal, checked)) {
                if ((_effect2.f & (ASYNC | BLOCK_EFFECT)) !== 0) {
                  set_signal_status(_effect2, DIRTY);
                  batch.schedule(_effect2);
                } else {
                  _classPrivateFieldGet(_dirty_effects, batch).add(_effect2);
                }
              }
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }
        }
        if (_classPrivateFieldGet(_roots, batch).length > 0 && !_classPrivateFieldGet(_decrement_queued, batch)) {
          batch.apply();
          var _iterator62 = _createForOfIteratorHelper(_classPrivateFieldGet(_roots, batch)),
            _step62;
          try {
            for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
              root2 = _step62.value;
              _assertClassBrand(_Batch_brand, _batch2 = batch, _traverse).call(_batch2, root2, [], []);
            }
          } catch (err) {
            _iterator62.e(err);
          } finally {
            _iterator62.f();
          }
          _classPrivateFieldSet(_roots, batch, []);
        }
        batch.deactivate();
      }
    },
    is_earlier,
    sources,
    batch_value,
    current,
    others,
    marked,
    checked,
    source2,
    current_unequal,
    root2,
    _batch2;
  for (var batch = first_batch; batch !== null; batch = _classPrivateFieldGet(_next, batch)) {
    if (_loop7(batch)) continue;
  }
}
function _unlink() {
  if (!this.linked) return;
  var prev = _classPrivateFieldGet(_prev, this);
  var next2 = _classPrivateFieldGet(_next, this);
  if (prev === null) {
    first_batch = next2;
  } else {
    _classPrivateFieldSet(_next, prev, next2);
  }
  if (next2 === null) {
    last_batch = prev;
  } else {
    _classPrivateFieldSet(_prev, next2, prev);
  }
  this.linked = false;
}
function flushSync(fn) {
  var was_flushing_sync = is_flushing_sync;
  is_flushing_sync = true;
  try {
    var result;
    if (fn) ;
    while (true) {
      flush_tasks();
      if (current_batch === null) {
        return /** @type {T} */result;
      }
      current_batch.flush();
    }
  } finally {
    is_flushing_sync = was_flushing_sync;
  }
}
function infinite_loop_guard() {
  try {
    effect_update_depth_exceeded();
  } catch (error) {
    invoke_error_boundary(error, last_scheduled_effect);
  }
}
var eager_block_effects = null;
function flush_queued_effects(effects) {
  var length = effects.length;
  if (length === 0) return;
  var i = 0;
  while (i < length) {
    var effect2 = effects[i++];
    if ((effect2.f & (DESTROYED | INERT)) === 0 && is_dirty(effect2)) {
      var _eager_block_effects;
      eager_block_effects = /* @__PURE__ */new Set();
      update_effect(effect2);
      if (effect2.deps === null && effect2.first === null && effect2.nodes === null && effect2.teardown === null && effect2.ac === null) {
        unlink_effect(effect2);
      }
      if (((_eager_block_effects = eager_block_effects) === null || _eager_block_effects === void 0 ? void 0 : _eager_block_effects.size) > 0) {
        old_values.clear();
        var _iterator14 = _createForOfIteratorHelper(eager_block_effects),
          _step14;
        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var e = _step14.value;
            if ((e.f & (DESTROYED | INERT)) !== 0) continue;
            var ordered_effects = [e];
            var ancestor = e.parent;
            while (ancestor !== null) {
              if (eager_block_effects.has(ancestor)) {
                eager_block_effects["delete"](ancestor);
                ordered_effects.push(ancestor);
              }
              ancestor = ancestor.parent;
            }
            for (var j = ordered_effects.length - 1; j >= 0; j--) {
              var e2 = ordered_effects[j];
              if ((e2.f & (DESTROYED | INERT)) !== 0) continue;
              update_effect(e2);
            }
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }
        eager_block_effects.clear();
      }
    }
  }
  eager_block_effects = null;
}
function mark_effects(value, sources, marked, checked) {
  if (marked.has(value)) return;
  marked.add(value);
  if (value.reactions !== null) {
    var _iterator15 = _createForOfIteratorHelper(value.reactions),
      _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var reaction = _step15.value;
        var flags2 = reaction.f;
        if ((flags2 & DERIVED) !== 0) {
          mark_effects(/** @type {Derived} */
          reaction, sources, marked, checked);
        } else if ((flags2 & (ASYNC | BLOCK_EFFECT)) !== 0 && (flags2 & DIRTY) === 0 && depends_on(reaction, sources, checked)) {
          set_signal_status(reaction, DIRTY);
          schedule_effect(/** @type {Effect} */
          reaction);
        }
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
  }
}
function depends_on(reaction, sources, checked) {
  var depends = checked.get(reaction);
  if (depends !== void 0) return depends;
  if (reaction.deps !== null) {
    var _iterator16 = _createForOfIteratorHelper(reaction.deps),
      _step16;
    try {
      for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
        var dep = _step16.value;
        if (includes.call(sources, dep)) {
          return true;
        }
        if ((dep.f & DERIVED) !== 0 && depends_on(/** @type {Derived} */
        dep, sources, checked)) {
          checked.set(/** @type {Derived} */
          dep, true);
          return true;
        }
      }
    } catch (err) {
      _iterator16.e(err);
    } finally {
      _iterator16.f();
    }
  }
  checked.set(reaction, false);
  return false;
}
function schedule_effect(effect2) {
  current_batch.schedule(effect2);
}
function reset_branch(effect2, tracked) {
  if ((effect2.f & BRANCH_EFFECT) !== 0 && (effect2.f & CLEAN) !== 0) {
    return;
  }
  if ((effect2.f & DIRTY) !== 0) {
    tracked.d.push(effect2);
  } else if ((effect2.f & MAYBE_DIRTY) !== 0) {
    tracked.m.push(effect2);
  }
  set_signal_status(effect2, CLEAN);
  var e = effect2.first;
  while (e !== null) {
    reset_branch(e, tracked);
    e = e.next;
  }
}
function reset_all(effect2) {
  set_signal_status(effect2, CLEAN);
  var e = effect2.first;
  while (e !== null) {
    reset_all(e);
    e = e.next;
  }
}
var eager_effects = /* @__PURE__ */new Set();
var old_values = /* @__PURE__ */new Map();
var eager_effects_deferred = false;
function source(v, stack) {
  var signal = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: v,
    reactions: null,
    equals: equals,
    rv: 0,
    wv: 0
  };
  return signal;
}
// @__NO_SIDE_EFFECTS__
function state(v, stack) {
  var s = source(v);
  push_reaction_value(s);
  return s;
}
// @__NO_SIDE_EFFECTS__
function mutable_source(initial_value) {
  var immutable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var trackable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var s = source(initial_value);
  if (!immutable) {
    s.equals = safe_equals;
  }
  return s;
}
function _set(source2, value) {
  var should_proxy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (active_reaction !== null && (
  // since we are untracking the function inside `$inspect.with` we need to add this check
  // to ensure we error if state is set inside an inspect effect
  !untracking || (active_reaction.f & EAGER_EFFECT) !== 0) && is_runes() && (active_reaction.f & (DERIVED | BLOCK_EFFECT | ASYNC | EAGER_EFFECT)) !== 0 && (current_sources === null || !current_sources.has(source2))) {
    state_unsafe_mutation();
  }
  var new_value = should_proxy ? proxy(value) : value;
  return internal_set(source2, new_value, legacy_updates);
}
function internal_set(source2, value) {
  var updated_during_traversal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!source2.equals(value)) {
    if (is_destroying_effect) {
      old_values.set(source2, value);
    } else if (!old_values.has(source2)) {
      old_values.set(source2, source2.v);
    }
    var batch = Batch.ensure();
    batch.capture(source2, value);
    if ((source2.f & DERIVED) !== 0) {
      var derived2 = /** @type {Derived} */
      source2;
      if ((source2.f & DIRTY) !== 0) {
        execute_derived(derived2);
      }
      if (batch_values === null) {
        update_derived_status(derived2);
      }
    }
    source2.wv = increment_write_version();
    mark_reactions(source2, DIRTY, updated_during_traversal);
    if (active_effect !== null && (active_effect.f & CLEAN) !== 0 && (active_effect.f & (BRANCH_EFFECT | ROOT_EFFECT)) === 0) {
      if (untracked_writes === null) {
        set_untracked_writes([source2]);
      } else {
        untracked_writes.push(source2);
      }
    }
    if (!batch.is_fork && eager_effects.size > 0 && !eager_effects_deferred) {
      flush_eager_effects();
    }
  }
  return value;
}
function flush_eager_effects() {
  eager_effects_deferred = false;
  var _iterator17 = _createForOfIteratorHelper(eager_effects),
    _step17;
  try {
    for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
      var effect2 = _step17.value;
      if ((effect2.f & CLEAN) !== 0) {
        set_signal_status(effect2, MAYBE_DIRTY);
      }
      var dirty = void 0;
      try {
        dirty = is_dirty(effect2);
      } catch (_unused2) {
        dirty = true;
      }
      if (dirty) {
        update_effect(effect2);
      }
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }
  eager_effects.clear();
}
function increment(source2) {
  _set(source2, source2.v + 1);
}
function mark_reactions(signal, status, updated_during_traversal) {
  var reactions = signal.reactions;
  if (reactions === null) return;
  var length = reactions.length;
  for (var i = 0; i < length; i++) {
    var reaction = reactions[i];
    var flags2 = reaction.f;
    var not_dirty = (flags2 & DIRTY) === 0;
    if (not_dirty) {
      set_signal_status(reaction, status);
    }
    if ((flags2 & EAGER_EFFECT) !== 0) {
      eager_effects.add(/** @type {Effect} */
      reaction);
    } else if ((flags2 & DERIVED) !== 0) {
      var _batch_values2;
      var derived2 = /** @type {Derived} */
      reaction;
      (_batch_values2 = batch_values) === null || _batch_values2 === void 0 || _batch_values2["delete"](derived2);
      if ((flags2 & WAS_MARKED) === 0) {
        if (flags2 & CONNECTED && (active_effect === null || (active_effect.f & REACTION_IS_UPDATING) === 0)) {
          reaction.f |= WAS_MARKED;
        }
        mark_reactions(derived2, MAYBE_DIRTY, updated_during_traversal);
      }
    } else if (not_dirty) {
      var effect2 = /** @type {Effect} */
      reaction;
      if ((flags2 & BLOCK_EFFECT) !== 0 && eager_block_effects !== null) {
        eager_block_effects.add(effect2);
      }
      if (updated_during_traversal !== null) {
        updated_during_traversal.push(effect2);
      } else {
        schedule_effect(effect2);
      }
    }
  }
}
var is_updating_effect = false;
var is_destroying_effect = false;
function set_is_destroying_effect(value) {
  is_destroying_effect = value;
}
var active_reaction = null;
var untracking = false;
function set_active_reaction(reaction) {
  active_reaction = reaction;
}
var active_effect = null;
function set_active_effect(effect2) {
  active_effect = effect2;
}
var current_sources = null;
function push_reaction_value(value) {
  if (active_reaction !== null && true) {
    (current_sources !== null && current_sources !== void 0 ? current_sources : current_sources = /* @__PURE__ */new Set()).add(value);
  }
}
var new_deps = null;
var skipped_deps = 0;
var untracked_writes = null;
function set_untracked_writes(value) {
  untracked_writes = value;
}
var write_version = 1;
var read_version = 0;
var update_version = read_version;
function set_update_version(value) {
  update_version = value;
}
function increment_write_version() {
  return ++write_version;
}
function is_dirty(reaction) {
  var flags2 = reaction.f;
  if ((flags2 & DIRTY) !== 0) {
    return true;
  }
  if (flags2 & DERIVED) {
    reaction.f &= ~WAS_MARKED;
  }
  if ((flags2 & MAYBE_DIRTY) !== 0) {
    var dependencies = /** @type {Value[]} */
    reaction.deps;
    var length = dependencies.length;
    for (var i = 0; i < length; i++) {
      var dependency = dependencies[i];
      if (is_dirty(/** @type {Derived} */
      dependency)) {
        update_derived(/** @type {Derived} */
        dependency);
      }
      if (dependency.wv > reaction.wv) {
        return true;
      }
    }
    if ((flags2 & CONNECTED) !== 0 &&
    // During time traveling we don't want to reset the status so that
    // traversal of the graph in the other batches still happens
    batch_values === null) {
      set_signal_status(reaction, CLEAN);
    }
  }
  return false;
}
function schedule_possible_effect_self_invalidation(signal, effect2) {
  var root2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var reactions = signal.reactions;
  if (reactions === null) return;
  if (current_sources !== null && current_sources.has(signal)) {
    return;
  }
  for (var i = 0; i < reactions.length; i++) {
    var reaction = reactions[i];
    if ((reaction.f & DERIVED) !== 0) {
      schedule_possible_effect_self_invalidation(/** @type {Derived} */
      reaction, effect2, false);
    } else if (effect2 === reaction) {
      if (root2) {
        set_signal_status(reaction, DIRTY);
      } else if ((reaction.f & CLEAN) !== 0) {
        set_signal_status(reaction, MAYBE_DIRTY);
      }
      schedule_effect(/** @type {Effect} */
      reaction);
    }
  }
}
function update_reaction(reaction) {
  var previous_deps = new_deps;
  var previous_skipped_deps = skipped_deps;
  var previous_untracked_writes = untracked_writes;
  var previous_reaction = active_reaction;
  var previous_sources = current_sources;
  var previous_component_context = component_context;
  var previous_untracking = untracking;
  var previous_update_version = update_version;
  var flags2 = reaction.f;
  new_deps = /** @type {null | Value[]} */
  null;
  skipped_deps = 0;
  untracked_writes = null;
  active_reaction = (flags2 & (BRANCH_EFFECT | ROOT_EFFECT)) === 0 ? reaction : null;
  current_sources = null;
  set_component_context(reaction.ctx);
  untracking = false;
  update_version = ++read_version;
  if (reaction.ac !== null) {
    without_reactive_context(function () {
      reaction.ac.abort(STALE_REACTION);
    });
    reaction.ac = null;
  }
  try {
    reaction.f |= REACTION_IS_UPDATING;
    var fn = /** @type {Function} */
    reaction.fn;
    var result = fn();
    reaction.f |= REACTION_RAN;
    var deps = update_dependencies(reaction);
    if (is_runes() && untracked_writes !== null && !untracking && deps !== null && (reaction.f & (DERIVED | MAYBE_DIRTY | DIRTY)) === 0) {
      for (var i = 0; i < /** @type {Source[]} */
      untracked_writes.length; i++) {
        schedule_possible_effect_self_invalidation(untracked_writes[i], /** @type {Effect} */
        reaction);
      }
    }
    if (previous_reaction !== null && previous_reaction !== reaction) {
      read_version++;
      if (previous_reaction.deps !== null) {
        for (var i2 = 0; i2 < previous_skipped_deps; i2 += 1) {
          previous_reaction.deps[i2].rv = read_version;
        }
      }
      if (previous_deps !== null) {
        var _iterator18 = _createForOfIteratorHelper(previous_deps),
          _step18;
        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var dep = _step18.value;
            dep.rv = read_version;
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      }
      if (untracked_writes !== null) {
        if (previous_untracked_writes === null) {
          previous_untracked_writes = untracked_writes;
        } else {
          var _previous_untracked_w;
          (_previous_untracked_w = previous_untracked_writes).push.apply(_previous_untracked_w, _toConsumableArray(/** @type {Source[]} */
          untracked_writes));
        }
      }
    }
    if ((reaction.f & ERROR_VALUE) !== 0) {
      reaction.f ^= ERROR_VALUE;
    }
    return result;
  } catch (error) {
    update_dependencies(reaction);
    return handle_error(error);
  } finally {
    reaction.f ^= REACTION_IS_UPDATING;
    new_deps = previous_deps;
    skipped_deps = previous_skipped_deps;
    untracked_writes = previous_untracked_writes;
    active_reaction = previous_reaction;
    current_sources = previous_sources;
    set_component_context(previous_component_context);
    untracking = previous_untracking;
    update_version = previous_update_version;
  }
}
function update_dependencies(reaction) {
  var _current_batch5;
  var deps = reaction.deps;
  var is_fork = (_current_batch5 = current_batch) === null || _current_batch5 === void 0 ? void 0 : _current_batch5.is_fork;
  if (new_deps !== null) {
    var i;
    if (!is_fork) {
      remove_reactions(reaction, skipped_deps);
    }
    if (deps !== null && skipped_deps > 0) {
      deps.length = skipped_deps + new_deps.length;
      for (i = 0; i < new_deps.length; i++) {
        deps[skipped_deps + i] = new_deps[i];
      }
    } else {
      reaction.deps = deps = new_deps;
    }
    if (effect_tracking() && (reaction.f & CONNECTED) !== 0) {
      for (i = skipped_deps; i < deps.length; i++) {
        var _deps$i, _deps$i$reactions;
        ((_deps$i$reactions = (_deps$i = deps[i]).reactions) !== null && _deps$i$reactions !== void 0 ? _deps$i$reactions : _deps$i.reactions = []).push(reaction);
      }
    }
  } else if (!is_fork && deps !== null && skipped_deps < deps.length) {
    remove_reactions(reaction, skipped_deps);
    deps.length = skipped_deps;
  }
  return deps;
}
function remove_reaction(signal, dependency) {
  var reactions = dependency.reactions;
  if (reactions !== null) {
    var index = index_of.call(reactions, signal);
    if (index !== -1) {
      var new_length = reactions.length - 1;
      if (new_length === 0) {
        reactions = dependency.reactions = null;
      } else {
        reactions[index] = reactions[new_length];
        reactions.pop();
      }
    }
  }
  if (reactions === null && (dependency.f & DERIVED) !== 0 && (
  // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  new_deps === null || !includes.call(new_deps, dependency))) {
    var derived2 = /** @type {Derived} */
    dependency;
    if ((derived2.f & CONNECTED) !== 0) {
      derived2.f ^= CONNECTED;
      derived2.f &= ~WAS_MARKED;
    }
    if (derived2.v !== UNINITIALIZED) {
      update_derived_status(derived2);
    }
    if (derived2.ac !== null) {
      without_reactive_context(function () {
        derived2.ac.abort(STALE_REACTION);
        derived2.ac = null;
        set_signal_status(derived2, DIRTY);
      });
    }
    freeze_derived_effects(derived2);
    remove_reactions(derived2, 0);
  }
}
function remove_reactions(signal, start_index) {
  var dependencies = signal.deps;
  if (dependencies === null) return;
  for (var i = start_index; i < dependencies.length; i++) {
    remove_reaction(signal, dependencies[i]);
  }
}
function update_effect(effect2) {
  var flags2 = effect2.f;
  if ((flags2 & DESTROYED) !== 0) {
    return;
  }
  set_signal_status(effect2, CLEAN);
  var previous_effect = active_effect;
  var was_updating_effect = is_updating_effect;
  active_effect = effect2;
  is_updating_effect = (flags2 & (BRANCH_EFFECT | ROOT_EFFECT)) === 0;
  try {
    if ((flags2 & (BLOCK_EFFECT | MANAGED_EFFECT)) !== 0) {
      destroy_block_effect_children(effect2);
    } else {
      destroy_effect_children(effect2);
    }
    execute_effect_teardown(effect2);
    var teardown2 = update_reaction(effect2);
    effect2.teardown = typeof teardown2 === "function" ? teardown2 : null;
    effect2.wv = write_version;
    var dep;
    if (DEV && tracing_mode_flag && (effect2.f & DIRTY) !== 0 && effect2.deps !== null) ;
  } finally {
    is_updating_effect = was_updating_effect;
    active_effect = previous_effect;
  }
}
function tick() {
  return _tick.apply(this, arguments);
}
function _tick() {
  _tick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          _context0.n = 1;
          return Promise.resolve();
        case 1:
          flushSync();
        case 2:
          return _context0.a(2);
      }
    }, _callee0);
  }));
  return _tick.apply(this, arguments);
}
function _get(signal) {
  var _batch_values3;
  var flags2 = signal.f;
  var is_derived = (flags2 & DERIVED) !== 0;
  if (active_reaction !== null && !untracking) {
    var destroyed = active_effect !== null && (active_effect.f & DESTROYED) !== 0;
    if (!destroyed && (current_sources === null || !current_sources.has(signal))) {
      var deps = active_reaction.deps;
      if ((active_reaction.f & REACTION_IS_UPDATING) !== 0) {
        if (signal.rv < read_version) {
          signal.rv = read_version;
          if (new_deps === null && deps !== null && deps[skipped_deps] === signal) {
            skipped_deps++;
          } else if (new_deps === null) {
            new_deps = [signal];
          } else {
            new_deps.push(signal);
          }
        }
      } else {
        var _active_reaction, _active_reaction$deps;
        (_active_reaction$deps = (_active_reaction = active_reaction).deps) !== null && _active_reaction$deps !== void 0 ? _active_reaction$deps : _active_reaction.deps = [];
        if (!includes.call(active_reaction.deps, signal)) {
          active_reaction.deps.push(signal);
        }
        var reactions = signal.reactions;
        if (reactions === null) {
          signal.reactions = [active_reaction];
        } else if (!includes.call(reactions, active_reaction)) {
          reactions.push(active_reaction);
        }
      }
    }
  }
  if (is_destroying_effect && old_values.has(signal)) {
    return old_values.get(signal);
  }
  if (is_derived) {
    var derived2 = /** @type {Derived} */
    signal;
    if (is_destroying_effect) {
      var value = derived2.v;
      if ((derived2.f & CLEAN) === 0 && derived2.reactions !== null || depends_on_old_values(derived2)) {
        value = execute_derived(derived2);
      }
      old_values.set(derived2, value);
      return value;
    }
    var should_connect = (derived2.f & CONNECTED) === 0 && !untracking && active_reaction !== null && (is_updating_effect || (active_reaction.f & CONNECTED) !== 0);
    var is_new = (derived2.f & REACTION_RAN) === 0;
    if (is_dirty(derived2)) {
      if (should_connect) {
        derived2.f |= CONNECTED;
      }
      update_derived(derived2);
    }
    if (should_connect && !is_new) {
      unfreeze_derived_effects(derived2);
      reconnect(derived2);
    }
  }
  if ((_batch_values3 = batch_values) !== null && _batch_values3 !== void 0 && _batch_values3.has(signal)) {
    return batch_values.get(signal);
  }
  if ((signal.f & ERROR_VALUE) !== 0) {
    throw signal.v;
  }
  return signal.v;
}
function reconnect(derived2) {
  derived2.f |= CONNECTED;
  if (derived2.deps === null) return;
  var _iterator19 = _createForOfIteratorHelper(derived2.deps),
    _step19;
  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var _dep$reactions;
      var dep = _step19.value;
      ((_dep$reactions = dep.reactions) !== null && _dep$reactions !== void 0 ? _dep$reactions : dep.reactions = []).push(derived2);
      if ((dep.f & DERIVED) !== 0 && (dep.f & CONNECTED) === 0) {
        unfreeze_derived_effects(/** @type {Derived} */
        dep);
        reconnect(/** @type {Derived} */
        dep);
      }
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
}
function depends_on_old_values(derived2) {
  if (derived2.v === UNINITIALIZED) return true;
  if (derived2.deps === null) return false;
  var _iterator20 = _createForOfIteratorHelper(derived2.deps),
    _step20;
  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var dep = _step20.value;
      if (old_values.has(dep)) {
        return true;
      }
      if ((dep.f & DERIVED) !== 0 && depends_on_old_values(/** @type {Derived} */
      dep)) {
        return true;
      }
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
  return false;
}
function untrack(fn) {
  var previous_untracking = untracking;
  try {
    untracking = true;
    return fn();
  } finally {
    untracking = previous_untracking;
  }
}
function validate_effect(rune) {
  if (active_effect === null) {
    if (active_reaction === null) {
      effect_orphan();
    }
    effect_in_unowned_derived();
  }
  if (is_destroying_effect) {
    effect_in_teardown();
  }
}
function push_effect(effect2, parent_effect) {
  var parent_last = parent_effect.last;
  if (parent_last === null) {
    parent_effect.last = parent_effect.first = effect2;
  } else {
    parent_last.next = effect2;
    effect2.prev = parent_last;
    parent_effect.last = effect2;
  }
}
function create_effect(type, fn) {
  var _current_batch6;
  var parent = active_effect;
  if (parent !== null && (parent.f & INERT) !== 0) {
    type |= INERT;
  }
  var effect2 = {
    ctx: component_context,
    deps: null,
    nodes: null,
    f: type | DIRTY | CONNECTED,
    first: null,
    fn: fn,
    last: null,
    next: null,
    parent: parent,
    b: parent && parent.b,
    prev: null,
    teardown: null,
    wv: 0,
    ac: null
  };
  (_current_batch6 = current_batch) === null || _current_batch6 === void 0 || _current_batch6.register_created_effect(effect2);
  var e = effect2;
  if ((type & EFFECT) !== 0) {
    if (collected_effects !== null) {
      collected_effects.push(effect2);
    } else {
      Batch.ensure().schedule(effect2);
    }
  } else if (fn !== null) {
    try {
      update_effect(effect2);
    } catch (e2) {
      destroy_effect(effect2);
      throw e2;
    }
    if (e.deps === null && e.teardown === null && e.nodes === null && e.first === e.last &&
    // either `null`, or a singular child
    (e.f & EFFECT_PRESERVED) === 0) {
      e = e.first;
      if ((type & BLOCK_EFFECT) !== 0 && (type & EFFECT_TRANSPARENT) !== 0 && e !== null) {
        e.f |= EFFECT_TRANSPARENT;
      }
    }
  }
  if (e !== null) {
    e.parent = parent;
    if (parent !== null) {
      push_effect(e, parent);
    }
    if (active_reaction !== null && (active_reaction.f & DERIVED) !== 0 && (type & ROOT_EFFECT) === 0) {
      var _derived2$effects;
      var derived2 = /** @type {Derived} */
      active_reaction;
      ((_derived2$effects = derived2.effects) !== null && _derived2$effects !== void 0 ? _derived2$effects : derived2.effects = []).push(e);
    }
  }
  return effect2;
}
function effect_tracking() {
  return active_reaction !== null && !untracking;
}
function teardown(fn) {
  var effect2 = create_effect(RENDER_EFFECT, null);
  set_signal_status(effect2, CLEAN);
  effect2.teardown = fn;
  return effect2;
}
function user_effect(fn) {
  validate_effect();
  var flags2 = /** @type {Effect} */
  active_effect.f;
  var defer = !active_reaction && (flags2 & BRANCH_EFFECT) !== 0 && component_context !== null && !component_context.i;
  if (defer) {
    var _context$e;
    var context = /** @type {ComponentContext} */
    component_context;
    ((_context$e = context.e) !== null && _context$e !== void 0 ? _context$e : context.e = []).push(fn);
  } else {
    return create_user_effect(fn);
  }
}
function create_user_effect(fn) {
  return create_effect(EFFECT | USER_EFFECT, fn);
}
function effect_root(fn) {
  Batch.ensure();
  var effect2 = create_effect(ROOT_EFFECT | EFFECT_PRESERVED, fn);
  return function () {
    destroy_effect(effect2);
  };
}
function component_root(fn) {
  Batch.ensure();
  var effect2 = create_effect(ROOT_EFFECT | EFFECT_PRESERVED, fn);
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (fulfil) {
      if (options.outro) {
        pause_effect(effect2, function () {
          destroy_effect(effect2);
          fulfil(void 0);
        });
      } else {
        destroy_effect(effect2);
        fulfil(void 0);
      }
    });
  };
}
function effect(fn) {
  return create_effect(EFFECT, fn);
}
function async_effect(fn) {
  return create_effect(ASYNC | EFFECT_PRESERVED, fn);
}
function render_effect(fn) {
  var flags2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return create_effect(RENDER_EFFECT | flags2, fn);
}
function template_effect(fn) {
  var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var blockers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  flatten(blockers, sync, async, function (values) {
    create_effect(RENDER_EFFECT, function () {
      fn.apply(void 0, _toConsumableArray(values.map(_get)));
    });
  });
}
function block(fn) {
  var flags2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var effect2 = create_effect(BLOCK_EFFECT | flags2, fn);
  return effect2;
}
function managed(fn) {
  var flags2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var effect2 = create_effect(MANAGED_EFFECT | flags2, fn);
  return effect2;
}
function branch(fn) {
  return create_effect(BRANCH_EFFECT | EFFECT_PRESERVED, fn);
}
function execute_effect_teardown(effect2) {
  var teardown2 = effect2.teardown;
  if (teardown2 !== null) {
    var previously_destroying_effect = is_destroying_effect;
    var previous_reaction = active_reaction;
    set_is_destroying_effect(true);
    set_active_reaction(null);
    try {
      teardown2.call(null);
    } catch (error) {
      invoke_error_boundary(error, effect2.parent);
    } finally {
      set_is_destroying_effect(previously_destroying_effect);
      set_active_reaction(previous_reaction);
    }
  }
}
function destroy_effect_children(signal) {
  var remove_dom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var effect2 = signal.first;
  signal.first = signal.last = null;
  var _loop2 = function _loop2() {
      var controller = effect2.ac;
      if (controller !== null) {
        without_reactive_context(function () {
          controller.abort(STALE_REACTION);
        });
      }
      next2 = effect2.next;
      if ((effect2.f & ROOT_EFFECT) !== 0) {
        effect2.parent = null;
      } else {
        destroy_effect(effect2, remove_dom);
      }
      effect2 = next2;
    },
    next2;
  while (effect2 !== null) {
    _loop2();
  }
}
function destroy_block_effect_children(signal) {
  var effect2 = signal.first;
  while (effect2 !== null) {
    var next2 = effect2.next;
    if ((effect2.f & BRANCH_EFFECT) === 0) {
      destroy_effect(effect2);
    }
    effect2 = next2;
  }
}
function destroy_effect(effect2) {
  var remove_dom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var removed = false;
  if ((remove_dom || (effect2.f & HEAD_EFFECT) !== 0) && effect2.nodes !== null && effect2.nodes.end !== null) {
    remove_effect_dom(effect2.nodes.start, /** @type {TemplateNode} */
    effect2.nodes.end);
    removed = true;
  }
  effect2.f |= DESTROYING;
  destroy_effect_children(effect2, remove_dom && !removed);
  remove_reactions(effect2, 0);
  var transitions = effect2.nodes && effect2.nodes.t;
  if (transitions !== null) {
    var _iterator21 = _createForOfIteratorHelper(transitions),
      _step21;
    try {
      for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
        var transition = _step21.value;
        transition.stop();
      }
    } catch (err) {
      _iterator21.e(err);
    } finally {
      _iterator21.f();
    }
  }
  execute_effect_teardown(effect2);
  effect2.f ^= DESTROYING;
  effect2.f |= DESTROYED;
  var parent = effect2.parent;
  if (parent !== null && parent.first !== null) {
    unlink_effect(effect2);
  }
  effect2.next = effect2.prev = effect2.teardown = effect2.ctx = effect2.deps = effect2.fn = effect2.nodes = effect2.ac = effect2.b = null;
}
function remove_effect_dom(node, end) {
  while (node !== null) {
    var next2 = node === end ? null : /* @__PURE__ */get_next_sibling(node);
    node.remove();
    node = next2;
  }
}
function unlink_effect(effect2) {
  var parent = effect2.parent;
  var prev = effect2.prev;
  var next2 = effect2.next;
  if (prev !== null) prev.next = next2;
  if (next2 !== null) next2.prev = prev;
  if (parent !== null) {
    if (parent.first === effect2) parent.first = next2;
    if (parent.last === effect2) parent.last = prev;
  }
}
function pause_effect(effect2, callback) {
  var destroy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var transitions = [];
  effect2.f |= PAUSED;
  pause_children(effect2, transitions, true);
  var fn = function fn() {
    if (destroy) destroy_effect(effect2);
    if (callback) callback();
  };
  var remaining = transitions.length;
  if (remaining > 0) {
    var check = function check() {
      return --remaining || fn();
    };
    var _iterator22 = _createForOfIteratorHelper(transitions),
      _step22;
    try {
      for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
        var transition = _step22.value;
        transition.out(check);
      }
    } catch (err) {
      _iterator22.e(err);
    } finally {
      _iterator22.f();
    }
  } else {
    fn();
  }
}
function pause_children(effect2, transitions, local) {
  if ((effect2.f & INERT) !== 0) return;
  effect2.f ^= INERT;
  var t = effect2.nodes && effect2.nodes.t;
  if (t !== null) {
    var _iterator23 = _createForOfIteratorHelper(t),
      _step23;
    try {
      for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
        var transition = _step23.value;
        if (transition.is_global || local) {
          transitions.push(transition);
        }
      }
    } catch (err) {
      _iterator23.e(err);
    } finally {
      _iterator23.f();
    }
  }
  var child2 = effect2.first;
  while (child2 !== null) {
    var sibling2 = child2.next;
    if ((child2.f & ROOT_EFFECT) === 0) {
      var transparent = (child2.f & EFFECT_TRANSPARENT) !== 0 ||
      // If this is a branch effect without a block effect parent,
      // it means the parent block effect was pruned. In that case,
      // transparency information was transferred to the branch effect.
      (child2.f & BRANCH_EFFECT) !== 0 && (effect2.f & BLOCK_EFFECT) !== 0;
      pause_children(child2, transitions, transparent ? local : false);
    }
    child2 = sibling2;
  }
}
function resume_effect(effect2) {
  effect2.f &= ~PAUSED;
  resume_children(effect2, true);
}
function resume_children(effect2, local) {
  if ((effect2.f & PAUSED) !== 0) return;
  if ((effect2.f & INERT) === 0) return;
  effect2.f ^= INERT;
  if ((effect2.f & CLEAN) === 0) {
    set_signal_status(effect2, DIRTY);
    Batch.ensure().schedule(effect2);
  }
  var child2 = effect2.first;
  while (child2 !== null) {
    var sibling2 = child2.next;
    var transparent = (child2.f & EFFECT_TRANSPARENT) !== 0 || (child2.f & BRANCH_EFFECT) !== 0;
    resume_children(child2, transparent ? local : false);
    child2 = sibling2;
  }
  var t = effect2.nodes && effect2.nodes.t;
  if (t !== null) {
    var _iterator24 = _createForOfIteratorHelper(t),
      _step24;
    try {
      for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
        var transition = _step24.value;
        if (transition.is_global || local) {
          transition["in"]();
        }
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }
  }
}
function move_effect(effect2, fragment) {
  if (!effect2.nodes) return;
  var node = effect2.nodes.start;
  var end = effect2.nodes.end;
  while (node !== null) {
    var next2 = node === end ? null : /* @__PURE__ */get_next_sibling(node);
    fragment.append(node);
    node = next2;
  }
}
function createSubscriber(start) {
  var subscribers = 0;
  var version = source(0);
  var stop;
  return function () {
    if (effect_tracking()) {
      _get(version);
      render_effect(function () {
        if (subscribers === 0) {
          stop = untrack(function () {
            return start(function () {
              return increment(version);
            });
          });
        }
        subscribers += 1;
        return function () {
          queue_micro_task(function () {
            subscribers -= 1;
            if (subscribers === 0) {
              var _stop;
              (_stop = stop) === null || _stop === void 0 || _stop();
              stop = void 0;
              increment(version);
            }
          });
        };
      });
    }
  };
}
function store(defaultValue) {
  var scope = {
    get: function get(name) {
      return get$1(scope.store)[name];
    },
    set: function set(name, value) {
      if (typeof name === "string") {
        Object.assign(get$1(scope.store), _defineProperty({}, name, value));
      } else {
        Object.assign(get$1(scope.store), name);
      }
      scope.store.set(get$1(scope.store));
    },
    store: writable(defaultValue)
  };
  return scope;
}
globalThis.$altcha = globalThis.$altcha || {
  algorithms: /* @__PURE__ */new Map(),
  defaults: store({}),
  i18n: store({}),
  instances: /* @__PURE__ */new Set(),
  plugins: /* @__PURE__ */new Set()
};
var i18n = {
  ariaLinkLabel: "Altcha (official website)",
  cancel: "Cancel",
  enterCode: "Enter code",
  enterCodeAria: "Enter code you hear. Press Space to play audio.",
  enterCodeFromImage: "To proceed, please enter the code from the image below.",
  error: "Verification failed. Try again later.",
  expired: "Verification expired. Try again.",
  footer: 'Protected by <a href="https://altcha.org/" tabindex="-1" target="_blank" rel="noopener" aria-label="Altcha (official website)">ALTCHA</a>',
  getAudioChallenge: "Get an audio challenge",
  label: "I'm not a robot",
  loading: "Loading...",
  reload: "Reload",
  verify: "Verify",
  verificationRequired: "Verification required!",
  verified: "Verified",
  verifying: "Verifying...",
  waitAlert: "Verifying... please wait."
};
globalThis.$altcha.i18n.set("en", i18n);
var PUBLIC_VERSION = "5";
if (typeof window !== "undefined") {
  var _window$__svelte, _window$__svelte$v, _window, _window$__svelte2;
  ((_window$__svelte$v = (_window$__svelte = (_window$__svelte2 = (_window = window).__svelte) !== null && _window$__svelte2 !== void 0 ? _window$__svelte2 : _window.__svelte = {}).v) !== null && _window$__svelte$v !== void 0 ? _window$__svelte$v : _window$__svelte.v = /* @__PURE__ */new Set()).add(PUBLIC_VERSION);
}
var event_symbol = /* @__PURE__ */Symbol("events");
var all_registered_events = /* @__PURE__ */new Set();
var root_event_handles = /* @__PURE__ */new Set();
function create_event(event_name, dom, handler) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  function target_handler(event2) {
    var _this4 = this;
    if (!options.capture) {
      handle_event_propagation.call(dom, event2);
    }
    if (!event2.cancelBubble) {
      return without_reactive_context(function () {
        return handler === null || handler === void 0 ? void 0 : handler.call(_this4, event2);
      });
    }
  }
  if (event_name.startsWith("pointer") || event_name.startsWith("touch") || event_name === "wheel") {
    queue_micro_task(function () {
      dom.addEventListener(event_name, target_handler, options);
    });
  } else {
    dom.addEventListener(event_name, target_handler, options);
  }
  return target_handler;
}
function event(event_name, dom, handler, capture2, passive) {
  var options = {
    capture: capture2,
    passive: passive
  };
  var target_handler = create_event(event_name, dom, handler, options);
  if (dom === document.body ||
  // @ts-ignore
  dom === window ||
  // @ts-ignore
  dom === document ||
  // Firefox has quirky behavior, it can happen that we still get "canplay" events when the element is already removed
  dom instanceof HTMLMediaElement) {
    teardown(function () {
      dom.removeEventListener(event_name, target_handler, options);
    });
  }
}
function delegated(event_name, element, handler) {
  var _element$event_symbol;
  ((_element$event_symbol = element[event_symbol]) !== null && _element$event_symbol !== void 0 ? _element$event_symbol : element[event_symbol] = {})[event_name] = handler;
}
function delegate(events) {
  for (var i = 0; i < events.length; i++) {
    all_registered_events.add(events[i]);
  }
  var _iterator25 = _createForOfIteratorHelper(root_event_handles),
    _step25;
  try {
    for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
      var fn = _step25.value;
      fn(events);
    }
  } catch (err) {
    _iterator25.e(err);
  } finally {
    _iterator25.f();
  }
}
var last_propagated_event = null;
var last_propagated_event_clear_scheduled = false;
function handle_event_propagation(event2) {
  var _event2$composedPath;
  var handler_element = this;
  var owner_document = /** @type {Node} */
  handler_element.ownerDocument;
  var event_name = event2.type;
  var path = ((_event2$composedPath = event2.composedPath) === null || _event2$composedPath === void 0 ? void 0 : _event2$composedPath.call(event2)) || [];
  var current_target = /** @type {null | Element} */
  path[0] || event2.target;
  last_propagated_event = event2;
  if (!last_propagated_event_clear_scheduled) {
    last_propagated_event_clear_scheduled = true;
    setTimeout(function () {
      last_propagated_event_clear_scheduled = false;
      last_propagated_event = null;
    });
  }
  var path_idx = 0;
  var handled_at = last_propagated_event === event2 && event2[event_symbol];
  if (handled_at) {
    var at_idx = path.indexOf(handled_at);
    if (at_idx !== -1 && (handler_element === document || handler_element === /** @type {any} */
    window)) {
      event2[event_symbol] = handler_element;
      return;
    }
    var handler_idx = path.indexOf(handler_element);
    if (handler_idx === -1) {
      return;
    }
    if (at_idx <= handler_idx) {
      path_idx = at_idx;
    }
  }
  current_target = /** @type {Element} */
  path[path_idx] || event2.target;
  if (current_target === handler_element) return;
  define_property(event2, "currentTarget", {
    configurable: true,
    get: function get() {
      return current_target || owner_document;
    }
  });
  var previous_reaction = active_reaction;
  var previous_effect = active_effect;
  set_active_reaction(null);
  set_active_effect(null);
  try {
    var throw_error;
    var other_errors = [];
    while (current_target !== null) {
      if (current_target === handler_element) break;
      try {
        var _current_target$event;
        var delegated2 = (_current_target$event = current_target[event_symbol]) === null || _current_target$event === void 0 ? void 0 : _current_target$event[event_name];
        if (delegated2 != null && (! /** @type {any} */
        current_target.disabled ||
        // DOM could've been updated already by the time this is reached, so we check this as well
        // -> the target could not have been disabled because it emits the event in the first place
        event2.target === current_target)) {
          delegated2.call(current_target, event2);
        }
      } catch (error) {
        if (throw_error) {
          other_errors.push(error);
        } else {
          throw_error = error;
        }
      }
      if (event2.cancelBubble) break;
      path_idx++;
      current_target = path_idx < path.length ? (/** @type {Element} */
      path[path_idx]) : null;
    }
    if (throw_error) {
      var _iterator26 = _createForOfIteratorHelper(other_errors),
        _step26;
      try {
        var _loop3 = function _loop3() {
          var error = _step26.value;
          queueMicrotask(function () {
            throw error;
          });
        };
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          _loop3();
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }
      throw throw_error;
    }
  } finally {
    event2[event_symbol] = handler_element;
    delete event2.currentTarget;
    set_active_reaction(previous_reaction);
    set_active_effect(previous_effect);
  }
}
var policy =
// We gotta write it like this because after downleveling the pure comment may end up in the wrong location
(globalThis === null || globalThis === void 0 || (_globalThis$window = globalThis.window) === null || _globalThis$window === void 0 ? void 0 : _globalThis$window.trustedTypes) && /* @__PURE__ */globalThis.window.trustedTypes.createPolicy("svelte-trusted-html", {
  /** @param {string} html */
  createHTML: function createHTML(html2) {
    return html2;
  }
});
function create_trusted_html(html2) {
  var _policy$createHTML;
  return /** @type {string} */(_policy$createHTML = policy === null || policy === void 0 ? void 0 : policy.createHTML(html2)) !== null && _policy$createHTML !== void 0 ? _policy$createHTML : html2;
}
function create_fragment_from_html(html2) {
  var elem = create_element("template");
  elem.innerHTML = create_trusted_html(html2.replaceAll("<!>", "<!---->"));
  return elem.content;
}
function assign_nodes(start, end) {
  var effect2 = /** @type {Effect} */
  active_effect;
  if (effect2.nodes === null) {
    effect2.nodes = {
      start: start,
      end: end,
      a: null,
      t: null
    };
  }
}
// @__NO_SIDE_EFFECTS__
function from_html(content, flags2) {
  var is_fragment = (flags2 & TEMPLATE_FRAGMENT) !== 0;
  var use_import_node = (flags2 & TEMPLATE_USE_IMPORT_NODE) !== 0;
  var node;
  var has_start = !content.startsWith("<!>");
  return function () {
    if (hydrating) {
      assign_nodes(hydrate_node, null);
      return hydrate_node;
    }
    if (node === void 0) {
      node = create_fragment_from_html(has_start ? content : "<!>" + content);
      if (!is_fragment) node = /** @type {TemplateNode} */
      /* @__PURE__ */get_first_child(node);
    }
    var clone = /** @type {TemplateNode} */
    use_import_node || is_firefox ? document.importNode(node, true) : node.cloneNode(true);
    if (is_fragment) {
      var start = /** @type {TemplateNode} */
      /* @__PURE__ */get_first_child(clone);
      var end = /** @type {TemplateNode} */
      clone.lastChild;
      assign_nodes(start, end);
    } else {
      assign_nodes(clone, clone);
    }
    return clone;
  };
}
// @__NO_SIDE_EFFECTS__
function from_namespace(content, flags2) {
  var ns = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "svg";
  var has_start = !content.startsWith("<!>");
  var wrapped = "<".concat(ns, ">").concat(has_start ? content : "<!>" + content, "</").concat(ns, ">");
  var node;
  return function () {
    if (hydrating) {
      assign_nodes(hydrate_node, null);
      return hydrate_node;
    }
    if (!node) {
      var fragment = /** @type {DocumentFragment} */
      create_fragment_from_html(wrapped);
      var root2 = /** @type {Element} */
      /* @__PURE__ */get_first_child(fragment);
      {
        node = /** @type {Element} */
        /* @__PURE__ */get_first_child(root2);
      }
    }
    var clone = /** @type {TemplateNode} */
    node.cloneNode(true);
    {
      assign_nodes(clone, clone);
    }
    return clone;
  };
}
// @__NO_SIDE_EFFECTS__
function from_svg(content, flags2) {
  return /* @__PURE__ */from_namespace(content, flags2, "svg");
}
function text() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (!hydrating) {
    var t = create_text(value + "");
    assign_nodes(t, t);
    return t;
  }
  var node = hydrate_node;
  if (node.nodeType !== TEXT_NODE) {
    node.before(node = create_text());
    set_hydrate_node(node);
  } else {
    merge_text_nodes(/** @type {Text} */
    node);
  }
  assign_nodes(node, node);
  return node;
}
function comment() {
  if (hydrating) {
    assign_nodes(hydrate_node, null);
    return hydrate_node;
  }
  var frag = document.createDocumentFragment();
  var start = document.createComment("");
  var anchor = create_text();
  frag.append(start, anchor);
  assign_nodes(start, anchor);
  return frag;
}
function append(anchor, dom) {
  if (hydrating) {
    var effect2 = /** @type {Effect & { nodes: EffectNodes }} */
    active_effect;
    if ((effect2.f & REACTION_RAN) === 0 || effect2.nodes.end === null) {
      effect2.nodes.end = hydrate_node;
    }
    hydrate_next();
    return;
  }
  if (anchor === null) {
    return;
  }
  anchor.before(/** @type {Node} */
  dom);
}
function is_capture_event(name) {
  return name.endsWith("capture") && name !== "gotpointercapture" && name !== "lostpointercapture";
}
var DELEGATED_EVENTS = ["beforeinput", "click", "change", "dblclick", "contextmenu", "focusin", "focusout", "input", "keydown", "keyup", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "pointerdown", "pointermove", "pointerout", "pointerover", "pointerup", "touchend", "touchmove", "touchstart"];
function can_delegate_event(event_name) {
  return DELEGATED_EVENTS.includes(event_name);
}
var ATTRIBUTE_ALIASES = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject",
  novalidate: "noValidate",
  allowfullscreen: "allowFullscreen",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback"
};
function normalize_attribute(name) {
  var _ATTRIBUTE_ALIASES$na;
  name = name.toLowerCase();
  return (_ATTRIBUTE_ALIASES$na = ATTRIBUTE_ALIASES[name]) !== null && _ATTRIBUTE_ALIASES$na !== void 0 ? _ATTRIBUTE_ALIASES$na : name;
}
var PASSIVE_EVENTS = ["touchstart", "touchmove"];
function is_passive_event(name) {
  return PASSIVE_EVENTS.includes(name);
}
var flags = EFFECT_TRANSPARENT | EFFECT_PRESERVED;
function boundary(node, props, children, transform_error) {
  new Boundary(node, props, children, transform_error);
}
var _anchor = /*#__PURE__*/new WeakMap();
var _hydrate_open = /*#__PURE__*/new WeakMap();
var _props = /*#__PURE__*/new WeakMap();
var _children = /*#__PURE__*/new WeakMap();
var _effect = /*#__PURE__*/new WeakMap();
var _main_effect = /*#__PURE__*/new WeakMap();
var _pending_effect = /*#__PURE__*/new WeakMap();
var _failed_effect = /*#__PURE__*/new WeakMap();
var _offscreen_fragment = /*#__PURE__*/new WeakMap();
var _local_pending_count = /*#__PURE__*/new WeakMap();
var _pending_count = /*#__PURE__*/new WeakMap();
var _pending_count_update_queued = /*#__PURE__*/new WeakMap();
var _dirty_effects2 = /*#__PURE__*/new WeakMap();
var _maybe_dirty_effects2 = /*#__PURE__*/new WeakMap();
var _effect_pending = /*#__PURE__*/new WeakMap();
var _effect_pending_subscriber = /*#__PURE__*/new WeakMap();
var _Boundary_brand = /*#__PURE__*/new WeakSet();
var Boundary = /*#__PURE__*/function () {
  /**
   * @param {TemplateNode} node
   * @param {BoundaryProps} props
   * @param {((anchor: Node) => void)} children
   * @param {((error: unknown) => unknown) | undefined} [transform_error]
   */
  function Boundary(node, props, children, transform_error) {
    var _this5 = this,
      _ref,
      _this$parent2;
    _classCallCheck(this, Boundary);
    _classPrivateMethodInitSpec(this, _Boundary_brand);
    /** @type {Boundary | null} */
    _defineProperty(this, "parent", void 0);
    _defineProperty(this, "is_pending", false);
    /**
     * API-level transformError transform function. Transforms errors before they reach the `failed` snippet.
     * Inherited from parent boundary, or defaults to identity.
     * @type {(error: unknown) => unknown}
     */
    _defineProperty(this, "transform_error", void 0);
    /** @type {TemplateNode} */
    _classPrivateFieldInitSpec(this, _anchor, void 0);
    /** @type {TemplateNode | null} */
    _classPrivateFieldInitSpec(this, _hydrate_open, hydrating ? hydrate_node : null);
    /** @type {BoundaryProps} */
    _classPrivateFieldInitSpec(this, _props, void 0);
    /** @type {((anchor: Node) => void)} */
    _classPrivateFieldInitSpec(this, _children, void 0);
    /** @type {Effect} */
    _classPrivateFieldInitSpec(this, _effect, void 0);
    /** @type {Effect | null} */
    _classPrivateFieldInitSpec(this, _main_effect, null);
    /** @type {Effect | null} */
    _classPrivateFieldInitSpec(this, _pending_effect, null);
    /** @type {Effect | null} */
    _classPrivateFieldInitSpec(this, _failed_effect, null);
    /** @type {DocumentFragment | null} */
    _classPrivateFieldInitSpec(this, _offscreen_fragment, null);
    _classPrivateFieldInitSpec(this, _local_pending_count, 0);
    _classPrivateFieldInitSpec(this, _pending_count, 0);
    _classPrivateFieldInitSpec(this, _pending_count_update_queued, false);
    /** @type {Set<Effect>} */
    _classPrivateFieldInitSpec(this, _dirty_effects2, /* @__PURE__ */new Set());
    /** @type {Set<Effect>} */
    _classPrivateFieldInitSpec(this, _maybe_dirty_effects2, /* @__PURE__ */new Set());
    /**
     * A source containing the number of pending async deriveds/expressions.
     * Only created if `$effect.pending()` is used inside the boundary,
     * otherwise updating the source results in needless `Batch.ensure()`
     * calls followed by no-op flushes
     * @type {Source<number> | null}
     */
    _classPrivateFieldInitSpec(this, _effect_pending, null);
    _classPrivateFieldInitSpec(this, _effect_pending_subscriber, createSubscriber(function () {
      _classPrivateFieldSet(_effect_pending, _this5, source(_classPrivateFieldGet(_local_pending_count, _this5)));
      return function () {
        _classPrivateFieldSet(_effect_pending, _this5, null);
      };
    }));
    _classPrivateFieldSet(_anchor, this, node);
    _classPrivateFieldSet(_props, this, props);
    _classPrivateFieldSet(_children, this, function (anchor) {
      var effect2 = /** @type {Effect} */
      active_effect;
      effect2.b = _this5;
      effect2.f |= BOUNDARY_EFFECT;
      children(anchor);
    });
    this.parent = /** @type {Effect} */
    active_effect.b;
    this.transform_error = (_ref = transform_error !== null && transform_error !== void 0 ? transform_error : (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.transform_error) !== null && _ref !== void 0 ? _ref : function (e) {
      return e;
    };
    _classPrivateFieldSet(_effect, this, block(function () {
      if (hydrating) {
        var comment2 = /** @type {Comment} */
        _classPrivateFieldGet(_hydrate_open, _this5);
        hydrate_next();
        var server_rendered_pending = comment2.data === HYDRATION_START_ELSE;
        var server_rendered_failed = comment2.data.startsWith(HYDRATION_START_FAILED);
        if (server_rendered_failed) {
          var serialized_error = JSON.parse(comment2.data.slice(HYDRATION_START_FAILED.length));
          _assertClassBrand(_Boundary_brand, _this5, _hydrate_failed_content).call(_this5, serialized_error);
        } else if (server_rendered_pending) {
          _assertClassBrand(_Boundary_brand, _this5, _hydrate_pending_content).call(_this5);
        } else {
          _assertClassBrand(_Boundary_brand, _this5, _hydrate_resolved_content).call(_this5);
        }
      } else {
        _assertClassBrand(_Boundary_brand, _this5, _render).call(_this5);
      }
    }, flags));
    if (hydrating) {
      _classPrivateFieldSet(_anchor, this, hydrate_node);
    }
  }
  return _createClass(Boundary, [{
    key: "defer_effect",
    value:
    /**
     * Defer an effect inside a pending boundary until the boundary resolves
     * @param {Effect} effect
     */
    function defer_effect(effect2) {
      _defer_effect(effect2, _classPrivateFieldGet(_dirty_effects2, this), _classPrivateFieldGet(_maybe_dirty_effects2, this));
    }
    /**
     * Returns `false` if the effect exists inside a boundary whose pending snippet is shown
     * @returns {boolean}
     */
  }, {
    key: "is_rendered",
    value: function is_rendered() {
      return !this.is_pending && (!this.parent || this.parent.is_rendered());
    }
  }, {
    key: "has_pending_snippet",
    value: function has_pending_snippet() {
      return !!_classPrivateFieldGet(_props, this).pending;
    }
    /**
     * @template T
     * @param {() => T} fn
     */
  }, {
    key: "update_pending_count",
    value:
    /**
     * Update the source that powers `$effect.pending()` inside this boundary,
     * and controls when the current `pending` snippet (if any) is removed.
     * Do not call from inside the class
     * @param {1 | -1} d
     * @param {Batch} batch
     */
    function update_pending_count(d, batch) {
      var _this6 = this;
      _assertClassBrand(_Boundary_brand, this, _update_pending_count).call(this, d, batch);
      _classPrivateFieldSet(_local_pending_count, this, _classPrivateFieldGet(_local_pending_count, this) + d);
      if (!_classPrivateFieldGet(_effect_pending, this) || _classPrivateFieldGet(_pending_count_update_queued, this)) return;
      _classPrivateFieldSet(_pending_count_update_queued, this, true);
      queue_micro_task(function () {
        _classPrivateFieldSet(_pending_count_update_queued, _this6, false);
        if (_classPrivateFieldGet(_effect_pending, _this6)) {
          internal_set(_classPrivateFieldGet(_effect_pending, _this6), _classPrivateFieldGet(_local_pending_count, _this6));
        }
      });
    }
  }, {
    key: "get_effect_pending",
    value: function get_effect_pending() {
      _classPrivateFieldGet(_effect_pending_subscriber, this).call(this);
      return _get(/** @type {Source<number>} */
      _classPrivateFieldGet(_effect_pending, this));
    }
    /** @param {unknown} error */
  }, {
    key: "error",
    value: function error(_error) {
      var _current_batch7,
        _this7 = this;
      if (!_classPrivateFieldGet(_props, this).onerror && !_classPrivateFieldGet(_props, this).failed) {
        throw _error;
      }
      if ((_current_batch7 = current_batch) !== null && _current_batch7 !== void 0 && _current_batch7.is_fork) {
        if (_classPrivateFieldGet(_main_effect, this)) current_batch.skip_effect(_classPrivateFieldGet(_main_effect, this));
        if (_classPrivateFieldGet(_pending_effect, this)) current_batch.skip_effect(_classPrivateFieldGet(_pending_effect, this));
        if (_classPrivateFieldGet(_failed_effect, this)) current_batch.skip_effect(_classPrivateFieldGet(_failed_effect, this));
        current_batch.oncommit(function () {
          _assertClassBrand(_Boundary_brand, _this7, _handle_error).call(_this7, _error);
        });
      } else {
        _assertClassBrand(_Boundary_brand, this, _handle_error).call(this, _error);
      }
    }
    /**
     * @param {unknown} error
     */
  }]);
}();
function _hydrate_resolved_content() {
  var _this18 = this;
  try {
    _classPrivateFieldSet(_main_effect, this, branch(function () {
      return _classPrivateFieldGet(_children, _this18).call(_this18, _classPrivateFieldGet(_anchor, _this18));
    }));
  } catch (error) {
    this.error(error);
  }
}
/**
 * @param {unknown} error The deserialized error from the server's hydration comment
 */
function _hydrate_failed_content(error) {
  var _this19 = this;
  var failed = _classPrivateFieldGet(_props, this).failed;
  var _assertClassBrand$cal = _assertClassBrand(_Boundary_brand, this, _create_reset).call(this, error),
    reset2 = _assertClassBrand$cal.reset,
    invoke_onerror = _assertClassBrand$cal.invoke_onerror;
  queue_micro_task(invoke_onerror);
  if (!failed) return;
  _classPrivateFieldSet(_failed_effect, this, branch(function () {
    failed(_classPrivateFieldGet(_anchor, _this19), function () {
      return error;
    }, function () {
      return reset2;
    });
  }));
}
/**
 * Creates the `reset` function for a failed boundary, along with a function
 * that invokes `onerror` with it (if provided)
 * @param {unknown} error
 * @returns {{ reset: () => void, invoke_onerror: () => void }}
 */
function _create_reset(error) {
  var _this20 = this;
  var did_reset = false;
  var calling_on_error = false;
  var reset2 = function reset2() {
    if (did_reset) {
      svelte_boundary_reset_noop();
      return;
    }
    did_reset = true;
    if (calling_on_error) {
      svelte_boundary_reset_onerror();
    }
    if (_classPrivateFieldGet(_failed_effect, _this20) !== null) {
      pause_effect(_classPrivateFieldGet(_failed_effect, _this20), function () {
        _classPrivateFieldSet(_failed_effect, _this20, null);
      });
    }
    _assertClassBrand(_Boundary_brand, _this20, _run).call(_this20, function () {
      _assertClassBrand(_Boundary_brand, _this20, _render).call(_this20);
    });
  };
  var invoke_onerror = function invoke_onerror() {
    try {
      var _classPrivateFieldGet8, _classPrivateFieldGet9;
      calling_on_error = true;
      (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(_props, _this20)).onerror) === null || _classPrivateFieldGet8 === void 0 || _classPrivateFieldGet8.call(_classPrivateFieldGet9, error, reset2);
      calling_on_error = false;
    } catch (err) {
      invoke_error_boundary(err, _classPrivateFieldGet(_effect, _this20) && _classPrivateFieldGet(_effect, _this20).parent);
    }
  };
  return {
    reset: reset2,
    invoke_onerror: invoke_onerror
  };
}
function _hydrate_pending_content() {
  var _this21 = this;
  var pending = _classPrivateFieldGet(_props, this).pending;
  if (!pending) return;
  this.is_pending = true;
  _classPrivateFieldSet(_pending_effect, this, branch(function () {
    return pending(_classPrivateFieldGet(_anchor, _this21));
  }));
  queue_micro_task(function () {
    var fragment = _classPrivateFieldSet(_offscreen_fragment, _this21, document.createDocumentFragment());
    var anchor = create_text();
    var handled = false;
    fragment.append(anchor);
    _classPrivateFieldSet(_main_effect, _this21, _assertClassBrand(_Boundary_brand, _this21, _run).call(_this21, function () {
      try {
        return branch(function () {
          return _classPrivateFieldGet(_children, _this21).call(_this21, anchor);
        });
      } catch (error) {
        try {
          _this21.error(error);
          handled = true;
        } catch (error2) {
          invoke_error_boundary(error2, _classPrivateFieldGet(_effect, _this21).parent);
        }
        return null;
      }
    }));
    if (_classPrivateFieldGet(_main_effect, _this21) === null) {
      _classPrivateFieldSet(_offscreen_fragment, _this21, null);
      if (handled) _assertClassBrand(_Boundary_brand, _this21, _resolve).call(_this21, /** @type {Batch} */
      current_batch);
      return;
    }
    if (_classPrivateFieldGet(_pending_count, _this21) === 0) {
      _classPrivateFieldGet(_anchor, _this21).before(fragment);
      _classPrivateFieldSet(_offscreen_fragment, _this21, null);
      pause_effect(/** @type {Effect} */
      _classPrivateFieldGet(_pending_effect, _this21), function () {
        _classPrivateFieldSet(_pending_effect, _this21, null);
      });
      _assertClassBrand(_Boundary_brand, _this21, _resolve).call(_this21, /** @type {Batch} */
      current_batch);
    }
  });
}
function _render() {
  var _this22 = this;
  try {
    this.is_pending = this.has_pending_snippet();
    _classPrivateFieldSet(_pending_count, this, 0);
    _classPrivateFieldSet(_local_pending_count, this, 0);
    _classPrivateFieldSet(_main_effect, this, branch(function () {
      _classPrivateFieldGet(_children, _this22).call(_this22, _classPrivateFieldGet(_anchor, _this22));
    }));
    if (_classPrivateFieldGet(_pending_count, this) > 0) {
      var fragment = _classPrivateFieldSet(_offscreen_fragment, this, document.createDocumentFragment());
      move_effect(_classPrivateFieldGet(_main_effect, this), fragment);
      var pending = /** @type {(anchor: Node) => void} */
      _classPrivateFieldGet(_props, this).pending;
      _classPrivateFieldSet(_pending_effect, this, branch(function () {
        return pending(_classPrivateFieldGet(_anchor, _this22));
      }));
    } else {
      _assertClassBrand(_Boundary_brand, this, _resolve).call(this, /** @type {Batch} */
      current_batch);
    }
  } catch (error) {
    this.error(error);
  }
}
/**
 * @param {Batch} batch
 */
function _resolve(batch) {
  this.is_pending = false;
  batch.transfer_effects(_classPrivateFieldGet(_dirty_effects2, this), _classPrivateFieldGet(_maybe_dirty_effects2, this));
}
function _run(fn) {
  var previous_effect = active_effect;
  var previous_reaction = active_reaction;
  var previous_ctx = component_context;
  set_active_effect(_classPrivateFieldGet(_effect, this));
  set_active_reaction(_classPrivateFieldGet(_effect, this));
  set_component_context(_classPrivateFieldGet(_effect, this).ctx);
  try {
    Batch.ensure();
    return fn();
  } finally {
    set_active_effect(previous_effect);
    set_active_reaction(previous_reaction);
    set_component_context(previous_ctx);
  }
}
/**
 * Updates the pending count associated with the currently visible pending snippet,
 * if any, such that we can replace the snippet with content once work is done
 * @param {1 | -1} d
 * @param {Batch} batch
 */
function _update_pending_count(d, batch) {
  var _this23 = this;
  if (!this.has_pending_snippet()) {
    if (this.parent) {
      var _this$parent;
      _assertClassBrand(_Boundary_brand, _this$parent = this.parent, _update_pending_count).call(_this$parent, d, batch);
    }
    return;
  }
  _classPrivateFieldSet(_pending_count, this, _classPrivateFieldGet(_pending_count, this) + d);
  if (_classPrivateFieldGet(_pending_count, this) === 0) {
    _assertClassBrand(_Boundary_brand, this, _resolve).call(this, batch);
    if (_classPrivateFieldGet(_pending_effect, this)) {
      pause_effect(_classPrivateFieldGet(_pending_effect, this), function () {
        _classPrivateFieldSet(_pending_effect, _this23, null);
      });
    }
    if (_classPrivateFieldGet(_offscreen_fragment, this)) {
      _classPrivateFieldGet(_anchor, this).before(_classPrivateFieldGet(_offscreen_fragment, this));
      _classPrivateFieldSet(_offscreen_fragment, this, null);
    }
  }
}
function _handle_error(error) {
  var _this24 = this;
  if (_classPrivateFieldGet(_main_effect, this)) {
    destroy_effect(_classPrivateFieldGet(_main_effect, this));
    _classPrivateFieldSet(_main_effect, this, null);
  }
  if (_classPrivateFieldGet(_pending_effect, this)) {
    destroy_effect(_classPrivateFieldGet(_pending_effect, this));
    _classPrivateFieldSet(_pending_effect, this, null);
  }
  if (_classPrivateFieldGet(_failed_effect, this)) {
    destroy_effect(_classPrivateFieldGet(_failed_effect, this));
    _classPrivateFieldSet(_failed_effect, this, null);
  }
  if (hydrating) {
    set_hydrate_node(/** @type {TemplateNode} */
    _classPrivateFieldGet(_hydrate_open, this));
    next();
    set_hydrate_node(skip_nodes());
  }
  var failed = _classPrivateFieldGet(_props, this).failed;
  var handle_error_result = function handle_error_result(transformed_error) {
    var _assertClassBrand$cal2 = _assertClassBrand(_Boundary_brand, _this24, _create_reset).call(_this24, transformed_error),
      reset2 = _assertClassBrand$cal2.reset,
      invoke_onerror = _assertClassBrand$cal2.invoke_onerror;
    invoke_onerror();
    if (failed) {
      _classPrivateFieldSet(_failed_effect, _this24, _assertClassBrand(_Boundary_brand, _this24, _run).call(_this24, function () {
        try {
          return branch(function () {
            var effect2 = /** @type {Effect} */
            active_effect;
            effect2.b = _this24;
            effect2.f |= BOUNDARY_EFFECT;
            failed(_classPrivateFieldGet(_anchor, _this24), function () {
              return transformed_error;
            }, function () {
              return reset2;
            });
          });
        } catch (error2) {
          invoke_error_boundary(error2, /** @type {Effect} */
          _classPrivateFieldGet(_effect, _this24).parent);
          return null;
        }
      }));
    }
  };
  queue_micro_task(function () {
    var result;
    try {
      result = _this24.transform_error(error);
    } catch (e) {
      invoke_error_boundary(e, _classPrivateFieldGet(_effect, _this24) && _classPrivateFieldGet(_effect, _this24).parent);
      return;
    }
    if (result !== null && _typeof(result) === "object" && typeof /** @type {any} */
    result.then === "function") {
      result.then(handle_error_result, /** @param {unknown} e */
      function (e) {
        return invoke_error_boundary(e, _classPrivateFieldGet(_effect, _this24) && _classPrivateFieldGet(_effect, _this24).parent);
      });
    } else {
      handle_error_result(result);
    }
  });
}
function set_text(text2, value) {
  var _text2$TEXT_CACHE;
  var str = value == null ? "" : _typeof(value) === "object" ? "".concat(value) : value;
  if (str !== (/** @type {any} */(_text2$TEXT_CACHE = text2[TEXT_CACHE]) !== null && _text2$TEXT_CACHE !== void 0 ? _text2$TEXT_CACHE : text2[TEXT_CACHE] = text2.nodeValue)) {
    text2[TEXT_CACHE] = str;
    text2.nodeValue = "".concat(str);
  }
}
function mount(component2, options) {
  return _mount(component2, options);
}
function hydrate(component2, options) {
  var _options$intro;
  init_operations();
  options.intro = (_options$intro = options.intro) !== null && _options$intro !== void 0 ? _options$intro : false;
  var target = options.target;
  var was_hydrating = hydrating;
  var previous_hydrate_node = hydrate_node;
  try {
    var anchor = /* @__PURE__ */get_first_child(target);
    while (anchor && (anchor.nodeType !== COMMENT_NODE || /** @type {Comment} */
    anchor.data !== HYDRATION_START)) {
      anchor = /* @__PURE__ */get_next_sibling(anchor);
    }
    if (!anchor) {
      throw HYDRATION_ERROR;
    }
    set_hydrating(true);
    set_hydrate_node(/** @type {Comment} */
    anchor);
    var instance = _mount(component2, _objectSpread(_objectSpread({}, options), {}, {
      anchor: anchor
    }));
    set_hydrating(false);
    return /**  @type {Exports} */instance;
  } catch (error) {
    if (error instanceof Error && error.message.split("\n").some(function (line) {
      return line.startsWith("https://svelte.dev/e/");
    })) {
      throw error;
    }
    if (error !== HYDRATION_ERROR) {
      console.warn("Failed to hydrate: ", error);
    }
    if (options.recover === false) {
      hydration_failed();
    }
    init_operations();
    clear_text_content(target);
    set_hydrating(false);
    return mount(component2, options);
  } finally {
    set_hydrating(was_hydrating);
    set_hydrate_node(previous_hydrate_node);
  }
}
var listeners = /* @__PURE__ */new Map();
function _mount(Component, _ref2) {
  var target = _ref2.target,
    anchor = _ref2.anchor,
    _ref2$props = _ref2.props,
    props = _ref2$props === void 0 ? {} : _ref2$props,
    events = _ref2.events,
    context = _ref2.context,
    _ref2$intro = _ref2.intro,
    intro = _ref2$intro === void 0 ? true : _ref2$intro,
    transformError = _ref2.transformError;
  init_operations();
  var component2 = void 0;
  var unmount2 = component_root(function () {
    var anchor_node = anchor !== null && anchor !== void 0 ? anchor : target.appendChild(create_text());
    boundary(/** @type {TemplateNode} */
    anchor_node, {
      pending: function pending() {}
    }, function (anchor_node2) {
      push({});
      var ctx = /** @type {ComponentContext} */
      component_context;
      if (context) ctx.c = context;
      if (events) {
        props.$$events = events;
      }
      if (hydrating) {
        assign_nodes(/** @type {TemplateNode} */
        anchor_node2, null);
      }
      component2 = Component(anchor_node2, props) || mark_as_component();
      if (hydrating) {
        active_effect.nodes.end = hydrate_node;
        if (hydrate_node === null || hydrate_node.nodeType !== COMMENT_NODE || /** @type {Comment} */
        hydrate_node.data !== HYDRATION_END) {
          hydration_mismatch();
          throw HYDRATION_ERROR;
        }
      }
      pop();
    }, transformError);
    var registered_events = /* @__PURE__ */new Set();
    var event_handle = function event_handle(events2) {
      for (var i = 0; i < events2.length; i++) {
        var event_name = events2[i];
        if (registered_events.has(event_name)) continue;
        registered_events.add(event_name);
        var passive = is_passive_event(event_name);
        for (var _i = 0, _arr = [target, document]; _i < _arr.length; _i++) {
          var node = _arr[_i];
          var counts = listeners.get(node);
          if (counts === void 0) {
            counts = /* @__PURE__ */new Map();
            listeners.set(node, counts);
          }
          var count = counts.get(event_name);
          if (count === void 0) {
            node.addEventListener(event_name, handle_event_propagation, {
              passive: passive
            });
            counts.set(event_name, 1);
          } else {
            counts.set(event_name, count + 1);
          }
        }
      }
    };
    event_handle(array_from(all_registered_events));
    root_event_handles.add(event_handle);
    return function () {
      var _iterator27 = _createForOfIteratorHelper(registered_events),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var event_name = _step27.value;
          for (var _i2 = 0, _arr2 = [target, document]; _i2 < _arr2.length; _i2++) {
            var node = _arr2[_i2];
            var counts = /** @type {Map<string, number>} */
            listeners.get(node);
            var count = /** @type {number} */
            counts.get(event_name);
            if (--count == 0) {
              node.removeEventListener(event_name, handle_event_propagation);
              counts["delete"](event_name);
              if (counts.size === 0) {
                listeners["delete"](node);
              }
            } else {
              counts.set(event_name, count);
            }
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      root_event_handles["delete"](event_handle);
      if (anchor_node !== anchor) {
        var _anchor_node$parentNo;
        (_anchor_node$parentNo = anchor_node.parentNode) === null || _anchor_node$parentNo === void 0 || _anchor_node$parentNo.removeChild(anchor_node);
      }
    };
  });
  mounted_components.set(component2, unmount2);
  return component2;
}
var mounted_components = /* @__PURE__ */new WeakMap();
function unmount(component2, options) {
  var fn = mounted_components.get(component2);
  if (fn) {
    mounted_components["delete"](component2);
    return fn(options);
  }
  return Promise.resolve();
}
var _batches = /*#__PURE__*/new WeakMap();
var _onscreen = /*#__PURE__*/new WeakMap();
var _offscreen = /*#__PURE__*/new WeakMap();
var _outroing = /*#__PURE__*/new WeakMap();
var _transition = /*#__PURE__*/new WeakMap();
var _commit2 = /*#__PURE__*/new WeakMap();
var _discard = /*#__PURE__*/new WeakMap();
var BranchManager = /*#__PURE__*/function () {
  /**
   * @param {TemplateNode} anchor
   * @param {boolean} transition
   */
  function BranchManager(anchor) {
    var _this8 = this;
    var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, BranchManager);
    /** @type {TemplateNode} */
    _defineProperty(this, "anchor", void 0);
    /** @type {Map<Batch, Key>} */
    _classPrivateFieldInitSpec(this, _batches, /* @__PURE__ */new Map());
    /**
     * Map of keys to effects that are currently rendered in the DOM.
     * These effects are visible and actively part of the document tree.
     * Example:
     * ```
     * {#if condition}
     * 	foo
     * {:else}
     * 	bar
     * {/if}
     * ```
     * Can result in the entries `true->Effect` and `false->Effect`
     * @type {Map<Key, Effect>}
     */
    _classPrivateFieldInitSpec(this, _onscreen, /* @__PURE__ */new Map());
    /**
     * Similar to #onscreen with respect to the keys, but contains branches that are not yet
     * in the DOM, because their insertion is deferred.
     * @type {Map<Key, Branch>}
     */
    _classPrivateFieldInitSpec(this, _offscreen, /* @__PURE__ */new Map());
    /**
     * Keys of effects that are currently outroing
     * @type {Set<Key>}
     */
    _classPrivateFieldInitSpec(this, _outroing, /* @__PURE__ */new Set());
    /**
     * Whether to pause (i.e. outro) on change, or destroy immediately.
     * This is necessary for `<svelte:element>`
     */
    _classPrivateFieldInitSpec(this, _transition, true);
    /**
     * @param {Batch} batch
     */
    _classPrivateFieldInitSpec(this, _commit2, function (batch) {
      if (!_classPrivateFieldGet(_batches, _this8).has(batch)) return;
      var key2 = /** @type {Key} */
      _classPrivateFieldGet(_batches, _this8).get(batch);
      var onscreen = _classPrivateFieldGet(_onscreen, _this8).get(key2);
      if (onscreen) {
        resume_effect(onscreen);
        _classPrivateFieldGet(_outroing, _this8)["delete"](key2);
      } else {
        var offscreen = _classPrivateFieldGet(_offscreen, _this8).get(key2);
        if (offscreen) {
          resume_effect(offscreen.effect);
          _classPrivateFieldGet(_onscreen, _this8).set(key2, offscreen.effect);
          _classPrivateFieldGet(_offscreen, _this8)["delete"](key2);
          offscreen.fragment.lastChild.remove();
          _this8.anchor.before(offscreen.fragment);
          onscreen = offscreen.effect;
        }
      }
      var _iterator28 = _createForOfIteratorHelper(_classPrivateFieldGet(_batches, _this8)),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var _step28$value = _slicedToArray(_step28.value, 2),
            b = _step28$value[0],
            k = _step28$value[1];
          _classPrivateFieldGet(_batches, _this8)["delete"](b);
          if (b === batch) {
            break;
          }
          var offscreen2 = _classPrivateFieldGet(_offscreen, _this8).get(k);
          if (offscreen2) {
            destroy_effect(offscreen2.effect);
            _classPrivateFieldGet(_offscreen, _this8)["delete"](k);
          }
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      var _iterator29 = _createForOfIteratorHelper(_classPrivateFieldGet(_onscreen, _this8)),
        _step29;
      try {
        var _loop4 = function _loop4() {
          var _step29$value = _slicedToArray(_step29.value, 2),
            k = _step29$value[0],
            effect2 = _step29$value[1];
          if (k === key2 || _classPrivateFieldGet(_outroing, _this8).has(k)) return 1; // continue
          var on_destroy = function on_destroy() {
            var keys = Array.from(_classPrivateFieldGet(_batches, _this8).values());
            if (keys.includes(k)) {
              var fragment = document.createDocumentFragment();
              move_effect(effect2, fragment);
              fragment.append(create_text());
              _classPrivateFieldGet(_offscreen, _this8).set(k, {
                effect: effect2,
                fragment: fragment
              });
            } else {
              destroy_effect(effect2);
            }
            _classPrivateFieldGet(_outroing, _this8)["delete"](k);
            _classPrivateFieldGet(_onscreen, _this8)["delete"](k);
          };
          if (_classPrivateFieldGet(_transition, _this8) || !onscreen) {
            _classPrivateFieldGet(_outroing, _this8).add(k);
            pause_effect(effect2, on_destroy, false);
          } else {
            on_destroy();
          }
        };
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          if (_loop4()) continue;
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    });
    /**
     * @param {Batch} batch
     */
    _classPrivateFieldInitSpec(this, _discard, function (batch) {
      _classPrivateFieldGet(_batches, _this8)["delete"](batch);
      var keys = Array.from(_classPrivateFieldGet(_batches, _this8).values());
      var _iterator30 = _createForOfIteratorHelper(_classPrivateFieldGet(_offscreen, _this8)),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var _step30$value = _slicedToArray(_step30.value, 2),
            k = _step30$value[0],
            branch2 = _step30$value[1];
          if (!keys.includes(k)) {
            destroy_effect(branch2.effect);
            _classPrivateFieldGet(_offscreen, _this8)["delete"](k);
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
    });
    this.anchor = anchor;
    _classPrivateFieldSet(_transition, this, transition);
  }
  return _createClass(BranchManager, [{
    key: "ensure",
    value:
    /**
     *
     * @param {any} key
     * @param {null | ((target: TemplateNode) => void)} fn
     */
    function ensure(key2, fn) {
      var _this9 = this;
      var batch = /** @type {Batch} */
      current_batch;
      var defer = should_defer_append();
      if (fn && !_classPrivateFieldGet(_onscreen, this).has(key2) && !_classPrivateFieldGet(_offscreen, this).has(key2)) {
        if (defer) {
          var fragment = document.createDocumentFragment();
          var target = create_text();
          fragment.append(target);
          _classPrivateFieldGet(_offscreen, this).set(key2, {
            effect: branch(function () {
              return fn(target);
            }),
            fragment: fragment
          });
        } else {
          _classPrivateFieldGet(_onscreen, this).set(key2, branch(function () {
            return fn(_this9.anchor);
          }));
        }
      }
      _classPrivateFieldGet(_batches, this).set(batch, key2);
      if (defer) {
        var _iterator31 = _createForOfIteratorHelper(_classPrivateFieldGet(_onscreen, this)),
          _step31;
        try {
          for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
            var _step31$value = _slicedToArray(_step31.value, 2),
              k = _step31$value[0],
              effect2 = _step31$value[1];
            if (k === key2) {
              batch.unskip_effect(effect2);
            } else {
              batch.skip_effect(effect2);
            }
          }
        } catch (err) {
          _iterator31.e(err);
        } finally {
          _iterator31.f();
        }
        var _iterator32 = _createForOfIteratorHelper(_classPrivateFieldGet(_offscreen, this)),
          _step32;
        try {
          for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
            var _step32$value = _slicedToArray(_step32.value, 2),
              _k = _step32$value[0],
              branch2 = _step32$value[1];
            if (_k === key2) {
              batch.unskip_effect(branch2.effect);
            } else {
              batch.skip_effect(branch2.effect);
            }
          }
        } catch (err) {
          _iterator32.e(err);
        } finally {
          _iterator32.f();
        }
        batch.oncommit(_classPrivateFieldGet(_commit2, this));
        batch.ondiscard(_classPrivateFieldGet(_discard, this));
      } else {
        if (hydrating) {
          this.anchor = hydrate_node;
        }
        _classPrivateFieldGet(_commit2, this).call(this, batch);
      }
    }
  }]);
}();
function snippet(node, get_snippet) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }
  var branches = new BranchManager(node);
  block(function () {
    var _get_snippet;
    var snippet2 = (_get_snippet = get_snippet()) !== null && _get_snippet !== void 0 ? _get_snippet : null;
    branches.ensure(snippet2, snippet2 && function (anchor) {
      return snippet2.apply(void 0, [anchor].concat(args));
    });
  }, EFFECT_TRANSPARENT);
}
function onMount(fn) {
  if (component_context === null) {
    lifecycle_outside_component();
  }
  {
    user_effect(function () {
      var cleanup = untrack(fn);
      if (typeof cleanup === "function") return /** @type {() => void} */cleanup;
    });
  }
}
function if_block(node, fn) {
  var elseif = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var marker;
  if (hydrating) {
    marker = hydrate_node;
    hydrate_next();
  }
  var branches = new BranchManager(node);
  var flags2 = elseif ? EFFECT_TRANSPARENT : 0;
  function update_branch(key2, fn2) {
    if (hydrating) {
      var data = read_hydration_instruction(/** @type {TemplateNode} */
      marker);
      if (key2 !== parseInt(data.substring(1))) {
        var anchor = skip_nodes();
        set_hydrate_node(anchor);
        branches.anchor = anchor;
        set_hydrating(false);
        branches.ensure(key2, fn2);
        set_hydrating(true);
        return;
      }
    }
    branches.ensure(key2, fn2);
  }
  block(function () {
    var has_branch = false;
    fn(function (fn2) {
      var key2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      has_branch = true;
      update_branch(key2, fn2);
    });
    if (!has_branch) {
      update_branch(-1, null);
    }
  }, flags2);
}
var NAN = /* @__PURE__ */Symbol("NaN");
function key(node, get_key, render_fn) {
  if (hydrating) {
    hydrate_next();
  }
  var branches = new BranchManager(node);
  block(function () {
    var key2 = get_key();
    if (key2 !== key2) {
      key2 = /** @type {any} */
      NAN;
    }
    branches.ensure(key2, render_fn);
  });
}
function html(node, get_value) {
  var is_controlled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var svg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var mathml = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var skip_warning = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var anchor = node;
  var value = "";
  if (is_controlled) {
    var parent_node = /** @type {Element} */
    node;
    if (hydrating) {
      anchor = set_hydrate_node(/* @__PURE__ */get_first_child(parent_node));
    }
  }
  template_effect(function () {
    var _get_value;
    var effect2 = /** @type {Effect} */
    active_effect;
    if (value === (value = (_get_value = get_value()) !== null && _get_value !== void 0 ? _get_value : "")) {
      if (hydrating) hydrate_next();
      return;
    }
    if (is_controlled && !hydrating) {
      effect2.nodes = null;
      parent_node.innerHTML = /** @type {string} */
      value;
      if (value !== "") {
        assign_nodes(/** @type {TemplateNode} */
        /* @__PURE__ */get_first_child(parent_node), /** @type {TemplateNode} */
        parent_node.lastChild);
      }
      return;
    }
    if (effect2.nodes !== null) {
      remove_effect_dom(effect2.nodes.start, /** @type {TemplateNode} */
      effect2.nodes.end);
      effect2.nodes = null;
    }
    if (value === "") return;
    if (hydrating) {
      hydrate_node.data;
      var next2 = hydrate_next();
      var last = next2;
      while (next2 !== null && (next2.nodeType !== COMMENT_NODE || /** @type {Comment} */
      next2.data !== "")) {
        last = next2;
        next2 = /* @__PURE__ */get_next_sibling(next2);
      }
      if (next2 === null) {
        hydration_mismatch();
        throw HYDRATION_ERROR;
      }
      assign_nodes(hydrate_node, last);
      anchor = set_hydrate_node(next2);
      return;
    }
    var ns = svg ? NAMESPACE_SVG : mathml ? NAMESPACE_MATHML : void 0;
    var wrapper = /** @type {HTMLTemplateElement | SVGElement | MathMLElement} */
    create_element(svg ? "svg" : mathml ? "math" : "template", ns);
    wrapper.innerHTML = /** @type {any} */
    value;
    var node2 = svg || mathml ? wrapper : (/** @type {HTMLTemplateElement} */
    wrapper.content);
    assign_nodes(/** @type {TemplateNode} */
    /* @__PURE__ */get_first_child(node2), /** @type {TemplateNode} */
    node2.lastChild);
    if (svg || mathml) {
      while (/* @__PURE__ */get_first_child(node2)) {
        anchor.before(/** @type {TemplateNode} */
        /* @__PURE__ */get_first_child(node2));
      }
    } else {
      anchor.before(node2);
    }
  });
}
function component(node, get_component, render_fn) {
  var hydration_start_node;
  if (hydrating) {
    hydration_start_node = hydrate_node;
    hydrate_next();
  }
  var branches = new BranchManager(node);
  block(function () {
    var _get_component;
    var component2 = (_get_component = get_component()) !== null && _get_component !== void 0 ? _get_component : null;
    if (hydrating) {
      var data = read_hydration_instruction(/** @type {TemplateNode} */
      hydration_start_node);
      var server_had_component = data === HYDRATION_START;
      var client_has_component = component2 !== null;
      if (server_had_component !== client_has_component) {
        var anchor = skip_nodes();
        set_hydrate_node(anchor);
        branches.anchor = anchor;
        set_hydrating(false);
        branches.ensure(component2, component2 && function (target) {
          return render_fn(target, component2);
        });
        set_hydrating(true);
        return;
      }
    }
    branches.ensure(component2, component2 && function (target) {
      return render_fn(target, component2);
    });
  }, EFFECT_TRANSPARENT);
}
function attach(node, get_fn) {
  var fn = void 0;
  var e;
  managed(function () {
    if (fn !== (fn = get_fn())) {
      if (e) {
        destroy_effect(e);
        e = null;
      }
      if (fn) {
        e = branch(function () {
          effect(function () {
            return /** @type {(node: Element) => void} */fn(node);
          });
        });
      }
    }
  });
}
function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  } else for (f in e) e[f] && (n && (n += " "), n += f);
  return n;
}
function clsx$1() {
  for (var e, t, f = 0, n = "", o = arguments.length; f < o; f++) (e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
function clsx(value) {
  if (_typeof(value) === "object") {
    return clsx$1(value);
  } else {
    return value !== null && value !== void 0 ? value : "";
  }
}
var whitespace = _toConsumableArray(" \t\n\r\f\xA0\x0B\uFEFF");
function to_class(value, hash, directives) {
  var classname = value == null ? "" : "" + value;
  if (directives) {
    for (var _i3 = 0, _Object$keys = Object.keys(directives); _i3 < _Object$keys.length; _i3++) {
      var key2 = _Object$keys[_i3];
      if (directives[key2]) {
        classname = classname ? classname + " " + key2 : key2;
      } else if (classname.length) {
        var len = key2.length;
        var a = 0;
        while ((a = classname.indexOf(key2, a)) >= 0) {
          var b = a + len;
          if ((a === 0 || whitespace.includes(classname[a - 1])) && (b === classname.length || whitespace.includes(classname[b]))) {
            classname = (a === 0 ? "" : classname.substring(0, a)) + classname.substring(b + 1);
          } else {
            a = b;
          }
        }
      }
    }
  }
  return classname === "" ? null : classname;
}
function append_styles(styles) {
  var important = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = important ? " !important;" : ";";
  var css2 = "";
  for (var _i4 = 0, _Object$keys2 = Object.keys(styles); _i4 < _Object$keys2.length; _i4++) {
    var key2 = _Object$keys2[_i4];
    var value = styles[key2];
    if (value != null && value !== "") {
      css2 += " " + key2 + ": " + value + separator;
    }
  }
  return css2;
}
function to_css_name(name) {
  if (name[0] !== "-" || name[1] !== "-") {
    return name.toLowerCase();
  }
  return name;
}
function to_style(value, styles) {
  if (styles) {
    var new_style = "";
    var normal_styles;
    var important_styles;
    if (Array.isArray(styles)) {
      normal_styles = styles[0];
      important_styles = styles[1];
    } else {
      normal_styles = styles;
    }
    if (value) {
      value = String(value).replaceAll(/\/\*.*?\*\//g, "").trim();
      var in_str = false;
      var in_apo = 0;
      var in_comment = false;
      var reserved_names = [];
      if (normal_styles) {
        reserved_names.push.apply(reserved_names, _toConsumableArray(Object.keys(normal_styles).map(to_css_name)));
      }
      if (important_styles) {
        reserved_names.push.apply(reserved_names, _toConsumableArray(Object.keys(important_styles).map(to_css_name)));
      }
      var start_index = 0;
      var name_index = -1;
      var len = value.length;
      for (var i = 0; i < len; i++) {
        var c = value[i];
        if (in_comment) {
          if (c === "/" && value[i - 1] === "*") {
            in_comment = false;
          }
        } else if (in_str) {
          if (in_str === c) {
            in_str = false;
          }
        } else if (c === "/" && value[i + 1] === "*") {
          in_comment = true;
        } else if (c === '"' || c === "'") {
          in_str = c;
        } else if (c === "(") {
          in_apo++;
        } else if (c === ")") {
          in_apo--;
        }
        if (!in_comment && in_str === false && in_apo === 0) {
          if (c === ":" && name_index === -1) {
            name_index = i;
          } else if (c === ";" || i === len - 1) {
            if (name_index !== -1) {
              var name = to_css_name(value.substring(start_index, name_index).trim());
              if (!reserved_names.includes(name)) {
                if (c !== ";") {
                  i++;
                }
                var property = value.substring(start_index, i).trim();
                new_style += " " + property + ";";
              }
            }
            start_index = i + 1;
            name_index = -1;
          }
        }
      }
    }
    if (normal_styles) {
      new_style += append_styles(normal_styles);
    }
    if (important_styles) {
      new_style += append_styles(important_styles, true);
    }
    new_style = new_style.trim();
    return new_style === "" ? null : new_style;
  }
  return value == null ? null : String(value);
}
function set_class(dom, is_html, value, hash, prev_classes, next_classes) {
  var prev = /** @type {any} */
  dom[CLASS_CACHE];
  if (hydrating || prev !== value || prev === void 0) {
    var next_class_name = to_class(value, hash, next_classes);
    if (!hydrating || next_class_name !== dom.getAttribute("class")) {
      if (next_class_name == null) {
        dom.removeAttribute("class");
      } else if (is_html) {
        dom.className = next_class_name;
      } else {
        dom.setAttribute("class", next_class_name);
      }
    }
    dom[CLASS_CACHE] = value;
  } else if (next_classes && prev_classes !== next_classes) {
    for (var key2 in next_classes) {
      var is_present = !!next_classes[key2];
      if (prev_classes == null || is_present !== !!prev_classes[key2]) {
        dom.classList.toggle(key2, is_present);
      }
    }
  }
  return next_classes;
}
function update_styles(dom) {
  var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var next2 = arguments.length > 2 ? arguments[2] : undefined;
  var priority = arguments.length > 3 ? arguments[3] : undefined;
  for (var key2 in next2) {
    var value = next2[key2];
    if (prev[key2] !== value) {
      if (next2[key2] == null) {
        dom.style.removeProperty(key2);
      } else {
        dom.style.setProperty(key2, value, priority);
      }
    }
  }
}
function set_style(dom, value, prev_styles, next_styles) {
  var prev = /** @type {any} */
  dom[STYLE_CACHE];
  if (hydrating || prev !== value) {
    var next_style_attr = to_style(value, next_styles);
    if (!hydrating || next_style_attr !== dom.getAttribute("style")) {
      if (next_style_attr == null) {
        dom.removeAttribute("style");
      } else {
        dom.style.cssText = next_style_attr;
      }
    }
    dom[STYLE_CACHE] = value;
  } else if (next_styles) {
    if (Array.isArray(next_styles)) {
      update_styles(dom, prev_styles === null || prev_styles === void 0 ? void 0 : prev_styles[0], next_styles[0]);
      update_styles(dom, prev_styles === null || prev_styles === void 0 ? void 0 : prev_styles[1], next_styles[1], "important");
    } else {
      update_styles(dom, prev_styles, next_styles);
    }
  }
  return next_styles;
}
function set_selected(option, selected) {
  if (selected) {
    if (!option.hasAttribute("selected")) option.setAttribute("selected", "");
  } else {
    option.removeAttribute("selected");
  }
}
function set_default_select_value(select, value) {
  var mounting = !("__defaultValue" in select);
  if (!mounting && select.__defaultValue === value) return;
  select.__defaultValue = value;
  apply_default_select_value(select, !mounting || "__value" in select);
}
function apply_default_select_value(select, preserve) {
  var value = select.__defaultValue;
  var multiple = select.multiple;
  var values = multiple ? value !== null && value !== void 0 ? value : [] : null;
  if (multiple && !is_array(values)) return;
  var index = select.selectedIndex;
  var selected = preserve && multiple ? new Set(select.selectedOptions) : null;
  var _iterator33 = _createForOfIteratorHelper(select.options),
    _step33;
  try {
    for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
      var option = _step33.value;
      var option_value = get_option_value(option);
      set_selected(option, multiple ? (/** @type {any[]} */
      values.includes(option_value)) : is(option_value, value));
    }
  } catch (err) {
    _iterator33.e(err);
  } finally {
    _iterator33.f();
  }
  if (!preserve) return;
  if (selected !== null) {
    var _iterator34 = _createForOfIteratorHelper(select.options),
      _step34;
    try {
      for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
        option = _step34.value;
        var was_selected = selected.has(option);
        if (option.selected !== was_selected) option.selected = was_selected;
      }
    } catch (err) {
      _iterator34.e(err);
    } finally {
      _iterator34.f();
    }
  } else if (select.selectedIndex !== index) {
    select.selectedIndex = index;
  }
}
function select_option(select, value) {
  var mounting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (select.multiple) {
    if (value == void 0) {
      return;
    }
    if (!is_array(value)) {
      return select_multiple_invalid_value();
    }
    var _iterator35 = _createForOfIteratorHelper(select.options),
      _step35;
    try {
      for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
        var option = _step35.value;
        option.selected = value.includes(get_option_value(option));
      }
    } catch (err) {
      _iterator35.e(err);
    } finally {
      _iterator35.f();
    }
    return;
  }
  var _iterator36 = _createForOfIteratorHelper(select.options),
    _step36;
  try {
    for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
      option = _step36.value;
      var option_value = get_option_value(option);
      if (is(option_value, value)) {
        option.selected = true;
        return;
      }
    }
  } catch (err) {
    _iterator36.e(err);
  } finally {
    _iterator36.f();
  }
  if (!mounting || value !== void 0) {
    select.selectedIndex = -1;
  }
}
function init_select(select) {
  var observer = new MutationObserver(function (entries) {
    if (entries.every(is_selectedcontent_mutation)) return;
    if ("__defaultValue" in select) {
      apply_default_select_value(select, false);
    }
    if ("__value" in select) {
      select_option(select, select.__value);
    }
  });
  observer.observe(select, {
    // Listen to option element changes
    childList: true,
    subtree: true,
    // because of <optgroup>
    // Listen to option element value attribute changes
    // (doesn't get notified of select value changes,
    // because that property is not reflected as an attribute)
    attributes: true,
    attributeFilter: ["value"]
  });
  teardown(function () {
    observer.disconnect();
  });
}
function get_option_value(option) {
  if ("__value" in option) {
    return option.__value;
  } else {
    return option.value;
  }
}
function is_selectedcontent_mutation(entry) {
  if (/** @type {Element} */
  entry.target.closest("selectedcontent") !== null) {
    return true;
  }
  if (entry.type === "childList") {
    var nodes = [].concat(_toConsumableArray(entry.addedNodes), _toConsumableArray(entry.removedNodes));
    return nodes.length > 0 && nodes.every(function (node) {
      return node.nodeName === "SELECTEDCONTENT";
    });
  }
  return false;
}
var CLASS = /* @__PURE__ */Symbol("class");
var STYLE = /* @__PURE__ */Symbol("style");
var IS_CUSTOM_ELEMENT = /* @__PURE__ */Symbol("is custom element");
var IS_HTML = /* @__PURE__ */Symbol("is html");
var LINK_TAG = IS_XHTML ? "link" : "LINK";
var INPUT_TAG = IS_XHTML ? "input" : "INPUT";
var OPTION_TAG = IS_XHTML ? "option" : "OPTION";
var SELECT_TAG = IS_XHTML ? "select" : "SELECT";
var PROGRESS_TAG = IS_XHTML ? "progress" : "PROGRESS";
function remove_input_defaults(input) {
  if (!hydrating) return;
  var already_removed = false;
  var remove_defaults = function remove_defaults() {
    if (already_removed) return;
    already_removed = true;
    if (input.hasAttribute("value")) {
      var value = input.value;
      set_attribute(input, "value", null);
      input.value = value;
    }
    if (input.hasAttribute("checked")) {
      var checked = input.checked;
      set_attribute(input, "checked", null);
      input.checked = checked;
    }
  };
  input[FORM_RESET_HANDLER] = remove_defaults;
  queue_micro_task(remove_defaults);
  add_form_reset_listener();
}
function set_value(element, value) {
  var attributes = get_attributes(element);
  if (attributes.value === (attributes.value = // treat null and undefined the same for the initial value
  value !== null && value !== void 0 ? value : void 0) ||
  // @ts-expect-error
  // `progress` elements always need their value set when it's `0`
  element.value === value && (value !== 0 || element.nodeName !== PROGRESS_TAG)) {
    return;
  }
  element.value = value !== null && value !== void 0 ? value : "";
}
function set_attribute(element, attribute, value, skip_warning) {
  var attributes = get_attributes(element);
  if (hydrating) {
    attributes[attribute] = element.getAttribute(attribute);
    if (attribute === "src" || attribute === "srcset" || attribute === "href" && element.nodeName === LINK_TAG) {
      return;
    }
  }
  if (attributes[attribute] === (attributes[attribute] = value)) return;
  if (attribute === "loading") {
    element[LOADING_ATTR_SYMBOL] = value;
  }
  if (value == null) {
    element.removeAttribute(attribute);
  } else if (typeof value !== "string" && get_setters(element).has(attribute)) {
    element[attribute] = value;
  } else {
    element.setAttribute(attribute, value);
  }
}
function set_attributes(element, prev, next2, css_hash) {
  var should_remove_defaults = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var skip_warning = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  if (hydrating && should_remove_defaults && element.nodeName === INPUT_TAG) {
    if (!("defaultValue" in next2 || "defaultChecked" in next2)) {
      remove_input_defaults(/** @type {HTMLInputElement} */
      element);
    }
  }
  var attributes = get_attributes(element);
  var is_custom_element = attributes[IS_CUSTOM_ELEMENT];
  var preserve_attribute_case = !attributes[IS_HTML];
  var is_hydrating_custom_element = hydrating && is_custom_element;
  if (is_hydrating_custom_element) {
    set_hydrating(false);
  }
  var current = prev || {};
  var is_option_element = element.nodeName === OPTION_TAG;
  var is_select_element = element.nodeName === SELECT_TAG;
  for (var key2 in prev) {
    if (!(key2 in next2) && key2[0] + key2[1] !== "$$") {
      next2[key2] = null;
    }
  }
  if (next2["class"]) {
    next2["class"] = clsx(next2["class"]);
  } else if (next2[CLASS]) {
    next2["class"] = null;
  }
  if (next2[STYLE]) {
    var _next2$style;
    (_next2$style = next2.style) !== null && _next2$style !== void 0 ? _next2$style : next2.style = null;
  }
  var setters = get_setters(element);
  if (element.nodeName === INPUT_TAG && "type" in next2 && ("value" in next2 || "__value" in next2)) {
    var type = next2.type;
    if (type !== current.type || type === void 0 && element.hasAttribute("type")) {
      current.type = type;
      set_attribute(element, "type", type);
    }
  }
  var _loop5 = function _loop5(key3) {
      var value = next2[key3];
      if (is_option_element && key3 === "value" && value == null) {
        element.value = element.__value = "";
        current[key3] = value;
        return 0; // continue
      }
      if (key3 === "class") {
        is_html = element.namespaceURI === "http://www.w3.org/1999/xhtml";
        set_class(element, is_html, value, css_hash, prev === null || prev === void 0 ? void 0 : prev[CLASS], next2[CLASS]);
        current[key3] = value;
        current[CLASS] = next2[CLASS];
        return 0; // continue
      }
      if (key3 === "style") {
        set_style(element, value, prev === null || prev === void 0 ? void 0 : prev[STYLE], next2[STYLE]);
        current[key3] = value;
        current[STYLE] = next2[STYLE];
        return 0; // continue
      }
      prev_value = current[key3];
      if (value === prev_value && !(value === void 0 && element.hasAttribute(key3))) {
        return 0; // continue
      }
      current[key3] = value;
      prefix = key3[0] + key3[1];
      if (prefix === "$$") return 0; // continue
      if (prefix === "on") {
        var opts = {};
        var event_handle_key = "$$" + key3;
        var event_name = key3.slice(2);
        is_delegated = can_delegate_event(event_name);
        if (is_capture_event(event_name)) {
          event_name = event_name.slice(0, -7);
          opts.capture = true;
        }
        if (!is_delegated && prev_value) {
          if (value != null) return 0; // continue
          element.removeEventListener(event_name, current[event_handle_key], opts);
          current[event_handle_key] = null;
        }
        if (is_delegated) {
          delegated(event_name, element, value);
          delegate([event_name]);
        } else if (value != null) {
          var handle2 = function handle2(evt) {
            current[key3].call(this, evt);
          };
          handle = handle2;
          current[event_handle_key] = create_event(event_name, element, handle2, opts);
        }
      } else if (key3 === "style") {
        set_attribute(element, key3, value);
      } else if (key3 === "autofocus") {
        autofocus(/** @type {HTMLElement} */
        element, Boolean(value));
      } else if (!is_custom_element && (key3 === "__value" || key3 === "value" && value != null)) {
        element.value = element.__value = value;
      } else if (key3 === "selected" && is_option_element) {
        set_selected(/** @type {HTMLOptionElement} */
        element, value);
      } else {
        name = key3;
        if (!preserve_attribute_case) {
          name = normalize_attribute(name);
        }
        is_default = name === "defaultValue" || name === "defaultChecked";
        if (is_select_element && name === "defaultValue") return 0; // continue
        if (value == null && !is_custom_element && !is_default) {
          attributes[key3] = null;
          if (name === "value" || name === "checked") {
            var input = /** @type {HTMLInputElement} */
            element;
            var use_default = prev === void 0;
            if (name === "value") {
              var previous = input.defaultValue;
              input.removeAttribute(name);
              input.defaultValue = previous;
              input.value = input.__value = use_default ? previous : null;
            } else {
              var _previous = input.defaultChecked;
              input.removeAttribute(name);
              input.defaultChecked = _previous;
              input.checked = use_default ? _previous : false;
            }
          } else {
            element.removeAttribute(key3);
          }
        } else if (is_default || (is_custom_element || typeof value !== "string") && setters.has(name)) {
          element[name] = value;
          if (name in attributes) attributes[name] = UNINITIALIZED;
        } else if (typeof value !== "function") {
          set_attribute(element, name, value);
        }
      }
    },
    is_html,
    prev_value,
    prefix,
    is_delegated,
    handle,
    name,
    is_default,
    _ret;
  for (var key3 in next2) {
    _ret = _loop5(key3);
    if (_ret === 0) continue;
  }
  if (is_hydrating_custom_element) {
    set_hydrating(true);
  }
  return current;
}
function attribute_effect(element, fn) {
  var sync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var async = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var blockers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var css_hash = arguments.length > 5 ? arguments[5] : undefined;
  var should_remove_defaults = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var skip_warning = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  flatten(blockers, sync, async, function (values) {
    var prev = void 0;
    var effects = {};
    var is_select = element.nodeName === SELECT_TAG;
    var inited = false;
    managed(function () {
      var next2 = fn.apply(void 0, _toConsumableArray(values.map(_get)));
      var current = set_attributes(element, prev, next2, css_hash, should_remove_defaults, skip_warning);
      if (inited && is_select) {
        var select2 = /** @type {HTMLSelectElement} */
        element;
        if ("defaultValue" in next2) {
          set_default_select_value(select2, next2.defaultValue);
        }
        if ("value" in next2) {
          select_option(select2, next2.value);
        }
      }
      var _iterator37 = _createForOfIteratorHelper(Object.getOwnPropertySymbols(effects)),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var symbol = _step37.value;
          if (!next2[symbol]) destroy_effect(effects[symbol]);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      var _iterator38 = _createForOfIteratorHelper(Object.getOwnPropertySymbols(next2)),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var _symbol = _step38.value;
          var n = next2[_symbol];
          if (_symbol.description === ATTACHMENT_KEY && (!prev || n !== prev[_symbol])) {
            if (effects[_symbol]) destroy_effect(effects[_symbol]);
            effects[_symbol] = branch(function () {
              return attach(element, function () {
                return n;
              });
            });
          }
          current[_symbol] = n;
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
      prev = current;
    });
    if (is_select) {
      var select = /** @type {HTMLSelectElement} */
      element;
      effect(function () {
        var attrs = /** @type {Record<string | symbol, any>} */
        prev;
        if ("defaultValue" in attrs) {
          set_default_select_value(select, attrs.defaultValue);
        }
        select_option(select, attrs.value, true);
        init_select(select);
      });
    }
    inited = true;
  });
}
function get_attributes(element) {
  var _element$ATTRIBUTES_C;
  return /** @type {Record<string | symbol, unknown>} **/ /** @type {any} */(_element$ATTRIBUTES_C = element[ATTRIBUTES_CACHE]) !== null && _element$ATTRIBUTES_C !== void 0 ? _element$ATTRIBUTES_C : element[ATTRIBUTES_CACHE] = _defineProperty(_defineProperty({}, IS_CUSTOM_ELEMENT, element.nodeName.includes("-")), IS_HTML, element.namespaceURI === NAMESPACE_HTML);
}
var setters_cache = /* @__PURE__ */new Map();
function get_setters(element) {
  var cache_key = element.getAttribute("is") || element.nodeName;
  var setters = setters_cache.get(cache_key);
  if (setters) return setters;
  setters_cache.set(cache_key, setters = /* @__PURE__ */new Set());
  var descriptors;
  var proto = element;
  var element_proto = Element.prototype;
  while (element_proto !== proto) {
    descriptors = get_descriptors(proto);
    for (var key2 in descriptors) {
      if (descriptors[key2].set &&
      // better safe than sorry, we don't want spread attributes to mess with HTML content
      key2 !== "innerHTML" && key2 !== "textContent" && key2 !== "innerText") {
        setters.add(key2);
      }
    }
    proto = get_prototype_of(proto);
  }
  return setters;
}
function bind_value(input, get2) {
  var set2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : get2;
  var batches = /* @__PURE__ */new WeakSet();
  listen_to_event_and_reset_event(input, "input", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(is_reset) {
      var value, start, end, length, new_length;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            value = is_reset ? input.defaultValue : input.value;
            value = is_numberlike_input(input) ? to_number(value) : value;
            set2(value);
            if (current_batch !== null) {
              batches.add(current_batch);
            }
            _context.n = 1;
            return tick();
          case 1:
            if (value !== (value = get2())) {
              start = input.selectionStart;
              end = input.selectionEnd;
              length = input.value.length;
              input.value = value !== null && value !== void 0 ? value : "";
              if (end !== null) {
                new_length = input.value.length;
                if (start === end && end === length && new_length > length) {
                  input.selectionStart = new_length;
                  input.selectionEnd = new_length;
                } else {
                  input.selectionStart = start;
                  input.selectionEnd = Math.min(end, new_length);
                }
              }
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
  if (
  // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  hydrating && input.defaultValue !== input.value ||
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  untrack(get2) == null && input.value) {
    set2(is_numberlike_input(input) ? to_number(input.value) : input.value);
    if (current_batch !== null) {
      batches.add(current_batch);
    }
  }
  render_effect(function () {
    var value = get2();
    if (input === document.activeElement) {
      var batch = /** @type {Batch} */
      current_batch;
      if (batches.has(batch)) {
        return;
      }
    }
    if (is_numberlike_input(input) && value === to_number(input.value)) {
      return;
    }
    if (input.type === "date" && !value && !input.value) {
      return;
    }
    if (value !== input.value) {
      input.value = value !== null && value !== void 0 ? value : "";
    }
  });
}
function is_numberlike_input(input) {
  var type = input.type;
  return type === "number" || type === "range";
}
function to_number(value) {
  return value === "" ? null : +value;
}
function is_bound_this(bound_value, element_or_component) {
  return bound_value === element_or_component || (bound_value === null || bound_value === void 0 ? void 0 : bound_value[STATE_SYMBOL]) === element_or_component;
}
function bind_this() {
  var element_or_component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mark_as_component();
  var update = arguments.length > 1 ? arguments[1] : undefined;
  var get_value = arguments.length > 2 ? arguments[2] : undefined;
  var get_parts = arguments.length > 3 ? arguments[3] : undefined;
  var component_effect = /** @type {ComponentContext} */
  component_context.r;
  var parent = /** @type {Effect} */
  active_effect;
  effect(function () {
    var old_parts;
    var parts;
    render_effect(function () {
      old_parts = parts;
      parts = [];
      untrack(function () {
        if (!is_bound_this(get_value.apply(void 0, _toConsumableArray(parts)), element_or_component)) {
          update.apply(void 0, [element_or_component].concat(_toConsumableArray(parts)));
          if (old_parts && is_bound_this(get_value.apply(void 0, _toConsumableArray(old_parts)), element_or_component)) {
            update.apply(void 0, [null].concat(_toConsumableArray(old_parts)));
          }
        }
      });
    });
    return function () {
      var p = parent;
      while (p !== component_effect && p.parent !== null && p.parent.f & DESTROYING) {
        p = p.parent;
      }
      var teardown2 = function teardown2() {
        if (parts && is_bound_this(get_value.apply(void 0, _toConsumableArray(parts)), element_or_component)) {
          update.apply(void 0, [null].concat(_toConsumableArray(parts)));
        }
      };
      var original_teardown = p.teardown;
      p.teardown = function () {
        teardown2();
        original_teardown === null || original_teardown === void 0 || original_teardown();
      };
    };
  });
  return element_or_component;
}
var rest_props_handler = {
  get: function get(target, key2) {
    if (target.exclude.has(key2)) return;
    return target.props[key2];
  },
  set: function set(target, key2) {
    return false;
  },
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, key2) {
    if (target.exclude.has(key2)) return;
    if (key2 in target.props) {
      return {
        enumerable: true,
        configurable: true,
        value: target.props[key2]
      };
    }
  },
  has: function has(target, key2) {
    if (target.exclude.has(key2)) return false;
    return key2 in target.props;
  },
  ownKeys: function ownKeys(target) {
    return Reflect.ownKeys(target.props).filter(function (key2) {
      return !target.exclude.has(key2);
    });
  }
};
// @__NO_SIDE_EFFECTS__
function rest_props(props, exclude, name) {
  return new Proxy({
    props: props,
    exclude: exclude
  }, rest_props_handler);
}
function prop(props, key2, flags2, fallback) {
  var fallback_value = /** @type {V} */
  fallback;
  var fallback_dirty = true;
  var get_fallback = function get_fallback() {
    if (fallback_dirty) {
      fallback_dirty = false;
      fallback_value = /** @type {V} */
      fallback;
    }
    return fallback_value;
  };
  var initial_value;
  {
    initial_value = /** @type {V} */
    props[key2];
  }
  if (initial_value === void 0 && fallback !== void 0) {
    initial_value = get_fallback();
  }
  var getter;
  {
    getter = function getter() {
      var value = /** @type {V} */
      props[key2];
      if (value === void 0) return get_fallback();
      fallback_dirty = true;
      return value;
    };
  }
  var overridden = false;
  var d = /* @__PURE__ */derived(function () {
    overridden = false;
    return getter();
  });
  var parent_effect = /** @type {Effect} */
  active_effect;
  return /** @type {() => V} */function (value, mutation) {
    if (arguments.length > 0) {
      var new_value = mutation ? _get(d) : value;
      _set(d, new_value);
      overridden = true;
      if (fallback_value !== void 0) {
        fallback_value = new_value;
      }
      return value;
    }
    if (is_destroying_effect && overridden || (parent_effect.f & DESTROYED) !== 0) {
      return d.v;
    }
    return _get(d);
  };
}
function createClassComponent(options) {
  return new Svelte4Component(options);
}
var _events = /*#__PURE__*/new WeakMap();
var _instance = /*#__PURE__*/new WeakMap();
var Svelte4Component = /*#__PURE__*/function () {
  /**
   * @param {ComponentConstructorOptions & {
   *  component: any;
   * }} options
   */
  function Svelte4Component(options) {
    var _options$intro2,
      _options$props,
      _this0 = this;
    _classCallCheck(this, Svelte4Component);
    /** @type {any} */
    _classPrivateFieldInitSpec(this, _events, void 0);
    /** @type {Record<string, any>} */
    _classPrivateFieldInitSpec(this, _instance, void 0);
    var sources = /* @__PURE__ */new Map();
    var add_source = function add_source(key2, value) {
      var s = /* @__PURE__ */mutable_source(value, false, false);
      sources.set(key2, s);
      return s;
    };
    var props = new Proxy(_objectSpread(_objectSpread({}, options.props || {}), {}, {
      $$events: {}
    }), {
      get: function get(target, prop2) {
        var _sources$get;
        return _get((_sources$get = sources.get(prop2)) !== null && _sources$get !== void 0 ? _sources$get : add_source(prop2, Reflect.get(target, prop2)));
      },
      has: function has(target, prop2) {
        var _sources$get2;
        if (prop2 === LEGACY_PROPS) return true;
        _get((_sources$get2 = sources.get(prop2)) !== null && _sources$get2 !== void 0 ? _sources$get2 : add_source(prop2, Reflect.get(target, prop2)));
        return Reflect.has(target, prop2);
      },
      set: function set(target, prop2, value) {
        var _sources$get3;
        _set((_sources$get3 = sources.get(prop2)) !== null && _sources$get3 !== void 0 ? _sources$get3 : add_source(prop2, value), value);
        return Reflect.set(target, prop2, value);
      }
    });
    _classPrivateFieldSet(_instance, this, (options.hydrate ? hydrate : mount)(options.component, {
      target: options.target,
      anchor: options.anchor,
      props: props,
      context: options.context,
      intro: (_options$intro2 = options.intro) !== null && _options$intro2 !== void 0 ? _options$intro2 : false,
      recover: options.recover,
      transformError: options.transformError
    }));
    if (!(options !== null && options !== void 0 && (_options$props = options.props) !== null && _options$props !== void 0 && _options$props.$$host) || options.sync === false) {
      flushSync();
    }
    _classPrivateFieldSet(_events, this, props.$$events);
    var _loop6 = function _loop6() {
      var key2 = _Object$keys3[_i5];
      if (key2 === "$set" || key2 === "$destroy" || key2 === "$on") return 1; // continue
      define_property(_this0, key2, {
        get: function get() {
          return _classPrivateFieldGet(_instance, this)[key2];
        },
        /** @param {any} value */set: function set(value) {
          _classPrivateFieldGet(_instance, this)[key2] = value;
        },
        enumerable: true
      });
    };
    for (var _i5 = 0, _Object$keys3 = Object.keys(_classPrivateFieldGet(_instance, this)); _i5 < _Object$keys3.length; _i5++) {
      if (_loop6()) continue;
    }
    _classPrivateFieldGet(_instance, this).$set = /** @param {Record<string, any>} next */
    function (next2) {
      Object.assign(props, next2);
    };
    _classPrivateFieldGet(_instance, this).$destroy = function () {
      unmount(_classPrivateFieldGet(_instance, _this0));
    };
  }
  /** @param {Record<string, any>} props */
  return _createClass(Svelte4Component, [{
    key: "$set",
    value: function $set(props) {
      _classPrivateFieldGet(_instance, this).$set(props);
    }
    /**
     * @param {string} event
     * @param {(...args: any[]) => any} callback
     * @returns {any}
     */
  }, {
    key: "$on",
    value: function $on(event2, callback) {
      var _this1 = this;
      _classPrivateFieldGet(_events, this)[event2] = _classPrivateFieldGet(_events, this)[event2] || [];
      var cb = function cb() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        return callback.call.apply(callback, [_this1].concat(args));
      };
      _classPrivateFieldGet(_events, this)[event2].push(cb);
      return function () {
        _classPrivateFieldGet(_events, _this1)[event2] = _classPrivateFieldGet(_events, _this1)[event2].filter(/** @param {any} fn */
        function (fn) {
          return fn !== cb;
        });
      };
    }
  }, {
    key: "$destroy",
    value: function $destroy() {
      _classPrivateFieldGet(_instance, this).$destroy();
    }
  }]);
}();
var SvelteElement = /*#__PURE__*/_createClass(function SvelteElement() {
  _classCallCheck(this, SvelteElement);
});
if (typeof HTMLElement === "function") {
  SvelteElement = /*#__PURE__*/function (_HTMLElement) {
    /**
     * @param {*} $$componentCtor
     * @param {*} $$slots
     * @param {ShadowRootInit | undefined} shadow_root_init
     */
    function SvelteElement($$componentCtor, $$slots, shadow_root_init) {
      var _this10;
      _classCallCheck(this, SvelteElement);
      _this10 = _callSuper(this, SvelteElement);
      /** The Svelte component constructor */
      _defineProperty(_this10, "$$ctor", void 0);
      /** Slots */
      _defineProperty(_this10, "$$s", void 0);
      /** @type {any} The Svelte component instance */
      _defineProperty(_this10, "$$c", void 0);
      /** Whether or not the custom element is connected */
      _defineProperty(_this10, "$$cn", false);
      /** @type {Record<string, any>} Component props data */
      _defineProperty(_this10, "$$d", {});
      /** `true` if currently in the process of reflecting component props back to attributes */
      _defineProperty(_this10, "$$r", false);
      /** @type {Record<string, CustomElementPropDefinition>} Props definition (name, reflected, type etc) */
      _defineProperty(_this10, "$$p_d", {});
      /** @type {Record<string, EventListenerOrEventListenerObject[]>} Event listeners */
      _defineProperty(_this10, "$$l", {});
      /** @type {Map<EventListenerOrEventListenerObject, Function>} Event listener unsubscribe functions */
      _defineProperty(_this10, "$$l_u", /* @__PURE__ */new Map());
      /** @type {any} The managed render effect for reflecting attributes */
      _defineProperty(_this10, "$$me", void 0);
      /** @type {ShadowRoot | null} The ShadowRoot of the custom element */
      _defineProperty(_this10, "$$shadowRoot", null);
      _this10.$$ctor = $$componentCtor;
      _this10.$$s = $$slots;
      if (shadow_root_init) {
        _this10.$$shadowRoot = _this10.attachShadow(shadow_root_init);
      }
      return _this10;
    }
    /**
     * @param {string} type
     * @param {EventListenerOrEventListenerObject} listener
     * @param {boolean | AddEventListenerOptions} [options]
     */
    _inherits(SvelteElement, _HTMLElement);
    return _createClass(SvelteElement, [{
      key: "addEventListener",
      value: function addEventListener(type, listener, options) {
        this.$$l[type] = this.$$l[type] || [];
        this.$$l[type].push(listener);
        if (this.$$c) {
          var unsub = this.$$c.$on(type, listener);
          this.$$l_u.set(listener, unsub);
        }
        _superPropGet(SvelteElement, "addEventListener", this, 3)([type, listener, options]);
      }
      /**
       * @param {string} type
       * @param {EventListenerOrEventListenerObject} listener
       * @param {boolean | AddEventListenerOptions} [options]
       */
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, listener, options) {
        _superPropGet(SvelteElement, "removeEventListener", this, 3)([type, listener, options]);
        if (this.$$c) {
          var unsub = this.$$l_u.get(listener);
          if (unsub) {
            unsub();
            this.$$l_u["delete"](listener);
          }
        }
      }
    }, {
      key: "connectedCallback",
      value: function () {
        var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var _this11 = this;
          var create_slot2, create_slot, $$slots, existing_slots, _iterator39, _step39, name, _iterator40, _step40, attribute, _name, key2, type, _iterator42, _step42, listener, unsub;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                this.$$cn = true;
                if (this.$$c) {
                  _context2.n = 3;
                  break;
                }
                create_slot2 = function create_slot2(name) {
                  return function (anchor) {
                    var slot = create_element("slot");
                    if (name !== "default") slot.name = name;
                    append(anchor, slot);
                  };
                };
                create_slot = create_slot2;
                _context2.n = 1;
                return Promise.resolve();
              case 1:
                if (!(!this.$$cn || this.$$c)) {
                  _context2.n = 2;
                  break;
                }
                return _context2.a(2);
              case 2:
                $$slots = {};
                existing_slots = get_custom_elements_slots(this);
                _iterator39 = _createForOfIteratorHelper(this.$$s);
                try {
                  for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
                    name = _step39.value;
                    if (name in existing_slots) {
                      if (name === "default" && !this.$$d.children) {
                        this.$$d.children = create_slot2(name);
                        $$slots["default"] = true;
                      } else {
                        $$slots[name] = create_slot2(name);
                      }
                    }
                  }
                } catch (err) {
                  _iterator39.e(err);
                } finally {
                  _iterator39.f();
                }
                _iterator40 = _createForOfIteratorHelper(this.attributes);
                try {
                  for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                    attribute = _step40.value;
                    _name = this.$$g_p(attribute.name);
                    if (!(_name in this.$$d)) {
                      this.$$d[_name] = get_custom_element_value(_name, attribute.value, this.$$p_d, "toProp");
                    }
                  }
                } catch (err) {
                  _iterator40.e(err);
                } finally {
                  _iterator40.f();
                }
                for (key2 in this.$$p_d) {
                  if (!(key2 in this.$$d) && this[key2] !== void 0) {
                    this.$$d[key2] = this[key2];
                    delete this[key2];
                  }
                }
                this.$$c = createClassComponent({
                  component: this.$$ctor,
                  target: this.$$shadowRoot || this,
                  props: _objectSpread(_objectSpread({}, this.$$d), {}, {
                    $$slots: $$slots,
                    $$host: this
                  })
                });
                this.$$me = effect_root(function () {
                  render_effect(function () {
                    _this11.$$r = true;
                    var _iterator41 = _createForOfIteratorHelper(object_keys(_this11.$$c)),
                      _step41;
                    try {
                      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
                        var _this11$$$p_d$_key;
                        var _key4 = _step41.value;
                        if (!((_this11$$$p_d$_key = _this11.$$p_d[_key4]) !== null && _this11$$$p_d$_key !== void 0 && _this11$$$p_d$_key.reflect)) continue;
                        _this11.$$d[_key4] = _this11.$$c[_key4];
                        var attribute_value = get_custom_element_value(_key4, _this11.$$d[_key4], _this11.$$p_d, "toAttribute");
                        if (attribute_value == null) {
                          _this11.removeAttribute(_this11.$$p_d[_key4].attribute || _key4);
                        } else {
                          _this11.setAttribute(_this11.$$p_d[_key4].attribute || _key4, attribute_value);
                        }
                      }
                    } catch (err) {
                      _iterator41.e(err);
                    } finally {
                      _iterator41.f();
                    }
                    _this11.$$r = false;
                  });
                });
                for (type in this.$$l) {
                  _iterator42 = _createForOfIteratorHelper(this.$$l[type]);
                  try {
                    for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                      listener = _step42.value;
                      unsub = this.$$c.$on(type, listener);
                      this.$$l_u.set(listener, unsub);
                    }
                  } catch (err) {
                    _iterator42.e(err);
                  } finally {
                    _iterator42.f();
                  }
                }
                this.$$l = {};
              case 3:
                return _context2.a(2);
            }
          }, _callee2, this);
        }));
        function connectedCallback() {
          return _connectedCallback.apply(this, arguments);
        }
        return connectedCallback;
      }() // We don't need this when working within Svelte code, but for compatibility of people using this outside of Svelte
      // and setting attributes through setAttribute etc, this is helpful
      /**
       * @param {string} attr
       * @param {string} _oldValue
       * @param {string} newValue
       */
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        var _this$$$c;
        if (this.$$r) return;
        attr = this.$$g_p(attr);
        this.$$d[attr] = get_custom_element_value(attr, newValue, this.$$p_d, "toProp");
        (_this$$$c = this.$$c) === null || _this$$$c === void 0 || _this$$$c.$set(_defineProperty({}, attr, this.$$d[attr]));
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _this12 = this;
        this.$$cn = false;
        Promise.resolve().then(function () {
          if (!_this12.$$cn && _this12.$$c) {
            _this12.$$c.$destroy();
            _this12.$$me();
            _this12.$$c = void 0;
          }
        });
      }
      /**
       * @param {string} attribute_name
       */
    }, {
      key: "$$g_p",
      value: function $$g_p(attribute_name) {
        var _this13 = this;
        return object_keys(this.$$p_d).find(function (key2) {
          return _this13.$$p_d[key2].attribute === attribute_name || !_this13.$$p_d[key2].attribute && key2.toLowerCase() === attribute_name;
        }) || attribute_name;
      }
    }]);
  }(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
}
function get_custom_element_value(prop2, value, props_definition, transform) {
  var _props_definition$pro;
  var type = (_props_definition$pro = props_definition[prop2]) === null || _props_definition$pro === void 0 ? void 0 : _props_definition$pro.type;
  value = type === "Boolean" && typeof value !== "boolean" ? value != null : value;
  if (!transform || !props_definition[prop2]) {
    return value;
  } else if (transform === "toAttribute") {
    switch (type) {
      case "Object":
      case "Array":
        return value == null ? null : JSON.stringify(value);
      case "Boolean":
        return value ? "" : null;
      case "Number":
        return value == null ? null : value;
      default:
        return value;
    }
  } else {
    switch (type) {
      case "Object":
      case "Array":
        return value && JSON.parse(value);
      case "Boolean":
        return value;
      // conversion already handled above
      case "Number":
        return value != null ? +value : value;
      default:
        return value;
    }
  }
}
function get_custom_elements_slots(element) {
  var result = {};
  element.childNodes.forEach(function (node) {
    result[/** @type {Element} node */
    node.slot || "default"] = true;
  });
  return result;
}
function create_custom_element(Component, props_definition, slots, exports, shadow_root_init, extend) {
  var Class = /*#__PURE__*/function (_SvelteElement) {
    function Class() {
      var _this14;
      _classCallCheck(this, Class);
      _this14 = _callSuper(this, Class, [Component, slots, shadow_root_init]);
      _this14.$$p_d = props_definition;
      return _this14;
    }
    _inherits(Class, _SvelteElement);
    return _createClass(Class, null, [{
      key: "observedAttributes",
      get: function get() {
        return object_keys(props_definition).map(function (key2) {
          return (props_definition[key2].attribute || key2).toLowerCase();
        });
      }
    }]);
  }(SvelteElement);
  object_keys(props_definition).forEach(function (prop2) {
    define_property(Class.prototype, prop2, {
      get: function get() {
        return this.$$c && prop2 in this.$$c ? this.$$c[prop2] : this.$$d[prop2];
      },
      set: function set(value) {
        value = get_custom_element_value(prop2, value, props_definition);
        this.$$d[prop2] = value;
        var component2 = this.$$c;
        if (component2) {
          var _get_descriptor4;
          var setter = (_get_descriptor4 = get_descriptor(component2, prop2)) === null || _get_descriptor4 === void 0 ? void 0 : _get_descriptor4.get;
          if (setter) {
            component2[prop2] = value;
          } else {
            component2.$set(_defineProperty({}, prop2, value));
          }
        }
      }
    });
  });
  exports.forEach(function (property) {
    define_property(Class.prototype, property, {
      get: function get() {
        var _this$$$c2;
        return (_this$$$c2 = this.$$c) === null || _this$$$c2 === void 0 ? void 0 : _this$$$c2[property];
      }
    });
  });
  Component.element = /** @type {any} */
  Class;
  return Class;
}
var rest_excludes$3 = /* @__PURE__ */new Set(["$$slots", "$$events", "$$legacy", "$$host", "loading"]);
var root$7 = /* @__PURE__ */from_html("<div class=\"altcha-checkbox\"><input/> <svg aria-hidden=\"true\" width=\"12\" height=\"9\" viewBox=\"0 0 12 9\"><polyline points=\"1 5 4 8 11 1\"></polyline></svg> <div class=\"altcha-spinner altcha-checkbox-spinner\" aria-hidden=\"true\"></div></div>");
function Checkbox($$anchor, $$props) {
  push($$props, true);
  var loading = prop($$props, "loading"),
    rest = /* @__PURE__ */rest_props($$props, rest_excludes$3);
  var inputEl;
  function onClick() {
    var _inputEl;
    (_inputEl = inputEl) === null || _inputEl === void 0 || _inputEl.click();
  }
  var $$exports = {
    get loading() {
      return loading();
    },
    set loading($$value) {
      loading($$value);
      flushSync();
    }
  };
  var div = root$7();
  var input = child(div);
  attribute_effect(input, function () {
    return _objectSpread({
      type: "checkbox"
    }, rest);
  }, void 0, void 0, void 0, void 0, true);
  bind_this(input, function ($$value) {
    return inputEl = $$value;
  }, function () {
    return inputEl;
  });
  var svg = sibling(input, 2);
  next(2);
  reset(div);
  template_effect(function () {
    return set_attribute(div, "data-loading", loading());
  });
  delegated("click", svg, onClick);
  append($$anchor, div);
  return pop($$exports);
}
delegate(["click"]);
create_custom_element(Checkbox, {
  loading: {}
}, [], [], {
  mode: "open"
});
var rest_excludes$2 = /* @__PURE__ */new Set(["$$slots", "$$events", "$$legacy", "$$host", "loading"]);
var root$6 = /* @__PURE__ */from_html("<div class=\"altcha-checkbox-native\"><input/> <div class=\"altcha-spinner altcha-checkbox-native-spinner\"></div></div>");
function CheckboxNative($$anchor, $$props) {
  push($$props, true);
  var loading = prop($$props, "loading"),
    rest = /* @__PURE__ */rest_props($$props, rest_excludes$2);
  var $$exports = {
    get loading() {
      return loading();
    },
    set loading($$value) {
      loading($$value);
      flushSync();
    }
  };
  var div = root$6();
  var input = child(div);
  attribute_effect(input, function () {
    return _objectSpread({
      type: "checkbox"
    }, rest);
  }, void 0, void 0, void 0, void 0, true);
  next(2);
  reset(div);
  template_effect(function () {
    return set_attribute(div, "data-loading", loading());
  });
  append($$anchor, div);
  return pop($$exports);
}
create_custom_element(CheckboxNative, {
  loading: {}
}, [], [], {
  mode: "open"
});
var root$5 = /* @__PURE__ */from_html("<div><a target=\"_blank\" rel=\"noopener\" class=\"altcha-logo\" aria-hidden=\"true\" tabindex=\"-1\"><svg width=\"22\" height=\"22\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.33955 16.4279C5.88954 20.6586 12.1971 21.2105 16.4279 17.6604C18.4699 15.947 19.6548 13.5911 19.9352 11.1365L17.9886 10.4279C17.8738 12.5624 16.909 14.6459 15.1423 16.1284C11.7577 18.9684 6.71167 18.5269 3.87164 15.1423C1.03163 11.7577 1.4731 6.71166 4.8577 3.87164C8.24231 1.03162 13.2883 1.4731 16.1284 4.8577C16.9767 5.86872 17.5322 7.02798 17.804 8.2324L19.9522 9.01429C19.7622 7.07737 19.0059 5.17558 17.6604 3.57212C14.1104 -0.658624 7.80283 -1.21043 3.57212 2.33956C-0.658625 5.88958 -1.21046 12.1971 2.33955 16.4279Z\" fill=\"currentColor\"></path><path d=\"M3.57212 2.33956C1.65755 3.94607 0.496389 6.11731 0.12782 8.40523L2.04639 9.13961C2.26047 7.15832 3.21057 5.25375 4.8577 3.87164C8.24231 1.03162 13.2883 1.4731 16.1284 4.8577L13.8302 6.78606L19.9633 9.13364C19.7929 7.15555 19.0335 5.20847 17.6604 3.57212C14.1104 -0.658624 7.80283 -1.21043 3.57212 2.33956Z\" fill=\"currentColor\"></path><path d=\"M7 10H5C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10H13C13 11.6569 11.6569 13 10 13C8.3431 13 7 11.6569 7 10Z\" fill=\"currentColor\"></path></svg></a></div>");
function Logo($$anchor, $$props) {
  push($$props, true);
  var strings = prop($$props, "strings");
  var website = "https://altcha.org";
  var $$exports = {
    get strings() {
      return strings();
    },
    set strings($$value) {
      strings($$value);
      flushSync();
    }
  };
  var div = root$5();
  var a = child(div);
  set_attribute(a, "href", website);
  reset(div);
  template_effect(function () {
    return set_attribute(a, "aria-label", strings().ariaLinkLabel);
  });
  append($$anchor, div);
  return pop($$exports);
}
create_custom_element(Logo, {
  strings: {}
}, [], [], {
  mode: "open"
});
var root$4 = /* @__PURE__ */from_html("<div class=\"altcha-footer\"><p></p> <!></div>");
function Footer($$anchor, $$props) {
  push($$props, true);
  var logo = prop($$props, "logo"),
    strings = prop($$props, "strings");
  var $$exports = {
    get logo() {
      return logo();
    },
    set logo($$value) {
      logo($$value);
      flushSync();
    },
    get strings() {
      return strings();
    },
    set strings($$value) {
      strings($$value);
      flushSync();
    }
  };
  var div = root$4();
  var p = child(div);
  html(p, function () {
    return strings().footer;
  }, true);
  reset(p);
  var node = sibling(p, 2);
  {
    var consequent = function consequent($$anchor2) {
      Logo($$anchor2, {
        get strings() {
          return strings();
        }
      });
    };
    if_block(node, function ($$render) {
      if (logo()) $$render(consequent);
    });
  }
  reset(div);
  append($$anchor, div);
  return pop($$exports);
}
create_custom_element(Footer, {
  logo: {},
  strings: {}
}, [], [], {
  mode: "open"
});
var rest_excludes$1 = /* @__PURE__ */new Set(["$$slots", "$$events", "$$legacy", "$$host", "loading"]);
var root$3 = /* @__PURE__ */from_html("<div class=\"altcha-switch\"><input/>  <div class=\"altcha-switch-toggle\"><div class=\"altcha-spinner altcha-switch-spinner\"></div></div></div>");
function Switch($$anchor, $$props) {
  push($$props, true);
  var loading = prop($$props, "loading"),
    rest = /* @__PURE__ */rest_props($$props, rest_excludes$1);
  var inputEl;
  function onClick() {
    var _inputEl2;
    (_inputEl2 = inputEl) === null || _inputEl2 === void 0 || _inputEl2.click();
  }
  var $$exports = {
    get loading() {
      return loading();
    },
    set loading($$value) {
      loading($$value);
      flushSync();
    }
  };
  var div = root$3();
  var input = child(div);
  attribute_effect(input, function () {
    return _objectSpread({
      type: "checkbox"
    }, rest);
  }, void 0, void 0, void 0, void 0, true);
  bind_this(input, function ($$value) {
    return inputEl = $$value;
  }, function () {
    return inputEl;
  });
  var div_1 = sibling(input, 2);
  reset(div);
  template_effect(function () {
    return set_attribute(div, "data-loading", loading());
  });
  delegated("click", div_1, onClick);
  append($$anchor, div);
  return pop($$exports);
}
delegate(["click"]);
create_custom_element(Switch, {
  loading: {}
}, [], [], {
  mode: "open"
});
var AudioState = /* @__PURE__ */function (AudioState2) {
  AudioState2["ERROR"] = "error";
  AudioState2["LOADING"] = "loading";
  AudioState2["PLAYING"] = "playing";
  AudioState2["PAUSED"] = "paused";
  AudioState2["READY"] = "ready";
  return AudioState2;
}(AudioState || {});
var State = /* @__PURE__ */function (State2) {
  State2["CODE"] = "code";
  State2["ERROR"] = "error";
  State2["VERIFIED"] = "verified";
  State2["VERIFYING"] = "verifying";
  State2["UNVERIFIED"] = "unverified";
  State2["EXPIRED"] = "expired";
  return State2;
}(State || {});
var root$2 = /* @__PURE__ */from_html("<div class=\"altcha-code-challenge-title\"> </div>");
var root_1$2 = /* @__PURE__ */from_html("<div class=\"altcha-spinner\"></div>");
var root_2$2 = /* @__PURE__ */from_svg("<svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017ZM10.9999 16.0002V18.0002H12.9999V16.0002H10.9999ZM10.9999 9.00017V14.0002H12.9999V9.00017H10.9999Z\"></path></svg>");
var root_3$2 = /* @__PURE__ */from_svg("<svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M15 7C15 6.44772 15.4477 6 16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7ZM7 7C7 6.44772 7.44772 6 8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7Z\"></path></svg>");
var root_4$1 = /* @__PURE__ */from_svg("<svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M4 12H7C8.10457 12 9 12.8954 9 14V19C9 20.1046 8.10457 21 7 21H4C2.89543 21 2 20.1046 2 19V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V19C22 20.1046 21.1046 21 20 21H17C15.8954 21 15 20.1046 15 19V14C15 12.8954 15.8954 12 17 12H20C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z\"></path></svg>");
var root_5$1 = /* @__PURE__ */from_html("<button type=\"button\" class=\"altcha-button altcha-button-secondary\"><!></button>");
var root_6$1 = /* @__PURE__ */from_html("<audio hidden=\"\" autoplay=\"\"></audio>");
var root_7$1 = /* @__PURE__ */from_html("<div class=\"altcha-code-challenge\"><form data-code-challenge=\"true\"><!> <div class=\"altcha-code-challenge-text\"> </div> <img class=\"altcha-code-challenge-image\" alt=\"\"/> <div class=\"altcha-code-challenge-row\"><input type=\"text\" class=\"altcha-input\" autocomplete=\"off\" name=\"\" required=\"\"/> <!> <button type=\"button\" class=\"altcha-button altcha-button-secondary\"><svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2V4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 9.25022 5.38734 6.82447 7.50024 5.38451L7.5 8H9.5V2L3.5 2V4L5.99918 3.99989C3.57075 5.82434 2 8.72873 2 12Z\"></path></svg></button></div> <div class=\"altcha-code-challenge-buttons\"><button type=\"submit\" class=\"altcha-button\"> </button> <button type=\"button\" class=\"altcha-button altcha-button-secondary\"> </button></div></form> <!></div>");
function Code($$anchor, $$props) {
  push($$props, true);
  var audioUrl = prop($$props, "audioUrl"),
    codeChallenge = prop($$props, "codeChallenge"),
    config = prop($$props, "config"),
    imageUrl = prop($$props, "imageUrl"),
    onCancel = prop($$props, "onCancel"),
    onReload = prop($$props, "onReload"),
    onSubmit = prop($$props, "onSubmit"),
    strings = prop($$props, "strings");
  var audioState = /* @__PURE__ */state(void 0);
  var elAudio = /* @__PURE__ */state(void 0);
  var elInput = /* @__PURE__ */state(void 0);
  var loading = /* @__PURE__ */state(false);
  var code = /* @__PURE__ */state("");
  var playAudio = /* @__PURE__ */state(false);
  onMount(function () {
    if (!config().disableAutoFocus) {
      tick().then(function () {
        var _get3;
        (_get3 = _get(elInput)) === null || _get3 === void 0 || _get3.focus();
      });
    }
    return function () {
      if (_get(elAudio)) {
        _get(elAudio).pause();
        _set(elAudio, void 0);
      }
    };
  });
  function onAudioEnded() {
    _set(audioState, AudioState.PAUSED, true);
  }
  function onAudioError(ev) {
    _set(audioState, AudioState.ERROR, true);
  }
  function onAudioCanPlay() {
    _set(audioState, AudioState.READY, true);
  }
  function onAudioLoadStart() {
    _set(audioState, AudioState.LOADING, true);
  }
  function onAudioPlaying() {
    _set(audioState, AudioState.PLAYING, true);
  }
  function onAudioPause() {
    _set(audioState, AudioState.PAUSED, true);
  }
  function onInputKeyDown(ev) {
    if (ev.code === "Space") {
      ev.preventDefault();
      ev.stopPropagation();
      onPlayAudio();
    } else if (ev.code === "Escape") {
      var _onCancel;
      ev.preventDefault();
      ev.stopPropagation();
      (_onCancel = onCancel()) === null || _onCancel === void 0 || _onCancel();
    }
  }
  function onSubmitCapture(ev) {
    var _onSubmit;
    ev.preventDefault();
    ev.stopPropagation();
    (_onSubmit = onSubmit()) === null || _onSubmit === void 0 || _onSubmit(_get(code));
  }
  function onPlayAudio() {
    if (_get(elAudio)) {
      if (_get(audioState) === AudioState.LOADING) ;else if (!_get(elAudio).paused) {
        _get(elAudio).pause();
      } else {
        if (audioUrl() && _get(elAudio).src !== audioUrl()) {
          _get(elAudio).src = audioUrl();
        }
        _get(elAudio).currentTime = 0;
        _get(elAudio).play();
      }
    } else {
      _set(playAudio, true);
      requestAnimationFrame(function () {
        if (_get(elAudio) && audioUrl()) {
          _get(elAudio).src = audioUrl();
          _get(elAudio).play();
        }
      });
    }
  }
  var $$exports = {
    get audioUrl() {
      return audioUrl();
    },
    set audioUrl($$value) {
      audioUrl($$value);
      flushSync();
    },
    get codeChallenge() {
      return codeChallenge();
    },
    set codeChallenge($$value) {
      codeChallenge($$value);
      flushSync();
    },
    get config() {
      return config();
    },
    set config($$value) {
      config($$value);
      flushSync();
    },
    get imageUrl() {
      return imageUrl();
    },
    set imageUrl($$value) {
      imageUrl($$value);
      flushSync();
    },
    get onCancel() {
      return onCancel();
    },
    set onCancel($$value) {
      onCancel($$value);
      flushSync();
    },
    get onReload() {
      return onReload();
    },
    set onReload($$value) {
      onReload($$value);
      flushSync();
    },
    get onSubmit() {
      return onSubmit();
    },
    set onSubmit($$value) {
      onSubmit($$value);
      flushSync();
    },
    get strings() {
      return strings();
    },
    set strings($$value) {
      strings($$value);
      flushSync();
    }
  };
  var div = root_7$1();
  var form = child(div);
  var node = child(form);
  {
    var consequent = function consequent($$anchor2) {
      var div_1 = root$2();
      var text2 = only_child(div_1, true);
      template_effect(function () {
        return set_text(text2, strings().verificationRequired);
      });
      append($$anchor2, div_1);
    };
    if_block(node, function ($$render) {
      if (config().codeChallengeDisplay !== "standard") $$render(consequent);
    });
  }
  var div_2 = sibling(node, 2);
  var text_1 = only_child(div_2, true);
  var img = sibling(div_2, 2);
  var div_3 = sibling(img, 2);
  var input = child(div_3);
  remove_input_defaults(input);
  input.disabled = _get(loading);
  bind_this(input, function ($$value) {
    return _set(elInput, $$value);
  }, function () {
    return _get(elInput);
  });
  var node_1 = sibling(input, 2);
  {
    var consequent_4 = function consequent_4($$anchor2) {
      var button = root_5$1();
      var node_2 = child(button);
      {
        var consequent_1 = function consequent_1($$anchor3) {
          var div_4 = root_1$2();
          append($$anchor3, div_4);
        };
        var consequent_2 = function consequent_2($$anchor3) {
          var svg = root_2$2();
          append($$anchor3, svg);
        };
        var consequent_3 = function consequent_3($$anchor3) {
          var svg_1 = root_3$2();
          append($$anchor3, svg_1);
        };
        var alternate = function alternate($$anchor3) {
          var svg_2 = root_4$1();
          append($$anchor3, svg_2);
        };
        if_block(node_2, function ($$render) {
          if (_get(audioState) === AudioState.LOADING) $$render(consequent_1);else if (_get(audioState) === AudioState.ERROR) $$render(consequent_2, 1);else if (_get(audioState) === AudioState.PLAYING) $$render(consequent_3, 2);else $$render(alternate, -1);
        });
      }
      reset(button);
      template_effect(function () {
        set_attribute(button, "title", strings().getAudioChallenge);
        button.disabled = _get(audioState) === AudioState.LOADING || _get(audioState) === AudioState.ERROR;
        set_attribute(button, "aria-label", _get(audioState) === AudioState.LOADING ? strings().loading : strings().getAudioChallenge);
      });
      event("click", button, function () {
        return onPlayAudio();
      }, true);
      append($$anchor2, button);
    };
    if_block(node_1, function ($$render) {
      if (codeChallenge().audio) $$render(consequent_4);
    });
  }
  var button_1 = sibling(node_1, 2);
  reset(div_3);
  var div_5 = sibling(div_3, 2);
  var button_2 = child(div_5);
  var text_2 = only_child(button_2, true);
  var button_3 = sibling(button_2, 2);
  var text_3 = only_child(button_3, true);
  reset(div_5);
  reset(form);
  var node_3 = sibling(form, 2);
  {
    var consequent_5 = function consequent_5($$anchor2) {
      var audio = root_6$1();
      bind_this(audio, function ($$value) {
        return _set(elAudio, $$value);
      }, function () {
        return _get(elAudio);
      });
      event("error", audio, onAudioError);
      event("loadstart", audio, onAudioLoadStart);
      event("canplay", audio, onAudioCanPlay);
      event("pause", audio, onAudioPause);
      event("playing", audio, onAudioPlaying);
      event("ended", audio, onAudioEnded);
      append($$anchor2, audio);
    };
    if_block(node_3, function ($$render) {
      if (_get(playAudio)) $$render(consequent_5);
    });
  }
  reset(div);
  template_effect(function () {
    set_text(text_1, strings().enterCodeFromImage);
    set_attribute(img, "src", imageUrl());
    set_attribute(input, "minlength", codeChallenge().length || 1);
    set_attribute(input, "maxlength", codeChallenge().length);
    set_attribute(input, "placeholder", strings().enterCode);
    set_attribute(input, "aria-label", _get(audioState) === AudioState.LOADING ? strings().loading : _get(audioState) === AudioState.PLAYING ? "" : strings().enterCodeAria);
    set_attribute(input, "aria-live", _get(audioState) ? "assertive" : "polite");
    set_attribute(input, "aria-busy", _get(audioState) === AudioState.LOADING);
    set_attribute(button_1, "title", strings().reload);
    set_attribute(button_1, "aria-label", strings().reload);
    set_attribute(button_2, "aria-label", strings().verify);
    set_text(text_2, strings().verify);
    set_attribute(button_3, "aria-label", strings().cancel);
    set_text(text_3, strings().cancel);
  });
  event("submit", form, onSubmitCapture, true);
  delegated("keydown", input, onInputKeyDown);
  bind_value(input, function () {
    return _get(code);
  }, function ($$value) {
    return _set(code, $$value);
  });
  event("click", button_1, function () {
    var _onReload;
    return (_onReload = onReload()) === null || _onReload === void 0 ? void 0 : _onReload();
  }, true);
  event("click", button_3, function () {
    var _onCancel2;
    return (_onCancel2 = onCancel()) === null || _onCancel2 === void 0 ? void 0 : _onCancel2();
  }, true);
  append($$anchor, div);
  return pop($$exports);
}
delegate(["keydown"]);
create_custom_element(Code, {
  audioUrl: {},
  codeChallenge: {},
  config: {},
  imageUrl: {},
  onCancel: {},
  onReload: {},
  onSubmit: {},
  strings: {}
}, [], [], {
  mode: "open"
});
var rest_excludes = /* @__PURE__ */new Set(["$$slots", "$$events", "$$legacy", "$$host", "anchor", "children", "display", "backdrop", "onClickOutside", "onClickOutsideDelay", "onClose", "placement", "updateUISignal", "variant"]);
var root$1 = /* @__PURE__ */from_html("<div class=\"altcha-popover-backdrop\" data-backdrop=\"\"></div>");
var root_1$1 = /* @__PURE__ */from_html("<div class=\"altcha-popover-arrow\"></div>");
var root_2$1 = /* @__PURE__ */from_html("<div role=\"button\" class=\"altcha-popover-close\">&times;</div>");
var root_3$1 = /* @__PURE__ */from_html("<!> <div><!> <!> <div class=\"altcha-popover-content\"><!></div></div>", 1);
function Popover($$anchor, $$props) {
  push($$props, true);
  var anchor = prop($$props, "anchor"),
    children = prop($$props, "children"),
    display = prop($$props, "display", 7, "standard"),
    backdrop = prop($$props, "backdrop", 7, false),
    onClickOutside = prop($$props, "onClickOutside"),
    onClickOutsideDelay = prop($$props, "onClickOutsideDelay", 7, 600),
    onClose = prop($$props, "onClose"),
    placement = prop($$props, "placement", 7, "auto"),
    updateUISignal = prop($$props, "updateUISignal"),
    variant = prop($$props, "variant", 7, "neutral"),
    rest = /* @__PURE__ */rest_props($$props, rest_excludes);
  var el = /* @__PURE__ */state(void 0);
  var elBackdrop = /* @__PURE__ */state(void 0);
  var top = /* @__PURE__ */state(false);
  var mountedAt = /* @__PURE__ */state(0);
  user_effect(function () {
    if (placement() !== "auto") {
      _set(top, placement() === "top");
    }
  });
  user_effect(function () {
    if (updateUISignal()) {
      reposition();
    }
  });
  onMount(function () {
    var moveToBody = display() === "bottomsheet" || display() === "overlay";
    if (moveToBody) {
      _get(elBackdrop) && document.body.append(_get(elBackdrop));
      _get(el) && document.body.append(_get(el));
    }
    reposition();
    tick().then(function () {
      _set(mountedAt, Date.now(), true);
    });
    return function () {
      if (moveToBody) {
        _get(elBackdrop) && document.body.removeChild(_get(elBackdrop));
        _get(el) && document.body.removeChild(_get(el));
      }
    };
  });
  function onCloseClick() {
    var _onClose;
    (_onClose = onClose()) === null || _onClose === void 0 || _onClose();
  }
  function onWindowClick(ev) {
    var _get4;
    var target = ev.target;
    if (!((_get4 = _get(el)) !== null && _get4 !== void 0 && _get4.contains(target)) && (!onClickOutsideDelay() || _get(mountedAt) + onClickOutsideDelay() < Date.now())) {
      var _onClickOutside;
      (_onClickOutside = onClickOutside()) === null || _onClickOutside === void 0 || _onClickOutside();
    }
  }
  function onWindowResize() {
    reposition();
  }
  function onWindowScroll() {
    reposition();
  }
  function reposition() {
    if (anchor() && placement() === "auto" && _get(el)) {
      var boundary2 = anchor().getBoundingClientRect();
      var bottomGap = document.documentElement.clientHeight - (boundary2.top + boundary2.height);
      var newTop = bottomGap < _get(el).clientHeight;
      if (_get(top) !== newTop) {
        _set(top, newTop);
      }
    }
  }
  var $$exports = {
    get anchor() {
      return anchor();
    },
    set anchor($$value) {
      anchor($$value);
      flushSync();
    },
    get children() {
      return children();
    },
    set children($$value) {
      children($$value);
      flushSync();
    },
    get display() {
      return display();
    },
    set display($$value) {
      if ($$value === void 0) {
        $$value = "standard";
      }
      display($$value);
      flushSync();
    },
    get backdrop() {
      return backdrop();
    },
    set backdrop($$value) {
      if ($$value === void 0) {
        $$value = false;
      }
      backdrop($$value);
      flushSync();
    },
    get onClickOutside() {
      return onClickOutside();
    },
    set onClickOutside($$value) {
      onClickOutside($$value);
      flushSync();
    },
    get onClickOutsideDelay() {
      return onClickOutsideDelay();
    },
    set onClickOutsideDelay($$value) {
      if ($$value === void 0) {
        $$value = 600;
      }
      onClickOutsideDelay($$value);
      flushSync();
    },
    get onClose() {
      return onClose();
    },
    set onClose($$value) {
      onClose($$value);
      flushSync();
    },
    get placement() {
      return placement();
    },
    set placement($$value) {
      if ($$value === void 0) {
        $$value = "auto";
      }
      placement($$value);
      flushSync();
    },
    get updateUISignal() {
      return updateUISignal();
    },
    set updateUISignal($$value) {
      updateUISignal($$value);
      flushSync();
    },
    get variant() {
      return variant();
    },
    set variant($$value) {
      if ($$value === void 0) {
        $$value = "neutral";
      }
      variant($$value);
      flushSync();
    }
  };
  var fragment = root_3$1();
  event("click", $window, onWindowClick, true);
  event("resize", $window, onWindowResize);
  event("scroll", $window, onWindowScroll);
  var node = first_child(fragment);
  {
    var consequent = function consequent($$anchor2) {
      var div = root$1();
      bind_this(div, function ($$value) {
        return _set(elBackdrop, $$value);
      }, function () {
        return _get(elBackdrop);
      });
      append($$anchor2, div);
    };
    if_block(node, function ($$render) {
      if (backdrop()) $$render(consequent);
    });
  }
  var div_1 = sibling(node, 2);
  attribute_effect(div_1, function () {
    var _ref4;
    return _objectSpread(_objectSpread({}, rest), {}, {
      "class": "altcha-popover ".concat((_ref4 = $$props["class"] || "") !== null && _ref4 !== void 0 ? _ref4 : ""),
      "data-popover": true,
      "data-variant": variant(),
      "data-top": _get(top),
      "data-display": display()
    });
  });
  var node_1 = child(div_1);
  {
    var consequent_1 = function consequent_1($$anchor2) {
      var div_2 = root_1$1();
      append($$anchor2, div_2);
    };
    if_block(node_1, function ($$render) {
      if (display() === "standard") $$render(consequent_1);
    });
  }
  var node_2 = sibling(node_1, 2);
  {
    var consequent_2 = function consequent_2($$anchor2) {
      var div_3 = root_2$1();
      event("click", div_3, onCloseClick, true);
      append($$anchor2, div_3);
    };
    if_block(node_2, function ($$render) {
      if (display() !== "standard") $$render(consequent_2);
    });
  }
  var div_4 = sibling(node_2, 2);
  var node_3 = child(div_4);
  snippet(node_3, function () {
    var _children2;
    return (_children2 = children()) !== null && _children2 !== void 0 ? _children2 : noop;
  });
  reset(div_4);
  reset(div_1);
  bind_this(div_1, function ($$value) {
    return _set(el, $$value);
  }, function () {
    return _get(el);
  });
  append($$anchor, fragment);
  return pop($$exports);
}
create_custom_element(Popover, {
  anchor: {},
  children: {},
  display: {},
  backdrop: {},
  onClickOutside: {},
  onClickOutsideDelay: {},
  onClose: {},
  placement: {},
  updateUISignal: {},
  variant: {}
}, [], [], {
  mode: "open"
});
function bufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer)).map(function (b) {
    return b.toString(16).padStart(2, "0");
  }).join("");
}
function injectCss(css2) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "altcha-css";
  var nonce = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof document !== "undefined" && document && !document.getElementById(id)) {
    var _document$currentScri, _document$currentScri2, _document$querySelect;
    var style = document.createElement("style");
    style.id = id;
    style.textContent = css2;
    var resolvedNonce = (_document$currentScri = (_document$currentScri2 = document.currentScript) === null || _document$currentScri2 === void 0 ? void 0 : _document$currentScri2.nonce) !== null && _document$currentScri !== void 0 ? _document$currentScri : (_document$querySelect = document.querySelector('meta[name="csp-nonce"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content;
    if (resolvedNonce) {
      style.nonce = resolvedNonce;
    }
    document.head.appendChild(style);
  }
}
function solveChallengeWorkers(_x2) {
  return _solveChallengeWorkers.apply(this, arguments);
}
function _solveChallengeWorkers() {
  _solveChallengeWorkers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(options) {
    var challenge, _options$concurrency2, concurrency, _options$controller2, controller, createWorker, _options$onOutOfMemor, onOutOfMemory, counterMode, _options$timeout, timeout, workersConcurrency, workersInstances, terminate, i, solution, _err$message, isOOM, retryConcurrency, _t6, _t7;
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.p = _context1.n) {
        case 0:
          challenge = options.challenge, _options$concurrency2 = options.concurrency, concurrency = _options$concurrency2 === void 0 ? navigator.hardwareConcurrency : _options$concurrency2, _options$controller2 = options.controller, controller = _options$controller2 === void 0 ? new AbortController() : _options$controller2, createWorker = options.createWorker, _options$onOutOfMemor = options.onOutOfMemory, onOutOfMemory = _options$onOutOfMemor === void 0 ? function (c) {
            return c > 1 ? Math.floor(c / 2) : 0;
          } : _options$onOutOfMemor, counterMode = options.counterMode, _options$timeout = options.timeout, timeout = _options$timeout === void 0 ? 9e4 : _options$timeout;
          workersConcurrency = Math.min(16, Math.max(1, concurrency));
          workersInstances = [];
          terminate = function terminate() {
            for (var _i7 = 0, _workersInstances = workersInstances; _i7 < _workersInstances.length; _i7++) {
              var worker = _workersInstances[_i7];
              worker.terminate();
            }
          };
          i = 0;
        case 1:
          if (!(i < workersConcurrency)) {
            _context1.n = 4;
            break;
          }
          _t6 = workersInstances;
          _context1.n = 2;
          return createWorker(challenge.parameters.algorithm);
        case 2:
          _t6.push.call(_t6, _context1.v);
        case 3:
          i++;
          _context1.n = 1;
          break;
        case 4:
          solution = null;
          _context1.p = 5;
          _context1.n = 6;
          return Promise.race(workersInstances.map(function (worker, i) {
            controller.signal.addEventListener("abort", function () {
              worker.postMessage({
                type: "abort"
              });
            });
            return new Promise(function (resolve, reject) {
              worker.addEventListener("error", function (err) {
                reject(err);
              });
              worker.addEventListener("message", function (message) {
                if (message.data) {
                  for (var _i8 = 0, _workersInstances2 = workersInstances; _i8 < _workersInstances2.length; _i8++) {
                    var w = _workersInstances2[_i8];
                    if (w !== worker) {
                      w.postMessage({
                        type: "abort"
                      });
                    }
                  }
                  if (message.data.error) {
                    return reject(new Error(message.data.error));
                  }
                }
                resolve(message.data);
              });
              worker.postMessage({
                challenge: challenge,
                counterMode: counterMode,
                counterStart: i,
                counterStep: workersConcurrency,
                timeout: timeout,
                type: "work"
              });
            });
          }));
        case 6:
          solution = _context1.v;
          _context1.n = 9;
          break;
        case 7:
          _context1.p = 7;
          _t7 = _context1.v;
          isOOM = _t7 instanceof Error && !!(_t7 !== null && _t7 !== void 0 && (_err$message = _t7.message) !== null && _err$message !== void 0 && _err$message.includes("Out of memory"));
          if (!isOOM) {
            _context1.n = 8;
            break;
          }
          if (!onOutOfMemory) {
            _context1.n = 8;
            break;
          }
          terminate();
          retryConcurrency = onOutOfMemory(workersConcurrency);
          if (!retryConcurrency) {
            _context1.n = 8;
            break;
          }
          return _context1.a(2, solveChallengeWorkers(_objectSpread(_objectSpread({}, options), {}, {
            challenge: challenge,
            controller: controller,
            concurrency: retryConcurrency,
            createWorker: createWorker
          })));
        case 8:
          throw _t7;
        case 9:
          _context1.p = 9;
          terminate();
          return _context1.f(9);
        case 10:
          if (!controller.signal.aborted) {
            _context1.n = 11;
            break;
          }
          return _context1.a(2, null);
        case 11:
          return _context1.a(2, solution || null);
      }
    }, _callee1, null, [[5, 7, 9, 10]]);
  }));
  return _solveChallengeWorkers.apply(this, arguments);
}
var Collector = /*#__PURE__*/function () {
  function Collector() {
    var _this15 = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Collector);
    _defineProperty(this, "TAG_CODES", {
      INPUT: 1,
      TEXTAREA: 2,
      SELECT: 3,
      BUTTON: 4,
      A: 5,
      DETAILS: 6,
      SUMMARY: 7,
      IFRAME: 8,
      VIDEO: 9,
      AUDIO: 10
    });
    _defineProperty(this, "maxSamples", void 0);
    _defineProperty(this, "sampleInterval", void 0);
    _defineProperty(this, "target", void 0);
    _defineProperty(this, "focusStartTime", 0);
    _defineProperty(this, "focusInteraction", 0);
    _defineProperty(this, "focusInteractionTimer", null);
    _defineProperty(this, "lastPointerSample", 0);
    _defineProperty(this, "lastTouchSample", 0);
    _defineProperty(this, "lastScrollSample", 0);
    _defineProperty(this, "pendingPointer", null);
    _defineProperty(this, "pendingTouch", null);
    _defineProperty(this, "focus", []);
    _defineProperty(this, "pointer", []);
    _defineProperty(this, "scroll", []);
    _defineProperty(this, "touch", []);
    _defineProperty(this, "onFocus", function (e) {
      var _this15$TAG_CODES$el$;
      if (_this15.focusInteraction === 2) {
        return;
      }
      var el = e.target;
      if (!(el instanceof Element)) {
        return;
      }
      var now = performance.now();
      if (_this15.focusStartTime === 0) {
        _this15.focusStartTime = now;
      }
      _this15.focus.push([Math.round(now - _this15.focusStartTime), el.tabIndex, (_this15$TAG_CODES$el$ = _this15.TAG_CODES[el.tagName]) !== null && _this15$TAG_CODES$el$ !== void 0 ? _this15$TAG_CODES$el$ : 0, _this15.focusInteraction ? 1 : 0]);
      _this15.evict(_this15.focus);
    });
    _defineProperty(this, "onInteraction", function (e) {
      _this15.focusInteraction = "keyCode" in e ? 1 : 2;
      if (_this15.focusInteractionTimer) {
        clearTimeout(_this15.focusInteractionTimer);
      }
      _this15.focusInteractionTimer = setTimeout(function () {
        _this15.focusInteraction = 0;
      }, 100);
    });
    _defineProperty(this, "onPointer", function (e) {
      if (e.pointerType === "touch") {
        return;
      }
      var now = e.timeStamp || performance.now();
      _this15.pendingPointer = [Math.round(e.clientX), Math.round(e.clientY), Math.round(now)];
      if (now - _this15.lastPointerSample >= _this15.sampleInterval) {
        _this15.pointer.push(_this15.pendingPointer);
        _this15.lastPointerSample = now;
        _this15.pendingPointer = null;
        _this15.evict(_this15.pointer);
      }
    });
    _defineProperty(this, "onScroll", function () {
      var now = performance.now();
      if (now - _this15.lastScrollSample < _this15.sampleInterval) {
        return;
      }
      _this15.scroll.push([Math.round(window.scrollY), Math.round(now)]);
      _this15.lastScrollSample = now;
      _this15.evict(_this15.scroll);
    });
    _defineProperty(this, "onTouchMove", function (e) {
      var now = e.timeStamp || performance.now();
      var t = e.touches[0];
      if (!t) {
        return;
      }
      _this15.pendingTouch = [Math.round(t.clientX), Math.round(t.clientY), Math.round(now), Math.round(t.force * 1e3) / 1e3, Math.round(t.radiusX || 0), Math.round(t.radiusY || 0)];
      if (now - _this15.lastTouchSample >= _this15.sampleInterval) {
        _this15.touch.push(_this15.pendingTouch);
        _this15.lastTouchSample = now;
        _this15.pendingTouch = null;
        _this15.evict(_this15.touch);
      }
    });
    var _options$maxSamples = options.maxSamples,
      maxSamples = _options$maxSamples === void 0 ? 60 : _options$maxSamples,
      _options$sampleInterv = options.sampleInterval,
      sampleInterval = _options$sampleInterv === void 0 ? 50 : _options$sampleInterv,
      _options$target = options.target,
      target = _options$target === void 0 ? window : _options$target;
    this.maxSamples = maxSamples;
    this.sampleInterval = sampleInterval;
    this.target = target;
    this.attach();
  }
  return _createClass(Collector, [{
    key: "destroy",
    value: function destroy() {
      var o = {
        capture: true
      };
      this.target.removeEventListener("focusin", this.onFocus, o);
      this.target.removeEventListener("keydown", this.onInteraction, o);
      this.target.removeEventListener("pointerdown", this.onInteraction, o);
      this.target.removeEventListener("pointermove", this.onPointer, o);
      this.target.removeEventListener("scroll", this.onScroll, o);
      this.target.removeEventListener("touchmove", this.onTouchMove, o);
    }
  }, {
    key: "export",
    value: function _export() {
      return {
        focus: this.focus,
        maxTouchPoints: navigator.maxTouchPoints || 0,
        pointer: this.pointer,
        scroll: this.scroll,
        time: Date.now(),
        touch: this.touch
      };
    }
  }, {
    key: "attach",
    value: function attach() {
      var o = {
        passive: true,
        capture: true
      };
      this.target.addEventListener("focusin", this.onFocus, o);
      this.target.addEventListener("keydown", this.onInteraction, o);
      this.target.addEventListener("pointerdown", this.onInteraction, o);
      this.target.addEventListener("pointermove", this.onPointer, o);
      this.target.addEventListener("scroll", this.onScroll, o);
      this.target.addEventListener("touchmove", this.onTouchMove, o);
    }
  }, {
    key: "evict",
    value: function evict(buffer) {
      if (buffer.length > this.maxSamples) {
        buffer.splice(0, buffer.length - this.maxSamples);
      }
    }
  }]);
}();
var root = /* @__PURE__ */from_html("<div class=\"altcha-overlay-backdrop\" data-backdrop=\"\"></div>");
var root_1 = /* @__PURE__ */from_html("<div class=\"altcha-overlay-content\"></div>");
var root_2 = /* @__PURE__ */from_html("<div role=\"button\" class=\"altcha-overlay-close\">&times;</div> <!>", 1);
var root_3 = /* @__PURE__ */from_html("<div class=\"altcha-floating-arrow\"></div>");
var root_4 = /* @__PURE__ */from_html("<input type=\"hidden\"/>");
var root_5 = /* @__PURE__ */from_html("<div class=\"altcha-error\">Secure context (HTTPS) required.</div>");
var root_6 = /* @__PURE__ */from_html("<div class=\"altcha-error\"> </div>");
var root_7 = /* @__PURE__ */from_html("<!> <!>", 1);
var root_8 = /* @__PURE__ */from_html("<!> <div class=\"altcha\"><!> <div class=\"altcha-main\"><div><div class=\"altcha-checkbox-wrap\"><!> <label><!></label></div> <!></div> <!> <!> <!></div> <!></div>", 1);
function Widget($$anchor, $$props) {
  push($$props, true);
  var $altchaDefaults = function $altchaDefaults() {
    return store_get(altchaDefaults, "$altchaDefaults", $$stores);
  };
  var $altchaI18nStore = function $altchaI18nStore() {
    return store_get(altchaI18nStore, "$altchaI18nStore", $$stores);
  };
  var _setup_stores = setup_stores(),
    _setup_stores2 = _slicedToArray(_setup_stores, 2),
    $$stores = _setup_stores2[0],
    $$cleanup = _setup_stores2[1];
  var fieldsSelector = 'input[type="text"]:not([data-no-spamfilter]), textarea:not([data-no-spamfilter])';
  var submitButtonSelector = 'input[type="submit"], button[type="submit"], button:not([type="button"]):not([type="reset"])';
  var rtlLanguages = ["ar", "fa", "he", "ur"];
  var isSecureContext = globalThis.isSecureContext;
  var altchaDefaults = globalThis.$altcha.defaults.store;
  var hardwareConcurrency = navigator.hardwareConcurrency || 2;
  var deviceMemory = navigator.deviceMemory || 0;
  var defaultWorkers = deviceMemory && deviceMemory <= 4 ? Math.min(4, hardwareConcurrency) : hardwareConcurrency;
  var altchaI18nStore = globalThis.$altcha.i18n.store;
  var instance = $$props.$$host;
  var dispatch = function dispatch(event2, detail) {
    tick().then(function () {
      instance === null || instance === void 0 || instance.dispatchEvent(new CustomEvent(event2, {
        detail: detail
      }));
    });
  };
  var hisCollector = null;
  var baseUrl = /* @__PURE__ */state(proxy(new URL(location.origin)));
  var checked = /* @__PURE__ */state(false);
  var codeChallenge = /* @__PURE__ */state(null);
  var currentController = /* @__PURE__ */state(null);
  var currentDisplay = /* @__PURE__ */state(null);
  var currentState = /* @__PURE__ */state(proxy(State.UNVERIFIED));
  var elAnchorArrow = /* @__PURE__ */state(void 0);
  var elFloatingAnchor = /* @__PURE__ */state(void 0);
  var elForm = /* @__PURE__ */state(null);
  var elRoot = /* @__PURE__ */state(void 0);
  var elSubmitter = /* @__PURE__ */state(null);
  var error = /* @__PURE__ */state(null);
  var expirationTimeout = /* @__PURE__ */state(null);
  var payload = /* @__PURE__ */state(null);
  var plugins = /* @__PURE__ */state(proxy([]));
  var updateUISignal = /* @__PURE__ */state(0);
  var userConfig = /* @__PURE__ */state(proxy({}));
  var visible = /* @__PURE__ */state(true);
  var config = /* @__PURE__ */user_derived(function () {
    return _objectSpread(_objectSpread({
      fetch: function (_fetch) {
        function fetch(_x3, _x4) {
          return _fetch.apply(this, arguments);
        }
        fetch.toString = function () {
          return _fetch.toString();
        };
        return fetch;
      }(function (input, init) {
        return fetch(input, init);
      }),
      audioChallengeLanguage: "",
      auto: "off",
      barPlacement: "bottom",
      challenge: "",
      codeChallenge: null,
      codeChallengeDisplay: "standard",
      credentials: null,
      debug: false,
      disableAutoFocus: false,
      display: "standard",
      floatingAnchor: "",
      floatingOffset: 8,
      floatingPersist: false,
      floatingPlacement: "auto",
      hideFooter: false,
      hideLogo: false,
      humanInteractionSignature: true,
      language: "",
      mockError: false,
      minDuration: 500,
      overlayContent: "",
      name: "altcha",
      popoverPlacement: "auto",
      retryOnOutOfMemoryError: true,
      setCookie: null,
      serverVerificationFields: false,
      serverVerificationTimeZone: false,
      test: false,
      timeout: 9e4,
      type: "checkbox",
      validationMessage: "",
      verifyFunction: null,
      verifyUrl: "",
      workers: defaultWorkers
    }, $altchaDefaults()), _get(userConfig));
  });
  var checkboxId = /* @__PURE__ */user_derived(function () {
    return "altcha-checkbox-".concat($$props.id || Math.floor(Math.random() * 1e12).toString(16));
  });
  var CheckboxComponent = /* @__PURE__ */user_derived(function () {
    return getCheckboxComponent(_get(config).type);
  });
  var auto = /* @__PURE__ */user_derived(function () {
    return _get(config).auto;
  });
  var loading = /* @__PURE__ */user_derived(function () {
    return _get(currentState) === State.VERIFYING;
  });
  var showFooter = /* @__PURE__ */user_derived(function () {
    return !_get(config).hideFooter;
  });
  var showLogo = /* @__PURE__ */user_derived(function () {
    return !_get(config).hideLogo && _get(config).display !== "bar";
  });
  var locale = /* @__PURE__ */user_derived(function () {
    return getI18nStrings($altchaI18nStore(), [_get(config).language, document.documentElement.lang].concat(_toConsumableArray(navigator.languages)));
  });
  var dir = /* @__PURE__ */user_derived(function () {
    return rtlLanguages.includes(_get(locale).language) ? "rtl" : void 0;
  });
  var strings = /* @__PURE__ */user_derived(function () {
    return _objectSpread({}, _get(locale).strings);
  });
  var codeChallengeAudioUrl = /* @__PURE__ */user_derived(function () {
    var _get5, _get6;
    return (_get5 = _get(codeChallenge)) !== null && _get5 !== void 0 && (_get5 = _get5.audio) !== null && _get5 !== void 0 && _get5.match(/^(https?:)?\//) ? getUrl(_get(codeChallenge).audio, _get(baseUrl), {
      language: _get(config).audioChallengeLanguage || _get(locale).language
    }).toString() : (_get6 = _get(codeChallenge)) === null || _get6 === void 0 ? void 0 : _get6.audio;
  });
  var codeChallengeImageUrl = /* @__PURE__ */user_derived(function () {
    var _get7, _get8;
    return (_get7 = _get(codeChallenge)) !== null && _get7 !== void 0 && (_get7 = _get7.image) !== null && _get7 !== void 0 && _get7.match(/^(https?:)?\//) ? getUrl(_get(codeChallenge).image, _get(baseUrl)) : (_get8 = _get(codeChallenge)) === null || _get8 === void 0 ? void 0 : _get8.image;
  });
  user_effect(function () {
    configure({
      auto: $$props.auto,
      challenge: $$props.challenge,
      display: $$props.display,
      language: $$props.language,
      name: $$props.name,
      type: $$props.type,
      workers: $$props.workers
    });
  });
  user_effect(function () {
    if ($$props.theme) {
      instance === null || instance === void 0 || instance.setAttribute("theme", $$props.theme);
    } else {
      instance === null || instance === void 0 || instance.removeAttribute("theme");
    }
  });
  user_effect(function () {
    if ($$props.configuration) {
      try {
        configure(JSON.parse($$props.configuration));
      } catch (_unused3) {
        log("unable to parse the `configuration` attribute (JSON expected)");
      }
    }
  });
  user_effect(function () {
    if (_get(currentDisplay) !== _get(config).display) {
      setDisplay(_get(config).display);
    }
  });
  user_effect(function () {
    if (_get(checked) && _get(currentState) === State.VERIFYING) {
      _set(checked, false);
    }
  });
  user_effect(function () {
    if (!_get(checked) && _get(currentState) === State.VERIFIED) {
      _set(checked, true);
    }
  });
  user_effect(function () {
    if (!_get(checked)) {
      var checkbox = getCheckboxElement();
      if (checkbox && checkbox.checked) {
        checkbox.checked = false;
      }
    }
  });
  user_effect(function () {
    if (_get(currentState) === State.VERIFIED) {
      var _getCheckboxElement;
      (_getCheckboxElement = getCheckboxElement()) === null || _getCheckboxElement === void 0 || _getCheckboxElement.setCustomValidity("");
    }
  });
  user_effect(function () {
    if (_get(auto) === "onload") {
      var tm = setTimeout(function () {
        verify();
      }, 1);
      return function () {
        if (tm) {
          clearTimeout(tm);
        }
      };
    }
  });
  user_effect(function () {
    if (_get(error)) {
      log("error:", _get(error));
    }
  });
  user_effect(function () {
    if (_get(payload) && _get(config).setCookie) {
      setCookie(_get(payload), _get(config).setCookie);
    }
  });
  onMount(function () {
    var _get9, _get0, _get1, _get10;
    log("mounted", "3.2.3");
    if (instance) {
      globalThis.$altcha.instances.add(instance);
    }
    _set(elForm, (_get9 = _get(elRoot)) === null || _get9 === void 0 ? void 0 : _get9.closest("form"), true);
    (_get0 = _get(elForm)) === null || _get0 === void 0 || _get0.addEventListener("reset", onFormReset);
    (_get1 = _get(elForm)) === null || _get1 === void 0 || _get1.addEventListener("submit", onFormSubmit, {
      capture: true
    });
    (_get10 = _get(elForm)) === null || _get10 === void 0 || _get10.addEventListener("focusin", onFormFocusIn);
    activatePlugins();
    if (_get(config).humanInteractionSignature) {
      log("human interaction signature enabled");
      hisCollector = new Collector();
    }
    dispatch("load");
    if (!isSecureContext) {
      log("secure context (HTTPS) required");
    }
    return function () {
      var _get11, _get12, _get13, _hisCollector;
      destroyPlugins();
      if (instance) {
        globalThis.$altcha.instances["delete"](instance);
      }
      if (_get(expirationTimeout)) {
        clearTimeout(_get(expirationTimeout));
      }
      (_get11 = _get(elForm)) === null || _get11 === void 0 || _get11.removeEventListener("reset", onFormReset);
      (_get12 = _get(elForm)) === null || _get12 === void 0 || _get12.removeEventListener("submit", onFormSubmit, {
        capture: true
      });
      (_get13 = _get(elForm)) === null || _get13 === void 0 || _get13.removeEventListener("focusin", onFormFocusIn);
      (_hisCollector = hisCollector) === null || _hisCollector === void 0 || _hisCollector.destroy();
    };
  });
  function activatePlugins() {
    _set(plugins, _toConsumableArray(globalThis.$altcha.plugins).map(function (PluginCls) {
      return new PluginCls(instance);
    }), true);
    log("activating plugins", _get(plugins).map(function (plugin) {
      return plugin.constructor.name;
    }));
    var _iterator43 = _createForOfIteratorHelper(_get(plugins)),
      _step43;
    try {
      for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
        var plugin = _step43.value;
        plugin.activate();
      }
    } catch (err) {
      _iterator43.e(err);
    } finally {
      _iterator43.f();
    }
  }
  function callHook(_x5) {
    return _callHook.apply(this, arguments);
  }
  function _callHook() {
    _callHook = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(hook) {
      var result,
        _len4,
        args,
        _key5,
        _iterator45,
        _step45,
        _plugin$hook,
        plugin,
        _args3 = arguments,
        _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            result = void 0;
            for (_len4 = _args3.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key5 = 1; _key5 < _len4; _key5++) {
              args[_key5 - 1] = _args3[_key5];
            }
            _iterator45 = _createForOfIteratorHelper(_get(plugins));
            _context3.p = 1;
            _iterator45.s();
          case 2:
            if ((_step45 = _iterator45.n()).done) {
              _context3.n = 5;
              break;
            }
            plugin = _step45.value;
            _context3.n = 3;
            return (_plugin$hook = plugin[hook]).call.apply(_plugin$hook, [plugin].concat(args));
          case 3:
            result = _context3.v;
          case 4:
            _context3.n = 2;
            break;
          case 5:
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t = _context3.v;
            _iterator45.e(_t);
          case 7:
            _context3.p = 7;
            _iterator45.f();
            return _context3.f(7);
          case 8:
            return _context3.a(2, result);
        }
      }, _callee3, null, [[1, 6, 7, 8]]);
    }));
    return _callHook.apply(this, arguments);
  }
  function destroyPlugins() {
    var _iterator44 = _createForOfIteratorHelper(_get(plugins)),
      _step44;
    try {
      for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
        var plugin = _step44.value;
        plugin.destroy();
      }
    } catch (err) {
      _iterator44.e(err);
    } finally {
      _iterator44.f();
    }
  }
  function createChallengeFromV1(challenge) {
    var _challenge$salt$split = challenge.salt.split("?"),
      _challenge$salt$split2 = _slicedToArray(_challenge$salt$split, 2),
      _ = _challenge$salt$split2[0],
      queryParams = _challenge$salt$split2[1];
    var data = {};
    if (queryParams) {
      try {
        Object.assign(data, Object.fromEntries(new URLSearchParams(queryParams).entries()));
      } catch (_unused4) {}
    }
    var result = {
      codeChallenge: challenge.codeChallenge,
      parameters: {
        algorithm: challenge.algorithm,
        cost: 1,
        data: data,
        expiresAt: data !== null && data !== void 0 && data.expires ? parseInt(data.expires, 10) : void 0,
        keyLength: challenge.algorithm === "SHA-512" ? 64 : challenge.algorithm === "SHA-384" ? 48 : 32,
        nonce: bufferToHex(new TextEncoder().encode(challenge.salt)),
        keyPrefix: challenge.challenge,
        salt: ""
      },
      signature: challenge.signature
    };
    Object.defineProperties(result, {
      _originalSalt: {
        enumerable: false,
        value: challenge.salt,
        writable: false
      },
      _version: {
        enumerable: false,
        value: 1,
        writable: false
      }
    });
    return result;
  }
  function createPayloadV1(challenge, solution) {
    return {
      algorithm: challenge.parameters.algorithm,
      challenge: challenge.parameters.keyPrefix,
      number: solution.counter,
      salt: "_originalSalt" in challenge ? challenge._originalSalt : challenge.parameters.nonce,
      signature: challenge.signature,
      took: solution.time || 0
    };
  }
  function delay(_x6) {
    return _delay.apply(this, arguments);
  }
  function _delay() {
    _delay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(ms) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _delay.apply(this, arguments);
  }
  function fetchChallenge() {
    return _fetchChallenge.apply(this, arguments);
  }
  function _fetchChallenge() {
    _fetchChallenge = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var source2,
        requestOptions,
        hook,
        challenge,
        resp,
        configHeader,
        json,
        _args5 = arguments,
        _t2,
        _t3;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            source2 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : _get(config).challenge;
            requestOptions = _args5.length > 1 ? _args5[1] : undefined;
            _context5.n = 1;
            return callHook("onFetchChallenge", source2);
          case 1:
            hook = _context5.v;
            challenge = null;
            if (!(hook !== void 0)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2, hook);
          case 2:
            if (!(typeof source2 === "string")) {
              _context5.n = 13;
              break;
            }
            if (!source2.startsWith("{")) {
              _context5.n = 6;
              break;
            }
            log("parsing JSON challenge");
            _context5.p = 3;
            challenge = JSON.parse(source2);
            _context5.n = 5;
            break;
          case 4:
            _context5.p = 4;
            _t2 = _context5.v;
            throw new Error("Unable to parse JSON challenge.");
          case 5:
            _context5.n = 12;
            break;
          case 6:
            log("fetching challenge from", (requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.method) || "GET", source2);
            _set(baseUrl, new URL(source2, location.origin), true);
            _context5.n = 7;
            return _get(config).fetch(source2, _objectSpread({
              credentials: _get(config).credentials || void 0
            }, requestOptions));
          case 7:
            resp = _context5.v;
            _context5.n = 8;
            return validateResponse(resp);
          case 8:
            configHeader = resp.headers.get("x-altcha-config");
            if (configHeader) {
              processConfigHeader(configHeader);
            }
            _context5.n = 9;
            return resp.json();
          case 9:
            json = _context5.v;
            if (!(json && "his" in json && json.his)) {
              _context5.n = 11;
              break;
            }
            log("requested HIS");
            if (hisCollector) {
              _context5.n = 10;
              break;
            }
            throw new Error("Server requested HIS data but collector is disabled.");
          case 10:
            return _context5.a(2, fetchChallenge(getUrl(json.his.url, _get(baseUrl)), {
              body: JSON.stringify({
                his: hisCollector["export"]()
              }),
              headers: {
                "content-type": "application/json"
              },
              method: "POST"
            }));
          case 11:
            if (json && "hisResult" in json && json.hisResult) {
              log("HIS result", json.hisResult);
            }
            challenge = json;
          case 12:
            _context5.n = 16;
            break;
          case 13:
            if (!(source2 && _typeof(source2) === "object")) {
              _context5.n = 16;
              break;
            }
            _context5.p = 14;
            challenge = JSON.parse(JSON.stringify(source2));
            _context5.n = 16;
            break;
          case 15:
            _context5.p = 15;
            _t3 = _context5.v;
            throw new Error("Unable to parse JSON challenge.");
          case 16:
            if (isChallengeV1(challenge)) {
              challenge = createChallengeFromV1(challenge);
            }
            if (isChallengeValid(challenge)) {
              _context5.n = 17;
              break;
            }
            throw new Error("Challenge validation failed.");
          case 17:
            return _context5.a(2, challenge);
        }
      }, _callee5, null, [[14, 15], [3, 4]]);
    }));
    return _fetchChallenge.apply(this, arguments);
  }
  function isChallengeV1(challenge) {
    return _typeof(challenge) === "object" && "challenge" in challenge;
  }
  function isChallengeValid(challenge) {
    return !!challenge && _typeof(challenge) === "object" && "parameters" in challenge && !!challenge.parameters && _typeof(challenge.parameters) === "object" && "algorithm" in challenge.parameters && "nonce" in challenge.parameters && "salt" in challenge.parameters && "keyPrefix" in challenge.parameters;
  }
  function getCheckboxElement() {
    return document.getElementById(_get(checkboxId));
  }
  function getCheckboxComponent(type) {
    switch (type) {
      case "checkbox":
        return Checkbox;
      case "switch":
        return Switch;
      case "native":
      default:
        return CheckboxNative;
    }
  }
  function getI18nStrings(i18n2, languages) {
    var codes = Object.keys(i18n2).map(function (code) {
      return code.toLowerCase();
    });
    var language = languages.reduce(function (acc, lang) {
      lang = lang.toLowerCase();
      return acc || (i18n2[lang] ? lang : null) || codes.find(function (code) {
        return lang.split("-")[0] === code.split("-")[0];
      }) || null;
    }, null);
    if (!i18n2[language || ""]) {
      language = "en";
    }
    return {
      language: language,
      strings: i18n2[language]
    };
  }
  function getPlacement(display) {
    switch (display) {
      case "bar":
        return _get(config).barPlacement || "bottom";
      case "floating":
        return _get(config).floatingPlacement || "auto";
      default:
        return void 0;
    }
  }
  function getTextFields(names) {
    var _get14;
    var elInputs = _toConsumableArray(((_get14 = _get(elForm)) === null || _get14 === void 0 ? void 0 : _get14.querySelectorAll(fieldsSelector)) || []);
    return elInputs.reduce(function (acc, el) {
      var name = el.name;
      var value = el.value;
      if (name && value) {
        acc[name] = /\n/.test(value) ? value.replace(new RegExp("(?<!\\r)\\n", "g"), "\r\n") : value;
      }
      return acc;
    }, {});
  }
  function getTimeZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (_unused5) {}
    return void 0;
  }
  function getUrl(uri, baseUrl2, params) {
    var result = new URL(uri, baseUrl2);
    if (!result.search) {
      result.search = baseUrl2.search;
    }
    if (params) {
      for (var key2 in params) {
        if (params[key2] !== void 0 && params[key2] !== null) {
          result.searchParams.set(key2, params[key2]);
        }
      }
    }
    return result.toString();
  }
  function onCheckboxChange(ev) {
    if (!_get(checked) && ev.currentTarget.checked) {
      ev.preventDefault();
      ev.currentTarget.checked = false;
      if (_get(currentState) !== State.VERIFYING) {
        verify();
      }
    } else if (!ev.currentTarget.checked) {
      ev.preventDefault();
      reset$1();
    }
  }
  function onCheckboxInvalid(ev) {
    if (_get(currentState) === State.VERIFYING) {
      ev.currentTarget.setCustomValidity(_get(strings).waitAlert);
    } else if (_get(config).validationMessage) {
      ev.currentTarget.setCustomValidity(_get(config).validationMessage);
    }
  }
  function onCloseClick() {
    setDisplay(_get(config).display);
    reset$1();
  }
  function onDocumentScroll() {
    updateUI();
  }
  function onDocumentClick(ev) {
    var target = ev.target;
    if (_get(config).display === "floating" && target && !(instance !== null && instance !== void 0 && instance.contains(target)) && !target.hasAttribute("data-backdrop") && !target.closest("[data-popover]") && _get(currentState) !== State.VERIFIED && !_get(config).floatingPersist) {
      hide();
    }
  }
  function onFormFocusIn(ev) {
    if (_get(auto) === "onfocus" && _get(currentState) === State.UNVERIFIED) {
      verify();
    }
  }
  function onFormReset() {
    setDisplay(_get(config).display);
    reset$1();
  }
  function onFormSubmit(ev) {
    var target = ev.target;
    if ((target === null || target === void 0 ? void 0 : target.getAttribute("data-code-challenge")) === "true") {
      return;
    }
    if (_get(auto) === "onsubmit" && _get(currentState) === State.UNVERIFIED) {
      ev.preventDefault();
      ev.stopPropagation();
      _set(elSubmitter, ev.submitter, true);
      show();
      verify().then(function (result) {
        if (result && !_get(codeChallenge)) {
          tick().then(function () {
            requestSubmit(_get(elSubmitter));
          });
        }
      });
    }
  }
  function onWindowPageshow(ev) {
    if (ev.persisted) {
      setDisplay(_get(config).display);
      reset$1();
    }
  }
  function onWindowResize() {
    updateUI();
  }
  function processConfigHeader(jsonConfig) {
    try {
      var json = JSON.parse(jsonConfig);
      if (json && _typeof(json) === "object") {
        var _json$sentinel, _json$sentinel2;
        configure(_objectSpread({
          // Backward compatibility mappings
          serverVerificationFields: json === null || json === void 0 || (_json$sentinel = json.sentinel) === null || _json$sentinel === void 0 ? void 0 : _json$sentinel.fields,
          serverVerificationTimeZone: json === null || json === void 0 || (_json$sentinel2 = json.sentinel) === null || _json$sentinel2 === void 0 ? void 0 : _json$sentinel2.timeZone,
          verifyUrl: json.verifyurl
        }, json));
      }
    } catch (err) {
      log("unable to configure from x-altcha-config header", err);
    }
  }
  function repositionFloating() {
    var viewportOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
    if (!_get(elRoot)) {
      return;
    }
    var floatingPlacement = _get(config).floatingPlacement;
    if (!_get(elFloatingAnchor)) {
      var _get15;
      _set(elFloatingAnchor, (_get(config).floatingAnchor instanceof HTMLElement ? _get(config).floatingAnchor : _get(config).floatingAnchor ? document.querySelector(_get(config).floatingAnchor) : (_get15 = _get(elForm)) === null || _get15 === void 0 ? void 0 : _get15.querySelector(submitButtonSelector)) || _get(elForm), true);
      if (!_get(elFloatingAnchor)) {
        log("unable to find floating anchor element");
        return;
      }
    }
    var offsetY = parseInt(_get(config).floatingOffset, 10) || 12;
    var anchorBoundry = _get(elFloatingAnchor).getBoundingClientRect();
    var elBoundary = _get(elRoot).getBoundingClientRect();
    var docHeight = document.documentElement.clientHeight;
    var docWidth = document.documentElement.clientWidth;
    var showOnTop = !floatingPlacement || floatingPlacement === "auto" ? anchorBoundry.bottom + elBoundary.height + offsetY + viewportOffset > docHeight : floatingPlacement === "top";
    var left = Math.max(viewportOffset, Math.min(docWidth - viewportOffset - elBoundary.width, anchorBoundry.left + anchorBoundry.width / 2 - elBoundary.width / 2));
    _get(elRoot).style.setProperty("--altcha-floating-left", "".concat(left, "px"));
    _get(elRoot).style.setProperty("--altcha-floating-top", showOnTop ? "".concat(anchorBoundry.top - (elBoundary.height + offsetY), "px") : "".concat(anchorBoundry.bottom + offsetY, "px"));
    _get(elRoot).setAttribute("data-floating-position", showOnTop ? "top" : "bottom");
    if (_get(elAnchorArrow)) {
      var anchorArrowBoundry = _get(elAnchorArrow).getBoundingClientRect();
      _get(elAnchorArrow).style.left = anchorBoundry.left - left + anchorBoundry.width / 2 - anchorArrowBoundry.width / 2 + "px";
    }
  }
  function requestServerVerification(_x7, _x8) {
    return _requestServerVerification.apply(this, arguments);
  }
  function _requestServerVerification() {
    _requestServerVerification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(verificationPayload, code) {
      var hook, resp, json;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _context6.n = 1;
            return callHook("onRequestServerVerification", verificationPayload, code);
          case 1:
            hook = _context6.v;
            if (!(hook !== void 0)) {
              _context6.n = 2;
              break;
            }
            return _context6.a(2, hook);
          case 2:
            log("requesting server verification from", _get(config).verifyUrl);
            if (_get(config).verifyUrl) {
              _context6.n = 3;
              break;
            }
            throw new Error("Parameter verifyUrl must be set for server verification.");
          case 3:
            _context6.n = 4;
            return _get(config).fetch(getUrl(_get(config).verifyUrl, _get(baseUrl)), {
              body: JSON.stringify({
                code: code,
                fields: _get(config).serverVerificationFields ? getTextFields() : void 0,
                payload: verificationPayload,
                timeZone: _get(config).serverVerificationTimeZone ? getTimeZone() : void 0
              }),
              credentials: _get(config).credentials || void 0,
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST"
            });
          case 4:
            resp = _context6.v;
            _context6.n = 5;
            return validateResponse(resp);
          case 5:
            _context6.n = 6;
            return resp.json();
          case 6:
            json = _context6.v;
            if (json && _typeof(json) === "object" && "payload" in json && !!json.payload) {
              dispatch("serververification", json);
            }
            return _context6.a(2, json);
        }
      }, _callee6);
    }));
    return _requestServerVerification.apply(this, arguments);
  }
  function requestSubmit(submitter) {
    var _get16;
    if (_get(elForm) && "requestSubmit" in _get(elForm)) {
      _get(elForm).requestSubmit(submitter);
    } else if ((_get16 = _get(elForm)) !== null && _get16 !== void 0 && _get16.reportValidity()) {
      if (submitter) {
        submitter.click();
      } else {
        _get(elForm).submit();
      }
    }
  }
  function setCookie(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var domain = options.domain,
      _options$name = options.name,
      name = _options$name === void 0 ? _get(config).name : _options$name,
      maxAge = options.maxAge,
      path = options.path,
      sameSite = options.sameSite,
      secure = options.secure;
    var cookie = "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(value));
    if (domain) cookie += "; Domain=".concat(domain);
    if (maxAge != null) cookie += "; Max-Age=".concat(maxAge);
    if (path) cookie += "; Path=".concat(path);
    if (sameSite) cookie += "; SameSite=".concat(sameSite);
    if (secure) cookie += "; Secure";
    document.cookie = cookie;
  }
  function setDisplay(value) {
    switch (value) {
      case "bar":
      case "floating":
      case "overlay":
        hide();
        if (!_get(auto) || _get(auto) === "off") {
          _get(userConfig).auto = "onsubmit";
        }
        break;
      case "standard":
        show();
    }
    if (_get(currentDisplay) !== value) {
      _set(currentDisplay, value, true);
    }
  }
  function setChallengeExpiration(expiresAt) {
    if (_get(expirationTimeout)) {
      clearTimeout(_get(expirationTimeout));
    }
    var onExpired = function onExpired() {
      if (_get(currentState) !== State.UNVERIFIED) {
        _set(checked, false);
        setState(State.EXPIRED);
      } else {
        reset$1();
      }
      dispatch("expired");
    };
    var duration = expiresAt * 1e3 - Date.now();
    if (duration >= 1) {
      _set(expirationTimeout, setTimeout(onExpired, duration), true);
    } else {
      onExpired();
    }
  }
  function validateResponse(_x9) {
    return _validateResponse.apply(this, arguments);
  }
  function _validateResponse() {
    _validateResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(resp) {
      var _resp$headers$get, json, contentType, _t4;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (!(resp.status >= 400)) {
              _context7.n = 6;
              break;
            }
            if (!((_resp$headers$get = resp.headers.get("content-type")) !== null && _resp$headers$get !== void 0 && _resp$headers$get.includes("/json"))) {
              _context7.n = 5;
              break;
            }
            _context7.p = 1;
            _context7.n = 2;
            return resp.json();
          case 2:
            json = _context7.v;
            _context7.n = 4;
            break;
          case 3:
            _context7.p = 3;
            _t4 = _context7.v;
          case 4:
            if (!(json && "error" in json)) {
              _context7.n = 5;
              break;
            }
            throw new Error("Server responded with ".concat(resp.status, " - ").concat(json.error));
          case 5:
            throw new Error("Server responded with ".concat(resp.status, "."));
          case 6:
            contentType = resp.headers.get("content-type");
            if (!(!contentType || !contentType.includes("/json"))) {
              _context7.n = 7;
              break;
            }
            throw new Error("Server responded with invalid content-type. Expected application/json, received ".concat(contentType, "."));
          case 7:
            return _context7.a(2);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return _validateResponse.apply(this, arguments);
  }
  function verifyServer(_x0) {
    return _verifyServer.apply(this, arguments);
  }
  function _verifyServer() {
    _verifyServer = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(code) {
      var _result, _result2;
      var result, _result3, _getCheckboxElement2;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            if (_get(payload)) {
              _context8.n = 1;
              break;
            }
            setState(State.ERROR, "Cannot verify code challenge without PoW payload.");
            return _context8.a(2);
          case 1:
            setState(State.VERIFYING);
            result = null;
            if (!_get(config).verifyUrl) {
              _context8.n = 3;
              break;
            }
            _context8.n = 2;
            return requestServerVerification(_get(payload), code);
          case 2:
            result = _context8.v;
            _context8.n = 6;
            break;
          case 3:
            if (!_get(config).verifyFunction) {
              _context8.n = 5;
              break;
            }
            _context8.n = 4;
            return _get(config).verifyFunction(_get(payload), code);
          case 4:
            result = _context8.v;
            _context8.n = 6;
            break;
          case 5:
            setState(State.ERROR, "Parameter verifyUrl is required for code challenge verification.");
            return _context8.a(2);
          case 6:
            if ((_result = result) !== null && _result !== void 0 && _result.payload) {
              _set(payload, result.payload, true);
              log("server payload", _get(payload));
            }
            if (((_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.verified) === true) {
              log("verified");
              setState(State.VERIFIED);
              dispatch("verified", {
                payload: _get(payload)
              });
              if (_get(auto) === "onsubmit") {
                tick().then(function () {
                  requestSubmit(_get(elSubmitter));
                });
              }
            } else {
              setState(State.ERROR, ((_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.reason) || "Verification failed.");
            }
            if (!_get(config).disableAutoFocus) {
              (_getCheckboxElement2 = getCheckboxElement()) === null || _getCheckboxElement2 === void 0 || _getCheckboxElement2.focus();
            }
          case 7:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return _verifyServer.apply(this, arguments);
  }
  function configure(newConfig) {
    Object.assign(_get(userConfig), _objectSpread({}, Object.fromEntries(Object.entries(newConfig).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        _ = _ref6[0],
        value = _ref6[1];
      return value !== void 0;
    }))));
  }
  function getConfiguration() {
    return _objectSpread({}, _get(config));
  }
  function getState() {
    return _get(currentState);
  }
  function hide() {
    _set(visible, false);
  }
  function log() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
      args[_key6] = arguments[_key6];
    }
    if (_get(config).debug || args.some(function (a) {
      return a instanceof Error;
    })) {
      var _console;
      (_console = console)[args[0] instanceof Error ? "error" : "log"].apply(_console, ["ALTCHA", "[name=".concat(_get(config).name, "]")].concat(args));
    }
  }
  function reset$1() {
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : State.UNVERIFIED;
    var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _set(checked, false);
    _set(error, err, true);
    _set(payload, null);
    if (_get(currentController)) {
      _get(currentController).abort();
    }
    if (_get(expirationTimeout)) {
      clearTimeout(_get(expirationTimeout));
      _set(expirationTimeout, null);
    }
    setState(newState);
  }
  function setState(newState) {
    var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _set(currentState, newState, true);
    _set(error, err, true);
    dispatch("statechange", {
      payload: _get(payload),
      state: _get(currentState)
    });
  }
  function show() {
    _set(visible, true);
    tick().then(function () {
      updateUI();
    });
  }
  function updateUI() {
    switch (_get(config).display) {
      case "floating":
        return repositionFloating();
    }
    _set(updateUISignal, _get(updateUISignal) + 1);
  }
  function verify() {
    return _verify.apply(this, arguments);
  }
  function _verify() {
    _verify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var options,
        _options$concurrency,
        concurrency,
        _options$controller,
        controller,
        _options$minDuration,
        minDuration,
        start,
        challenge,
        solution,
        isChallengeV12,
        hook,
        _get18,
        _get17,
        createWorker,
        _args9 = arguments,
        _t5;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            options = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
            _options$concurrency = options.concurrency, concurrency = _options$concurrency === void 0 ? Math.max(1, _get(config).workers) : _options$concurrency, _options$controller = options.controller, controller = _options$controller === void 0 ? new AbortController() : _options$controller, _options$minDuration = options.minDuration, minDuration = _options$minDuration === void 0 ? _get(config).minDuration : _options$minDuration;
            start = performance.now();
            challenge = null;
            solution = null;
            isChallengeV12 = false;
            _context9.n = 1;
            return callHook("onVerify", options);
          case 1:
            hook = _context9.v;
            if (!(hook !== void 0)) {
              _context9.n = 2;
              break;
            }
            return _context9.a(2, hook);
          case 2:
            reset$1(State.VERIFYING);
            _set(currentController, controller, true);
            _context9.p = 3;
            if (isSecureContext) {
              _context9.n = 4;
              break;
            }
            throw new Error("Secure context (HTTPS) required.");
          case 4:
            if (!_get(config).mockError) {
              _context9.n = 5;
              break;
            }
            throw new Error("Mock error.");
          case 5:
            if (!_get(config).test) {
              _context9.n = 8;
              break;
            }
            log("running test mode with null challenge");
            _context9.n = 6;
            return delay(Math.max(0, minDuration - (performance.now() - start)));
          case 6:
            if (!((_get17 = _get(currentController)) !== null && _get17 !== void 0 && _get17.signal.aborted)) {
              _context9.n = 7;
              break;
            }
            reset$1();
            return _context9.a(2, null);
          case 7:
            _set(payload, btoa(JSON.stringify({
              challenge: null,
              solution: null,
              test: true
            })), true);
            log("verified");
            setState(State.VERIFIED);
            dispatch("verified", {
              payload: _get(payload)
            });
            return _context9.a(2, {
              payload: _get(payload)
            });
          case 8:
            _context9.n = 9;
            return fetchChallenge();
          case 9:
            challenge = _context9.v;
            if (challenge) {
              _context9.n = 10;
              break;
            }
            throw new Error("Failed to fetch challenge.");
          case 10:
            log("challenge", challenge);
            if ("configuration" in challenge) {
              log("re-configuring from challenge", challenge.configuration);
              configure(challenge.configuration);
            }
            if (challenge.parameters.expiresAt) {
              setChallengeExpiration(challenge.parameters.expiresAt);
            }
            isChallengeV12 = "_version" in challenge && challenge._version === 1;
            createWorker = globalThis.$altcha.algorithms.get(challenge.parameters.algorithm);
            if (createWorker) {
              _context9.n = 11;
              break;
            }
            throw new Error("Unsupported algorithm ".concat(challenge.parameters.algorithm, "."));
          case 11:
            _context9.n = 12;
            return solveChallengeWorkers({
              challenge: challenge,
              concurrency: concurrency,
              controller: controller,
              createWorker: createWorker,
              counterMode: isChallengeV12 ? "string" : "uint32",
              onOutOfMemory: function onOutOfMemory(c) {
                log("out of memory error received");
                dispatch("outofmemory");
                if (_get(config).retryOnOutOfMemoryError && c > 1) {
                  var retryConcurrency = Math.floor(c / 2);
                  log("retrying with ".concat(retryConcurrency, " workers..."));
                  return retryConcurrency;
                }
              },
              timeout: _get(config).timeout
            });
          case 12:
            solution = _context9.v;
            if (!((_get18 = _get(currentController)) !== null && _get18 !== void 0 && _get18.signal.aborted)) {
              _context9.n = 13;
              break;
            }
            reset$1();
            return _context9.a(2, null);
          case 13:
            if (solution) {
              _context9.n = 14;
              break;
            }
            throw new Error("Failed to find solution.");
          case 14:
            log("solution", solution);
            _context9.n = 15;
            return delay(Math.max(0, minDuration - (performance.now() - start)));
          case 15:
            _set(codeChallenge, challenge.codeChallenge || _get(config).codeChallenge || null, true);
            if (isChallengeV12) {
              _set(payload, btoa(JSON.stringify(createPayloadV1(challenge, solution))), true);
            } else {
              _set(payload, btoa(JSON.stringify({
                challenge: {
                  parameters: challenge.parameters,
                  signature: challenge.signature
                },
                solution: solution
              })), true);
            }
            if (!_get(codeChallenge)) {
              _context9.n = 16;
              break;
            }
            log("requesting code verification");
            setState(State.CODE);
            dispatch("codechallenge", {
              codeChallenge: _get(codeChallenge)
            });
            _context9.n = 19;
            break;
          case 16:
            if (!_get(config).verifyUrl) {
              _context9.n = 18;
              break;
            }
            _context9.n = 17;
            return verifyServer();
          case 17:
            _context9.n = 19;
            break;
          case 18:
            log("verified");
            setState(State.VERIFIED);
            dispatch("verified", {
              payload: _get(payload)
            });
          case 19:
            _context9.n = 21;
            break;
          case 20:
            _context9.p = 20;
            _t5 = _context9.v;
            log("verification failed", _t5);
            setState(State.ERROR, String(_t5));
            return _context9.a(2, null);
          case 21:
            _context9.p = 21;
            _set(currentController, null);
            return _context9.f(21);
          case 22:
            return _context9.a(2, {
              challenge: challenge,
              payload: _get(payload),
              solution: solution
            });
        }
      }, _callee9, null, [[3, 20, 21, 22]]);
    }));
    return _verify.apply(this, arguments);
  }
  var $$exports = {
    configure: configure,
    getConfiguration: getConfiguration,
    getState: getState,
    hide: hide,
    log: log,
    reset: reset$1,
    setState: setState,
    show: show,
    updateUI: updateUI,
    verify: verify
  };
  var fragment = root_8();
  event("scroll", $document, onDocumentScroll);
  event("click", $document, onDocumentClick);
  event("pageshow", $window, onWindowPageshow);
  event("resize", $window, onWindowResize);
  var node = first_child(fragment);
  {
    var consequent = function consequent($$anchor2) {
      var div = root();
      append($$anchor2, div);
    };
    if_block(node, function ($$render) {
      if (_get(config).display === "overlay" && _get(visible)) $$render(consequent);
    });
  }
  var div_1 = sibling(node, 2);
  var node_1 = child(div_1);
  {
    var consequent_2 = function consequent_2($$anchor2) {
      var fragment_1 = root_2();
      var div_2 = first_child(fragment_1);
      var node_2 = sibling(div_2, 2);
      {
        var consequent_1 = function consequent_1($$anchor3) {
          var div_3 = root_1();
          html(div_3, function () {
            var _document$querySelect2;
            return (_document$querySelect2 = document.querySelector(_get(config).overlayContent)) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.innerHTML;
          }, true);
          reset(div_3);
          append($$anchor3, div_3);
        };
        if_block(node_2, function ($$render) {
          if (_get(config).overlayContent) $$render(consequent_1);
        });
      }
      event("click", div_2, onCloseClick, true);
      append($$anchor2, fragment_1);
    };
    if_block(node_1, function ($$render) {
      if (_get(config).display === "overlay" && _get(visible)) $$render(consequent_2);
    });
  }
  var div_4 = sibling(node_1, 2);
  var div_5 = child(div_4);
  var div_6 = child(div_5);
  var node_3 = child(div_6);
  {
    var $0 = /* @__PURE__ */user_derived(function () {
      return _get(config).display === "standard" && _get(auto) !== "onsubmit" || _get(currentState) === State.VERIFYING;
    });
    component(node_3, function () {
      return _get(CheckboxComponent);
    }, function ($$anchor2, CheckboxComponent_1) {
      CheckboxComponent_1($$anchor2, {
        get id() {
          return _get(checkboxId);
        },
        name: "",
        get required() {
          return _get($0);
        },
        get loading() {
          return _get(loading);
        },
        get checked() {
          return _get(checked);
        },
        onchange: onCheckboxChange,
        oninvalid: onCheckboxInvalid
      });
    });
  }
  var label = sibling(node_3, 2);
  var node_4 = child(label);
  {
    var consequent_3 = function consequent_3($$anchor2) {
      var text$1 = text();
      template_effect(function () {
        return set_text(text$1, _get(strings).verificationRequired);
      });
      append($$anchor2, text$1);
    };
    var consequent_4 = function consequent_4($$anchor2) {
      var text_1 = text();
      template_effect(function () {
        return set_text(text_1, _get(strings).verifying);
      });
      append($$anchor2, text_1);
    };
    var consequent_5 = function consequent_5($$anchor2) {
      var text_2 = text();
      template_effect(function () {
        return set_text(text_2, _get(strings).verified);
      });
      append($$anchor2, text_2);
    };
    var alternate = function alternate($$anchor2) {
      var text_3 = text();
      template_effect(function () {
        return set_text(text_3, _get(strings).label);
      });
      append($$anchor2, text_3);
    };
    if_block(node_4, function ($$render) {
      if (_get(currentState) === State.CODE && _get(codeChallenge)) $$render(consequent_3);else if (_get(currentState) === State.VERIFYING) $$render(consequent_4, 1);else if (_get(currentState) === State.VERIFIED) $$render(consequent_5, 2);else $$render(alternate, -1);
    });
  }
  reset(label);
  reset(div_6);
  var node_5 = sibling(div_6, 2);
  {
    var consequent_6 = function consequent_6($$anchor2) {
      Logo($$anchor2, {
        get strings() {
          return _get(strings);
        }
      });
    };
    if_block(node_5, function ($$render) {
      if (_get(showLogo)) $$render(consequent_6);
    });
  }
  reset(div_5);
  var node_6 = sibling(div_5, 2);
  {
    var consequent_7 = function consequent_7($$anchor2) {
      {
        var _$ = /* @__PURE__ */user_derived(function () {
          return _get(config).display === "bar" && _get(showLogo);
        });
        Footer($$anchor2, {
          get logo() {
            return _get(_$);
          },
          get strings() {
            return _get(strings);
          }
        });
      }
    };
    if_block(node_6, function ($$render) {
      if (_get(showFooter)) $$render(consequent_7);
    });
  }
  var node_7 = sibling(node_6, 2);
  {
    var consequent_8 = function consequent_8($$anchor2) {
      var div_7 = root_3();
      bind_this(div_7, function ($$value) {
        return _set(elAnchorArrow, $$value);
      }, function () {
        return _get(elAnchorArrow);
      });
      append($$anchor2, div_7);
    };
    if_block(node_7, function ($$render) {
      if (_get(config).display === "floating") $$render(consequent_8);
    });
  }
  var node_8 = sibling(node_7, 2);
  {
    var consequent_9 = function consequent_9($$anchor2) {
      var input_1 = root_4();
      remove_input_defaults(input_1);
      template_effect(function () {
        set_attribute(input_1, "name", _get(config).name);
        set_value(input_1, _get(payload));
      });
      append($$anchor2, input_1);
    };
    if_block(node_8, function ($$render) {
      if (!_get(config).setCookie) $$render(consequent_9);
    });
  }
  reset(div_4);
  var node_9 = sibling(div_4, 2);
  {
    var consequent_12 = function consequent_12($$anchor2) {
      Popover($$anchor2, {
        get anchor() {
          return _get(elRoot);
        },
        onClickOutside: function onClickOutside() {
          if (isSecureContext) {
            reset$1();
          }
        },
        get placement() {
          return _get(config).popoverPlacement;
        },
        role: "alert",
        variant: "error",
        get dir() {
          return _get(dir);
        },
        get updateUISignal() {
          return _get(updateUISignal);
        },
        children: function children($$anchor3, $$slotProps) {
          var fragment_9 = comment();
          var node_10 = first_child(fragment_9);
          {
            var consequent_10 = function consequent_10($$anchor4) {
              var div_8 = root_5();
              append($$anchor4, div_8);
            };
            var consequent_11 = function consequent_11($$anchor4) {
              var div_9 = root_6();
              var text_4 = only_child(div_9, true);
              template_effect(function () {
                return set_text(text_4, _get(strings).expired);
              });
              append($$anchor4, div_9);
            };
            var alternate_1 = function alternate_1($$anchor4) {
              var div_10 = root_6();
              var text_5 = only_child(div_10, true);
              template_effect(function () {
                set_attribute(div_10, "title", _get(error));
                set_text(text_5, _get(strings).error);
              });
              append($$anchor4, div_10);
            };
            if_block(node_10, function ($$render) {
              if (!_get(error) && !isSecureContext) $$render(consequent_10);else if (!_get(error) && _get(currentState) === State.EXPIRED) $$render(consequent_11, 1);else $$render(alternate_1, -1);
            });
          }
          append($$anchor3, fragment_9);
        },
        $$slots: {
          "default": true
        }
      });
    };
    var consequent_14 = function consequent_14($$anchor2) {
      var fragment_10 = comment();
      var node_11 = first_child(fragment_10);
      key(node_11, function () {
        return _get(codeChallenge);
      }, function ($$anchor3) {
        {
          var _$2 = /* @__PURE__ */user_derived(function () {
            return _get(config).codeChallengeDisplay !== "standard";
          });
          Popover($$anchor3, {
            get anchor() {
              return _get(elRoot);
            },
            get backdrop() {
              return _get(_$2);
            },
            get display() {
              return _get(config).codeChallengeDisplay;
            },
            onClose: function onClose() {
              reset$1();
            },
            get placement() {
              return _get(config).popoverPlacement;
            },
            role: "dialog",
            get "aria-label"() {
              return _get(strings).verificationRequired;
            },
            get dir() {
              return _get(dir);
            },
            get updateUISignal() {
              return _get(updateUISignal);
            },
            children: function children($$anchor4, $$slotProps) {
              var fragment_12 = root_7();
              var node_12 = first_child(fragment_12);
              Code(node_12, {
                get audioUrl() {
                  return _get(codeChallengeAudioUrl);
                },
                get imageUrl() {
                  return _get(codeChallengeImageUrl);
                },
                onCancel: function onCancel() {
                  return reset$1();
                },
                onReload: function onReload() {
                  return verify();
                },
                onSubmit: function onSubmit(code) {
                  return verifyServer(code);
                },
                get codeChallenge() {
                  return _get(codeChallenge);
                },
                get config() {
                  return _get(config);
                },
                get strings() {
                  return _get(strings);
                }
              });
              var node_13 = sibling(node_12, 2);
              {
                var consequent_13 = function consequent_13($$anchor5) {
                  Footer($$anchor5, {
                    get logo() {
                      return _get(showLogo);
                    },
                    get strings() {
                      return _get(strings);
                    }
                  });
                };
                if_block(node_13, function ($$render) {
                  if (_get(showFooter) && _get(config).codeChallengeDisplay !== "standard") $$render(consequent_13);
                });
              }
              append($$anchor4, fragment_12);
            },
            $$slots: {
              "default": true
            }
          });
        }
      });
      append($$anchor2, fragment_10);
    };
    if_block(node_9, function ($$render) {
      if (_get(error) || _get(currentState) === State.EXPIRED || !isSecureContext) $$render(consequent_12);else if (_get(codeChallenge) && _get(currentState) === State.CODE) $$render(consequent_14, 1);
    });
  }
  reset(div_1);
  bind_this(div_1, function ($$value) {
    return _set(elRoot, $$value);
  }, function () {
    return _get(elRoot);
  });
  template_effect(function ($0) {
    set_attribute(div_1, "data-state", _get(currentState));
    set_attribute(div_1, "data-display", _get(config).display || void 0);
    set_attribute(div_1, "data-placement", $0);
    set_attribute(div_1, "data-visible", _get(visible) || void 0);
    set_attribute(div_1, "dir", _get(dir));
    set_attribute(label, "for", _get(checkboxId));
    div_1.dir = div_1.dir;
  }, [function () {
    return getPlacement(_get(config).display);
  }]);
  append($$anchor, fragment);
  var $$pop = pop($$exports);
  $$cleanup();
  return $$pop;
}
if (typeof window !== "undefined" && window.customElements && !customElements.get("altcha-widget")) customElements.define("altcha-widget", create_custom_element(Widget, {
  auto: {
    type: "String"
  },
  challenge: {
    type: "String"
  },
  configuration: {
    type: "String"
  },
  display: {
    type: "String"
  },
  language: {
    type: "String"
  },
  name: {
    type: "String"
  },
  theme: {
    type: "String"
  },
  type: {
    type: "String"
  },
  workers: {
    type: "Number"
  }
}, [], ["configure", "getConfiguration", "getState", "hide", "log", "reset", "setState", "show", "updateUI", "verify"]));
var jsContent$1 = "(function() {\n  \"use strict\";\n  function bufferStartsWith(buffer, prefix) {\n    if (prefix.length > buffer.length) {\n      return false;\n    }\n    for (let i = 0; i < prefix.length; i++) {\n      if (buffer[i] !== prefix[i]) {\n        return false;\n      }\n    }\n    return true;\n  }\n  function bufferToHex(buffer) {\n    return Array.from(new Uint8Array(buffer)).map((b) => b.toString(16).padStart(2, \"0\")).join(\"\");\n  }\n  function concatBuffers(a, b) {\n    const out = new Uint8Array(a.length + b.length);\n    out.set(a, 0);\n    out.set(b, a.length);\n    return out;\n  }\n  function hexToBuffer(hex) {\n    if (hex.length % 2 !== 0) {\n      throw new Error(`Hex string must have an even length. Got: ${hex}`);\n    }\n    const buffer = new ArrayBuffer(hex.length / 2);\n    const view = new DataView(buffer);\n    for (let i = 0; i < hex.length; i += 2) {\n      const byteString = hex.substring(i, i + 2);\n      const byteValue = parseInt(byteString, 16);\n      view.setUint8(i / 2, byteValue);\n    }\n    return new Uint8Array(buffer);\n  }\n  async function delay(ms) {\n    await new Promise((resolve) => setTimeout(resolve, ms));\n  }\n  function timeDuration(start) {\n    return Math.floor((performance.now() - start) * 10) / 10;\n  }\n  class PasswordBuffer {\n    constructor(nonce, mode = \"uint32\") {\n      this.nonce = nonce;\n      this.mode = mode;\n      this.buffer = new Uint8Array(this.nonce.length + this.COUNTER_BYTES);\n      this.buffer.set(this.nonce, 0);\n      this.dataView = new DataView(this.buffer.buffer);\n    }\n    nonce;\n    mode;\n    COUNTER_BYTES = 4;\n    buffer;\n    dataView;\n    encoder = new TextEncoder();\n    /**\n     * Appends the counter to the nonce buffer.\n     * In 'string' mode, encodes the counter as a UTF-8 string.\n     * In 'uint32' mode, writes the counter as a big-endian 32-bit integer.\n     */\n    setCounter(n) {\n      if (this.mode === \"string\") {\n        return concatBuffers(this.nonce, this.encoder.encode(n.toString()));\n      }\n      this.dataView.setUint32(this.nonce.length, n, false);\n      return this.buffer;\n    }\n  }\n  async function solveChallenge(options) {\n    const {\n      challenge,\n      controller,\n      counterMode = \"uint32\",\n      counterStart = 0,\n      counterStep = 1,\n      deriveKey: deriveKey2,\n      timeout = 9e4\n    } = options;\n    const { nonce, keyPrefix, salt } = challenge.parameters;\n    const nonceBuf = hexToBuffer(nonce);\n    const saltBuf = hexToBuffer(salt);\n    const keyPrefixBuf = keyPrefix.length % 2 === 0 ? hexToBuffer(keyPrefix) : null;\n    const password = new PasswordBuffer(nonceBuf, counterMode);\n    const start = performance.now();\n    let counter = counterStart;\n    let iterations = 0;\n    let derivedKeyHex = \"\";\n    let lastYield = start;\n    while (true) {\n      if (controller?.signal.aborted || timeout && iterations % 10 === 0 && performance.now() - start > timeout) {\n        return null;\n      }\n      const { derivedKey } = await deriveKey2(\n        challenge.parameters,\n        saltBuf,\n        password.setCounter(counter)\n      );\n      if (iterations % 10 === 0 && performance.now() - lastYield > 200) {\n        await delay(0);\n        lastYield = performance.now();\n      }\n      if (keyPrefixBuf ? bufferStartsWith(derivedKey, keyPrefixBuf) : bufferToHex(derivedKey).startsWith(keyPrefix)) {\n        derivedKeyHex = bufferToHex(derivedKey);\n        break;\n      }\n      counter = counter + counterStep;\n      iterations = iterations + 1;\n    }\n    return {\n      counter,\n      derivedKey: derivedKeyHex,\n      time: timeDuration(start)\n    };\n  }\n  function handler(options) {\n    const { deriveKey: deriveKey2 } = options;\n    let controller = void 0;\n    self.onmessage = async (message) => {\n      const { challenge, counterMode, counterStart, counterStep, timeout, type } = message.data;\n      if (type === \"abort\") {\n        controller?.abort();\n      } else if (type === \"work\") {\n        controller = new AbortController();\n        let solution;\n        try {\n          solution = await solveChallenge({\n            challenge,\n            controller,\n            counterStart,\n            counterStep,\n            deriveKey: deriveKey2,\n            counterMode,\n            timeout\n          });\n        } catch (err) {\n          return self.postMessage({ error: err });\n        }\n        self.postMessage(solution);\n      }\n    };\n  }\n  function getDigest(algorithm) {\n    switch (algorithm) {\n      case \"PBKDF2/SHA-512\":\n        return \"SHA-512\";\n      case \"PBKDF2/SHA-384\":\n        return \"SHA-384\";\n      case \"PBKDF2/SHA-256\":\n      default:\n        return \"SHA-256\";\n    }\n  }\n  async function deriveKey(parameters, salt, password) {\n    const { algorithm, cost, keyLength = 32 } = parameters;\n    const passwordKey = await crypto.subtle.importKey(\n      \"raw\",\n      password,\n      { name: \"PBKDF2\" },\n      false,\n      [\"deriveKey\"]\n    );\n    const derivedKey = await crypto.subtle.deriveKey(\n      {\n        name: \"PBKDF2\",\n        salt,\n        iterations: cost,\n        hash: getDigest(algorithm)\n      },\n      passwordKey,\n      { name: \"AES-GCM\", length: keyLength * 8 },\n      true,\n      [\"encrypt\"]\n    );\n    return {\n      derivedKey: new Uint8Array(await crypto.subtle.exportKey(\"raw\", derivedKey))\n    };\n  }\n  handler({\n    deriveKey\n  });\n})();\n";
var blob$1 = typeof self !== "undefined" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", jsContent$1], {
  type: "text/javascript;charset=utf-8"
});
function WorkerWrapper$1(options) {
  var objURL;
  try {
    objURL = blob$1 && (self.URL || self.webkitURL).createObjectURL(blob$1);
    if (!objURL) throw "";
    var worker = new Worker(objURL, {
      name: options === null || options === void 0 ? void 0 : options.name
    });
    worker.addEventListener("error", function () {
      (self.URL || self.webkitURL).revokeObjectURL(objURL);
    });
    return worker;
  } catch (e) {
    return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(jsContent$1), {
      name: options === null || options === void 0 ? void 0 : options.name
    });
  }
}
var jsContent = "(function() {\n  \"use strict\";\n  function bufferStartsWith(buffer, prefix) {\n    if (prefix.length > buffer.length) {\n      return false;\n    }\n    for (let i = 0; i < prefix.length; i++) {\n      if (buffer[i] !== prefix[i]) {\n        return false;\n      }\n    }\n    return true;\n  }\n  function bufferToHex(buffer) {\n    return Array.from(new Uint8Array(buffer)).map((b) => b.toString(16).padStart(2, \"0\")).join(\"\");\n  }\n  function concatBuffers(a, b) {\n    const out = new Uint8Array(a.length + b.length);\n    out.set(a, 0);\n    out.set(b, a.length);\n    return out;\n  }\n  function hexToBuffer(hex) {\n    if (hex.length % 2 !== 0) {\n      throw new Error(`Hex string must have an even length. Got: ${hex}`);\n    }\n    const buffer = new ArrayBuffer(hex.length / 2);\n    const view = new DataView(buffer);\n    for (let i = 0; i < hex.length; i += 2) {\n      const byteString = hex.substring(i, i + 2);\n      const byteValue = parseInt(byteString, 16);\n      view.setUint8(i / 2, byteValue);\n    }\n    return new Uint8Array(buffer);\n  }\n  async function delay(ms) {\n    await new Promise((resolve) => setTimeout(resolve, ms));\n  }\n  function timeDuration(start) {\n    return Math.floor((performance.now() - start) * 10) / 10;\n  }\n  class PasswordBuffer {\n    constructor(nonce, mode = \"uint32\") {\n      this.nonce = nonce;\n      this.mode = mode;\n      this.buffer = new Uint8Array(this.nonce.length + this.COUNTER_BYTES);\n      this.buffer.set(this.nonce, 0);\n      this.dataView = new DataView(this.buffer.buffer);\n    }\n    nonce;\n    mode;\n    COUNTER_BYTES = 4;\n    buffer;\n    dataView;\n    encoder = new TextEncoder();\n    /**\n     * Appends the counter to the nonce buffer.\n     * In 'string' mode, encodes the counter as a UTF-8 string.\n     * In 'uint32' mode, writes the counter as a big-endian 32-bit integer.\n     */\n    setCounter(n) {\n      if (this.mode === \"string\") {\n        return concatBuffers(this.nonce, this.encoder.encode(n.toString()));\n      }\n      this.dataView.setUint32(this.nonce.length, n, false);\n      return this.buffer;\n    }\n  }\n  async function solveChallenge(options) {\n    const {\n      challenge,\n      controller,\n      counterMode = \"uint32\",\n      counterStart = 0,\n      counterStep = 1,\n      deriveKey: deriveKey2,\n      timeout = 9e4\n    } = options;\n    const { nonce, keyPrefix, salt } = challenge.parameters;\n    const nonceBuf = hexToBuffer(nonce);\n    const saltBuf = hexToBuffer(salt);\n    const keyPrefixBuf = keyPrefix.length % 2 === 0 ? hexToBuffer(keyPrefix) : null;\n    const password = new PasswordBuffer(nonceBuf, counterMode);\n    const start = performance.now();\n    let counter = counterStart;\n    let iterations = 0;\n    let derivedKeyHex = \"\";\n    let lastYield = start;\n    while (true) {\n      if (controller?.signal.aborted || timeout && iterations % 10 === 0 && performance.now() - start > timeout) {\n        return null;\n      }\n      const { derivedKey } = await deriveKey2(\n        challenge.parameters,\n        saltBuf,\n        password.setCounter(counter)\n      );\n      if (iterations % 10 === 0 && performance.now() - lastYield > 200) {\n        await delay(0);\n        lastYield = performance.now();\n      }\n      if (keyPrefixBuf ? bufferStartsWith(derivedKey, keyPrefixBuf) : bufferToHex(derivedKey).startsWith(keyPrefix)) {\n        derivedKeyHex = bufferToHex(derivedKey);\n        break;\n      }\n      counter = counter + counterStep;\n      iterations = iterations + 1;\n    }\n    return {\n      counter,\n      derivedKey: derivedKeyHex,\n      time: timeDuration(start)\n    };\n  }\n  function handler(options) {\n    const { deriveKey: deriveKey2 } = options;\n    let controller = void 0;\n    self.onmessage = async (message) => {\n      const { challenge, counterMode, counterStart, counterStep, timeout, type } = message.data;\n      if (type === \"abort\") {\n        controller?.abort();\n      } else if (type === \"work\") {\n        controller = new AbortController();\n        let solution;\n        try {\n          solution = await solveChallenge({\n            challenge,\n            controller,\n            counterStart,\n            counterStep,\n            deriveKey: deriveKey2,\n            counterMode,\n            timeout\n          });\n        } catch (err) {\n          return self.postMessage({ error: err });\n        }\n        self.postMessage(solution);\n      }\n    };\n  }\n  async function deriveKey(parameters, salt, password) {\n    const { algorithm, keyLength = 32 } = parameters;\n    const iterations = Math.max(1, parameters.cost);\n    let data = void 0;\n    let derivedKey = void 0;\n    for (let i = 0; i < iterations; i++) {\n      if (i === 0) {\n        data = concatBuffers(salt, password);\n      } else {\n        data = derivedKey;\n      }\n      derivedKey = new Uint8Array(\n        (await crypto.subtle.digest(algorithm, data)).slice(0, keyLength)\n      );\n    }\n    return {\n      parameters: {},\n      derivedKey\n    };\n  }\n  handler({\n    deriveKey\n  });\n})();\n";
var blob = typeof self !== "undefined" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", jsContent], {
  type: "text/javascript;charset=utf-8"
});
function WorkerWrapper(options) {
  var objURL;
  try {
    objURL = blob && (self.URL || self.webkitURL).createObjectURL(blob);
    if (!objURL) throw "";
    var worker = new Worker(objURL, {
      name: options === null || options === void 0 ? void 0 : options.name
    });
    worker.addEventListener("error", function () {
      (self.URL || self.webkitURL).revokeObjectURL(objURL);
    });
    return worker;
  } catch (e) {
    return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(jsContent), {
      name: options === null || options === void 0 ? void 0 : options.name
    });
  }
}
var css = ':root {\n  --altcha-border-color: var(--altcha-color-neutral);\n  --altcha-border-width: 1px;\n  --altcha-border-radius: 6px;\n  --altcha-color-base: light-dark(oklch(100% 0.00011 271.152), oklch(20.904% 0.00002 271.152));\n  --altcha-color-base-content: light-dark(\n  	oklch(20.904% 0.00002 271.152),\n  	oklch(100% 0.00011 271.152)\n  );\n  --altcha-color-error: oklch(51.284% 0.20527 28.678);\n  --altcha-color-error-content: oklch(100% 0.00011 271.152);\n  --altcha-color-neutral: light-dark(oklch(83.591% 0.0001 271.152), oklch(46.04% 0.00005 271.152));\n  --altcha-color-neutral-content: light-dark(\n  	oklch(46.76% 0.00005 271.152),\n  	oklch(100% 0.00011 271.152)\n  );\n  --altcha-color-primary: oklch(40.279% 0.2449 268.131);\n  --altcha-color-primary-content: oklch(100% 0.00011 271.152);\n  --altcha-color-success: oklch(55.748% 0.18968 142.511);\n  --altcha-color-success-content: oklch(100% 0.00011 271.152);\n  --altcha-checkbox-border-color: light-dark(\n  	oklch(66.494% 0.00233 15.434),\n  	oklch(51.028% 0.00006 271.152)\n  );\n  --altcha-checkbox-border-radius: 5px;\n  --altcha-checkbox-border-width: var(--altcha-border-width);\n  --altcha-checkbox-outline: 2px solid var(--altcha-checkbox-outline-color);\n  --altcha-checkbox-outline-color: -webkit-focus-ring-color;\n  --altcha-checkbox-outline-offset: 2px;\n  --altcha-checkbox-size: 22px;\n  --altcha-checkbox-transition-duration: var(--altcha-transition-duration);\n  --altcha-input-background-color: var(--altcha-color-base);\n  --altcha-input-border-radius: 3px;\n  --altcha-input-border-width: 1px;\n  --altcha-input-color: var(--altcha-color-base-content);\n  --altcha-max-width: 320px;\n  --altcha-padding: 0.75rem;\n  --altcha-popover-arrow-size: 6px;\n  --altcha-popover-color: var(--altcha-border-color);\n  --altcha-shadow: drop-shadow(3px 3px 6px oklch(0% 0 0 / 0.2));\n  --altcha-spinner-color: var(--altcha-color-base-content);\n  --altcha-switch-background-color: var(--altcha-color-neutral);\n  --altcha-switch-border-radius: calc(infinity * 1px);\n  --altcha-switch-height: var(--altcha-checkbox-size);\n  --altcha-switch-padding: 0.25rem;\n  --altcha-switch-width: calc(var(--altcha-checkbox-size) * 1.75);\n  --altcha-switch-toggle-border-radius: 100%;\n  --altcha-switch-toggle-color: var(--altcha-color-neutral-content);\n  --altcha-switch-toggle-size: calc(\n  	var(--altcha-switch-height) - calc(var(--altcha-switch-padding) * 2)\n  );\n  --altcha-transition-duration: 0.6s;\n  --altcha-z-index: 99999999;\n  --altcha-z-index-popover: 999999999;\n}\n\n@supports (-moz-appearance: none) {\n  :root {\n    --altcha-checkbox-outline-color: var(--altcha-color-primary);\n  }\n}\n.altcha {\n  all: revert-layer;\n  display: none;\n  font-family: inherit;\n  font-size: inherit;\n  position: relative;\n}\n.altcha[data-visible] {\n  display: block;\n}\n.altcha-popover, .altcha-popover * {\n  all: revert-layer;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.25;\n}\n.altcha * {\n  all: revert-layer;\n  box-sizing: border-box;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: 1.25;\n}\n.altcha a, .altcha-popover a {\n  color: currentColor;\n  text-decoration: none;\n}\n.altcha a:hover, .altcha-popover a:hover {\n  color: currentColor;\n}\n.altcha-main {\n  align-items: start;\n  background-color: var(--altcha-color-base);\n  border: var(--altcha-border-width, 1px) solid var(--altcha-border-color);\n  border-radius: var(--altcha-border-radius, 0);\n  color: var(--altcha-color-base-content);\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: space-between;\n  padding: var(--altcha-padding);\n  max-width: var(--altcha-max-width, 100%);\n}\n.altcha-main > * {\n  display: flex;\n  width: 100%;\n}\n.altcha-main > *:first-child {\n  flex-grow: 1;\n}\n.altcha-checkbox-wrap {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  gap: 0.5rem;\n}\n.altcha-checkbox-wrap > * {\n  display: flex;\n}\n.altcha-logo {\n  opacity: 0.7;\n}\n.altcha-footer {\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  font-size: 0.7rem;\n  opacity: 0.7;\n}\n.altcha-footer p {\n  margin: 0;\n  padding: 0;\n}\n.altcha-error {\n  font-size: 0.85rem;\n}\n.altcha-button {\n  align-items: center;\n  background: var(--altcha-color-primary);\n  border: var(--altcha-input-border-width) solid var(--altcha-color-primary);\n  border-radius: var(--altcha-input-border-radius);\n  color: var(--altcha-color-primary-content);\n  cursor: pointer;\n  display: flex;\n  font-size: 0.9rem;\n  gap: 0.5rem;\n  padding: 0.35rem;\n}\n.altcha-button:focus {\n  border-color: var(--altcha-color-primary);\n  outline: var(--altcha-checkbox-outline);\n  outline-offset: var(--altcha-checkbox-outline-offset);\n}\n.altcha-button > .altcha-spinner, .altcha-button > svg {\n  height: 20px;\n  width: 20px;\n}\n.altcha-button-secondary {\n  background: transparent;\n  border-color: var(--altcha-color-neutral);\n  color: var(--altcha-color-neutral-content);\n}\n.altcha-input {\n  background: var(--altcha-input-background-color);\n  border: var(--altcha-input-border-width) solid var(--altcha-color-neutral);\n  border-radius: var(--altcha-input-border-radius);\n  color: var(--altcha-input-color);\n  flex-grow: 1;\n  font-size: 1rem;\n  min-width: 0;\n  padding: 0.25rem;\n  width: auto;\n}\n.altcha-input:focus {\n  border-color: var(--altcha-color-primary);\n  outline: var(--altcha-checkbox-outline);\n  outline-offset: var(--altcha-checkbox-outline-offset);\n}\n.altcha-spinner {\n  animation: altcha-rotate 0.6s linear infinite;\n  border-radius: 100%;\n  border: var(--altcha-checkbox-border-width) solid var(--altcha-spinner-color);\n  border-bottom-color: transparent;\n  border-right-color: transparent;\n  opacity: 0.7;\n}\n.altcha-popover {\n  background-color: var(--altcha-color-base);\n  border: var(--altcha-border-width) solid var(--altcha-border-color);\n  border-radius: var(--altcha-border-radius);\n  color: var(--altcha-color-base-content);\n  filter: var(--altcha-shadow);\n  position: absolute;\n  left: calc(var(--altcha-padding) / 2);\n  max-width: calc(var(--altcha-max-width) - var(--altcha-padding));\n  top: calc(var(--altcha-padding) + var(--altcha-checkbox-size) + var(--altcha-popover-arrow-size));\n  z-index: var(--altcha-z-index-popover);\n}\n.altcha-popover-arrow {\n  border: var(--altcha-popover-arrow-size) solid transparent;\n  border-bottom-color: var(--altcha-popover-color);\n  content: "";\n  height: 0;\n  left: calc(var(--altcha-checkbox-size) / 2);\n  position: absolute;\n  top: calc(var(--altcha-popover-arrow-size) * -2);\n  width: 0;\n}\n.altcha-popover-content {\n  max-height: 100dvh;\n  overflow: auto;\n  padding: var(--altcha-padding);\n}\n.altcha-popover[data-top=true][data-display=standard] {\n  bottom: calc(100% - (var(--altcha-padding) - var(--altcha-popover-arrow-size)));\n  top: auto;\n}\n.altcha-popover[data-top=true][data-display=standard] .altcha-popover-arrow {\n  border-bottom-color: transparent;\n  border-top-color: var(--altcha-popover-color);\n  bottom: calc(var(--altcha-popover-arrow-size) * -2);\n  top: auto;\n}\n.altcha-popover[data-variant=error] {\n  --altcha-popover-color: var(--altcha-color-error);\n  background-color: var(--altcha-color-error);\n  border-color: var(--altcha-color-error);\n  color: var(--altcha-color-error-content);\n}\n.altcha-popover[data-variant=error] .altcha-popover-content {\n  padding: calc(var(--altcha-padding) / 1.5) var(--altcha-padding);\n}\n.altcha-popover[data-display=overlay] {\n  animation: altcha-overlay-slidein 0.5s forwards;\n  left: 50%;\n  position: fixed;\n  top: 45%;\n  transform: translate(-50%, -50%);\n  width: var(--altcha-max-width);\n  z-index: var(--altcha-z-index);\n}\n.altcha-popover[data-display=bottomsheet] {\n  animation: altcha-bottomsheet-slideup 0.5s forwards;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  border-bottom: 0;\n  bottom: -100%;\n  left: 50%;\n  position: fixed;\n  top: auto;\n  transform: translate(-50%, 0);\n  width: var(--altcha-max-width);\n  z-index: var(--altcha-z-index);\n}\n.altcha-popover[data-display=bottomsheet] .altcha-popover-content {\n  padding-bottom: calc(var(--altcha-padding) * 2);\n}\n.altcha-popover-backdrop {\n  background: var(--altcha-color-base-content);\n  bottom: 0;\n  left: 0;\n  opacity: 0.1;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 0.5s;\n  z-index: var(--altcha-z-index);\n}\n.altcha-popover-close {\n  color: var(--altcha-color-base-content);\n  cursor: pointer;\n  display: inline-block;\n  font-size: 1rem;\n  height: 1.25rem;\n  line-height: 0.95;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  text-shadow: 0 0 1px var(--altcha-color-base);\n  top: -1.5rem;\n  width: 1.25rem;\n  z-index: var(--altcha-z-index);\n}\n[dir=rtl] .altcha-popover {\n  left: auto;\n  right: calc(var(--altcha-padding) / 2);\n}\n[dir=rtl] .altcha-popover-arrow {\n  left: auto;\n  right: calc(var(--altcha-checkbox-size) / 2);\n}\n[dir=rtl] .altcha-popover-close {\n  left: 0;\n  right: auto;\n}\n.altcha-popover[data-display=bottomsheet] .altcha-footer, .altcha-popover[data-display=overlay] .altcha-footer {\n  align-items: center;\n  justify-content: center;\n  padding-top: 1rem;\n  gap: 0.5rem;\n}\n.altcha-popover[data-display=bottomsheet] .altcha-footer svg, .altcha-popover[data-display=overlay] .altcha-footer svg {\n  height: 18px;\n  width: 18px;\n  vertical-align: middle;\n}\n.altcha-code-challenge > form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.altcha-code-challenge-title {\n  font-weight: 600;\n}\n.altcha-code-challenge-text {\n  font-size: 0.85rem;\n}\n.altcha-code-challenge-image {\n  background: white;\n  border: var(--altcha-input-border-width) solid var(--altcha-color-neutral);\n  border-radius: var(--altcha-input-border-radius);\n  object-fit: contain;\n  height: 50px;\n}\n.altcha-code-challenge-row {\n  display: flex;\n  gap: 0.5rem;\n}\n.altcha-code-challenge-buttons {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: var(--altcha-padding);\n  justify-content: space-between;\n}\n.altcha-code-challenge-buttons button {\n  justify-content: center;\n  width: 100%;\n}\n.altcha-checkbox {\n  cursor: pointer;\n  height: var(--altcha-checkbox-size);\n  position: relative;\n  width: var(--altcha-checkbox-size);\n}\n.altcha-checkbox input {\n  appearance: none;\n  background: var(--altcha-input-background-color);\n  border: var(--altcha-checkbox-border-width, 2px) solid var(--altcha-checkbox-border-color);\n  border-radius: var(--altcha-checkbox-border-radius);\n  cursor: pointer;\n  height: var(--altcha-checkbox-size);\n  left: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  width: var(--altcha-checkbox-size);\n}\n@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {\n  .altcha-checkbox input {\n    /* Safari-only: fixes focus outline */\n  }\n  .altcha-checkbox input:focus {\n    outline-width: 2px;\n    outline-style: solid;\n  }\n}\n.altcha-checkbox input:before {\n  border-radius: var(--altcha-checkbox-border-radius);\n  content: "";\n  width: 100%;\n  height: 100%;\n  background: var(--altcha-color-neutral);\n  display: block;\n  transform: scale(0);\n}\n.altcha-checkbox input:checked {\n  background-color: var(--altcha-color-success);\n  border-color: var(--altcha-color-success);\n}\n.altcha-checkbox input:checked::before {\n  background-color: var(--altcha-color-success);\n  opacity: 0;\n  transform: scale(2.2);\n  transition: all var(--altcha-checkbox-transition-duration) ease;\n  transition-delay: 0.1s;\n}\n.altcha-checkbox svg {\n  --altcha-radio-svg-size: calc(var(--altcha-checkbox-size) * 0.5);\n  --altcha-radio-svg-offset: calc(var(--altcha-checkbox-size) * 0.25);\n  fill: none;\n  left: var(--altcha-radio-svg-offset);\n  height: var(--altcha-radio-svg-size);\n  opacity: 0;\n  position: absolute;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 16px;\n  stroke-dashoffset: 16px;\n  top: var(--altcha-radio-svg-offset);\n  transform: translate3d(0, 0, 0);\n  width: var(--altcha-radio-svg-size);\n}\n.altcha-checkbox input:checked + svg {\n  color: var(--altcha-color-success-content);\n  opacity: 1;\n  stroke-dashoffset: 0;\n  transition: all var(--altcha-checkbox-transition-duration) ease;\n  transition-delay: 0.1s;\n}\n.altcha-checkbox-spinner {\n  display: none;\n  left: 0;\n  height: var(--altcha-checkbox-size);\n  position: absolute;\n  top: 0;\n  width: var(--altcha-checkbox-size);\n}\n.altcha-checkbox[data-loading=true] input {\n  appearance: none;\n  opacity: 0;\n  pointer-events: none;\n}\n.altcha-checkbox[data-loading=true] .altcha-checkbox-spinner {\n  display: block;\n}\n.altcha-checkbox-native {\n  height: var(--altcha-checkbox-size);\n  position: relative;\n  width: var(--altcha-checkbox-size);\n}\n.altcha-checkbox-native input {\n  height: var(--altcha-checkbox-size);\n  margin: 0;\n  width: var(--altcha-checkbox-size);\n}\n.altcha-checkbox-native-spinner {\n  display: none;\n  left: 0;\n  height: var(--altcha-checkbox-size);\n  position: absolute;\n  top: 0;\n  width: var(--altcha-checkbox-size);\n}\n.altcha-checkbox-native[data-loading=true] input {\n  appearance: none;\n  opacity: 0;\n  pointer-events: none;\n}\n.altcha-checkbox-native[data-loading=true] .altcha-checkbox-native-spinner {\n  display: block;\n}\n.altcha-switch {\n  align-items: center;\n  border-radius: var(--altcha-switch-border-radius);\n  background-color: var(--altcha-switch-background-color);\n  display: flex;\n  height: var(--altcha-switch-height);\n  padding: var(--altcha-switch-padding);\n  position: relative;\n  width: var(--altcha-switch-width);\n}\n.altcha-switch:focus-within {\n  outline: var(--altcha-checkbox-outline);\n  outline-offset: var(--altcha-checkbox-outline-offset);\n}\n.altcha-switch input {\n  appearance: none;\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.altcha-switch-toggle {\n  align-items: center;\n  background-color: var(--altcha-switch-toggle-color);\n  border-radius: var(--altcha-switch-toggle-border-radius);\n  cursor: pointer;\n  display: flex;\n  height: var(--altcha-switch-toggle-size);\n  justify-content: center;\n  left: var(--altcha-switch-padding);\n  position: absolute;\n  transition: width 150ms ease-out, left 150ms ease-out;\n  width: var(--altcha-switch-toggle-size);\n}\n.altcha-switch-spinner {\n  display: none;\n  height: var(--altcha-switch-toggle-size);\n  width: var(--altcha-switch-toggle-size);\n}\n.altcha-switch[data-loading=true] {\n  pointer-events: none;\n}\n.altcha-switch[data-loading=true] .altcha-switch-spinner {\n  display: block;\n}\n.altcha-switch[data-loading=true] .altcha-switch-toggle {\n  background-color: transparent;\n  left: calc(50% - var(--altcha-switch-toggle-size) / 2);\n}\n[data-state=verified] .altcha-switch {\n  --altcha-switch-background-color: var(--altcha-color-success);\n}\n[data-state=verified] .altcha-switch-toggle {\n  background-color: var(--altcha-color-success-content);\n  left: calc(100% - var(--altcha-switch-height) + var(--altcha-switch-padding));\n}\n[dir=rtl] .altcha-switch-toggle {\n  left: calc(100% - var(--altcha-switch-height) + var(--altcha-switch-padding));\n}\n[dir=rtl][data-state=verified] .altcha-switch-toggle {\n  left: var(--altcha-switch-padding);\n}\n.altcha-floating-arrow {\n  border: 6px solid transparent;\n  border-bottom-color: var(--altcha-border-color);\n  content: "";\n  height: 0;\n  left: 12px;\n  position: absolute;\n  top: -12px;\n  width: 0;\n}\n.altcha-overlay-backdrop {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity var(--altcha-transition-duration);\n  z-index: var(--altcha-z-index);\n}\n.altcha-overlay-close {\n  display: inline-block;\n  color: currentColor;\n  cursor: pointer;\n  font-size: 1rem;\n  height: 1rem;\n  line-height: 0.85;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  text-shadow: 0 0 1px var(--altcha-color-base);\n  top: -1.5rem;\n  width: 1rem;\n  z-index: var(--altcha-z-index);\n}\n.altcha[data-display=overlay] {\n  animation: altcha-overlay-slidein var(--altcha-transition-duration) forwards;\n  filter: var(--altcha-shadow);\n  left: 50%;\n  opacity: 0;\n  position: fixed;\n  top: 45%;\n  transform: translate(-50%, -50%);\n  z-index: var(--altcha-z-index);\n}\n.altcha[data-display=overlay] .altcha-main {\n  width: var(--altcha-max-width);\n}\n.altcha[data-display=floating] {\n  display: none;\n  filter: var(--altcha-shadow);\n  left: var(--altcha-floating-left, -100%);\n  position: fixed;\n  top: var(--altcha-floating-top, -100%);\n  z-index: var(--altcha-z-index);\n}\n.altcha[data-display=floating] .altcha-main {\n  width: var(--altcha-max-width);\n}\n.altcha[data-display=floating][data-floating-position=top] .altcha-floating-arrow {\n  border-bottom-color: transparent;\n  border-top-color: var(--altcha-border-color);\n  bottom: -12px;\n  top: auto;\n}\n.altcha[data-display=floating][data-visible] {\n  display: flex;\n}\n.altcha[data-display=bar] {\n  bottom: -100%;\n  filter: var(--altcha-shadow);\n  left: 0;\n  position: fixed;\n  right: 0;\n  transition: bottom var(--altcha-transition-duration), top var(--altcha-transition-duration);\n  z-index: var(--altcha-z-index);\n}\n.altcha[data-display=bar] .altcha-main {\n  align-items: center;\n  border-radius: 0;\n  border-width: var(--altcha-border-width) 0 0 0;\n  flex-direction: row;\n  max-width: 100% !important;\n}\n.altcha[data-display=bar] .altcha-main > * {\n  width: auto;\n}\n.altcha[data-display=bar][data-placement=top] {\n  bottom: auto;\n  top: -100%;\n}\n.altcha[data-display=bar][data-placement=top] .altcha-main {\n  border-width: 0 0 var(--altcha-border-width) 0;\n}\n.altcha[data-display=bar][data-placement=bottom]:not([data-state=unverified]) {\n  bottom: 0;\n}\n.altcha[data-display=bar][data-placement=top]:not([data-state=unverified]) {\n  top: 0;\n}\n.altcha[data-display=invisible] {\n  display: none;\n}\n\n@keyframes altcha-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes altcha-bottomsheet-slideup {\n  100% {\n    bottom: 0;\n  }\n}\n@keyframes altcha-overlay-slidein {\n  100% {\n    opacity: 1;\n    top: 50%;\n  }\n}';
injectCss(css);
$altcha.algorithms.set("SHA-256", function () {
  return new WorkerWrapper();
});
$altcha.algorithms.set("SHA-384", function () {
  return new WorkerWrapper();
});
$altcha.algorithms.set("SHA-512", function () {
  return new WorkerWrapper();
});
$altcha.algorithms.set("PBKDF2/SHA-256", function () {
  return new WorkerWrapper$1();
});
$altcha.algorithms.set("PBKDF2/SHA-384", function () {
  return new WorkerWrapper$1();
});
$altcha.algorithms.set("PBKDF2/SHA-512", function () {
  return new WorkerWrapper$1();
});

/***/ }),
/* 364 */
/***/ (function(module, exports) {

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var noop = function noop() {};
function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a !== null && _typeof(a) === "object" || typeof a === "function";
}
function subscribe_to_store(store2, run, invalidate) {
  if (store2 == null) {
    run(void 0);
    return noop;
  }
  var unsub = untrack(function () {
    return store2.subscribe(run,
    // @ts-expect-error
    invalidate);
  });
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}
var subscriber_queue = [];
function writable(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var stop = null;
  var subscribers = /* @__PURE__ */new Set();
  function set(new_value) {
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        var run_queue = !subscriber_queue.length;
        var _iterator = _createForOfIteratorHelper(subscribers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subscriber = _step.value;
            subscriber[1]();
            subscriber_queue.push(subscriber, value);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (run_queue) {
          for (var i = 0; i < subscriber_queue.length; i += 2) {
            subscriber_queue[i][0](subscriber_queue[i + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update(fn) {
    set(fn(/** @type {T} */
    value));
  }
  function subscribe(run) {
    var invalidate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
    var subscriber = [run, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set, update) || noop;
    }
    run(/** @type {T} */
    value);
    return function () {
      subscribers["delete"](subscriber);
      if (subscribers.size === 0 && stop) {
        stop();
        stop = null;
      }
    };
  }
  return {
    set: set,
    update: update,
    subscribe: subscribe
  };
}
function _get(store2) {
  var value;
  subscribe_to_store(store2, function (_) {
    return value = _;
  })();
  return value;
}
var untracking = false;
function untrack(fn) {
  var previous_untracking = untracking;
  try {
    untracking = true;
    return fn();
  } finally {
    untracking = previous_untracking;
  }
}
function store(defaultValue) {
  var scope = {
    get: function get(name) {
      return _get(scope.store)[name];
    },
    set: function set(name, value) {
      if (typeof name === "string") {
        Object.assign(_get(scope.store), _defineProperty({}, name, value));
      } else {
        Object.assign(_get(scope.store), name);
      }
      scope.store.set(_get(scope.store));
    },
    store: writable(defaultValue)
  };
  return scope;
}
globalThis.$altcha = globalThis.$altcha || {
  algorithms: /* @__PURE__ */new Map(),
  defaults: store({}),
  i18n: store({}),
  instances: /* @__PURE__ */new Set(),
  plugins: /* @__PURE__ */new Set()
};
var i18n = {
  ariaLinkLabel: "Altcha (site oficial)",
  enterCode: "Digite o código",
  enterCodeAria: "Digite o código que você ouve. Pressione Espaço para reproduzir o áudio.",
  error: "Falha na verificação. Por favor, tente novamente mais tarde.",
  expired: "Verificação expirada. Por favor, tente novamente.",
  footer: 'Protegido por <a href="https://altcha.org/" tabindex="-1" target="_blank" rel="noopener" aria-label="Altcha (site oficial)">ALTCHA</a>',
  getAudioChallenge: "Obter desafio de áudio",
  label: "Eu não sou um robô",
  loading: "Carregando...",
  reload: "Recarregar",
  verify: "Verificar",
  verificationRequired: "Verificação necessária!",
  verified: "Verificado",
  verifying: "Verificando...",
  waitAlert: "Verificando... por favor aguarde.",
  cancel: "Cancelar",
  enterCodeFromImage: "Para prosseguir, digite o código da imagem abaixo."
};
globalThis.$altcha.i18n.set("pt-br", i18n);

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_initialName__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_icons__ = __webpack_require__(26);



var HeaderNav = function HeaderNav(_ref) {
  var baseURL = _ref.baseURL,
    isAuthenticated = _ref.isAuthenticated,
    isMobile = _ref.isMobile,
    user = _ref.user;
  if (!isAuthenticated || !user) {
    return null;
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "logged_in_header"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "avatar_user_large"
  }, Object(__WEBPACK_IMPORTED_MODULE_1__utils_initialName__["a" /* getUserInitials */])(user.username)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "logged_in_header_text"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, "Ol\xE1, ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, user.name), "!"))), isMobile ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
    className: "nav_menu"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "nav_menu_items"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "items"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat("https://dev.segurospromo.com.br", "/area-do-cliente/"),
    className: "dropdown_item"
  }, "Ver minha conta", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["b" /* ChevronRightIcon */], {
    size: 24,
    color: "#007E47"
  }))))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("nav", {
    className: "nav_menu"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
    className: "nav_menu_items"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "items"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat(baseURL, "/area-do-cliente/meu-perfil"),
    className: "dropdown_item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["j" /* UserIcon */], {
    size: 24,
    color: "#007E47"
  }), "Ver minha conta")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
    className: "items"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat(baseURL, "/area-do-cliente/meus-pedidos"),
    className: "dropdown_item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__assets_icons__["a" /* CartIcon */], {
    size: 24,
    color: "#007E47"
  }), "Meus pedidos")))));
};
/* harmony default export */ __webpack_exports__["a"] = (HeaderNav);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_icons__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoogleLoginButton__ = __webpack_require__(112);



var AlertTriggerLogin = function AlertTriggerLogin(_ref) {
  var baseURL = _ref.baseURL,
    authURL = _ref.authURL,
    refetchUser = _ref.refetchUser;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container_alert_trigger"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container_alert_description"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "text_description"
  }, "Garanta descontos exclusivos e encontre os menores pre\xE7os do mercado!")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container_auth_social"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GoogleLoginButton__["a" /* default */], {
    label: "Acessar com o Google",
    refetchUser: refetchUser
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "".concat(baseURL, "/area-do-cliente/login?redirect=").concat(encodeURIComponent(window.location.href)),
    className: "button_email"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__assets_icons__["d" /* EmailIcon */], null), "Acessar com e-mail"));
};
/* harmony default export */ __webpack_exports__["a"] = (AlertTriggerLogin);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function useCurrentUser() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var fetchUser = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var url, response, data, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          setIsLoading(true);
          setError(null);
          _context.p = 1;
          url = "".concat("https://dev.segurospromo.com.br", "/safearea/api/v1/users/me/");
          _context.n = 2;
          return fetch(url, {
            credentials: 'include'
          });
        case 2:
          response = _context.v;
          if (response.ok) {
            _context.n = 3;
            break;
          }
          throw new Error("Erro ao buscar usu\xE1rio: ".concat(response.status));
        case 3:
          _context.n = 4;
          return response.json();
        case 4:
          data = _context.v;
          setUser(data);
          _context.n = 6;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          setError(_t.message);
          setUser(null);
        case 6:
          _context.p = 6;
          setIsLoading(false);
          return _context.f(6);
        case 7:
          return _context.a(2);
      }
    }, _callee, null, [[1, 5, 6, 7]]);
  })), []);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    fetchUser();
  }, [fetchUser]);
  return {
    user: user,
    isLoading: isLoading,
    error: error,
    refetch: fetchUser
  };
}
/* harmony default export */ __webpack_exports__["a"] = (useCurrentUser);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_searchActions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCalls__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(20);




var filterByLowerPrice = function filterByLowerPrice() {
  Object(__WEBPACK_IMPORTED_MODULE_2__apiCalls__["fetchSortOptionsService"])().then(function (response) {
    var sortOptions = response.sort_options;
    var lowerPriceSlug = sortOptions[1].name;
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_searchActions__["x" /* setSortOption */])(lowerPriceSlug));
  });
};
var manageTags = function manageTags(tags) {
  if (tags.includes('mPrecoAds')) filterByLowerPrice();
};
var managePlansSorting = function managePlansSorting(sortOption) {
  if (!window.location.pathname.includes('pesquisa')) return;
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_searchActions__["x" /* setSortOption */])(sortOption));
};
var manageParams = function manageParams() {
  var _getUrlParams = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["getUrlParams"])(),
    tt = _getUrlParams.tt,
    sortby = _getUrlParams.sortby;
  if (sortby) managePlansSorting(sortby);
  if (tt) manageTags(tt);
};
/* harmony default export */ __webpack_exports__["a"] = (manageParams);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mobileActive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__ = __webpack_require__(9);

var mobileActive = function mobileActive() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actions_actionTypes__["a" /* ACCESS_IS_MOBILE */],
    mobileActive: window.innerWidth <= 768 ? true : false
  };
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return page404; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return page500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorPages_css__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorPages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ErrorPages_css__);
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }


var page404 = function page404(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container-errorpage"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "image-errorpage",
    src: "/assets/images/erro-404.svg",
    alt: ""
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, "Lamentamos, mas n\xE3o tem nada aqui."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Verifique se o endere\xE7o est\xE1 correto ou volte \xE0 home para fazer uma pesquisa.", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "\xC9 muito perigoso viajar por a\xED sem um ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Seguro"), ". ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/",
    className: "btn-voltar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/arrow-left.svg",
    alt: ""
  }), "\xA0Voltar ao in\xEDcio")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Precisa de ajuda?"), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Em caso de d\xFAvidas entre em contato com o nosso atendimento.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "phones"
  }, "4003-8442", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(31) 3972-7083 - WhatsApp"));
};
var page500 = function page500(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "container-errorpage"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    className: "image-errorpage",
    src: "/assets/images/erro-processar-compra.svg",
    alt: ""
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", null, "Lamentamos! Algo saiu errado. "), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Nosso servidor enfrentou algum problema mas j\xE1 estamos trabalhando para corrigir a situa\xE7\xE3o.", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "Por favor, volte ao in\xEDcio e tente novamente em um minuto.", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
    href: "/",
    className: "btn-voltar"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: "/assets/images/arrow-left.svg",
    alt: ""
  }), "\xA0Voltar")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong", null, "Precisa de ajuda?"), " ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "Em caso de d\xFAvidas entre em contato com o nosso atendimento.")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
    className: "phones"
  }, "4003-8442", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), "(31) 3972-7083 - WhatsApp"));
};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GrowthBook; });
/* unused harmony export prefetchPayload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dom_mutator__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_mjs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mjs__ = __webpack_require__(35);
var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }




var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var SDK_VERSION = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["n" /* loadSDKVersion */])();
var GrowthBook = /*#__PURE__*/function () {
  // context is technically private, but some tools depend on it so we can't mangle the name

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  function GrowthBook(options) {
    _classCallCheck(this, GrowthBook);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = this.context = options;
    this._renderer = options.renderer || null;
    this._trackedExperiments = new Set();
    this._completedChangeIds = new Set();
    this._trackedFeatures = {};
    this.debug = !!options.debug;
    this._subscriptions = new Set();
    this._featureUsageSubs = new Set();
    this._customEventSubs = new Set();
    this._experimentViewedSubs = new Set();
    this.ready = false;
    this._assigned = new Map();
    this._activeAutoExperiments = new Map();
    this._triggeredExpKeys = new Set();
    this._initialized = false;
    this._redirectedUrl = "";
    this._deferredTrackingCalls = new Map();
    this._autoExperimentsAllowed = !options.disableExperimentsOnLoad;
    this._destroyCallbacks = [];
    this.logs = [];
    this.log = this.log.bind(this);
    this._saveDeferredTrack = this._saveDeferredTrack.bind(this);
    this._onExperimentEval = this._onExperimentEval.bind(this);
    this._fireSubscriptions = this._fireSubscriptions.bind(this);
    this._recordChangedId = this._recordChangedId.bind(this);
    if (options.remoteEval) {
      if (options.decryptionKey) {
        throw new Error("Encryption is not available for remoteEval");
      }
      if (!options.clientKey) {
        throw new Error("Missing clientKey");
      }
      var isGbHost = false;
      try {
        isGbHost = !!new URL(options.apiHost || "").hostname.match(/growthbook\.io$/i);
      } catch (e) {
        // ignore invalid URLs
      }
      if (isGbHost) {
        throw new Error("Cannot use remoteEval on GrowthBook Cloud");
      }
    } else {
      if (options.cacheKeyAttributes) {
        throw new Error("cacheKeyAttributes are only used for remoteEval");
      }
    }
    if (options.stickyBucketService) {
      var s = options.stickyBucketService;
      this._saveStickyBucketAssignmentDoc = function (doc) {
        return s.saveAssignments(doc);
      };
    }
    if (options.plugins) {
      var _iterator = _createForOfIteratorHelper(options.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin(this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (options.features) {
      this.ready = true;
    }
    if (isBrowser && options.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (options.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    // Hydrate sticky bucket service
    if (this._options.stickyBucketService && this._options.stickyBucketAssignmentDocs) {
      for (var key in this._options.stickyBucketAssignmentDocs) {
        var doc = this._options.stickyBucketAssignmentDocs[key];
        if (doc) {
          this._options.stickyBucketService.saveAssignments(doc)["catch"](function () {
            // Ignore hydration errors
          });
        }
      }
    }

    // Legacy - passing in features/experiments into the constructor instead of using init
    if (this.ready) {
      this.refreshStickyBuckets(this.getPayload());
    }
  }
  return _createClass(GrowthBook, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this._payload = payload;
              _context.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["a" /* decryptPayload */])(payload, this._options.decryptionKey);
            case 1:
              data = _context.v;
              this._decryptedPayload = data;
              _context.n = 2;
              return this.refreshStickyBuckets(data);
            case 2:
              if (data.features) {
                this._options.features = data.features;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              if (data.contextualBandits) {
                this._options.contextualBandits = data.contextualBandits;
              }
              if (data.experiments) {
                this._options.experiments = data.experiments;
                this._updateAllAutoExperiments();
              }
              this.ready = true;
              this._render();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      this._initialized = true;
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      if (this._options.stickyBucketService && !this._options.stickyBucketAssignmentDocs) {
        this._options.stickyBucketAssignmentDocs = this.generateStickyBucketAssignmentDocsSync(this._options.stickyBucketService, payload);
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._options.features = payload.features;
      }
      if (payload.savedGroups) {
        this._options.savedGroups = payload.savedGroups;
      }
      if (payload.contextualBandits) {
        this._options.contextualBandits = payload.contextualBandits;
      }
      if (payload.experiments) {
        this._options.experiments = payload.experiments;
        this._updateAllAutoExperiments();
      }
      this.ready = true;
      Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this._initialized = true;
              options = options || {};
              if (options.cacheSettings) {
                Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["b" /* configureCache */])(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.setPayload(options.payload);
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
              return _context2.a(2, {
                success: true,
                source: "init"
              });
            case 2:
              _context2.n = 3;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 3:
              _yield$this$_refresh = _context2.v;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
              _context2.n = 4;
              return this.setPayload(data || {});
            case 4:
              return _context2.a(2, res);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }() /** @deprecated Use {@link init} */
  }, {
    key: "loadFeatures",
    value: (function () {
      var _loadFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var _this$_options$backgr;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              options = options || {};
              _context3.n = 1;
              return this.init({
                skipCache: options.skipCache,
                timeout: options.timeout,
                streaming: ((_this$_options$backgr = this._options.backgroundSync) !== null && _this$_options$backgr !== void 0 ? _this$_options$backgr : true) && (options.autoRefresh || this._options.subscribeToChanges)
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadFeatures(_x3) {
        return _loadFeatures.apply(this, arguments);
      }
      return loadFeatures;
    }())
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(options) {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 1:
              res = _context4.v;
              if (!res.data) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return this.setPayload(res.data);
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function refreshFeatures(_x4) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["d" /* getApiHosts */])(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this.getExperiments()
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "isRemoteEval",
    value: function isRemoteEval() {
      return this._options.remoteEval || false;
    }
  }, {
    key: "getCacheKeyAttributes",
    value: function getCacheKeyAttributes() {
      return this._options.cacheKeyAttributes;
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref) {
        var _ref2;
        var timeout, skipCache, allowStale, streaming;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context5.n = 1;
                break;
              }
              throw new Error("Missing clientKey");
            case 1:
              return _context5.a(2, Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["c" /* refreshFeatures */])({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: (_ref2 = streaming !== null && streaming !== void 0 ? streaming : this._options.backgroundSync) !== null && _ref2 !== void 0 ? _ref2 : true
              }));
          }
        }, _callee5, this);
      }));
      function _refresh(_x5) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "_render",
    value: function _render() {
      if (this._renderer) {
        try {
          this._renderer();
        } catch (e) {
          console.error("Failed to render", e);
        }
      }
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this._options.features = features;
      this.ready = true;
      this._render();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedFeatures",
    value: (function () {
      var _setEncryptedFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(encryptedString, decryptionKey, subtle) {
        var featuresJSON;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 1:
              featuresJSON = _context6.v;
              this.setFeatures(JSON.parse(featuresJSON));
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function setEncryptedFeatures(_x6, _x7, _x8) {
        return _setEncryptedFeatures.apply(this, arguments);
      }
      return setEncryptedFeatures;
    }() /** @deprecated Use {@link setPayload} */)
  }, {
    key: "setExperiments",
    value: function setExperiments(experiments) {
      this._options.experiments = experiments;
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedExperiments",
    value: (function () {
      var _setEncryptedExperiments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(encryptedString, decryptionKey, subtle) {
        var experimentsJSON;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["b" /* decrypt */])(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 1:
              experimentsJSON = _context7.v;
              this.setExperiments(JSON.parse(experimentsJSON));
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function setEncryptedExperiments(_x9, _x0, _x1) {
        return _setEncryptedExperiments.apply(this, arguments);
      }
      return setEncryptedExperiments;
    }())
  }, {
    key: "setAttributes",
    value: function () {
      var _setAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(attributes) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              this._options.attributes = attributes;
              if (!this._options.stickyBucketService) {
                _context8.n = 1;
                break;
              }
              _context8.n = 1;
              return this.refreshStickyBuckets();
            case 1:
              if (!this._options.remoteEval) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              return _context8.a(2);
            case 3:
              this._render();
              this._updateAllAutoExperiments();
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function setAttributes(_x10) {
        return _setAttributes.apply(this, arguments);
      }
      return setAttributes;
    }()
  }, {
    key: "updateAttributes",
    value: function () {
      var _updateAttributes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(attributes) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              return _context9.a(2, this.setAttributes(_objectSpread(_objectSpread({}, this._options.attributes), attributes)));
          }
        }, _callee9, this);
      }));
      function updateAttributes(_x11) {
        return _updateAttributes.apply(this, arguments);
      }
      return updateAttributes;
    }()
  }, {
    key: "setAttributeOverrides",
    value: function () {
      var _setAttributeOverrides = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(overrides) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              this._options.attributeOverrides = overrides;
              if (!this._options.stickyBucketService) {
                _context0.n = 1;
                break;
              }
              _context0.n = 1;
              return this.refreshStickyBuckets();
            case 1:
              if (!this._options.remoteEval) {
                _context0.n = 3;
                break;
              }
              _context0.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              return _context0.a(2);
            case 3:
              this._render();
              this._updateAllAutoExperiments();
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function setAttributeOverrides(_x12) {
        return _setAttributeOverrides.apply(this, arguments);
      }
      return setAttributeOverrides;
    }()
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(vars) {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this._options.forcedVariations = vars || {};
              if (!this._options.remoteEval) {
                _context1.n = 2;
                break;
              }
              _context1.n = 1;
              return this._refreshForRemoteEval();
            case 1:
              return _context1.a(2);
            case 2:
              this._render();
              this._updateAllAutoExperiments();
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function setForcedVariations(_x13) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._options.forcedFeatureValues = map;
      this._render();
    }
  }, {
    key: "setURL",
    value: function () {
      var _setURL = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(url) {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!(url === this._options.url)) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              this._options.url = url;
              this._redirectedUrl = "";
              if (!this._options.remoteEval) {
                _context10.n = 3;
                break;
              }
              _context10.n = 2;
              return this._refreshForRemoteEval();
            case 2:
              this._updateAllAutoExperiments(true);
              return _context10.a(2);
            case 3:
              this._updateAllAutoExperiments(true);
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function setURL(_x14) {
        return _setURL.apply(this, arguments);
      }
      return setURL;
    }()
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread(_objectSpread({}, this._options.attributes), this._options.attributeOverrides);
    }
  }, {
    key: "getForcedVariations",
    value: function getForcedVariations() {
      return this._options.forcedVariations || {};
    }
  }, {
    key: "getForcedFeatures",
    value: function getForcedFeatures() {
      // eslint-disable-next-line
      return this._options.forcedFeatureValues || new Map();
    }
  }, {
    key: "getStickyBucketAssignmentDocs",
    value: function getStickyBucketAssignmentDocs() {
      return this._options.stickyBucketAssignmentDocs || {};
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return this._options.url || "";
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._options.features || {};
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      return this._options.experiments || [];
    }
  }, {
    key: "getCompletedChangeIds",
    value: function getCompletedChangeIds() {
      return Array.from(this._completedChangeIds);
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this._subscriptions.add(cb);
      return function () {
        _this._subscriptions["delete"](cb);
      };
    }

    // Internal — first-party plugin use only.
    // Currently singleton-only. UserScopedGrowthBook could use the same signatures;
    // GrowthBookClient would need UserContext in callbacks to identify the user.
    // Fires on deduped feature value changes (not every evalFeature call). Overrides excluded.
    // One of three plugin streams: feature usage, experiment assignments (_subscribeExperimentViewed), custom events.
  }, {
    key: "_subscribeFeatureUsage",
    value: function _subscribeFeatureUsage(cb) {
      var _this2 = this;
      this._featureUsageSubs.add(cb);
      return function () {
        return _this2._featureUsageSubs["delete"](cb);
      };
    }

    // Internal — first-party plugin use only.
    // Fires once per deduped experiment assignment, alongside (not instead of) trackingCallback.
  }, {
    key: "_subscribeExperimentViewed",
    value: function _subscribeExperimentViewed(cb) {
      var _this3 = this;
      this._experimentViewedSubs.add(cb);
      return function () {
        return _this3._experimentViewedSubs["delete"](cb);
      };
    }

    // Internal — first-party plugin use only.
    // Fires for explicit logEvent() calls only, not SDK-internal events.
  }, {
    key: "_subscribeCustomEvents",
    value: function _subscribeCustomEvents(cb) {
      var _this4 = this;
      this._customEventSubs.add(cb);
      return function () {
        return _this4._customEventSubs["delete"](cb);
      };
    }
  }, {
    key: "_refreshForRemoteEval",
    value: function () {
      var _refreshForRemoteEval2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (this._options.remoteEval) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              if (this._initialized) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2);
            case 2:
              _context11.n = 3;
              return this._refresh({
                allowStale: false
              });
            case 3:
              res = _context11.v;
              if (!res.data) {
                _context11.n = 4;
                break;
              }
              _context11.n = 4;
              return this.setPayload(res.data);
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function _refreshForRemoteEval() {
        return _refreshForRemoteEval2.apply(this, arguments);
      }
      return _refreshForRemoteEval;
    }()
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this._assigned);
    }
  }, {
    key: "onDestroy",
    value: function onDestroy(cb) {
      this._destroyCallbacks.push(cb);
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return !!this._destroyed;
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      options = options || {};
      this._destroyed = true;

      // Custom callbacks
      // Do this first in case it needs access to the below data that is cleared
      this._destroyCallbacks.forEach(function (cb) {
        try {
          cb();
        } catch (e) {
          console.error(e);
        }
      });

      // Release references to save memory
      this._subscriptions.clear();
      this._featureUsageSubs.clear();
      this._customEventSubs.clear();
      this._experimentViewedSubs.clear();
      this._assigned.clear();
      this._trackedExperiments.clear();
      this._completedChangeIds.clear();
      this._deferredTrackingCalls.clear();
      this._trackedFeatures = {};
      this._destroyCallbacks = [];
      this._payload = undefined;
      this._saveStickyBucketAssignmentDoc = undefined;
      Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["e" /* unsubscribe */])(this);
      if (options.destroyAllStreams) {
        Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["a" /* clearAutoRefresh */])();
      }
      this.logs = [];
      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }

      // Undo any active auto experiments
      this._activeAutoExperiments.forEach(function (exp) {
        exp.undo();
      });
      this._activeAutoExperiments.clear();
      this._triggeredExpKeys.clear();
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this._options.forcedVariations = this._options.forcedVariations || {};
      this._options.forcedVariations[key] = variation;
      if (this._options.remoteEval) {
        this._refreshForRemoteEval();
        return;
      }
      this._updateAllAutoExperiments();
      this._render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var _runExperiment = Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["j" /* runExperiment */])(experiment, null, this._getEvalContext()),
        result = _runExperiment.result;
      this._onExperimentEval(experiment, result);
      return result;
    }
  }, {
    key: "triggerExperiment",
    value: function triggerExperiment(key) {
      var _this5 = this;
      this._triggeredExpKeys.add(key);
      if (!this._options.experiments) return null;
      var experiments = this._options.experiments.filter(function (exp) {
        return exp.key === key;
      });
      return experiments.map(function (exp) {
        return _this5._runAutoExperiment(exp);
      }).filter(function (res) {
        return res !== null;
      });
    }
  }, {
    key: "triggerAutoExperiments",
    value: function triggerAutoExperiments() {
      this._autoExperimentsAllowed = true;
      this._updateAllAutoExperiments(true);
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext() {
      return {
        user: this._getUserContext(),
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getUserContext",
    value: function _getUserContext() {
      return {
        attributes: this._options.user ? _objectSpread(_objectSpread({}, this._options.user), this._options.attributes) : this._options.attributes,
        enableDevMode: this._options.enableDevMode,
        blockedChangeIds: this._options.blockedChangeIds,
        stickyBucketAssignmentDocs: this._options.stickyBucketAssignmentDocs,
        url: this._getContextUrl(),
        forcedVariations: this._options.forcedVariations,
        forcedFeatureValues: this._options.forcedFeatureValues,
        attributeOverrides: this._options.attributeOverrides,
        saveStickyBucketAssignmentDoc: this._saveStickyBucketAssignmentDoc,
        trackingCallback: this._options.trackingCallback,
        onFeatureUsage: this._options.onFeatureUsage,
        devLogs: this.logs,
        featureUsageSubs: this._featureUsageSubs,
        experimentViewedSubs: this._experimentViewedSubs,
        trackedExperiments: this._trackedExperiments,
        trackedFeatureUsage: this._trackedFeatures
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._options.features,
        experiments: this._options.experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        contextualBandits: this._options.contextualBandits,
        groups: this._options.groups,
        overrides: this._options.overrides,
        onExperimentEval: this._onExperimentEval,
        recordChangeId: this._recordChangedId,
        saveDeferredTrack: this._saveDeferredTrack,
        eventLogger: this._options.eventLogger
      };
    }
  }, {
    key: "_runAutoExperiment",
    value: function _runAutoExperiment(experiment, forceRerun) {
      var _this6 = this;
      var existing = this._activeAutoExperiments.get(experiment);

      // If this is a manual experiment and it's not already running, skip
      if (experiment.manual && !this._triggeredExpKeys.has(experiment.key) && !existing) return null;

      // Check if this particular experiment is blocked by options settings
      // For example, if all visualEditor experiments are disabled
      var isBlocked = this._isAutoExperimentBlockedByContext(experiment);
      if (isBlocked) {
        "production" !== "production" && this.log("Auto experiment blocked", {
          id: experiment.key
        });
      }
      var result;
      var trackingCall;
      // Run the experiment (if blocked exclude)
      if (isBlocked) {
        result = Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["f" /* getExperimentResult */])(this._getEvalContext(), experiment, -1, false, "");
      } else {
        var _runExperiment2 = Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["j" /* runExperiment */])(experiment, null, this._getEvalContext());
        result = _runExperiment2.result;
        trackingCall = _runExperiment2.trackingCall;
        this._onExperimentEval(experiment, result);
      }

      // A hash to quickly tell if the assigned value changed
      var valueHash = JSON.stringify(result.value);

      // If the changes are already active, no need to re-apply them
      if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
        return result;
      }

      // Undo any existing changes
      if (existing) this._undoActiveAutoExperiment(experiment);

      // Apply new changes
      if (result.inExperiment) {
        var changeType = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["c" /* getAutoExperimentChangeType */])(experiment);
        if (changeType === "redirect" && result.value.urlRedirect && experiment.urlPatterns) {
          var url = experiment.persistQueryString ? Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["o" /* mergeQueryStrings */])(this._getContextUrl(), result.value.urlRedirect) : result.value.urlRedirect;
          if (Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["m" /* isURLTargeted */])(url, experiment.urlPatterns)) {
            this.log("Skipping redirect because original URL matches redirect URL", {
              id: experiment.key
            });
            return result;
          }
          this._redirectedUrl = url;
          var _this$_getNavigateFun = this._getNavigateFunction(),
            navigate = _this$_getNavigateFun.navigate,
            delay = _this$_getNavigateFun.delay;
          if (navigate) {
            if (isBrowser) {
              var _this$_options$maxNav;
              // Wait for the possibly-async tracking callback, bound by min and max delays
              Promise.all([].concat(_toConsumableArray(trackingCall ? [Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["q" /* promiseTimeout */])(trackingCall, (_this$_options$maxNav = this._options.maxNavigateDelay) !== null && _this$_options$maxNav !== void 0 ? _this$_options$maxNav : 1000)] : []), [new Promise(function (resolve) {
                var _this6$_options$navig;
                return window.setTimeout(resolve, (_this6$_options$navig = _this6._options.navigateDelay) !== null && _this6$_options$navig !== void 0 ? _this6$_options$navig : delay);
              })])).then(function () {
                try {
                  navigate(url);
                } catch (e) {
                  console.error(e);
                }
              });
            } else {
              try {
                navigate(url);
              } catch (e) {
                console.error(e);
              }
            }
          }
        } else if (changeType === "visual") {
          var undo = this._options.applyDomChangesCallback ? this._options.applyDomChangesCallback(result.value) : this._applyDOMChanges(result.value);
          if (undo) {
            this._activeAutoExperiments.set(experiment, {
              undo: undo,
              valueHash: valueHash
            });
          }
        }
      }
      return result;
    }
  }, {
    key: "_undoActiveAutoExperiment",
    value: function _undoActiveAutoExperiment(exp) {
      var data = this._activeAutoExperiments.get(exp);
      if (data) {
        data.undo();
        this._activeAutoExperiments["delete"](exp);
      }
    }
  }, {
    key: "_updateAllAutoExperiments",
    value: function _updateAllAutoExperiments(forceRerun) {
      var _this7 = this;
      if (!this._autoExperimentsAllowed) return;
      var experiments = this._options.experiments || [];

      // Stop any experiments that are no longer defined
      var keys = new Set(experiments);
      this._activeAutoExperiments.forEach(function (v, k) {
        if (!keys.has(k)) {
          v.undo();
          _this7._activeAutoExperiments["delete"](k);
        }
      });

      // Re-run all new/updated experiments
      var _iterator2 = _createForOfIteratorHelper(experiments),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var exp = _step2.value;
          var result = this._runAutoExperiment(exp, forceRerun);

          // Once you're in a redirect experiment, break out of the loop and don't run any further experiments
          if (result && result.inExperiment && Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["c" /* getAutoExperimentChangeType */])(exp) === "redirect") {
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_onExperimentEval",
    value: function _onExperimentEval(experiment, result) {
      var prev = this._assigned.get(experiment.key);
      this._assigned.set(experiment.key, {
        experiment: experiment,
        result: result
      });
      if (this._subscriptions.size > 0) {
        this._fireSubscriptions(experiment, result, prev);
      }
    }
  }, {
    key: "_fireSubscriptions",
    value: function _fireSubscriptions(experiment, result,
    // eslint-disable-next-line
    prev) {
      // If assigned variation has changed, fire subscriptions
      // TODO: what if the experiment definition has changed?
      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this._subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "_recordChangedId",
    value: function _recordChangedId(id) {
      this._completedChangeIds.add(id);
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var value = this.evalFeature(key).value;
      return value === null ? defaultValue : value;
    }

    /**
     * @deprecated Use {@link evalFeature}
     * @param id
     */
  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["b" /* evalFeature */])(id, this._getEvalContext());
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "getDeferredTrackingCalls",
    value: function getDeferredTrackingCalls() {
      return Array.from(this._deferredTrackingCalls.values());
    }
  }, {
    key: "setDeferredTrackingCalls",
    value: function setDeferredTrackingCalls(calls) {
      this._deferredTrackingCalls = new Map(calls.filter(function (c) {
        return c && c.experiment && c.result;
      }).map(function (c) {
        return [Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["e" /* getExperimentDedupeKey */])(c.experiment, c.result), c];
      }));
    }
  }, {
    key: "fireDeferredTrackingCalls",
    value: function () {
      var _fireDeferredTrackingCalls = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _this8 = this;
        var promises;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (this._options.trackingCallback) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              promises = [];
              this._deferredTrackingCalls.forEach(function (call) {
                if (!call || !call.experiment || !call.result) {
                  console.error("Invalid deferred tracking call", {
                    call: call
                  });
                } else {
                  promises.push(_this8._options.trackingCallback(call.experiment, call.result, call.user));
                }
              });
              this._deferredTrackingCalls.clear();
              _context12.n = 2;
              return Promise.all(promises);
            case 2:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function fireDeferredTrackingCalls() {
        return _fireDeferredTrackingCalls.apply(this, arguments);
      }
      return fireDeferredTrackingCalls;
    }()
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
      this.fireDeferredTrackingCalls();
    }
  }, {
    key: "setFeatureUsageCallback",
    value: function setFeatureUsageCallback(callback) {
      this._options.onFeatureUsage = callback;
    }
  }, {
    key: "setEventLogger",
    value: function setEventLogger(logger) {
      this._options.eventLogger = logger;
    }
  }, {
    key: "logEvent",
    value: function () {
      var _logEvent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(eventName, properties) {
        var _t;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              if (!this._destroyed) {
                _context13.n = 1;
                break;
              }
              console.error("Cannot log event to destroyed GrowthBook instance");
              return _context13.a(2);
            case 1:
              if (this._options.enableDevMode) {
                this.logs.push({
                  eventName: eventName,
                  properties: properties,
                  timestamp: Date.now().toString(),
                  logType: "event"
                });
              }
              if (this._customEventSubs.size) {
                this._customEventSubs.forEach(function (cb) {
                  try {
                    cb(eventName, properties || {});
                  } catch (e) {
                    console.error(e);
                  }
                });
              }
              if (!this._options.eventLogger) {
                _context13.n = 6;
                break;
              }
              _context13.p = 2;
              _context13.n = 3;
              return this._options.eventLogger(eventName, properties || {}, Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["i" /* getTrackingUserContext */])(this._getUserContext()));
            case 3:
              _context13.n = 5;
              break;
            case 4:
              _context13.p = 4;
              _t = _context13.v;
              console.error(_t);
            case 5:
              _context13.n = 7;
              break;
            case 6:
              console.error("No event logger configured");
            case 7:
              return _context13.a(2);
          }
        }, _callee13, this, [[2, 4]]);
      }));
      function logEvent(_x15, _x16) {
        return _logEvent.apply(this, arguments);
      }
      return logEvent;
    }()
  }, {
    key: "_saveDeferredTrack",
    value: function _saveDeferredTrack(data) {
      this._deferredTrackingCalls.set(Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["e" /* getExperimentDedupeKey */])(data.experiment, data.result), data);
    }
  }, {
    key: "_getContextUrl",
    value: function _getContextUrl() {
      return this._options.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "_isAutoExperimentBlockedByContext",
    value: function _isAutoExperimentBlockedByContext(experiment) {
      var changeType = Object(__WEBPACK_IMPORTED_MODULE_1__util_mjs__["c" /* getAutoExperimentChangeType */])(experiment);
      if (changeType === "visual") {
        if (this._options.disableVisualExperiments) return true;
        if (this._options.disableJsInjection) {
          if (experiment.variations.some(function (v) {
            return v.js;
          })) {
            return true;
          }
        }
      } else if (changeType === "redirect") {
        if (this._options.disableUrlRedirectExperiments) return true;

        // Validate URLs
        try {
          var current = new URL(this._getContextUrl());
          var _iterator3 = _createForOfIteratorHelper(experiment.variations),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var v = _step3.value;
              if (!v || !v.urlRedirect) continue;
              var url = new URL(v.urlRedirect);

              // If we're blocking cross origin redirects, block if the protocol or host is different
              if (this._options.disableCrossOriginUrlRedirectExperiments) {
                if (url.protocol !== current.protocol) return true;
                if (url.host !== current.host) return true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } catch (e) {
          // Problem parsing one of the URLs
          this.log("Error parsing current or redirect URL", {
            id: experiment.key,
            error: e
          });
          return true;
        }
      } else {
        // Block any unknown changeTypes
        return true;
      }
      if (experiment.changeId && (this._options.blockedChangeIds || []).includes(experiment.changeId)) {
        return true;
      }
      return false;
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl() {
      return this._redirectedUrl;
    }
  }, {
    key: "_getNavigateFunction",
    value: function _getNavigateFunction() {
      if (this._options.navigate) {
        return {
          navigate: this._options.navigate,
          delay: 0
        };
      } else if (isBrowser) {
        return {
          navigate: function navigate(url) {
            window.location.replace(url);
          },
          delay: 100
        };
      }
      return {
        navigate: null,
        delay: 0
      };
    }
  }, {
    key: "_applyDOMChanges",
    value: function _applyDOMChanges(changes) {
      if (!isBrowser) return;
      var undo = [];
      if (changes.css) {
        var s = document.createElement("style");
        s.innerHTML = changes.css;
        document.head.appendChild(s);
        undo.push(function () {
          return s.remove();
        });
      }
      if (changes.js) {
        var script = document.createElement("script");
        script.innerHTML = changes.js;
        if (this._options.jsInjectionNonce) {
          script.nonce = this._options.jsInjectionNonce;
        }
        document.head.appendChild(script);
        undo.push(function () {
          return script.remove();
        });
      }
      if (changes.domMutations) {
        changes.domMutations.forEach(function (mutation) {
          undo.push(__WEBPACK_IMPORTED_MODULE_0_dom_mutator__["a" /* default */].declarative(mutation).revert);
        });
      }
      return function () {
        undo.forEach(function (fn) {
          return fn();
        });
      };
    }
  }, {
    key: "refreshStickyBuckets",
    value: function () {
      var _refreshStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(data) {
        var ctx, docs;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              if (!this._options.stickyBucketService) {
                _context14.n = 2;
                break;
              }
              ctx = this._getEvalContext();
              _context14.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["c" /* getAllStickyBucketAssignmentDocs */])(ctx, this._options.stickyBucketService, data);
            case 1:
              docs = _context14.v;
              this._options.stickyBucketAssignmentDocs = docs;
            case 2:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function refreshStickyBuckets(_x17) {
        return _refreshStickyBuckets.apply(this, arguments);
      }
      return refreshStickyBuckets;
    }()
  }, {
    key: "generateStickyBucketAssignmentDocsSync",
    value: function generateStickyBucketAssignmentDocsSync(stickyBucketService, payload) {
      if (!("getAllAssignmentsSync" in stickyBucketService)) {
        console.error("generating StickyBucketAssignmentDocs docs requires StickyBucketServiceSync");
        return;
      }
      var ctx = this._getEvalContext();
      var attributes = Object(__WEBPACK_IMPORTED_MODULE_3__core_mjs__["h" /* getStickyBucketAttributes */])(ctx, payload);
      return stickyBucketService.getAllAssignmentsSync(attributes);
    }
  }, {
    key: "inDevMode",
    value: function inDevMode() {
      return !!this._options.enableDevMode;
    }
  }]);
}();
function prefetchPayload(_x18) {
  return _prefetchPayload.apply(this, arguments);
}
function _prefetchPayload() {
  _prefetchPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(options) {
    var instance;
    return _regenerator().w(function (_context15) {
      while (1) switch (_context15.n) {
        case 0:
          // Create a temporary instance, just to fetch the payload
          instance = new GrowthBook(options);
          _context15.n = 1;
          return Object(__WEBPACK_IMPORTED_MODULE_2__feature_repository_mjs__["c" /* refreshFeatures */])({
            instance: instance,
            skipCache: options.skipCache,
            allowStale: false,
            backgroundSync: options.streaming
          });
        case 1:
          instance.destroy();
        case 2:
          return _context15.a(2);
      }
    }, _callee15);
  }));
  return _prefetchPayload.apply(this, arguments);
}

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export connectGlobalObserver */
/* unused harmony export disconnectGlobalObserver */
/* unused harmony export validAttributeName */
var validAttributeName = /^[a-zA-Z:_][a-zA-Z0-9:_.-]*$/;
var nullController = {
  revert: function revert() {}
};
var elements = /*#__PURE__*/new Map();
var mutations = /*#__PURE__*/new Set();

function getObserverInit(attr) {
  return attr === 'html' ? {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  } : {
    childList: false,
    subtree: false,
    attributes: true,
    attributeFilter: [attr]
  };
}

function getElementRecord(element) {
  var record = elements.get(element);

  if (!record) {
    record = {
      element: element,
      attributes: {}
    };
    elements.set(element, record);
  }

  return record;
}

function createElementPropertyRecord(el, attr, getCurrentValue, setValue, mutationRunner) {
  var currentValue = getCurrentValue(el);
  var record = {
    isDirty: false,
    originalValue: currentValue,
    virtualValue: currentValue,
    mutations: [],
    el: el,
    _positionTimeout: null,
    observer: new MutationObserver(function () {
      // enact a 1 second timeout that blocks subsequent firing of the
      // observer until the timeout is complete. This will prevent multiple
      // mutations from firing in quick succession, which can cause the
      // mutation to be reverted before the DOM has a chance to update.
      if (attr === 'position' && record._positionTimeout) return;else if (attr === 'position') record._positionTimeout = setTimeout(function () {
        record._positionTimeout = null;
      }, 1000);
      var currentValue = getCurrentValue(el);
      if (attr === 'position' && currentValue.parentNode === record.virtualValue.parentNode && currentValue.insertBeforeNode === record.virtualValue.insertBeforeNode) return;
      if (currentValue === record.virtualValue) return;
      record.originalValue = currentValue;
      mutationRunner(record);
    }),
    mutationRunner: mutationRunner,
    setValue: setValue,
    getCurrentValue: getCurrentValue
  };

  if (attr === 'position' && el.parentNode) {
    record.observer.observe(el.parentNode, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
  } else {
    record.observer.observe(el, getObserverInit(attr));
  }

  return record;
}

function queueIfNeeded(val, record) {
  var currentVal = record.getCurrentValue(record.el);
  record.virtualValue = val;

  if (val && typeof val !== 'string') {
    if (!currentVal || val.parentNode !== currentVal.parentNode || val.insertBeforeNode !== currentVal.insertBeforeNode) {
      record.isDirty = true;
      runDOMUpdates();
    }
  } else if (val !== currentVal) {
    record.isDirty = true;
    runDOMUpdates();
  }
}

function htmlMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(getTransformedHTML(val), record);
}

function classMutationRunner(record) {
  var val = new Set(record.originalValue.split(/\s+/).filter(Boolean));
  record.mutations.forEach(function (m) {
    return m.mutate(val);
  });
  queueIfNeeded(Array.from(val).filter(Boolean).join(' '), record);
}

function attrMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(val, record);
}

function _loadDOMNodes(_ref) {
  var parentSelector = _ref.parentSelector,
      insertBeforeSelector = _ref.insertBeforeSelector;
  var parentNode = document.querySelector(parentSelector);
  if (!parentNode) return null;
  var insertBeforeNode = insertBeforeSelector ? document.querySelector(insertBeforeSelector) : null;
  if (insertBeforeSelector && !insertBeforeNode) return null;
  return {
    parentNode: parentNode,
    insertBeforeNode: insertBeforeNode
  };
}

function positionMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    var selectors = m.mutate();

    var newNodes = _loadDOMNodes(selectors);

    val = newNodes || val;
  });
  queueIfNeeded(val, record);
}

var getHTMLValue = function getHTMLValue(el) {
  return el.innerHTML;
};

var setHTMLValue = function setHTMLValue(el, value) {
  return el.innerHTML = value;
};

function getElementHTMLRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.html) {
    elementRecord.html = createElementPropertyRecord(element, 'html', getHTMLValue, setHTMLValue, htmlMutationRunner);
  }

  return elementRecord.html;
}

var getElementPosition = function getElementPosition(el) {
  return {
    parentNode: el.parentElement,
    insertBeforeNode: el.nextElementSibling
  };
};

var setElementPosition = function setElementPosition(el, value) {
  if (value.insertBeforeNode && !value.parentNode.contains(value.insertBeforeNode)) {
    // skip position mutation - insertBeforeNode not a child of parent. happens
    // when mutation observer for indvidual element fires out of order
    return;
  }

  value.parentNode.insertBefore(el, value.insertBeforeNode);
};

function getElementPositionRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.position) {
    elementRecord.position = createElementPropertyRecord(element, 'position', getElementPosition, setElementPosition, positionMutationRunner);
  }

  return elementRecord.position;
}

var setClassValue = function setClassValue(el, val) {
  return val ? el.className = val : el.removeAttribute('class');
};

var getClassValue = function getClassValue(el) {
  return el.className;
};

function getElementClassRecord(el) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.classes) {
    elementRecord.classes = createElementPropertyRecord(el, 'class', getClassValue, setClassValue, classMutationRunner);
  }

  return elementRecord.classes;
}

var getAttrValue = function getAttrValue(attrName) {
  return function (el) {
    var _el$getAttribute;

    return (_el$getAttribute = el.getAttribute(attrName)) != null ? _el$getAttribute : null;
  };
};

var setAttrValue = function setAttrValue(attrName) {
  return function (el, val) {
    return val !== null ? el.setAttribute(attrName, val) : el.removeAttribute(attrName);
  };
};

function getElementAttributeRecord(el, attr) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.attributes[attr]) {
    elementRecord.attributes[attr] = createElementPropertyRecord(el, attr, getAttrValue(attr), setAttrValue(attr), attrMutationRunner);
  }

  return elementRecord.attributes[attr];
}

function deleteElementPropertyRecord(el, attr) {
  var element = elements.get(el);
  if (!element) return;

  if (attr === 'html') {
    var _element$html, _element$html$observe;

    (_element$html = element.html) == null ? void 0 : (_element$html$observe = _element$html.observer) == null ? void 0 : _element$html$observe.disconnect();
    delete element.html;
  } else if (attr === 'class') {
    var _element$classes, _element$classes$obse;

    (_element$classes = element.classes) == null ? void 0 : (_element$classes$obse = _element$classes.observer) == null ? void 0 : _element$classes$obse.disconnect();
    delete element.classes;
  } else if (attr === 'position') {
    var _element$position, _element$position$obs;

    (_element$position = element.position) == null ? void 0 : (_element$position$obs = _element$position.observer) == null ? void 0 : _element$position$obs.disconnect();
    delete element.position;
  } else {
    var _element$attributes, _element$attributes$a, _element$attributes$a2;

    (_element$attributes = element.attributes) == null ? void 0 : (_element$attributes$a = _element$attributes[attr]) == null ? void 0 : (_element$attributes$a2 = _element$attributes$a.observer) == null ? void 0 : _element$attributes$a2.disconnect();
    delete element.attributes[attr];
  }
}

var transformContainer;

function getTransformedHTML(html) {
  if (!transformContainer) {
    transformContainer = document.createElement('div');
  }

  transformContainer.innerHTML = html;
  return transformContainer.innerHTML;
}

function setPropertyValue(el, attr, m) {
  if (!m.isDirty) return;
  m.isDirty = false;
  var val = m.virtualValue;

  if (!m.mutations.length) {
    deleteElementPropertyRecord(el, attr);
  }

  m.setValue(el, val);
}

function setValue(m, el) {
  m.html && setPropertyValue(el, 'html', m.html);
  m.classes && setPropertyValue(el, 'class', m.classes);
  m.position && setPropertyValue(el, 'position', m.position);
  Object.keys(m.attributes).forEach(function (attr) {
    setPropertyValue(el, attr, m.attributes[attr]);
  });
}

function runDOMUpdates() {
  elements.forEach(setValue);
} // find or create ElementPropertyRecord, add mutation to it, then run


function startMutating(mutation, element) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(element);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(element);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(element, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(element);
  }

  if (!record) return;
  record.mutations.push(mutation);
  record.mutationRunner(record);
} // get (existing) ElementPropertyRecord, remove mutation from it, then run


function stopMutating(mutation, el) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(el);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(el);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(el, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(el);
  }

  if (!record) return;
  var index = record.mutations.indexOf(mutation);
  if (index !== -1) record.mutations.splice(index, 1);
  record.mutationRunner(record);
} // maintain list of elements associated with mutation


function refreshElementsSet(mutation) {
  // if a position mutation has already found an element to move, don't move
  // any more elements
  if (mutation.kind === 'position' && mutation.elements.size === 1) return;
  var existingElements = new Set(mutation.elements);
  var matchingElements = document.querySelectorAll(mutation.selector);
  matchingElements.forEach(function (el) {
    if (!existingElements.has(el)) {
      mutation.elements.add(el);
      startMutating(mutation, el);
    }
  });
}

function revertMutation(mutation) {
  mutation.elements.forEach(function (el) {
    return stopMutating(mutation, el);
  });
  mutation.elements.clear();
  mutations["delete"](mutation);
}

function refreshAllElementSets() {
  mutations.forEach(refreshElementsSet);
} // Observer for elements that don't exist in the DOM yet


var observer;
function disconnectGlobalObserver() {
  observer && observer.disconnect();
}
function connectGlobalObserver() {
  if (typeof document === 'undefined') return;

  if (!observer) {
    observer = new MutationObserver(function () {
      refreshAllElementSets();
    });
  }

  refreshAllElementSets();
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
} // run on init

connectGlobalObserver();

function newMutation(m) {
  // Not in a browser
  if (typeof document === 'undefined') return nullController; // add to global index of mutations

  mutations.add(m); // run refresh on init to establish list of elements associated w/ mutation

  refreshElementsSet(m);
  return {
    revert: function revert() {
      revertMutation(m);
    }
  };
}

function html(selector, mutate) {
  return newMutation({
    kind: 'html',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function position(selector, mutate) {
  return newMutation({
    kind: 'position',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function classes(selector, mutate) {
  return newMutation({
    kind: 'class',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function attribute(selector, attribute, mutate) {
  if (!validAttributeName.test(attribute)) return nullController;

  if (attribute === 'class' || attribute === 'className') {
    return classes(selector, function (classnames) {
      var mutatedClassnames = mutate(Array.from(classnames).join(' '));
      classnames.clear();
      if (!mutatedClassnames) return;
      mutatedClassnames.split(/\s+/g).filter(Boolean).forEach(function (c) {
        return classnames.add(c);
      });
    });
  }

  return newMutation({
    kind: 'attribute',
    attribute: attribute,
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function declarative(_ref2) {
  var selector = _ref2.selector,
      action = _ref2.action,
      value = _ref2.value,
      attr = _ref2.attribute,
      parentSelector = _ref2.parentSelector,
      insertBeforeSelector = _ref2.insertBeforeSelector;

  if (attr === 'html') {
    if (action === 'append') {
      return html(selector, function (val) {
        return val + (value != null ? value : '');
      });
    } else if (action === 'set') {
      return html(selector, function () {
        return value != null ? value : '';
      });
    }
  } else if (attr === 'class') {
    if (action === 'append') {
      return classes(selector, function (val) {
        if (value) val.add(value);
      });
    } else if (action === 'remove') {
      return classes(selector, function (val) {
        if (value) val["delete"](value);
      });
    } else if (action === 'set') {
      return classes(selector, function (val) {
        val.clear();
        if (value) val.add(value);
      });
    }
  } else if (attr === 'position') {
    if (action === 'set' && parentSelector) {
      return position(selector, function () {
        return {
          insertBeforeSelector: insertBeforeSelector,
          parentSelector: parentSelector
        };
      });
    }
  } else {
    if (action === 'append') {
      return attribute(selector, attr, function (val) {
        return val !== null ? val + (value != null ? value : '') : value != null ? value : '';
      });
    } else if (action === 'set') {
      return attribute(selector, attr, function () {
        return value != null ? value : '';
      });
    } else if (action === 'remove') {
      return attribute(selector, attr, function () {
        return null;
      });
    }
  }

  return nullController;
}

var index = {
  html: html,
  classes: classes,
  attribute: attribute,
  position: position,
  declarative: declarative
};

/* harmony default export */ __webpack_exports__["a"] = (index);

//# sourceMappingURL=dom-mutator.esm.js.map


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GrowthBookClient */
/* unused harmony export UserScopedGrowthBook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mjs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mjs__ = __webpack_require__(35);
var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }



var SDK_VERSION = Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["n" /* loadSDKVersion */])();
var GrowthBookClient = /*#__PURE__*/function () {
  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  function GrowthBookClient(options) {
    _classCallCheck(this, GrowthBookClient);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = options;
    this.debug = !!options.debug;
    this.ready = false;
    this._features = {};
    this._experiments = [];
    this.log = this.log.bind(this);
    if (options.plugins) {
      var _iterator = _createForOfIteratorHelper(options.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin(this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  return _createClass(GrowthBookClient, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(payload) {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this._payload = payload;
              _context.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["a" /* decryptPayload */])(payload, this._options.decryptionKey);
            case 1:
              data = _context.v;
              this._decryptedPayload = data;
              if (data.features) {
                this._features = data.features;
              }
              if (data.experiments) {
                this._experiments = data.experiments;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              if (data.contextualBandits) {
                this._options.contextualBandits = data.contextualBandits;
              }
              this.ready = true;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._features = payload.features;
      }
      if (payload.savedGroups) {
        this._options.savedGroups = payload.savedGroups;
      }
      if (payload.contextualBandits) {
        this._options.contextualBandits = payload.contextualBandits;
      }
      if (payload.experiments) {
        this._experiments = payload.experiments;
      }
      this.ready = true;
      Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              options = options || {};
              if (options.cacheSettings) {
                Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["b" /* configureCache */])(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.setPayload(options.payload);
            case 1:
              Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
              return _context2.a(2, {
                success: true,
                source: "init"
              });
            case 2:
              _context2.n = 3;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 3:
              _yield$this$_refresh = _context2.v;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["d" /* startBackgroundSync */])(this, options);
              _context2.n = 4;
              return this.setPayload(data || {});
            case 4:
              return _context2.a(2, res);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(options) {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 1:
              res = _context3.v;
              if (!res.data) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return this.setPayload(res.data);
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function refreshFeatures(_x3) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["d" /* getApiHosts */])(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this._experiments || []
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref) {
        var timeout, skipCache, allowStale, streaming;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context4.n = 1;
                break;
              }
              throw new Error("Missing clientKey");
            case 1:
              return _context4.a(2, Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["c" /* refreshFeatures */])({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: streaming !== null && streaming !== void 0 ? streaming : true
              }));
          }
        }, _callee4, this);
      }));
      function _refresh(_x4) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._features || {};
    }
  }, {
    key: "getGlobalAttributes",
    value: function getGlobalAttributes() {
      return this._options.globalAttributes || {};
    }
  }, {
    key: "setGlobalAttributes",
    value: function setGlobalAttributes(attributes) {
      this._options.globalAttributes = attributes;
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      options = options || {};
      this._destroyed = true;
      Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["e" /* unsubscribe */])(this);
      if (options.destroyAllStreams) {
        Object(__WEBPACK_IMPORTED_MODULE_1__feature_repository_mjs__["a" /* clearAutoRefresh */])();
      }

      // Release references to save memory
      this._features = {};
      this._experiments = [];
      this._decryptedPayload = undefined;
      this._payload = undefined;
      this._options = {};
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return !!this._destroyed;
    }
  }, {
    key: "setEventLogger",
    value: function setEventLogger(logger) {
      this._options.eventLogger = logger;
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName, properties, userContext) {
      if (this._options.eventLogger) {
        var ctx = this._getEvalContext(userContext);
        this._options.eventLogger(eventName, properties, Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["i" /* getTrackingUserContext */])(ctx.user));
      }
    }
  }, {
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment, userContext) {
      var _runExperiment = Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["j" /* runExperiment */])(experiment, null, this._getEvalContext(userContext)),
        result = _runExperiment.result;
      return result;
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext(userContext) {
      if (this._options.globalAttributes) {
        userContext = _objectSpread(_objectSpread({}, userContext), {}, {
          attributes: _objectSpread(_objectSpread({}, this._options.globalAttributes), userContext.attributes)
        });
      }
      return {
        user: userContext,
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._features,
        experiments: this._experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        contextualBandits: this._options.contextualBandits,
        forcedFeatureValues: this._options.forcedFeatureValues,
        forcedVariations: this._options.forcedVariations,
        trackingCallback: this._options.trackingCallback,
        onFeatureUsage: this._options.onFeatureUsage,
        eventLogger: this._options.eventLogger
      };
    }
  }, {
    key: "isOn",
    value: function isOn(key, userContext) {
      return this.evalFeature(key, userContext).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key, userContext) {
      return this.evalFeature(key, userContext).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue, userContext) {
      var value = this.evalFeature(key, userContext).value;
      return value === null ? defaultValue : value;
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id, userContext) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["b" /* evalFeature */])(id, this._getEvalContext(userContext));
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
    }
  }, {
    key: "setFeatureUsageCallback",
    value: function setFeatureUsageCallback(callback) {
      this._options.onFeatureUsage = callback;
    }
  }, {
    key: "applyStickyBuckets",
    value: function () {
      var _applyStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(partialContext, stickyBucketService) {
        var ctx, stickyBucketAssignmentDocs;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              ctx = this._getEvalContext(partialContext);
              _context5.n = 1;
              return Object(__WEBPACK_IMPORTED_MODULE_2__core_mjs__["c" /* getAllStickyBucketAssignmentDocs */])(ctx, stickyBucketService);
            case 1:
              stickyBucketAssignmentDocs = _context5.v;
              return _context5.a(2, _objectSpread(_objectSpread({}, partialContext), {}, {
                stickyBucketAssignmentDocs: stickyBucketAssignmentDocs,
                saveStickyBucketAssignmentDoc: function saveStickyBucketAssignmentDoc(doc) {
                  return stickyBucketService.saveAssignments(doc);
                }
              }));
          }
        }, _callee5, this);
      }));
      function applyStickyBuckets(_x5, _x6) {
        return _applyStickyBuckets.apply(this, arguments);
      }
      return applyStickyBuckets;
    }()
  }, {
    key: "createScopedInstance",
    value: function createScopedInstance(userContext, userPlugins) {
      return new UserScopedGrowthBook(this, userContext, [].concat(_toConsumableArray(this._options.plugins || []), _toConsumableArray(userPlugins || [])));
    }
  }]);
}();
var UserScopedGrowthBook = /*#__PURE__*/function () {
  function UserScopedGrowthBook(gb, userContext, plugins) {
    _classCallCheck(this, UserScopedGrowthBook);
    this._gb = gb;
    this._userContext = userContext;
    this.logs = [];
    this._userContext.trackedExperiments = this._userContext.trackedExperiments || new Set();
    this._userContext.trackedFeatureUsage = this._userContext.trackedFeatureUsage || {};
    this._userContext.experimentViewedSubs = this._userContext.experimentViewedSubs || new Set();
    this._userContext.devLogs = this.logs;
    if (plugins) {
      var _iterator2 = _createForOfIteratorHelper(plugins),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          plugin(this);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }
  return _createClass(UserScopedGrowthBook, [{
    key: "runInlineExperiment",
    value: function runInlineExperiment(experiment) {
      return this._gb.runInlineExperiment(experiment, this._userContext);
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this._gb.isOn(key, this._userContext);
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this._gb.isOff(key, this._userContext);
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      return this._gb.getFeatureValue(key, defaultValue, this._userContext);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return this._gb.evalFeature(id, this._userContext);
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventName, properties) {
      if (this._userContext.enableDevMode) {
        this.logs.push({
          eventName: eventName,
          properties: properties,
          timestamp: Date.now().toString(),
          logType: "event"
        });
      }
      this._gb.logEvent(eventName, properties || {}, this._userContext);
    }
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(cb) {
      this._userContext.trackingCallback = cb;
    }
  }, {
    key: "setFeatureUsageCallback",
    value: function setFeatureUsageCallback(cb) {
      this._userContext.onFeatureUsage = cb;
    }
    // Internal — first-party plugin use only.
    // Fires once per deduped experiment assignment for this user.
  }, {
    key: "_subscribeExperimentViewed",
    value: function _subscribeExperimentViewed(cb) {
      var subs = this._userContext.experimentViewedSubs = this._userContext.experimentViewedSubs || new Set();
      subs.add(cb);
      return function () {
        return subs["delete"](cb);
      };
    }
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return this._gb.getApiInfo();
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._gb.getClientKey();
    }
  }, {
    key: "setURL",
    value: function setURL(url) {
      this._userContext.url = url;
    }
  }, {
    key: "updateAttributes",
    value: function updateAttributes(attributes) {
      this._userContext.attributes = _objectSpread(_objectSpread({}, this._userContext.attributes), attributes);
    }
  }, {
    key: "setAttributeOverrides",
    value: function setAttributeOverrides(overrides) {
      this._userContext.attributeOverrides = overrides;
    }
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(vars) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this._userContext.forcedVariations = vars || {};
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function setForcedVariations(_x7) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._userContext.forcedFeatureValues = map;
    }
  }, {
    key: "getUserContext",
    value: function getUserContext() {
      return this._userContext;
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return SDK_VERSION;
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._gb.getDecryptedPayload();
    }
  }, {
    key: "inDevMode",
    value: function inDevMode() {
      return !!this._userContext.enableDevMode;
    }
  }]);
}();

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StickyBucketService */
/* unused harmony export StickyBucketServiceSync */
/* unused harmony export LocalStorageStickyBucketService */
/* unused harmony export ExpressCookieStickyBucketService */
/* unused harmony export BrowserCookieStickyBucketService */
/* unused harmony export RedisStickyBucketService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_mjs__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mjs__ = __webpack_require__(35);
var _excluded = ["domain"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


/**
 * Responsible for reading and writing documents which describe sticky bucket assignments.
 */
var StickyBucketService = /*#__PURE__*/function () {
  function StickyBucketService(opts) {
    _classCallCheck(this, StickyBucketService);
    opts = opts || {};
    this.prefix = opts.prefix || "";
  }
  /**
   * The SDK calls getAllAssignments to populate sticky buckets. This in turn will
   * typically loop through individual getAssignments calls. However, some StickyBucketService
   * instances (i.e. Redis) will instead perform a multi-query inside getAllAssignments instead.
   */
  return _createClass(StickyBucketService, [{
    key: "getAllAssignments",
    value: (function () {
      var _getAllAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(attributes) {
        var _this = this;
        var docs;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              docs = {};
              _context.n = 1;
              return Promise.all(Object.entries(attributes).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  attributeName = _ref2[0],
                  attributeValue = _ref2[1];
                return _this.getAssignments(attributeName, attributeValue);
              }));
            case 1:
              _context.v.forEach(function (doc) {
                if (doc) {
                  var key = Object(__WEBPACK_IMPORTED_MODULE_1__core_mjs__["g" /* getStickyBucketAttributeKey */])(doc.attributeName, doc.attributeValue);
                  docs[key] = doc;
                }
              });
              return _context.a(2, docs);
          }
        }, _callee);
      }));
      function getAllAssignments(_x) {
        return _getAllAssignments.apply(this, arguments);
      }
      return getAllAssignments;
    }())
  }, {
    key: "getKey",
    value: function getKey(attributeName, attributeValue) {
      return "".concat(this.prefix).concat(attributeName, "||").concat(attributeValue);
    }
  }]);
}();
var StickyBucketServiceSync = /*#__PURE__*/function (_StickyBucketService) {
  function StickyBucketServiceSync() {
    _classCallCheck(this, StickyBucketServiceSync);
    return _callSuper(this, StickyBucketServiceSync, arguments);
  }
  _inherits(StickyBucketServiceSync, _StickyBucketService);
  return _createClass(StickyBucketServiceSync, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(attributeName, attributeValue) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.getAssignmentsSync(attributeName, attributeValue));
          }
        }, _callee2, this);
      }));
      function getAssignments(_x2, _x3) {
        return _getAssignments.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(doc) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.saveAssignmentsSync(doc);
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveAssignments(_x4) {
        return _saveAssignments.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }, {
    key: "getAllAssignmentsSync",
    value: function getAllAssignmentsSync(attributes) {
      var _this2 = this;
      var docs = {};
      Object.entries(attributes).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          attributeName = _ref4[0],
          attributeValue = _ref4[1];
        return _this2.getAssignmentsSync(attributeName, attributeValue);
      }).forEach(function (doc) {
        if (doc) {
          var key = Object(__WEBPACK_IMPORTED_MODULE_1__core_mjs__["g" /* getStickyBucketAttributeKey */])(doc.attributeName, doc.attributeValue);
          docs[key] = doc;
        }
      });
      return docs;
    }
  }]);
}(StickyBucketService);
var LocalStorageStickyBucketService = /*#__PURE__*/function (_StickyBucketService2) {
  function LocalStorageStickyBucketService(opts) {
    var _this3;
    _classCallCheck(this, LocalStorageStickyBucketService);
    opts = opts || {};
    _this3 = _callSuper(this, LocalStorageStickyBucketService);
    _this3.prefix = opts.prefix || "gbStickyBuckets__";
    try {
      _this3.localStorage = opts.localStorage || globalThis.localStorage;
    } catch (e) {
      // Ignore localStorage errors
    }
    return _this3;
  }
  _inherits(LocalStorageStickyBucketService, _StickyBucketService2);
  return _createClass(LocalStorageStickyBucketService, [{
    key: "getAssignments",
    value: function () {
      var _getAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(attributeName, attributeValue) {
        var key, doc, raw, data, _t, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              key = this.getKey(attributeName, attributeValue);
              doc = null;
              if (this.localStorage) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, doc);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.localStorage.getItem(key);
            case 2:
              _t = _context4.v;
              if (_t) {
                _context4.n = 3;
                break;
              }
              _t = "{}";
            case 3:
              raw = _t;
              data = JSON.parse(raw);
              if (data.attributeName && data.attributeValue && data.assignments) {
                doc = data;
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t2 = _context4.v;
            case 5:
              return _context4.a(2, doc);
          }
        }, _callee4, this, [[1, 4]]);
      }));
      function getAssignments(_x5, _x6) {
        return _getAssignments2.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(doc) {
        var key, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.localStorage) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return this.localStorage.setItem(key, JSON.stringify(doc));
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function saveAssignments(_x7) {
        return _saveAssignments2.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);
var ExpressCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketServiceS) {
  /**
   * Intended to be used with cookieParser() middleware from npm: 'cookie-parser'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value must be manually encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function ExpressCookieStickyBucketService(_ref5) {
    var _this4;
    var _ref5$prefix = _ref5.prefix,
      prefix = _ref5$prefix === void 0 ? "gbStickyBuckets__" : _ref5$prefix,
      req = _ref5.req,
      res = _ref5.res,
      _ref5$cookieAttribute = _ref5.cookieAttributes,
      cookieAttributes = _ref5$cookieAttribute === void 0 ? {
        maxAge: 180 * 24 * 3600 * 1000
      } : _ref5$cookieAttribute;
    _classCallCheck(this, ExpressCookieStickyBucketService);
    _this4 = _callSuper(this, ExpressCookieStickyBucketService);
    _this4.prefix = prefix;
    _this4.req = req;
    _this4.res = res;
    _this4.cookieAttributes = cookieAttributes;
    return _this4;
  }
  _inherits(ExpressCookieStickyBucketService, _StickyBucketServiceS);
  return _createClass(ExpressCookieStickyBucketService, [{
    key: "getAssignmentsSync",
    value: function getAssignmentsSync(attributeName, attributeValue) {
      var key = this.getKey(attributeName, attributeValue);
      var doc = null;
      if (!this.req) return doc;
      try {
        var raw = this.req.cookies[key] || "{}";
        var data = JSON.parse(raw);
        if (data.attributeName && data.attributeValue && data.assignments) {
          doc = data;
        }
      } catch (e) {
        // Ignore cookie errors
      }
      return doc;
    }
  }, {
    key: "saveAssignmentsSync",
    value: function saveAssignmentsSync(doc) {
      var key = this.getKey(doc.attributeName, doc.attributeValue);
      if (!this.res) return;
      var str = JSON.stringify(doc);
      this.res.cookie(encodeURIComponent(key), encodeURIComponent(str), this.cookieAttributes);
    }
  }]);
}(StickyBucketServiceSync);
var BrowserCookieStickyBucketService = /*#__PURE__*/function (_StickyBucketServiceS2) {
  /**
   * Intended to be used with npm: 'js-cookie'.
   * Assumes:
   *  - reading a cookie is automatically decoded via decodeURIComponent() or similar
   *  - writing a cookie name & value is automatically encoded via encodeURIComponent() or similar
   *  - all cookie bodies are JSON encoded strings and are manually encoded/decoded
   */

  function BrowserCookieStickyBucketService(_ref6) {
    var _this5;
    var _ref6$prefix = _ref6.prefix,
      prefix = _ref6$prefix === void 0 ? "gbStickyBuckets__" : _ref6$prefix,
      jsCookie = _ref6.jsCookie,
      _ref6$cookieAttribute = _ref6.cookieAttributes,
      cookieAttributes = _ref6$cookieAttribute === void 0 ? {
        expires: 180
      } : _ref6$cookieAttribute;
    _classCallCheck(this, BrowserCookieStickyBucketService);
    _this5 = _callSuper(this, BrowserCookieStickyBucketService);
    _this5.prefix = prefix;
    _this5.jsCookie = jsCookie;
    _this5.cookieAttributes = cookieAttributes;
    return _this5;
  }
  _inherits(BrowserCookieStickyBucketService, _StickyBucketServiceS2);
  return _createClass(BrowserCookieStickyBucketService, [{
    key: "getAssignmentsSync",
    value: function getAssignmentsSync(attributeName, attributeValue) {
      var key = this.getKey(attributeName, attributeValue);
      var doc = null;
      if (!this.jsCookie) return doc;
      try {
        var raw = this.jsCookie.get(key);
        var data = JSON.parse(raw || "{}");
        if (data.attributeName && data.attributeValue && data.assignments) {
          doc = data;
        }
      } catch (e) {
        // Ignore cookie errors
      }
      return doc;
    }
  }, {
    key: "saveAssignmentsSync",
    value: function () {
      var _saveAssignmentsSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(doc) {
        var key, str, _this$cookieAttribute, domain, hostOnlyAttributes;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.jsCookie) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              str = JSON.stringify(doc);
              _this$cookieAttribute = this.cookieAttributes, domain = _this$cookieAttribute.domain, hostOnlyAttributes = _objectWithoutProperties(_this$cookieAttribute, _excluded);
              if (domain) {
                _context6.n = 2;
                break;
              }
              this.jsCookie.set(key, str, this.cookieAttributes);
              return _context6.a(2);
            case 2:
              // Remove any legacy host-only cookie first - it would shadow the
              // domain-scoped one on reads
              this.jsCookie.remove(key, hostOnlyAttributes);
              this.jsCookie.set(key, str, this.cookieAttributes);
              // Browsers silently reject a cookie whose domain doesn't cover this host
              // (e.g. a typo) - fall back to host-only so assignments still persist
              if (this.jsCookie.get(key) !== str) {
                this.jsCookie.set(key, str, hostOnlyAttributes);
              }
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function saveAssignmentsSync(_x8) {
        return _saveAssignmentsSync.apply(this, arguments);
      }
      return saveAssignmentsSync;
    }()
  }]);
}(StickyBucketServiceSync);
var RedisStickyBucketService = /*#__PURE__*/function (_StickyBucketService3) {
  /** Intended to be used with npm: 'ioredis'. **/

  function RedisStickyBucketService(_ref7) {
    var _this6;
    var redis = _ref7.redis;
    _classCallCheck(this, RedisStickyBucketService);
    _this6 = _callSuper(this, RedisStickyBucketService);
    _this6.redis = redis;
    return _this6;
  }
  _inherits(RedisStickyBucketService, _StickyBucketService3);
  return _createClass(RedisStickyBucketService, [{
    key: "getAllAssignments",
    value: function () {
      var _getAllAssignments2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(attributes) {
        var _this$redis;
        var docs, keys;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              docs = {};
              keys = Object.entries(attributes).map(function (_ref8) {
                var _ref9 = _slicedToArray(_ref8, 2),
                  attributeName = _ref9[0],
                  attributeValue = _ref9[1];
                return Object(__WEBPACK_IMPORTED_MODULE_1__core_mjs__["g" /* getStickyBucketAttributeKey */])(attributeName, attributeValue);
              });
              if (this.redis) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, docs);
            case 1:
              _context7.n = 2;
              return (_this$redis = this.redis).mget.apply(_this$redis, _toConsumableArray(keys)).then(function (values) {
                values.forEach(function (raw) {
                  try {
                    var data = JSON.parse(raw || "{}");
                    if (data.attributeName && "attributeValue" in data && data.assignments) {
                      var key = Object(__WEBPACK_IMPORTED_MODULE_1__core_mjs__["g" /* getStickyBucketAttributeKey */])(data.attributeName, Object(__WEBPACK_IMPORTED_MODULE_0__util_mjs__["r" /* toString */])(data.attributeValue));
                      docs[key] = data;
                    }
                  } catch (e) {
                    // ignore redis doc parse errors
                  }
                });
              });
            case 2:
              return _context7.a(2, docs);
          }
        }, _callee7, this);
      }));
      function getAllAssignments(_x9) {
        return _getAllAssignments2.apply(this, arguments);
      }
      return getAllAssignments;
    }()
  }, {
    key: "getAssignments",
    value: function () {
      var _getAssignments3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_attributeName, _attributeValue) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              return _context8.a(2, null);
          }
        }, _callee8);
      }));
      function getAssignments(_x0, _x1) {
        return _getAssignments3.apply(this, arguments);
      }
      return getAssignments;
    }()
  }, {
    key: "saveAssignments",
    value: function () {
      var _saveAssignments3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(doc) {
        var key;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              key = this.getKey(doc.attributeName, doc.attributeValue);
              if (this.redis) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _context9.n = 2;
              return this.redis.set(key, JSON.stringify(doc));
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function saveAssignments(_x10) {
        return _saveAssignments3.apply(this, arguments);
      }
      return saveAssignments;
    }()
  }]);
}(StickyBucketService);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// staticV2/js/main.c1a57377.js